
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire117b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire117b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i9BKe", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $2726d886f4171354$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $2726d886f4171354$export$cc3e2d3244e01b7f);
"use strict";
var $2726d886f4171354$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($2726d886f4171354$export$4f037c6ec2da4eeb || {});
const $2726d886f4171354$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $2726d886f4171354$export$ba4241979983e013 = (ext, defaultPriority)=>$2726d886f4171354$var$normalizeExtension(ext).priority ?? defaultPriority;
const $2726d886f4171354$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */ remove (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */ add (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b.value, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    },
    /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */ mixin (Target, ...sources) {
        for (const source of sources)Object.defineProperties(Target.prototype, Object.getOwnPropertyDescriptors(source));
    }
};

});

parcelRegister("8rEJm", function(module, exports) {
module.exports = Promise.all([
    import("h7xf3"),
    import("dCEEN")
]).then(()=>parcelRequire('gFyHJ'));

});

parcelRegister("eOPp4", function(module, exports) {
module.exports = Promise.all([
    import("h7xf3"),
    import("5zD7l")
]).then(()=>parcelRequire('danRq'));

});

parcelRegister("7dx1H", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $7h8HJ = parcelRequire("7h8HJ");

var $lLQso = parcelRequire("lLQso");

var $jXXId = parcelRequire("jXXId");

var $jMNJq = parcelRequire("jMNJq");

var $8xl7d = parcelRequire("8xl7d");

var $aQPld = parcelRequire("aQPld");

var $hNatJ = parcelRequire("hNatJ");
parcelRequire("8QN7n");

"use strict";
(0, $i9BKe.extensions).add((0, $7h8HJ.AlphaMask), (0, $lLQso.ColorMask), (0, $jXXId.StencilMask), (0, $hNatJ.VideoSource), (0, $aQPld.ImageSource), (0, $8xl7d.CanvasSource), (0, $jMNJq.BufferImageSource));

});
parcelRegister("7h8HJ", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $90469dbfa4a0e350$export$3c32667be409917c);

var $i9BKe = parcelRequire("i9BKe");

var $4rhnu = parcelRequire("4rhnu");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $90469dbfa4a0e350$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.inverse = false;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $4rhnu.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        if (!this.inverse) (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $4rhnu.Sprite);
    }
}
$90469dbfa4a0e350$export$3c32667be409917c.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});
parcelRegister("4rhnu", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $2ddac34a8a6af484$export$3075603db8e6204c);

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $f8J9J = parcelRequire("f8J9J");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $2ddac34a8a6af484$export$3075603db8e6204c extends (0, $b9FQU.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $bLlTJ.Texture).EMPTY){
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $bLlTJ.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "sprite";
        /** @internal */ this.batched = true;
        this._visualBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $bLlTJ.Texture)) return new $2ddac34a8a6af484$export$3075603db8e6204c(source);
        return new $2ddac34a8a6af484$export$3075603db8e6204c((0, $bLlTJ.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */ get texture() {
        return this._texture;
    }
    /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */ get visualBounds() {
        (0, $f8J9J.updateQuadBounds)(this._visualBounds, this._anchor, this._texture);
        return this._visualBounds;
    }
    /**
   * @deprecated
   * @ignore
   */ get sourceBounds() {
        (0, $kXq8E.deprecation)("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
        return this.visualBounds;
    }
    /** @private */ updateBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const bounds = this._bounds;
        const { width: width, height: height } = texture.orig;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._visualBounds = null;
        this._bounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("a32F4", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $702ea64f2b15c76d$export$3755aaad3fd42e52);
"use strict";
class $702ea64f2b15c76d$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */ clone(observer) {
        return new $702ea64f2b15c76d$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
    }
    /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("bLlTJ", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $dd4e44a750d6d26c$export$5431306cf43de24a);

var $3vRz3 = parcelRequire("3vRz3");

var $2RwkA = parcelRequire("2RwkA");

var $fM4Mk = parcelRequire("fM4Mk");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $2coCi = parcelRequire("2coCi");

var $jMNJq = parcelRequire("jMNJq");

var $iA5fe = parcelRequire("iA5fe");

var $jNN6Y = parcelRequire("jNN6Y");
"use strict";
class $dd4e44a750d6d26c$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param {TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $aGJhg.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $fM4Mk.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $iA5fe.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $jNN6Y.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $2RwkA.groupD8).add(rotate, (0, $2RwkA.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            this._source.off("resize", this.update, this);
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $iA5fe.TextureSource)({
        label: "EMPTY"
    })
});
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY.destroy = (0, $2coCi.NOOP);
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    source: new (0, $jMNJq.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE.destroy = (0, $2coCi.NOOP);

});
parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("2RwkA", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $99d48e5a2f9844ff$export$b7bb6a2a8d203102);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $99d48e5a2f9844ff$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $99d48e5a2f9844ff$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $99d48e5a2f9844ff$var$rotationCayley = [];
const $99d48e5a2f9844ff$var$rotationMatrices = [];
const $99d48e5a2f9844ff$var$signum = Math.sign;
function $99d48e5a2f9844ff$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $99d48e5a2f9844ff$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _uy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _vx = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$vy[j]);
            const _vy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($99d48e5a2f9844ff$var$ux[k] === _ux && $99d48e5a2f9844ff$var$uy[k] === _uy && $99d48e5a2f9844ff$var$vx[k] === _vx && $99d48e5a2f9844ff$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $eY4rt.Matrix)();
        mat.set($99d48e5a2f9844ff$var$ux[i], $99d48e5a2f9844ff$var$uy[i], $99d48e5a2f9844ff$var$vx[i], $99d48e5a2f9844ff$var$vy[i], 0, 0);
        $99d48e5a2f9844ff$var$rotationMatrices.push(mat);
    }
}
$99d48e5a2f9844ff$var$init();
const $99d48e5a2f9844ff$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$99d48e5a2f9844ff$var$ux[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$99d48e5a2f9844ff$var$uy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$99d48e5a2f9844ff$var$vx[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$99d48e5a2f9844ff$var$vy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.S;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.E;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SE;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NE;
        return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0, dw = 0, dh = 0)=>{
        const mat = $99d48e5a2f9844ff$var$rotationMatrices[$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotation)];
        const a = mat.a;
        const b = mat.b;
        const c = mat.c;
        const d = mat.d;
        const finalTx = tx - Math.min(0, a * dw, c * dh, a * dw + c * dh);
        const finalTy = ty - Math.min(0, b * dw, d * dh, b * dw + d * dh);
        const a1 = matrix.a;
        const b1 = matrix.b;
        const c1 = matrix.c;
        const d1 = matrix.d;
        matrix.a = a * a1 + b * c1;
        matrix.b = a * b1 + b * d1;
        matrix.c = c * a1 + d * c1;
        matrix.d = c * b1 + d * d1;
        matrix.tx = finalTx * a1 + finalTy * c1 + matrix.tx;
        matrix.ty = finalTx * b1 + finalTy * d1 + matrix.ty;
    },
    /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */ transformRectCoords: (rect, sourceFrame, rotation, out)=>{
        const { x: x, y: y, width: width, height: height } = rect;
        const { x: frameX, y: frameY, width: frameWidth, height: frameHeight } = sourceFrame;
        if (rotation === $99d48e5a2f9844ff$export$b7bb6a2a8d203102.E) {
            out.set(x + frameX, y + frameY, width, height);
            return out;
        } else if (rotation === $99d48e5a2f9844ff$export$b7bb6a2a8d203102.S) return out.set(frameWidth - y - height + frameX, x + frameY, height, width);
        else if (rotation === $99d48e5a2f9844ff$export$b7bb6a2a8d203102.W) return out.set(frameWidth - x - width + frameX, frameHeight - y - height + frameY, width, height);
        else if (rotation === $99d48e5a2f9844ff$export$b7bb6a2a8d203102.N) return out.set(y + frameX, frameHeight - x - width + frameY, height, width);
        return out.set(x + frameX, y + frameY, width, height);
    }
};

});
parcelRegister("eY4rt", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85);

var $aWW4e = parcelRequire("aWW4e");

var $1HooC = parcelRequire("1HooC");
"use strict";
class $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /**
     * Array representation of the matrix.
     * Only populated when `toArray()` is called.
     * @default null
     * @see {@link Matrix.toArray} For filling this array
     */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $aWW4e.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */ static get IDENTITY() {
        return $fd3f7bfaf4af3d85$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */ static get shared() {
        return $fd3f7bfaf4af3d85$var$tempMatrix.identity();
    }
}
const $fd3f7bfaf4af3d85$var$tempMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
const $fd3f7bfaf4af3d85$var$identityMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();

});
parcelRegister("aWW4e", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $635707f32e142ac4$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $635707f32e142ac4$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $635707f32e142ac4$export$870617f62e3187f1);
"use strict";
const $635707f32e142ac4$export$59ed0a0a5de1084b = Math.PI * 2;
const $635707f32e142ac4$export$3f91627dc85c5d57 = 180 / Math.PI;
const $635707f32e142ac4$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("1HooC", function(module, exports) {

$parcel$export(module.exports, "Point", () => $fdaff9f788d94485$export$baf26146a414f24a);
"use strict";
class $fdaff9f788d94485$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /**
     * Position of the point on the x axis
     * @example
     * ```ts
     * // Set x position
     * const point = new Point();
     * point.x = 100;
     *
     * // Use in calculations
     * const width = rightPoint.x - leftPoint.x;
     * ```
     */ this.x = 0;
        /**
     * Position of the point on the y axis
     * @example
     * ```ts
     * // Set y position
     * const point = new Point();
     * point.y = 200;
     *
     * // Use in calculations
     * const height = bottomPoint.y - topPoint.y;
     * ```
     */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */ clone() {
        return new $fdaff9f788d94485$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */ static get shared() {
        $fdaff9f788d94485$var$tempPoint.x = 0;
        $fdaff9f788d94485$var$tempPoint.y = 0;
        return $fdaff9f788d94485$var$tempPoint;
    }
}
const $fdaff9f788d94485$var$tempPoint = new $fdaff9f788d94485$export$baf26146a414f24a();

});



parcelRegister("fM4Mk", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $55a82579353c67d9$export$4617fb02663045ef);

var $1HooC = parcelRequire("1HooC");
"use strict";
const $55a82579353c67d9$var$tempPoints = [
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)()
];
class $55a82579353c67d9$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Rectangle(0, 0, 100, 100);
     * console.log(shape.type); // 'rectangle'
     *
     * // Use in type guards
     * if (shape.type === 'rectangle') {
     *     console.log(shape.width, shape.height);
     * }
     * ```
     * @readonly
     * @default 'rectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */ get left() {
        return this.x;
    }
    /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */ get right() {
        return this.x + this.width;
    }
    /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */ get top() {
        return this.y;
    }
    /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */ get bottom() {
        return this.y + this.height;
    }
    /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */ static get EMPTY() {
        return new $55a82579353c67d9$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $55a82579353c67d9$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const outerLeft = _x - strokeWidthOuter;
        const outerRight = _x + width + strokeWidthOuter;
        const outerTop = _y - strokeWidthOuter;
        const outerBottom = _y + height + strokeWidthOuter;
        const innerLeft = _x + strokeWidthInner;
        const innerRight = _x + width - strokeWidthInner;
        const innerTop = _y + strokeWidthInner;
        const innerBottom = _y + height - strokeWidthInner;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $55a82579353c67d9$var$tempPoints[0].set(other.left, other.top);
        const lb = $55a82579353c67d9$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $55a82579353c67d9$var$tempPoints[2].set(other.right, other.top);
        const rb = $55a82579353c67d9$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */ scale(x, y = x) {
        this.x *= x;
        this.y *= y;
        this.width *= x;
        this.height *= y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */ getBounds(out) {
        out || (out = new $55a82579353c67d9$export$4617fb02663045ef());
        out.copyFrom(this);
        return out;
    }
    /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */ containsRect(other) {
        if (this.width <= 0 || this.height <= 0) return false;
        const x1 = other.x;
        const y1 = other.y;
        const x2 = other.x + other.width;
        const y2 = other.y + other.height;
        return x1 >= this.x && x1 < this.x + this.width && y1 >= this.y && y1 < this.y + this.height && x2 >= this.x && x2 < this.x + this.width && y2 >= this.y && y2 < this.y + this.height;
    }
    /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */ set(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("aGJhg", function(module, exports) {

$parcel$export(module.exports, "uid", () => $aa9685d46d70e8a7$export$e2a22331486dcca0);
"use strict";
const $aa9685d46d70e8a7$var$uidCache = {
    default: -1
};
function $aa9685d46d70e8a7$export$e2a22331486dcca0(name = "default") {
    if ($aa9685d46d70e8a7$var$uidCache[name] === void 0) $aa9685d46d70e8a7$var$uidCache[name] = -1;
    return ++$aa9685d46d70e8a7$var$uidCache[name];
}
function $aa9685d46d70e8a7$export$220409b686c277d0() {
    for(const key in $aa9685d46d70e8a7$var$uidCache)delete $aa9685d46d70e8a7$var$uidCache[key];
}

});

parcelRegister("kXq8E", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $86481ab6f435a4d7$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $86481ab6f435a4d7$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $86481ab6f435a4d7$export$afd31d834b512e89);
"use strict";
const $86481ab6f435a4d7$var$warnings = /* @__PURE__ */ new Set();
const $86481ab6f435a4d7$export$dc79da96439604f0 = "8.0.0";
const $86481ab6f435a4d7$export$e88af00f5d3e8bcc = "8.3.4";
const $86481ab6f435a4d7$var$deprecationState = {
    quiet: false,
    noColor: false
};
const $86481ab6f435a4d7$export$afd31d834b512e89 = (version, message, ignoreDepth = 3)=>{
    if ($86481ab6f435a4d7$var$deprecationState.quiet || $86481ab6f435a4d7$var$warnings.has(message)) return;
    let stack = new Error().stack;
    const deprecationMessage = `${message}
Deprecated since v${version}`;
    const useGroup = typeof console.groupCollapsed === "function" && !$86481ab6f435a4d7$var$deprecationState.noColor;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (useGroup) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", deprecationMessage);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
            console.warn(stack);
        }
    }
    $86481ab6f435a4d7$var$warnings.add(message);
};
Object.defineProperties($86481ab6f435a4d7$export$afd31d834b512e89, {
    quiet: {
        get: ()=>$86481ab6f435a4d7$var$deprecationState.quiet,
        set: (value)=>{
            $86481ab6f435a4d7$var$deprecationState.quiet = value;
        },
        enumerable: true,
        configurable: false
    },
    noColor: {
        get: ()=>$86481ab6f435a4d7$var$deprecationState.noColor,
        set: (value)=>{
            $86481ab6f435a4d7$var$deprecationState.noColor = value;
        },
        enumerable: true,
        configurable: false
    }
});

});

parcelRegister("2coCi", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $342f4d0330a1a110$export$5702a91a6f42969f);
"use strict";
const $342f4d0330a1a110$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("jMNJq", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $38c8a704e7d4a191$export$1872462350fcb7cd);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $38c8a704e7d4a191$export$1872462350fcb7cd extends (0, $iA5fe.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$38c8a704e7d4a191$export$1872462350fcb7cd.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iA5fe", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $50e6ce3cf0e8b717$export$8498e6a2e655d3d8);

var $3vRz3 = parcelRequire("3vRz3");

var $NbSCN = parcelRequire("NbSCN");

var $dr868 = parcelRequire("dr868");

var $aGJhg = parcelRequire("aGJhg");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
const $50e6ce3cf0e8b717$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** unique id for this Texture source */ this.uid = (0, $aGJhg.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @internal
     */ this.uploadMethodId = "unknown";
        /** @internal */ this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     */ this.sampleCount = 1;
        /**
     * The number of mip levels to generate for this texture.
     * this is overridden if autoGenerateMipmaps is true. it is read only!
     */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /** how this texture is viewed/sampled by shaders (WebGPU view dimension) */ this.viewDimension = "2d";
        /** how many array layers this texture has (WebGPU depthOrArrayLayers) */ this.arrayLayerCount = 1;
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.viewDimension = options.viewDimension ?? options.dimensions;
        this.arrayLayerCount = options.arrayLayerCount;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $aFPUT.TextureStyle)((0, $dr868.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._style.maxAnisotropy = value;
    }
    get maxAnisotropy() {
        return this._style.maxAnisotropy;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy?.();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution || (resolution = this._resolution);
        width || (width = this.width);
        height || (height = this.height);
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $NbSCN.isPow2)(this.pixelWidth) && (0, $NbSCN.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $50e6ce3cf0e8b717$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    viewDimension: "2d",
    arrayLayerCount: 1,
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $50e6ce3cf0e8b717$export$8498e6a2e655d3d8 = $50e6ce3cf0e8b717$var$_TextureSource;

});
parcelRegister("NbSCN", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $445bbf816b14b66c$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $445bbf816b14b66c$export$eb50b9c078eb6ae7);
"use strict";
function $445bbf816b14b66c$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $445bbf816b14b66c$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $445bbf816b14b66c$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("dr868", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $c5dcc841d9b9a11e$export$801feaffb936a09d);
"use strict";
function $c5dcc841d9b9a11e$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("aFPUT", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $46d9af7c4b00e80a$var$idHash = /* @__PURE__ */ Object.create(null);
function $46d9af7c4b00e80a$var$createResourceIdFromString(value) {
    const id = $46d9af7c4b00e80a$var$idHash[value];
    if (id === void 0) $46d9af7c4b00e80a$var$idHash[value] = (0, $aGJhg.uid)("resource");
    return id;
}
const $46d9af7c4b00e80a$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        /** @internal */ this._resourceType = "textureSampler";
        /** @internal */ this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link TextureStyle#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link TextureStyle#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this._sharedResourceId = null;
        this.emit("change", this);
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $46d9af7c4b00e80a$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $46d9af7c4b00e80a$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5 = $46d9af7c4b00e80a$var$_TextureStyle;

});



parcelRegister("jNN6Y", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $707e20d60f27daa2$export$dbea3135e9da48cb);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $707e20d60f27daa2$var$tempMat = new (0, $eY4rt.Matrix)();
class $707e20d60f27daa2$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $eY4rt.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $707e20d60f27daa2$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($707e20d60f27daa2$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("f8J9J", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $67aa708353891905$export$558ce66aa5723f1d);
"use strict";
function $67aa708353891905$export$558ce66aa5723f1d(bounds, anchor, texture) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});

parcelRegister("b9FQU", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $950433d02344dbbb$export$19fb617b96998849);

var $7wtv9 = parcelRequire("7wtv9");

var $eicwU = parcelRequire("eicwU");
"use strict";
class $950433d02344dbbb$export$19fb617b96998849 extends (0, $eicwU.Container) {
    constructor(options){
        super(options);
        /** @internal */ this.canBundle = true;
        /** @internal */ this.allowChildren = false;
        /** @internal */ this._roundPixels = 0;
        /** @internal */ this._lastUsed = -1;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        this._bounds = new (0, $7wtv9.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
        this.autoGarbageCollect = options.autoGarbageCollect ?? true;
    }
    /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this.updateBounds();
        this._boundsDirty = false;
        return this._bounds;
    }
    /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    /** @private */ onViewUpdate() {
        this._didViewChangeTick++;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    /** Unloads the GPU data from the view. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
        this.onViewUpdate();
    }
    destroy(options) {
        this.unload();
        super.destroy(options);
        this._bounds = null;
    }
    /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */ collectRenderablesSimple(instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        renderPipes.blendMode.pushBlendMode(this, this.groupBlendMode, instructionSet);
        const rp = renderPipes;
        const pipe = rp[this.renderPipeId];
        if (pipe?.addRenderable) pipe.addRenderable(this, instructionSet);
        this.didViewUpdate = false;
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
        renderPipes.blendMode.popBlendMode(instructionSet);
    }
}

});
parcelRegister("7wtv9", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $0b15abb3a529f09f$export$c4e9d269599ab4b4);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $0b15abb3a529f09f$var$defaultMatrix = new (0, $eY4rt.Matrix)();
class $0b15abb3a529f09f$export$c4e9d269599ab4b4 {
    /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */ constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X coordinate of the bounds.
     * Represents the leftmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set left edge
     * bounds.minX = 100;
     * ```
     * @default Infinity
     */ this.minX = Infinity;
        /**
     * The minimum Y coordinate of the bounds.
     * Represents the topmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set top edge
     * bounds.minY = 100;
     * ```
     * @default Infinity
     */ this.minY = Infinity;
        /**
     * The maximum X coordinate of the bounds.
     * Represents the rightmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set right edge
     * bounds.maxX = 200;
     * // Get width
     * const width = bounds.maxX - bounds.minX;
     * ```
     * @default -Infinity
     */ this.maxX = -Infinity;
        /**
     * The maximum Y coordinate of the bounds.
     * Represents the bottommost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set bottom edge
     * bounds.maxY = 200;
     * // Get height
     * const height = bounds.maxY - bounds.minY;
     * ```
     * @default -Infinity
     */ this.maxY = -Infinity;
        /**
     * The transformation matrix applied to this bounds object.
     * Used when calculating bounds with transforms.
     * @example
     * ```ts
     * const bounds = new Bounds();
     *
     * // Apply translation matrix
     * bounds.matrix = new Matrix()
     *     .translate(100, 100);
     *
     * // Combine transformations
     * bounds.matrix = new Matrix()
     *     .translate(50, 50)
     *     .rotate(Math.PI / 4)
     *     .scale(2, 2);
     *
     * // Use in bounds calculations
     * bounds.addFrame(0, 0, 100, 100); // Uses current matrix
     * bounds.addFrame(0, 0, 100, 100, customMatrix); // Override matrix
     * ```
     * @advanced
     */ this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $fM4Mk.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */ clone() {
        return new $0b15abb3a529f09f$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */ get left() {
        return this.minX;
    }
    /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */ get right() {
        return this.maxX;
    }
    /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */ get top() {
        return this.minY;
    }
    /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */ get bottom() {
        return this.maxY;
    }
    /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */ get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */ toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
    /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */ copyFrom(bounds) {
        this.minX = bounds.minX;
        this.minY = bounds.minY;
        this.maxX = bounds.maxX;
        this.maxY = bounds.maxY;
        return this;
    }
}

});

parcelRegister("eicwU", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $8a2b4ed6f59ce4dc$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $8a2b4ed6f59ce4dc$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $8a2b4ed6f59ce4dc$export$42a852a2b6b56249);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $j1i7q = parcelRequire("j1i7q");

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $aWW4e = parcelRequire("aWW4e");

var $a32F4 = parcelRequire("a32F4");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $61KiY = parcelRequire("61KiY");

var $9atlQ = parcelRequire("9atlQ");

var $236jP = parcelRequire("236jP");

var $49nq9 = parcelRequire("49nq9");

var $apXS2 = parcelRequire("apXS2");

var $kkVML = parcelRequire("kkVML");

var $3hzRR = parcelRequire("3hzRR");

var $8ifkW = parcelRequire("8ifkW");

var $kEqoj = parcelRequire("kEqoj");

var $ggvKl = parcelRequire("ggvKl");

var $82jXu = parcelRequire("82jXu");

var $g5iYs = parcelRequire("g5iYs");

var $1pFbO = parcelRequire("1pFbO");

var $gIPW8 = parcelRequire("gIPW8");
"use strict";
const $8a2b4ed6f59ce4dc$var$defaultSkew = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultPivot = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultScale = new (0, $a32F4.ObservablePoint)(null, 1, 1);
const $8a2b4ed6f59ce4dc$var$defaultOrigin = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5 = 1;
const $8a2b4ed6f59ce4dc$export$e4801e7edc7582f = 2;
const $8a2b4ed6f59ce4dc$export$83db162b74637ea = 4;
const $8a2b4ed6f59ce4dc$export$8363b5079568fbee = 8;
class $8a2b4ed6f59ce4dc$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options = {}){
        super();
        /**
     * unique id for this container
     * @internal
     */ this.uid = (0, $aGJhg.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container. Each child must be a Container or extend from it.
     *
     * The array is read-only, but its contents can be modified using Container methods.
     * @example
     * ```ts
     * // Access children
     * const firstChild = container.children[0];
     * const lastChild = container.children[container.children.length - 1];
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding children
     * @see {@link Container#removeChild} For removing children
     */ this.children = [];
        /**
     * The display object container that contains this display object.
     * This represents the parent-child relationship in the display tree.
     * @example
     * ```ts
     * // Basic parent access
     * const parent = sprite.parent;
     *
     * // Walk up the tree
     * let current = sprite;
     * while (current.parent) {
     *     console.log('Level up:', current.parent.constructor.name);
     *     current = current.parent;
     * }
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding to a parent
     * @see {@link Container#removeChild} For removing from parent
     */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        /**
     * The RenderLayer this container belongs to, if any.
     * If it belongs to a RenderLayer, it will be rendered from the RenderLayer's position in the scene.
     * @readonly
     * @advanced
     */ this.parentRenderLayer = null;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /** @internal */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * This matrix represents the local transformation without any parent influence.
     * @example
     * ```ts
     * // Basic transform access
     * const localMatrix = sprite.localTransform;
     * console.log(localMatrix.toString());
     * ```
     * @readonly
     * @see {@link Container#worldTransform} For global transform
     * @see {@link Container#groupTransform} For render group transform
     */ this.localTransform = new (0, $eY4rt.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     * @advanced
     */ this.relativeGroupTransform = new (0, $eY4rt.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     * @advanced
     */ this.groupTransform = this.relativeGroupTransform;
        /**
     * Whether this object has been destroyed. If true, the object should no longer be used.
     * After an object is destroyed, all of its functionality is disabled and references are removed.
     * @example
     * ```ts
     * // Cleanup with destroy
     * sprite.destroy();
     * console.log(sprite.destroyed); // true
     * ```
     * @default false
     * @see {@link Container#destroy} For destroying objects
     */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     */ this._position = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     */ this._scale = $8a2b4ed6f59ce4dc$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     */ this._pivot = $8a2b4ed6f59ce4dc$var$defaultPivot;
        /**
     * The origin point around which the container rotates and scales.
     * Unlike pivot, changing origin will not move the container's position.
     * @private
     */ this._origin = $8a2b4ed6f59ce4dc$var$defaultOrigin;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     */ this._skew = $8a2b4ed6f59ce4dc$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        /** @internal */ this.localColor = 16777215;
        /** @internal */ this.localAlpha = 1;
        /** @internal */ this.groupAlpha = 1;
        // A
        /** @internal */ this.groupColor = 16777215;
        // BGR
        /** @internal */ this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /** @internal */ this.localBlendMode = "inherit";
        /** @internal */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /** @internal */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $gIPW8.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */ static mixin(source) {
        (0, $kXq8E.deprecation)("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead.");
        (0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, source);
    }
    // = 'default';
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    /** @ignore */ get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */ addChild(...children) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (renderGroup) renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            if (child.parentRenderLayer) child.parentRenderLayer.detach(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $61KiY.BigPool).get((0, $1pFbO.RenderGroup), this);
        this.groupTransform = (0, $eY4rt.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /**
   * This will disable the render group for this container.
   * @advanced
   */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $61KiY.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $eY4rt.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */ get angle() {
        return this.rotation * (0, $aWW4e.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $aWW4e.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) {
            this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
            if (this._origin !== $8a2b4ed6f59ce4dc$var$defaultOrigin) (0, $hUCK4.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */ get skew() {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        if (typeof value === "string") value = parseFloat(value);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */ get origin() {
        if (this._origin === $8a2b4ed6f59ce4dc$var$defaultOrigin) this._origin = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._origin;
    }
    set origin(value) {
        if (this._origin === $8a2b4ed6f59ce4dc$var$defaultOrigin) {
            this._origin = new (0, $a32F4.ObservablePoint)(this, 0, 0);
            if (this._pivot !== $8a2b4ed6f59ce4dc$var$defaultPivot) (0, $hUCK4.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._origin.set(value) : this._origin.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        this.origin.set(typeof opts.originX === "number" ? opts.originX : this.origin.x, typeof opts.originY === "number" ? opts.originY : this.origin.y);
        return this;
    }
    /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const origin = this._origin;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        const ox = -origin._x;
        const oy = -origin._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c) + (ox * lt.a + oy * lt.c) - ox;
        lt.ty = position._y - (px * lt.b + py * lt.d) + (ox * lt.b + oy * lt.d) - oy;
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $a2eTA.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */ get tint() {
        return (0, $8ifkW.bgr2rgb)(this.localColor);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
        this.emit("visibleChanged", value);
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /**
   * Whether or not the object should be rendered.
   * @advanced
   */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        let oldChildren;
        if (this.children.length) oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._origin = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren && oldChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
(0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, (0, $236jP.childrenHelperMixin), (0, $3hzRR.getFastGlobalBoundsMixin), (0, $g5iYs.toLocalGlobalMixin), (0, $ggvKl.onRenderMixin), (0, $kEqoj.measureMixin), (0, $apXS2.effectsMixin), (0, $kkVML.findMixin), (0, $82jXu.sortMixin), (0, $j1i7q.cullingMixin), (0, $9atlQ.cacheAsTextureMixin), (0, $8ifkW.getGlobalMixin), (0, $49nq9.collectRenderablesMixin));

});
parcelRegister("a2eTA", function(module, exports) {

$parcel$export(module.exports, "Color", () => $f6a94f8017837c10$export$892596cec99bc70e);

var $erZA3 = parcelRequire("erZA3");

var $lCM3s = parcelRequire("lCM3s");
"use strict";
(0, $erZA3.extend)([
    (0, $lCM3s.default)
]);
const $f6a94f8017837c10$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */ get red() {
        return this._components[0];
    }
    /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */ get green() {
        return this._components[1];
    }
    /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */ get blue() {
        return this._components[2];
    }
    /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */ get alpha() {
        return this._components[3];
    }
    /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */ toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */ toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out || (out = this._arrayRgba);
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */ toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        this._value = null;
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $erZA3.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Static shared Color instance used for utility operations. This is a singleton color object
 * that can be reused to avoid creating unnecessary Color instances.
 * > [!IMPORTANT] You should be careful when using this shared instance, as it is mutable and can be
 * > changed by any code that uses it.
 * >
 * > It is best used for one-off color operations or temporary transformations.
 * > For persistent colors, create your own Color instance instead.
 * @example
 * ```ts
 * import { Color } from 'pixi.js';
 *
 * // Use shared instance for one-off color operations
 * Color.shared.setValue(0xff0000);
 * const redHex = Color.shared.toHex();     // "#ff0000"
 * const redRgb = Color.shared.toRgbArray(); // [1, 0, 0]
 *
 * // Temporary color transformations
 * const colorNumber = Color.shared
 *     .setValue('#ff0000')     // Set to red
 *     .setAlpha(0.5)          // Make semi-transparent
 *     .premultiply(0.8)       // Apply premultiplication
 *     .toNumber();            // Convert to number
 *
 * // Chain multiple operations
 * const result = Color.shared
 *     .setValue(someColor)
 *     .multiply(tintColor)
 *     .toPremultiplied(alpha);
 * ```
 * @remarks
 * - This is a shared instance - be careful about multiple code paths using it simultaneously
 * - Use for temporary color operations to avoid allocating new Color instances
 * - The value is preserved between operations, so reset if needed
 * - For persistent colors, create your own Color instance instead
 */ $f6a94f8017837c10$var$_Color.shared = new $f6a94f8017837c10$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $f6a94f8017837c10$var$_Color._temp = new $f6a94f8017837c10$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f6a94f8017837c10$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $f6a94f8017837c10$export$892596cec99bc70e = $f6a94f8017837c10$var$_Color;

});
parcelRegister("erZA3", function(module, exports) {

$parcel$export(module.exports, "colord", () => $482ad42e73ee00b6$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $482ad42e73ee00b6$export$8b58be045bf06082);
var $482ad42e73ee00b6$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $482ad42e73ee00b6$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $482ad42e73ee00b6$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $482ad42e73ee00b6$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $482ad42e73ee00b6$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $482ad42e73ee00b6$var$a = function(r) {
    return {
        r: $482ad42e73ee00b6$var$e(r.r, 0, 255),
        g: $482ad42e73ee00b6$var$e(r.g, 0, 255),
        b: $482ad42e73ee00b6$var$e(r.b, 0, 255),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$o = function(r) {
    return {
        r: $482ad42e73ee00b6$var$n(r.r),
        g: $482ad42e73ee00b6$var$n(r.g),
        b: $482ad42e73ee00b6$var$n(r.b),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$i = /^#([0-9a-f]{3,8})$/i, $482ad42e73ee00b6$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $482ad42e73ee00b6$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $482ad42e73ee00b6$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $482ad42e73ee00b6$var$g = function(r) {
    return {
        h: $482ad42e73ee00b6$var$u(r.h),
        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
        l: $482ad42e73ee00b6$var$e(r.l, 0, 100),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$d = function(r) {
    return {
        h: $482ad42e73ee00b6$var$n(r.h),
        s: $482ad42e73ee00b6$var$n(r.s),
        l: $482ad42e73ee00b6$var$n(r.l),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$f = function(r) {
    var t, n, e;
    return $482ad42e73ee00b6$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $482ad42e73ee00b6$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $482ad42e73ee00b6$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $482ad42e73ee00b6$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$y = {
    string: [
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$v.exec(r) || $482ad42e73ee00b6$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $482ad42e73ee00b6$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $482ad42e73ee00b6$var$l.exec(t) || $482ad42e73ee00b6$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $482ad42e73ee00b6$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($482ad42e73ee00b6$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $482ad42e73ee00b6$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $482ad42e73ee00b6$var$t(n) && $482ad42e73ee00b6$var$t(e) && $482ad42e73ee00b6$var$t(u) ? $482ad42e73ee00b6$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(e) || !$482ad42e73ee00b6$var$t(u)) return null;
                var i = $482ad42e73ee00b6$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $482ad42e73ee00b6$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(a) || !$482ad42e73ee00b6$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $482ad42e73ee00b6$var$u(r.h),
                        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
                        v: $482ad42e73ee00b6$var$e(r.v, 0, 100),
                        a: $482ad42e73ee00b6$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $482ad42e73ee00b6$var$b(h);
            },
            "hsv"
        ]
    ]
}, $482ad42e73ee00b6$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$var$x = function(r) {
    return "string" == typeof r ? $482ad42e73ee00b6$var$N(r.trim(), $482ad42e73ee00b6$var$y.string) : "object" == typeof r && null !== r ? $482ad42e73ee00b6$var$N(r, $482ad42e73ee00b6$var$y.object) : [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$export$f61ac8b6f1f46202 = function(r) {
    return $482ad42e73ee00b6$var$x(r)[1];
}, $482ad42e73ee00b6$var$M = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: $482ad42e73ee00b6$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $482ad42e73ee00b6$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $482ad42e73ee00b6$var$$ = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $482ad42e73ee00b6$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $482ad42e73ee00b6$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $482ad42e73ee00b6$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $482ad42e73ee00b6$var$n($482ad42e73ee00b6$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $482ad42e73ee00b6$var$s($482ad42e73ee00b6$var$n(255 * a)) : "", "#" + $482ad42e73ee00b6$var$s(t) + $482ad42e73ee00b6$var$s(e) + $482ad42e73ee00b6$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $482ad42e73ee00b6$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $482ad42e73ee00b6$var$h(this.rgba), {
            h: $482ad42e73ee00b6$var$n(r.h),
            s: $482ad42e73ee00b6$var$n(r.s),
            v: $482ad42e73ee00b6$var$n(r.v),
            a: $482ad42e73ee00b6$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $482ad42e73ee00b6$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $482ad42e73ee00b6$var$c(this.rgba);
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $482ad42e73ee00b6$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $482ad42e73ee00b6$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $482ad42e73ee00b6$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $482ad42e73ee00b6$export$4d30ed660ff08d0 ? r : new $482ad42e73ee00b6$export$4d30ed660ff08d0(r);
}, $482ad42e73ee00b6$var$S = [], $482ad42e73ee00b6$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $482ad42e73ee00b6$var$S.indexOf(r) < 0 && (r($482ad42e73ee00b6$export$4d30ed660ff08d0, $482ad42e73ee00b6$var$y), $482ad42e73ee00b6$var$S.push(r));
    });
}, $482ad42e73ee00b6$export$4385e60b38654f68 = function() {
    return new $482ad42e73ee00b6$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("lCM3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1f6e6e10c0717$export$2e2bcd8739ae039);
function $4bf1f6e6e10c0717$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("j1i7q", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $b5b40e006e048a91$export$dce76d4f0fd249ed);
"use strict";
const $b5b40e006e048a91$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("hUCK4", function(module, exports) {

$parcel$export(module.exports, "warn", () => $ffdcd240d931c2ea$export$c106dd0671a0fc2d);
"use strict";
let $ffdcd240d931c2ea$var$warnCount = 0;
const $ffdcd240d931c2ea$var$maxWarnings = 500;
function $ffdcd240d931c2ea$export$c106dd0671a0fc2d(...args) {
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) return;
    $ffdcd240d931c2ea$var$warnCount++;
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});

parcelRegister("61KiY", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $9483424e2013bba4$export$8249372279066210);

var $2GH55 = parcelRequire("2GH55");

var $5Xsoh = parcelRequire("5Xsoh");
"use strict";
class $9483424e2013bba4$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $5Xsoh.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
    /** Clears all pools in the group. This will reset all pools and free their resources. */ clear() {
        this._poolsByClass.forEach((pool)=>pool.clear());
        this._poolsByClass.clear();
    }
}
const $9483424e2013bba4$export$8249372279066210 = new $9483424e2013bba4$export$866836a21808b71c();
(0, $2GH55.GlobalResourceRegistry).register($9483424e2013bba4$export$8249372279066210);

});
parcelRegister("2GH55", function(module, exports) {

$parcel$export(module.exports, "GlobalResourceRegistry", () => $d9b938d02c9f10cf$export$b2525f5e8e38902b);
"use strict";
const $d9b938d02c9f10cf$export$b2525f5e8e38902b = {
    /**
   * Set of registered pools and cleanable objects.
   * @private
   */ _registeredResources: /* @__PURE__ */ new Set(),
    /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */ register (pool) {
        this._registeredResources.add(pool);
    },
    /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */ unregister (pool) {
        this._registeredResources.delete(pool);
    },
    /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */ release () {
        this._registeredResources.forEach((pool)=>pool.clear());
    },
    /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */ get registeredCount () {
        return this._registeredResources.size;
    },
    /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */ isRegistered (pool) {
        return this._registeredResources.has(pool);
    },
    /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */ reset () {
        this._registeredResources.clear();
    }
};

});

parcelRegister("5Xsoh", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $ce33839780b5f2f3$export$14963ee5c8637e11);
"use strict";
class $ce33839780b5f2f3$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else {
            item = new this._classType();
            this._count++;
        }
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool */ clear() {
        if (this._pool.length > 0 && this._pool[0].destroy) for(let i = 0; i < this._index; i++)this._pool[i].destroy();
        this._pool.length = 0;
        this._count = 0;
        this._index = 0;
    }
}

});


parcelRegister("9atlQ", function(module, exports) {

$parcel$export(module.exports, "cacheAsTextureMixin", () => $a8b261c324971086$export$9660f593b1298e75);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $a8b261c324971086$export$9660f593b1298e75 = {
    get isCachedAsTexture () {
        return !!this.renderGroup?.isCachedAsTexture;
    },
    cacheAsTexture (val1) {
        if (typeof val1 === "boolean" && val1 === false) this.disableRenderGroup();
        else {
            this.enableRenderGroup();
            this.renderGroup.enableCacheAsTexture(val1 === true ? {} : val1);
        }
    },
    updateCacheTexture () {
        this.renderGroup?.updateCacheTexture();
    },
    get cacheAsBitmap () {
        return this.isCachedAsTexture;
    },
    set cacheAsBitmap (val){
        (0, $kXq8E.deprecation)("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
        this.cacheAsTexture(val);
    }
};

});

parcelRegister("236jP", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $0d8e0eeab3189cd3$export$64cca9f0c2df174a);

var $33PVi = parcelRequire("33PVi");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $0d8e0eeab3189cd3$export$64cca9f0c2df174a = {
    allowChildren: true,
    removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $33PVi.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                const child = removed[i];
                child.parentRenderLayer?.detach(child);
                this.emit("childRemoved", child, this, i);
                removed[i].emit("removed", this);
            }
            if (removed.length > 0) this._didViewChangeTick++;
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    addChildAt (child, index) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        const sameParent = child.parent === this;
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (sameParent) {
                if (currentIndex === index) return child;
                child.parent.children.splice(currentIndex, 1);
            } else child.removeFromParent();
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        if (sameParent) return child;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    removeFromParent () {
        this.parent?.removeChild(this);
    },
    reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    },
    replaceChild (oldChild, newChild) {
        oldChild.updateLocalTransform();
        this.addChildAt(newChild, this.getChildIndex(oldChild));
        newChild.setFromMatrix(oldChild.localTransform);
        newChild.updateLocalTransform();
        this.removeChild(oldChild);
    }
};

});
parcelRegister("33PVi", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $cefc366e7023560b$export$8d47c0e1ce445404);
"use strict";
function $cefc366e7023560b$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("49nq9", function(module, exports) {

$parcel$export(module.exports, "collectRenderablesMixin", () => $0a36b694a408d29d$export$e50be97f8cd670d0);
"use strict";
const $0a36b694a408d29d$export$e50be97f8cd670d0 = {
    collectRenderables (instructionSet, renderer, currentLayer) {
        if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild) return;
        if (this.sortableChildren) this.sortChildren();
        if (this.isSimple) this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        else if (this.renderGroup) renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
        else this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    },
    collectRenderablesSimple (instructionSet, renderer, currentLayer) {
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    },
    collectRenderablesWithEffects (instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        for(let i = 0; i < this.effects.length; i++){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.push(effect, this, instructionSet);
        }
        this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        for(let i = this.effects.length - 1; i >= 0; i--){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.pop(effect, this, instructionSet);
        }
    }
};

});

parcelRegister("apXS2", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $1d59e812d2000ae8$export$eec5e288a9d02a7c);

var $aWIPo = parcelRequire("aWIPo");

var $dZmDL = parcelRequire("dZmDL");
"use strict";
const $1d59e812d2000ae8$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _maskOptions: {
        inverse: false
    },
    _filterEffect: null,
    effects: [],
    _markStructureAsChanged () {
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
    },
    addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $dZmDL.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $dZmDL.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    get mask () {
        return this._maskEffect?.mask;
    },
    setMask (options) {
        this._maskOptions = {
            ...this._maskOptions,
            ...options
        };
        if (options.mask) this.mask = options.mask;
        this._markStructureAsChanged();
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("aWIPo", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $573d66e12a5f4185$export$d66c06ffe23037ab);
"use strict";
class $573d66e12a5f4185$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("dZmDL", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $f40a37c299623cb8$export$1eb319167fe02d04);

var $i9BKe = parcelRequire("i9BKe");

var $61KiY = parcelRequire("61KiY");
"use strict";
class $f40a37c299623cb8$export$3b0749bf144d4b29 {
    constructor(){
        /** @private */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $61KiY.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $61KiY.BigPool).return(effect);
    }
}
const $f40a37c299623cb8$export$1eb319167fe02d04 = new $f40a37c299623cb8$export$3b0749bf144d4b29();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).MaskEffect, $f40a37c299623cb8$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("kkVML", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $1ce16328dd0c7b09$export$468b0762e1bfbd64);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $1ce16328dd0c7b09$export$468b0762e1bfbd64 = {
    label: null,
    get name () {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("3hzRR", function(module, exports) {

$parcel$export(module.exports, "getFastGlobalBoundsMixin", () => $af7175d9cdd285e4$export$993f17c9646405e3);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $af7175d9cdd285e4$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $af7175d9cdd285e4$export$993f17c9646405e3 = {
    getFastGlobalBounds (factorRenderLayers, bounds) {
        bounds || (bounds = new (0, $7wtv9.Bounds)());
        bounds.clear();
        this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        bounds.applyMatrix(renderGroup.worldTransform);
        return bounds;
    },
    _getGlobalBoundsRecursive (factorRenderLayers, bounds, currentLayer) {
        let localBounds = bounds;
        if (factorRenderLayers && this.parentRenderLayer && this.parentRenderLayer !== currentLayer) return;
        if (this.localDisplayStatus !== 7 || !this.measurable) return;
        const manageEffects = !!this.effects.length;
        if (this.renderGroup || manageEffects) localBounds = (0, $5tmC8.boundsPool).get().clear();
        if (this.boundsArea) bounds.addRect(this.boundsArea, this.worldTransform);
        else {
            if (this.renderPipeId) {
                const viewBounds = this.bounds;
                localBounds.addFrame(viewBounds.minX, viewBounds.minY, viewBounds.maxX, viewBounds.maxY, this.groupTransform);
            }
            const children = this.children;
            for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
        }
        if (manageEffects) {
            let advanced = false;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            for(let i = 0; i < this.effects.length; i++)if (this.effects[i].addBounds) {
                if (!advanced) {
                    advanced = true;
                    localBounds.applyMatrix(renderGroup.worldTransform);
                }
                this.effects[i].addBounds(localBounds, true);
            }
            if (advanced) localBounds.applyMatrix(renderGroup.worldTransform.copyTo($af7175d9cdd285e4$var$tempMatrix).invert());
            bounds.addBounds(localBounds);
            (0, $5tmC8.boundsPool).return(localBounds);
        } else if (this.renderGroup) {
            bounds.addBounds(localBounds, this.relativeGroupTransform);
            (0, $5tmC8.boundsPool).return(localBounds);
        }
    }
};

});
parcelRegister("5tmC8", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $aaa7ee585a7b6ebc$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $aaa7ee585a7b6ebc$export$9194656040c1dc42);

var $eY4rt = parcelRequire("eY4rt");

var $61KiY = parcelRequire("61KiY");

var $7wtv9 = parcelRequire("7wtv9");
"use strict";
const $aaa7ee585a7b6ebc$export$3849005ba4dacf72 = (0, $61KiY.BigPool).getPool((0, $eY4rt.Matrix));
const $aaa7ee585a7b6ebc$export$9194656040c1dc42 = (0, $61KiY.BigPool).getPool((0, $7wtv9.Bounds));

});


parcelRegister("8ifkW", function(module, exports) {

$parcel$export(module.exports, "bgr2rgb", () => $cff3716760fd205e$export$110f9f26b10ddb4a);
$parcel$export(module.exports, "getGlobalMixin", () => $cff3716760fd205e$export$c7c22dc0c465d95a);

var $eY4rt = parcelRequire("eY4rt");

var $iskjc = parcelRequire("iskjc");

var $5tmC8 = parcelRequire("5tmC8");

var $4KYBZ = parcelRequire("4KYBZ");
"use strict";
function $cff3716760fd205e$export$110f9f26b10ddb4a(color) {
    return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const $cff3716760fd205e$export$c7c22dc0c465d95a = {
    getGlobalAlpha (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return this.renderGroup.worldAlpha;
            if (this.parentRenderGroup) return this.parentRenderGroup.worldAlpha * this.alpha;
            return this.alpha;
        }
        let alpha = this.alpha;
        let current = this.parent;
        while(current){
            alpha *= current.alpha;
            current = current.parent;
        }
        return alpha;
    },
    getGlobalTransform (matrix = new (0, $eY4rt.Matrix)(), skipUpdate) {
        if (skipUpdate) return matrix.copyFrom(this.worldTransform);
        this.updateLocalTransform();
        const parentTransform = (0, $iskjc.updateTransformBackwards)(this, (0, $5tmC8.matrixPool).get().identity());
        matrix.appendFrom(this.localTransform, parentTransform);
        (0, $5tmC8.matrixPool).return(parentTransform);
        return matrix;
    },
    getGlobalTint (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a(this.renderGroup.worldColor);
            if (this.parentRenderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a((0, $4KYBZ.multiplyColors)(this.localColor, this.parentRenderGroup.worldColor));
            return this.tint;
        }
        let color = this.localColor;
        let parent = this.parent;
        while(parent){
            color = (0, $4KYBZ.multiplyColors)(color, parent.localColor);
            parent = parent.parent;
        }
        return $cff3716760fd205e$export$110f9f26b10ddb4a(color);
    }
};

});
parcelRegister("iskjc", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $b2563854990e287d$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $b2563854990e287d$export$2022bc48a49dd6d2);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $b2563854990e287d$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $5tmC8.matrixPool).get().identity();
            parentTransform = $b2563854990e287d$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $eY4rt.Matrix).IDENTITY;
    $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $5tmC8.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $5tmC8.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        const renderableBounds = target.bounds;
        if (renderableBounds && !renderableBounds.isEmpty()) {
            bounds.matrix = worldTransform;
            bounds.addBounds(renderableBounds);
        }
        for(let i = 0; i < target.children.length; i++)$b2563854990e287d$var$_getGlobalBounds(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $5tmC8.matrixPool).return(worldTransform);
}
function $b2563854990e287d$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $b2563854990e287d$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});

parcelRegister("4KYBZ", function(module, exports) {

$parcel$export(module.exports, "multiplyColors", () => $d2dd747da74b9c5e$export$a82a3ae2e3118160);

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $d2dd747da74b9c5e$var$WHITE_BGR = 16777215;
function $d2dd747da74b9c5e$export$a82a3ae2e3118160(localBGRColor, parentBGRColor) {
    if (localBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return parentBGRColor;
    if (parentBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return localBGRColor;
    return (0, $3N6bV.multiplyHexColors)(localBGRColor, parentBGRColor);
}

});
parcelRegister("3N6bV", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $038267701630e9a0$export$815d7ea0395de72c);
"use strict";
function $038267701630e9a0$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255 | 0;
    const g = g1 * g2 / 255 | 0;
    const b = b1 * b2 / 255 | 0;
    return (r << 16) + (g << 8) + b;
}

});



parcelRegister("kEqoj", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $4a6a8e8422db6a2e$export$285e6e72e8e62f0);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");

var $j68wk = parcelRequire("j68wk");

var $lK289 = parcelRequire("lK289");
"use strict";
const $4a6a8e8422db6a2e$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $4a6a8e8422db6a2e$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $7wtv9.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $lK289.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $j68wk.getLocalBounds)(this, localBoundsCacheData.localBounds, $4a6a8e8422db6a2e$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    getBounds (skipUpdate, bounds) {
        return (0, $iskjc.getGlobalBounds)(this, skipUpdate, bounds || new (0, $7wtv9.Bounds)());
    }
};

});
parcelRegister("j68wk", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $653ce529dcaa332d$export$ffaf4f504c4c5c9c);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $653ce529dcaa332d$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $eY4rt.Matrix).IDENTITY);
    $653ce529dcaa332d$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $653ce529dcaa332d$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            bounds.addBounds(target.bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$653ce529dcaa332d$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    (0, $5tmC8.matrixPool).return(relativeTransform);
}

});

parcelRegister("lK289", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $6ac8d139665df8ac$export$fd5aadbd3827bcf1);
"use strict";
function $6ac8d139665df8ac$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $6ac8d139665df8ac$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("ggvKl", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $63981d12ee78567e$export$2a5246d1114cb81d);
"use strict";
const $63981d12ee78567e$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("82jXu", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $8864252dd84a6b69$export$eb4acdd9f4781aed);
"use strict";
const $8864252dd84a6b69$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    sortDirty: false,
    sortableChildren: false,
    get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($8864252dd84a6b69$var$sortChildren);
    }
};
function $8864252dd84a6b69$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("g5iYs", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $6a95391942e887de$export$38fa7a987602e8dd);

var $1HooC = parcelRequire("1HooC");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $6a95391942e887de$export$38fa7a987602e8dd = {
    getGlobalPosition (point = new (0, $1HooC.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    toGlobal (position, point, skipUpdate = false) {
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.apply(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    },
    toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.applyInverse(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    }
};

});

parcelRegister("1pFbO", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $5a621eb8e375b2c4$export$94d273f8d74f2a5);

var $eY4rt = parcelRequire("eY4rt");

var $dK5Jn = parcelRequire("dK5Jn");

var $3Xbp7 = parcelRequire("3Xbp7");
"use strict";
class $5a621eb8e375b2c4$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $eY4rt.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        this.gcTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $dK5Jn.InstructionSet)();
        this._onRenderContainers = [];
        /**
     * Indicates if the cached texture needs to be updated.
     * @default true
     */ this.textureNeedsUpdate = true;
        /**
     * Indicates if the container should be cached as a texture.
     * @default false
     */ this.isCachedAsTexture = false;
        this._matrixDirty = 7;
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child._updateFlags = 15;
            this.addChild(child);
        }
    }
    enableCacheAsTexture(options = {}) {
        this.textureOptions = options;
        this.isCachedAsTexture = true;
        this.textureNeedsUpdate = true;
    }
    disableCacheAsTexture() {
        this.isCachedAsTexture = false;
        if (this.texture) {
            (0, $3Xbp7.TexturePool).returnTexture(this.texture, true);
            this.texture = null;
        }
    }
    updateCacheTexture() {
        this.textureNeedsUpdate = true;
        const cachedParent = this._parentCacheAsTextureRenderGroup;
        if (cachedParent && !cachedParent.textureNeedsUpdate) cachedParent.updateCacheTexture();
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
        this.disableCacheAsTexture();
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    updateRenderable(renderable) {
        if (renderable.globalDisplayStatus < 7) return;
        this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
        renderable.didViewUpdate = false;
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender(renderer) {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender(renderer);
    }
    destroy() {
        this.disableCacheAsTexture();
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    invalidateMatrices() {
        this._matrixDirty = 7;
    }
    /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */ get inverseWorldTransform() {
        if ((this._matrixDirty & 1) === 0) return this._inverseWorldTransform;
        this._matrixDirty &= -2;
        this._inverseWorldTransform || (this._inverseWorldTransform = new (0, $eY4rt.Matrix)());
        return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
    }
    /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */ get textureOffsetInverseTransform() {
        if ((this._matrixDirty & 2) === 0) return this._textureOffsetInverseTransform;
        this._matrixDirty &= -3;
        this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new (0, $eY4rt.Matrix)());
        return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(-this._textureBounds.x, -this._textureBounds.y);
    }
    /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */ get inverseParentTextureTransform() {
        if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
        this._matrixDirty &= -5;
        const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
        if (parentCacheAsTexture) {
            this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new (0, $eY4rt.Matrix)());
            return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(-parentCacheAsTexture._textureBounds.x, -parentCacheAsTexture._textureBounds.y);
        }
        return this.worldTransform;
    }
    /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */ get cacheToLocalTransform() {
        if (this.isCachedAsTexture) return this.textureOffsetInverseTransform;
        if (!this._parentCacheAsTextureRenderGroup) return null;
        return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
    }
}

});
parcelRegister("dK5Jn", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $a69ff318b1fa7c86$export$2946bd01f10dd922);

var $aGJhg = parcelRequire("aGJhg");
"use strict";
class $a69ff318b1fa7c86$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $aGJhg.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        /** used by the garbage collector to track when the instruction set was last used */ this.gcTick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Destroy the instruction set, clearing the instructions and renderables.
   * @internal
   */ destroy() {
        this.instructions.length = 0;
        this.renderables.length = 0;
        this.renderPipes = null;
        this.gcTick = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});

parcelRegister("3Xbp7", function(module, exports) {

$parcel$export(module.exports, "TexturePool", () => $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2);

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
let $0b9fa50ced13ccd0$var$count = 0;
class $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this.textureStyle = new (0, $aFPUT.TextureStyle)(this.textureOptions);
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   * @param autoGenerateMipmaps - Whether to automatically generate mipmaps for this texture
   */ createTexture(pixelWidth, pixelHeight, antialias, autoGenerateMipmaps) {
        const textureSource = new (0, $iA5fe.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: false,
            autoGenerateMipmaps: autoGenerateMipmaps
        });
        return new (0, $bLlTJ.Texture)({
            source: textureSource,
            label: `texturePool_${$0b9fa50ced13ccd0$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @param autoGenerateMipmaps - Whether to automatically generate mipmaps. Defaults to false.
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias, autoGenerateMipmaps = false) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $NbSCN.nextPow2)(po2Width);
        po2Height = (0, $NbSCN.nextPow2)(po2Height);
        const antialiasFlag = antialias ? 1 : 0;
        const mipmapFlag = autoGenerateMipmaps ? 1 : 0;
        const key = (po2Width << 17) + (po2Height << 2) + (mipmapFlag << 1) + antialiasFlag;
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias, autoGenerateMipmaps);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets a pooled texture matching the dimensions and resolution of the given texture.
   *
   * This is a convenience wrapper around {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * that copies width, height, and resolution from an existing texture. Useful when a filter needs
   * a temporary texture the same size as its input (e.g., for multi-pass blur).
   * @param texture - The texture whose dimensions to match.
   * @param antialias - Whether to use antialias on the pooled texture. Defaults to `false`.
   * @returns A pooled texture with power-of-two backing dimensions at the source resolution.
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Returns a texture to the pool so it can be reused by future
   * {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * or {@link TexturePoolClass#getSameSizeTexture|getSameSizeTexture} calls.
   *
   * If you modified the texture's style after obtaining it (e.g., changed filtering or wrapping),
   * pass `resetStyle = true` to restore the pool's default {@link TexturePoolClass#textureStyle|textureStyle}.
   * This prevents style changes from leaking into subsequent consumers of the same pooled texture.
   * @param renderTexture - The texture to return to the pool.
   * @param resetStyle - When `true`, replaces the texture source's style with the pool default. Defaults to `false`.
   */ returnTexture(renderTexture, resetStyle = false) {
        const key = this._poolKeyHash[renderTexture.uid];
        if (resetStyle) renderTexture.source.style = this.textureStyle;
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2 = new $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d();
(0, $2GH55.GlobalResourceRegistry).register($0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2);

});


parcelRegister("gIPW8", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $83c57e61d47d996f$export$59d0441a278e5935);
"use strict";
function $83c57e61d47d996f$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("jzlb7", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $cd1eadd0f2fb679c$export$12af48852c6ac574);

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");
"use strict";
const $cd1eadd0f2fb679c$var$tempBounds = new (0, $7wtv9.Bounds)();
function $cd1eadd0f2fb679c$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $cd1eadd0f2fb679c$var$tempBounds;
    mask.measurable = true;
    (0, $iskjc.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("4vXk0", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $6df4144b7f405909$export$7416ac774b1f1a33);

var $j68wk = parcelRequire("j68wk");

var $5tmC8 = parcelRequire("5tmC8");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $6df4144b7f405909$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $5tmC8.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $5tmC8.matrixPool).get().identity();
    const relativeMask = $6df4144b7f405909$var$getMatrixRelativeToParent(mask, localRoot, tempMatrix);
    (0, $j68wk.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $5tmC8.matrixPool).return(tempMatrix);
    (0, $5tmC8.boundsPool).return(boundsToMask);
}
function $6df4144b7f405909$var$getMatrixRelativeToParent(target, root, matrix) {
    if (!target) {
        (0, $hUCK4.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $6df4144b7f405909$var$getMatrixRelativeToParent(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("lLQso", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $2625cf12b5a3b5e5$export$1e2a2c76374c2542);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $2625cf12b5a3b5e5$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$2625cf12b5a3b5e5$export$1e2a2c76374c2542.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("jXXId", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $e8890ea82735e7dd$export$abd85894695764cb);

var $i9BKe = parcelRequire("i9BKe");

var $eicwU = parcelRequire("eicwU");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $e8890ea82735e7dd$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $eicwU.Container);
    }
}
$e8890ea82735e7dd$export$abd85894695764cb.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("8xl7d", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $adfc96265c7ca69d$export$ca65ccf5708c6a0c);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $adfc96265c7ca69d$export$ca65ccf5708c6a0c extends (0, $iA5fe.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $iCGeI.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity && "style" in this.resource) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$adfc96265c7ca69d$export$ca65ccf5708c6a0c.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iCGeI", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $bfbe44ab70ab7a53$export$d988306fa84f7b44);

var $9OKiP = parcelRequire("9OKiP");
"use strict";
let $bfbe44ab70ab7a53$var$currentAdapter = (0, $9OKiP.BrowserAdapter);
const $bfbe44ab70ab7a53$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $bfbe44ab70ab7a53$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $bfbe44ab70ab7a53$var$currentAdapter = adapter;
    }
};

});
parcelRegister("9OKiP", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $ed1c5172c2eee607$export$e467cc3399500025);
"use strict";
const $ed1c5172c2eee607$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    createImage: ()=>new Image(),
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("aQPld", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $ac4c5539d7b1f960$export$280e9a68c3ffd919);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $ac4c5539d7b1f960$export$280e9a68c3ffd919 extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$ac4c5539d7b1f960$export$280e9a68c3ffd919.extension = (0, $i9BKe.ExtensionType).TextureSource;

});

parcelRegister("hNatJ", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $4dc351acd421ceef$export$f3a17123d80000c5);

var $i9BKe = parcelRequire("i9BKe");

var $4J7WL = parcelRequire("4J7WL");

var $7blVu = parcelRequire("7blVu");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
const $4dc351acd421ceef$var$_VideoSource = class _VideoSource extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $4J7WL.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $7blVu.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$4dc351acd421ceef$var$_VideoSource.extension = (0, $i9BKe.ExtensionType).TextureSource;
/** The default options for video sources. */ $4dc351acd421ceef$var$_VideoSource.defaultOptions = {
    ...(0, $iA5fe.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $4dc351acd421ceef$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $4dc351acd421ceef$export$f3a17123d80000c5 = $4dc351acd421ceef$var$_VideoSource;

});
parcelRegister("4J7WL", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $2bf8d15685054100$export$39c54bcc89dcee11);

var $cQMLP = parcelRequire("cQMLP");

var $bJH8Y = parcelRequire("bJH8Y");
"use strict";
const $2bf8d15685054100$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method {@link Ticker#start|start}
     * automatically when a listener is added.
     * @example
     * ```ts
     * // Default behavior (manual start)
     * const ticker = new Ticker();
     * ticker.autoStart = false;
     * ticker.add(() => {
     *     // Won't run until ticker.start() is called
     * });
     *
     * // Auto-start behavior
     * const autoTicker = new Ticker();
     * autoTicker.autoStart = true;
     * autoTicker.add(() => {
     *     // Runs immediately when added
     * });
     * ```
     * @default false
     * @see {@link Ticker#start} For manually starting the ticker
     * @see {@link Ticker#stop} For manually stopping the ticker
     */ this.autoStart = false;
        /**
     * Scalar representing the delta time factor.
     * This is a dimensionless value representing the fraction of a frame at the target framerate.
     * At 60 FPS, this value is typically around 1.0.
     *
     * This is NOT in milliseconds - it's a scalar multiplier for frame-independent animations.
     * For actual milliseconds, use {@link Ticker#deltaMS}.
     * @example
     * ```ts
     * // Frame-independent animation using deltaTime scalar
     * ticker.add((ticker) => {
     *     // Rotate sprite by 0.1 radians per frame, scaled by deltaTime
     *     sprite.rotation += 0.1 * ticker.deltaTime;
     * });
     * ```
     */ this.deltaTime = 1;
        /**
     * The last time update was invoked, in milliseconds since epoch.
     * Similar to performance.now() timestamp format.
     *
     * Used internally for calculating time deltas between frames.
     * @example
     * ```ts
     * ticker.add((ticker) => {
     *     const currentTime = performance.now();
     *     const timeSinceLastFrame = currentTime - ticker.lastTime;
     *     console.log(`Time since last frame: ${timeSinceLastFrame}ms`);
     * });
     * ```
     */ this.lastTime = -1;
        /**
     * Factor of current {@link Ticker#deltaTime|deltaTime}.
     * Used to scale time for slow motion or fast-forward effects.
     * @example
     * ```ts
     * // Basic speed adjustment
     * ticker.speed = 0.5; // Half speed (slow motion)
     * ticker.speed = 2.0; // Double speed (fast forward)
     *
     * // Temporary speed changes
     * function slowMotion() {
     *     const normalSpeed = ticker.speed;
     *     ticker.speed = 0.2;
     *     setTimeout(() => {
     *         ticker.speed = normalSpeed;
     *     }, 1000);
     * }
     * ```
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     *
     * `true` if {@link Ticker#start|start} has been called.
     * `false` if {@link Ticker#stop|Stop} has been called.
     *
     * While `false`, this value may change to `true` in the
     * event of {@link Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     * @example
     * ```ts
     * // Check ticker state
     * const ticker = new Ticker();
     * console.log(ticker.started); // false
     *
     * // Start and verify
     * ticker.start();
     * console.log(ticker.started); // true
     * ```
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by maxFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $bJH8Y.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /** Conditionally cancels a pending animation frame. */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */ add(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */ addOnce(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000` (typically 60).
   *
   * If `maxFPS` is currently set (non-zero) and `minFPS` is set above it,
   * `maxFPS` is automatically raised to match. This keeps the two limits consistent.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // minFPS above maxFPS pushes maxFPS up
   * ticker.minFPS = 50; // maxFPS is raised to 50
   * ```
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPMS = Math.min(Math.max(0, fps) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
        if (this._minElapsedMS && fps > this.maxFPS) this.maxFPS = fps;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`.
   *
   * If `maxFPS` is set below the current `minFPS`, `minFPS` is automatically lowered to match.
   * This keeps the two limits consistent.
   * @example
   * ```ts
   * // Cap the frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with minFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // maxFPS below minFPS pushes minFPS down
   * ticker.maxFPS = 20; // minFPS is now also 20
   * ```
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            if (fps < this.minFPS) this.minFPS = fps;
            this._minElapsedMS = 1 / (fps / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frame rate in frames per millisecond.
 * Used for converting deltaTime to a scalar time delta.
 * @example
 * ```ts
 * // Default is 0.06 (60 FPS)
 * console.log(Ticker.targetFPMS); // 0.06
 *
 * // Calculate target frame duration
 * const frameDuration = 1 / Ticker.targetFPMS; // ≈ 16.67ms
 *
 * // Use in custom timing calculations
 * const deltaTime = elapsedMS * Ticker.targetFPMS;
 * ```
 * @remarks
 * - Default is 0.06 (equivalent to 60 FPS)
 * - Used in deltaTime calculations
 * - Affects all ticker instances
 * @default 0.06
 * @see {@link Ticker#deltaTime} For time scaling
 * @see {@link Ticker#FPS} For actual frame rate
 */ $2bf8d15685054100$var$_Ticker.targetFPMS = 0.06;
let $2bf8d15685054100$export$39c54bcc89dcee11 = $2bf8d15685054100$var$_Ticker;

});
parcelRegister("cQMLP", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $d091949369ecd400$export$688aaf132ba9b379);
"use strict";
var $d091949369ecd400$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($d091949369ecd400$export$688aaf132ba9b379 || {});

});

parcelRegister("bJH8Y", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $44ffb68c45a667a2$export$579021a5759a260f);
"use strict";
class $44ffb68c45a667a2$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("7blVu", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $1603b82fc2121ba0$export$8df68d58aae31877);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $1603b82fc2121ba0$var$promise;
async function $1603b82fc2121ba0$export$8df68d58aae31877() {
    $1603b82fc2121ba0$var$promise ?? ($1603b82fc2121ba0$var$promise = (async ()=>{
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(1, 1);
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $1603b82fc2121ba0$var$promise;
}

});


parcelRegister("8QN7n", function(module, exports) {

var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $da9f248d33f9f2f1$var$sources = [];
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).TextureSource, $da9f248d33f9f2f1$var$sources);
function $da9f248d33f9f2f1$export$688bcf31fbf7eb15(options = {}) {
    return $da9f248d33f9f2f1$var$textureSourceFrom(options);
}
function $da9f248d33f9f2f1$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $da9f248d33f9f2f1$var$sources.length; i++){
        const Source = $da9f248d33f9f2f1$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $da9f248d33f9f2f1$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $2IhKp.Cache).has(resource)) return (0, $2IhKp.Cache).get(resource);
    const texture = new (0, $bLlTJ.Texture)({
        source: $da9f248d33f9f2f1$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $2IhKp.Cache).has(resource)) (0, $2IhKp.Cache).remove(resource);
    });
    if (!skipCache) (0, $2IhKp.Cache).set(resource, texture);
    return texture;
}
function $da9f248d33f9f2f1$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $2IhKp.Cache).get(id);
    else if (id instanceof (0, $iA5fe.TextureSource)) return new (0, $bLlTJ.Texture)({
        source: id
    });
    return $da9f248d33f9f2f1$export$3b748ed6327ec85b(id, skipCache);
}
(0, $bLlTJ.Texture).from = $da9f248d33f9f2f1$export$4266177d9730bb1;
(0, $iA5fe.TextureSource).from = $da9f248d33f9f2f1$var$textureSourceFrom;

});
parcelRegister("2IhKp", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3d19110becfaeec3$export$94affb487e701bf2);

var $hUCK4 = parcelRequire("hUCK4");

var $3CHiv = parcelRequire("3CHiv");
"use strict";
class $3d19110becfaeec3$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $3CHiv.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $hUCK4.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /**
   * All loader parsers registered
   * @advanced
   */ get parsers() {
        return this._parsers;
    }
}
const $3d19110becfaeec3$export$94affb487e701bf2 = new $3d19110becfaeec3$var$CacheClass();

});
parcelRegister("3CHiv", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $93954259b3f62d4e$export$b01be8e180bf3d9b);
"use strict";
const $93954259b3f62d4e$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("4RJM2", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $8PDkK = parcelRequire("8PDkK");
"use strict";
(0, $i9BKe.extensions).add((0, $8PDkK.spritesheetAsset));

});
parcelRegister("8PDkK", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $a322641177c54ad8$export$46dcda4f1cdd80fe);

var $iEtN5 = parcelRequire("iEtN5");

var $8kCsw = parcelRequire("8kCsw");

var $5Oad7 = parcelRequire("5Oad7");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");

var $lzfZe = parcelRequire("lzfZe");

var $58WFl = parcelRequire("58WFl");
"use strict";
const $a322641177c54ad8$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $a322641177c54ad8$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $lzfZe.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $a322641177c54ad8$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $a322641177c54ad8$export$46dcda4f1cdd80fe = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $58WFl.Spritesheet),
        getCacheableAssets: (keys, asset)=>$a322641177c54ad8$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $i9BKe.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $a322641177c54ad8$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        /** used for deprecation purposes */ name: "spritesheetLoader",
        id: "spritesheet",
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $lzfZe.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, textureOptions: // if user need to use custom filename (not from jsonFile.meta.image)
            textureOptions, cachePrefix: // if user need to set texture options on texture
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $lzfZe.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $bLlTJ.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $5Oad7.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    {
                        src: imagePath,
                        data: textureOptions
                    }
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $58WFl.Spritesheet)({
                texture: texture.source,
                data: asset,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $5Oad7.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            textureOptions: textureOptions,
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("iEtN5", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $29ed14ceb032dea6$export$820ed6348c4f2750);
"use strict";
var $29ed14ceb032dea6$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($29ed14ceb032dea6$export$820ed6348c4f2750 || {});

});

parcelRegister("8kCsw", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $23cc1cafdfe05125$export$8b4c839865b08288);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $8F3vm = parcelRequire("8F3vm");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $23cc1cafdfe05125$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $3CHiv.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Removes the specified alias for an asset.
   *
   * This only removes the alias mapping. It does **not** remove, unload, or destroy the
   * underlying asset. If the asset is already cached, it stays in memory until you call
   * `Assets.unload`.
   *
   * If `asset` is provided, the alias is only removed when the resolver's current mapping for
   * that alias matches the given `ResolvedAsset`. This lets you avoid accidentally removing an
   * alias that has been reassigned.
   *
   * Silently returns if the alias does not exist or the asset does not match.
   * @param alias - the alias to remove
   * @param asset - only remove the alias if it is currently assigned to this asset
   * @example
   * ```ts
   * resolver.add({ alias: 'hero', src: 'hero.png' });
   *
   * // Simple removal
   * resolver.removeAlias('hero');
   *
   * // Conditional removal — only if alias currently maps to a specific asset
   * const resolved = resolver.resolve('hero');
   * resolver.removeAlias('hero', resolved);
   * ```
   */ removeAlias(alias, asset) {
        if (!this._assetMap[alias]) return;
        if (asset && asset !== this._resolverHash[alias]) return;
        delete this._resolverHash[alias];
        delete this._assetMap[alias];
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $hUCK4.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $hUCK4.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $3CHiv.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: userDefinedLoadParser, parser: userDefinedParser } = asset;
            const srcsToUse = (0, $3CHiv.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $8F3vm.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            const parseUrl = (url)=>{
                const parser = this._parsers.find((p)=>p.test(url));
                return {
                    src: url,
                    ...parser?.parse(url)
                };
            };
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") formattedAsset = parseUrl(src2);
                    else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        if (src2.loadParser || src2.parser) {
                            userDefinedLoadParser = src2.loadParser ?? userDefinedLoadParser;
                            userDefinedParser = src2.parser ?? userDefinedParser;
                        }
                        formattedAsset = {
                            ...parseUrl(src2.src),
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: userDefinedLoadParser,
                        parser: userDefinedParser,
                        progressSize: asset.progressSize
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $4DmkB.isSingleItem)(bundleIds);
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $4DmkB.isSingleItem)(keys);
        keys = (0, $3CHiv.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[i];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, parser: parser, format: format, progressSize: progressSize } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $lzfZe.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.parser = parser ?? formattedAsset.parser;
        formattedAsset.format = format ?? formattedAsset.format ?? $23cc1cafdfe05125$export$4bb0ea38086a2ed5(formattedAsset.src);
        if (progressSize !== void 0) formattedAsset.progressSize = progressSize;
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $23cc1cafdfe05125$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $23cc1cafdfe05125$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("lzfZe", function(module, exports) {

$parcel$export(module.exports, "path", () => $3c67d20d89e3898c$export$bb654e07daaf8c3a);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
function $3c67d20d89e3898c$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $3c67d20d89e3898c$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $3c67d20d89e3898c$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $3c67d20d89e3898c$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($3c67d20d89e3898c$var$escapeRegExp(find), "g"), replace);
}
function $3c67d20d89e3898c$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $3c67d20d89e3898c$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */ toPosix (path2) {
        return $3c67d20d89e3898c$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ getProtocol (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $3c67d20d89e3898c$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $iCGeI.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $3c67d20d89e3898c$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */ normalize (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $3c67d20d89e3898c$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ isAbsolute (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $3c67d20d89e3898c$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */ dirname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ rootname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */ basename (path2, ext) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (ext) $3c67d20d89e3898c$var$assertPath(ext);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */ extname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */ parse (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("8F3vm", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $fde1bf5bcf60c2d9$export$738117acc6638004);
"use strict";
function $fde1bf5bcf60c2d9$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $fde1bf5bcf60c2d9$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $fde1bf5bcf60c2d9$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $fde1bf5bcf60c2d9$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("4DmkB", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $f373b2ad881b3255$export$16a80d27953452d4);
"use strict";
const $f373b2ad881b3255$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("5Oad7", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $273b4a26d8a43536$export$f57b97ef8be10dda);
"use strict";
const $273b4a26d8a43536$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("58WFl", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $9c38ec259f91df14$export$674d2eb4debbef0c);

var $fM4Mk = parcelRequire("fM4Mk");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $9c38ec259f91df14$var$_Spritesheet = class _Spritesheet {
    constructor(optionsOrTexture, arg1){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        let options = optionsOrTexture;
        if (optionsOrTexture?.source instanceof (0, $iA5fe.TextureSource)) options = {
            texture: optionsOrTexture,
            data: arg1
        };
        const { texture: texture, data: data, cachePrefix: cachePrefix = "" } = options;
        this.cachePrefix = cachePrefix;
        this._texture = texture instanceof (0, $bLlTJ.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */ parseSync() {
        this._processFrames(0, true);
        this._processAnimations();
        return this.textures;
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */ _processFrames(initialFrameIndex, processAll = false) {
        let frameIndex = initialFrameIndex;
        const maxFrames = processAll ? Infinity : _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $fM4Mk.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $fM4Mk.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $bLlTJ.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/**
 * The maximum number of Textures to build per process.
 * @advanced
 */ $9c38ec259f91df14$var$_Spritesheet.BATCH_SIZE = 1e3;
let $9c38ec259f91df14$export$674d2eb4debbef0c = $9c38ec259f91df14$var$_Spritesheet;

});



parcelRegister("3UUq4", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $453fded98f054a94$export$58ab3ed211eed562);

var $a2eTA = parcelRequire("a2eTA");

var $aEImn = parcelRequire("aEImn");

var $eicwU = parcelRequire("eicwU");

var $cJHPn = parcelRequire("cJHPn");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $2GH55 = parcelRequire("2GH55");


var $hFYOq = parcelRequire("hFYOq");

var $gtbjr = parcelRequire("gtbjr");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $453fded98f054a94$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $453fded98f054a94$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** The current tick of the renderer. */ this.tick = 0;
        /** @internal */ this.uid = (0, $aGJhg.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$453fded98f054a94$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $aEImn.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        this.tick++;
        let options = args;
        if (options instanceof (0, $eicwU.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $a2eTA.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        if (!options.container.visible) return;
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $hFYOq.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target, mipLevel: mipLevel, layer: layer } = options;
        (0, $a2eTA.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $a2eTA.Color).shared.toArray(), mipLevel ?? 0, layer ?? 0);
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $gtbjr.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
            this.runners.destroy.add(this.renderPipes[name]);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        if (options === true || typeof options === "object" && options.releaseGlobalResources) (0, $2GH55.GlobalResourceRegistry).release();
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
        this.removeAllListeners();
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $cJHPn.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $453fded98f054a94$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $453fded98f054a94$export$58ab3ed211eed562 = $453fded98f054a94$var$_AbstractRenderer;

});
parcelRegister("aEImn", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $326e7279631cea1a$export$3b30260a318c769f);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $326e7279631cea1a$var$environments = [];
(0, $i9BKe.extensions).handleByNamedList((0, $i9BKe.ExtensionType).Environment, $326e7279631cea1a$var$environments);
async function $326e7279631cea1a$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $326e7279631cea1a$var$environments.length; i++){
        const env = $326e7279631cea1a$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $326e7279631cea1a$export$72225172dd907279(add) {
    return $326e7279631cea1a$export$3b30260a318c769f(!add);
}

});

parcelRegister("cJHPn", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $d88536e9c61409d6$export$70c0711f29adc5cf);
"use strict";
let $d88536e9c61409d6$var$unsafeEval;
function $d88536e9c61409d6$export$70c0711f29adc5cf() {
    if (typeof $d88536e9c61409d6$var$unsafeEval === "boolean") return $d88536e9c61409d6$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $d88536e9c61409d6$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $d88536e9c61409d6$var$unsafeEval = false;
    }
    return $d88536e9c61409d6$var$unsafeEval;
}

});

parcelRegister("hFYOq", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $bdcaad22b468ed1b$export$6c4d37c7f376a1de);
"use strict";
var $bdcaad22b468ed1b$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($bdcaad22b468ed1b$export$6c4d37c7f376a1de || {});

});

parcelRegister("gtbjr", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $299af1a7d2dd4105$export$ff5f2fe687fe3979);
"use strict";
class $299af1a7d2dd4105$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("256Qy", function(module, exports) {
module.exports = Promise.all([
    import("dpGs2"),
    import("19oeW"),
    import("aNM0B")
]).then(()=>parcelRequire('aIpib'));

});

parcelRegister("gC3YA", function(module, exports) {
module.exports = Promise.all([
    import("dpGs2"),
    import("19oeW"),
    import("7EYKF")
]).then(()=>parcelRequire('kpxDv'));

});

parcelRegister("6Tctm", function(module, exports) {
module.exports = Promise.all([
    import("dpGs2"),
    import("f2r3l")
]).then(()=>parcelRequire('ckUpu'));

});

parcelRegister("gVtOu", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $eaa9a2f5d114568e$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $eaa9a2f5d114568e$export$5fba6e443d2fb64);

var $i9BKe = parcelRequire("i9BKe");

var $7hfrt = parcelRequire("7hfrt");
"use strict";
class $eaa9a2f5d114568e$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $7hfrt.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $eaa9a2f5d114568e$export$918f3e4d2b801859.extension = (0, $i9BKe.ExtensionType).Application;
class $eaa9a2f5d114568e$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $7hfrt.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $eaa9a2f5d114568e$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("7hfrt", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $6c3dc1ec0fb181c1$export$a4ad2735b021c132);

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $6c3dc1ec0fb181c1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $6c3dc1ec0fb181c1$export$a4ad2735b021c132 = "8.17.1";

});


parcelRegister("lhab9", function(module, exports) {
module.exports = import("hwpgb").then(()=>parcelRequire('fl08K'));

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("awcfo", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $6cadf620a92ebba7$export$6f452ee382def63c);
"use strict";
class $6cadf620a92ebba7$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        currentResource?.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @param tick - The current tick.
   * @internal
   */ _touch(now, tick) {
        const resources = this.resources;
        for(const i in resources){
            resources[i]._gcLastUsed = now;
            resources[i]._touched = tick;
        }
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource?.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) this.destroy();
        else this._updateKey();
    }
}

});


parcelRegister("5RxDh", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $122ab179875de631$export$34bf80542893bcb);

var $i9BKe = parcelRequire("i9BKe");

var $4rmMq = parcelRequire("4rmMq");

var $6Ogkc = parcelRequire("6Ogkc");

var $bBMVz = parcelRequire("bBMVz");
"use strict";
let $122ab179875de631$var$defaultShader = null;
const $122ab179875de631$var$_DefaultBatcher = class _DefaultBatcher extends (0, $4rmMq.Batcher) {
    constructor(options){
        super(options);
        this.geometry = new (0, $6Ogkc.BatchGeometry)();
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
        $122ab179875de631$var$defaultShader ?? ($122ab179875de631$var$defaultShader = new (0, $bBMVz.DefaultShader)(options.maxTextures));
        this.shader = $122ab179875de631$var$defaultShader;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
    /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */ _updateMaxTextures(maxTextures) {
        if (this.shader.maxTextures === maxTextures) return;
        $122ab179875de631$var$defaultShader = new (0, $bBMVz.DefaultShader)(maxTextures);
        this.shader = $122ab179875de631$var$defaultShader;
    }
    destroy() {
        this.shader = null;
        super.destroy();
    }
};
/** @ignore */ $122ab179875de631$var$_DefaultBatcher.extension = {
    type: [
        (0, $i9BKe.ExtensionType).Batcher
    ],
    name: "default"
};
let $122ab179875de631$export$34bf80542893bcb = $122ab179875de631$var$_DefaultBatcher;

});
parcelRegister("4rmMq", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $71f140885a3d3890$export$704b12ddc1dacdd2);

var $aGJhg = parcelRequire("aGJhg");

var $aaUE3 = parcelRequire("aaUE3");

var $kXq8E = parcelRequire("kXq8E");

var $2GH55 = parcelRequire("2GH55");

var $1tfR4 = parcelRequire("1tfR4");

var $eN26f = parcelRequire("eN26f");

var $1EHMq = parcelRequire("1EHMq");

var $bRzRK = parcelRequire("bRzRK");
"use strict";
class $71f140885a3d3890$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $bRzRK.BatchTextureArray)();
        this.blendMode = "normal";
        this.topology = "triangle-strip";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
        this.elements = null;
    }
}
const $71f140885a3d3890$var$batchPool = [];
let $71f140885a3d3890$var$batchPoolIndex = 0;
(0, $2GH55.GlobalResourceRegistry).register({
    clear: ()=>{
        if ($71f140885a3d3890$var$batchPool.length > 0) {
            for (const item of $71f140885a3d3890$var$batchPool)if (item) item.destroy();
        }
        $71f140885a3d3890$var$batchPool.length = 0;
        $71f140885a3d3890$var$batchPoolIndex = 0;
    }
});
function $71f140885a3d3890$var$getBatchFromPool() {
    return $71f140885a3d3890$var$batchPoolIndex > 0 ? $71f140885a3d3890$var$batchPool[--$71f140885a3d3890$var$batchPoolIndex] : new $71f140885a3d3890$export$33b107562567fc47();
}
function $71f140885a3d3890$var$returnBatchToPool(batch) {
    batch.elements = null;
    $71f140885a3d3890$var$batchPool[$71f140885a3d3890$var$batchPoolIndex++] = batch;
}
let $71f140885a3d3890$var$BATCH_TICK = 0;
const $71f140885a3d3890$var$_Batcher = class _Batcher {
    constructor(options){
        /** unique id for this batcher */ this.uid = (0, $aGJhg.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        if (!options.maxTextures) {
            (0, $kXq8E.deprecation)("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options");
            options.maxTextures = (0, $1EHMq.getMaxTexturesPerBatch)();
        }
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $aaUE3.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $71f140885a3d3890$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $eN26f.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        let topology = firstElement.topology;
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        let batchElements = [];
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $eN26f.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
            if (source._batchTick === $71f140885a3d3890$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                batchElements.push(element);
                continue;
            }
            source._batchTick = $71f140885a3d3890$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                topology = element.topology;
                batch = $71f140885a3d3890$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                batchElements = [];
                ++$71f140885a3d3890$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            batchElements.push(element);
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
            start = size;
            ++$71f140885a3d3890$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action, elements) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.topology = topology;
        batch.start = indexStart;
        batch.size = indexSize;
        batch.elements = elements;
        ++$71f140885a3d3890$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $aaUE3.ViewableBuffer)(newSize);
        (0, $1tfR4.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $1tfR4.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */ destroy(options = {}) {
        if (this.batches === null) return;
        for(let i = 0; i < this.batchIndex; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        this.geometry.destroy(true);
        this.geometry = null;
        if (options.shader) {
            this.shader?.destroy();
            this.shader = null;
        }
        for(let i = 0; i < this._elements.length; i++)if (this._elements[i]) this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$71f140885a3d3890$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $71f140885a3d3890$export$704b12ddc1dacdd2 = $71f140885a3d3890$var$_Batcher;

});
parcelRegister("aaUE3", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $d6aafa25b0389ff9$export$4fdbf0662aa3047a);
"use strict";
class $d6aafa25b0389ff9$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this.uint32View = null;
        this.float32View = null;
        this.uint16View = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._int32View = null;
        this._float64Array = null;
        this._bigUint64Array = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("1tfR4", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $3976cf47510ef1a5$export$c691b0c42debe682);
"use strict";
function $3976cf47510ef1a5$export$c691b0c42debe682(sourceBuffer, destinationBuffer, sourceOffset, byteLength) {
    sourceOffset ?? (sourceOffset = 0);
    byteLength ?? (byteLength = Math.min(sourceBuffer.byteLength - sourceOffset, destinationBuffer.byteLength));
    if (!(sourceOffset & 7) && !(byteLength & 7)) {
        const len = byteLength / 8;
        new Float64Array(destinationBuffer, 0, len).set(new Float64Array(sourceBuffer, sourceOffset, len));
    } else if (!(sourceOffset & 3) && !(byteLength & 3)) {
        const len = byteLength / 4;
        new Float32Array(destinationBuffer, 0, len).set(new Float32Array(sourceBuffer, sourceOffset, len));
    } else new Uint8Array(destinationBuffer).set(new Uint8Array(sourceBuffer, sourceOffset, byteLength));
}

});

parcelRegister("eN26f", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $3b017cb7131d92fc$export$ab2fc5cf3fe899fe);

var $eE5Ke = parcelRequire("eE5Ke");
"use strict";
function $3b017cb7131d92fc$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $eE5Ke.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("eE5Ke", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $16526f00f7b0e2b9$export$c250b85d73a91bdf);
"use strict";
const $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $16526f00f7b0e2b9$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
    return STENCIL_MODES2;
})($16526f00f7b0e2b9$export$c250b85d73a91bdf || {});

});


parcelRegister("1EHMq", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $b5d07f8bc89d7387$export$313b92466c30ee73);

var $ckKKH = parcelRequire("ckKKH");

var $awsWF = parcelRequire("awsWF");
"use strict";
let $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = null;
function $b5d07f8bc89d7387$export$313b92466c30ee73() {
    if ($b5d07f8bc89d7387$var$maxTexturesPerBatchCache) return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
    const gl = (0, $ckKKH.getTestContext)();
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = (0, $awsWF.checkMaxIfStatementsInShader)($b5d07f8bc89d7387$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
}

});
parcelRegister("ckKKH", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $a517f2c0dcfb1c3f$export$f034b2d55f8df08b);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $a517f2c0dcfb1c3f$var$context;
function $a517f2c0dcfb1c3f$export$f034b2d55f8df08b() {
    if (!$a517f2c0dcfb1c3f$var$context || $a517f2c0dcfb1c3f$var$context?.isContextLost()) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        $a517f2c0dcfb1c3f$var$context = canvas.getContext("webgl", {});
    }
    return $a517f2c0dcfb1c3f$var$context;
}

});

parcelRegister("awsWF", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $717b67827b6a1bc1$export$fb6ad4e758d74cc0);
"use strict";
const $717b67827b6a1bc1$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $717b67827b6a1bc1$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $717b67827b6a1bc1$var$fragTemplate.replace(/%forloop%/gi, $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});


parcelRegister("bRzRK", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $a96c3003620e8697$export$aa760e0febf1a758);
"use strict";
class $a96c3003620e8697$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("6Ogkc", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $ec424808c68c925d$export$449e8d355fd68e43);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");

var $cOnev = parcelRequire("cOnev");
"use strict";
const $ec424808c68c925d$var$placeHolderBufferData = new Float32Array(1);
const $ec424808c68c925d$var$placeHolderIndexData = new Uint32Array(1);
class $ec424808c68c925d$export$449e8d355fd68e43 extends (0, $cOnev.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lvEAL", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9841377a483d1ce7$export$a143d493d941bafc);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
class $9841377a483d1ce7$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** If set to true, the buffer will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** @internal */ this._updateID = 1;
        this._dataInt32 = null;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size ?? (size = data?.byteLength);
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    get dataInt32() {
        if (!this._dataInt32) this._dataInt32 = new Int32Array(this.data.buffer);
        return this._dataInt32;
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $1UZ6r.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $1UZ6r.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $1UZ6r.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        this._dataInt32 = null;
        if (!oldData || oldData.length !== value.length) {
            if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $aGJhg.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Unloads the buffer from the GPU */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("1UZ6r", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $f4c8f2641f61e66f$export$f8deb2be8632fd10);
"use strict";
var $f4c8f2641f61e66f$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($f4c8f2641f61e66f$export$f8deb2be8632fd10 || {});

});


parcelRegister("cOnev", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $f72e7cebaee4d192$export$2db6c17465f94a2);

var $3vRz3 = parcelRequire("3vRz3");

var $7wtv9 = parcelRequire("7wtv9");

var $aGJhg = parcelRequire("aGJhg");

var $lvEAL = parcelRequire("lvEAL");

var $zwuDY = parcelRequire("zwuDY");

var $dYcXX = parcelRequire("dYcXX");
"use strict";
function $f72e7cebaee4d192$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lvEAL.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $zwuDY.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $f72e7cebaee4d192$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options = {}){
        super();
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /** The unique id of the geometry. */ this.uid = (0, $aGJhg.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        this.buffers = [];
        this.attributes = {};
        if (attributes) for(const i in attributes)this.addAttribute(i, attributes[i]);
        this.instanceCount = options.instanceCount ?? 1;
        if (indexBuffer) this.addIndex(indexBuffer);
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */ addAttribute(name, attributeOption) {
        const attribute = $f72e7cebaee4d192$var$ensureIsAttribute(attributeOption);
        const bufferIndex = this.buffers.indexOf(attribute.buffer);
        if (bufferIndex === -1) {
            this.buffers.push(attribute.buffer);
            attribute.buffer.on("update", this.onBufferUpdate, this);
            attribute.buffer.on("change", this.onBufferUpdate, this);
        }
        this.attributes[name] = attribute;
    }
    /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */ addIndex(indexBuffer) {
        this.indexBuffer = (0, $zwuDY.ensureIsBuffer)(indexBuffer, true);
        this.buffers.push(this.indexBuffer);
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $dYcXX.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /** Unloads the geometry from the GPU. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.unload();
        this.indexBuffer?.destroy();
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("zwuDY", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $c27f8a68b3d31b3f$export$e02adcb3cf335e03);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
function $c27f8a68b3d31b3f$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lvEAL.Buffer))) {
        let usage = index ? (0, $1UZ6r.BufferUsage).INDEX : (0, $1UZ6r.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lvEAL.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("dYcXX", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $547d4a1f0305efcb$export$ca8be28ec6402f29);
"use strict";
function $547d4a1f0305efcb$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("bBMVz", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $5546e8c9dd716d36$export$5ee16216350ebcbc);

var $3JBHn = parcelRequire("3JBHn");

var $cNnNT = parcelRequire("cNnNT");

var $ikSZA = parcelRequire("ikSZA");

var $kSpdC = parcelRequire("kSpdC");

var $10zIa = parcelRequire("10zIa");

var $5iDyo = parcelRequire("5iDyo");
"use strict";
class $5546e8c9dd716d36$export$5ee16216350ebcbc extends (0, $5iDyo.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $3JBHn.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBitGl),
                (0, $ikSZA.generateTextureBatchBitGl)(maxTextures),
                (0, $kSpdC.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $3JBHn.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBit),
                (0, $ikSZA.generateTextureBatchBit)(maxTextures),
                (0, $kSpdC.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $10zIa.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
        this.maxTextures = maxTextures;
    }
}

});
parcelRegister("3JBHn", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $52144493f15d3fff$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $52144493f15d3fff$export$477b8252c7ecdf2);

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $i8pLT = parcelRequire("i8pLT");

var $jOJh1 = parcelRequire("jOJh1");

var $8hMvn = parcelRequire("8hMvn");
"use strict";
function $52144493f15d3fff$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $i8pLT.compileHighShader)({
        template: {
            fragment: (0, $jOJh1.fragmentGPUTemplate),
            vertex: (0, $jOJh1.vertexGPUTemplate)
        },
        bits: [
            (0, $8hMvn.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $6j7wq.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $52144493f15d3fff$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $fK92B.GlProgram)({
        name: name,
        ...(0, $i8pLT.compileHighShaderGl)({
            template: {
                vertex: (0, $jOJh1.vertexGlTemplate),
                fragment: (0, $jOJh1.fragmentGlTemplate)
            },
            bits: [
                (0, $8hMvn.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("fK92B", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $5a1cd4acf4c2252d$export$64881d9ea0a969d7);

var $9kWs1 = parcelRequire("9kWs1");

var $c1vp1 = parcelRequire("c1vp1");

var $iCp49 = parcelRequire("iCp49");

var $67Nsh = parcelRequire("67Nsh");

var $3Hbxe = parcelRequire("3Hbxe");

var $aUAMu = parcelRequire("aUAMu");

var $500fb = parcelRequire("500fb");
"use strict";
const $5a1cd4acf4c2252d$var$processes = {
    stripVersion: // strips any version headers..
    $500fb.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $67Nsh.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $iCp49.addProgramDefines,
    setProgramName: // add the program name to the shader
    $aUAMu.setProgramName,
    insertVersion: // add the version string to the shader header
    $3Hbxe.insertVersion
};
const $5a1cd4acf4c2252d$var$programCache = /* @__PURE__ */ Object.create(null);
const $5a1cd4acf4c2252d$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $c1vp1.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($5a1cd4acf4c2252d$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $5a1cd4acf4c2252d$var$processes[processKey](fragment, processOptions, true);
            vertex = $5a1cd4acf4c2252d$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this.transformFeedbackVaryings = options.transformFeedbackVaryings;
        this._key = (0, $9kWs1.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
        $5a1cd4acf4c2252d$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$5a1cd4acf4c2252d$var$programCache[key]) {
            $5a1cd4acf4c2252d$var$programCache[key] = new _GlProgram(options);
            $5a1cd4acf4c2252d$var$programCache[key]._cacheKey = key;
        }
        return $5a1cd4acf4c2252d$var$programCache[key];
    }
};
/** The default options used by the program. */ $5a1cd4acf4c2252d$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $5a1cd4acf4c2252d$export$64881d9ea0a969d7 = $5a1cd4acf4c2252d$var$_GlProgram;

});
parcelRegister("9kWs1", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $0601e88d616c38d4$export$1e452c36dfe36a93);
"use strict";
const $0601e88d616c38d4$var$idCounts = /* @__PURE__ */ Object.create(null);
const $0601e88d616c38d4$var$idHash = /* @__PURE__ */ Object.create(null);
function $0601e88d616c38d4$export$1e452c36dfe36a93(value, groupId) {
    let id = $0601e88d616c38d4$var$idHash[value];
    if (id === void 0) {
        if ($0601e88d616c38d4$var$idCounts[groupId] === void 0) $0601e88d616c38d4$var$idCounts[groupId] = 1;
        $0601e88d616c38d4$var$idHash[value] = id = $0601e88d616c38d4$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("c1vp1", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $e905b7e6e5b75a20$export$428c38e64838140);

var $ckKKH = parcelRequire("ckKKH");
"use strict";
let $e905b7e6e5b75a20$var$maxFragmentPrecision;
function $e905b7e6e5b75a20$export$428c38e64838140() {
    if (!$e905b7e6e5b75a20$var$maxFragmentPrecision) {
        $e905b7e6e5b75a20$var$maxFragmentPrecision = "mediump";
        const gl = (0, $ckKKH.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $e905b7e6e5b75a20$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $e905b7e6e5b75a20$var$maxFragmentPrecision;
}

});

parcelRegister("iCp49", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $ab141df14b998d07$export$fba00ea8bc676dd1);
"use strict";
function $ab141df14b998d07$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("67Nsh", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $bda6ccefc0c5ab42$export$899bdffb1b617f8b);
"use strict";
function $bda6ccefc0c5ab42$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("3Hbxe", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $82be6e3df1c54b73$export$df5409633d2e06a0);
"use strict";
function $82be6e3df1c54b73$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("aUAMu", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $de2ea14e21161fdc$export$fcd35f5a80d5e29b);
"use strict";
const $de2ea14e21161fdc$var$fragmentNameCache = {};
const $de2ea14e21161fdc$var$VertexNameCache = {};
function $de2ea14e21161fdc$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $de2ea14e21161fdc$var$fragmentNameCache : $de2ea14e21161fdc$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("500fb", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $d98e8e318b45168f$export$f71406e7a553e9e5);
"use strict";
function $d98e8e318b45168f$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("6j7wq", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $8e9bc14aafd75f61$export$b7a31a3cdd61870);

var $9kWs1 = parcelRequire("9kWs1");

var $7j3L3 = parcelRequire("7j3L3");

var $ceyhm = parcelRequire("ceyhm");

var $eebg6 = parcelRequire("eebg6");

var $gwiyt = parcelRequire("gwiyt");

var $ftyd4 = parcelRequire("ftyd4");
"use strict";
const $8e9bc14aafd75f61$var$programCache = /* @__PURE__ */ Object.create(null);
class $8e9bc14aafd75f61$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /** @internal */ this._layoutKey = 0;
        /** @internal */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $ftyd4.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $gwiyt.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $eebg6.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $9kWs1.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $7j3L3.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
        $8e9bc14aafd75f61$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$8e9bc14aafd75f61$var$programCache[key]) {
            $8e9bc14aafd75f61$var$programCache[key] = new $8e9bc14aafd75f61$export$b7a31a3cdd61870(options);
            $8e9bc14aafd75f61$var$programCache[key]._cacheKey = key;
        }
        return $8e9bc14aafd75f61$var$programCache[key];
    }
}

});
parcelRegister("7j3L3", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $a83de38b8d80c92b$export$b0efe5f01c53f69f);

var $kavUV = parcelRequire("kavUV");
"use strict";
const $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    vec2i: "sint32x2",
    vec3i: "sint32x3",
    vec4i: "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    vec2u: "uint32x2",
    vec3u: "uint32x3",
    vec4u: "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
const $a83de38b8d80c92b$var$LOCATION_REGEX = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function $a83de38b8d80c92b$var$parseLocations(str, results) {
    let match;
    while((match = $a83de38b8d80c92b$var$LOCATION_REGEX.exec(str)) !== null){
        const format = $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
        results[match[2]] = {
            location: parseInt(match[1], 10),
            format: format,
            stride: (0, $kavUV.getAttributeInfoFromFormat)(format).stride,
            offset: 0,
            instance: false,
            start: 0
        };
    }
    $a83de38b8d80c92b$var$LOCATION_REGEX.lastIndex = 0;
}
function $a83de38b8d80c92b$var$stripComments(source) {
    return source.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function $a83de38b8d80c92b$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const cleanSource = $a83de38b8d80c92b$var$stripComments(source);
    const mainVertStart = cleanSource.indexOf(`fn ${entryPoint}(`);
    if (mainVertStart === -1) return results;
    const arrowFunctionStart = cleanSource.indexOf("->", mainVertStart);
    if (arrowFunctionStart === -1) return results;
    const functionArgsSubstring = cleanSource.substring(mainVertStart, arrowFunctionStart);
    $a83de38b8d80c92b$var$parseLocations(functionArgsSubstring, results);
    if (Object.keys(results).length === 0) {
        const structMatch = functionArgsSubstring.match(/\(\s*\w+\s*:\s*(\w+)/);
        if (structMatch) {
            const structName = structMatch[1];
            const structRegex = new RegExp(`struct\\s+${structName}\\s*\\{([^}]+)\\}`, "s");
            const structBody = cleanSource.match(structRegex);
            if (structBody) $a83de38b8d80c92b$var$parseLocations(structBody[1], results);
        }
    }
    return results;
}

});
parcelRegister("kavUV", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $b94249370f97e371$export$4da509c30cc6be33);
"use strict";
const $b94249370f97e371$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $b94249370f97e371$export$4da509c30cc6be33(format) {
    return $b94249370f97e371$var$attributeFormatData[format] ?? $b94249370f97e371$var$attributeFormatData.float32;
}

});


parcelRegister("ceyhm", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $ea3e5b1ac2f96ec2$export$368e99a200562975);
"use strict";
function $ea3e5b1ac2f96ec2$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*([\w<>]+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>// Handle both direct type matches and generic types like array<StructName>
            group.type === name || group.type.includes(`<${name}>`))) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("eebg6", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $6d1e03a3e3cda982$export$950011c0dc347495);

var $aR3rf = parcelRequire("aR3rf");
"use strict";
function $6d1e03a3e3cda982$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).VERTEX | (0, $aR3rf.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d" || group.type.startsWith("texture_2d<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
        else if (group.type === "texture_2d_array" || group.type.startsWith("texture_2d_array<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d-array",
                multisampled: false
            }
        });
        else if (group.type === "texture_cube" || group.type.startsWith("texture_cube<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "cube",
                multisampled: false
            }
        });
    }
    for(let i = 0; i < layout.length; i++)layout[i] || (layout[i] = []);
    return layout;
}

});
parcelRegister("aR3rf", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $06e6106f9171a2e8$export$34a0cafc5a97ef31);
"use strict";
var $06e6106f9171a2e8$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($06e6106f9171a2e8$export$34a0cafc5a97ef31 || {});

});


parcelRegister("gwiyt", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $292f21f6c3cd9e17$export$6a0f9650f9d4f875);
"use strict";
function $292f21f6c3cd9e17$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("ftyd4", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $f605447e20cc6f1a$export$5f344e20ddfaa2d6);
"use strict";
function $f605447e20cc6f1a$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("i8pLT", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $9ef573d9dfae5a48$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $9ef573d9dfae5a48$export$ff7039b165d48f97);

var $9zLXd = parcelRequire("9zLXd");

var $jJet4 = parcelRequire("jJet4");

var $ak3Em = parcelRequire("ak3Em");

var $9hCqF = parcelRequire("9hCqF");

var $9Zsfg = parcelRequire("9Zsfg");
"use strict";
const $9ef573d9dfae5a48$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $9ef573d9dfae5a48$var$bitCacheMap = /* @__PURE__ */ new Map();
let $9ef573d9dfae5a48$var$CACHE_UID = 0;
function $9ef573d9dfae5a48$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits);
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(template.vertex, template.fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $ak3Em.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $9hCqF.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $ak3Em.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $9ef573d9dfae5a48$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$9ef573d9dfae5a48$var$bitCacheMap.has(highFragment)) $9ef573d9dfae5a48$var$bitCacheMap.set(highFragment, $9ef573d9dfae5a48$var$CACHE_UID++);
        return $9ef573d9dfae5a48$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $jJet4.compileHooks)(vertex);
    const fragmentParts = (0, $jJet4.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $9zLXd.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $9zLXd.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $9Zsfg.injectBits)(vertex, vertexParts),
        fragment: (0, $9Zsfg.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("9zLXd", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $c36d60e017699465$export$38c21fb192fe3d9);

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $c36d60e017699465$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $hUCK4.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("jJet4", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $e10d3f89fc808d5a$export$17705ba43ca63936);
"use strict";
const $e10d3f89fc808d5a$var$findHooksRx = /\{\{(.*?)\}\}/g;
function $e10d3f89fc808d5a$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($e10d3f89fc808d5a$var$findHooksRx)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("ak3Em", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $76be63c34b98a2b0$export$aa47df9391ef0455);
"use strict";
function $76be63c34b98a2b0$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $76be63c34b98a2b0$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $76be63c34b98a2b0$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $76be63c34b98a2b0$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("9hCqF", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $eeb3f3dfbb29bd14$export$ae19cc473c7ab18);
"use strict";
function $eeb3f3dfbb29bd14$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $eeb3f3dfbb29bd14$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $eeb3f3dfbb29bd14$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $eeb3f3dfbb29bd14$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $eeb3f3dfbb29bd14$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $eeb3f3dfbb29bd14$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$eeb3f3dfbb29bd14$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
            ${results.sort().map((inValue)=>` ${$eeb3f3dfbb29bd14$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("9Zsfg", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $650fee7fffdacf4b$export$83c47c7340456c75);
"use strict";
function $650fee7fffdacf4b$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("jOJh1", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $f723d8c01fbb4e07$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $f723d8c01fbb4e07$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $f723d8c01fbb4e07$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $f723d8c01fbb4e07$export$3f7784dd6a13ff5a);
"use strict";
const $f723d8c01fbb4e07$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $f723d8c01fbb4e07$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $f723d8c01fbb4e07$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $f723d8c01fbb4e07$export$3f7784dd6a13ff5a = /* glsl */ `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`;

});

parcelRegister("8hMvn", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $d20cb1ce683ff173$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsBitGl", () => $d20cb1ce683ff173$export$38608853d4735d51);
"use strict";
const $d20cb1ce683ff173$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $d20cb1ce683ff173$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $d20cb1ce683ff173$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("cNnNT", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $39898bd73b5669c2$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $39898bd73b5669c2$export$93189e9821cf4459);
"use strict";
const $39898bd73b5669c2$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $39898bd73b5669c2$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("ikSZA", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $da5fa72bb41a0724$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $da5fa72bb41a0724$export$204e46d9a7a4f835);
"use strict";
const $da5fa72bb41a0724$var$textureBatchBitGpuCache = {};
function $da5fa72bb41a0724$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$aff2d36945cda647(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$da5fa72bb41a0724$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$da5fa72bb41a0724$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures];
}
const $da5fa72bb41a0724$var$textureBatchBitGlCache = {};
function $da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$204e46d9a7a4f835(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("kSpdC", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $2b55e281ef9e6651$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $2b55e281ef9e6651$export$222909710f39cc5);
"use strict";
const $2b55e281ef9e6651$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $2b55e281ef9e6651$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("10zIa", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe);

var $cryyq = parcelRequire("cryyq");
"use strict";
const $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash = {};
function $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $cryyq.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});
parcelRegister("cryyq", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5);

var $aGJhg = parcelRequire("aGJhg");

var $9kWs1 = parcelRequire("9kWs1");

var $jhfqN = parcelRequire("jhfqN");

var $ezKtQ = parcelRequire("ezKtQ");
"use strict";
const $9136c1ea7e89e2b5$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("uniform");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "uniformGroup";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $jhfqN.UNIFORM_TYPES_MAP)[uniformData.type]) {
                const arrayMatch = uniformData.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
                if (arrayMatch) {
                    const [, innerType, size] = arrayMatch;
                    throw new Error(`Uniform type ${uniformData.type} is not supported. Use type: '${innerType}', size: ${size} instead.`);
                }
                throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $jhfqN.UNIFORM_TYPES_VALUES).join(", ")}`);
            }
            uniformData.value ?? (uniformData.value = (0, $ezKtQ.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $9kWs1.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $9136c1ea7e89e2b5$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5 = $9136c1ea7e89e2b5$var$_UniformGroup;

});
parcelRegister("jhfqN", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $d4900ea566bb062d$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $d4900ea566bb062d$export$97ddd6675231876e);
"use strict";
const $d4900ea566bb062d$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>",
    "vec2<i32>",
    "vec3<i32>",
    "vec4<i32>"
];
const $d4900ea566bb062d$export$97ddd6675231876e = $d4900ea566bb062d$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("ezKtQ", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $aa11a20cb06f2781$export$7febdb6905805c3d);
"use strict";
function $aa11a20cb06f2781$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("5iDyo", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $26072a826565afe8$export$462bb059fed9d9e5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $fK92B = parcelRequire("fK92B");

var $awcfo = parcelRequire("awcfo");

var $6j7wq = parcelRequire("6j7wq");

var $2bK9z = parcelRequire("2bK9z");

var $cryyq = parcelRequire("cryyq");
"use strict";
class $26072a826565afe8$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options){
        super();
        /** A unique identifier for the shader */ this.uid = (0, $aGJhg.uid)("shader");
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        /** @internal */ this._destroyed = false;
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $awcfo.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $cryyq.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $awcfo.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $awcfo.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        if (this._destroyed) return;
        this._destroyed = true;
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $6j7wq.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $fK92B.GlProgram).from(gl);
        return new $26072a826565afe8$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("2bK9z", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $d9ac1633e306ebfe$export$2ca8315eebe81c3d);
"use strict";
var $d9ac1633e306ebfe$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["CANVAS"] = 4] = "CANVAS";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($d9ac1633e306ebfe$export$2ca8315eebe81c3d || {});

});




parcelRegister("1DS3C", function(module, exports) {

$parcel$export(module.exports, "GCManagedHash", () => $b112721887c05db1$export$632d6e63cd4488df);
"use strict";
class $b112721887c05db1$export$632d6e63cd4488df {
    constructor(options){
        // Exposed directly for GC system access
        this.items = /* @__PURE__ */ Object.create(null);
        const { renderer: renderer, type: type, onUnload: onUnload, priority: priority, name: name } = options;
        this._renderer = renderer;
        renderer.gc.addResourceHash(this, "items", type, priority ?? 0);
        this._onUnload = onUnload;
        this.name = name;
    }
    /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */ add(item) {
        if (this.items[item.uid]) return false;
        this.items[item.uid] = item;
        item.once("unload", this.remove, this);
        item._gcLastUsed = this._renderer.gc.now;
        return true;
    }
    remove(item, ...args) {
        if (!this.items[item.uid]) return;
        const gpuData = item._gpuData[this._renderer.uid];
        if (!gpuData) return;
        this._onUnload?.(item, ...args);
        gpuData.destroy();
        item._gpuData[this._renderer.uid] = null;
        this.items[item.uid] = null;
    }
    removeAll(...args) {
        Object.values(this.items).forEach((item)=>item && this.remove(item, ...args));
    }
    destroy(...args) {
        this.removeAll(...args);
        this.items = /* @__PURE__ */ Object.create(null);
        this._renderer = null;
        this._onUnload = null;
    }
}

});

parcelRegister("1mKkK", function(module, exports) {

$parcel$export(module.exports, "shapeBuilders", () => $2ba674c6e42be2fb$export$ab760b0d495e92a1);
$parcel$export(module.exports, "buildContextBatches", () => $2ba674c6e42be2fb$export$e3c00f31a053d231);

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $kVCUp = parcelRequire("kVCUp");

var $9Co9Q = parcelRequire("9Co9Q");

var $bLlTJ = parcelRequire("bLlTJ");

var $61KiY = parcelRequire("61KiY");

var $xZ5a3 = parcelRequire("xZ5a3");

var $dY2iR = parcelRequire("dY2iR");

var $46SPq = parcelRequire("46SPq");

var $7pahp = parcelRequire("7pahp");

var $ei7YJ = parcelRequire("ei7YJ");

var $7DIxn = parcelRequire("7DIxn");

var $iAUCq = parcelRequire("iAUCq");

var $34u7a = parcelRequire("34u7a");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $2ba674c6e42be2fb$export$ab760b0d495e92a1 = {};
(0, $i9BKe.extensions).handleByMap((0, $i9BKe.ExtensionType).ShapeBuilder, $2ba674c6e42be2fb$export$ab760b0d495e92a1);
(0, $i9BKe.extensions).add((0, $7DIxn.buildRectangle), (0, $ei7YJ.buildPolygon), (0, $iAUCq.buildTriangle), (0, $dY2iR.buildCircle), (0, $dY2iR.buildEllipse), (0, $dY2iR.buildRoundedRectangle));
const $2ba674c6e42be2fb$var$tempRect = new (0, $fM4Mk.Rectangle)();
const $2ba674c6e42be2fb$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
function $2ba674c6e42be2fb$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $2ba674c6e42be2fb$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $2ba674c6e42be2fb$var$addShapePathToGeometryData(hole.shapePath, style, true, batches, geometryData);
            if (hole) shapePath.shapePrimitives[shapePath.shapePrimitives.length - 1].holes = hole.shapePath.shapePrimitives;
            $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData);
        }
    }
}
function $2ba674c6e42be2fb$var$addTextureToGeometryData(data, batches, geometryData) {
    const points = [];
    const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1.rectangle;
    const rect = $2ba674c6e42be2fb$var$tempRect;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    if (!build.build(rect, points)) return;
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const texture = data.image;
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix, holes: holes })=>{
        const points = [];
        const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1[shape.type];
        if (!build.build(shape, points)) return;
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        let topology = "triangle-list";
        if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
        if (!isStroke) {
            if (holes) {
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $2ba674c6e42be2fb$var$getHoleArrays(holes);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $2E1jb.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            if (!lineStyle.pixelLine) (0, $46SPq.buildLine)(points, lineStyle, false, close, vertices, indices);
            else {
                (0, $7pahp.buildPixelLine)(points, close, vertices, indices);
                topology = "line-list";
            }
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $bLlTJ.Texture).WHITE) {
            const textureMatrix = (0, $34u7a.generateTextureMatrix)($2ba674c6e42be2fb$var$tempTextureMatrix, style, shape, matrix);
            (0, $kVCUp.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $kVCUp.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        graphicsBatch.topology = topology;
        batches.push(graphicsBatch);
    });
}
function $2ba674c6e42be2fb$var$getHoleArrays(holePrimitives) {
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $2ba674c6e42be2fb$export$ab760b0d495e92a1[holePrimitive.type];
        if (holeBuilder.build(holePrimitive, holePoints)) holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("kVCUp", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $1606ccc0770732ec$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $1606ccc0770732ec$export$580e3d8462b9fe52);
"use strict";
function $1606ccc0770732ec$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $1606ccc0770732ec$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("9Co9Q", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $74e682a1604b3625$export$cbe36b8a8d6e3d3);
"use strict";
function $74e682a1604b3625$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset || (offset = 0);
    stride || (stride = 2);
    size || (size = vertices.length / stride - offset);
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("xZ5a3", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $3f80d08e0b9378c5$export$91d2a08bbf21546b);

var $eY4rt = parcelRequire("eY4rt");

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $3f80d08e0b9378c5$var$identityMatrix = new (0, $eY4rt.Matrix)();
class $3f80d08e0b9378c5$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.topology = "triangle-list";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.renderable && this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $3N6bV.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $3f80d08e0b9378c5$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
        gpuBuffer.topology = this.topology;
    }
    reset() {
        this.applyTransform = true;
        this.renderable = null;
        this.topology = "triangle-list";
    }
    destroy() {
        this.renderable = null;
        this.texture = null;
        this.geometryData = null;
        this._batcher = null;
        this._batch = null;
    }
}

});

parcelRegister("dY2iR", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $791ed7b81fe09d67$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $791ed7b81fe09d67$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $791ed7b81fe09d67$export$4b54fce47d2ae7f4);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $791ed7b81fe09d67$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            rx = ry = circle.radius;
            if (rx <= 0) return false;
            x = circle.x;
            y = circle.y;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            if (rx <= 0 || ry <= 0) return false;
            x = ellipse.x;
            y = ellipse.y;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (dx < 0 || dy < 0) return false;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return false;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return true;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $791ed7b81fe09d67$export$d35b00c6ec9534ca = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $791ed7b81fe09d67$export$4b54fce47d2ae7f4 = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("46SPq", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $9fc8551677af3cf1$export$45986ccf08e93b0b);

var $1HooC = parcelRequire("1HooC");

var $d1s7O = parcelRequire("d1s7O");

var $168p3 = parcelRequire("168p3");
"use strict";
function $9fc8551677af3cf1$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $9fc8551677af3cf1$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $9fc8551677af3cf1$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $168p3.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $1HooC.Point)(points[0], points[1]);
    const lastPoint = new (0, $1HooC.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $d1s7O.curveEps) * (0, $d1s7O.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("d1s7O", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $5f88c52b3933a72f$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $5f88c52b3933a72f$export$51a946149243709);
"use strict";
const $5f88c52b3933a72f$export$7159a7c43f12984 = 1e-4;
const $5f88c52b3933a72f$export$51a946149243709 = 1e-4;

});

parcelRegister("168p3", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $19281094736c08bb$export$38856eae80d480e1);
"use strict";
function $19281094736c08bb$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("7pahp", function(module, exports) {

$parcel$export(module.exports, "buildPixelLine", () => $1882f668f31d317e$export$44c058937667e9f0);

var $d1s7O = parcelRequire("d1s7O");
"use strict";
function $1882f668f31d317e$export$44c058937667e9f0(points, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const fx = points[0];
    const fy = points[1];
    const lx = points[points.length - 2];
    const ly = points[points.length - 1];
    const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
    const verts = vertices;
    const length = points.length / 2;
    const indexStart = verts.length / 2;
    for(let i = 0; i < length; i++){
        verts.push(points[i * 2]);
        verts.push(points[i * 2 + 1]);
    }
    for(let i = 0; i < length - 1; i++)indices.push(indexStart + i, indexStart + i + 1);
    if (closePath) indices.push(indexStart + length - 1, indexStart);
}

});

parcelRegister("ei7YJ", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $7f823fd9a95a0bf4$export$4c2d12f7b210f357);

var $i9BKe = parcelRequire("i9BKe");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $7f823fd9a95a0bf4$var$emptyArray = [];
const $7f823fd9a95a0bf4$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $2E1jb.triangulateWithHoles)(points, $7f823fd9a95a0bf4$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("2E1jb", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $0c79f6b53084d415$export$5a241bf9c2c3d94b);

var $e9PUX = parcelRequire("e9PUX");
"use strict";
function $0c79f6b53084d415$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, $e9PUX.earcut)(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("e9PUX", function(module, exports) {

$parcel$export(module.exports, "earcut", () => $04328aff3292927e$export$71a1409458eaaf0d);

var $d7ir8 = parcelRequire("d7ir8");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $04328aff3292927e$export$71a1409458eaaf0d = (0, $d7ir8.default).default || (0, $d7ir8.default);

});
parcelRegister("d7ir8", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ca3aec61c89f59$export$2e2bcd8739ae039);
function $98ca3aec61c89f59$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $98ca3aec61c89f59$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $98ca3aec61c89f59$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $98ca3aec61c89f59$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $98ca3aec61c89f59$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $98ca3aec61c89f59$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $98ca3aec61c89f59$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $98ca3aec61c89f59$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $98ca3aec61c89f59$var$equals(last, last.next)) {
        $98ca3aec61c89f59$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $98ca3aec61c89f59$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($98ca3aec61c89f59$var$equals(p, p.next) || $98ca3aec61c89f59$var$area(p.prev, p, p.next) === 0)) {
            $98ca3aec61c89f59$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $98ca3aec61c89f59$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $98ca3aec61c89f59$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $98ca3aec61c89f59$var$isEarHashed(ear, minX, minY, invSize) : $98ca3aec61c89f59$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $98ca3aec61c89f59$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $98ca3aec61c89f59$var$earcutLinked($98ca3aec61c89f59$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $98ca3aec61c89f59$var$cureLocalIntersections($98ca3aec61c89f59$var$filterPoints(ear), triangles);
                $98ca3aec61c89f59$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $98ca3aec61c89f59$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $98ca3aec61c89f59$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($98ca3aec61c89f59$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $98ca3aec61c89f59$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $98ca3aec61c89f59$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($98ca3aec61c89f59$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $98ca3aec61c89f59$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $98ca3aec61c89f59$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $98ca3aec61c89f59$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $98ca3aec61c89f59$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $98ca3aec61c89f59$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $98ca3aec61c89f59$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $98ca3aec61c89f59$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$98ca3aec61c89f59$var$equals(a, b) && $98ca3aec61c89f59$var$intersects(a, p, p.next, b) && $98ca3aec61c89f59$var$locallyInside(a, b) && $98ca3aec61c89f59$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $98ca3aec61c89f59$var$removeNode(p);
            $98ca3aec61c89f59$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $98ca3aec61c89f59$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $98ca3aec61c89f59$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $98ca3aec61c89f59$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $98ca3aec61c89f59$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $98ca3aec61c89f59$var$filterPoints(a, a.next);
                c = $98ca3aec61c89f59$var$filterPoints(c, c.next);
                // run earcut on each half
                $98ca3aec61c89f59$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $98ca3aec61c89f59$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $98ca3aec61c89f59$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $98ca3aec61c89f59$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($98ca3aec61c89f59$var$getLeftmost(list));
    }
    queue.sort($98ca3aec61c89f59$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $98ca3aec61c89f59$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $98ca3aec61c89f59$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $98ca3aec61c89f59$var$eliminateHole(hole, outerNode) {
    const bridge = $98ca3aec61c89f59$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $98ca3aec61c89f59$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $98ca3aec61c89f59$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $98ca3aec61c89f59$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $98ca3aec61c89f59$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($98ca3aec61c89f59$var$equals(hole, p)) return p;
    do {
        if ($98ca3aec61c89f59$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $98ca3aec61c89f59$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($98ca3aec61c89f59$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $98ca3aec61c89f59$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $98ca3aec61c89f59$var$sectorContainsSector(m, p) {
    return $98ca3aec61c89f59$var$area(m.prev, m, p.prev) < 0 && $98ca3aec61c89f59$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $98ca3aec61c89f59$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $98ca3aec61c89f59$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $98ca3aec61c89f59$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $98ca3aec61c89f59$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $98ca3aec61c89f59$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $98ca3aec61c89f59$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $98ca3aec61c89f59$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $98ca3aec61c89f59$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $98ca3aec61c89f59$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $98ca3aec61c89f59$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$98ca3aec61c89f59$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($98ca3aec61c89f59$var$locallyInside(a, b) && $98ca3aec61c89f59$var$locallyInside(b, a) && $98ca3aec61c89f59$var$middleInside(a, b) && // locally visible
    ($98ca3aec61c89f59$var$area(a.prev, a, b.prev) || $98ca3aec61c89f59$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $98ca3aec61c89f59$var$equals(a, b) && $98ca3aec61c89f59$var$area(a.prev, a, a.next) > 0 && $98ca3aec61c89f59$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $98ca3aec61c89f59$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $98ca3aec61c89f59$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $98ca3aec61c89f59$var$intersects(p1, q1, p2, q2) {
    const o1 = $98ca3aec61c89f59$var$sign($98ca3aec61c89f59$var$area(p1, q1, p2));
    const o2 = $98ca3aec61c89f59$var$sign($98ca3aec61c89f59$var$area(p1, q1, q2));
    const o3 = $98ca3aec61c89f59$var$sign($98ca3aec61c89f59$var$area(p2, q2, p1));
    const o4 = $98ca3aec61c89f59$var$sign($98ca3aec61c89f59$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $98ca3aec61c89f59$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $98ca3aec61c89f59$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $98ca3aec61c89f59$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $98ca3aec61c89f59$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $98ca3aec61c89f59$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $98ca3aec61c89f59$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $98ca3aec61c89f59$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $98ca3aec61c89f59$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $98ca3aec61c89f59$var$locallyInside(a, b) {
    return $98ca3aec61c89f59$var$area(a.prev, a, a.next) < 0 ? $98ca3aec61c89f59$var$area(a, b, a.next) >= 0 && $98ca3aec61c89f59$var$area(a, a.prev, b) >= 0 : $98ca3aec61c89f59$var$area(a, b, a.prev) < 0 || $98ca3aec61c89f59$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $98ca3aec61c89f59$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $98ca3aec61c89f59$var$splitPolygon(a, b) {
    const a2 = $98ca3aec61c89f59$var$createNode(a.i, a.x, a.y), b2 = $98ca3aec61c89f59$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $98ca3aec61c89f59$var$insertNode(i, x, y, last) {
    const p = $98ca3aec61c89f59$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $98ca3aec61c89f59$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $98ca3aec61c89f59$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $98ca3aec61c89f59$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($98ca3aec61c89f59$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($98ca3aec61c89f59$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $98ca3aec61c89f59$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $98ca3aec61c89f59$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}

});




parcelRegister("7DIxn", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $1d4b4832ec6feb5d$export$cbe813d11f2192b2);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $1d4b4832ec6feb5d$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width > 0 && height > 0)) return false;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("iAUCq", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $14f13b7de979604e$export$8eb75cb9f614d270);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $14f13b7de979604e$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("34u7a", function(module, exports) {

$parcel$export(module.exports, "generateTextureMatrix", () => $72972982d23c75da$export$1e9b9e463121b388);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $gwwtL = parcelRequire("gwwtL");
"use strict";
const $72972982d23c75da$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
const $72972982d23c75da$var$tempRect = new (0, $fM4Mk.Rectangle)();
function $72972982d23c75da$export$1e9b9e463121b388(out, style, shape, matrix) {
    const textureMatrix = style.matrix ? out.copyFrom(style.matrix).invert() : out.identity();
    if (style.textureSpace === "local") {
        const bounds = shape.getBounds($72972982d23c75da$var$tempRect);
        if (style.width) bounds.pad(style.width);
        const { x: tx, y: ty } = bounds;
        const sx = 1 / bounds.width;
        const sy = 1 / bounds.height;
        const mTx = -tx * sx;
        const mTy = -ty * sy;
        const a1 = textureMatrix.a;
        const b1 = textureMatrix.b;
        const c1 = textureMatrix.c;
        const d1 = textureMatrix.d;
        textureMatrix.a *= sx;
        textureMatrix.b *= sx;
        textureMatrix.c *= sy;
        textureMatrix.d *= sy;
        textureMatrix.tx = mTx * a1 + mTy * c1 + textureMatrix.tx;
        textureMatrix.ty = mTx * b1 + mTy * d1 + textureMatrix.ty;
    } else {
        textureMatrix.translate(style.texture.frame.x, style.texture.frame.y);
        textureMatrix.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
    }
    const sourceStyle = style.texture.source.style;
    if (!(style.fill instanceof (0, $gwwtL.FillGradient)) && sourceStyle.addressMode === "clamp-to-edge") {
        sourceStyle.addressMode = "repeat";
        sourceStyle.update();
    }
    if (matrix) textureMatrix.append($72972982d23c75da$var$tempTextureMatrix.copyFrom(matrix).invert());
    return textureMatrix;
}

});
parcelRegister("gwwtL", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $339e160815705dba$export$722a6ea8c60ca86);

var $a2eTA = parcelRequire("a2eTA");

var $iCGeI = parcelRequire("iCGeI");

var $eY4rt = parcelRequire("eY4rt");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $dr868 = parcelRequire("dr868");
"use strict";
const $339e160815705dba$var$emptyColorStops = [
    {
        offset: 0,
        color: "white"
    },
    {
        offset: 1,
        color: "black"
    }
];
const $339e160815705dba$var$_FillGradient = class _FillGradient {
    constructor(...args){
        /**
     * Unique identifier for this gradient instance
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillGradient");
        /**
     * Internal tick counter to track changes in the gradient.
     * This is used to invalidate the gradient when the texture changes.
     * @internal
     */ this._tick = 0;
        /** Type of gradient - currently only supports 'linear' */ this.type = "linear";
        /** Array of color stops defining the gradient */ this.colorStops = [];
        let options = $339e160815705dba$var$ensureGradientOptions(args);
        const defaults = options.type === "radial" ? _FillGradient.defaultRadialOptions : _FillGradient.defaultLinearOptions;
        options = {
            ...defaults,
            ...(0, $dr868.definedProps)(options)
        };
        this._textureSize = options.textureSize;
        this._wrapMode = options.wrapMode;
        if (options.type === "radial") {
            this.center = options.center;
            this.outerCenter = options.outerCenter ?? this.center;
            this.innerRadius = options.innerRadius;
            this.outerRadius = options.outerRadius;
            this.scale = options.scale;
            this.rotation = options.rotation;
        } else {
            this.start = options.start;
            this.end = options.end;
        }
        this.textureSpace = options.textureSpace;
        this.type = options.type;
        options.colorStops.forEach((stop)=>{
            this.addColorStop(stop.offset, stop.color);
        });
    }
    /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */ addColorStop(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: (0, $a2eTA.Color).shared.setValue(color).toHexa()
        });
        return this;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildLinearGradient() {
        if (this.texture) return;
        let { x: x0, y: y0 } = this.start;
        let { x: x1, y: y1 } = this.end;
        let dx = x1 - x0;
        let dy = y1 - y0;
        const flip = dx < 0 || dy < 0;
        if (this._wrapMode === "clamp-to-edge") {
            if (dx < 0) {
                const temp = x0;
                x0 = x1;
                x1 = temp;
                dx *= -1;
            }
            if (dy < 0) {
                const temp = y0;
                y0 = y1;
                y1 = temp;
                dy *= -1;
            }
        }
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, 1);
        const gradient = !flip ? context.createLinearGradient(0, 0, this._textureSize, 0) : context.createLinearGradient(this._textureSize, 0, 0, 0);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = gradient;
        context.fillRect(0, 0, defaultSize, 1);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        const m = new (0, $eY4rt.Matrix)();
        m.scale(dist / defaultSize, 1);
        m.rotate(angle);
        m.translate(x0, y0);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildGradient() {
        if (!this.texture) this._tick++;
        if (this.type === "linear") this.buildLinearGradient();
        else this.buildRadialGradient();
    }
    /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildRadialGradient() {
        if (this.texture) return;
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, defaultSize);
        const { x: x0, y: y0 } = this.center;
        const { x: x1, y: y1 } = this.outerCenter;
        const r0 = this.innerRadius;
        const r1 = this.outerRadius;
        const ox = x1 - r1;
        const oy = y1 - r1;
        const scale = defaultSize / (r1 * 2);
        const cx = (x0 - ox) * scale;
        const cy = (y0 - oy) * scale;
        const gradient = context.createRadialGradient(cx, cy, r0 * scale, (x1 - ox) * scale, (y1 - oy) * scale, r1 * scale);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = colorStops[colorStops.length - 1].color;
        context.fillRect(0, 0, defaultSize, defaultSize);
        context.fillStyle = gradient;
        context.translate(cx, cy);
        context.rotate(this.rotation);
        context.scale(1, this.scale);
        context.translate(-cx, -cy);
        context.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const m = new (0, $eY4rt.Matrix)();
        m.scale(1 / scale, 1 / scale);
        m.translate(ox, oy);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture?.destroy(true);
        this.texture = null;
        this.transform = null;
        this.colorStops = [];
        this.start = null;
        this.end = null;
        this.center = null;
        this.outerCenter = null;
    }
    /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */ get styleKey() {
        return `fill-gradient-${this.uid}-${this._tick}`;
    }
};
/** Default options for creating a gradient fill */ $339e160815705dba$var$_FillGradient.defaultLinearOptions = {
    start: {
        x: 0,
        y: 0
    },
    end: {
        x: 0,
        y: 1
    },
    colorStops: [],
    textureSpace: "local",
    type: "linear",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
/** Default options for creating a radial gradient fill */ $339e160815705dba$var$_FillGradient.defaultRadialOptions = {
    center: {
        x: 0.5,
        y: 0.5
    },
    innerRadius: 0,
    outerRadius: 0.5,
    colorStops: [],
    scale: 1,
    textureSpace: "local",
    type: "radial",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
let $339e160815705dba$export$722a6ea8c60ca86 = $339e160815705dba$var$_FillGradient;
function $339e160815705dba$var$addColorStops(gradient, colorStops) {
    for(let i = 0; i < colorStops.length; i++){
        const stop = colorStops[i];
        gradient.addColorStop(stop.offset, stop.color);
    }
}
function $339e160815705dba$var$getCanvas(width, height) {
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(width, height);
    const context = canvas.getContext("2d");
    return {
        canvas: canvas,
        context: context
    };
}
function $339e160815705dba$var$ensureGradientOptions(args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || args[1]) {
        (0, $kXq8E.deprecation)("8.5.2", `use options object instead`);
        options = {
            type: "linear",
            start: {
                x: args[0],
                y: args[1]
            },
            end: {
                x: args[2],
                y: args[3]
            },
            textureSpace: args[4],
            textureSize: args[5] ?? $339e160815705dba$export$722a6ea8c60ca86.defaultLinearOptions.textureSize
        };
    }
    return options;
}

});



parcelRegister("ktCpi", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $e9923e9fec04a606$export$3d1378c7410cd8e);

var $eY4rt = parcelRequire("eY4rt");

var $aGJhg = parcelRequire("aGJhg");
"use strict";
const $e9923e9fec04a606$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $e9923e9fec04a606$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /**
     * unique id for this fill pattern
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillPattern");
        /**
     * Internal tick counter to track changes in the pattern.
     * This is used to invalidate the pattern when the texture or transform changes.
     * @internal
     */ this._tick = 0;
        /** The transform matrix applied to the pattern */ this.transform = new (0, $eY4rt.Matrix)();
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeV;
        }
    }
    /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */ setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._tick++;
    }
    /** Internal texture used to render the gradient */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this._texture === value) return;
        this._texture = value;
        this._tick++;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `fill-pattern-${this.uid}-${this._tick}`;
    }
    /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture.destroy(true);
        this.texture = null;
    }
}

});

parcelRegister("grNFH", function(module, exports) {

$parcel$export(module.exports, "canUseNewCanvasBlendModes", () => $2efe908c9b733b18$export$888398ad8627cefd);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue;
function $2efe908c9b733b18$var$createColoredCanvas(color) {
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(6, 1);
    const context = canvas.getContext("2d");
    context.fillStyle = color;
    context.fillRect(0, 0, 6, 1);
    return canvas;
}
function $2efe908c9b733b18$export$888398ad8627cefd() {
    if ($2efe908c9b733b18$var$canUseNewCanvasBlendModesValue !== void 0) return $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue;
    try {
        const magenta = $2efe908c9b733b18$var$createColoredCanvas("#ff00ff");
        const yellow = $2efe908c9b733b18$var$createColoredCanvas("#ffff00");
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(6, 1);
        const context = canvas.getContext("2d");
        context.globalCompositeOperation = "multiply";
        context.drawImage(magenta, 0, 0);
        context.drawImage(yellow, 2, 0);
        const imageData = context.getImageData(2, 0, 1, 1);
        if (!imageData) $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue = false;
        else {
            const data = imageData.data;
            $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue = data[0] === 255 && data[1] === 0 && data[2] === 0;
        }
    } catch (_error) {
        $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue = false;
    }
    return $2efe908c9b733b18$var$canUseNewCanvasBlendModesValue;
}

});

parcelRegister("jGzhD", function(module, exports) {

$parcel$export(module.exports, "canvasUtils", () => $96dd8a92db8b3464$export$fc1aa66eb2d10b9e);

var $a2eTA = parcelRequire("a2eTA");

var $iCGeI = parcelRequire("iCGeI");

var $2RwkA = parcelRequire("2RwkA");

var $grNFH = parcelRequire("grNFH");
"use strict";
const $96dd8a92db8b3464$export$fc1aa66eb2d10b9e = {
    canvas: null,
    convertTintToImage: false,
    cacheStepsPerColorChannel: 8,
    canUseMultiply: (0, $grNFH.canUseNewCanvasBlendModes)(),
    tintMethod: null,
    _canvasSourceCache: /* @__PURE__ */ new WeakMap(),
    _unpremultipliedCache: /* @__PURE__ */ new WeakMap(),
    getCanvasSource: (texture)=>{
        const source = texture.source;
        const resource = source?.resource;
        if (!resource) return null;
        const isPMA = source.alphaMode === "premultiplied-alpha";
        const resourceWidth = source.resourceWidth ?? source.pixelWidth;
        const resourceHeight = source.resourceHeight ?? source.pixelHeight;
        const needsResize = resourceWidth !== source.pixelWidth || resourceHeight !== source.pixelHeight;
        if (isPMA) {
            if (resource instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && resource instanceof OffscreenCanvas) {
                if (!needsResize) return resource;
            }
            const cached = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._unpremultipliedCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
        }
        if (resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int8Array || resource instanceof Uint16Array || resource instanceof Int16Array || resource instanceof Uint32Array || resource instanceof Int32Array || resource instanceof Float32Array || resource instanceof ArrayBuffer) {
            const cached = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._canvasSourceCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d");
            const imageData = context.createImageData(source.pixelWidth, source.pixelHeight);
            const data = imageData.data;
            const bytes = resource instanceof ArrayBuffer ? new Uint8Array(resource) : new Uint8Array(resource.buffer, resource.byteOffset, resource.byteLength);
            if (source.format === "bgra8unorm") for(let i = 0; i < data.length && i + 3 < bytes.length; i += 4){
                data[i] = bytes[i + 2];
                data[i + 1] = bytes[i + 1];
                data[i + 2] = bytes[i];
                data[i + 3] = bytes[i + 3];
            }
            else data.set(bytes.subarray(0, data.length));
            context.putImageData(imageData, 0, 0);
            $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._canvasSourceCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        if (isPMA) {
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d", {
                willReadFrequently: true
            });
            canvas.width = source.pixelWidth;
            canvas.height = source.pixelHeight;
            context.drawImage(resource, 0, 0);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i += 4){
                const a = data[i + 3];
                if (a > 0) {
                    const alphaInv = 255 / a;
                    data[i] = Math.min(255, data[i] * alphaInv + 0.5);
                    data[i + 1] = Math.min(255, data[i + 1] * alphaInv + 0.5);
                    data[i + 2] = Math.min(255, data[i + 2] * alphaInv + 0.5);
                }
            }
            context.putImageData(imageData, 0, 0);
            $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._unpremultipliedCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        if (needsResize) {
            const cached = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._canvasSourceCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d");
            canvas.width = source.pixelWidth;
            canvas.height = source.pixelHeight;
            context.drawImage(resource, 0, 0);
            $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._canvasSourceCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        return resource;
    },
    getTintedCanvas: (sprite, color)=>{
        const texture = sprite.texture;
        const stringColor = (0, $a2eTA.Color).shared.setValue(color).toHex();
        const cache = texture.tintCache || (texture.tintCache = {});
        const cachedCanvas = cache[stringColor];
        const resourceId = texture.source._resourceId;
        if (cachedCanvas?.tintId === resourceId) return cachedCanvas;
        const canvas = cachedCanvas && "getContext" in cachedCanvas ? cachedCanvas : (0, $iCGeI.DOMAdapter).get().createCanvas();
        $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.tintMethod(texture, color, canvas);
        canvas.tintId = resourceId;
        if ($96dd8a92db8b3464$export$fc1aa66eb2d10b9e.convertTintToImage && canvas.toDataURL !== void 0) {
            const tintImage = (0, $iCGeI.DOMAdapter).get().createImage();
            tintImage.src = canvas.toDataURL();
            tintImage.tintId = resourceId;
            cache[stringColor] = tintImage;
        } else cache[stringColor] = canvas;
        return cache[stringColor];
    },
    getTintedPattern: (texture, color)=>{
        const stringColor = (0, $a2eTA.Color).shared.setValue(color).toHex();
        const cache = texture.patternCache || (texture.patternCache = {});
        const resourceId = texture.source._resourceId;
        let pattern = cache[stringColor];
        if (pattern?.tintId === resourceId) return pattern;
        if (!$96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canvas) $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.tintMethod(texture, color, $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canvas);
        const context = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canvas.getContext("2d");
        pattern = context.createPattern($96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canvas, "repeat");
        pattern.tintId = resourceId;
        cache[stringColor] = pattern;
        return pattern;
    },
    /**
   * Applies a transform to a CanvasPattern.
   * @param pattern - The pattern to apply the transform to.
   * @param matrix - The matrix to apply.
   * @param matrix.a
   * @param matrix.b
   * @param matrix.c
   * @param matrix.d
   * @param matrix.tx
   * @param matrix.ty
   * @param invert
   */ applyPatternTransform: (pattern, matrix, invert = true)=>{
        if (!matrix) return;
        const patternAny = pattern;
        if (!patternAny.setTransform) return;
        const DOMMatrixCtor = globalThis.DOMMatrix;
        if (!DOMMatrixCtor) return;
        const domMatrix = new DOMMatrixCtor([
            matrix.a,
            matrix.b,
            matrix.c,
            matrix.d,
            matrix.tx,
            matrix.ty
        ]);
        patternAny.setTransform(invert ? domMatrix.inverse() : domMatrix);
    },
    tintWithMultiply: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $2RwkA.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.fillStyle = (0, $a2eTA.Color).shared.setValue(color).toHex();
        context.fillRect(0, 0, outWidth, outHeight);
        context.globalCompositeOperation = "multiply";
        const source = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.globalCompositeOperation = "destination-atop";
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },
    tintWithOverlay: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $2RwkA.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.globalCompositeOperation = "copy";
        context.fillStyle = (0, $a2eTA.Color).shared.setValue(color).toHex();
        context.fillRect(0, 0, outWidth, outHeight);
        context.globalCompositeOperation = "destination-atop";
        const source = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },
    tintWithPerPixel: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $2RwkA.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.globalCompositeOperation = "copy";
        const source = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $96dd8a92db8b3464$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
        const r = color >> 16 & 255;
        const g = color >> 8 & 255;
        const b = color & 255;
        const imageData = context.getImageData(0, 0, outWidth, outHeight);
        const data = imageData.data;
        for(let i = 0; i < data.length; i += 4){
            data[i] = data[i] * r / 255;
            data[i + 1] = data[i + 1] * g / 255;
            data[i + 2] = data[i + 2] * b / 255;
        }
        context.putImageData(imageData, 0, 0);
    },
    /**
   * Applies inverse rotation transform to context for texture packer rotation compensation.
   * Supports all 16 groupD8 symmetries (rotations and reflections).
   * @param context - Canvas 2D context
   * @param rotate - The groupD8 rotation value
   * @param srcWidth - Source crop width (before rotation)
   * @param srcHeight - Source crop height (before rotation)
   */ _applyInverseRotation: (context, rotate, srcWidth, srcHeight)=>{
        const inv = (0, $2RwkA.groupD8).inv(rotate);
        const a = (0, $2RwkA.groupD8).uX(inv);
        const b = (0, $2RwkA.groupD8).uY(inv);
        const c = (0, $2RwkA.groupD8).vX(inv);
        const d = (0, $2RwkA.groupD8).vY(inv);
        const tx = -Math.min(0, a * srcWidth, c * srcHeight, a * srcWidth + c * srcHeight);
        const ty = -Math.min(0, b * srcWidth, d * srcHeight, b * srcWidth + d * srcHeight);
        context.transform(a, b, c, d, tx, ty);
    }
};
$96dd8a92db8b3464$export$fc1aa66eb2d10b9e.tintMethod = $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.canUseMultiply ? $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.tintWithMultiply : $96dd8a92db8b3464$export$fc1aa66eb2d10b9e.tintWithPerPixel;

});

parcelRegister("2Aebl", function(module, exports) {

$parcel$export(module.exports, "State", () => $f68a91b4254cec58$export$7254cc27399e90bd);
"use strict";
const $f68a91b4254cec58$var$blendModeIds = {
    normal: 0,
    add: 1,
    multiply: 2,
    screen: 3,
    overlay: 4,
    erase: 5,
    "normal-npm": 6,
    "add-npm": 7,
    "screen-npm": 8,
    min: 9,
    max: 10
};
const $f68a91b4254cec58$var$BLEND = 0;
const $f68a91b4254cec58$var$OFFSET = 1;
const $f68a91b4254cec58$var$CULLING = 2;
const $f68a91b4254cec58$var$DEPTH_TEST = 3;
const $f68a91b4254cec58$var$WINDING = 4;
const $f68a91b4254cec58$var$DEPTH_MASK = 5;
const $f68a91b4254cec58$var$_State = class _State {
    constructor(){
        this.data = 0;
        this.blendMode = "normal";
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$BLEND) !== value) this.data ^= 1 << $f68a91b4254cec58$var$BLEND;
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$OFFSET) !== value) this.data ^= 1 << $f68a91b4254cec58$var$OFFSET;
    }
    /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */ set cullMode(value) {
        if (value === "none") {
            this.culling = false;
            return;
        }
        this.culling = true;
        this.clockwiseFrontFace = value === "front";
    }
    get cullMode() {
        if (!this.culling) return "none";
        return this.clockwiseFrontFace ? "front" : "back";
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$CULLING) !== value) this.data ^= 1 << $f68a91b4254cec58$var$CULLING;
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_TEST) !== value) this.data ^= 1 << $f68a91b4254cec58$var$DEPTH_TEST;
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_MASK) !== value) this.data ^= 1 << $f68a91b4254cec58$var$DEPTH_MASK;
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$WINDING) !== value) this.data ^= 1 << $f68a91b4254cec58$var$WINDING;
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== "none";
        this._blendMode = value;
        this._blendModeId = $f68a91b4254cec58$var$blendModeIds[value] || 0;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */ static for2d() {
        const state = new _State();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
};
$f68a91b4254cec58$var$_State.default2d = $f68a91b4254cec58$var$_State.for2d();
let $f68a91b4254cec58$export$7254cc27399e90bd = $f68a91b4254cec58$var$_State;

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("6B0gZ", function(module, exports) {

$parcel$export(module.exports, "color32BitToUniform", () => $67025a23fd381e5c$export$2c68e848c5b81f5);
"use strict";
function $67025a23fd381e5c$export$d13a52631f102a23(rgb, alpha, out, offset) {
    out[offset++] = (rgb >> 16 & 255) / 255;
    out[offset++] = (rgb >> 8 & 255) / 255;
    out[offset++] = (rgb & 255) / 255;
    out[offset++] = alpha;
}
function $67025a23fd381e5c$export$2c68e848c5b81f5(abgr, out, offset) {
    const alpha = (abgr >> 24 & 255) / 255;
    out[offset++] = (abgr & 255) / 255 * alpha;
    out[offset++] = (abgr >> 8 & 255) / 255 * alpha;
    out[offset++] = (abgr >> 16 & 255) / 255 * alpha;
    out[offset++] = alpha;
}

});

parcelRegister("3cebA", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $1b5e4ef3a1ed4a4a$export$29d3e417456abdad);

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");

var $8aC7P = parcelRequire("8aC7P");
parcelRequire("bqs0D");
"use strict";
class $1b5e4ef3a1ed4a4a$export$29d3e417456abdad extends (0, $b9FQU.ViewContainer) {
    /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $8aC7P.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        /** @internal */ this.renderPipeId = "graphics";
        if (!context) {
            this.context = this._ownedContext = new (0, $8aC7P.GraphicsContext)();
            this.context.autoGarbageCollect = this.autoGarbageCollect;
        } else this.context = context;
        this.didViewUpdate = true;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        if (this._context) {
            this._context.off("update", this.onViewUpdate, this);
            this._context.off("unload", this.unload, this);
        }
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this._context.on("unload", this.unload, this);
        this.onViewUpdate();
    }
    /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */ get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */ updateBounds() {}
    /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    /**
   * @param now - The current time in milliseconds.
   * @internal
   */ _onTouch(now) {
        this._gcLastUsed = now;
        this._context._gcLastUsed = now;
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */ clone(deep = false) {
        if (deep) return new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        if (color !== void 0) fillStyle.color = color;
        if (alpha !== void 0) fillStyle.alpha = alpha;
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});
parcelRegister("8aC7P", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $5d1287b36eb70f7f$export$cde35afe8b5f985);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $1HooC = parcelRequire("1HooC");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $7wtv9 = parcelRequire("7wtv9");

var $c9xxq = parcelRequire("c9xxq");

var $6ph3G = parcelRequire("6ph3G");

var $6mQKv = parcelRequire("6mQKv");

var $eOSrx = parcelRequire("eOSrx");
"use strict";
const $5d1287b36eb70f7f$var$tmpPoint = new (0, $1HooC.Point)();
const $5d1287b36eb70f7f$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $5d1287b36eb70f7f$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /**
     * unique id for this graphics context
     * @internal
     */ this.uid = (0, $aGJhg.uid)("graphicsContext");
        /**
     * Indicates whether content is updated and have to be re-rendered.
     * @internal
     */ this.dirty = true;
        /** The batch mode for this graphics context. It can be 'auto', 'batch', or 'no-batch'. */ this.batchMode = "auto";
        /** @internal */ this.instructions = [];
        /** Whether the graphics context has been destroyed. */ this.destroyed = false;
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        this._transform = new (0, $eY4rt.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $6mQKv.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint || tint === 0 ? (0, $a2eTA.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $1HooC.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $6mQKv.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $6ph3G.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $5d1287b36eb70f7f$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($5d1287b36eb70f7f$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        this._boundsDirty = true;
        this.dirty = true;
        this.emit("update", this, 16);
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const alignment = data.style.alignment;
                let outerPadding = data.style.width * (1 - alignment);
                if (data.style.join === "miter") outerPadding *= (0, $eOSrx.getMaxMiterRatio)(data.path, data.style.miterLimit);
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - outerPadding, _bounds.minY - outerPadding, _bounds.maxX + outerPadding, _bounds.maxY + outerPadding);
            }
        }
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $5d1287b36eb70f7f$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else {
                    const strokeStyle = style;
                    hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
                }
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /** Unloads the GPU data from the graphics context. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        this._stateStack.length = 0;
        this._transform = null;
        this.unload();
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local"
};
/** The default stroke style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local",
    /** If the stroke is a pixel line. */ pixelLine: false
};
let $5d1287b36eb70f7f$export$cde35afe8b5f985 = $5d1287b36eb70f7f$var$_GraphicsContext;

});
parcelRegister("c9xxq", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $0663b1de1906f348$export$7e54506375634c19);

var $1HooC = parcelRequire("1HooC");

var $aGJhg = parcelRequire("aGJhg");

var $hUCK4 = parcelRequire("hUCK4");

var $b2eG6 = parcelRequire("b2eG6");

var $ein11 = parcelRequire("ein11");
"use strict";
class $0663b1de1906f348$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */ constructor(instructions, signed = false){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $aGJhg.uid)("graphicsPath");
        this._dirty = true;
        this.checkForHoles = signed;
        if (typeof instructions === "string") (0, $b2eG6.parseSVGPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $ein11.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius || (innerRadius = radius / 2);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $0663b1de1906f348$export$7e54506375634c19();
        newGraphicsPath2D.checkForHoles = this.checkForHoles;
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $0663b1de1906f348$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $0663b1de1906f348$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $0663b1de1906f348$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $hUCK4.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $0663b1de1906f348$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("b2eG6", function(module, exports) {

$parcel$export(module.exports, "parseSVGPath", () => $aa8e6738d1d86e9a$export$33813e954ab16e32);

var $8DJYa = parcelRequire("8DJYa");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $aa8e6738d1d86e9a$export$33813e954ab16e32(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($8DJYa)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], // First control point
                data[3], data[4], // Second control point
                lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], // First control point
                lastX + data[3], lastY + data[4], // Second control point
                lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "Z":
            // Close Path
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $hUCK4.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("8DJYa", function(module, exports) {
module.exports = $64a59fcc91535eb3$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $64a59fcc91535eb3$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $64a59fcc91535eb3$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $64a59fcc91535eb3$var$parse(path) {
    var data = [];
    path.replace($64a59fcc91535eb3$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $64a59fcc91535eb3$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $64a59fcc91535eb3$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $64a59fcc91535eb3$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $64a59fcc91535eb3$var$length[type])));
        }
    });
    return data;
}
var $64a59fcc91535eb3$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $64a59fcc91535eb3$var$parseValues(args) {
    var numbers = args.match($64a59fcc91535eb3$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("ein11", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $664ff60a6792361f$export$148534a3c727230b);

var $h7nJT = parcelRequire("h7nJT");

var $9hswb = parcelRequire("9hswb");

var $hbpIN = parcelRequire("hbpIN");

var $fM4Mk = parcelRequire("fM4Mk");

var $7u40a = parcelRequire("7u40a");

var $7wtv9 = parcelRequire("7wtv9");

var $lI2iN = parcelRequire("lI2iN");

var $eRV6E = parcelRequire("eRV6E");

var $aiLPr = parcelRequire("aiLPr");

var $boMdH = parcelRequire("boMdH");

var $jjbCG = parcelRequire("jjbCG");

var $9ad7k = parcelRequire("9ad7k");
"use strict";
const $664ff60a6792361f$var$tempRectangle = new (0, $fM4Mk.Rectangle)();
class $664ff60a6792361f$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
        this.signed = graphicsPath2D.checkForHoles;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $aiLPr.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $boMdH.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $jjbCG.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $lI2iN.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $eRV6E.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        const shapePrimitives = this.shapePrimitives;
        const start = shapePrimitives.length;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        if (path.checkForHoles && shapePrimitives.length - start > 1) {
            let mainShape = null;
            for(let i = start; i < shapePrimitives.length; i++){
                const shapePrimitive = shapePrimitives[i];
                if (shapePrimitive.shape.type === "polygon") {
                    const polygon = shapePrimitive.shape;
                    const mainPolygon = mainShape?.shape;
                    if (mainPolygon && mainPolygon.containsPolygon(polygon)) {
                        mainShape.holes || (mainShape.holes = []);
                        mainShape.holes.push(shapePrimitive);
                        shapePrimitives.copyWithin(i, i + 1);
                        shapePrimitives.length--;
                        i--;
                    } else mainShape = shapePrimitive;
                }
            }
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $fM4Mk.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $h7nJT.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $hbpIN.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = startAngle - i * delta;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $9ad7k.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $9ad7k.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $9hswb.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $7u40a.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $hbpIN.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $hbpIN.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($664ff60a6792361f$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("h7nJT", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f9e7c5f8c3846477$export$c89a927ffc67e6fa);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $f9e7c5f8c3846477$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks.
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Circle(0, 0, 50);
     * console.log(shape.type); // 'circle'
     *
     * // Use in type guards
     * if (shape.type === 'circle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @remarks
     * - Used for shape type checking
     * - More efficient than instanceof
     * - Read-only property
     * @readonly
     * @default 'circle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     * @see {@link ShapePrimitive} For shape interface
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */ clone() {
        return new $f9e7c5f8c3846477$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, width, alignment = 0.5) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const radius = this.radius;
        const outerWidth = (1 - alignment) * width;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("9hswb", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $985c1ca392a56bd1$export$80b0269ab108fa11);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $985c1ca392a56bd1$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Ellipse(0, 0, 50, 25);
     * console.log(shape.type); // 'ellipse'
     *
     * // Use in type guards
     * if (shape.type === 'ellipse') {
     *     console.log(shape.halfWidth, shape.halfHeight);
     * }
     * ```
     * @readonly
     * @default 'ellipse'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */ clone() {
        return new $985c1ca392a56bd1$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const strokeOuterWidth = strokeWidth * (1 - alignment);
        const strokeInnerWidth = strokeWidth - strokeOuterWidth;
        const innerHorizontal = halfWidth - strokeInnerWidth;
        const innerVertical = halfHeight - strokeInnerWidth;
        const outerHorizontal = halfWidth + strokeOuterWidth;
        const outerVertical = halfHeight + strokeOuterWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
        const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("hbpIN", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $11dc5aebdc9b56ee$export$7d31b617c820d435);

var $kXq8E = parcelRequire("kXq8E");

var $4sAiw = parcelRequire("4sAiw");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
let $11dc5aebdc9b56ee$var$tempRect;
let $11dc5aebdc9b56ee$var$tempRect2;
class $11dc5aebdc9b56ee$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Polygon([0, 0, 100, 0, 50, 100]);
     * console.log(shape.type); // 'polygon'
     *
     * // Use in type guards
     * if (shape.type === 'polygon') {
     *     // TypeScript knows this is a Polygon
     *     console.log(shape.points.length);
     * }
     * ```
     * @readonly
     * @default 'polygon'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */ isClockwise() {
        let area = 0;
        const points = this.points;
        const length = points.length;
        for(let i = 0; i < length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % length];
            const y2 = points[(i + 3) % length];
            area += (x2 - x1) * (y2 + y1);
        }
        return area < 0;
    }
    /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */ containsPolygon(polygon) {
        const thisBounds = this.getBounds($11dc5aebdc9b56ee$var$tempRect);
        const otherBounds = polygon.getBounds($11dc5aebdc9b56ee$var$tempRect2);
        if (!thisBounds.containsRect(otherBounds)) return false;
        const points = polygon.points;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!this.contains(x, y)) return false;
        }
        return true;
    }
    /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */ clone() {
        const points = this.points.slice();
        const polygon = new $11dc5aebdc9b56ee$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const strokeWidthSquared = strokeWidth * strokeWidth;
        const rightWidthSquared = strokeWidthSquared * (1 - alignment);
        const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSquared = (0, $4sAiw.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            const sign = Math.sign((x2 - x1) * (y - y1) - (y2 - y1) * (x - x1));
            if (distanceSquared <= (sign < 0 ? leftWidthSquared : rightWidthSquared)) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */ get x() {
        (0, $kXq8E.deprecation)("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead.");
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */ get y() {
        (0, $kXq8E.deprecation)("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead.");
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startX() {
        return this.points[0];
    }
    /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startY() {
        return this.points[1];
    }
}

});
parcelRegister("4sAiw", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $95fee67952e97042$export$db32ff20ff695a);
"use strict";
function $95fee67952e97042$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("7u40a", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $019041c7bdb3bf3e$export$d55ab2e3dc5a4263);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $019041c7bdb3bf3e$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class $019041c7bdb3bf3e$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new RoundedRectangle(0, 0, 100, 100, 20);
     * console.log(shape.type); // 'roundedRectangle'
     *
     * // Use in type guards
     * if (shape.type === 'roundedRectangle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @readonly
     * @default 'roundedRectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $019041c7bdb3bf3e$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */ strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - strokeWidthOuter && pX <= x + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - strokeWidthOuter && pY <= y + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter) || pX < innerX && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("lI2iN", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $4a51fd8da05fe222$export$7dab5eac414ecba2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $4a51fd8da05fe222$var$RECURSION_LIMIT = 8;
const $4a51fd8da05fe222$var$FLT_EPSILON = 11920929e-14;
const $4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON = 1;
const $4a51fd8da05fe222$var$curveAngleToleranceEpsilon = 0.01;
const $4a51fd8da05fe222$var$mAngleTolerance = 0;
const $4a51fd8da05fe222$var$mCuspLimit = 0;
function $4a51fd8da05fe222$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $4a51fd8da05fe222$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $4a51fd8da05fe222$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $4a51fd8da05fe222$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON && d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $4a51fd8da05fe222$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $4a51fd8da05fe222$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("hFzkv", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $119fb8487ef4f791$export$f2f3ca33e4c65172);

var $i9BKe = parcelRequire("i9BKe");

var $beJMG = parcelRequire("beJMG");

var $5RxDh = parcelRequire("5RxDh");

var $dK5Jn = parcelRequire("dK5Jn");

var $1DS3C = parcelRequire("1DS3C");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $1mKkK = parcelRequire("1mKkK");
"use strict";
class $119fb8487ef4f791$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
    reset() {
        if (this.batches) this.batches.forEach((batch)=>{
            (0, $61KiY.BigPool).return(batch);
        });
        if (this.graphicsData) (0, $61KiY.BigPool).return(this.graphicsData);
        this.isBatchable = false;
        this.context = null;
        this.batches.length = 0;
        this.geometryData.indices.length = 0;
        this.geometryData.vertices.length = 0;
        this.geometryData.uvs.length = 0;
        this.graphicsData = null;
    }
    destroy() {
        this.reset();
        this.batches = null;
        this.geometryData = null;
    }
}
class $119fb8487ef4f791$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.instructions = new (0, $dK5Jn.InstructionSet)();
    }
    init(options) {
        const maxTextures = options.maxTextures;
        this.batcher ? this.batcher._updateMaxTextures(maxTextures) : this.batcher = new (0, $5RxDh.DefaultBatcher)({
            maxTextures: maxTextures
        });
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
    destroy() {
        this.batcher.destroy();
        this.instructions.destroy();
        this.batcher = null;
        this.instructions = null;
    }
}
const $119fb8487ef4f791$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        return context._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const hasContext = !!context._gpuData[this._renderer.uid];
        const gpuContext = context._gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            (0, $1mKkK.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            else gpuContext.isBatchable = true;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        return context._gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $61KiY.BigPool).get($119fb8487ef4f791$export$9b6a6c5b37fc8f49, {
            maxTextures: this._renderer.limits.maxBatchableTextures
        });
        const gpuContext = context._gpuData[this._renderer.uid];
        const { batches: batches, geometryData: geometryData } = gpuContext;
        gpuContext.graphicsData = graphicsData;
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $beJMG.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count, this._renderer.limits.maxBatchableTextures);
        }
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $119fb8487ef4f791$export$e3e348c254036d55();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $119fb8487ef4f791$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $119fb8487ef4f791$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $119fb8487ef4f791$export$f2f3ca33e4c65172 = $119fb8487ef4f791$var$_GraphicsContextSystem;

});


parcelRegister("eRV6E", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $39a9db3afcc2f789$export$d53ce9debfe7a6c2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $39a9db3afcc2f789$var$RECURSION_LIMIT = 8;
const $39a9db3afcc2f789$var$FLT_EPSILON = 11920929e-14;
const $39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON = 1;
const $39a9db3afcc2f789$var$curveAngleToleranceEpsilon = 0.01;
const $39a9db3afcc2f789$var$mAngleTolerance = 0;
function $39a9db3afcc2f789$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $39a9db3afcc2f789$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $39a9db3afcc2f789$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $39a9db3afcc2f789$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $39a9db3afcc2f789$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($39a9db3afcc2f789$var$mAngleTolerance < $39a9db3afcc2f789$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $39a9db3afcc2f789$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $39a9db3afcc2f789$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $39a9db3afcc2f789$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("aiLPr", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $4598c98f5bbae757$export$ed8eebdc6998f0f6);
"use strict";
function $4598c98f5bbae757$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("boMdH", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $35a2eb588826e37c$export$d46b7933b415e02f);

var $aiLPr = parcelRequire("aiLPr");
"use strict";
function $35a2eb588826e37c$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $aiLPr.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("jjbCG", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $d859b1787749b4c9$export$71ccaa6dca53075e);

var $lI2iN = parcelRequire("lI2iN");
"use strict";
const $d859b1787749b4c9$var$TAU = Math.PI * 2;
const $d859b1787749b4c9$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $d859b1787749b4c9$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $d859b1787749b4c9$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $d859b1787749b4c9$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $d859b1787749b4c9$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $d859b1787749b4c9$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $d859b1787749b4c9$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $d859b1787749b4c9$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $d859b1787749b4c9$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $d859b1787749b4c9$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $d859b1787749b4c9$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $d859b1787749b4c9$var$out);
    let { ang1: ang1, ang2: ang2 } = $d859b1787749b4c9$var$out;
    const { centerX: centerX, centerY: centerY } = $d859b1787749b4c9$var$out;
    let ratio = Math.abs(ang2) / ($d859b1787749b4c9$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $d859b1787749b4c9$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $d859b1787749b4c9$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $d859b1787749b4c9$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $d859b1787749b4c9$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $lI2iN.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("9ad7k", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $9769dc3699a7c802$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $9769dc3699a7c802$export$cf503f371c53af9e);
"use strict";
function $9769dc3699a7c802$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $9769dc3699a7c802$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("6ph3G", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $ff733ce48c045e93$export$2cc2aaca18109aab);

var $hUCK4 = parcelRequire("hUCK4");

var $c9xxq = parcelRequire("c9xxq");

var $lwWDT = parcelRequire("lwWDT");

var $66BsB = parcelRequire("66BsB");

var $cEiD3 = parcelRequire("cEiD3");

var $gJb52 = parcelRequire("gJb52");

var $eeBBt = parcelRequire("eeBBt");
"use strict";
function $ff733ce48c045e93$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        defs: {},
        path: new (0, $c9xxq.GraphicsPath)()
    };
    (0, $lwWDT.parseSVGDefinitions)(svg, session);
    const children = svg.children;
    const { fillStyle: fillStyle, strokeStyle: strokeStyle } = (0, $cEiD3.parseSVGStyle)(svg, session);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.nodeName.toLowerCase() === "defs") continue;
        $ff733ce48c045e93$var$renderChildren(child, session, fillStyle, strokeStyle);
    }
    return graphicsContext;
}
function $ff733ce48c045e93$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = (0, $cEiD3.parseSVGStyle)(svg, session);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    const noStyle = !fillStyle && !strokeStyle;
    if (noStyle) fillStyle = {
        color: 0
    };
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            {
                d = svg.getAttribute("d");
                const fillRule = svg.getAttribute("fill-rule");
                const subpaths = (0, $eeBBt.extractSubpaths)(d);
                const hasExplicitEvenodd = fillRule === "evenodd";
                const hasMultipleSubpaths = subpaths.length > 1;
                const shouldProcessHoles = hasExplicitEvenodd && hasMultipleSubpaths;
                if (shouldProcessHoles) {
                    const subpathsWithArea = subpaths.map((subpath)=>({
                            path: subpath,
                            area: (0, $eeBBt.calculatePathArea)(subpath)
                        }));
                    subpathsWithArea.sort((a, b)=>b.area - a.area);
                    const useMultipleHolesApproach = subpaths.length > 3 || !(0, $gJb52.checkForNestedPattern)(subpathsWithArea);
                    if (useMultipleHolesApproach) for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isMainShape = i === 0;
                        session.context.beginPath();
                        const newPath = new (0, $c9xxq.GraphicsPath)(void 0, true);
                        (0, $eeBBt.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isMainShape) {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        } else session.context.cut();
                    }
                    else for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isHole = i % 2 === 1;
                        session.context.beginPath();
                        const newPath = new (0, $c9xxq.GraphicsPath)(void 0, true);
                        (0, $eeBBt.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isHole) session.context.cut();
                        else {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        }
                    }
                } else {
                    const useEvenoddForGraphicsPath = fillRule ? fillRule === "evenodd" : true;
                    graphicsPath = new (0, $c9xxq.GraphicsPath)(d, useEvenoddForGraphicsPath);
                    session.context.path(graphicsPath);
                    if (fillStyle) session.context.fill(fillStyle);
                    if (strokeStyle) session.context.stroke(strokeStyle);
                }
                break;
            }
        case "circle":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            r = (0, $66BsB.parseSVGFloatAttribute)(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "rect":
            x = (0, $66BsB.parseSVGFloatAttribute)(svg, "x", 0);
            y = (0, $66BsB.parseSVGFloatAttribute)(svg, "y", 0);
            width = (0, $66BsB.parseSVGFloatAttribute)(svg, "width", 0);
            height = (0, $66BsB.parseSVGFloatAttribute)(svg, "height", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "ellipse":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "line":
            x1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x1", 0);
            y1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y1", 0);
            x2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x2", 0);
            y2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        // Group elements - just process children
        case "g":
        case "svg":
            break;
        default:
            (0, $hUCK4.warn)(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    if (noStyle) fillStyle = null;
    for(let i = 0; i < children.length; i++)$ff733ce48c045e93$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}

});
parcelRegister("lwWDT", function(module, exports) {

$parcel$export(module.exports, "parseSVGDefinitions", () => $2ade0f5beda11c2d$export$d578aced17ea3023);

var $a2eTA = parcelRequire("a2eTA");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $66BsB = parcelRequire("66BsB");
"use strict";
function $2ade0f5beda11c2d$export$d578aced17ea3023(svg, session) {
    const definitions = svg.querySelectorAll("defs");
    for(let i = 0; i < definitions.length; i++){
        const definition = definitions[i];
        for(let j = 0; j < definition.children.length; j++){
            const child = definition.children[j];
            switch(child.nodeName.toLowerCase()){
                case "lineargradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseLinearGradient(child);
                    break;
                case "radialgradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseRadialGradient(child);
                    break;
                default:
                    break;
            }
        }
    }
}
function $2ade0f5beda11c2d$var$parseLinearGradient(child) {
    const x0 = (0, $66BsB.parseSVGFloatAttribute)(child, "x1", 0);
    const y0 = (0, $66BsB.parseSVGFloatAttribute)(child, "y1", 0);
    const x1 = (0, $66BsB.parseSVGFloatAttribute)(child, "x2", 1);
    const y1 = (0, $66BsB.parseSVGFloatAttribute)(child, "y2", 0);
    const gradientUnit = child.getAttribute("gradientUnits") || "objectBoundingBox";
    const gradient = new (0, $gwwtL.FillGradient)(x0, y0, x1, y1, gradientUnit === "objectBoundingBox" ? "local" : "global");
    for(let k = 0; k < child.children.length; k++){
        const stop = child.children[k];
        const offset = (0, $66BsB.parseSVGFloatAttribute)(stop, "offset", 0);
        const color = (0, $a2eTA.Color).shared.setValue(stop.getAttribute("stop-color")).toNumber();
        gradient.addColorStop(offset, color);
    }
    return gradient;
}
function $2ade0f5beda11c2d$var$parseRadialGradient(_child) {
    (0, $hUCK4.warn)("[SVG Parser] Radial gradients are not yet supported");
    return new (0, $gwwtL.FillGradient)(0, 0, 1, 0);
}

});
parcelRegister("66BsB", function(module, exports) {

$parcel$export(module.exports, "parseSVGFloatAttribute", () => $30452626b79fbc29$export$dd264bbf059b1af7);
"use strict";
function $30452626b79fbc29$export$dd264bbf059b1af7(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}

});


parcelRegister("cEiD3", function(module, exports) {

$parcel$export(module.exports, "parseSVGStyle", () => $4fc848fee6ca709e$export$394301fd4b48c7bc);

var $a2eTA = parcelRequire("a2eTA");

var $iK8wH = parcelRequire("iK8wH");
"use strict";
const $4fc848fee6ca709e$export$d1c537faaad576dd = {
    // Fill properties
    fill: {
        type: "paint",
        default: 0
    },
    // Fill color/gradient
    "fill-opacity": {
        type: "number",
        default: 1
    },
    // Fill transparency
    // Stroke properties
    stroke: {
        type: "paint",
        default: 0
    },
    // Stroke color/gradient
    "stroke-width": {
        type: "number",
        default: 1
    },
    // Width of stroke
    "stroke-opacity": {
        type: "number",
        default: 1
    },
    // Stroke transparency
    "stroke-linecap": {
        type: "string",
        default: "butt"
    },
    // End cap style: butt, round, square
    "stroke-linejoin": {
        type: "string",
        default: "miter"
    },
    // Join style: miter, round, bevel
    "stroke-miterlimit": {
        type: "number",
        default: 10
    },
    // Limit on miter join sharpness
    "stroke-dasharray": {
        type: "string",
        default: "none"
    },
    // Dash pattern
    "stroke-dashoffset": {
        type: "number",
        default: 0
    },
    // Offset for dash pattern
    // Global properties
    opacity: {
        type: "number",
        default: 1
    }
};
function $4fc848fee6ca709e$export$394301fd4b48c7bc(svg, session) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    const result = {
        strokeStyle: strokeStyle,
        fillStyle: fillStyle,
        useFill: false,
        useStroke: false
    };
    for(const key in $4fc848fee6ca709e$export$d1c537faaad576dd){
        const attribute = svg.getAttribute(key);
        if (attribute) $4fc848fee6ca709e$var$parseAttribute(session, result, key, attribute.trim());
    }
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i].trim();
            const [key, value] = stylePart.split(":");
            if ($4fc848fee6ca709e$export$d1c537faaad576dd[key]) $4fc848fee6ca709e$var$parseAttribute(session, result, key, value.trim());
        }
    }
    return {
        strokeStyle: result.useStroke ? strokeStyle : null,
        fillStyle: result.useFill ? fillStyle : null,
        useFill: result.useFill,
        useStroke: result.useStroke
    };
}
function $4fc848fee6ca709e$var$parseAttribute(session, result, id, value) {
    switch(id){
        case "stroke":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.strokeStyle.fill = session.defs[id2];
                } else result.strokeStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useStroke = true;
            }
            break;
        case "stroke-width":
            result.strokeStyle.width = Number(value);
            break;
        case "fill":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.fillStyle.fill = session.defs[id2];
                } else result.fillStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useFill = true;
            }
            break;
        case "fill-opacity":
            result.fillStyle.alpha = Number(value);
            break;
        case "stroke-opacity":
            result.strokeStyle.alpha = Number(value);
            break;
        case "opacity":
            result.fillStyle.alpha = Number(value);
            result.strokeStyle.alpha = Number(value);
            break;
    }
}

});
parcelRegister("iK8wH", function(module, exports) {

$parcel$export(module.exports, "extractSvgUrlId", () => $bfccbd4b202a8863$export$c7c899a4a04107c);
"use strict";
function $bfccbd4b202a8863$export$c7c899a4a04107c(url) {
    const match = url.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
    return match ? match[1] : "";
}

});


parcelRegister("gJb52", function(module, exports) {

$parcel$export(module.exports, "checkForNestedPattern", () => $9fb42cb0760022d0$export$ed0d227537169c54);
"use strict";
function $9fb42cb0760022d0$export$ed0d227537169c54(subpathsWithArea) {
    if (subpathsWithArea.length <= 2) return true;
    const areas = subpathsWithArea.map((s)=>s.area).sort((a, b)=>b - a);
    const [largestArea, secondArea] = areas;
    const smallestArea = areas[areas.length - 1];
    const largestToSecondRatio = largestArea / secondArea;
    const secondToSmallestRatio = secondArea / smallestArea;
    if (largestToSecondRatio > 3 && secondToSmallestRatio < 2) return false;
    return true;
}
function $9fb42cb0760022d0$export$610d4ffdd1dde411(context, index = 0) {
    const instruction = context.instructions[index];
    if (!instruction || instruction.action !== "fill") throw new Error(`Expected fill instruction at index ${index}, got ${instruction?.action || "undefined"}`);
    return instruction.data;
}

});

parcelRegister("eeBBt", function(module, exports) {

$parcel$export(module.exports, "extractSubpaths", () => $c386432f9c5ff5be$export$af504e8f7eac5195);
$parcel$export(module.exports, "calculatePathArea", () => $c386432f9c5ff5be$export$c5f82a6ddca6e166);
$parcel$export(module.exports, "appendSVGPath", () => $c386432f9c5ff5be$export$29a5b7b41692ef3);

var $c9xxq = parcelRequire("c9xxq");
"use strict";
function $c386432f9c5ff5be$export$af504e8f7eac5195(pathData) {
    const parts = pathData.split(/(?=[Mm])/);
    const subpaths = parts.filter((part)=>part.trim().length > 0);
    return subpaths;
}
function $c386432f9c5ff5be$export$c5f82a6ddca6e166(pathData) {
    const coords = pathData.match(/[-+]?[0-9]*\.?[0-9]+/g);
    if (!coords || coords.length < 4) return 0;
    const numbers = coords.map(Number);
    const xs = [];
    const ys = [];
    for(let i = 0; i < numbers.length; i += 2)if (i + 1 < numbers.length) {
        xs.push(numbers[i]);
        ys.push(numbers[i + 1]);
    }
    if (xs.length === 0 || ys.length === 0) return 0;
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const area = (maxX - minX) * (maxY - minY);
    return area;
}
function $c386432f9c5ff5be$export$29a5b7b41692ef3(pathData, graphicsPath) {
    const tempPath = new (0, $c9xxq.GraphicsPath)(pathData, false);
    for (const instruction of tempPath.instructions)graphicsPath.instructions.push(instruction);
}

});


parcelRegister("6mQKv", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $ee0f76cca9221b48$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $ee0f76cca9221b48$export$64975ed44b74a62b);

var $a2eTA = parcelRequire("a2eTA");

var $bLlTJ = parcelRequire("bLlTJ");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
function $ee0f76cca9221b48$var$isColorLike(value) {
    return (0, $a2eTA.Color).isColorLike(value);
}
function $ee0f76cca9221b48$var$isFillPattern(value) {
    return value instanceof (0, $ktCpi.FillPattern);
}
function $ee0f76cca9221b48$var$isFillGradient(value) {
    return value instanceof (0, $gwwtL.FillGradient);
}
function $ee0f76cca9221b48$var$isTexture(value) {
    return value instanceof (0, $bLlTJ.Texture);
}
function $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $a2eTA.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $bLlTJ.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle) {
    fill.texture = value;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    fill.textureSpace = value.textureSpace;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    const color = (0, $a2eTA.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    return style;
}
function $ee0f76cca9221b48$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($ee0f76cca9221b48$var$isColorLike(value)) return $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isTexture(value)) return $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillPattern(value)) return $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillGradient(value)) return $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillPattern(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillGradient(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $ee0f76cca9221b48$var$handleFillObject(objectStyle, defaultStyle);
}
function $ee0f76cca9221b48$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, pixelLine: pixelLine, ...rest } = defaultStyle;
    const fill = $ee0f76cca9221b48$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        pixelLine: pixelLine,
        ...fill
    };
}

});

parcelRegister("eOSrx", function(module, exports) {

$parcel$export(module.exports, "getMaxMiterRatio", () => $5b35bdcf6ca4c436$export$95a81f2c49712883);
"use strict";
function $5b35bdcf6ca4c436$export$95a81f2c49712883(path, miterLimit) {
    let maxRatio = 1;
    const shapePrimitives = path.shapePath.shapePrimitives;
    for(let i = 0; i < shapePrimitives.length; i++){
        const shape = shapePrimitives[i].shape;
        if (shape.type !== "polygon") continue;
        const points = shape.points;
        const n = points.length;
        if (n < 6) continue;
        const closed = shape.closePath;
        for(let j = 0; j < n; j += 2){
            if (!closed && (j === 0 || j === n - 2)) continue;
            const prevIdx = (j - 2 + n) % n;
            const nextIdx = (j + 2) % n;
            const x0 = points[prevIdx];
            const y0 = points[prevIdx + 1];
            const x1 = points[j];
            const y1 = points[j + 1];
            const x2 = points[nextIdx];
            const y2 = points[nextIdx + 1];
            const dx0 = x0 - x1;
            const dy0 = y0 - y1;
            const dx1 = x2 - x1;
            const dy1 = y2 - y1;
            const len0Sq = dx0 * dx0 + dy0 * dy0;
            const len1Sq = dx1 * dx1 + dy1 * dy1;
            if (len0Sq < 1e-12 || len1Sq < 1e-12) continue;
            const dot = dx0 * dx1 + dy0 * dy1;
            const cosAngle = dot / Math.sqrt(len0Sq * len1Sq);
            let clampedCos = cosAngle;
            if (clampedCos < -1) clampedCos = -1;
            else if (clampedCos > 1) clampedCos = 1;
            const sinHalfAngle = Math.sqrt((1 - clampedCos) * 0.5);
            if (sinHalfAngle < 1e-6) continue;
            const miterRatio = Math.min(1 / sinHalfAngle, miterLimit);
            if (miterRatio > maxRatio) maxRatio = miterRatio;
        }
    }
    return maxRatio;
}

});


parcelRegister("bqs0D", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $7jrEU = parcelRequire("7jrEU");

var $ajBJN = parcelRequire("ajBJN");

var $hFzkv = parcelRequire("hFzkv");

var $3Ey0f = parcelRequire("3Ey0f");
"use strict";
(0, $i9BKe.extensions).add((0, $ajBJN.CanvasGraphicsPipe));
(0, $i9BKe.extensions).add((0, $3Ey0f.GraphicsPipe));
(0, $i9BKe.extensions).add((0, $7jrEU.CanvasGraphicsContextSystem));
(0, $i9BKe.extensions).add((0, $hFzkv.GraphicsContextSystem));

});
parcelRegister("7jrEU", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsContextSystem", () => $e0ffdacb44a3e41f$export$ecb840d1abeff74b);

var $i9BKe = parcelRequire("i9BKe");

var $dK5Jn = parcelRequire("dK5Jn");

var $1DS3C = parcelRequire("1DS3C");
"use strict";
class $e0ffdacb44a3e41f$var$CanvasGraphicsContext {
    constructor(){
        /**
     * Whether this context can be batched.
     * @advanced
     */ this.isBatchable = false;
    }
    /**
   * Reset cached canvas data.
   * @advanced
   */ reset() {
        this.isBatchable = false;
        this.context = null;
        if (this.graphicsData) {
            this.graphicsData.destroy();
            this.graphicsData = null;
        }
    }
    /**
   * Destroy the cached data.
   * @advanced
   */ destroy() {
        this.reset();
    }
}
class $e0ffdacb44a3e41f$var$CanvasGraphicsContextRenderData {
    constructor(){
        /**
     * Instructions for canvas rendering.
     * @advanced
     */ this.instructions = new (0, $dK5Jn.InstructionSet)();
    }
    /**
   * Initialize render data.
   * @advanced
   */ init() {
        this.instructions.reset();
    }
    /**
   * Destroy render data.
   * @advanced
   */ destroy() {
        this.instructions.destroy();
        this.instructions = null;
    }
}
const $e0ffdacb44a3e41f$var$_CanvasGraphicsContextSystem = class _CanvasGraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        const gpuContext = this.getGpuContext(context);
        return gpuContext.graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const gpuData = context._gpuData;
        const hasContext = !!gpuData[this._renderer.uid];
        const gpuContext = gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            gpuContext.isBatchable = false;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        const gpuData = context._gpuData;
        return gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const renderData = new $e0ffdacb44a3e41f$var$CanvasGraphicsContextRenderData();
        const gpuContext = this.getGpuContext(context);
        gpuContext.graphicsData = renderData;
        renderData.init();
        return renderData;
    }
    _initContext(context) {
        const gpuContext = new $e0ffdacb44a3e41f$var$CanvasGraphicsContext();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $e0ffdacb44a3e41f$var$_CanvasGraphicsContextSystem.extension = {
    type: [
        (0, $i9BKe.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $e0ffdacb44a3e41f$var$_CanvasGraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $e0ffdacb44a3e41f$export$ecb840d1abeff74b = $e0ffdacb44a3e41f$var$_CanvasGraphicsContextSystem;

});

parcelRegister("ajBJN", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsPipe", () => $4d61da8374115e9c$export$26ad1716c6143fba);

var $i9BKe = parcelRequire("i9BKe");

var $2Aebl = parcelRequire("2Aebl");

var $1DS3C = parcelRequire("1DS3C");
"use strict";
class $4d61da8374115e9c$export$26ad1716c6143fba {
    constructor(renderer, adaptor){
        this.state = (0, $2Aebl.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(_graphics) {
        return false;
    }
    addRenderable(graphics, instructionSet) {
        this._managedGraphics.add(graphics);
        this.renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(graphics);
    }
    updateRenderable(_graphics) {}
    execute(graphics) {
        if (!graphics.isRenderable) return;
        this._adaptor.execute(this, graphics);
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
    }
}
/** @ignore */ $4d61da8374115e9c$export$26ad1716c6143fba.extension = {
    type: [
        (0, $i9BKe.ExtensionType).CanvasPipes
    ],
    name: "graphics"
};

});

parcelRegister("3Ey0f", function(module, exports) {

$parcel$export(module.exports, "GraphicsPipe", () => $41b59a27ea0e0c59$export$56171ef5563dc803);

var $i9BKe = parcelRequire("i9BKe");

var $2Aebl = parcelRequire("2Aebl");

var $1DS3C = parcelRequire("1DS3C");

var $61KiY = parcelRequire("61KiY");

var $6B0gZ = parcelRequire("6B0gZ");

var $xZ5a3 = parcelRequire("xZ5a3");
"use strict";
class $41b59a27ea0e0c59$export$2a885cf99f131046 {
    constructor(){
        this.batches = [];
        this.batched = false;
    }
    destroy() {
        this.batches.forEach((batch)=>{
            (0, $61KiY.BigPool).return(batch);
        });
        this.batches.length = 0;
    }
}
class $41b59a27ea0e0c59$export$56171ef5563dc803 {
    constructor(renderer, adaptor){
        this.state = (0, $2Aebl.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(graphics) {
        const context = graphics.context;
        const wasBatched = !!graphics._gpuData;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(context);
        if (gpuContext.isBatchable || wasBatched !== gpuContext.isBatchable) return true;
        return false;
    }
    addRenderable(graphics, instructionSet) {
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        if (graphics.didViewUpdate) this._rebuild(graphics);
        if (gpuContext.isBatchable) this._addToBatcher(graphics, instructionSet);
        else {
            this.renderer.renderPipes.batch.break(instructionSet);
            instructionSet.add(graphics);
        }
    }
    updateRenderable(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const batches = gpuData.batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batch._batcher.updateElement(batch);
        }
    }
    execute(graphics) {
        if (!graphics.isRenderable) return;
        const renderer = this.renderer;
        const context = graphics.context;
        const contextSystem = renderer.graphicsContext;
        if (!contextSystem.getGpuContext(context).batches.length) return;
        const shader = context.customShader || this._adaptor.shader;
        this.state.blendMode = graphics.groupBlendMode;
        const localUniforms = shader.resources.localUniforms.uniforms;
        localUniforms.uTransformMatrix = graphics.groupTransform;
        localUniforms.uRound = renderer._roundPixels | graphics._roundPixels;
        (0, $6B0gZ.color32BitToUniform)(graphics.groupColorAlpha, localUniforms.uColor, 0);
        this._adaptor.execute(this, graphics);
    }
    _rebuild(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        gpuData.destroy();
        if (gpuContext.isBatchable) this._updateBatchesForRenderable(graphics, gpuData);
    }
    _addToBatcher(graphics, instructionSet) {
        const batchPipe = this.renderer.renderPipes.batch;
        const batches = this._getGpuDataForRenderable(graphics).batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batchPipe.addToBatch(batch, instructionSet);
        }
    }
    _getGpuDataForRenderable(graphics) {
        return graphics._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(graphics);
    }
    _initGpuDataForRenderable(graphics) {
        const gpuData = new $41b59a27ea0e0c59$export$2a885cf99f131046();
        graphics._gpuData[this.renderer.uid] = gpuData;
        this._managedGraphics.add(graphics);
        return gpuData;
    }
    _updateBatchesForRenderable(graphics, gpuData) {
        const context = graphics.context;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.getGpuContext(context);
        const roundPixels = this.renderer._roundPixels | graphics._roundPixels;
        gpuData.batches = gpuContext.batches.map((batch)=>{
            const batchClone = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
            batch.copyTo(batchClone);
            batchClone.renderable = graphics;
            batchClone.roundPixels = roundPixels;
            return batchClone;
        });
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
        this.state = null;
    }
}
/** @ignore */ $41b59a27ea0e0c59$export$56171ef5563dc803.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLPipes,
        (0, $i9BKe.ExtensionType).WebGPUPipes
    ],
    name: "graphics"
};

});



parcelRegister("6qNFd", function(module, exports) {

$parcel$export(module.exports, "BatchableSprite", () => $745046e2c487719c$export$fe4bdc7069ee0b9c);
"use strict";
class $745046e2c487719c$export$fe4bdc7069ee0b9c {
    constructor(){
        this.batcherName = "default";
        this.topology = "triangle-list";
        // batch specific..
        this.attributeSize = 4;
        this.indexSize = 6;
        this.packAsQuad = true;
        this.roundPixels = 0;
        this._attributeStart = 0;
        // location in the buffer
        this._batcher = null;
        this._batch = null;
    }
    get blendMode() {
        return this.renderable.groupBlendMode;
    }
    get color() {
        return this.renderable.groupColorAlpha;
    }
    reset() {
        this.renderable = null;
        this.texture = null;
        this._batcher = null;
        this._batch = null;
        this.bounds = null;
    }
    destroy() {
        this.reset();
    }
}

});

parcelRegister("wLFHs", function(module, exports) {

$parcel$export(module.exports, "CanvasTextMetrics", () => $3648baf7179c08cc$export$b12f6bdc825d944f);

var $edP2D = parcelRequire("edP2D");

var $iCGeI = parcelRequire("iCGeI");

var $fKQfr = parcelRequire("fKQfr");

var $ab7uj = parcelRequire("ab7uj");

var $fkIsr = parcelRequire("fkIsr");

var $9dqAM = parcelRequire("9dqAM");
"use strict";
const $3648baf7179c08cc$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $3648baf7179c08cc$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see CanvasTextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result === void 0) {
            const proto = (0, $iCGeI.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param fontProperties - the font properties object from TextMetrics.measureFont
   * @param taggedData - optional object containing tagged text specific data
   * @param taggedData.runsByLine - per-line style runs for tagged text
   * @param taggedData.lineAscents - per-line ascent values for tagged text
   * @param taggedData.lineDescents - per-line descent values for tagged text
   * @param taggedData.lineHeights - per-line height values for tagged text
   * @param taggedData.hasDropShadow - whether any run has a drop shadow
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties, taggedData){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
        if (taggedData) {
            this.runsByLine = taggedData.runsByLine;
            this.lineAscents = taggedData.lineAscents;
            this.lineDescents = taggedData.lineDescents;
            this.lineHeights = taggedData.lineHeights;
            this.hasDropShadow = taggedData.hasDropShadow;
        }
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap2 = style.wordWrap) {
        const textKey = `${text}-${style.styleKey}-wordWrap-${wordWrap2}`;
        if (_CanvasTextMetrics._measurementCache.has(textKey)) return _CanvasTextMetrics._measurementCache.get(textKey);
        const isTagged = (0, $ab7uj.hasTagStyles)(style) && (0, $ab7uj.hasTagMarkup)(text);
        if (isTagged) {
            const result = (0, $fKQfr.measureTaggedText)(text, style, wordWrap2, _CanvasTextMetrics._context, _CanvasTextMetrics._measureText, _CanvasTextMetrics.measureFont, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
            const measurements2 = new _CanvasTextMetrics(text, style, result.width, result.height, result.lines, result.lineWidths, result.lineHeight, result.maxLineWidth, result.fontProperties, {
                runsByLine: result.runsByLine,
                lineAscents: result.lineAscents,
                lineDescents: result.lineDescents,
                lineHeights: result.lineHeights,
                hasDropShadow: result.hasDropShadow
            });
            _CanvasTextMetrics._measurementCache.set(textKey, measurements2);
            return measurements2;
        }
        const font = style._fontString;
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
            fontProperties.descent = 0;
        }
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const outputText = wordWrap2 ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split((0, $fkIsr.NEWLINE_MATCH_REGEX));
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width ?? 0;
        const lineHeight = style.lineHeight || fontProperties.fontSize;
        const baseWidth = _CanvasTextMetrics._getAlignWidth(maxLineWidth, style, wordWrap2);
        const width = _CanvasTextMetrics._adjustWidthForStyle(baseWidth, style);
        const baseHeight = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
        const height = _CanvasTextMetrics._adjustHeightForStyle(baseHeight, style);
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        _CanvasTextMetrics._measurementCache.set(textKey, measurements);
        return measurements;
    }
    /**
   * Adjusts the measured width to account for stroke and drop shadow.
   * @param baseWidth - The base content width
   * @param style - The text style
   * @returns The adjusted width
   */ static _adjustWidthForStyle(baseWidth, style) {
        const strokeWidth = style._stroke?.width || 0;
        let width = baseWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        return width;
    }
    /**
   * Adjusts the measured height to account for drop shadow.
   * @param baseHeight - The base content height
   * @param style - The text style
   * @returns The adjusted height
   */ static _adjustHeightForStyle(baseHeight, style) {
        let height = baseHeight;
        if (style.dropShadow) height += style.dropShadow.distance;
        return height;
    }
    /**
   * Calculates the base width for alignment purposes.
   * When word wrap is enabled with center/right alignment, uses wordWrapWidth.
   * @param maxLineWidth - The maximum line width
   * @param style - The text style
   * @param wordWrapEnabled - Whether word wrap is enabled
   * @returns The width to use for alignment calculations
   */ static _getAlignWidth(maxLineWidth, style, wordWrapEnabled) {
        const useWrapWidth = wordWrapEnabled && style.align !== "left";
        return useWrapWidth ? Math.max(maxLineWidth, style.wordWrapWidth) : maxLineWidth;
    }
    /**
   * Measures the rendered width of a string, accounting for letter spacing and using the provided context.
   * @param text - The text to measure
   * @param letterSpacing - Letter spacing in pixels
   * @param context - Canvas 2D context
   * @returns The measured width of the text with spacing
   * @internal
   */ static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        const metrics = context.measureText(text);
        let metricWidth = metrics.width;
        const actualBoundingBoxLeft = -(metrics.actualBoundingBoxLeft ?? 0);
        const actualBoundingBoxRight = metrics.actualBoundingBoxRight ?? 0;
        let boundsWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
        if (metricWidth > 0) {
            if (useExperimentalLetterSpacing) {
                metricWidth -= letterSpacing;
                boundsWidth -= letterSpacing;
            } else {
                const val = (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
                metricWidth += val;
                boundsWidth += val;
            }
        }
        return Math.max(metricWidth, boundsWidth);
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        return (0, $9dqAM.wordWrap)(text, style, canvas, _CanvasTextMetrics._measureText, _CanvasTextMetrics.canBreakWords, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return (0, $fkIsr.isBreakingSpace)(char, _nextChar);
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const ascent = metrics.actualBoundingBoxAscent ?? 0;
        const descent = metrics.actualBoundingBoxDescent ?? 0;
        const properties = {
            ascent: ascent,
            descent: descent,
            fontSize: ascent + descent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $3648baf7179c08cc$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            } catch (_cx) {
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $3648baf7179c08cc$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.METRICS_STRING = "|\xC9q\xC5";
/** Baseline symbol for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>{
            const segments = segmenter.segment(s);
            const result = [];
            let i = 0;
            for (const segment of segments)result[i++] = segment.segment;
            return result;
        };
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see CanvasTextMetrics.experimentalLetterSpacingSupported
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@link TextMetrics.FontMetrics} objects. */ $3648baf7179c08cc$var$_CanvasTextMetrics._fonts = {};
/** Cache for measured text metrics */ $3648baf7179c08cc$var$_CanvasTextMetrics._measurementCache = (0, $edP2D.lru)(1e3);
let $3648baf7179c08cc$export$b12f6bdc825d944f = $3648baf7179c08cc$var$_CanvasTextMetrics;

});
parcelRegister("edP2D", function(module, exports) {

$parcel$export(module.exports, "lru", () => $31ac0cf4d61f3c71$export$64e09406e6c5de88, (v) => $31ac0cf4d61f3c71$export$64e09406e6c5de88 = v);
/**
 * tiny-lru
 *
 * @copyright 2026 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 11.4.7
 */ var $31ac0cf4d61f3c71$export$ca3ab3d175dec122;
var $31ac0cf4d61f3c71$export$64e09406e6c5de88;
'use strict';
/**
 * A high-performance Least Recently Used (LRU) cache implementation with optional TTL support.
 * Items are automatically evicted when the cache reaches its maximum size,
 * removing the least recently used items first. All core operations (get, set, delete) are O(1).
 *
 * @class LRU
 * @example
 * // Create a cache with max 100 items
 * const cache = new LRU(100);
 * cache.set('key1', 'value1');
 * console.log(cache.get('key1')); // 'value1'
 *
 * @example
 * // Create a cache with TTL
 * const cache = new LRU(100, 5000); // 5 second TTL
 * cache.set('key1', 'value1');
 * // After 5 seconds, key1 will be expired
 */ class $31ac0cf4d61f3c71$var$LRU {
    /**
	 * Creates a new LRU cache instance.
	 * Note: Constructor does not validate parameters. Use lru() factory function for parameter validation.
	 *
	 * @constructor
	 * @param {number} [max=0] - Maximum number of items to store. 0 means unlimited.
	 * @param {number} [ttl=0] - Time to live in milliseconds. 0 means no expiration.
	 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
	 * @example
	 * const cache = new LRU(1000, 60000, true); // 1000 items, 1 minute TTL, reset on access
	 * @see {@link lru} For parameter validation
	 * @since 1.0.0
	 */ constructor(max = 0, ttl = 0, resetTtl = false){
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.max = max;
        this.resetTtl = resetTtl;
        this.size = 0;
        this.ttl = ttl;
    }
    /**
	 * Removes all items from the cache.
	 *
	 * @method clear
	 * @memberof LRU
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.clear();
	 * console.log(cache.size); // 0
	 * @since 1.0.0
	 */ clear() {
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.size = 0;
        return this;
    }
    /**
	 * Removes an item from the cache by key.
	 *
	 * @method delete
	 * @memberof LRU
	 * @param {string} key - The key of the item to delete.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1');
	 * cache.delete('key1');
	 * console.log(cache.has('key1')); // false
	 * @see {@link LRU#has}
	 * @see {@link LRU#clear}
	 * @since 1.0.0
	 */ delete(key) {
        if (this.has(key)) {
            const item = this.items[key];
            delete this.items[key];
            this.size--;
            if (item.prev !== null) item.prev.next = item.next;
            if (item.next !== null) item.next.prev = item.prev;
            if (this.first === item) this.first = item.next;
            if (this.last === item) this.last = item.prev;
        }
        return this;
    }
    /**
	 * Returns an array of [key, value] pairs for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method entries
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get entries for. Defaults to all keys.
	 * @returns {Array<Array<*>>} Array of [key, value] pairs in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.entries()); // [['a', 1], ['b', 2]]
	 * console.log(cache.entries(['a'])); // [['a', 1]]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#values}
	 * @since 11.1.0
	 */ entries(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            result[i] = [
                key,
                this.get(key)
            ];
        }
        return result;
    }
    /**
	 * Removes the least recently used item from the cache.
	 *
	 * @method evict
	 * @memberof LRU
	 * @param {boolean} [bypass=false] - Whether to force eviction even when cache is empty.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('old', 'value').set('new', 'value');
	 * cache.evict(); // Removes 'old' item
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ evict(bypass = false) {
        if (bypass || this.size > 0) {
            const item = this.first;
            delete this.items[item.key];
            if (--this.size === 0) {
                this.first = null;
                this.last = null;
            } else {
                this.first = item.next;
                this.first.prev = null;
            }
        }
        return this;
    }
    /**
	 * Returns the expiration timestamp for a given key.
	 *
	 * @method expiresAt
	 * @memberof LRU
	 * @param {string} key - The key to check expiration for.
	 * @returns {number|undefined} The expiration timestamp in milliseconds, or undefined if key doesn't exist.
	 * @example
	 * const cache = new LRU(100, 5000); // 5 second TTL
	 * cache.set('key1', 'value1');
	 * console.log(cache.expiresAt('key1')); // timestamp 5 seconds from now
	 * @see {@link LRU#get}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ expiresAt(key) {
        let result;
        if (this.has(key)) result = this.items[key].expiry;
        return result;
    }
    /**
	 * Retrieves a value from the cache by key. Updates the item's position to most recently used.
	 *
	 * @method get
	 * @memberof LRU
	 * @param {string} key - The key to retrieve.
	 * @returns {*} The value associated with the key, or undefined if not found or expired.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.get('key1')); // 'value1'
	 * console.log(cache.get('nonexistent')); // undefined
	 * @see {@link LRU#set}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ get(key) {
        const item = this.items[key];
        if (item !== undefined) {
            // Check TTL only if enabled to avoid unnecessary Date.now() calls
            if (this.ttl > 0) {
                if (item.expiry <= Date.now()) {
                    this.delete(key);
                    return undefined;
                }
            }
            // Fast LRU update without full set() overhead
            this.moveToEnd(item);
            return item.value;
        }
        return undefined;
    }
    /**
	 * Checks if a key exists in the cache.
	 *
	 * @method has
	 * @memberof LRU
	 * @param {string} key - The key to check for.
	 * @returns {boolean} True if the key exists, false otherwise.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.has('key1')); // true
	 * console.log(cache.has('nonexistent')); // false
	 * @see {@link LRU#get}
	 * @see {@link LRU#delete}
	 * @since 9.0.0
	 */ has(key) {
        return key in this.items;
    }
    /**
	 * Efficiently moves an item to the end of the LRU list (most recently used position).
	 * This is an internal optimization method that avoids the overhead of the full set() operation
	 * when only LRU position needs to be updated.
	 *
	 * @method moveToEnd
	 * @memberof LRU
	 * @param {Object} item - The cache item with prev/next pointers to reposition.
	 * @private
	 * @since 11.3.5
	 */ moveToEnd(item) {
        // If already at the end, nothing to do
        if (this.last === item) return;
        // Remove item from current position in the list
        if (item.prev !== null) item.prev.next = item.next;
        if (item.next !== null) item.next.prev = item.prev;
        // Update first pointer if this was the first item
        if (this.first === item) this.first = item.next;
        // Add item to the end
        item.prev = this.last;
        item.next = null;
        if (this.last !== null) this.last.next = item;
        this.last = item;
        // Handle edge case: if this was the only item, it's also first
        if (this.first === null) this.first = item;
    }
    /**
	 * Returns an array of all keys in the cache, ordered from least to most recently used.
	 *
	 * @method keys
	 * @memberof LRU
	 * @returns {string[]} Array of keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * cache.get('a'); // Move 'a' to most recent
	 * console.log(cache.keys()); // ['b', 'a']
	 * @see {@link LRU#values}
	 * @see {@link LRU#entries}
	 * @since 9.0.0
	 */ keys() {
        const result = new Array(this.size);
        let x = this.first;
        let i = 0;
        while(x !== null){
            result[i++] = x.key;
            x = x.next;
        }
        return result;
    }
    /**
	 * Sets a value in the cache and returns any evicted item.
	 *
	 * @method setWithEvicted
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {Object|null} The evicted item (if any) with shape {key, value, expiry, prev, next}, or null.
	 * @example
	 * const cache = new LRU(2);
	 * cache.set('a', 1).set('b', 2);
	 * const evicted = cache.setWithEvicted('c', 3); // evicted = {key: 'a', value: 1, ...}
	 * @see {@link LRU#set}
	 * @see {@link LRU#evict}
	 * @since 11.3.0
	 */ setWithEvicted(key, value, resetTtl = this.resetTtl) {
        let evicted = null;
        if (this.has(key)) this.set(key, value, true, resetTtl);
        else {
            if (this.max > 0 && this.size === this.max) {
                evicted = {
                    ...this.first
                };
                this.evict(true);
            }
            let item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return evicted;
    }
    /**
	 * Sets a value in the cache. Updates the item's position to most recently used.
	 *
	 * @method set
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [bypass=false] - Internal parameter for setWithEvicted method.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1')
	 *      .set('key2', 'value2')
	 *      .set('key3', 'value3');
	 * @see {@link LRU#get}
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ set(key, value, bypass = false, resetTtl = this.resetTtl) {
        let item = this.items[key];
        if (bypass || item !== undefined) {
            // Existing item: update value and position
            item.value = value;
            if (bypass === false && resetTtl) item.expiry = this.ttl > 0 ? Date.now() + this.ttl : this.ttl;
            // Always move to end, but the bypass parameter affects TTL reset behavior
            this.moveToEnd(item);
        } else {
            // New item: check for eviction and create
            if (this.max > 0 && this.size === this.max) this.evict(true);
            item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return this;
    }
    /**
	 * Returns an array of all values in the cache for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method values
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get values for. Defaults to all keys.
	 * @returns {Array<*>} Array of values corresponding to the keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.values()); // [1, 2]
	 * console.log(cache.values(['a'])); // [1]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#entries}
	 * @since 11.1.0
	 */ values(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++)result[i] = this.get(keys[i]);
        return result;
    }
}
/**
 * Factory function to create a new LRU cache instance with parameter validation.
 *
 * @function lru
 * @param {number} [max=1000] - Maximum number of items to store. Must be >= 0. Use 0 for unlimited size.
 * @param {number} [ttl=0] - Time to live in milliseconds. Must be >= 0. Use 0 for no expiration.
 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
 * @returns {LRU} A new LRU cache instance.
 * @throws {TypeError} When parameters are invalid (negative numbers or wrong types).
 * @example
 * // Create cache with factory function
 * const cache = lru(100, 5000, true);
 * cache.set('key', 'value');
 *
 * @example
 * // Error handling
 * try {
 *   const cache = lru(-1); // Invalid max
 * } catch (error) {
 *   console.error(error.message); // "Invalid max value"
 * }
 * @see {@link LRU}
 * @since 1.0.0
 */ function $31ac0cf4d61f3c71$var$lru(max = 1000, ttl = 0, resetTtl = false) {
    if (isNaN(max) || max < 0) throw new TypeError("Invalid max value");
    if (isNaN(ttl) || ttl < 0) throw new TypeError("Invalid ttl value");
    if (typeof resetTtl !== "boolean") throw new TypeError("Invalid resetTtl value");
    return new $31ac0cf4d61f3c71$var$LRU(max, ttl, resetTtl);
}
$31ac0cf4d61f3c71$export$ca3ab3d175dec122 = $31ac0cf4d61f3c71$var$LRU;
$31ac0cf4d61f3c71$export$64e09406e6c5de88 = $31ac0cf4d61f3c71$var$lru;

});

parcelRegister("fKQfr", function(module, exports) {

$parcel$export(module.exports, "measureTaggedText", () => $068d2e48fb55ade5$export$2c4cb70a2097cfee);

var $ab7uj = parcelRequire("ab7uj");

var $fkIsr = parcelRequire("fkIsr");
"use strict";
const $068d2e48fb55ade5$var$NEWLINE_TO_SPACE_REGEX = /\r\n|\r|\n/g;
function $068d2e48fb55ade5$export$2c4cb70a2097cfee(text, style, wordWrap, context, measureTextFn, measureFontFn, canBreakCharsFn, wordWrapSplitFn) {
    const runs = (0, $ab7uj.parseTaggedText)(text, style);
    const shouldCollapseNewlines = (0, $fkIsr.collapseNewlines)(style.whiteSpace);
    if (shouldCollapseNewlines) for(let i = 0; i < runs.length; i++){
        const run = runs[i];
        runs[i] = {
            text: run.text.replace($068d2e48fb55ade5$var$NEWLINE_TO_SPACE_REGEX, " "),
            style: run.style
        };
    }
    const runsByLine = [];
    let currentLineRuns = [];
    for (const run of runs){
        const parts = run.text.split((0, $fkIsr.NEWLINE_SPLIT_REGEX));
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            if (part === "\r\n" || part === "\r" || part === "\n") {
                runsByLine.push(currentLineRuns);
                currentLineRuns = [];
            } else if (part.length > 0) currentLineRuns.push({
                text: part,
                style: run.style
            });
        }
    }
    if (currentLineRuns.length > 0 || runsByLine.length === 0) runsByLine.push(currentLineRuns);
    const wrappedRunsByLine = wordWrap ? $068d2e48fb55ade5$export$e01e4e8f2c8b304b(runsByLine, style, context, measureTextFn, canBreakCharsFn, wordWrapSplitFn) : runsByLine;
    const lineWidths = [];
    const lineAscents = [];
    const lineDescents = [];
    const lineHeightsArr = [];
    const lines = [];
    let maxLineWidth = 0;
    const baseFont = style._fontString;
    const baseFontProps = measureFontFn(baseFont);
    if (baseFontProps.fontSize === 0) {
        baseFontProps.fontSize = style.fontSize;
        baseFontProps.ascent = style.fontSize;
    }
    let lastFont = "";
    let hasDropShadow = !!style.dropShadow;
    let maxRunStrokeWidth = style._stroke?.width || 0;
    for (const lineRuns of wrappedRunsByLine){
        let lineWidth = 0;
        let lineAscent = baseFontProps.ascent;
        let lineDescent = baseFontProps.descent;
        let lineText = "";
        for (const run of lineRuns){
            const runFont = run.style._fontString;
            const runFontProps = measureFontFn(runFont);
            if (runFont !== lastFont) {
                context.font = runFont;
                lastFont = runFont;
            }
            const runWidth = measureTextFn(run.text, run.style.letterSpacing, context);
            lineWidth += runWidth;
            lineAscent = Math.max(lineAscent, runFontProps.ascent);
            lineDescent = Math.max(lineDescent, runFontProps.descent);
            lineText += run.text;
            const runStrokeWidth = run.style._stroke?.width || 0;
            if (runStrokeWidth > maxRunStrokeWidth) maxRunStrokeWidth = runStrokeWidth;
            if (!hasDropShadow && run.style.dropShadow) hasDropShadow = true;
        }
        if (lineRuns.length === 0) {
            lineAscent = baseFontProps.ascent;
            lineDescent = baseFontProps.descent;
        }
        lineWidths.push(lineWidth);
        lineAscents.push(lineAscent);
        lineDescents.push(lineDescent);
        lines.push(lineText);
        const computedLineHeight = style.lineHeight || lineAscent + lineDescent;
        lineHeightsArr.push(computedLineHeight + style.leading);
        maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }
    const strokeWidth = maxRunStrokeWidth;
    const useWrapWidth = wordWrap && style.align !== "left";
    const alignWidth = useWrapWidth ? Math.max(maxLineWidth, style.wordWrapWidth) : maxLineWidth;
    const width = alignWidth + strokeWidth + (style.dropShadow ? style.dropShadow.distance : 0);
    let baseHeight = 0;
    for(let i = 0; i < lineHeightsArr.length; i++)baseHeight += lineHeightsArr[i];
    baseHeight = Math.max(baseHeight, lineHeightsArr[0] + strokeWidth);
    const height = baseHeight + (style.dropShadow ? style.dropShadow.distance : 0);
    const baseLineHeight = style.lineHeight || baseFontProps.fontSize;
    return {
        width: width,
        height: height,
        lines: lines,
        lineWidths: lineWidths,
        lineHeight: baseLineHeight + style.leading,
        maxLineWidth: maxLineWidth,
        fontProperties: baseFontProps,
        runsByLine: wrappedRunsByLine,
        lineAscents: lineAscents,
        lineDescents: lineDescents,
        lineHeights: lineHeightsArr,
        hasDropShadow: hasDropShadow
    };
}
function $068d2e48fb55ade5$export$e01e4e8f2c8b304b(runsByLine, style, context, measureTextFn, canBreakCharsFn, wordWrapSplitFn) {
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace, wordWrapWidth: wordWrapWidth, breakWords: breakWords } = style;
    const shouldCollapseSpaces = (0, $fkIsr.collapseSpaces)(whiteSpace);
    const adjustedWrapWidth = wordWrapWidth + letterSpacing;
    const tokenWidthCache = {};
    let lastFont = "";
    const measureTokenWidth = (token, tokenStyle)=>{
        const cacheKey = `${token}|${tokenStyle.styleKey}`;
        let width = tokenWidthCache[cacheKey];
        if (width === void 0) {
            const font = tokenStyle._fontString;
            if (font !== lastFont) {
                context.font = font;
                lastFont = font;
            }
            width = measureTextFn(token, tokenStyle.letterSpacing, context) + tokenStyle.letterSpacing;
            tokenWidthCache[cacheKey] = width;
        }
        return width;
    };
    const result = [];
    for (const lineRuns of runsByLine){
        const styledTokens = $068d2e48fb55ade5$export$7d01d70c6417df50(lineRuns);
        const resultStartLength = result.length;
        const getWordGroupWidth = (startIndex)=>{
            let totalWidth = 0;
            let j = startIndex;
            do {
                const { token: groupToken, style: groupStyle } = styledTokens[j];
                totalWidth += measureTokenWidth(groupToken, groupStyle);
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return totalWidth;
        };
        const getWordGroupTokens = (startIndex)=>{
            const tokens = [];
            let j = startIndex;
            do {
                tokens.push({
                    token: styledTokens[j].token,
                    style: styledTokens[j].style
                });
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return tokens;
        };
        let currentLineRuns = [];
        let currentWidth = 0;
        let canPrependSpaces = !shouldCollapseSpaces;
        let buildingRun = null;
        const flushBuildingRun = ()=>{
            if (buildingRun && buildingRun.text.length > 0) currentLineRuns.push(buildingRun);
            buildingRun = null;
        };
        const startNewLine = ()=>{
            flushBuildingRun();
            if (currentLineRuns.length > 0) {
                const lastRun = currentLineRuns[currentLineRuns.length - 1];
                lastRun.text = (0, $fkIsr.trimRight)(lastRun.text);
                if (lastRun.text.length === 0) currentLineRuns.pop();
            }
            result.push(currentLineRuns);
            currentLineRuns = [];
            currentWidth = 0;
            canPrependSpaces = false;
        };
        for(let i = 0; i < styledTokens.length; i++){
            const { token: token, style: tokenStyle, continuesFromPrevious: continuesFromPrevious } = styledTokens[i];
            const tokenWidth = measureTokenWidth(token, tokenStyle);
            if (shouldCollapseSpaces) {
                const currIsSpace = (0, $fkIsr.isBreakingSpace)(token);
                const lastChar = buildingRun?.text[buildingRun.text.length - 1] ?? currentLineRuns[currentLineRuns.length - 1]?.text.slice(-1) ?? "";
                const lastIsSpace = lastChar ? (0, $fkIsr.isBreakingSpace)(lastChar) : false;
                if (currIsSpace && lastIsSpace) continue;
            }
            const startsWordGroup = !continuesFromPrevious;
            const wordGroupWidth = startsWordGroup ? getWordGroupWidth(i) : tokenWidth;
            if (wordGroupWidth > adjustedWrapWidth && startsWordGroup) {
                if (currentWidth > 0) startNewLine();
                if (breakWords) {
                    const wordGroupTokens = getWordGroupTokens(i);
                    for(let g = 0; g < wordGroupTokens.length; g++){
                        const groupToken = wordGroupTokens[g].token;
                        const groupStyle = wordGroupTokens[g].style;
                        const charGroups = (0, $fkIsr.getCharacterGroups)(groupToken, breakWords, wordWrapSplitFn, canBreakCharsFn);
                        for (const char of charGroups){
                            const charWidth = measureTokenWidth(char, groupStyle);
                            if (charWidth + currentWidth > adjustedWrapWidth) startNewLine();
                            if (!buildingRun || buildingRun.style !== groupStyle) {
                                flushBuildingRun();
                                buildingRun = {
                                    text: char,
                                    style: groupStyle
                                };
                            } else buildingRun.text += char;
                            currentWidth += charWidth;
                        }
                    }
                    i += wordGroupTokens.length - 1;
                } else {
                    const wordGroupTokens = getWordGroupTokens(i);
                    flushBuildingRun();
                    result.push(wordGroupTokens.map((t)=>({
                            text: t.token,
                            style: t.style
                        })));
                    canPrependSpaces = false;
                    i += wordGroupTokens.length - 1;
                }
            } else if (wordGroupWidth + currentWidth > adjustedWrapWidth && startsWordGroup) {
                if ((0, $fkIsr.isBreakingSpace)(token)) {
                    canPrependSpaces = false;
                    continue;
                }
                startNewLine();
                buildingRun = {
                    text: token,
                    style: tokenStyle
                };
                currentWidth = tokenWidth;
            } else if (continuesFromPrevious && !breakWords) {
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            } else {
                const isSpace = (0, $fkIsr.isBreakingSpace)(token);
                if (currentWidth === 0 && isSpace && !canPrependSpaces) continue;
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            }
        }
        flushBuildingRun();
        if (currentLineRuns.length > 0) {
            const lastRun = currentLineRuns[currentLineRuns.length - 1];
            lastRun.text = (0, $fkIsr.trimRight)(lastRun.text);
            if (lastRun.text.length === 0) currentLineRuns.pop();
        }
        if (currentLineRuns.length > 0 || result.length === resultStartLength) result.push(currentLineRuns);
    }
    return result;
}
function $068d2e48fb55ade5$export$7d01d70c6417df50(runs) {
    const styledTokens = [];
    let lastTokenWasWord = false;
    for (const run of runs){
        const tokens = (0, $fkIsr.tokenize)(run.text);
        let isFirstTokenInRun = true;
        for (const token of tokens){
            const isSpace = (0, $fkIsr.isBreakingSpace)(token) || (0, $fkIsr.isNewline)(token);
            const continuesFromPrevious = isFirstTokenInRun && lastTokenWasWord && !isSpace;
            styledTokens.push({
                token: token,
                style: run.style,
                continuesFromPrevious: continuesFromPrevious
            });
            lastTokenWasWord = !isSpace;
            isFirstTokenInRun = false;
        }
    }
    return styledTokens;
}

});
parcelRegister("ab7uj", function(module, exports) {

$parcel$export(module.exports, "hasTagStyles", () => $0dd8f3d4377e0e05$export$3c634ede7db41923);
$parcel$export(module.exports, "hasTagMarkup", () => $0dd8f3d4377e0e05$export$328893c99ad2af02);
$parcel$export(module.exports, "parseTaggedText", () => $0dd8f3d4377e0e05$export$9657ef3c3357e745);
"use strict";
function $0dd8f3d4377e0e05$export$3c634ede7db41923(style) {
    return !!style.tagStyles && Object.keys(style.tagStyles).length > 0;
}
function $0dd8f3d4377e0e05$export$328893c99ad2af02(text) {
    return text.includes("<");
}
function $0dd8f3d4377e0e05$var$createMergedStyle(baseStyle, overrides) {
    return baseStyle.clone().assign(overrides);
}
function $0dd8f3d4377e0e05$export$9657ef3c3357e745(text, style) {
    const runs = [];
    const tagStyles = style.tagStyles;
    if (!$0dd8f3d4377e0e05$export$3c634ede7db41923(style) || !$0dd8f3d4377e0e05$export$328893c99ad2af02(text)) {
        runs.push({
            text: text,
            style: style
        });
        return runs;
    }
    const styleStack = [
        style
    ];
    const tagStack = [];
    let currentText = "";
    let i = 0;
    while(i < text.length){
        const char = text[i];
        if (char === "<") {
            const closeIndex = text.indexOf(">", i);
            if (closeIndex === -1) {
                currentText += char;
                i++;
                continue;
            }
            const tagContent = text.slice(i + 1, closeIndex);
            if (tagContent.startsWith("/")) {
                const closingTagName = tagContent.slice(1).trim();
                if (tagStack.length > 0 && tagStack[tagStack.length - 1] === closingTagName) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    styleStack.pop();
                    tagStack.pop();
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            } else {
                const tagName = tagContent.trim();
                if (tagStyles[tagName]) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    const currentStyle = styleStack[styleStack.length - 1];
                    const mergedStyle = $0dd8f3d4377e0e05$var$createMergedStyle(currentStyle, tagStyles[tagName]);
                    styleStack.push(mergedStyle);
                    tagStack.push(tagName);
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            }
        } else {
            currentText += char;
            i++;
        }
    }
    if (currentText.length > 0) runs.push({
        text: currentText,
        style: styleStack[styleStack.length - 1]
    });
    return runs;
}
function $0dd8f3d4377e0e05$export$1afb3864a65b041b(text, style) {
    if (!$0dd8f3d4377e0e05$export$3c634ede7db41923(style) || !$0dd8f3d4377e0e05$export$328893c99ad2af02(text)) return text;
    const runs = $0dd8f3d4377e0e05$export$9657ef3c3357e745(text, style);
    return runs.map((run)=>run.text).join("");
}

});

parcelRegister("fkIsr", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_SPLIT_REGEX", () => $815f097882a38d65$export$b396c635f7504541);
$parcel$export(module.exports, "NEWLINE_MATCH_REGEX", () => $815f097882a38d65$export$e943b22311785337);
$parcel$export(module.exports, "isNewline", () => $815f097882a38d65$export$c6b40e80adfef3ae);
$parcel$export(module.exports, "isBreakingSpace", () => $815f097882a38d65$export$40e905615472e8e0);
$parcel$export(module.exports, "isCollapsibleSpace", () => $815f097882a38d65$export$a039ab2e304958a3);
$parcel$export(module.exports, "isBreakAfterChar", () => $815f097882a38d65$export$6bde8c60f7bc4d99);
$parcel$export(module.exports, "collapseSpaces", () => $815f097882a38d65$export$7070a8061037f71a);
$parcel$export(module.exports, "collapseNewlines", () => $815f097882a38d65$export$368cf1740b390323);
$parcel$export(module.exports, "trimRight", () => $815f097882a38d65$export$da8e5da96e287379);
$parcel$export(module.exports, "tokenize", () => $815f097882a38d65$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "getCharacterGroups", () => $815f097882a38d65$export$8398461ec76ab549);
"use strict";
const $815f097882a38d65$export$c5622f59bd0a84ab = [
    10,
    // line feed
    13
];
const $815f097882a38d65$export$46828130f2642f37 = new Set($815f097882a38d65$export$c5622f59bd0a84ab);
const $815f097882a38d65$export$82c4cde34833f6b6 = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
const $815f097882a38d65$export$a7210490df44ebce = new Set($815f097882a38d65$export$82c4cde34833f6b6);
const $815f097882a38d65$export$446c7e4d3041897d = [
    9,
    // character tabulation (tab)
    32
];
const $815f097882a38d65$export$dcd7f83d8608ff99 = new Set($815f097882a38d65$export$446c7e4d3041897d);
const $815f097882a38d65$export$980d468e56d3017f = [
    45,
    // hyphen-minus
    8208,
    // unicode hyphen
    8211,
    // en-dash
    8212,
    // em-dash
    173
];
const $815f097882a38d65$export$534c2cd4e4342d6e = new Set($815f097882a38d65$export$980d468e56d3017f);
const $815f097882a38d65$export$b396c635f7504541 = /(\r\n|\r|\n)/;
const $815f097882a38d65$export$e943b22311785337 = /(?:\r\n|\r|\n)/;
function $815f097882a38d65$export$c6b40e80adfef3ae(char) {
    if (typeof char !== "string") return false;
    return $815f097882a38d65$export$46828130f2642f37.has(char.charCodeAt(0));
}
function $815f097882a38d65$export$40e905615472e8e0(char, _nextChar) {
    if (typeof char !== "string") return false;
    return $815f097882a38d65$export$a7210490df44ebce.has(char.charCodeAt(0));
}
function $815f097882a38d65$export$a039ab2e304958a3(char) {
    if (typeof char !== "string") return false;
    return $815f097882a38d65$export$dcd7f83d8608ff99.has(char.charCodeAt(0));
}
function $815f097882a38d65$export$6bde8c60f7bc4d99(char) {
    if (typeof char !== "string") return false;
    return $815f097882a38d65$export$534c2cd4e4342d6e.has(char.charCodeAt(0));
}
function $815f097882a38d65$export$7070a8061037f71a(whiteSpace) {
    return whiteSpace === "normal" || whiteSpace === "pre-line";
}
function $815f097882a38d65$export$368cf1740b390323(whiteSpace) {
    return whiteSpace === "normal";
}
function $815f097882a38d65$export$da8e5da96e287379(text) {
    if (typeof text !== "string") return "";
    let i = text.length - 1;
    while(i >= 0 && $815f097882a38d65$export$40e905615472e8e0(text[i]))i--;
    return i < text.length - 1 ? text.slice(0, i + 1) : text;
}
function $815f097882a38d65$export$660b2ee2d4fb4eff(text) {
    const tokens = [];
    const tokenChars = [];
    if (typeof text !== "string") return tokens;
    for(let i = 0; i < text.length; i++){
        const char = text[i];
        const nextChar = text[i + 1];
        if ($815f097882a38d65$export$40e905615472e8e0(char, nextChar) || $815f097882a38d65$export$c6b40e80adfef3ae(char)) {
            if (tokenChars.length > 0) {
                tokens.push(tokenChars.join(""));
                tokenChars.length = 0;
            }
            if (char === "\r" && nextChar === "\n") {
                tokens.push("\r\n");
                i++;
            } else tokens.push(char);
            continue;
        }
        tokenChars.push(char);
        if ($815f097882a38d65$export$6bde8c60f7bc4d99(char) && nextChar && !$815f097882a38d65$export$40e905615472e8e0(nextChar) && !$815f097882a38d65$export$c6b40e80adfef3ae(nextChar)) {
            tokens.push(tokenChars.join(""));
            tokenChars.length = 0;
        }
    }
    if (tokenChars.length > 0) tokens.push(tokenChars.join(""));
    return tokens;
}
function $815f097882a38d65$export$8398461ec76ab549(token, breakWords, splitFn, canBreakCharsFn) {
    const characters = splitFn(token);
    const groups = [];
    for(let j = 0; j < characters.length; j++){
        let char = characters[j];
        let lastChar = char;
        let k = 1;
        while(characters[j + k]){
            const nextChar = characters[j + k];
            if (!canBreakCharsFn(lastChar, nextChar, token, j, breakWords)) {
                char += nextChar;
                lastChar = nextChar;
                k++;
            } else break;
        }
        j += k - 1;
        groups.push(char);
    }
    return groups;
}

});


parcelRegister("9dqAM", function(module, exports) {

$parcel$export(module.exports, "wordWrap", () => $4de0b3c33d5eb8b2$export$dca3d8ad656c34d2);

var $fkIsr = parcelRequire("fkIsr");
"use strict";
const $4de0b3c33d5eb8b2$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
function $4de0b3c33d5eb8b2$var$getFromCache(key, letterSpacing, cache, context, measureTextFn) {
    let width = cache[key];
    if (typeof width !== "number") {
        width = measureTextFn(key, letterSpacing, context) + letterSpacing;
        cache[key] = width;
    }
    return width;
}
function $4de0b3c33d5eb8b2$export$dca3d8ad656c34d2(text, style, canvas, measureTextFn, canBreakWordsFn, canBreakCharsFn, wordWrapSplitFn) {
    const context = canvas.getContext("2d", $4de0b3c33d5eb8b2$var$contextSettings);
    context.font = style._fontString;
    let width = 0;
    let line = "";
    const linesArray = [];
    const cache = /* @__PURE__ */ Object.create(null);
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
    const shouldCollapseSpaces = (0, $fkIsr.collapseSpaces)(whiteSpace);
    const shouldCollapseNewlines = (0, $fkIsr.collapseNewlines)(whiteSpace);
    let canPrependSpaces = !shouldCollapseSpaces;
    const wordWrapWidth = style.wordWrapWidth + letterSpacing;
    const tokens = (0, $fkIsr.tokenize)(text);
    for(let i = 0; i < tokens.length; i++){
        let token = tokens[i];
        if ((0, $fkIsr.isNewline)(token)) {
            if (!shouldCollapseNewlines) {
                linesArray.push((0, $fkIsr.trimRight)(line));
                canPrependSpaces = !shouldCollapseSpaces;
                line = "";
                width = 0;
                continue;
            }
            token = " ";
        }
        if (shouldCollapseSpaces) {
            const currIsBreakingSpace = (0, $fkIsr.isBreakingSpace)(token);
            const lastIsBreakingSpace = (0, $fkIsr.isBreakingSpace)(line[line.length - 1]);
            if (currIsBreakingSpace && lastIsBreakingSpace) continue;
        }
        const tokenWidth = $4de0b3c33d5eb8b2$var$getFromCache(token, letterSpacing, cache, context, measureTextFn);
        if (tokenWidth > wordWrapWidth) {
            if (line !== "") {
                linesArray.push((0, $fkIsr.trimRight)(line));
                line = "";
                width = 0;
            }
            if (canBreakWordsFn(token, style.breakWords)) {
                const charGroups = (0, $fkIsr.getCharacterGroups)(token, style.breakWords, wordWrapSplitFn, canBreakCharsFn);
                for (const char of charGroups){
                    const characterWidth = $4de0b3c33d5eb8b2$var$getFromCache(char, letterSpacing, cache, context, measureTextFn);
                    if (characterWidth + width > wordWrapWidth) {
                        linesArray.push((0, $fkIsr.trimRight)(line));
                        canPrependSpaces = false;
                        line = "";
                        width = 0;
                    }
                    line += char;
                    width += characterWidth;
                }
            } else {
                if (line.length > 0) {
                    linesArray.push((0, $fkIsr.trimRight)(line));
                    line = "";
                    width = 0;
                }
                linesArray.push((0, $fkIsr.trimRight)(token));
                canPrependSpaces = false;
                line = "";
                width = 0;
            }
        } else {
            if (tokenWidth + width > wordWrapWidth) {
                canPrependSpaces = false;
                linesArray.push((0, $fkIsr.trimRight)(line));
                line = "";
                width = 0;
            }
            if (line.length > 0 || !(0, $fkIsr.isBreakingSpace)(token) || canPrependSpaces) {
                line += token;
                width += tokenWidth;
            }
        }
    }
    const trimmedLine = (0, $fkIsr.trimRight)(line);
    if (trimmedLine.length > 0) linesArray.push(trimmedLine);
    return linesArray.join("\n");
}

});


parcelRegister("fI0NC", function(module, exports) {

$parcel$export(module.exports, "fontStringFromTextStyle", () => $432516f32dcd2061$export$b7b5edb82ac3fc66);
"use strict";
const $432516f32dcd2061$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $432516f32dcd2061$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$432516f32dcd2061$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}

});

parcelRegister("4JkiF", function(module, exports) {

$parcel$export(module.exports, "getCanvasFillStyle", () => $70d03c252755e3f8$export$c31af9427fa8602b);

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
const $70d03c252755e3f8$var$PRECISION = 1e5;
function $70d03c252755e3f8$export$c31af9427fa8602b(fillStyle, context, textMetrics, padding = 0, offsetX = 0, offsetY = 0) {
    if (fillStyle.texture === (0, $bLlTJ.Texture).WHITE && !fillStyle.fill) return (0, $a2eTA.Color).shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
    else if (!fillStyle.fill) {
        const pattern = context.createPattern(fillStyle.texture.source.resource, "repeat");
        const tempMatrix = fillStyle.matrix.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillStyle.texture.source.pixelWidth, fillStyle.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $ktCpi.FillPattern)) {
        const fillPattern = fillStyle.fill;
        const pattern = context.createPattern(fillPattern.texture.source.resource, "repeat");
        const tempMatrix = fillPattern.transform.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillPattern.texture.source.pixelWidth, fillPattern.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $gwwtL.FillGradient)) {
        const fillGradient = fillStyle.fill;
        const isLinear = fillGradient.type === "linear";
        const isLocal = fillGradient.textureSpace === "local";
        let width = 1;
        let height = 1;
        if (isLocal && textMetrics) {
            width = textMetrics.width + padding;
            height = textMetrics.height + padding;
        }
        let gradient;
        let isNearlyVertical = false;
        if (isLinear) {
            const { start: start, end: end } = fillGradient;
            gradient = context.createLinearGradient(start.x * width + offsetX, start.y * height + offsetY, end.x * width + offsetX, end.y * height + offsetY);
            isNearlyVertical = Math.abs(end.x - start.x) < Math.abs((end.y - start.y) * 0.1);
        } else {
            const { center: center, innerRadius: innerRadius, outerCenter: outerCenter, outerRadius: outerRadius } = fillGradient;
            gradient = context.createRadialGradient(center.x * width + offsetX, center.y * height + offsetY, innerRadius * width, outerCenter.x * width + offsetX, outerCenter.y * height + offsetY, outerRadius * width);
        }
        if (isNearlyVertical && isLocal && textMetrics) {
            const ratio = textMetrics.lineHeight / height;
            for(let i = 0; i < textMetrics.lines.length; i++){
                const start = (i * textMetrics.lineHeight + padding / 2) / height;
                fillGradient.colorStops.forEach((stop)=>{
                    let globalStop = start + stop.offset * ratio;
                    globalStop = Math.max(0, Math.min(1, globalStop));
                    gradient.addColorStop(// fix to 5 decimal places to avoid floating point precision issues
                    Math.floor(globalStop * $70d03c252755e3f8$var$PRECISION) / $70d03c252755e3f8$var$PRECISION, (0, $a2eTA.Color).shared.setValue(stop.color).toHex());
                });
            }
        } else fillGradient.colorStops.forEach((stop)=>{
            gradient.addColorStop(stop.offset, (0, $a2eTA.Color).shared.setValue(stop.color).toHex());
        });
        return gradient;
    }
    (0, $hUCK4.warn)("FillStyle not recognised", fillStyle);
    return "red";
}

});

parcelRegister("eKNW7", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $d76c68b7f9f9bbea$export$1df879243bf2e42d);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");

var $8aC7P = parcelRequire("8aC7P");

var $6mQKv = parcelRequire("6mQKv");

var $fI0NC = parcelRequire("fI0NC");
"use strict";
const $d76c68b7f9f9bbea$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(style = {}){
        super();
        /**
     * Unique identifier for the TextStyle class.
     * This is used to track instances and ensure uniqueness.
     * @internal
     */ this.uid = (0, $aGJhg.uid)("textStyle");
        /**
     * Internal tick counter used to track updates and changes.
     * This is incremented whenever the style is modified, allowing for efficient change detection.
     * @internal
     */ this._tick = 0;
        this._cachedFontString = null;
        $d76c68b7f9f9bbea$var$convertV7Tov8Style(style);
        const isTextStyle = style instanceof _TextStyle;
        const existingStyle = style;
        if (isTextStyle) style = existingStyle._toObject();
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this._tagStyles = style.tagStyles ?? void 0;
        this.update();
        this._tick = 0;
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @type {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        if (this._align === value) return;
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        if (this._breakWords === value) return;
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (this._dropShadow === value) return;
        if (value !== null && typeof value === "object") this._dropShadow = this._createProxy({
            ..._TextStyle.defaultDropShadow,
            ...value
        });
        else this._dropShadow = value ? this._createProxy({
            ..._TextStyle.defaultDropShadow
        }) : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (this._fontSize === value) return;
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @type {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value.toLowerCase();
        this.update();
    }
    /**
   * The font variant.
   * @type {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        if (this._fontVariant === value) return;
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        if (this._leading === value) return;
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        if (this._letterSpacing === value) return;
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        if (this._lineHeight === value) return;
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   * > [!NOTE] This will NOT affect the positioning or bounds of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        if (this._padding === value) return;
        this._padding = value;
        this.update();
    }
    /**
   * An optional filter or array of filters to apply to the text, allowing for advanced visual effects.
   * These filters will be applied to the text as it is created, resulting in faster rendering for static text
   * compared to applying the filter directly to the text object (which would be applied at run time).
   * @default null
   */ get filters() {
        return this._filters;
    }
    set filters(value) {
        if (this._filters === value) return;
        this._filters = Object.freeze(value);
        this.update();
    }
    /**
   * Trim transparent borders from the text texture.
   * > [!IMPORTANT] PERFORMANCE WARNING:
   * > This is a costly operation as it requires scanning pixel alpha values.
   * > Avoid using `trim: true` for dynamic text, as it could significantly impact performance.
   */ get trim() {
        return this._trim;
    }
    set trim(value) {
        if (this._trim === value) return;
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        if (this._textBaseline === value) return;
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @type {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        if (this._whiteSpace === value) return;
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        if (this._wordWrap === value) return;
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        if (this._wordWrapWidth === value) return;
        this._wordWrapWidth = value;
        this.update();
    }
    /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        if (this._isFillStyle(value)) this._originalFill = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultFillStyle,
            ...value
        }, ()=>{
            this._fill = (0, $6mQKv.toFillStyle)({
                ...this._originalFill
            }, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        });
        this._fill = (0, $6mQKv.toFillStyle)(value === 0 ? "black" : value, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        if (this._isFillStyle(value)) this._originalStroke = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultStrokeStyle,
            ...value
        }, ()=>{
            this._stroke = (0, $6mQKv.toStrokeStyle)({
                ...this._originalStroke
            }, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        });
        this._stroke = (0, $6mQKv.toStrokeStyle)(value, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    /**
   * Custom styles to apply to specific tags within the text.
   * Allows for rich text formatting using simple tag markup like `<red>text</red>`.
   *
   * Tags are only parsed when this property has entries. If `tagStyles` is undefined,
   * `<` characters in text are treated as literal.
   * @example
   * ```ts
   * const text = new Text({
   *     text: '<red>Red</red>, <blue>Blue</blue>',
   *     style: {
   *         fill: 'white',
   *         tagStyles: {
   *             red: { fill: 'red' },
   *             blue: { fill: 'blue' }
   *         }
   *     }
   * });
   * ```
   */ get tagStyles() {
        return this._tagStyles;
    }
    set tagStyles(value) {
        if (this._tagStyles === value) return;
        this._tagStyles = value ?? void 0;
        this.update();
    }
    update() {
        this._tick++;
        this._cachedFontString = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    /**
   * Assigns partial style options to this TextStyle instance.
   * Uses public setters to ensure proper value transformation.
   * @param values - Partial style options to assign
   * @returns This TextStyle instance for chaining
   */ assign(values) {
        for(const key in values){
            const thisKey = key;
            this[thisKey] = values[key];
        }
        return this;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this.uid}-${this._tick}`;
    }
    /**
   * Returns the CSS font string for this style, cached for performance.
   * @internal
   * @returns CSS font string
   */ get _fontString() {
        if (this._cachedFontString === null) this._cachedFontString = (0, $fI0NC.fontStringFromTextStyle)(this);
        return this._cachedFontString;
    }
    /**
   * Returns an object with the same values as this TextStyle instance.
   * @returns Object with the same values as this TextStyle instance
   * @example
   * ```ts
   * const style = new TextStyle({
   *     fontSize: 24,
   *     fill: 0xff0000,
   *     stroke: { color: 0x0000ff, width: 2 }
   * });
   * const object = style.toObject();
   * console.log(object);
   * // { fontSize: 24, fill: 0xff0000, stroke: { color: 0x0000ff, width: 2 } }
   * ```
   */ _toObject() {
        return {
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this._dropShadow ? {
                ...this._dropShadow
            } : null,
            fill: this._fill ? {
                ...this._fill
            } : void 0,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke ? {
                ...this._stroke
            } : void 0,
            textBaseline: this.textBaseline,
            trim: this.trim,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth,
            filters: this._filters ? [
                ...this._filters
            ] : void 0,
            tagStyles: this._tagStyles ? {
                ...this._tagStyles
            } : void 0
        };
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle(this._toObject());
    }
    /**
   * Returns the final padding for the text style, taking into account any filters applied.
   * Used internally for correct measurements
   * @internal
   * @returns {number} The final padding for the text style.
   */ _getFinalPadding() {
        let filterPadding = 0;
        if (this._filters) for(let i = 0; i < this._filters.length; i++)filterPadding += this._filters[i].padding;
        return Math.max(this._padding, filterPadding);
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroy the text style and its textures
   * textStyle.destroy({ texture: true, textureSource: true });
   * textStyle.destroy(true);
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
    _createProxy(value, cb) {
        return new Proxy(value, {
            set: (target, property, newValue)=>{
                if (target[property] === newValue) return true;
                target[property] = newValue;
                cb?.(property, newValue);
                this.update();
                return true;
            }
        });
    }
    _isFillStyle(value) {
        return (value ?? null) !== null && !((0, $a2eTA.Color).isColorLike(value) || value instanceof (0, $gwwtL.FillGradient) || value instanceof (0, $ktCpi.FillPattern));
    }
};
/**
 * Default drop shadow settings used when enabling drop shadows on text.
 * These values are used as the base configuration when drop shadows are enabled without specific settings.
 * @example
 * ```ts
 * // Customize default settings globally
 * TextStyle.defaultDropShadow.alpha = 0.5;    // 50% opacity for all shadows
 * TextStyle.defaultDropShadow.blur = 2;       // 2px blur for all shadows
 * TextStyle.defaultDropShadow.color = 'blue'; // Blue shadows by default
 * ```
 */ $d76c68b7f9f9bbea$var$_TextStyle.defaultDropShadow = {
    alpha: 1,
    angle: Math.PI / 6,
    blur: 0,
    color: "black",
    distance: 5
};
/**
 * Default text style settings used when creating new text objects.
 * These values serve as the base configuration and can be customized globally.
 * @example
 * ```ts
 * // Customize default text style globally
 * TextStyle.defaultTextStyle.fontSize = 16;
 * TextStyle.defaultTextStyle.fill = 0x333333;
 * TextStyle.defaultTextStyle.fontFamily = ['Arial', 'Helvetica', 'sans-serif'];
 * ```
 */ $d76c68b7f9f9bbea$var$_TextStyle.defaultTextStyle = {
    align: "left",
    breakWords: false,
    dropShadow: null,
    fill: "black",
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    leading: 0,
    letterSpacing: 0,
    lineHeight: 0,
    padding: 0,
    stroke: null,
    textBaseline: "alphabetic",
    trim: false,
    whiteSpace: "pre",
    wordWrap: false,
    wordWrapWidth: 100
};
let $d76c68b7f9f9bbea$export$1df879243bf2e42d = $d76c68b7f9f9bbea$var$_TextStyle;
function $d76c68b7f9f9bbea$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $d76c68b7f9f9bbea$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        let obj = {};
        if ((0, $a2eTA.Color).isColorLike(color)) obj.color = color;
        else if (color instanceof (0, $gwwtL.FillGradient) || color instanceof (0, $ktCpi.FillPattern)) obj.fill = color;
        else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) obj = color;
        else throw new Error("Invalid stroke value.");
        style.stroke = {
            ...obj,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fillGradientStops)) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        if (!Array.isArray(oldStyle.fill) || oldStyle.fill.length === 0) throw new Error("Invalid fill value. Expected an array of colors for gradient fill.");
        if (oldStyle.fill.length !== oldStyle.fillGradientStops.length) (0, $hUCK4.warn)("The number of fill colors must match the number of fill gradient stops.");
        const gradientFill = new (0, $gwwtL.FillGradient)({
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 1
            },
            textureSpace: "local"
        });
        const fillGradientStops = oldStyle.fillGradientStops.slice();
        const fills = oldStyle.fill.map((color)=>(0, $a2eTA.Color).shared.setValue(color).toNumber());
        fillGradientStops.forEach((stop, index)=>{
            gradientFill.addColorStop(stop, fills[index]);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}

});


var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $c220e1d99a2da004$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("8rEJm"));
    }
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("eOPp4"));
    }
};



var $i9BKe = parcelRequire("i9BKe");
parcelRequire("7dx1H");
parcelRequire("4RJM2");













































var $i9BKe = parcelRequire("i9BKe");

var $iCGeI = parcelRequire("iCGeI");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
let $21de405eafa0c0bb$var$_isWebGLSupported;
function $21de405eafa0c0bb$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($21de405eafa0c0bb$var$_isWebGLSupported !== void 0) return $21de405eafa0c0bb$var$_isWebGLSupported;
    $21de405eafa0c0bb$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $iCGeI.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $21de405eafa0c0bb$var$_isWebGLSupported;
}



var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $7cb4832c2de4c977$var$_isWebGPUSupported;
async function $7cb4832c2de4c977$export$216169f30082c873(options = {}) {
    if ($7cb4832c2de4c977$var$_isWebGPUSupported !== void 0) return $7cb4832c2de4c977$var$_isWebGPUSupported;
    $7cb4832c2de4c977$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $iCGeI.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $7cb4832c2de4c977$var$_isWebGPUSupported;
}



var $3UUq4 = parcelRequire("3UUq4");
"use strict";
const $bf7ca24d384e2f55$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];



async function $bf7ca24d384e2f55$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $bf7ca24d384e2f55$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $bf7ca24d384e2f55$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $7cb4832c2de4c977$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("256Qy"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $21de405eafa0c0bb$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("gC3YA"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            const { CanvasRenderer: CanvasRenderer } = await (parcelRequire("6Tctm"));
            RendererClass = CanvasRenderer;
            finalOptions = {
                ...options,
                ...options.canvasOptions
            };
            break;
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    delete finalOptions.canvasOptions;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $eicwU = parcelRequire("eicwU");

var $gVtOu = parcelRequire("gVtOu");

var $kXq8E = parcelRequire("kXq8E");

var $i9BKe = parcelRequire("i9BKe");

var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $ea1a06b152e6d4d8$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", {
            configurable: true,
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    globalThis.addEventListener("resize", this.queueResize);
                    this.resize();
                }
            },
            get () {
                return this._resizeTo;
            }
        });
        this.queueResize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            this._resizeId = requestAnimationFrame(()=>this.resize());
        };
        this._cancelResize = ()=>{
            if (this._resizeId) {
                cancelAnimationFrame(this._resizeId);
                this._resizeId = null;
            }
        };
        this.resize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            let width;
            let height;
            if (this._resizeTo === globalThis.window) {
                width = globalThis.innerWidth;
                height = globalThis.innerHeight;
            } else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth;
                height = clientHeight;
            }
            this.renderer.resize(width, height);
            this.render();
        };
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize);
        this._cancelResize();
        this._cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    }
}
/** @ignore */ $ea1a06b152e6d4d8$export$6453cd852defe94a.extension = (0, $i9BKe.ExtensionType).Application;



var $i9BKe = parcelRequire("i9BKe");

var $cQMLP = parcelRequire("cQMLP");

var $4J7WL = parcelRequire("4J7WL");
"use strict";
class $63bd109872b60747$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        Object.defineProperty(this, "ticker", {
            configurable: true,
            set (ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, (0, $cQMLP.UPDATE_PRIORITY).LOW);
            },
            get () {
                return this._ticker;
            }
        });
        this.stop = ()=>{
            this._ticker.stop();
        };
        this.start = ()=>{
            this._ticker.start();
        };
        this._ticker = null;
        this.ticker = options.sharedTicker ? (0, $4J7WL.Ticker).shared : new (0, $4J7WL.Ticker)();
        if (options.autoStart) this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    }
}
/** @ignore */ $63bd109872b60747$export$50c361ceb4e2f4f0.extension = (0, $i9BKe.ExtensionType).Application;


"use strict";
(0, $i9BKe.extensions).add((0, $ea1a06b152e6d4d8$export$6453cd852defe94a));
(0, $i9BKe.extensions).add((0, $63bd109872b60747$export$50c361ceb4e2f4f0));


"use strict";
const $2202931bfc9ee5c9$var$_Application = class _Application {
    constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $eicwU.Container)();
        if (args[0] !== void 0) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.stage || (this.stage = new (0, $eicwU.Container)());
        this.renderer = await (0, $bf7ca24d384e2f55$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $2202931bfc9ee5c9$var$_Application._plugins = [];
let $2202931bfc9ee5c9$export$16975c34e60e1e61 = $2202931bfc9ee5c9$var$_Application;
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).Application, $2202931bfc9ee5c9$export$16975c34e60e1e61._plugins);
(0, $i9BKe.extensions).add((0, $gVtOu.ApplicationInitHook));





var $i9BKe = parcelRequire("i9BKe");

var $iEtN5 = parcelRequire("iEtN5");

var $5Oad7 = parcelRequire("5Oad7");

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lzfZe = parcelRequire("lzfZe");
"use strict";
const $2e97ab653ff7bb1e$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            if (font.chars[map[second]]) font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};



var $iCGeI = parcelRequire("iCGeI");
"use strict";
const $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            if (data.chars[map[second]]) data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};


"use strict";
const $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.match(/<font(\s|>)/)) return (0, $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3).test((0, $iCGeI.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3).parse((0, $iCGeI.DOMAdapter).get().parseXML(data));
    }
};


"use strict";
const $67f0360d0045775d$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $67f0360d0045775d$export$778a313228f06f6c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>!!asset?.pages && !!asset?.chars && typeof asset?.fontFamily === "string" && asset.fontFamily !== "",
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};

const $67f0360d0045775d$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Normal
    },
    /** used for deprecation purposes */ name: "loadBitmapFont",
    id: "bitmap-font",
    test (url) {
        return $67f0360d0045775d$var$validExtensions.includes((0, $lzfZe.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).test(data) || (0, $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).test(asset) ? (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).parse(asset) : (0, $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $lzfZe.path).join((0, $lzfZe.path).dirname(src), pageFile);
            imagePath = (0, $5Oad7.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const [loadedTextures, { BitmapFont: BitmapFont }] = await Promise.all([
            loader.load(textureUrls),
            (parcelRequire("lhab9"))
        ]);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new BitmapFont({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};



var $hUCK4 = parcelRequire("hUCK4");
"use strict";
class $1adc37b2cea8de16$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}



var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $df4c0fb70a898168$export$407b4625a915919d = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $bLlTJ.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
async function $36c6a70b0c6633f6$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (_e) {
            return false;
        }
        return true;
    }
    return false;
}


"use strict";
const $ca5df6e874c0bc98$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $36c6a70b0c6633f6$export$7c459e568e7cea2c)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $c65eb9bc0713cb5d$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $c65eb9bc0713cb5d$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$c65eb9bc0713cb5d$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$c65eb9bc0713cb5d$var$imageFormats.includes(f))
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $2ba590fe27c747f9$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $2ba590fe27c747f9$export$7a571c147b03abb1(mimeType) {
    if ($2ba590fe27c747f9$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}


"use strict";
const $8c93018bb9bae76f$export$7726d83fee274e25 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $dfa8be665f85221f$export$5a1da481121f806a = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $64abecc9a39a8c54$export$a041d698a1896657 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $c494cf4c5ea6913a$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $36c6a70b0c6633f6$export$7c459e568e7cea2c)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};



var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
const $be4c9d6031b69343$var$_Loader = class _Loader {
    constructor(){
        /**
     * Options for loading assets with the loader.
     * These options will be used as defaults for all load calls made with this loader instance.
     * They can be overridden by passing options directly to the load method.
     * @example
     * ```ts
     * // Create a loader with custom default options
     * const loader = new Loader();
     * loader.loadOptions = {
     *   strategy: 'skip', // Default strategy to 'skip'
     *   retryCount: 5,   // Default retry count to 5
     *   retryDelay: 500, // Default retry delay to 500ms
     * };
     *
     * // This load call will use the loader's default options
     * await loader.load('image1.png');
     */ this.loadOptions = {
            ..._Loader.defaultOptions
        };
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.parser || data.loadParser) {
                parser = this._parserHash[data.parser || data.loadParser];
                if (data.loadParser) (0, $hUCK4.warn)(`[Assets] "loadParser" is deprecated, use "parser" instead for ${url}`);
                if (!parser) (0, $hUCK4.warn)(`[Assets] specified load parser "${data.parser || data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $hUCK4.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgressOrOptions) {
        if (!this._parsersValidated) this._validateParsers();
        const options = typeof onProgressOrOptions === "function" ? {
            ..._Loader.defaultOptions,
            ...this.loadOptions,
            onProgress: onProgressOrOptions
        } : {
            ..._Loader.defaultOptions,
            ...this.loadOptions,
            ...onProgressOrOptions || {}
        };
        const { onProgress: onProgress, onError: onError, strategy: strategy, retryCount: retryCount, retryDelay: retryDelay } = options;
        let count = 0;
        const assets = {};
        const singleAsset = (0, $4DmkB.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $3CHiv.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.reduce((sum, asset)=>sum + (asset.progressSize || 1), 0);
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            if (assets[asset.src]) return;
            await this._loadAssetWithRetry(url, asset, {
                onProgress: onProgress,
                onError: onError,
                strategy: strategy,
                retryCount: retryCount,
                retryDelay: retryDelay
            }, assets);
            count += asset.progressSize || 1;
            if (onProgress) onProgress(count / total);
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $3CHiv.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name || parser.id).reduce((hash, parser)=>{
            if (!parser.name && !parser.id) (0, $hUCK4.warn)(`[Assets] parser should have an id`);
            else if (hash[parser.name] || hash[parser.id]) (0, $hUCK4.warn)(`[Assets] parser id conflict "${parser.id}"`);
            hash[parser.name] = parser;
            if (parser.id) hash[parser.id] = parser;
            return hash;
        }, {});
    }
    async _loadAssetWithRetry(url, asset, options, assets) {
        let attempt = 0;
        const { onError: onError, strategy: strategy, retryCount: retryCount, retryDelay: retryDelay } = options;
        const wait = (ms)=>new Promise((r)=>setTimeout(r, ms));
        while(true)try {
            if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
            assets[asset.src] = await this.promiseCache[url].promise;
            return;
        } catch (e) {
            delete this.promiseCache[url];
            delete assets[asset.src];
            attempt++;
            const isLast = strategy !== "retry" || attempt > retryCount;
            if (strategy === "retry" && !isLast) {
                if (onError) onError(e, asset);
                await wait(retryDelay);
                continue;
            }
            if (strategy === "skip") {
                if (onError) onError(e, asset);
                return;
            }
            if (onError) onError(e, asset);
            const error = new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            if (e instanceof Error && e.stack) error.stack = e.stack;
            throw error;
        }
    }
};
/**
 * Default options for loading assets
 * @example
 * ```ts
 * // Change default load options globally
 * Loader.defaultOptions = {
 *   strategy: 'skip', // Change default strategy to 'skip'
 *   retryCount: 5,   // Change default retry count to 5
 *   retryDelay: 500, // Change default retry delay to 500ms
 * };
 * ```
 */ $be4c9d6031b69343$var$_Loader.defaultOptions = {
    onProgress: void 0,
    onError: void 0,
    strategy: "throw",
    retryCount: 3,
    retryDelay: 250
};
let $be4c9d6031b69343$export$3b0d6d7590275603 = $be4c9d6031b69343$var$_Loader;



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");
"use strict";
function $d89e452ad91824ca$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}



var $lzfZe = parcelRequire("lzfZe");
"use strict";
function $8f487e3828a5ee92$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $lzfZe.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $c569a63b2f914437$var$validJSONExtension = ".json";
const $c569a63b2f914437$var$validJSONMIME = "application/json";
const $c569a63b2f914437$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadJson",
    id: "json",
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $c569a63b2f914437$var$validJSONMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $c569a63b2f914437$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $779da4c964b62347$var$validTXTExtension = ".txt";
const $779da4c964b62347$var$validTXTMIME = "text/plain";
const $779da4c964b62347$export$3835b7ee6dbebde8 = {
    /** used for deprecation purposes */ name: "loadTxt",
    id: "text",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $779da4c964b62347$var$validTXTMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $779da4c964b62347$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $2IhKp = parcelRequire("2IhKp");



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $0568dcd95d86dd78$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $0568dcd95d86dd78$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $0568dcd95d86dd78$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $0568dcd95d86dd78$export$c461ca8f39d93d9b(url) {
    const ext = (0, $lzfZe.path).extname(url);
    const name = (0, $lzfZe.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $0568dcd95d86dd78$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $0568dcd95d86dd78$var$encodeURIWhenNeeded(uri) {
    if ($0568dcd95d86dd78$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $0568dcd95d86dd78$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadWebFont",
    id: "web-font",
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $0568dcd95d86dd78$var$validFontMIMEs) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $0568dcd95d86dd78$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $iCGeI.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $0568dcd95d86dd78$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$0568dcd95d86dd78$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url('${$0568dcd95d86dd78$var$encodeURIWhenNeeded(url)}')`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            if ((0, $2IhKp.Cache).has(`${name}-and-url`)) {
                const cached = (0, $2IhKp.Cache).get(`${name}-and-url`);
                cached.entries.push({
                    url: url,
                    faces: fontFaces
                });
            } else (0, $2IhKp.Cache).set(`${name}-and-url`, {
                entries: [
                    {
                        url: url,
                        faces: fontFaces
                    }
                ]
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $hUCK4.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        const fonts = Array.isArray(font) ? font : [
            font
        ];
        const fontFamily = fonts[0].family;
        const cached = (0, $2IhKp.Cache).get(`${fontFamily}-and-url`);
        const entry = cached.entries.find((f)=>f.faces.some((t)=>fonts.indexOf(t) !== -1));
        entry.faces = entry.faces.filter((f)=>fonts.indexOf(f) === -1);
        if (entry.faces.length === 0) cached.entries = cached.entries.filter((f)=>f !== entry);
        fonts.forEach((t)=>{
            (0, $iCGeI.DOMAdapter).get().getFontFaceSet().delete(t);
        });
        if (cached.entries.length === 0) (0, $2IhKp.Cache).remove(`${fontFamily}-and-url`);
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $8aC7P = parcelRequire("8aC7P");

var $8kCsw = parcelRequire("8kCsw");
"use strict";
function $69836a01b04ce50b$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $8kCsw.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}





var $iEtN5 = parcelRequire("iEtN5");

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $2IhKp = parcelRequire("2IhKp");
"use strict";
function $703462f38e5d63e3$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $bLlTJ.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $2IhKp.Cache).has(url)) (0, $2IhKp.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $hUCK4.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $hUCK4.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}


"use strict";
const $258a91d856307e86$var$validSVGExtension = ".svg";
const $258a91d856307e86$var$validSVGMIME = "image/svg+xml";
const $258a91d856307e86$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    /** used for deprecation purposes */ name: "loadSVG",
    id: "svg",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $258a91d856307e86$var$validSVGMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $258a91d856307e86$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $258a91d856307e86$var$loadAsGraphics(url);
        return $258a91d856307e86$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $258a91d856307e86$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const image = (0, $iCGeI.DOMAdapter).get().createImage();
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(await response.text())}`;
    image.crossOrigin = crossOrigin;
    await image.decode();
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    const resolution = asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url);
    const canvasWidth = Math.ceil(width * resolution);
    const canvasHeight = Math.ceil(height * resolution);
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(canvasWidth, canvasHeight);
    const context = canvas.getContext("2d");
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
    const base = new (0, $aQPld.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url);
}
async function $258a91d856307e86$var$loadAsGraphics(url) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $8aC7P.GraphicsContext)();
    context.svg(svgSource);
    return context;
}



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");



const $9a21140edc3f77d8$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const WHITE_PNG = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=\";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== \"function\") return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (_e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n";
let $9a21140edc3f77d8$var$WORKER_URL = null;
class $9a21140edc3f77d8$export$2e2bcd8739ae039 {
    constructor(){
        if (!$9a21140edc3f77d8$var$WORKER_URL) $9a21140edc3f77d8$var$WORKER_URL = URL.createObjectURL(new Blob([
            $9a21140edc3f77d8$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($9a21140edc3f77d8$var$WORKER_URL);
    }
}
$9a21140edc3f77d8$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($9a21140edc3f77d8$var$WORKER_URL) {
        URL.revokeObjectURL($9a21140edc3f77d8$var$WORKER_URL);
        $9a21140edc3f77d8$var$WORKER_URL = null;
    }
};


const $361d1ede8b4541ed$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === \"premultiplied-alpha\" ? createImageBitmap(imageBlob, { premultiplyAlpha: \"none\" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $361d1ede8b4541ed$var$WORKER_URL = null;
class $361d1ede8b4541ed$export$2e2bcd8739ae039 {
    constructor(){
        if (!$361d1ede8b4541ed$var$WORKER_URL) $361d1ede8b4541ed$var$WORKER_URL = URL.createObjectURL(new Blob([
            $361d1ede8b4541ed$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($361d1ede8b4541ed$var$WORKER_URL);
    }
}
$361d1ede8b4541ed$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($361d1ede8b4541ed$var$WORKER_URL) {
        URL.revokeObjectURL($361d1ede8b4541ed$var$WORKER_URL);
        $361d1ede8b4541ed$var$WORKER_URL = null;
    }
};


"use strict";
let $778464c1601fd395$var$UUID = 0;
let $778464c1601fd395$var$MAX_WORKERS;
class $778464c1601fd395$var$WorkerManagerClass {
    constructor(){
        /** Whether the worker manager has been initialized */ this._initialized = false;
        /** Current number of created workers (used to enforce MAX_WORKERS limit) */ this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    /**
   * Checks if ImageBitmap is supported in the current environment.
   *
   * This method uses a dedicated worker to test ImageBitmap support
   * and caches the result for subsequent calls.
   * @returns Promise that resolves to true if ImageBitmap is supported, false otherwise
   */ isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $9a21140edc3f77d8$export$2e2bcd8739ae039)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $9a21140edc3f77d8$export$2e2bcd8739ae039).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    /**
   * Loads an image as an ImageBitmap using a web worker.
   * @param src - The source URL or path of the image to load
   * @param asset - Optional resolved asset containing additional texture source options
   * @returns Promise that resolves to the loaded ImageBitmap
   * @example
   * ```typescript
   * const bitmap = await WorkerManager.loadImageBitmap('image.png');
   * const bitmapWithOptions = await WorkerManager.loadImageBitmap('image.png', asset);
   * ```
   */ loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    /**
   * Initializes the worker pool if not already initialized.
   * Currently a no-op but reserved for future initialization logic.
   */ async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    /**
   * Gets an available worker from the pool or creates a new one if needed.
   *
   * Workers are created up to the MAX_WORKERS limit (based on navigator.hardwareConcurrency).
   * Each worker is configured with a message handler for processing results.
   * @returns Available worker or undefined if pool is at capacity and no workers are free
   */ _getWorker() {
        if ($778464c1601fd395$var$MAX_WORKERS === void 0) $778464c1601fd395$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $778464c1601fd395$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $361d1ede8b4541ed$export$2e2bcd8739ae039)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    /**
   * Returns a worker to the pool after completing a task.
   * @param worker - The worker to return to the pool
   */ _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    /**
   * Handles completion of a worker task by resolving or rejecting the corresponding promise.
   * @param data - Result data from the worker containing uuid, data, and optional error
   */ _complete(data) {
        if (!this._resolveHash[data.uuid]) return;
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        delete this._resolveHash[data.uuid];
    }
    /**
   * Executes a task using the worker pool system.
   *
   * Queues the task and processes it when a worker becomes available.
   * @param id - Identifier for the type of task to run
   * @param args - Arguments to pass to the worker
   * @returns Promise that resolves with the worker's result
   */ async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    /**
   * Processes the next item in the queue if workers are available.
   *
   * This method is called after worker initialization and when workers
   * complete tasks to continue processing the queue.
   */ _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$778464c1601fd395$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $778464c1601fd395$var$UUID++,
            id: id
        });
    }
    /**
   * Resets the worker manager, terminating all workers and clearing the queue.
   *
   * This method:
   * - Terminates all active workers
   * - Rejects all pending promises with an error
   * - Clears all internal state
   * - Resets initialization flags
   *
   * This should be called when the worker manager is no longer needed
   * to prevent memory leaks and ensure proper cleanup.
   * @example
   * ```typescript
   * // Clean up when shutting down
   * WorkerManager.reset();
   * ```
   */ reset() {
        this._workerPool.forEach((worker)=>worker.terminate());
        this._workerPool.length = 0;
        Object.values(this._resolveHash).forEach(({ reject: reject })=>{
            reject?.(new Error("WorkerManager has been reset before completion"));
        });
        this._resolveHash = {};
        this._queue.length = 0;
        this._initialized = false;
        this._createdWorkers = 0;
    }
}
const $778464c1601fd395$export$bcff6015853c67ce = new $778464c1601fd395$var$WorkerManagerClass();



var $iEtN5 = parcelRequire("iEtN5");

"use strict";
const $7390591d087b0cdb$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $7390591d087b0cdb$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $7390591d087b0cdb$export$c614e6247302006d(url, asset) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $7390591d087b0cdb$export$897b113ee8307cd0 = {
    /** used for deprecation purposes */ name: "loadTextures",
    id: "texture",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $7390591d087b0cdb$var$validImageMIMEs) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $7390591d087b0cdb$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $778464c1601fd395$export$bcff6015853c67ce).isImageBitmapSupported()) src = await (0, $778464c1601fd395$export$bcff6015853c67ce).loadImageBitmap(url, asset);
            else src = await $7390591d087b0cdb$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve, reject)=>{
            src = (0, $iCGeI.DOMAdapter).get().createImage();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else {
                src.onload = ()=>{
                    resolve(src);
                };
                src.onerror = reject;
            }
        });
        const base = new (0, $aQPld.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url),
            ...asset.data
        });
        return (0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $i9BKe = parcelRequire("i9BKe");

var $hNatJ = parcelRequire("hNatJ");

var $7blVu = parcelRequire("7blVu");





"use strict";
const $170b999e73028fac$var$potentialVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
let $170b999e73028fac$var$validVideoExtensions;
let $170b999e73028fac$var$validVideoMIMEs;
function $170b999e73028fac$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $170b999e73028fac$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $170b999e73028fac$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $170b999e73028fac$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc || (loc = globalThis.location);
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
function $170b999e73028fac$var$getBrowserSupportedVideoExtensions() {
    const supportedExtensions = [];
    const supportedMimes = [];
    for (const ext of $170b999e73028fac$var$potentialVideoExtensions){
        const mimeType = (0, $hNatJ.VideoSource).MIME_TYPES[ext.substring(1)] || `video/${ext.substring(1)}`;
        if ((0, $2ba590fe27c747f9$export$7a571c147b03abb1)(mimeType)) {
            supportedExtensions.push(ext);
            if (!supportedMimes.includes(mimeType)) supportedMimes.push(mimeType);
        }
    }
    return {
        validVideoExtensions: supportedExtensions,
        validVideoMime: supportedMimes
    };
}
const $170b999e73028fac$export$68fa0976ba667d63 = {
    /** used for deprecation purposes */ name: "loadVideo",
    id: "video",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        if (!$170b999e73028fac$var$validVideoExtensions || !$170b999e73028fac$var$validVideoMIMEs) {
            const { validVideoExtensions: ve, validVideoMime: vm } = $170b999e73028fac$var$getBrowserSupportedVideoExtensions();
            $170b999e73028fac$var$validVideoExtensions = ve;
            $170b999e73028fac$var$validVideoMIMEs = vm;
        }
        const isValidDataUrl = (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $170b999e73028fac$var$validVideoMIMEs);
        const isValidExtension = (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $170b999e73028fac$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $hNatJ.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url),
            alphaMode: asset.data?.alphaMode || await (0, $7blVu.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $170b999e73028fac$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (options.mime) mime = options.mime;
        else if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $hNatJ.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve, reject)=>{
            if (options.preload && !options.autoPlay) videoElement.load();
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.addEventListener("error", onError);
            sourceElement.addEventListener("error", onError);
            videoElement.appendChild(sourceElement);
            async function onCanPlay() {
                const base = new (0, $hNatJ.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                cleanup();
                if (asset.data.preload) await $170b999e73028fac$export$856bfbe81968ff62(videoElement);
                resolve((0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url));
            }
            function onError(event) {
                cleanup();
                reject(event);
            }
            function cleanup() {
                videoElement.removeEventListener("canplay", onCanPlay);
                videoElement.removeEventListener("error", onError);
                sourceElement.removeEventListener("error", onError);
            }
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $i9BKe = parcelRequire("i9BKe");

var $8kCsw = parcelRequire("8kCsw");

var $i9BKe = parcelRequire("i9BKe");


var $8kCsw = parcelRequire("8kCsw");
"use strict";
const $f9f0a4a658d5e519$export$cc356fa83de02bea = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $7390591d087b0cdb$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};


"use strict";
const $7c85897abf6bc2d6$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $8kCsw.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $f9f0a4a658d5e519$export$cc356fa83de02bea).parse
};




var $8kCsw = parcelRequire("8kCsw");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $f4e4ce59fcdafcd2$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $8kCsw.Resolver)();
        this.loader = new (0, $be4c9d6031b69343$export$3b0d6d7590275603)();
        this.cache = (0, $2IhKp.Cache);
        this._backgroundLoader = new (0, $1adc37b2cea8de16$export$1949379a83b843d5)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $hUCK4.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
        if (options.loadOptions) this.loader.loadOptions = {
            ...this.loader.loadOptions,
            ...options.loadOptions
        };
    }
    /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $4DmkB.isSingleItem)(urls);
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let total = 0;
        const counts = [];
        const _onProgress = ()=>{
            onProgress?.(counts.reduce((a, b)=>a + b, 0) / total);
        };
        const promises = keys.map((bundleId, i)=>{
            const resolveResult = resolveResults[bundleId];
            const values = Object.values(resolveResult);
            const totalAssetsToLoad = [
                ...new Set(values.flat())
            ];
            const progressSize = totalAssetsToLoad.reduce((sum, asset)=>sum + (asset.progressSize || 1), 0);
            counts.push(0);
            total += progressSize;
            return this._mapLoadToResolve(resolveResult, (e)=>{
                counts[i] = e * progressSize;
                _onProgress();
            }).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $2IhKp.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $2IhKp.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param progressOrLoadOptions - the progress callback or load options
   */ async _mapLoadToResolve(resolveResults, progressOrLoadOptions) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, progressOrLoadOptions);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $2IhKp.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $2IhKp.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */ get detections() {
        return this._detections;
    }
    /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $f4e4ce59fcdafcd2$export$c8eca95e306f7116 = new $f4e4ce59fcdafcd2$export$137d4dd907afac85();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).LoadParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.loader.parsers).handleByList((0, $i9BKe.ExtensionType).ResolveParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $i9BKe.ExtensionType).CacheParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.cache.parsers).handleByList((0, $i9BKe.ExtensionType).DetectionParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.detections);
(0, $i9BKe.extensions).add((0, $df4c0fb70a898168$export$407b4625a915919d), (0, $c65eb9bc0713cb5d$export$b106d7c2de3b4d89), (0, $ca5df6e874c0bc98$export$a60d2d4a3c570783), (0, $c494cf4c5ea6913a$export$d19529a9ed9823d4), (0, $8c93018bb9bae76f$export$7726d83fee274e25), (0, $dfa8be665f85221f$export$5a1da481121f806a), (0, $64abecc9a39a8c54$export$a041d698a1896657), (0, $c569a63b2f914437$export$e7c8553478f3aac7), (0, $779da4c964b62347$export$3835b7ee6dbebde8), (0, $0568dcd95d86dd78$export$129ed93ad26b0298), (0, $258a91d856307e86$export$b6a2e78b63791dfa), (0, $7390591d087b0cdb$export$897b113ee8307cd0), (0, $170b999e73028fac$export$68fa0976ba667d63), (0, $67f0360d0045775d$export$402edee29ac8bed4), (0, $67f0360d0045775d$export$778a313228f06f6c), (0, $f9f0a4a658d5e519$export$cc356fa83de02bea), (0, $7c85897abf6bc2d6$export$2b5cca0b89cb089c));
const $f4e4ce59fcdafcd2$var$assetKeyMap = {
    loader: (0, $i9BKe.ExtensionType).LoadParser,
    resolver: (0, $i9BKe.ExtensionType).ResolveParser,
    cache: (0, $i9BKe.ExtensionType).CacheParser,
    detection: (0, $i9BKe.ExtensionType).DetectionParser
};
(0, $i9BKe.extensions).handle((0, $i9BKe.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($f4e4ce59fcdafcd2$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $i9BKe.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($f4e4ce59fcdafcd2$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $i9BKe.extensions).remove(ref[key]));
});

























































































































var $1HooC = parcelRequire("1HooC");


































































































































































































































var $8QN7n = parcelRequire("8QN7n");

























var $eicwU = parcelRequire("eicwU");







































var $3cebA = parcelRequire("3cebA");















































var $7wtv9 = parcelRequire("7wtv9");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
const $dc30c934e05d5c6c$export$a7ffd1f9edff60c0 = {
    vertex: {
        attributeName: "aVertex",
        format: "float32x2",
        code: `
            const texture = p.texture;
            const sx = p.scaleX;
            const sy = p.scaleY;
            const ax = p.anchorX;
            const ay = p.anchorY;
            const trim = texture.trim;
            const orig = texture.orig;

            if (trim)
            {
                w1 = trim.x - (ax * orig.width);
                w0 = w1 + trim.width;

                h1 = trim.y - (ay * orig.height);
                h0 = h1 + trim.height;
            }
            else
            {
                w1 = -ax * (orig.width);
                w0 = w1 + orig.width;

                h1 = -ay * (orig.height);
                h0 = h1 + orig.height;
            }

            f32v[offset] = w1 * sx;
            f32v[offset + 1] = h1 * sy;

            f32v[offset + stride] = w0 * sx;
            f32v[offset + stride + 1] = h1 * sy;

            f32v[offset + (stride * 2)] = w0 * sx;
            f32v[offset + (stride * 2) + 1] = h0 * sy;

            f32v[offset + (stride * 3)] = w1 * sx;
            f32v[offset + (stride * 3) + 1] = h0 * sy;
        `,
        dynamic: false
    },
    // positionData
    position: {
        attributeName: "aPosition",
        format: "float32x2",
        code: `
            var x = p.x;
            var y = p.y;

            f32v[offset] = x;
            f32v[offset + 1] = y;

            f32v[offset + stride] = x;
            f32v[offset + stride + 1] = y;

            f32v[offset + (stride * 2)] = x;
            f32v[offset + (stride * 2) + 1] = y;

            f32v[offset + (stride * 3)] = x;
            f32v[offset + (stride * 3) + 1] = y;
        `,
        dynamic: true
    },
    // rotationData
    rotation: {
        attributeName: "aRotation",
        format: "float32",
        code: `
            var rotation = p.rotation;

            f32v[offset] = rotation;
            f32v[offset + stride] = rotation;
            f32v[offset + (stride * 2)] = rotation;
            f32v[offset + (stride * 3)] = rotation;
        `,
        dynamic: false
    },
    // uvsData
    uvs: {
        attributeName: "aUV",
        format: "float32x2",
        code: `
            var uvs = p.texture.uvs;

            f32v[offset] = uvs.x0;
            f32v[offset + 1] = uvs.y0;

            f32v[offset + stride] = uvs.x1;
            f32v[offset + stride + 1] = uvs.y1;

            f32v[offset + (stride * 2)] = uvs.x2;
            f32v[offset + (stride * 2) + 1] = uvs.y2;

            f32v[offset + (stride * 3)] = uvs.x3;
            f32v[offset + (stride * 3) + 1] = uvs.y3;
        `,
        dynamic: false
    },
    // tintData
    color: {
        attributeName: "aColor",
        format: "unorm8x4",
        code: `
            const c = p.color;

            u32v[offset] = c;
            u32v[offset + stride] = c;
            u32v[offset + (stride * 2)] = c;
            u32v[offset + (stride * 3)] = c;
        `,
        dynamic: false
    }
};



var $i9BKe = parcelRequire("i9BKe");

var $i9BKe = parcelRequire("i9BKe");

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $cryyq = parcelRequire("cryyq");

var $eN26f = parcelRequire("eN26f");

var $2Aebl = parcelRequire("2Aebl");

var $1DS3C = parcelRequire("1DS3C");

var $6B0gZ = parcelRequire("6B0gZ");

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");

var $cOnev = parcelRequire("cOnev");

var $kavUV = parcelRequire("kavUV");

var $aaUE3 = parcelRequire("aaUE3");
"use strict";
function $93985ebe359db76f$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    if (totalIndices > 65535) outBuffer || (outBuffer = new Uint32Array(totalIndices));
    else outBuffer || (outBuffer = new Uint16Array(totalIndices));
    if (outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4){
        outBuffer[i + 0] = j + 0;
        outBuffer[i + 1] = j + 1;
        outBuffer[i + 2] = j + 2;
        outBuffer[i + 3] = j + 0;
        outBuffer[i + 4] = j + 2;
        outBuffer[i + 5] = j + 3;
    }
    return outBuffer;
}



var $kavUV = parcelRequire("kavUV");
"use strict";
function $bbf7cf60af605027$export$f240bbaff81b32e9(properties) {
    return {
        dynamicUpdate: $bbf7cf60af605027$var$generateUpdateFunction(properties, true),
        staticUpdate: $bbf7cf60af605027$var$generateUpdateFunction(properties, false)
    };
}
function $bbf7cf60af605027$var$generateUpdateFunction(properties, dynamic) {
    const funcFragments = [];
    funcFragments.push(`

        var index = 0;

        for (let i = 0; i < ps.length; ++i)
        {
            const p = ps[i];

            `);
    let offset = 0;
    for(const i in properties){
        const property = properties[i];
        if (dynamic !== property.dynamic) continue;
        funcFragments.push(`offset = index + ${offset}`);
        funcFragments.push(property.code);
        const attributeInfo = (0, $kavUV.getAttributeInfoFromFormat)(property.format);
        offset += attributeInfo.stride / 4;
    }
    funcFragments.push(`
            index += stride * 4;
        }
    `);
    funcFragments.unshift(`
        var stride = ${offset};
    `);
    const functionSource = funcFragments.join("\n");
    return new Function("ps", "f32v", "u32v", functionSource);
}


"use strict";
class $41856aa613e5a21c$export$ef6bb3c375ab2229 {
    constructor(options){
        this._size = 0;
        this._generateParticleUpdateCache = {};
        const size = this._size = options.size ?? 1e3;
        const properties = options.properties;
        let staticVertexSize = 0;
        let dynamicVertexSize = 0;
        for(const i in properties){
            const property = properties[i];
            const attributeInfo = (0, $kavUV.getAttributeInfoFromFormat)(property.format);
            if (property.dynamic) dynamicVertexSize += attributeInfo.stride;
            else staticVertexSize += attributeInfo.stride;
        }
        this._dynamicStride = dynamicVertexSize / 4;
        this._staticStride = staticVertexSize / 4;
        this.staticAttributeBuffer = new (0, $aaUE3.ViewableBuffer)(size * 4 * staticVertexSize);
        this.dynamicAttributeBuffer = new (0, $aaUE3.ViewableBuffer)(size * 4 * dynamicVertexSize);
        this.indexBuffer = (0, $93985ebe359db76f$export$c56148e1bec42281)(size);
        const geometry = new (0, $cOnev.Geometry)();
        let dynamicOffset = 0;
        let staticOffset = 0;
        this._staticBuffer = new (0, $lvEAL.Buffer)({
            data: new Float32Array(1),
            label: "static-particle-buffer",
            shrinkToFit: false,
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST
        });
        this._dynamicBuffer = new (0, $lvEAL.Buffer)({
            data: new Float32Array(1),
            label: "dynamic-particle-buffer",
            shrinkToFit: false,
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST
        });
        for(const i in properties){
            const property = properties[i];
            const attributeInfo = (0, $kavUV.getAttributeInfoFromFormat)(property.format);
            if (property.dynamic) {
                geometry.addAttribute(property.attributeName, {
                    buffer: this._dynamicBuffer,
                    stride: this._dynamicStride * 4,
                    offset: dynamicOffset * 4,
                    format: property.format
                });
                dynamicOffset += attributeInfo.size;
            } else {
                geometry.addAttribute(property.attributeName, {
                    buffer: this._staticBuffer,
                    stride: this._staticStride * 4,
                    offset: staticOffset * 4,
                    format: property.format
                });
                staticOffset += attributeInfo.size;
            }
        }
        geometry.addIndex(this.indexBuffer);
        const uploadFunction = this.getParticleUpdate(properties);
        this._dynamicUpload = uploadFunction.dynamicUpdate;
        this._staticUpload = uploadFunction.staticUpdate;
        this.geometry = geometry;
    }
    getParticleUpdate(properties) {
        const key = $41856aa613e5a21c$var$getParticleSyncKey(properties);
        if (this._generateParticleUpdateCache[key]) return this._generateParticleUpdateCache[key];
        this._generateParticleUpdateCache[key] = this.generateParticleUpdate(properties);
        return this._generateParticleUpdateCache[key];
    }
    generateParticleUpdate(properties) {
        return (0, $bbf7cf60af605027$export$f240bbaff81b32e9)(properties);
    }
    update(particles, uploadStatic) {
        if (particles.length > this._size) {
            uploadStatic = true;
            this._size = Math.max(particles.length, this._size * 1.5 | 0);
            this.staticAttributeBuffer = new (0, $aaUE3.ViewableBuffer)(this._size * this._staticStride * 16);
            this.dynamicAttributeBuffer = new (0, $aaUE3.ViewableBuffer)(this._size * this._dynamicStride * 16);
            this.indexBuffer = (0, $93985ebe359db76f$export$c56148e1bec42281)(this._size);
            this.geometry.indexBuffer.setDataWithSize(this.indexBuffer, this.indexBuffer.byteLength, true);
        }
        const dynamicAttributeBuffer = this.dynamicAttributeBuffer;
        this._dynamicUpload(particles, dynamicAttributeBuffer.float32View, dynamicAttributeBuffer.uint32View);
        this._dynamicBuffer.setDataWithSize(this.dynamicAttributeBuffer.float32View, particles.length * this._dynamicStride * 4, true);
        if (uploadStatic) {
            const staticAttributeBuffer = this.staticAttributeBuffer;
            this._staticUpload(particles, staticAttributeBuffer.float32View, staticAttributeBuffer.uint32View);
            this._staticBuffer.setDataWithSize(staticAttributeBuffer.float32View, particles.length * this._staticStride * 4, true);
        }
    }
    destroy() {
        this._staticBuffer.destroy();
        this._dynamicBuffer.destroy();
        this.geometry.destroy();
    }
}
function $41856aa613e5a21c$var$getParticleSyncKey(properties) {
    const keyGen = [];
    for(const key in properties){
        const property = properties[key];
        keyGen.push(key, property.code, property.dynamic ? "d" : "s");
    }
    return keyGen.join("_");
}



var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $5iDyo = parcelRequire("5iDyo");

var $bLlTJ = parcelRequire("bLlTJ");

var $aFPUT = parcelRequire("aFPUT");
var $069f6fdbce626cce$export$2e2bcd8739ae039 = "varying vec2 vUV;\nvarying vec4 vColor;\n\nuniform sampler2D uTexture;\n\nvoid main(void){\n    vec4 color = texture2D(uTexture, vUV) * vColor;\n    gl_FragColor = color;\n}";


var $81fbd91e359ccc15$export$2e2bcd8739ae039 = "attribute vec2 aVertex;\nattribute vec2 aUV;\nattribute vec4 aColor;\n\nattribute vec2 aPosition;\nattribute float aRotation;\n\nuniform mat3 uTranslationMatrix;\nuniform float uRound;\nuniform vec2 uResolution;\nuniform vec4 uColor;\n\nvarying vec2 vUV;\nvarying vec4 vColor;\n\nvec2 roundPixels(vec2 position, vec2 targetSize)\n{       \n    return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;\n}\n\nvoid main(void){\n    float cosRotation = cos(aRotation);\n    float sinRotation = sin(aRotation);\n    float x = aVertex.x * cosRotation - aVertex.y * sinRotation;\n    float y = aVertex.x * sinRotation + aVertex.y * cosRotation;\n\n    vec2 v = vec2(x, y);\n    v = v + aPosition;\n\n    gl_Position = vec4((uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    if(uRound == 1.0)\n    {\n        gl_Position.xy = roundPixels(gl_Position.xy, uResolution);\n    }\n\n    vUV = aUV;\n    vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uColor;\n}\n";


var $0f00c0057c508d8e$export$2e2bcd8739ae039 = "\nstruct ParticleUniforms {\n  uTranslationMatrix:mat3x3<f32>,\n  uColor:vec4<f32>,\n  uRound:f32,\n  uResolution:vec2<f32>,\n};\n\nfn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>\n{\n  return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;\n}\n\n@group(0) @binding(0) var<uniform> uniforms: ParticleUniforms;\n\n@group(1) @binding(0) var uTexture: texture_2d<f32>;\n@group(1) @binding(1) var uSampler : sampler;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n    @location(1) color : vec4<f32>,\n  };\n@vertex\nfn mainVertex(\n  @location(0) aVertex: vec2<f32>,\n  @location(1) aPosition: vec2<f32>,\n  @location(2) aUV: vec2<f32>,\n  @location(3) aColor: vec4<f32>,\n  @location(4) aRotation: f32,\n) -> VSOutput {\n  \n   let v = vec2(\n       aVertex.x * cos(aRotation) - aVertex.y * sin(aRotation),\n       aVertex.x * sin(aRotation) + aVertex.y * cos(aRotation)\n   ) + aPosition;\n\n   var position = vec4((uniforms.uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n   if(uniforms.uRound == 1.0) {\n       position = vec4(roundPixels(position.xy, uniforms.uResolution), position.zw);\n   }\n\n    let vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uniforms.uColor;\n\n  return VSOutput(\n   position,\n   aUV,\n   vColor,\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @location(1) color: vec4<f32>,\n  @builtin(position) position: vec4<f32>,\n) -> @location(0) vec4<f32> {\n\n    var sample = textureSample(uTexture, uSampler, uv) * color;\n   \n    return sample;\n}";


"use strict";
class $6cc42f489248d548$export$aff9903e2c89709e extends (0, $5iDyo.Shader) {
    constructor(){
        const glProgram = (0, $fK92B.GlProgram).from({
            vertex: $81fbd91e359ccc15$export$2e2bcd8739ae039,
            fragment: $069f6fdbce626cce$export$2e2bcd8739ae039
        });
        const gpuProgram = (0, $6j7wq.GpuProgram).from({
            fragment: {
                source: (0, $0f00c0057c508d8e$export$2e2bcd8739ae039),
                entryPoint: "mainFragment"
            },
            vertex: {
                source: (0, $0f00c0057c508d8e$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            }
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                // this will be replaced with the texture from the particle container
                uTexture: (0, $bLlTJ.Texture).WHITE.source,
                // this will be replaced with the texture style from the particle container
                uSampler: new (0, $aFPUT.TextureStyle)({}),
                // this will be replaced with the local uniforms from the particle container
                uniforms: {
                    uTranslationMatrix: {
                        value: new (0, $eY4rt.Matrix)(),
                        type: "mat3x3<f32>"
                    },
                    uColor: {
                        value: new (0, $a2eTA.Color)(16777215),
                        type: "vec4<f32>"
                    },
                    uRound: {
                        value: 1,
                        type: "f32"
                    },
                    uResolution: {
                        value: [
                            0,
                            0
                        ],
                        type: "vec2<f32>"
                    }
                }
            }
        });
    }
}


"use strict";
class $5ae3d3daff48675c$export$bd0cb1ddce5f75fc {
    /**
   * @param renderer - The renderer this sprite batch works for.
   * @param adaptor
   */ constructor(renderer, adaptor){
        /** @internal */ this.state = (0, $2Aebl.State).for2d();
        /** Local uniforms that are used for rendering particles. */ this.localUniforms = new (0, $cryyq.UniformGroup)({
            uTranslationMatrix: {
                value: new (0, $eY4rt.Matrix)(),
                type: "mat3x3<f32>"
            },
            uColor: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uRound: {
                value: 1,
                type: "f32"
            },
            uResolution: {
                value: [
                    0,
                    0
                ],
                type: "vec2<f32>"
            }
        });
        this.renderer = renderer;
        this.adaptor = adaptor;
        this.defaultShader = new (0, $6cc42f489248d548$export$aff9903e2c89709e)();
        this.state = (0, $2Aebl.State).for2d();
        this._managedContainers = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            name: "particleContainer"
        });
    }
    validateRenderable(_renderable) {
        return false;
    }
    addRenderable(renderable, instructionSet) {
        this.renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(renderable);
    }
    getBuffers(renderable) {
        return renderable._gpuData[this.renderer.uid] || this._initBuffer(renderable);
    }
    _initBuffer(renderable) {
        renderable._gpuData[this.renderer.uid] = new (0, $41856aa613e5a21c$export$ef6bb3c375ab2229)({
            size: renderable.particleChildren.length,
            properties: renderable._properties
        });
        this._managedContainers.add(renderable);
        return renderable._gpuData[this.renderer.uid];
    }
    updateRenderable(_renderable) {}
    execute(container) {
        const children = container.particleChildren;
        if (children.length === 0) return;
        const renderer = this.renderer;
        const buffer = this.getBuffers(container);
        container.texture || (container.texture = children[0].texture);
        const state = this.state;
        buffer.update(children, container._childrenDirty);
        container._childrenDirty = false;
        state.blendMode = (0, $eN26f.getAdjustedBlendModeBlend)(container.blendMode, container.texture._source);
        const uniforms = this.localUniforms.uniforms;
        const transformationMatrix = uniforms.uTranslationMatrix;
        container.worldTransform.copyTo(transformationMatrix);
        const globalUniformData = renderer.globalUniforms.globalUniformData;
        transformationMatrix.tx -= globalUniformData.offset.x;
        transformationMatrix.ty -= globalUniformData.offset.y;
        transformationMatrix.prepend(globalUniformData.projectionMatrix);
        uniforms.uResolution = globalUniformData.resolution;
        uniforms.uRound = renderer._roundPixels | container._roundPixels;
        (0, $6B0gZ.color32BitToUniform)(container.groupColorAlpha, uniforms.uColor, 0);
        this.adaptor.execute(this, container);
    }
    /** Destroys the ParticleRenderer. */ destroy() {
        this._managedContainers.destroy();
        this.renderer = null;
        if (this.defaultShader) {
            this.defaultShader.destroy();
            this.defaultShader = null;
        }
    }
}
/** @ignore */ $5ae3d3daff48675c$export$bd0cb1ddce5f75fc.extension = {
    type: [
        (0, $i9BKe.ExtensionType).CanvasPipes
    ],
    name: "particle"
};



var $jGzhD = parcelRequire("jGzhD");
"use strict";
class $724a704ea275d250$export$a3bb3b18d3c0fa86 {
    execute(particleContainerPipe, container) {
        const renderer = particleContainerPipe.renderer;
        const context = renderer.canvasContext.activeContext;
        const children = container.particleChildren;
        const texture = container.texture;
        context.save();
        renderer.canvasContext.setContextTransform(container.worldTransform, container.roundPixels);
        renderer.canvasContext.setBlendMode(container.groupBlendMode);
        const groupColorAlpha = container.groupColorAlpha;
        const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
        const groupAlpha = (groupColorAlpha >>> 24 & 255) / 255 * filterAlpha;
        for(let i = 0; i < children.length; i++){
            const particle = children[i];
            const pTexture = particle.texture || texture;
            if (!pTexture?.source?.resource) continue;
            const color = particle.color;
            const alpha = (color >>> 24 & 255) / 255 * groupAlpha;
            if (alpha <= 0) continue;
            const bgr = color & 16777215;
            const tint = ((bgr & 255) << 16) + (bgr & 65280) + (bgr >> 16 & 255);
            let drawSource = pTexture.source.resource;
            if (tint !== 16777215) drawSource = (0, $jGzhD.canvasUtils).getTintedCanvas({
                texture: pTexture
            }, tint);
            const frame = pTexture.frame;
            const resolution = pTexture.source.resolution;
            const sx = frame.x * resolution;
            const sy = frame.y * resolution;
            const sw = frame.width * resolution;
            const sh = frame.height * resolution;
            context.globalAlpha = alpha;
            const dx = -particle.anchorX * frame.width;
            const dy = -particle.anchorY * frame.height;
            if (particle.rotation !== 0 || particle.scaleX !== 1 || particle.scaleY !== 1) {
                context.save();
                context.translate(particle.x, particle.y);
                context.rotate(particle.rotation);
                context.scale(particle.scaleX, particle.scaleY);
                context.drawImage(drawSource, sx, sy, sw, sh, dx, dy, frame.width, frame.height);
                context.restore();
            } else context.drawImage(drawSource, sx, sy, sw, sh, particle.x + dx, particle.y + dy, frame.width, frame.height);
        }
        context.restore();
    }
}


"use strict";
class $6fd635d9e77cd05c$export$577397794ae005cf extends (0, $5ae3d3daff48675c$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $724a704ea275d250$export$a3bb3b18d3c0fa86)());
    }
}
/** @ignore */ $6fd635d9e77cd05c$export$577397794ae005cf.extension = {
    type: [
        (0, $i9BKe.ExtensionType).CanvasPipes
    ],
    name: "particle"
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $e56f0b5bb8fea3d7$export$46c725f3fa23723f {
    execute(particleContainerPipe, container) {
        const state = particleContainerPipe.state;
        const renderer = particleContainerPipe.renderer;
        const shader = container.shader || particleContainerPipe.defaultShader;
        shader.resources.uTexture = container.texture._source;
        shader.resources.uniforms = particleContainerPipe.localUniforms;
        const gl = renderer.gl;
        const buffer = particleContainerPipe.getBuffers(container);
        renderer.shader.bind(shader);
        renderer.state.set(state);
        renderer.geometry.bind(buffer.geometry, shader.glProgram);
        const byteSize = buffer.geometry.indexBuffer.data.BYTES_PER_ELEMENT;
        const glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
        gl.drawElements(gl.TRIANGLES, container.particleChildren.length * 6, glType, 0);
    }
}



"use strict";
class $e1c6865aa6b933b2$export$265dc7019ac9a69c extends (0, $5ae3d3daff48675c$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $e56f0b5bb8fea3d7$export$46c725f3fa23723f)());
    }
}
/** @ignore */ $e1c6865aa6b933b2$export$265dc7019ac9a69c.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLPipes
    ],
    name: "particle"
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $a8d47e7729fe0fc5$export$b05a5c43c842f66d {
    execute(particleContainerPipe, container) {
        const renderer = particleContainerPipe.renderer;
        const shader = container.shader || particleContainerPipe.defaultShader;
        shader.groups[0] = renderer.renderPipes.uniformBatch.getUniformBindGroup(particleContainerPipe.localUniforms, true);
        shader.groups[1] = renderer.texture.getTextureBindGroup(container.texture);
        const state = particleContainerPipe.state;
        const buffer = particleContainerPipe.getBuffers(container);
        renderer.encoder.draw({
            geometry: buffer.geometry,
            shader: container.shader || particleContainerPipe.defaultShader,
            state: state,
            size: container.particleChildren.length * 6
        });
    }
}



"use strict";
class $f3f54c0dfd6a5b76$export$1097a2b67474552c extends (0, $5ae3d3daff48675c$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $a8d47e7729fe0fc5$export$b05a5c43c842f66d)());
    }
}
/** @ignore */ $f3f54c0dfd6a5b76$export$1097a2b67474552c.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGPUPipes
    ],
    name: "particle"
};


"use strict";
(0, $i9BKe.extensions).add((0, $e1c6865aa6b933b2$export$265dc7019ac9a69c));
(0, $i9BKe.extensions).add((0, $f3f54c0dfd6a5b76$export$1097a2b67474552c));
(0, $i9BKe.extensions).add((0, $6fd635d9e77cd05c$export$577397794ae005cf));


"use strict";
const $b425caa62af94b42$var$emptyBounds = new (0, $7wtv9.Bounds)(0, 0, 0, 0);
const $b425caa62af94b42$var$_ParticleContainer = class _ParticleContainer extends (0, $b9FQU.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = {}){
        options = {
            ..._ParticleContainer.defaultOptions,
            ...options,
            dynamicProperties: {
                ..._ParticleContainer.defaultOptions.dynamicProperties,
                ...options?.dynamicProperties
            }
        };
        const { dynamicProperties: dynamicProperties, shader: shader, roundPixels: roundPixels, texture: texture, particles: particles, ...rest } = options;
        super({
            label: "ParticleContainer",
            ...rest
        });
        /**
     * The unique identifier for the render pipe of this ParticleContainer.
     * @internal
     */ this.renderPipeId = "particle";
        /** @internal */ this.batched = false;
        /**
     * Indicates if the children of this ParticleContainer have changed and need to be updated.
     * @internal
     */ this._childrenDirty = false;
        this.texture = texture || null;
        this.shader = shader;
        this._properties = {};
        for(const key in 0, $dc30c934e05d5c6c$export$a7ffd1f9edff60c0){
            const property = (0, $dc30c934e05d5c6c$export$a7ffd1f9edff60c0)[key];
            const dynamic = dynamicProperties[key];
            this._properties[key] = {
                ...property,
                dynamic: dynamic
            };
        }
        this.allowChildren = true;
        this.roundPixels = roundPixels ?? false;
        this.particleChildren = particles ?? [];
    }
    /**
   * Adds one or more particles to the container. The particles will be rendered using the container's shared texture
   * and properties. When adding multiple particles, they must all share the same base texture.
   * @example
   * ```ts
   * const container = new ParticleContainer();
   *
   * // Add a single particle
   * const particle = new Particle(Assets.get('particleTexture'));
   * container.addParticle(particle);
   *
   * // Add multiple particles at once
   * const particles = [
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture'))
   * ];
   *
   * container.addParticle(...particles);
   * ```
   * @param children - The Particle(s) to add to the container
   * @returns The first particle that was added, for method chaining
   * @see {@link ParticleContainer#texture} For setting the shared texture
   * @see {@link ParticleContainer#update} For updating after modifications
   */ addParticle(...children) {
        for(let i = 0; i < children.length; i++)this.particleChildren.push(children[i]);
        this.onViewUpdate();
        return children[0];
    }
    /**
   * Removes one or more particles from the container. The particles must already be children
   * of this container to be removed.
   * @example
   * ```ts
   * // Remove a single particle
   * container.removeParticle(particle1);
   *
   * // Remove multiple particles at once
   * container.removeParticle(particle2, particle3);
   * ```
   * @param children - The Particle(s) to remove from the container
   * @returns The first particle that was removed, for method chaining
   * @see {@link ParticleContainer#particleChildren} For accessing all particles
   * @see {@link ParticleContainer#removeParticles} For removing particles by index
   * @see {@link ParticleContainer#removeParticleAt} For removing a particle at a specific index
   */ removeParticle(...children) {
        let didRemove = false;
        for(let i = 0; i < children.length; i++){
            const index = this.particleChildren.indexOf(children[i]);
            if (index > -1) {
                this.particleChildren.splice(index, 1);
                didRemove = true;
            }
        }
        if (didRemove) this.onViewUpdate();
        return children[0];
    }
    /**
   * Updates the particle container's internal state. Call this method after manually modifying
   * the particleChildren array or when changing static properties of particles.
   * @example
   * ```ts
   * // Batch modify particles
   * container.particleChildren.push(...particles);
   * container.update(); // Required after direct array modification
   *
   * // Update static properties
   * container.particleChildren.forEach(particle => {
   *     particle.position.set(
   *         Math.random() * 800,
   *         Math.random() * 600
   *     );
   * });
   * container.update(); // Required after changing static positions
   * ```
   * @see {@link ParticleProperties} For configuring dynamic vs static properties
   * @see {@link ParticleContainer#particleChildren} For direct array access
   */ update() {
        this._childrenDirty = true;
    }
    onViewUpdate() {
        this._childrenDirty = true;
        super.onViewUpdate();
    }
    /**
   * Returns a static empty bounds object since ParticleContainer does not calculate bounds automatically
   * for performance reasons. Use the `boundsArea` property to manually set container bounds.
   * @example
   * ```ts
   * const container = new ParticleContainer({
   *     texture: Texture.from('particle.png')
   * });
   *
   * // Default bounds are empty
   * console.log(container.bounds); // Bounds(0, 0, 0, 0)
   *
   * // Set manual bounds for the particle area
   * container.boundsArea = {
   *     minX: 0,
   *     minY: 0,
   *     maxX: 800,
   *     maxY: 600
   * };
   * ```
   * @readonly
   * @returns {Bounds} An empty bounds object (0,0,0,0)
   * @see {@link Container#boundsArea} For manually setting container bounds
   * @see {@link Bounds} For bounds object structure
   */ get bounds() {
        return $b425caa62af94b42$var$emptyBounds;
    }
    /** @private */ updateBounds() {}
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * particleContainer.destroy();
   * particleContainer.destroy(true);
   * particleContainer.destroy({ texture: true, textureSource: true, children: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            const texture = this.texture ?? this.particleChildren[0]?.texture;
            if (texture) texture.destroy(destroyTextureSource);
        }
        this.texture = null;
        this.shader?.destroy();
    }
    /**
   * Removes all particles from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed particles
   */ removeParticles(beginIndex, endIndex) {
        beginIndex ?? (beginIndex = 0);
        endIndex ?? (endIndex = this.particleChildren.length);
        const children = this.particleChildren.splice(beginIndex, endIndex - beginIndex);
        this.onViewUpdate();
        return children;
    }
    /**
   * Removes a particle from the specified index position.
   * @param index - The index to get the particle from
   * @returns The particle that was removed.
   */ removeParticleAt(index) {
        const child = this.particleChildren.splice(index, 1);
        this.onViewUpdate();
        return child[0];
    }
    /**
   * Adds a particle to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the particle is already in this container, it will be moved to the specified index.
   * @param {Container} child - The particle to add.
   * @param {number} index - The absolute index where the particle will be positioned at the end of the operation.
   * @returns {Container} The particle that was added.
   */ addParticleAt(child, index) {
        this.particleChildren.splice(index, 0, child);
        this.onViewUpdate();
        return child;
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChild(..._children) {
        throw new Error("ParticleContainer.addChild() is not available. Please use ParticleContainer.addParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChild(..._children) {
        throw new Error("ParticleContainer.removeChild() is not available. Please use ParticleContainer.removeParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticles()` instead.
   * @param {number} [_beginIndex]
   * @param {number} [_endIndex]
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildren(_beginIndex, _endIndex) {
        throw new Error("ParticleContainer.removeChildren() is not available. Please use ParticleContainer.removeParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildAt(_index) {
        throw new Error("ParticleContainer.removeChildAt() is not available. Please use ParticleContainer.removeParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildAt(_index) {
        throw new Error("ParticleContainer.getChildAt() is not available. Please use ParticleContainer.getParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.setParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ setChildIndex(_child, _index) {
        throw new Error("ParticleContainer.setChildIndex() is not available. Please use ParticleContainer.setParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildIndex(_child) {
        throw new Error("ParticleContainer.getChildIndex() is not available. Please use ParticleContainer.getParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticleAt()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChildAt(_child, _index) {
        throw new Error("ParticleContainer.addChildAt() is not available. Please use ParticleContainer.addParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.swapParticles()` instead.
   * @param {ContainerChild} _child
   * @param {ContainerChild} _child2
   * @ignore
   */ swapChildren(_child, _child2) {
        throw new Error("ParticleContainer.swapChildren() is not available. Please use ParticleContainer.swapParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChild(..._child) {
        throw new Error("ParticleContainer.reparentChild() is not available with the particle container");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @param _index - The index to reparent the child to
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChildAt(_child, _index) {
        throw new Error("ParticleContainer.reparentChildAt() is not available with the particle container");
    }
};
/**
 * Defines the default options for creating a ParticleContainer.
 * @example
 * ```ts
 * // Change defaults globally
 * ParticleContainer.defaultOptions = {
 *     dynamicProperties: {
 *         position: true,  // Update positions each frame
 *         rotation: true,  // Update rotations each frame
 *         vertex: false,   // Static vertices
 *         uvs: false,      // Static texture coordinates
 *         color: false     // Static colors
 *     },
 *     roundPixels: true // Enable pixel rounding for crisp rendering
 * };
 * ```
 * @property {Record<string, boolean>} dynamicProperties - Specifies which properties are dynamic.
 * @property {boolean} roundPixels - Indicates if pixels should be rounded.
 */ $b425caa62af94b42$var$_ParticleContainer.defaultOptions = {
    /** Specifies which properties are dynamic. */ dynamicProperties: {
        /** Indicates if vertex positions are dynamic. */ vertex: false,
        /** Indicates if particle positions are dynamic. */ position: true,
        /** Indicates if particle rotations are dynamic. */ rotation: false,
        /** Indicates if UV coordinates are dynamic. */ uvs: false,
        /** Indicates if particle colors are dynamic. */ color: false
    },
    /** Indicates if pixels should be rounded for rendering. */ roundPixels: false
};
let $b425caa62af94b42$export$e63bf72b2cfda112 = $b425caa62af94b42$var$_ParticleContainer;























var $4rhnu = parcelRequire("4rhnu");




















































var $iA5fe = parcelRequire("iA5fe");

var $aFPUT = parcelRequire("aFPUT");

var $a32F4 = parcelRequire("a32F4");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $7e36113173fcb92e$export$daf74670712de91 extends (0, $b9FQU.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this._text}:${this._style.styleKey}:${this._resolution}`;
    }
}
function $7e36113173fcb92e$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}



var $a2eTA = parcelRequire("a2eTA");

var $fM4Mk = parcelRequire("fM4Mk");

var $6RGCN = parcelRequire("6RGCN");

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
let $c7f22f786b0aa888$var$_internalCanvas = null;
let $c7f22f786b0aa888$var$_internalContext = null;
function $c7f22f786b0aa888$var$ensureInternalCanvas(width, height) {
    if (!$c7f22f786b0aa888$var$_internalCanvas) {
        $c7f22f786b0aa888$var$_internalCanvas = (0, $iCGeI.DOMAdapter).get().createCanvas(256, 128);
        $c7f22f786b0aa888$var$_internalContext = $c7f22f786b0aa888$var$_internalCanvas.getContext("2d", {
            willReadFrequently: true
        });
        $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "copy";
        $c7f22f786b0aa888$var$_internalContext.globalAlpha = 1;
    }
    if ($c7f22f786b0aa888$var$_internalCanvas.width < width || $c7f22f786b0aa888$var$_internalCanvas.height < height) {
        $c7f22f786b0aa888$var$_internalCanvas.width = (0, $NbSCN.nextPow2)(width);
        $c7f22f786b0aa888$var$_internalCanvas.height = (0, $NbSCN.nextPow2)(height);
    }
}
function $c7f22f786b0aa888$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c7f22f786b0aa888$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c7f22f786b0aa888$export$550eedf6c679837d(...args) {
    let options = args[0];
    if (!options.canvas) options = {
        canvas: args[0],
        resolution: args[1]
    };
    const { canvas: canvas } = options;
    const resolution = Math.min(options.resolution ?? 1, 1);
    const width = options.width ?? canvas.width;
    const height = options.height ?? canvas.height;
    let output = options.output;
    $c7f22f786b0aa888$var$ensureInternalCanvas(width, height);
    if (!$c7f22f786b0aa888$var$_internalContext) throw new TypeError("Failed to get canvas 2D context");
    $c7f22f786b0aa888$var$_internalContext.drawImage(canvas, 0, 0, width, height, 0, 0, width * resolution, height * resolution);
    const imageData = $c7f22f786b0aa888$var$_internalContext.getImageData(0, 0, width, height);
    const data = imageData.data;
    let left = 0;
    let top = 0;
    let right = width - 1;
    let bottom = height - 1;
    while(top < height && $c7f22f786b0aa888$var$checkRow(data, width, top))++top;
    if (top === height) return (0, $fM4Mk.Rectangle).EMPTY;
    while($c7f22f786b0aa888$var$checkRow(data, width, bottom))--bottom;
    while($c7f22f786b0aa888$var$checkColumn(data, width, left, top, bottom))++left;
    while($c7f22f786b0aa888$var$checkColumn(data, width, right, top, bottom))--right;
    ++right;
    ++bottom;
    $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "source-over";
    $c7f22f786b0aa888$var$_internalContext.strokeRect(left, top, right - left, bottom - top);
    $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "copy";
    output ?? (output = new (0, $fM4Mk.Rectangle)());
    output.set(left / resolution, top / resolution, (right - left) / resolution, (bottom - top) / resolution);
    return output;
}



var $wLFHs = parcelRequire("wLFHs");

var $fI0NC = parcelRequire("fI0NC");

var $4JkiF = parcelRequire("4JkiF");
"use strict";
const $53ece033e8053a02$var$tempRect = new (0, $fM4Mk.Rectangle)();
function $53ece033e8053a02$var$countSpaces(text) {
    let count = 0;
    for(let i = 0; i < text.length; i++)if (text.charCodeAt(i) === 32) count++;
    return count;
}
class $53ece033e8053a02$var$CanvasTextGeneratorClass {
    /**
   * Creates a canvas with the specified text rendered to it.
   *
   * Generates a canvas of appropriate size, renders the text with the provided style,
   * and returns both the canvas/context and a Rectangle representing the text bounds.
   *
   * When trim is enabled in the style, the frame will represent the bounds of the
   * non-transparent pixels, which can be smaller than the full canvas.
   * @param options - The options for generating the text canvas
   * @param options.text - The text to render
   * @param options.style - The style to apply to the text
   * @param options.resolution - The resolution of the canvas (defaults to 1)
   * @param options.padding
   * @returns An object containing the canvas/context and the frame (bounds) of the text
   */ getCanvasAndContext(options) {
        const { text: text, style: style, resolution: resolution = 1 } = options;
        const padding = style._getFinalPadding();
        const measured = (0, $wLFHs.CanvasTextMetrics).measureText(text || " ", style);
        const width = Math.ceil(Math.ceil(Math.max(1, measured.width) + padding * 2) * resolution);
        const height = Math.ceil(Math.ceil(Math.max(1, measured.height) + padding * 2) * resolution);
        const canvasAndContext = (0, $6RGCN.CanvasPool).getOptimalCanvasAndContext(width, height);
        this._renderTextToCanvas(style, padding, resolution, canvasAndContext, measured);
        const frame = style.trim ? (0, $c7f22f786b0aa888$export$550eedf6c679837d)({
            canvas: canvasAndContext.canvas,
            width: width,
            height: height,
            resolution: 1,
            output: $53ece033e8053a02$var$tempRect
        }) : $53ece033e8053a02$var$tempRect.set(0, 0, width, height);
        return {
            canvasAndContext: canvasAndContext,
            frame: frame
        };
    }
    /**
   * Returns a canvas and context to the pool.
   *
   * This should be called when you're done with the canvas to allow reuse
   * and prevent memory leaks.
   * @param canvasAndContext - The canvas and context to return to the pool
   */ returnCanvasAndContext(canvasAndContext) {
        (0, $6RGCN.CanvasPool).returnCanvasAndContext(canvasAndContext);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @param style - The style of the text
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render the text to
   * @param measured - Pre-measured text metrics to avoid duplicate measurement
   */ _renderTextToCanvas(style, padding, resolution, canvasAndContext, measured) {
        if (measured.runsByLine && measured.runsByLine.length > 0) {
            this._renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext);
            return;
        }
        const { canvas: canvas, context: context } = canvasAndContext;
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        const lines = measured.lines;
        const lineHeight = measured.lineHeight;
        const lineWidths = measured.lineWidths;
        const maxLineWidth = measured.maxLineWidth;
        const fontProperties = measured.fontProperties;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        if (style._stroke?.width) {
            const strokeStyle = style._stroke;
            context.lineWidth = strokeStyle.width;
            context.miterLimit = strokeStyle.miterLimit;
            context.lineJoin = strokeStyle.join;
            context.lineCap = strokeStyle.cap;
        }
        context.font = font;
        let linePositionX;
        let linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        const alignWidth = style.wordWrap ? Math.max(style.wordWrapWidth, maxLineWidth) : maxLineWidth;
        const strokeWidth = style._stroke?.width ?? 0;
        const halfStroke = strokeWidth / 2;
        let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
        if (lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (isShadowPass) this._setupDropShadow(context, style, resolution, dsOffsetShadow);
            else {
                const gradientBounds = style._gradientBounds;
                const gradientOffset = style._gradientOffset;
                if (gradientBounds) {
                    const gradientMetrics = {
                        width: gradientBounds.width,
                        height: gradientBounds.height,
                        lineHeight: gradientBounds.height,
                        lines: measured.lines
                    };
                    this._setFillAndStrokeStyles(context, style, gradientMetrics, padding, halfStroke, gradientOffset?.x ?? 0, gradientOffset?.y ?? 0);
                } else if (gradientOffset) this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke, gradientOffset.x, gradientOffset.y);
                else this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke);
                context.shadowColor = "rgba(0,0,0,0)";
            }
            for(let j = 0; j < lines.length; j++){
                linePositionX = halfStroke;
                linePositionY = halfStroke + j * lineHeight + fontProperties.ascent + linePositionYShift;
                linePositionX += this._getAlignmentOffset(lineWidths[j], alignWidth, style.align);
                let wordSpacing = 0;
                if (style.align === "justify" && style.wordWrap && j < lines.length - 1) {
                    const spaces = $53ece033e8053a02$var$countSpaces(lines[j]);
                    if (spaces > 0) wordSpacing = (alignWidth - lineWidths[j]) / spaces;
                }
                if (style._stroke?.width) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, true, wordSpacing);
                if (style._fill !== void 0) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, false, wordSpacing);
            }
        }
    }
    /**
   * Renders tagged text (with per-run styles) to canvas.
   * @param measured - The measured text metrics containing runsByLine
   * @param style - The base text style
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render to
   */ _renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext) {
        const { canvas: canvas, context: context } = canvasAndContext;
        const { runsByLine: runsByLine, lineWidths: lineWidths, maxLineWidth: maxLineWidth, lineAscents: lineAscents, lineHeights: lineHeights, hasDropShadow: hasDropShadow } = measured;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        const passesCount = hasDropShadow ? 2 : 1;
        const alignWidth = style.wordWrap ? Math.max(style.wordWrapWidth, maxLineWidth) : maxLineWidth;
        let maxStrokeWidth = style._stroke?.width ?? 0;
        for (const lineRuns of runsByLine)for (const run of lineRuns){
            const w = run.style._stroke?.width ?? 0;
            if (w > maxStrokeWidth) maxStrokeWidth = w;
        }
        const halfStroke = maxStrokeWidth / 2;
        const runDataByLine = [];
        for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
            const lineRuns = runsByLine[lineIndex];
            const runData = [];
            for (const run of lineRuns){
                const font = (0, $fI0NC.fontStringFromTextStyle)(run.style);
                context.font = font;
                runData.push({
                    width: (0, $wLFHs.CanvasTextMetrics)._measureText(run.text, run.style.letterSpacing, context),
                    font: font
                });
            }
            runDataByLine.push(runData);
        }
        for(let pass = 0; pass < passesCount; ++pass){
            const isShadowPass = hasDropShadow && pass === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (!isShadowPass) context.shadowColor = "rgba(0,0,0,0)";
            let currentY = halfStroke;
            for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
                const lineRuns = runsByLine[lineIndex];
                const lineWidth = lineWidths[lineIndex];
                const lineAscent = lineAscents[lineIndex];
                const currentLineHeight = lineHeights[lineIndex];
                const lineRunData = runDataByLine[lineIndex];
                let linePositionX = halfStroke;
                linePositionX += this._getAlignmentOffset(lineWidth, alignWidth, style.align);
                let wordSpacing = 0;
                if (style.align === "justify" && style.wordWrap && lineIndex < runsByLine.length - 1) {
                    let totalSpaces = 0;
                    for (const run of lineRuns)totalSpaces += $53ece033e8053a02$var$countSpaces(run.text);
                    if (totalSpaces > 0) wordSpacing = (alignWidth - lineWidth) / totalSpaces;
                }
                const linePositionY = currentY + lineAscent;
                let runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._stroke?.width) {
                        const runStroke = run.style._stroke;
                        context.lineWidth = runStroke.width;
                        context.miterLimit = runStroke.miterLimit;
                        context.lineJoin = runStroke.join;
                        context.lineCap = runStroke.cap;
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                const spacesSkipped = $53ece033e8053a02$var$countSpaces(run.text);
                                runX += runWidth + spacesSkipped * wordSpacing;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $wLFHs.CanvasTextMetrics).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.strokeStyle = (0, $4JkiF.getCanvasFillStyle)(runStroke, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, true, wordSpacing);
                    }
                    const spacesInRun = $53ece033e8053a02$var$countSpaces(run.text);
                    runX += runWidth + spacesInRun * wordSpacing;
                }
                runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._fill !== void 0) {
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                const spacesSkipped = $53ece033e8053a02$var$countSpaces(run.text);
                                runX += runWidth + spacesSkipped * wordSpacing;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $wLFHs.CanvasTextMetrics).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.fillStyle = (0, $4JkiF.getCanvasFillStyle)(run.style._fill, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, false, wordSpacing);
                    }
                    const spacesInFillRun = $53ece033e8053a02$var$countSpaces(run.text);
                    runX += runWidth + spacesInFillRun * wordSpacing;
                }
                currentY += currentLineHeight;
            }
        }
    }
    /**
   * Sets fill and stroke styles on the canvas context for text rendering.
   * @param context - The canvas context
   * @param style - The text style
   * @param metrics - The text metrics for gradient calculation
   * @param padding - The padding value
   * @param halfStroke - Half the stroke width
   * @param offsetX - X offset for gradient positioning
   * @param offsetY - Y offset for gradient positioning
   */ _setFillAndStrokeStyles(context, style, metrics, padding, halfStroke, offsetX = 0, offsetY = 0) {
        context.fillStyle = style._fill ? (0, $4JkiF.getCanvasFillStyle)(style._fill, context, metrics, padding * 2, offsetX, offsetY) : null;
        if (style._stroke?.width) {
            const strokePadding = halfStroke + padding * 2;
            context.strokeStyle = (0, $4JkiF.getCanvasFillStyle)(style._stroke, context, metrics, strokePadding, offsetX, offsetY);
        }
    }
    /**
   * Sets up the canvas context for drop shadow rendering.
   * @param context - The canvas context
   * @param style - The text style containing drop shadow options
   * @param resolution - The resolution multiplier
   * @param dsOffsetShadow - The shadow Y offset
   */ _setupDropShadow(context, style, resolution, dsOffsetShadow) {
        context.fillStyle = "black";
        context.strokeStyle = "black";
        const shadowOptions = style.dropShadow;
        const dropShadowColor = shadowOptions.color;
        const dropShadowAlpha = shadowOptions.alpha;
        context.shadowColor = (0, $a2eTA.Color).shared.setValue(dropShadowColor).setAlpha(dropShadowAlpha).toRgbaString();
        const dropShadowBlur = shadowOptions.blur * resolution;
        const dropShadowDistance = shadowOptions.distance * resolution;
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance + dsOffsetShadow;
    }
    /**
   * Calculates the X offset for text alignment.
   * @param lineWidth - The width of the current line
   * @param alignWidth - The width to align against (maxLineWidth or wordWrapWidth)
   * @param align - The text alignment
   * @returns The X offset for this line
   */ _getAlignmentOffset(lineWidth, alignWidth, align) {
        if (align === "right") return alignWidth - lineWidth;
        else if (align === "center") return (alignWidth - lineWidth) / 2;
        return 0;
    }
    /**
   * Render the text with letter-spacing.
   *
   * This method handles rendering text with the correct letter spacing, using either:
   * 1. Native letter spacing if supported by the browser
   * 2. Manual letter spacing calculation if not natively supported
   *
   * For manual letter spacing, it calculates the position of each character
   * based on its width and the desired spacing.
   * @param text - The text to draw
   * @param style - The text style to apply
   * @param canvasAndContext - The canvas and context to draw to
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Whether to render the stroke (true) or fill (false)
   * @param wordSpacing - Extra spacing to add between words (for justify alignment)
   * @private
   */ _drawLetterSpacing(text, style, canvasAndContext, x, y, isStroke = false, wordSpacing = 0) {
        const { context: context } = canvasAndContext;
        const letterSpacing = style.letterSpacing;
        let useExperimentalLetterSpacing = false;
        if ((0, $wLFHs.CanvasTextMetrics).experimentalLetterSpacingSupported) {
            if ((0, $wLFHs.CanvasTextMetrics).experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        if ((letterSpacing === 0 || useExperimentalLetterSpacing) && wordSpacing === 0) {
            if (isStroke) context.strokeText(text, x, y);
            else context.fillText(text, x, y);
            return;
        }
        if (wordSpacing !== 0 && (letterSpacing === 0 || useExperimentalLetterSpacing)) {
            const words = text.split(" ");
            let currentPosition2 = x;
            const spaceWidth = context.measureText(" ").width;
            for(let i = 0; i < words.length; i++){
                if (isStroke) context.strokeText(words[i], currentPosition2, y);
                else context.fillText(words[i], currentPosition2, y);
                currentPosition2 += context.measureText(words[i]).width + spaceWidth + wordSpacing;
            }
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $wLFHs.CanvasTextMetrics).graphemeSegmenter(text);
        let previousWidth = context.measureText(text).width;
        let currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            if (isStroke) context.strokeText(currentChar, currentPosition, y);
            else context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            if (currentChar === " ") currentPosition += wordSpacing;
            previousWidth = currentWidth;
        }
    }
}
const $53ece033e8053a02$export$bb54b62b519176d5 = new $53ece033e8053a02$var$CanvasTextGeneratorClass();



var $wLFHs = parcelRequire("wLFHs");

var $eKNW7 = parcelRequire("eKNW7");

var $i9BKe = parcelRequire("i9BKe");

var $i9BKe = parcelRequire("i9BKe");

var $1DS3C = parcelRequire("1DS3C");

var $f8J9J = parcelRequire("f8J9J");
"use strict";
function $290a944e424ac156$export$cd6ce24a38c376aa(batchableSprite, text) {
    const { texture: texture, bounds: bounds } = batchableSprite;
    const padding = text._style._getFinalPadding();
    (0, $f8J9J.updateQuadBounds)(bounds, text._anchor, texture);
    const paddingOffset = text._anchor._x * padding * 2;
    const paddingOffsetY = text._anchor._y * padding * 2;
    bounds.minX -= padding - paddingOffset;
    bounds.minY -= padding - paddingOffsetY;
    bounds.maxX -= padding - paddingOffset;
    bounds.maxY -= padding - paddingOffsetY;
}



var $6qNFd = parcelRequire("6qNFd");
"use strict";
class $f058ad147e9df630$export$f986f9176e9ba9b4 extends (0, $6qNFd.BatchableSprite) {
}


"use strict";
class $c066d8737bdb07a6$export$ed0d779e44b53050 {
    constructor(renderer){
        this._renderer = renderer;
        renderer.runners.resolutionChange.add(this);
        this._managedTexts = new (0, $1DS3C.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            onUnload: this.onTextUnload.bind(this),
            name: "canvasText"
        });
    }
    resolutionChange() {
        for(const key in this._managedTexts.items){
            const text = this._managedTexts.items[key];
            if (text?._autoResolution) text.onViewUpdate();
        }
    }
    validateRenderable(text) {
        const gpuText = this._getGpuText(text);
        const newKey = text.styleKey;
        if (gpuText.currentKey !== newKey) return true;
        return text._didTextUpdate;
    }
    addRenderable(text, instructionSet) {
        const batchableText = this._getGpuText(text);
        if (text._didTextUpdate) {
            const resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
            if (batchableText.currentKey !== text.styleKey || text._resolution !== resolution) this._updateGpuText(text);
            text._didTextUpdate = false;
            (0, $290a944e424ac156$export$cd6ce24a38c376aa)(batchableText, text);
        }
        this._renderer.renderPipes.batch.addToBatch(batchableText, instructionSet);
    }
    updateRenderable(text) {
        const batchableText = this._getGpuText(text);
        batchableText._batcher.updateElement(batchableText);
    }
    _updateGpuText(text) {
        const batchableText = this._getGpuText(text);
        if (batchableText.texture) this._renderer.canvasText.decreaseReferenceCount(batchableText.currentKey);
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        batchableText.texture = this._renderer.canvasText.getManagedTexture(text);
        batchableText.currentKey = text.styleKey;
    }
    _getGpuText(text) {
        return text._gpuData[this._renderer.uid] || this.initGpuText(text);
    }
    initGpuText(text) {
        const batchableText = new (0, $f058ad147e9df630$export$f986f9176e9ba9b4)();
        batchableText.currentKey = "--";
        batchableText.renderable = text;
        batchableText.transform = text.groupTransform;
        batchableText.bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        batchableText.roundPixels = this._renderer._roundPixels | text._roundPixels;
        text._gpuData[this._renderer.uid] = batchableText;
        this._managedTexts.add(text);
        return batchableText;
    }
    onTextUnload(text) {
        const gpuData = text._gpuData[this._renderer.uid];
        if (!gpuData) return;
        const { canvasText: canvasText } = this._renderer;
        const refCount = canvasText.getReferenceCount(gpuData.currentKey);
        if (refCount > 0) canvasText.decreaseReferenceCount(gpuData.currentKey);
        else if (gpuData.texture) canvasText.returnTexture(gpuData.texture);
    }
    destroy() {
        this._managedTexts.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $c066d8737bdb07a6$export$ed0d779e44b53050.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLPipes,
        (0, $i9BKe.ExtensionType).WebGPUPipes,
        (0, $i9BKe.ExtensionType).CanvasPipes
    ],
    name: "text"
};



var $i9BKe = parcelRequire("i9BKe");

var $3Xbp7 = parcelRequire("3Xbp7");

var $aFPUT = parcelRequire("aFPUT");

var $kXq8E = parcelRequire("kXq8E");


var $eKNW7 = parcelRequire("eKNW7");

var $3Xbp7 = parcelRequire("3Xbp7");

var $7wtv9 = parcelRequire("7wtv9");
"use strict";
const $eeb1e6506bb24c84$var$tempBounds = new (0, $7wtv9.Bounds)();
function $eeb1e6506bb24c84$export$80c61c6b7fb407a3(image, width, height, resolution, autoGenerateMipmaps = false) {
    const bounds = $eeb1e6506bb24c84$var$tempBounds;
    bounds.minX = 0;
    bounds.minY = 0;
    bounds.maxX = image.width / resolution | 0;
    bounds.maxY = image.height / resolution | 0;
    const texture = (0, $3Xbp7.TexturePool).getOptimalTexture(bounds.width, bounds.height, resolution, false, autoGenerateMipmaps);
    texture.source.uploadMethodId = "image";
    texture.source.resource = image;
    texture.source.alphaMode = "premultiply-alpha-on-upload";
    texture.frame.width = width / resolution;
    texture.frame.height = height / resolution;
    texture.source.emit("update", texture.source);
    texture.updateUvs();
    return texture;
}


"use strict";
class $c7b725dea32b48c5$export$1f58c6bd1c266764 {
    constructor(renderer, retainCanvasContext){
        this._activeTextures = {};
        this._renderer = renderer;
        this._retainCanvasContext = retainCanvasContext;
    }
    getTexture(options, _resolution, _style, _textKey) {
        if (typeof options === "string") {
            (0, $kXq8E.deprecation)("8.0.0", "CanvasTextSystem.getTexture: Use object TextOptions instead of separate arguments");
            options = {
                text: options,
                style: _style,
                resolution: _resolution
            };
        }
        if (!(options.style instanceof (0, $eKNW7.TextStyle))) options.style = new (0, $eKNW7.TextStyle)(options.style);
        if (!(options.textureStyle instanceof (0, $aFPUT.TextureStyle))) options.textureStyle = new (0, $aFPUT.TextureStyle)(options.textureStyle);
        if (typeof options.text !== "string") options.text = options.text.toString();
        const { text: text, style: style, textureStyle: textureStyle, autoGenerateMipmaps: autoGenerateMipmaps } = options;
        const resolution = options.resolution ?? this._renderer.resolution;
        const { frame: frame, canvasAndContext: canvasAndContext } = (0, $53ece033e8053a02$export$bb54b62b519176d5).getCanvasAndContext({
            text: text,
            style: style,
            resolution: resolution
        });
        const texture = (0, $eeb1e6506bb24c84$export$80c61c6b7fb407a3)(canvasAndContext.canvas, frame.width, frame.height, resolution, autoGenerateMipmaps);
        if (textureStyle) texture.source.style = textureStyle;
        if (style.trim) {
            frame.pad(style.padding);
            texture.frame.copyFrom(frame);
            texture.frame.scale(1 / resolution);
            texture.updateUvs();
        }
        if (style.filters) {
            const filteredTexture = this._applyFilters(texture, style.filters);
            this.returnTexture(texture);
            (0, $53ece033e8053a02$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            return filteredTexture;
        }
        this._renderer.texture.initSource(texture._source);
        if (!this._retainCanvasContext) (0, $53ece033e8053a02$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
        return texture;
    }
    /**
   * Returns a texture that was created wit the above `getTexture` function.
   * Handy if you are done with a texture and want to return it to the pool.
   * @param texture - The texture to be returned.
   */ returnTexture(texture) {
        const source = texture.source;
        const resource = source.resource;
        if (this._retainCanvasContext && resource?.getContext) {
            const context = resource.getContext("2d");
            if (context) (0, $53ece033e8053a02$export$bb54b62b519176d5).returnCanvasAndContext({
                canvas: resource,
                context: context
            });
        }
        source.resource = null;
        source.uploadMethodId = "unknown";
        source.alphaMode = "no-premultiply-alpha";
        (0, $3Xbp7.TexturePool).returnTexture(texture, true);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @deprecated since 8.10.0
   */ renderTextToCanvas() {
        (0, $kXq8E.deprecation)("8.10.0", "CanvasTextSystem.renderTextToCanvas: no longer supported, use CanvasTextSystem.getTexture instead");
    }
    /**
   * Gets or creates a managed texture for a Text object. This method handles texture reuse and reference counting.
   * @param text - The Text object that needs a texture
   * @returns A Texture instance that represents the rendered text
   * @remarks
   * This method performs the following:
   * 1. Sets the appropriate resolution based on auto-resolution settings
   * 2. Checks if a texture already exists for the text's style
   * 3. Creates a new texture if needed or returns an existing one
   * 4. Manages reference counting for texture reuse
   */ getManagedTexture(text) {
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        const textKey = text.styleKey;
        if (this._activeTextures[textKey]) {
            this._increaseReferenceCount(textKey);
            return this._activeTextures[textKey].texture;
        }
        const texture = this.getTexture({
            text: text.text,
            style: text.style,
            resolution: text._resolution,
            textureStyle: text.textureStyle,
            autoGenerateMipmaps: text.autoGenerateMipmaps
        });
        this._activeTextures[textKey] = {
            texture: texture,
            usageCount: 1
        };
        return texture;
    }
    /**
   * Decreases the reference count for a texture associated with a text key.
   * When the reference count reaches zero, the texture is returned to the pool.
   * @param textKey - The unique key identifying the text style configuration
   * @remarks
   * This method is crucial for memory management, ensuring textures are properly
   * cleaned up when they are no longer needed by any Text instances.
   */ decreaseReferenceCount(textKey) {
        const activeTexture = this._activeTextures[textKey];
        if (!activeTexture) return;
        activeTexture.usageCount--;
        if (activeTexture.usageCount === 0) {
            this.returnTexture(activeTexture.texture);
            this._activeTextures[textKey] = null;
        }
    }
    /**
   * Gets the current reference count for a texture associated with a text key.
   * @param textKey - The unique key identifying the text style configuration
   * @returns The number of Text instances currently using this texture
   */ getReferenceCount(textKey) {
        return this._activeTextures[textKey]?.usageCount ?? 0;
    }
    _increaseReferenceCount(textKey) {
        this._activeTextures[textKey].usageCount++;
    }
    /**
   * Applies the specified filters to the given texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture. It also ensures that the alpha mode of the resulting
   * texture is set to 'premultiplied-alpha'.
   * @param {Texture} texture - The texture to which the filters will be applied.
   * @param {Filter[]} filters - The filters to apply to the texture.
   * @returns {Texture} The resulting texture after all filters have been applied.
   */ _applyFilters(texture, filters) {
        const currentRenderTarget = this._renderer.renderTarget.renderTarget;
        const resultTexture = this._renderer.filter.generateFilteredTexture({
            texture: texture,
            filters: filters
        });
        this._renderer.renderTarget.bind(currentRenderTarget, false);
        return resultTexture;
    }
    destroy() {
        this._renderer = null;
        for(const key in this._activeTextures)if (this._activeTextures[key]) this.returnTexture(this._activeTextures[key].texture);
        this._activeTextures = null;
    }
}


"use strict";
class $78c42d114b108bc4$export$b13c6e11d8ae9690 extends (0, $c7b725dea32b48c5$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, true);
    }
}
/** @ignore */ $78c42d114b108bc4$export$b13c6e11d8ae9690.extension = {
    type: [
        (0, $i9BKe.ExtensionType).CanvasSystem
    ],
    name: "canvasText"
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
class $4454a0c768822ab8$export$56e4907c2e518abc extends (0, $c7b725dea32b48c5$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, false);
    }
}
/** @ignore */ $4454a0c768822ab8$export$56e4907c2e518abc.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "canvasText"
};


"use strict";
(0, $i9BKe.extensions).add((0, $78c42d114b108bc4$export$b13c6e11d8ae9690));
(0, $i9BKe.extensions).add((0, $4454a0c768822ab8$export$56e4907c2e518abc));
(0, $i9BKe.extensions).add((0, $c066d8737bdb07a6$export$ed0d779e44b53050));


"use strict";
class $dd84afd4ef9f1e09$export$5f1af8db9871e1d6 extends (0, $7e36113173fcb92e$export$daf74670712de91) {
    constructor(...args){
        const options = (0, $7e36113173fcb92e$export$8ddfb4f614f8ed86)(args, "Text");
        super(options, (0, $eKNW7.TextStyle));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $aFPUT.TextureStyle) ? options.textureStyle : new (0, $aFPUT.TextureStyle)(options.textureStyle);
        this.autoGenerateMipmaps = options.autoGenerateMipmaps ?? (0, $iA5fe.TextureSource).defaultOptions.autoGenerateMipmaps;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $53ece033e8053a02$export$bb54b62b519176d5).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $53ece033e8053a02$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $wLFHs.CanvasTextMetrics).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}



var $eKNW7 = parcelRequire("eKNW7");



















var $3vRz3 = parcelRequire("3vRz3");




















"use strict";
(0, $i9BKe.extensions).add((0, $c220e1d99a2da004$export$a6aad6334ef58a1c), (0, $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8));


var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $1HooC = parcelRequire("1HooC");
var $4rhnu = parcelRequire("4rhnu");
var $eKNW7 = parcelRequire("eKNW7");
var $08d460a2845743e4$exports = {};
$08d460a2845743e4$exports = import.meta.resolve("bWPRC");


var $bef0165d1ad394b0$exports = {};
$bef0165d1ad394b0$exports = import.meta.resolve("eKIoz");


var $c86de67ff8578ac6$exports = {};
$c86de67ff8578ac6$exports = import.meta.resolve("6FSlq");


var $ad859356d32f3a79$exports = {};
$ad859356d32f3a79$exports = import.meta.resolve("hvM7i");


var $6f2d3d314a720f3a$exports = {};
$6f2d3d314a720f3a$exports = import.meta.resolve("guiaY");


var $71da43bcfecbc88f$exports = {};
$71da43bcfecbc88f$exports = import.meta.resolve("6bpUe");


var $7a5a24d9cc7c7b72$exports = {};
$7a5a24d9cc7c7b72$exports = import.meta.resolve("jTiKQ");


var $46a2be3ffa3bfd30$exports = {};
$46a2be3ffa3bfd30$exports = import.meta.resolve("lB51l");


var $dbc2c9c10a838714$exports = {};
$dbc2c9c10a838714$exports = import.meta.resolve("a9zK1");


var $806881d35f5528af$exports = {};
$806881d35f5528af$exports = import.meta.resolve("6VYuM");


var $1a35ac73ddb3ee8a$export$a441d440b06e3168 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $1a35ac73ddb3ee8a$export$22b09f878622677a(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}


var $1f66f670f0127866$export$5edeffb658f039f4 = {
    exports: {}
};


var $fa525fd94a8427c4$var$hasRequiredEventemitter3;
function $fa525fd94a8427c4$export$b88c30a9414655a0() {
    if ($fa525fd94a8427c4$var$hasRequiredEventemitter3) return (0, $1f66f670f0127866$export$5edeffb658f039f4).exports;
    $fa525fd94a8427c4$var$hasRequiredEventemitter3 = 1;
    (function(module) {
        var has = Object.prototype.hasOwnProperty, prefix = '~';
        /**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */ function Events() {}
        //
        // We try to not inherit from `Object.prototype`. In some engines creating an
        // instance in this way is faster than calling `Object.create(null)` directly.
        // If `Object.create(null)` is not supported we prefix the event names with a
        // character to make sure that the built-in object properties are not
        // overridden or used as an attack vector.
        //
        if (Object.create) {
            Events.prototype = Object.create(null);
            //
            // This hack is needed because the `__proto__` property is still inherited in
            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
            //
            if (!new Events().__proto__) prefix = false;
        }
        /**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */ function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        /**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */ function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        /**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */ function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        /**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */ function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        /**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */ EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        /**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */ EventEmitter.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        /**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        /**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        /**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        /**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        /**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                //
                // Reset the array, or remove it completely if we have no more listeners.
                //
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        /**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        //
        // Alias methods names because people roll like that.
        //
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
        //
        // Expose the prefix.
        //
        EventEmitter.prefixed = prefix;
        //
        // Allow `EventEmitter` to be imported as module namespace.
        //
        EventEmitter.EventEmitter = EventEmitter;
        module.exports = EventEmitter;
    })((0, $1f66f670f0127866$export$5edeffb658f039f4));
    return (0, $1f66f670f0127866$export$5edeffb658f039f4).exports;
}


var $1cc29b2b9ac0411b$var$eventemitter3Exports = (0, $fa525fd94a8427c4$export$b88c30a9414655a0)();
var $1cc29b2b9ac0411b$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $1a35ac73ddb3ee8a$export$22b09f878622677a)($1cc29b2b9ac0411b$var$eventemitter3Exports);


var $403a382f9acbc955$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($403a382f9acbc955$export$7debb50ef11d5e0b || ($403a382f9acbc955$export$7debb50ef11d5e0b = {}));
var $403a382f9acbc955$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($403a382f9acbc955$export$4aa2142c225fd5c7 || ($403a382f9acbc955$export$4aa2142c225fd5c7 = {}));
const $403a382f9acbc955$export$5716da67bfaa244d = $403a382f9acbc955$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $403a382f9acbc955$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $403a382f9acbc955$export$5716da67bfaa244d.undefined;
        case "string":
            return $403a382f9acbc955$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $403a382f9acbc955$export$5716da67bfaa244d.nan : $403a382f9acbc955$export$5716da67bfaa244d.number;
        case "boolean":
            return $403a382f9acbc955$export$5716da67bfaa244d.boolean;
        case "function":
            return $403a382f9acbc955$export$5716da67bfaa244d.function;
        case "bigint":
            return $403a382f9acbc955$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $403a382f9acbc955$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $403a382f9acbc955$export$5716da67bfaa244d.array;
            if (data === null) return $403a382f9acbc955$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $403a382f9acbc955$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $403a382f9acbc955$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $403a382f9acbc955$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $403a382f9acbc955$export$5716da67bfaa244d.date;
            return $403a382f9acbc955$export$5716da67bfaa244d.object;
        default:
            return $403a382f9acbc955$export$5716da67bfaa244d.unknown;
    }
};
const $403a382f9acbc955$export$5ba560653e4a1035 = $403a382f9acbc955$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $403a382f9acbc955$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $403a382f9acbc955$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $403a382f9acbc955$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $403a382f9acbc955$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$403a382f9acbc955$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $403a382f9acbc955$export$f98dac4b251ab333(issues);
    return error;
};
const $403a382f9acbc955$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $403a382f9acbc955$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $403a382f9acbc955$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$403a382f9acbc955$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$403a382f9acbc955$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$403a382f9acbc955$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $403a382f9acbc955$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $403a382f9acbc955$var$overrideErrorMap = $403a382f9acbc955$export$341b0b6e0a6f5099;
function $403a382f9acbc955$export$1097a8289cfd22d7(map) {
    $403a382f9acbc955$var$overrideErrorMap = map;
}
function $403a382f9acbc955$export$32f27c719778d4c4() {
    return $403a382f9acbc955$var$overrideErrorMap;
}
const $403a382f9acbc955$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $403a382f9acbc955$export$1526d2e05f74572 = [];
function $403a382f9acbc955$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $403a382f9acbc955$export$32f27c719778d4c4();
    const issue = $403a382f9acbc955$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $403a382f9acbc955$export$341b0b6e0a6f5099 ? undefined : $403a382f9acbc955$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $403a382f9acbc955$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $403a382f9acbc955$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $403a382f9acbc955$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $403a382f9acbc955$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $403a382f9acbc955$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $403a382f9acbc955$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $403a382f9acbc955$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $403a382f9acbc955$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $403a382f9acbc955$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return state.get(receiver);
}
function $403a382f9acbc955$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $403a382f9acbc955$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($403a382f9acbc955$var$errorUtil || ($403a382f9acbc955$var$errorUtil = {}));
var $403a382f9acbc955$var$_ZodEnum_cache, $403a382f9acbc955$var$_ZodNativeEnum_cache;
class $403a382f9acbc955$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $403a382f9acbc955$var$handleResult = (ctx, result)=>{
    if ($403a382f9acbc955$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $403a382f9acbc955$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $403a382f9acbc955$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $403a382f9acbc955$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $403a382f9acbc955$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $403a382f9acbc955$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $403a382f9acbc955$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($403a382f9acbc955$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $403a382f9acbc955$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $403a382f9acbc955$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $403a382f9acbc955$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($403a382f9acbc955$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $403a382f9acbc955$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $403a382f9acbc955$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $403a382f9acbc955$export$a60af00cc0ce2582({
            schema: this,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $403a382f9acbc955$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $403a382f9acbc955$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $403a382f9acbc955$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $403a382f9acbc955$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $403a382f9acbc955$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $403a382f9acbc955$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $403a382f9acbc955$export$a60af00cc0ce2582({
            ...$403a382f9acbc955$var$processCreateParams(this._def),
            schema: this,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $403a382f9acbc955$export$bb19b37874861e7e({
            ...$403a382f9acbc955$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $403a382f9acbc955$export$66b0c798a395271f({
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$403a382f9acbc955$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $403a382f9acbc955$export$75a44ec6249ac76b({
            ...$403a382f9acbc955$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $403a382f9acbc955$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $403a382f9acbc955$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $403a382f9acbc955$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $403a382f9acbc955$var$cuid2Regex = /^[0-9a-z]+$/;
const $403a382f9acbc955$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $403a382f9acbc955$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $403a382f9acbc955$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $403a382f9acbc955$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $403a382f9acbc955$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $403a382f9acbc955$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $403a382f9acbc955$var$emojiRegex;
// faster, simpler, safer
const $403a382f9acbc955$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $403a382f9acbc955$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $403a382f9acbc955$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $403a382f9acbc955$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $403a382f9acbc955$var$dateRegex = new RegExp(`^${$403a382f9acbc955$var$dateRegexSource}$`);
function $403a382f9acbc955$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $403a382f9acbc955$var$timeRegex(args) {
    return new RegExp(`^${$403a382f9acbc955$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $403a382f9acbc955$export$a4b563879add27a(args) {
    let regex = `${$403a382f9acbc955$var$dateRegexSource}T${$403a382f9acbc955$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $403a382f9acbc955$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $403a382f9acbc955$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $403a382f9acbc955$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $403a382f9acbc955$export$1230eb29b8d3b502 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const status = new $403a382f9acbc955$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$403a382f9acbc955$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$403a382f9acbc955$var$emojiRegex) $403a382f9acbc955$var$emojiRegex = new RegExp($403a382f9acbc955$var$_emojiRegex, "u");
                if (!$403a382f9acbc955$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$403a382f9acbc955$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$403a382f9acbc955$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$403a382f9acbc955$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$403a382f9acbc955$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$403a382f9acbc955$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $403a382f9acbc955$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $403a382f9acbc955$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $403a382f9acbc955$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$403a382f9acbc955$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$403a382f9acbc955$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$403a382f9acbc955$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_string,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $403a382f9acbc955$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$403a382f9acbc955$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$403a382f9acbc955$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$403a382f9acbc955$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$403a382f9acbc955$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$403a382f9acbc955$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $403a382f9acbc955$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $403a382f9acbc955$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $403a382f9acbc955$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $403a382f9acbc955$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$403a382f9acbc955$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $403a382f9acbc955$export$1230eb29b8d3b502({
        checks: [],
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $403a382f9acbc955$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $403a382f9acbc955$export$5b070a55c0c43e09 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $403a382f9acbc955$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$403a382f9acbc955$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($403a382f9acbc955$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $403a382f9acbc955$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $403a382f9acbc955$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $403a382f9acbc955$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $403a382f9acbc955$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$403a382f9acbc955$export$5b070a55c0c43e09.create = (params)=>{
    return new $403a382f9acbc955$export$5b070a55c0c43e09({
        checks: [],
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$67d741fd70ff98f4 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $403a382f9acbc955$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $403a382f9acbc955$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $403a382f9acbc955$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $403a382f9acbc955$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $403a382f9acbc955$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$403a382f9acbc955$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $403a382f9acbc955$export$67d741fd70ff98f4({
        checks: [],
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$723d146f80596191 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$723d146f80596191.create = (params)=>{
    return new $403a382f9acbc955$export$723d146f80596191({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$e974be33bdc55521 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_date
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const status = new $403a382f9acbc955$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $403a382f9acbc955$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $403a382f9acbc955$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$403a382f9acbc955$export$e974be33bdc55521.create = (params)=>{
    return new $403a382f9acbc955$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodDate,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$bcc3b40f6b638044 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$bcc3b40f6b638044.create = (params)=>{
    return new $403a382f9acbc955$export$bcc3b40f6b638044({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodSymbol,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$4e780e961c30340d extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$4e780e961c30340d.create = (params)=>{
    return new $403a382f9acbc955$export$4e780e961c30340d({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodUndefined,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$a96281f914484f2d extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$a96281f914484f2d.create = (params)=>{
    return new $403a382f9acbc955$export$a96281f914484f2d({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNull,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$b9d1edb536b4e4eb extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $403a382f9acbc955$export$b9d1edb536b4e4eb({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodAny,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$ef3b1bb1630977ae extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$ef3b1bb1630977ae.create = (params)=>{
    return new $403a382f9acbc955$export$ef3b1bb1630977ae({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodUnknown,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$1e576a20c3ce9fb5 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
            code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
            expected: $403a382f9acbc955$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $403a382f9acbc955$export$9a105a556e65c2c0;
    }
}
$403a382f9acbc955$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $403a382f9acbc955$export$1e576a20c3ce9fb5({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNever,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$7d39f5df85f21031 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
}
$403a382f9acbc955$export$7d39f5df85f21031.create = (params)=>{
    return new $403a382f9acbc955$export$7d39f5df85f21031({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodVoid,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$7acfc3e64785411 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.array) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $403a382f9acbc955$export$5ba560653e4a1035.too_big : $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $403a382f9acbc955$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $403a382f9acbc955$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $403a382f9acbc955$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $403a382f9acbc955$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $403a382f9acbc955$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $403a382f9acbc955$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$403a382f9acbc955$export$7acfc3e64785411.create = (schema, params)=>{
    return new $403a382f9acbc955$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodArray,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
function $403a382f9acbc955$var$deepPartialify(schema) {
    if (schema instanceof $403a382f9acbc955$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $403a382f9acbc955$export$aa56fec1e9d629b8.create($403a382f9acbc955$var$deepPartialify(fieldSchema));
        }
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $403a382f9acbc955$export$7acfc3e64785411) return new $403a382f9acbc955$export$7acfc3e64785411({
        ...schema._def,
        type: $403a382f9acbc955$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $403a382f9acbc955$export$aa56fec1e9d629b8) return $403a382f9acbc955$export$aa56fec1e9d629b8.create($403a382f9acbc955$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $403a382f9acbc955$export$aaac0b8b429cef5) return $403a382f9acbc955$export$aaac0b8b429cef5.create($403a382f9acbc955$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $403a382f9acbc955$export$e2a18bb771d8e6a3) return $403a382f9acbc955$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$403a382f9acbc955$var$deepPartialify(item)));
    else return schema;
}
class $403a382f9acbc955$export$736315c5b55efbad extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $403a382f9acbc955$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $403a382f9acbc955$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                        code: $403a382f9acbc955$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $403a382f9acbc955$var$errorUtil.errToObj;
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $403a382f9acbc955$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $403a382f9acbc955$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $403a382f9acbc955$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $403a382f9acbc955$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $403a382f9acbc955$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $403a382f9acbc955$var$createZodEnum($403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$403a382f9acbc955$export$736315c5b55efbad.create = (shape, params)=>{
    return new $403a382f9acbc955$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $403a382f9acbc955$export$1e576a20c3ce9fb5.create(),
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodObject,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
$403a382f9acbc955$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $403a382f9acbc955$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $403a382f9acbc955$export$1e576a20c3ce9fb5.create(),
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodObject,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
$403a382f9acbc955$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $403a382f9acbc955$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $403a382f9acbc955$export$1e576a20c3ce9fb5.create(),
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodObject,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$a8b236cb5070a311 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $403a382f9acbc955$export$f98dac4b251ab333(result.ctx.common.issues));
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $403a382f9acbc955$export$f98dac4b251ab333(issues));
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$403a382f9acbc955$export$a8b236cb5070a311.create = (types, params)=>{
    return new $403a382f9acbc955$export$a8b236cb5070a311({
        options: types,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodUnion,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $403a382f9acbc955$var$getDiscriminator = (type)=>{
    if (type instanceof $403a382f9acbc955$export$378d0cfce37406e6) return $403a382f9acbc955$var$getDiscriminator(type.schema);
    else if (type instanceof $403a382f9acbc955$export$a60af00cc0ce2582) return $403a382f9acbc955$var$getDiscriminator(type.innerType());
    else if (type instanceof $403a382f9acbc955$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $403a382f9acbc955$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $403a382f9acbc955$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $403a382f9acbc955$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $403a382f9acbc955$export$bb19b37874861e7e) return $403a382f9acbc955$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $403a382f9acbc955$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $403a382f9acbc955$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $403a382f9acbc955$export$aa56fec1e9d629b8) return [
        undefined,
        ...$403a382f9acbc955$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $403a382f9acbc955$export$aaac0b8b429cef5) return [
        null,
        ...$403a382f9acbc955$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $403a382f9acbc955$export$66b0c798a395271f) return $403a382f9acbc955$var$getDiscriminator(type.unwrap());
    else if (type instanceof $403a382f9acbc955$export$5d1f7ef05c4e493a) return $403a382f9acbc955$var$getDiscriminator(type.unwrap());
    else if (type instanceof $403a382f9acbc955$export$75a44ec6249ac76b) return $403a382f9acbc955$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $403a382f9acbc955$export$5ef2424805ac76a3 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.object) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $403a382f9acbc955$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $403a382f9acbc955$export$5ef2424805ac76a3({
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$403a382f9acbc955$var$processCreateParams(params)
        });
    }
}
function $403a382f9acbc955$var$mergeValues(a, b) {
    const aType = $403a382f9acbc955$export$3e9057828ebd5c7a(a);
    const bType = $403a382f9acbc955$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $403a382f9acbc955$export$5716da67bfaa244d.object && bType === $403a382f9acbc955$export$5716da67bfaa244d.object) {
        const bKeys = $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $403a382f9acbc955$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $403a382f9acbc955$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $403a382f9acbc955$export$5716da67bfaa244d.array && bType === $403a382f9acbc955$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $403a382f9acbc955$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $403a382f9acbc955$export$5716da67bfaa244d.date && bType === $403a382f9acbc955$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $403a382f9acbc955$export$c02deaf0bb5203d4 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($403a382f9acbc955$export$afa861e3c5730743(parsedLeft) || $403a382f9acbc955$export$afa861e3c5730743(parsedRight)) return $403a382f9acbc955$export$9a105a556e65c2c0;
            const merged = $403a382f9acbc955$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $403a382f9acbc955$export$9a105a556e65c2c0;
            }
            if ($403a382f9acbc955$export$910b6cdd390341b3(parsedLeft) || $403a382f9acbc955$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$403a382f9acbc955$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $403a382f9acbc955$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodIntersection,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$e2a18bb771d8e6a3 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.array) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $403a382f9acbc955$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$403a382f9acbc955$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $403a382f9acbc955$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$a2acc09968cb4b7f extends $403a382f9acbc955$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.object) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $403a382f9acbc955$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $403a382f9acbc955$export$19342e026b58ebb7) return new $403a382f9acbc955$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodRecord,
            ...$403a382f9acbc955$var$processCreateParams(third)
        });
        return new $403a382f9acbc955$export$a2acc09968cb4b7f({
            keyType: $403a382f9acbc955$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodRecord,
            ...$403a382f9acbc955$var$processCreateParams(second)
        });
    }
}
class $403a382f9acbc955$export$163b6a2b712d9542 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.map) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$403a382f9acbc955$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $403a382f9acbc955$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodMap,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$977057706f816712 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.set) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $403a382f9acbc955$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $403a382f9acbc955$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $403a382f9acbc955$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $403a382f9acbc955$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $403a382f9acbc955$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$403a382f9acbc955$export$977057706f816712.create = (valueType, params)=>{
    return new $403a382f9acbc955$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodSet,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$d4602ba55673f53c extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.function) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $403a382f9acbc955$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $403a382f9acbc955$export$32f27c719778d4c4(),
                    $403a382f9acbc955$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $403a382f9acbc955$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $403a382f9acbc955$export$32f27c719778d4c4(),
                    $403a382f9acbc955$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $403a382f9acbc955$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $403a382f9acbc955$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $403a382f9acbc955$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $403a382f9acbc955$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $403a382f9acbc955$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $403a382f9acbc955$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $403a382f9acbc955$export$d4602ba55673f53c({
            ...this._def,
            args: $403a382f9acbc955$export$e2a18bb771d8e6a3.create(items).rest($403a382f9acbc955$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $403a382f9acbc955$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $403a382f9acbc955$export$d4602ba55673f53c({
            args: args ? args : $403a382f9acbc955$export$e2a18bb771d8e6a3.create([]).rest($403a382f9acbc955$export$ef3b1bb1630977ae.create()),
            returns: returns || $403a382f9acbc955$export$ef3b1bb1630977ae.create(),
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodFunction,
            ...$403a382f9acbc955$var$processCreateParams(params)
        });
    }
}
class $403a382f9acbc955$export$378d0cfce37406e6 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$403a382f9acbc955$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $403a382f9acbc955$export$378d0cfce37406e6({
        getter: getter,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodLazy,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$7e44096782a165d3 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$403a382f9acbc955$export$7e44096782a165d3.create = (value, params)=>{
    return new $403a382f9acbc955$export$7e44096782a165d3({
        value: value,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodLiteral,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
function $403a382f9acbc955$var$createZodEnum(values, params) {
    return new $403a382f9acbc955$export$d325d1f0e1c20179({
        values: values,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodEnum,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
}
class $403a382f9acbc955$export$d325d1f0e1c20179 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $403a382f9acbc955$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                expected: $403a382f9acbc955$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (!$403a382f9acbc955$var$__classPrivateFieldGet(this, $403a382f9acbc955$var$_ZodEnum_cache)) $403a382f9acbc955$var$__classPrivateFieldSet(this, $403a382f9acbc955$var$_ZodEnum_cache, new Set(this._def.values));
        if (!$403a382f9acbc955$var$__classPrivateFieldGet(this, $403a382f9acbc955$var$_ZodEnum_cache).has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $403a382f9acbc955$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $403a382f9acbc955$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$403a382f9acbc955$var$_ZodEnum_cache = new WeakMap();
$403a382f9acbc955$export$d325d1f0e1c20179.create = $403a382f9acbc955$var$createZodEnum;
class $403a382f9acbc955$export$370b2e8d6d6f5c56 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $403a382f9acbc955$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $403a382f9acbc955$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.string && ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.number) {
            const expectedValues = $403a382f9acbc955$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                expected: $403a382f9acbc955$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        if (!$403a382f9acbc955$var$__classPrivateFieldGet(this, $403a382f9acbc955$var$_ZodNativeEnum_cache)) $403a382f9acbc955$var$__classPrivateFieldSet(this, $403a382f9acbc955$var$_ZodNativeEnum_cache, new Set($403a382f9acbc955$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)));
        if (!$403a382f9acbc955$var$__classPrivateFieldGet(this, $403a382f9acbc955$var$_ZodNativeEnum_cache).has(input.data)) {
            const expectedValues = $403a382f9acbc955$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return $403a382f9acbc955$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$403a382f9acbc955$var$_ZodNativeEnum_cache = new WeakMap();
$403a382f9acbc955$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $403a382f9acbc955$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNativeEnum,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$3f196b0127d6e50a extends $403a382f9acbc955$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $403a382f9acbc955$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $403a382f9acbc955$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$403a382f9acbc955$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $403a382f9acbc955$export$3f196b0127d6e50a({
        type: schema,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodPromise,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$a60af00cc0ce2582 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $403a382f9acbc955$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $403a382f9acbc955$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $403a382f9acbc955$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $403a382f9acbc955$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $403a382f9acbc955$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $403a382f9acbc955$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$403a382f9acbc955$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$403a382f9acbc955$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $403a382f9acbc955$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$403a382f9acbc955$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $403a382f9acbc955$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
$403a382f9acbc955$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $403a382f9acbc955$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodEffects,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$aa56fec1e9d629b8 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $403a382f9acbc955$export$5716da67bfaa244d.undefined) return $403a382f9acbc955$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$403a382f9acbc955$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $403a382f9acbc955$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodOptional,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$aaac0b8b429cef5 extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $403a382f9acbc955$export$5716da67bfaa244d.null) return $403a382f9acbc955$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$403a382f9acbc955$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $403a382f9acbc955$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNullable,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$bb19b37874861e7e extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $403a382f9acbc955$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$403a382f9acbc955$export$bb19b37874861e7e.create = (type, params)=>{
    return new $403a382f9acbc955$export$bb19b37874861e7e({
        innerType: type,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$75a44ec6249ac76b extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($403a382f9acbc955$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $403a382f9acbc955$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $403a382f9acbc955$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$403a382f9acbc955$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $403a382f9acbc955$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
class $403a382f9acbc955$export$26ccfa0145e8511f extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $403a382f9acbc955$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $403a382f9acbc955$export$db7caee60e5d514d(ctx, {
                code: $403a382f9acbc955$export$5ba560653e4a1035.invalid_type,
                expected: $403a382f9acbc955$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $403a382f9acbc955$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$403a382f9acbc955$export$26ccfa0145e8511f.create = (params)=>{
    return new $403a382f9acbc955$export$26ccfa0145e8511f({
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodNaN,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
const $403a382f9acbc955$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $403a382f9acbc955$export$66b0c798a395271f extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $403a382f9acbc955$export$a3c3ef8a0e95c6da extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $403a382f9acbc955$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $403a382f9acbc955$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $403a382f9acbc955$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $403a382f9acbc955$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $403a382f9acbc955$export$5d1f7ef05c4e493a extends $403a382f9acbc955$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($403a382f9acbc955$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $403a382f9acbc955$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$403a382f9acbc955$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $403a382f9acbc955$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $403a382f9acbc955$export$558106ce543bd011.ZodReadonly,
        ...$403a382f9acbc955$var$processCreateParams(params)
    });
};
function $403a382f9acbc955$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $403a382f9acbc955$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $403a382f9acbc955$export$b9d1edb536b4e4eb.create();
}
const $403a382f9acbc955$export$1ee8ee30835eab8b = {
    object: $403a382f9acbc955$export$736315c5b55efbad.lazycreate
};
var $403a382f9acbc955$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($403a382f9acbc955$export$558106ce543bd011 || ($403a382f9acbc955$export$558106ce543bd011 = {}));
const $403a382f9acbc955$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$403a382f9acbc955$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $403a382f9acbc955$export$22b082955e083ec3 = $403a382f9acbc955$export$1230eb29b8d3b502.create;
const $403a382f9acbc955$export$98e628dec113755e = $403a382f9acbc955$export$5b070a55c0c43e09.create;
const $403a382f9acbc955$export$9e06de0973666692 = $403a382f9acbc955$export$26ccfa0145e8511f.create;
const $403a382f9acbc955$export$a0f65b52274bcc00 = $403a382f9acbc955$export$67d741fd70ff98f4.create;
const $403a382f9acbc955$export$4a21f16c33752377 = $403a382f9acbc955$export$723d146f80596191.create;
const $403a382f9acbc955$export$324d90190a8b822a = $403a382f9acbc955$export$e974be33bdc55521.create;
const $403a382f9acbc955$export$8f701197936bc2a6 = $403a382f9acbc955$export$bcc3b40f6b638044.create;
const $403a382f9acbc955$export$1db45310990710a5 = $403a382f9acbc955$export$4e780e961c30340d.create;
const $403a382f9acbc955$export$7b1b591b262c240 = $403a382f9acbc955$export$a96281f914484f2d.create;
const $403a382f9acbc955$export$4154a199d7d90455 = $403a382f9acbc955$export$b9d1edb536b4e4eb.create;
const $403a382f9acbc955$export$19282c40b967aec6 = $403a382f9acbc955$export$ef3b1bb1630977ae.create;
const $403a382f9acbc955$export$b3e22bcfd64c1022 = $403a382f9acbc955$export$1e576a20c3ce9fb5.create;
const $403a382f9acbc955$export$490e536ee7389aeb = $403a382f9acbc955$export$7d39f5df85f21031.create;
const $403a382f9acbc955$export$2f23118c22fb2630 = $403a382f9acbc955$export$7acfc3e64785411.create;
const $403a382f9acbc955$export$be5493f9613cbbe = $403a382f9acbc955$export$736315c5b55efbad.create;
const $403a382f9acbc955$export$8fb0df5f40d0b477 = $403a382f9acbc955$export$736315c5b55efbad.strictCreate;
const $403a382f9acbc955$export$971dd5b0dfd021b6 = $403a382f9acbc955$export$a8b236cb5070a311.create;
const $403a382f9acbc955$export$4b888e40c4ee26dd = $403a382f9acbc955$export$5ef2424805ac76a3.create;
const $403a382f9acbc955$export$bc86dfbf7795668c = $403a382f9acbc955$export$c02deaf0bb5203d4.create;
const $403a382f9acbc955$export$65e3907585753458 = $403a382f9acbc955$export$e2a18bb771d8e6a3.create;
const $403a382f9acbc955$export$e5185e241753e543 = $403a382f9acbc955$export$a2acc09968cb4b7f.create;
const $403a382f9acbc955$export$871de8747c9eaa88 = $403a382f9acbc955$export$163b6a2b712d9542.create;
const $403a382f9acbc955$export$adaa4cf7ef1b65be = $403a382f9acbc955$export$977057706f816712.create;
const $403a382f9acbc955$export$44e51c8aac7c2deb = $403a382f9acbc955$export$d4602ba55673f53c.create;
const $403a382f9acbc955$export$488013bae63b21da = $403a382f9acbc955$export$378d0cfce37406e6.create;
const $403a382f9acbc955$export$c8ec6e1ec9fefcb0 = $403a382f9acbc955$export$7e44096782a165d3.create;
const $403a382f9acbc955$export$78a99c8d44d72635 = $403a382f9acbc955$export$d325d1f0e1c20179.create;
const $403a382f9acbc955$export$6fe7eca19ebe5199 = $403a382f9acbc955$export$370b2e8d6d6f5c56.create;
const $403a382f9acbc955$export$c957ef27a0ebfd4 = $403a382f9acbc955$export$3f196b0127d6e50a.create;
const $403a382f9acbc955$export$dc573d8a6576cdb3 = $403a382f9acbc955$export$a60af00cc0ce2582.create;
const $403a382f9acbc955$export$516e28dec6a4b6d4 = $403a382f9acbc955$export$aa56fec1e9d629b8.create;
const $403a382f9acbc955$export$133fc36489ac9add = $403a382f9acbc955$export$aaac0b8b429cef5.create;
const $403a382f9acbc955$export$fc37fe19dfda43ee = $403a382f9acbc955$export$a60af00cc0ce2582.createWithPreprocess;
const $403a382f9acbc955$export$43f28b24e1eb8181 = $403a382f9acbc955$export$a3c3ef8a0e95c6da.create;
const $403a382f9acbc955$export$3b3d07727c5b702c = ()=>$403a382f9acbc955$export$22b082955e083ec3().optional();
const $403a382f9acbc955$export$eb150471a61fced6 = ()=>$403a382f9acbc955$export$98e628dec113755e().optional();
const $403a382f9acbc955$export$269251733cdcbbf1 = ()=>$403a382f9acbc955$export$4a21f16c33752377().optional();
const $403a382f9acbc955$export$8c14e57e778d3873 = {
    string: (arg)=>$403a382f9acbc955$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$403a382f9acbc955$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$403a382f9acbc955$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$403a382f9acbc955$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$403a382f9acbc955$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $403a382f9acbc955$export$96c94437c95d7862 = $403a382f9acbc955$export$9a105a556e65c2c0;
var $403a382f9acbc955$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $403a382f9acbc955$export$341b0b6e0a6f5099,
    setErrorMap: $403a382f9acbc955$export$1097a8289cfd22d7,
    getErrorMap: $403a382f9acbc955$export$32f27c719778d4c4,
    makeIssue: $403a382f9acbc955$export$244a85fde9c419ed,
    EMPTY_PATH: $403a382f9acbc955$export$1526d2e05f74572,
    addIssueToContext: $403a382f9acbc955$export$db7caee60e5d514d,
    ParseStatus: $403a382f9acbc955$export$5b20a5c3d05c1f6f,
    INVALID: $403a382f9acbc955$export$9a105a556e65c2c0,
    DIRTY: $403a382f9acbc955$export$325a211da9693fcf,
    OK: $403a382f9acbc955$export$c6813a8d51f77eaf,
    isAborted: $403a382f9acbc955$export$afa861e3c5730743,
    isDirty: $403a382f9acbc955$export$910b6cdd390341b3,
    isValid: $403a382f9acbc955$export$1ea939691cdc45b8,
    isAsync: $403a382f9acbc955$export$aefee5ebe1dcfd9e,
    get util () {
        return $403a382f9acbc955$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $403a382f9acbc955$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $403a382f9acbc955$export$5716da67bfaa244d,
    getParsedType: $403a382f9acbc955$export$3e9057828ebd5c7a,
    ZodType: $403a382f9acbc955$export$19342e026b58ebb7,
    datetimeRegex: $403a382f9acbc955$export$a4b563879add27a,
    ZodString: $403a382f9acbc955$export$1230eb29b8d3b502,
    ZodNumber: $403a382f9acbc955$export$5b070a55c0c43e09,
    ZodBigInt: $403a382f9acbc955$export$67d741fd70ff98f4,
    ZodBoolean: $403a382f9acbc955$export$723d146f80596191,
    ZodDate: $403a382f9acbc955$export$e974be33bdc55521,
    ZodSymbol: $403a382f9acbc955$export$bcc3b40f6b638044,
    ZodUndefined: $403a382f9acbc955$export$4e780e961c30340d,
    ZodNull: $403a382f9acbc955$export$a96281f914484f2d,
    ZodAny: $403a382f9acbc955$export$b9d1edb536b4e4eb,
    ZodUnknown: $403a382f9acbc955$export$ef3b1bb1630977ae,
    ZodNever: $403a382f9acbc955$export$1e576a20c3ce9fb5,
    ZodVoid: $403a382f9acbc955$export$7d39f5df85f21031,
    ZodArray: $403a382f9acbc955$export$7acfc3e64785411,
    ZodObject: $403a382f9acbc955$export$736315c5b55efbad,
    ZodUnion: $403a382f9acbc955$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $403a382f9acbc955$export$5ef2424805ac76a3,
    ZodIntersection: $403a382f9acbc955$export$c02deaf0bb5203d4,
    ZodTuple: $403a382f9acbc955$export$e2a18bb771d8e6a3,
    ZodRecord: $403a382f9acbc955$export$a2acc09968cb4b7f,
    ZodMap: $403a382f9acbc955$export$163b6a2b712d9542,
    ZodSet: $403a382f9acbc955$export$977057706f816712,
    ZodFunction: $403a382f9acbc955$export$d4602ba55673f53c,
    ZodLazy: $403a382f9acbc955$export$378d0cfce37406e6,
    ZodLiteral: $403a382f9acbc955$export$7e44096782a165d3,
    ZodEnum: $403a382f9acbc955$export$d325d1f0e1c20179,
    ZodNativeEnum: $403a382f9acbc955$export$370b2e8d6d6f5c56,
    ZodPromise: $403a382f9acbc955$export$3f196b0127d6e50a,
    ZodEffects: $403a382f9acbc955$export$a60af00cc0ce2582,
    ZodTransformer: $403a382f9acbc955$export$a60af00cc0ce2582,
    ZodOptional: $403a382f9acbc955$export$aa56fec1e9d629b8,
    ZodNullable: $403a382f9acbc955$export$aaac0b8b429cef5,
    ZodDefault: $403a382f9acbc955$export$bb19b37874861e7e,
    ZodCatch: $403a382f9acbc955$export$75a44ec6249ac76b,
    ZodNaN: $403a382f9acbc955$export$26ccfa0145e8511f,
    BRAND: $403a382f9acbc955$export$cf2deea74cde46b4,
    ZodBranded: $403a382f9acbc955$export$66b0c798a395271f,
    ZodPipeline: $403a382f9acbc955$export$a3c3ef8a0e95c6da,
    ZodReadonly: $403a382f9acbc955$export$5d1f7ef05c4e493a,
    custom: $403a382f9acbc955$export$4c00f665f0d4b443,
    Schema: $403a382f9acbc955$export$19342e026b58ebb7,
    ZodSchema: $403a382f9acbc955$export$19342e026b58ebb7,
    late: $403a382f9acbc955$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $403a382f9acbc955$export$558106ce543bd011;
    },
    coerce: $403a382f9acbc955$export$8c14e57e778d3873,
    any: $403a382f9acbc955$export$4154a199d7d90455,
    array: $403a382f9acbc955$export$2f23118c22fb2630,
    bigint: $403a382f9acbc955$export$a0f65b52274bcc00,
    boolean: $403a382f9acbc955$export$4a21f16c33752377,
    date: $403a382f9acbc955$export$324d90190a8b822a,
    discriminatedUnion: $403a382f9acbc955$export$4b888e40c4ee26dd,
    effect: $403a382f9acbc955$export$dc573d8a6576cdb3,
    'enum': $403a382f9acbc955$export$78a99c8d44d72635,
    'function': $403a382f9acbc955$export$44e51c8aac7c2deb,
    'instanceof': $403a382f9acbc955$export$3d916e7c22dbd8b5,
    intersection: $403a382f9acbc955$export$bc86dfbf7795668c,
    lazy: $403a382f9acbc955$export$488013bae63b21da,
    literal: $403a382f9acbc955$export$c8ec6e1ec9fefcb0,
    map: $403a382f9acbc955$export$871de8747c9eaa88,
    nan: $403a382f9acbc955$export$9e06de0973666692,
    nativeEnum: $403a382f9acbc955$export$6fe7eca19ebe5199,
    never: $403a382f9acbc955$export$b3e22bcfd64c1022,
    'null': $403a382f9acbc955$export$7b1b591b262c240,
    nullable: $403a382f9acbc955$export$133fc36489ac9add,
    number: $403a382f9acbc955$export$98e628dec113755e,
    object: $403a382f9acbc955$export$be5493f9613cbbe,
    oboolean: $403a382f9acbc955$export$269251733cdcbbf1,
    onumber: $403a382f9acbc955$export$eb150471a61fced6,
    optional: $403a382f9acbc955$export$516e28dec6a4b6d4,
    ostring: $403a382f9acbc955$export$3b3d07727c5b702c,
    pipeline: $403a382f9acbc955$export$43f28b24e1eb8181,
    preprocess: $403a382f9acbc955$export$fc37fe19dfda43ee,
    promise: $403a382f9acbc955$export$c957ef27a0ebfd4,
    record: $403a382f9acbc955$export$e5185e241753e543,
    set: $403a382f9acbc955$export$adaa4cf7ef1b65be,
    strictObject: $403a382f9acbc955$export$8fb0df5f40d0b477,
    string: $403a382f9acbc955$export$22b082955e083ec3,
    symbol: $403a382f9acbc955$export$8f701197936bc2a6,
    transformer: $403a382f9acbc955$export$dc573d8a6576cdb3,
    tuple: $403a382f9acbc955$export$65e3907585753458,
    'undefined': $403a382f9acbc955$export$1db45310990710a5,
    union: $403a382f9acbc955$export$971dd5b0dfd021b6,
    unknown: $403a382f9acbc955$export$19282c40b967aec6,
    'void': $403a382f9acbc955$export$490e536ee7389aeb,
    NEVER: $403a382f9acbc955$export$96c94437c95d7862,
    ZodIssueCode: $403a382f9acbc955$export$5ba560653e4a1035,
    quotelessJson: $403a382f9acbc955$export$913eddeaf297cfea,
    ZodError: $403a382f9acbc955$export$f98dac4b251ab333
});




var $7fd5b846378f669f$export$5edeffb658f039f4 = {
    exports: {}
};


var $3da5525ea9fd5e7e$var$hasRequiredBigInteger;
function $3da5525ea9fd5e7e$export$b88c30a9414655a0() {
    if ($3da5525ea9fd5e7e$var$hasRequiredBigInteger) return (0, $7fd5b846378f669f$export$5edeffb658f039f4).exports;
    $3da5525ea9fd5e7e$var$hasRequiredBigInteger = 1;
    (function(module) {
        var bigInt = function(undefined$1) {
            var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
            var supportsNativeBigInt = typeof BigInt === "function";
            function Integer(v, radix, alphabet, caseSensitive) {
                if (typeof v === "undefined") return Integer[0];
                if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
                return parseValue(v);
            }
            function BigInteger(value, sign) {
                this.value = value;
                this.sign = sign;
                this.isSmall = false;
            }
            BigInteger.prototype = Object.create(Integer.prototype);
            function SmallInteger(value) {
                this.value = value;
                this.sign = value < 0;
                this.isSmall = true;
            }
            SmallInteger.prototype = Object.create(Integer.prototype);
            function NativeBigInt(value) {
                this.value = value;
            }
            NativeBigInt.prototype = Object.create(Integer.prototype);
            function isPrecise(n) {
                return -MAX_INT < n && n < MAX_INT;
            }
            function smallToArray(n) {
                if (n < 1e7) return [
                    n
                ];
                if (n < 1e14) return [
                    n % 1e7,
                    Math.floor(n / 1e7)
                ];
                return [
                    n % 1e7,
                    Math.floor(n / 1e7) % 1e7,
                    Math.floor(n / 1e14)
                ];
            }
            function arrayToSmall(arr) {
                trim(arr);
                var length = arr.length;
                if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
                    case 0:
                        return 0;
                    case 1:
                        return arr[0];
                    case 2:
                        return arr[0] + arr[1] * BASE;
                    default:
                        return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
                }
                return arr;
            }
            function trim(v) {
                var i = v.length;
                while(v[--i] === 0);
                v.length = i + 1;
            }
            function createArray(length) {
                var x = new Array(length);
                var i = -1;
                while(++i < length)x[i] = 0;
                return x;
            }
            function truncate(n) {
                if (n > 0) return Math.floor(n);
                return Math.ceil(n);
            }
            function add(a, b) {
                var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
                for(i = 0; i < l_b; i++){
                    sum = a[i] + b[i] + carry;
                    carry = sum >= base ? 1 : 0;
                    r[i] = sum - carry * base;
                }
                while(i < l_a){
                    sum = a[i] + carry;
                    carry = sum === base ? 1 : 0;
                    r[i++] = sum - carry * base;
                }
                if (carry > 0) r.push(carry);
                return r;
            }
            function addAny(a, b) {
                if (a.length >= b.length) return add(a, b);
                return add(b, a);
            }
            function addSmall(a, carry) {
                var l = a.length, r = new Array(l), base = BASE, sum, i;
                for(i = 0; i < l; i++){
                    sum = a[i] - base + carry;
                    carry = Math.floor(sum / base);
                    r[i] = sum - carry * base;
                    carry += 1;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            BigInteger.prototype.add = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.subtract(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
                return new BigInteger(addAny(a, b), this.sign);
            };
            BigInteger.prototype.plus = BigInteger.prototype.add;
            SmallInteger.prototype.add = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.subtract(n.negate());
                var b = n.value;
                if (n.isSmall) {
                    if (isPrecise(a + b)) return new SmallInteger(a + b);
                    b = smallToArray(Math.abs(b));
                }
                return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
            };
            SmallInteger.prototype.plus = SmallInteger.prototype.add;
            NativeBigInt.prototype.add = function(v) {
                return new NativeBigInt(this.value + parseValue(v).value);
            };
            NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
            function subtract(a, b) {
                var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
                for(i = 0; i < b_l; i++){
                    difference = a[i] - borrow - b[i];
                    if (difference < 0) {
                        difference += base;
                        borrow = 1;
                    } else borrow = 0;
                    r[i] = difference;
                }
                for(i = b_l; i < a_l; i++){
                    difference = a[i] - borrow;
                    if (difference < 0) difference += base;
                    else {
                        r[i++] = difference;
                        break;
                    }
                    r[i] = difference;
                }
                for(; i < a_l; i++)r[i] = a[i];
                trim(r);
                return r;
            }
            function subtractAny(a, b, sign) {
                var value;
                if (compareAbs(a, b) >= 0) value = subtract(a, b);
                else {
                    value = subtract(b, a);
                    sign = !sign;
                }
                value = arrayToSmall(value);
                if (typeof value === "number") {
                    if (sign) value = -value;
                    return new SmallInteger(value);
                }
                return new BigInteger(value, sign);
            }
            function subtractSmall(a, b, sign) {
                var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
                for(i = 0; i < l; i++){
                    difference = a[i] + carry;
                    carry = Math.floor(difference / base);
                    difference %= base;
                    r[i] = difference < 0 ? difference + base : difference;
                }
                r = arrayToSmall(r);
                if (typeof r === "number") {
                    if (sign) r = -r;
                    return new SmallInteger(r);
                }
                return new BigInteger(r, sign);
            }
            BigInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.add(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
                return subtractAny(a, b, this.sign);
            };
            BigInteger.prototype.minus = BigInteger.prototype.subtract;
            SmallInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.add(n.negate());
                var b = n.value;
                if (n.isSmall) return new SmallInteger(a - b);
                return subtractSmall(b, Math.abs(a), a >= 0);
            };
            SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
            NativeBigInt.prototype.subtract = function(v) {
                return new NativeBigInt(this.value - parseValue(v).value);
            };
            NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
            BigInteger.prototype.negate = function() {
                return new BigInteger(this.value, !this.sign);
            };
            SmallInteger.prototype.negate = function() {
                var sign = this.sign;
                var small = new SmallInteger(-this.value);
                small.sign = !sign;
                return small;
            };
            NativeBigInt.prototype.negate = function() {
                return new NativeBigInt(-this.value);
            };
            BigInteger.prototype.abs = function() {
                return new BigInteger(this.value, false);
            };
            SmallInteger.prototype.abs = function() {
                return new SmallInteger(Math.abs(this.value));
            };
            NativeBigInt.prototype.abs = function() {
                return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
            };
            function multiplyLong(a, b) {
                var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
                for(i = 0; i < a_l; ++i){
                    a_i = a[i];
                    for(var j = 0; j < b_l; ++j){
                        b_j = b[j];
                        product = a_i * b_j + r[i + j];
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                        r[i + j + 1] += carry;
                    }
                }
                trim(r);
                return r;
            }
            function multiplySmall(a, b) {
                var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
                for(i = 0; i < l; i++){
                    product = a[i] * b + carry;
                    carry = Math.floor(product / base);
                    r[i] = product - carry * base;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            function shiftLeft(x, n) {
                var r = [];
                while(n-- > 0)r.push(0);
                return r.concat(x);
            }
            function multiplyKaratsuba(x, y) {
                var n = Math.max(x.length, y.length);
                if (n <= 30) return multiplyLong(x, y);
                n = Math.ceil(n / 2);
                var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
                var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
                var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
                trim(product);
                return product;
            }
            // The following function is derived from a surface fit of a graph plotting the performance difference
            // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
            function useKaratsuba(l1, l2) {
                return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
            }
            BigInteger.prototype.multiply = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
                if (n.isSmall) {
                    if (b === 0) return Integer[0];
                    if (b === 1) return this;
                    if (b === -1) return this.negate();
                    abs = Math.abs(b);
                    if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
                    b = smallToArray(abs);
                }
                if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
                return new BigInteger(multiplyLong(a, b), sign);
            };
            BigInteger.prototype.times = BigInteger.prototype.multiply;
            function multiplySmallAndArray(a, b, sign) {
                if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
                return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
            }
            SmallInteger.prototype._multiplyBySmall = function(a) {
                if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
                return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
            };
            BigInteger.prototype._multiplyBySmall = function(a) {
                if (a.value === 0) return Integer[0];
                if (a.value === 1) return this;
                if (a.value === -1) return this.negate();
                return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
            };
            SmallInteger.prototype.multiply = function(v) {
                return parseValue(v)._multiplyBySmall(this);
            };
            SmallInteger.prototype.times = SmallInteger.prototype.multiply;
            NativeBigInt.prototype.multiply = function(v) {
                return new NativeBigInt(this.value * parseValue(v).value);
            };
            NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
            function square(a) {
                //console.assert(2 * BASE * BASE < MAX_INT);
                var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
                for(i = 0; i < l; i++){
                    a_i = a[i];
                    carry = 0 - a_i * a_i;
                    for(var j = i; j < l; j++){
                        a_j = a[j];
                        product = 2 * (a_i * a_j) + r[i + j] + carry;
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                    }
                    r[i + l] = carry;
                }
                trim(r);
                return r;
            }
            BigInteger.prototype.square = function() {
                return new BigInteger(square(this.value), false);
            };
            SmallInteger.prototype.square = function() {
                var value = this.value * this.value;
                if (isPrecise(value)) return new SmallInteger(value);
                return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
            };
            NativeBigInt.prototype.square = function(v) {
                return new NativeBigInt(this.value * this.value);
            };
            function divMod1(a, b) {
                var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
                lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
                if (remainder.length <= a_l) remainder.push(0);
                divisor.push(0);
                divisorMostSignificantDigit = divisor[b_l - 1];
                for(shift = a_l - b_l; shift >= 0; shift--){
                    quotientDigit = base - 1;
                    if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
                    // quotientDigit <= base - 1
                    carry = 0;
                    borrow = 0;
                    l = divisor.length;
                    for(i = 0; i < l; i++){
                        carry += quotientDigit * divisor[i];
                        q = Math.floor(carry / base);
                        borrow += remainder[shift + i] - (carry - q * base);
                        carry = q;
                        if (borrow < 0) {
                            remainder[shift + i] = borrow + base;
                            borrow = -1;
                        } else {
                            remainder[shift + i] = borrow;
                            borrow = 0;
                        }
                    }
                    while(borrow !== 0){
                        quotientDigit -= 1;
                        carry = 0;
                        for(i = 0; i < l; i++){
                            carry += remainder[shift + i] - base + divisor[i];
                            if (carry < 0) {
                                remainder[shift + i] = carry + base;
                                carry = 0;
                            } else {
                                remainder[shift + i] = carry;
                                carry = 1;
                            }
                        }
                        borrow += carry;
                    }
                    result[shift] = quotientDigit;
                }
                // denormalization
                remainder = divModSmall(remainder, lambda)[0];
                return [
                    arrayToSmall(result),
                    arrayToSmall(remainder)
                ];
            }
            function divMod2(a, b) {
                // Performs faster than divMod1 on larger input sizes.
                var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
                while(a_l){
                    part.unshift(a[--a_l]);
                    trim(part);
                    if (compareAbs(part, b) < 0) {
                        result.push(0);
                        continue;
                    }
                    xlen = part.length;
                    highx = part[xlen - 1] * base + part[xlen - 2];
                    highy = b[b_l - 1] * base + b[b_l - 2];
                    if (xlen > b_l) highx = (highx + 1) * base;
                    guess = Math.ceil(highx / highy);
                    do {
                        check = multiplySmall(b, guess);
                        if (compareAbs(check, part) <= 0) break;
                        guess--;
                    }while (guess);
                    result.push(guess);
                    part = subtract(part, check);
                }
                result.reverse();
                return [
                    arrayToSmall(result),
                    arrayToSmall(part)
                ];
            }
            function divModSmall(value, lambda) {
                var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
                remainder = 0;
                for(i = length - 1; i >= 0; --i){
                    divisor = remainder * base + value[i];
                    q = truncate(divisor / lambda);
                    remainder = divisor - q * lambda;
                    quotient[i] = q | 0;
                }
                return [
                    quotient,
                    remainder | 0
                ];
            }
            function divModAny(self, v) {
                var value, n = parseValue(v);
                if (supportsNativeBigInt) return [
                    new NativeBigInt(self.value / n.value),
                    new NativeBigInt(self.value % n.value)
                ];
                var a = self.value, b = n.value;
                var quotient;
                if (b === 0) throw new Error("Cannot divide by zero");
                if (self.isSmall) {
                    if (n.isSmall) return [
                        new SmallInteger(truncate(a / b)),
                        new SmallInteger(a % b)
                    ];
                    return [
                        Integer[0],
                        self
                    ];
                }
                if (n.isSmall) {
                    if (b === 1) return [
                        self,
                        Integer[0]
                    ];
                    if (b == -1) return [
                        self.negate(),
                        Integer[0]
                    ];
                    var abs = Math.abs(b);
                    if (abs < BASE) {
                        value = divModSmall(a, abs);
                        quotient = arrayToSmall(value[0]);
                        var remainder = value[1];
                        if (self.sign) remainder = -remainder;
                        if (typeof quotient === "number") {
                            if (self.sign !== n.sign) quotient = -quotient;
                            return [
                                new SmallInteger(quotient),
                                new SmallInteger(remainder)
                            ];
                        }
                        return [
                            new BigInteger(quotient, self.sign !== n.sign),
                            new SmallInteger(remainder)
                        ];
                    }
                    b = smallToArray(abs);
                }
                var comparison = compareAbs(a, b);
                if (comparison === -1) return [
                    Integer[0],
                    self
                ];
                if (comparison === 0) return [
                    Integer[self.sign === n.sign ? 1 : -1],
                    Integer[0]
                ];
                // divMod1 is faster on smaller input sizes
                if (a.length + b.length <= 200) value = divMod1(a, b);
                else value = divMod2(a, b);
                quotient = value[0];
                var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
                if (typeof quotient === "number") {
                    if (qSign) quotient = -quotient;
                    quotient = new SmallInteger(quotient);
                } else quotient = new BigInteger(quotient, qSign);
                if (typeof mod === "number") {
                    if (mSign) mod = -mod;
                    mod = new SmallInteger(mod);
                } else mod = new BigInteger(mod, mSign);
                return [
                    quotient,
                    mod
                ];
            }
            BigInteger.prototype.divmod = function(v) {
                var result = divModAny(this, v);
                return {
                    quotient: result[0],
                    remainder: result[1]
                };
            };
            NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
            BigInteger.prototype.divide = function(v) {
                return divModAny(this, v)[0];
            };
            NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
                return new NativeBigInt(this.value / parseValue(v).value);
            };
            SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
            BigInteger.prototype.mod = function(v) {
                return divModAny(this, v)[1];
            };
            NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
                return new NativeBigInt(this.value % parseValue(v).value);
            };
            SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
            BigInteger.prototype.pow = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, value, x, y;
                if (b === 0) return Integer[1];
                if (a === 0) return Integer[0];
                if (a === 1) return Integer[1];
                if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.sign) return Integer[0];
                if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
                if (this.isSmall) {
                    if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
                }
                x = this;
                y = Integer[1];
                while(true){
                    if (b & true) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === 0) break;
                    b /= 2;
                    x = x.square();
                }
                return y;
            };
            SmallInteger.prototype.pow = BigInteger.prototype.pow;
            NativeBigInt.prototype.pow = function(v) {
                var n = parseValue(v);
                var a = this.value, b = n.value;
                var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
                if (b === _0) return Integer[1];
                if (a === _0) return Integer[0];
                if (a === _1) return Integer[1];
                if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.isNegative()) return new NativeBigInt(_0);
                var x = this;
                var y = Integer[1];
                while(true){
                    if ((b & _1) === _1) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === _0) break;
                    b /= _2;
                    x = x.square();
                }
                return y;
            };
            BigInteger.prototype.modPow = function(exp, mod) {
                exp = parseValue(exp);
                mod = parseValue(mod);
                if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
                var r = Integer[1], base = this.mod(mod);
                if (exp.isNegative()) {
                    exp = exp.multiply(Integer[-1]);
                    base = base.modInv(mod);
                }
                while(exp.isPositive()){
                    if (base.isZero()) return Integer[0];
                    if (exp.isOdd()) r = r.multiply(base).mod(mod);
                    exp = exp.divide(2);
                    base = base.square().mod(mod);
                }
                return r;
            };
            NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
            function compareAbs(a, b) {
                if (a.length !== b.length) return a.length > b.length ? 1 : -1;
                for(var i = a.length - 1; i >= 0; i--){
                    if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
                }
                return 0;
            }
            BigInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return 1;
                return compareAbs(a, b);
            };
            SmallInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = Math.abs(this.value), b = n.value;
                if (n.isSmall) {
                    b = Math.abs(b);
                    return a === b ? 0 : a > b ? 1 : -1;
                }
                return -1;
            };
            NativeBigInt.prototype.compareAbs = function(v) {
                var a = this.value;
                var b = parseValue(v).value;
                a = a >= 0 ? a : -a;
                b = b >= 0 ? b : -b;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            BigInteger.prototype.compare = function(v) {
                // See discussion about comparison with Infinity:
                // https://github.com/peterolson/BigInteger.js/issues/61
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (this.sign !== n.sign) return n.sign ? 1 : -1;
                if (n.isSmall) return this.sign ? -1 : 1;
                return compareAbs(a, b) * (this.sign ? -1 : 1);
            };
            BigInteger.prototype.compareTo = BigInteger.prototype.compare;
            SmallInteger.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
                if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
                return a < 0 ? 1 : -1;
            };
            SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
            NativeBigInt.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var a = this.value;
                var b = parseValue(v).value;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
            BigInteger.prototype.equals = function(v) {
                return this.compare(v) === 0;
            };
            NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
            BigInteger.prototype.notEquals = function(v) {
                return this.compare(v) !== 0;
            };
            NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
            BigInteger.prototype.greater = function(v) {
                return this.compare(v) > 0;
            };
            NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
            BigInteger.prototype.lesser = function(v) {
                return this.compare(v) < 0;
            };
            NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
            BigInteger.prototype.greaterOrEquals = function(v) {
                return this.compare(v) >= 0;
            };
            NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
            BigInteger.prototype.lesserOrEquals = function(v) {
                return this.compare(v) <= 0;
            };
            NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
            BigInteger.prototype.isEven = function() {
                return (this.value[0] & 1) === 0;
            };
            SmallInteger.prototype.isEven = function() {
                return (this.value & 1) === 0;
            };
            NativeBigInt.prototype.isEven = function() {
                return (this.value & BigInt(1)) === BigInt(0);
            };
            BigInteger.prototype.isOdd = function() {
                return (this.value[0] & 1) === 1;
            };
            SmallInteger.prototype.isOdd = function() {
                return (this.value & 1) === 1;
            };
            NativeBigInt.prototype.isOdd = function() {
                return (this.value & BigInt(1)) === BigInt(1);
            };
            BigInteger.prototype.isPositive = function() {
                return !this.sign;
            };
            SmallInteger.prototype.isPositive = function() {
                return this.value > 0;
            };
            NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
            BigInteger.prototype.isNegative = function() {
                return this.sign;
            };
            SmallInteger.prototype.isNegative = function() {
                return this.value < 0;
            };
            NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
            BigInteger.prototype.isUnit = function() {
                return false;
            };
            SmallInteger.prototype.isUnit = function() {
                return Math.abs(this.value) === 1;
            };
            NativeBigInt.prototype.isUnit = function() {
                return this.abs().value === BigInt(1);
            };
            BigInteger.prototype.isZero = function() {
                return false;
            };
            SmallInteger.prototype.isZero = function() {
                return this.value === 0;
            };
            NativeBigInt.prototype.isZero = function() {
                return this.value === BigInt(0);
            };
            BigInteger.prototype.isDivisibleBy = function(v) {
                var n = parseValue(v);
                if (n.isZero()) return false;
                if (n.isUnit()) return true;
                if (n.compareAbs(2) === 0) return this.isEven();
                return this.mod(n).isZero();
            };
            NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
            function isBasicPrime(v) {
                var n = v.abs();
                if (n.isUnit()) return false;
                if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
                if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
                if (n.lesser(49)) return true;
            // we don't know if it's prime: let the other functions figure it out
            }
            function millerRabinTest(n, a) {
                var nPrev = n.prev(), b = nPrev, r = 0, d, i, x;
                while(b.isEven())b = b.divide(2), r++;
                next: for(i = 0; i < a.length; i++){
                    if (n.lesser(a[i])) continue;
                    x = bigInt(a[i]).modPow(b, n);
                    if (x.isUnit() || x.equals(nPrev)) continue;
                    for(d = r - 1; d != 0; d--){
                        x = x.square().mod(n);
                        if (x.isUnit()) return false;
                        if (x.equals(nPrev)) continue next;
                    }
                    return false;
                }
                return true;
            }
            // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
            BigInteger.prototype.isPrime = function(strict) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var bits = n.bitLength();
                if (bits <= 64) return millerRabinTest(n, [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37
                ]);
                var logN = Math.log(2) * bits.toJSNumber();
                var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
                for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
            BigInteger.prototype.isProbablePrime = function(iterations, rng) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var t = iterations === undefined$1 ? 5 : iterations;
                for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
            BigInteger.prototype.modInv = function(n) {
                var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
                while(!newR.isZero()){
                    q = r.divide(newR);
                    lastT = t;
                    lastR = r;
                    t = newT;
                    r = newR;
                    newT = lastT.subtract(q.multiply(newT));
                    newR = lastR.subtract(q.multiply(newR));
                }
                if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
                if (t.compare(0) === -1) t = t.add(n);
                if (this.isNegative()) return t.negate();
                return t;
            };
            NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
            BigInteger.prototype.next = function() {
                var value = this.value;
                if (this.sign) return subtractSmall(value, 1, this.sign);
                return new BigInteger(addSmall(value, 1), this.sign);
            };
            SmallInteger.prototype.next = function() {
                var value = this.value;
                if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
                return new BigInteger(MAX_INT_ARR, false);
            };
            NativeBigInt.prototype.next = function() {
                return new NativeBigInt(this.value + BigInt(1));
            };
            BigInteger.prototype.prev = function() {
                var value = this.value;
                if (this.sign) return new BigInteger(addSmall(value, 1), true);
                return subtractSmall(value, 1, this.sign);
            };
            SmallInteger.prototype.prev = function() {
                var value = this.value;
                if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
                return new BigInteger(MAX_INT_ARR, true);
            };
            NativeBigInt.prototype.prev = function() {
                return new NativeBigInt(this.value - BigInt(1));
            };
            var powersOfTwo = [
                1
            ];
            while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
            var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
            function shift_isSmall(n) {
                return Math.abs(n) <= BASE;
            }
            BigInteger.prototype.shiftLeft = function(v) {
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftRight(-n);
                var result = this;
                if (result.isZero()) return result;
                while(n >= powers2Length){
                    result = result.multiply(highestPower2);
                    n -= powers2Length - 1;
                }
                return result.multiply(powersOfTwo[n]);
            };
            NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
            BigInteger.prototype.shiftRight = function(v) {
                var remQuo;
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftLeft(-n);
                var result = this;
                while(n >= powers2Length){
                    if (result.isZero() || result.isNegative() && result.isUnit()) return result;
                    remQuo = divModAny(result, highestPower2);
                    result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
                    n -= powers2Length - 1;
                }
                remQuo = divModAny(result, powersOfTwo[n]);
                return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            };
            NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
            function bitwise(x, y, fn) {
                y = parseValue(y);
                var xSign = x.isNegative(), ySign = y.isNegative();
                var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
                var xDigit = 0, yDigit = 0;
                var xDivMod = null, yDivMod = null;
                var result = [];
                while(!xRem.isZero() || !yRem.isZero()){
                    xDivMod = divModAny(xRem, highestPower2);
                    xDigit = xDivMod[1].toJSNumber();
                    if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
                    yDivMod = divModAny(yRem, highestPower2);
                    yDigit = yDivMod[1].toJSNumber();
                    if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
                    xRem = xDivMod[0];
                    yRem = yDivMod[0];
                    result.push(fn(xDigit, yDigit));
                }
                var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
                for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
                return sum;
            }
            BigInteger.prototype.not = function() {
                return this.negate().prev();
            };
            NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
            BigInteger.prototype.and = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a & b;
                });
            };
            NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
            BigInteger.prototype.or = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a | b;
                });
            };
            NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
            BigInteger.prototype.xor = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a ^ b;
                });
            };
            NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
            var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
            function roughLOB(n) {
                // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
                // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
                var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
                return x & -x;
            }
            function integerLogarithm(value, base) {
                if (base.compareTo(value) <= 0) {
                    var tmp = integerLogarithm(value, base.square(base));
                    var p = tmp.p;
                    var e = tmp.e;
                    var t = p.multiply(base);
                    return t.compareTo(value) <= 0 ? {
                        p: t,
                        e: e * 2 + 1
                    } : {
                        p: p,
                        e: e * 2
                    };
                }
                return {
                    p: bigInt(1),
                    e: 0
                };
            }
            BigInteger.prototype.bitLength = function() {
                var n = this;
                if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
                if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
                return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
            };
            NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
            function max(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.greater(b) ? a : b;
            }
            function min(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.lesser(b) ? a : b;
            }
            function gcd(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                if (a.equals(b)) return a;
                if (a.isZero()) return b;
                if (b.isZero()) return a;
                var c = Integer[1], d, t;
                while(a.isEven() && b.isEven()){
                    d = min(roughLOB(a), roughLOB(b));
                    a = a.divide(d);
                    b = b.divide(d);
                    c = c.multiply(d);
                }
                while(a.isEven())a = a.divide(roughLOB(a));
                do {
                    while(b.isEven())b = b.divide(roughLOB(b));
                    if (a.greater(b)) {
                        t = b;
                        b = a;
                        a = t;
                    }
                    b = b.subtract(a);
                }while (!b.isZero());
                return c.isUnit() ? a : a.multiply(c);
            }
            function lcm(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                return a.divide(gcd(a, b)).multiply(b);
            }
            function randBetween(a, b, rng) {
                a = parseValue(a);
                b = parseValue(b);
                var usedRNG = rng || Math.random;
                var low = min(a, b), high = max(a, b);
                var range = high.subtract(low).add(1);
                if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
                var digits = toBase(range, BASE).value;
                var result = [], restricted = true;
                for(var i = 0; i < digits.length; i++){
                    var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
                    var digit = truncate(usedRNG() * top);
                    result.push(digit);
                    if (digit < digits[i]) restricted = false;
                }
                return low.add(Integer.fromArray(result, BASE, false));
            }
            var parseBase = function(text, base, alphabet, caseSensitive) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                text = String(text);
                if (!caseSensitive) {
                    text = text.toLowerCase();
                    alphabet = alphabet.toLowerCase();
                }
                var length = text.length;
                var i;
                var absBase = Math.abs(base);
                var alphabetValues = {};
                for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
                for(i = 0; i < length; i++){
                    var c = text[i];
                    if (c === "-") continue;
                    if (c in alphabetValues) {
                        if (alphabetValues[c] >= absBase) {
                            if (c === "1" && absBase === 1) continue;
                            throw new Error(c + " is not a valid digit in base " + base + ".");
                        }
                    }
                }
                base = parseValue(base);
                var digits = [];
                var isNegative = text[0] === "-";
                for(i = isNegative ? 1 : 0; i < text.length; i++){
                    var c = text[i];
                    if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
                    else if (c === "<") {
                        var start = i;
                        do i++;
                        while (text[i] !== ">" && i < text.length);
                        digits.push(parseValue(text.slice(start + 1, i)));
                    } else throw new Error(c + " is not a valid character");
                }
                return parseBaseFromArray(digits, base, isNegative);
            };
            function parseBaseFromArray(digits, base, isNegative) {
                var val = Integer[0], pow = Integer[1], i;
                for(i = digits.length - 1; i >= 0; i--){
                    val = val.add(digits[i].times(pow));
                    pow = pow.times(base);
                }
                return isNegative ? val.negate() : val;
            }
            function stringify(digit, alphabet) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                if (digit < alphabet.length) return alphabet[digit];
                return "<" + digit + ">";
            }
            function toBase(n, base) {
                base = bigInt(base);
                if (base.isZero()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    throw new Error("Cannot convert nonzero numbers to base 0.");
                }
                if (base.equals(-1)) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    if (n.isNegative()) return {
                        value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                            1,
                            0
                        ])),
                        isNegative: false
                    };
                    var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                        0,
                        1
                    ]);
                    arr.unshift([
                        1
                    ]);
                    return {
                        value: [].concat.apply([], arr),
                        isNegative: false
                    };
                }
                var neg = false;
                if (n.isNegative() && base.isPositive()) {
                    neg = true;
                    n = n.abs();
                }
                if (base.isUnit()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    return {
                        value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                        isNegative: neg
                    };
                }
                var out = [];
                var left = n, divmod;
                while(left.isNegative() || left.compareAbs(base) >= 0){
                    divmod = left.divmod(base);
                    left = divmod.quotient;
                    var digit = divmod.remainder;
                    if (digit.isNegative()) {
                        digit = base.minus(digit).abs();
                        left = left.next();
                    }
                    out.push(digit.toJSNumber());
                }
                out.push(left.toJSNumber());
                return {
                    value: out.reverse(),
                    isNegative: neg
                };
            }
            function toBaseString(n, base, alphabet) {
                var arr = toBase(n, base);
                return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
                    return stringify(x, alphabet);
                }).join('');
            }
            BigInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            SmallInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            NativeBigInt.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            BigInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
                var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
                while(--l >= 0){
                    digit = String(v[l]);
                    str += zeros.slice(digit.length) + digit;
                }
                var sign = this.sign ? "-" : "";
                return sign + str;
            };
            SmallInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
                return String(this.value);
            };
            NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
            NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
                return this.toString();
            };
            BigInteger.prototype.valueOf = function() {
                return parseInt(this.toString(), 10);
            };
            BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
            SmallInteger.prototype.valueOf = function() {
                return this.value;
            };
            SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
            NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
                return parseInt(this.toString(), 10);
            };
            function parseStringValue(v) {
                if (isPrecise(+v)) {
                    var x = +v;
                    if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
                    throw new Error("Invalid integer: " + v);
                }
                var sign = v[0] === "-";
                if (sign) v = v.slice(1);
                var split = v.split(/e/i);
                if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
                if (split.length === 2) {
                    var exp = split[1];
                    if (exp[0] === "+") exp = exp.slice(1);
                    exp = +exp;
                    if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
                    var text = split[0];
                    var decimalPlace = text.indexOf(".");
                    if (decimalPlace >= 0) {
                        exp -= text.length - decimalPlace - 1;
                        text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
                    }
                    if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
                    text += new Array(exp + 1).join("0");
                    v = text;
                }
                var isValid = /^([0-9][0-9]*)$/.test(v);
                if (!isValid) throw new Error("Invalid integer: " + v);
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
                var r = [], max = v.length, l = LOG_BASE, min = max - l;
                while(max > 0){
                    r.push(+v.slice(min, max));
                    min -= l;
                    if (min < 0) min = 0;
                    max -= l;
                }
                trim(r);
                return new BigInteger(r, sign);
            }
            function parseNumberValue(v) {
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
                if (isPrecise(v)) {
                    if (v !== truncate(v)) throw new Error(v + " is not an integer.");
                    return new SmallInteger(v);
                }
                return parseStringValue(v.toString());
            }
            function parseValue(v) {
                if (typeof v === "number") return parseNumberValue(v);
                if (typeof v === "string") return parseStringValue(v);
                if (typeof v === "bigint") return new NativeBigInt(v);
                return v;
            }
            // Pre-define numbers in range [-999,999]
            for(var i = 0; i < 1000; i++){
                Integer[i] = parseValue(i);
                if (i > 0) Integer[-i] = parseValue(-i);
            }
            // Backwards compatibility
            Integer.one = Integer[1];
            Integer.zero = Integer[0];
            Integer.minusOne = Integer[-1];
            Integer.max = max;
            Integer.min = min;
            Integer.gcd = gcd;
            Integer.lcm = lcm;
            Integer.isInstance = function(x) {
                return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
            };
            Integer.randBetween = randBetween;
            Integer.fromArray = function(digits, base, isNegative) {
                return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
            };
            return Integer;
        }();
        // Node.js check
        if (module.hasOwnProperty("exports")) module.exports = bigInt;
    })((0, $7fd5b846378f669f$export$5edeffb658f039f4));
    return (0, $7fd5b846378f669f$export$5edeffb658f039f4).exports;
}


var $77fcb239dda6bb0b$var$BigIntegerExports = (0, $3da5525ea9fd5e7e$export$b88c30a9414655a0)();
var $77fcb239dda6bb0b$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $1a35ac73ddb3ee8a$export$22b09f878622677a)($77fcb239dda6bb0b$var$BigIntegerExports);


/**
 * Context: Due to Discord supporting more than 32 permissions, permission calculation has become more complicated than naive
 * bit operations on `number`s. To support this generically, we have created BigFlagUtils to work with bit-flags greater
 * than 32-bits in size.
 *
 * Ideally, we would like to use BigInt, which is pretty efficient, but some JavaScript engines do not support it.
 *
 * This file is intended to be a set of lower-level operators that act directly on "BigFlags".
 *
 * If you're working with permissions, in most cases you can probably use PermissionUtils.
 */ const $a462ad6d1a4d2753$var$MAX_BIG_INT = 64;
const $a462ad6d1a4d2753$var$SMALL_INT = 16;
const $a462ad6d1a4d2753$var$PARTS = $a462ad6d1a4d2753$var$MAX_BIG_INT / $a462ad6d1a4d2753$var$SMALL_INT;
function $a462ad6d1a4d2753$var$checkBrowserSupportsBigInt() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        BigInt;
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Takes the sliced output of `toHexReverseArray` and converts hex to decimal.
 */ function $a462ad6d1a4d2753$var$fromHexReverseArray(hexValues, start, size) {
    let value = 0;
    for(let i = 0; i < size; i++){
        const byte = hexValues[start + i];
        if (byte === undefined) break;
        value += byte * 16 ** i;
    }
    return value;
}
/**
 * Converts a number string to array of hex bytes based on the implementation found at
 * https://stackoverflow.com/questions/18626844/convert-a-large-integer-to-a-hex-string-in-javascript
 *
 * To avoid extra allocations it returns the values in reverse.
 */ function $a462ad6d1a4d2753$var$toHexReverseArray(value) {
    const sum = [];
    for(let i = 0; i < value.length; i++){
        let s = Number(value[i]);
        for(let j = 0; s || j < sum.length; j++){
            s += (sum[j] || 0) * 10;
            sum[j] = s % 16;
            s = (s - sum[j]) / 16;
        }
    }
    return sum;
}
/**
 * Splits a big integers into array of small integers to perform fast bitwise operations.
 */ function $a462ad6d1a4d2753$var$splitBigInt(value) {
    const sum = $a462ad6d1a4d2753$var$toHexReverseArray(value);
    const parts = Array($a462ad6d1a4d2753$var$PARTS);
    for(let i = 0; i < $a462ad6d1a4d2753$var$PARTS; i++)// Highest bits to lowest bits.
    parts[$a462ad6d1a4d2753$var$PARTS - 1 - i] = $a462ad6d1a4d2753$var$fromHexReverseArray(sum, i * $a462ad6d1a4d2753$var$PARTS, $a462ad6d1a4d2753$var$PARTS);
    return parts;
}
class $a462ad6d1a4d2753$var$HighLow {
    static fromString(value) {
        return new $a462ad6d1a4d2753$var$HighLow($a462ad6d1a4d2753$var$splitBigInt(value), value);
    }
    static fromBit(index) {
        const parts = Array($a462ad6d1a4d2753$var$PARTS);
        const offset = Math.floor(index / $a462ad6d1a4d2753$var$SMALL_INT);
        for(let i = 0; i < $a462ad6d1a4d2753$var$PARTS; i++)// Highest bits to lowest bits.
        parts[$a462ad6d1a4d2753$var$PARTS - 1 - i] = i === offset ? 1 << index - offset * $a462ad6d1a4d2753$var$SMALL_INT : 0;
        return new $a462ad6d1a4d2753$var$HighLow(parts);
    }
    constructor(parts, str){
        this.parts = parts;
        this.str = str;
    }
    and({ parts: parts }) {
        return new $a462ad6d1a4d2753$var$HighLow(this.parts.map((v, i)=>v & parts[i]));
    }
    or({ parts: parts }) {
        return new $a462ad6d1a4d2753$var$HighLow(this.parts.map((v, i)=>v | parts[i]));
    }
    xor({ parts: parts }) {
        return new $a462ad6d1a4d2753$var$HighLow(this.parts.map((v, i)=>v ^ parts[i]));
    }
    not() {
        return new $a462ad6d1a4d2753$var$HighLow(this.parts.map((v)=>~v));
    }
    equals({ parts: parts }) {
        return this.parts.every((v, i)=>v === parts[i]);
    }
    /**
     * For the average case the string representation is provided, but
     * when we need to convert high and low to string we just let the
     * slower big-integer library do it.
     */ toString() {
        if (this.str != null) return this.str;
        const array = new Array($a462ad6d1a4d2753$var$MAX_BIG_INT / 4);
        this.parts.forEach((value, offset)=>{
            const hex = $a462ad6d1a4d2753$var$toHexReverseArray(value.toString());
            for(let i = 0; i < 4; i++)array[i + offset * 4] = hex[3 - i] || 0;
        });
        return this.str = (0, $77fcb239dda6bb0b$export$2e2bcd8739ae039).fromArray(array, 16).toString();
    }
    toJSON() {
        return this.toString();
    }
}
const $a462ad6d1a4d2753$var$SUPPORTS_BIGINT = $a462ad6d1a4d2753$var$checkBrowserSupportsBigInt();
// Polyfill toJSON on BigInt if necessary.
if ($a462ad6d1a4d2753$var$SUPPORTS_BIGINT && BigInt.prototype.toJSON == null) BigInt.prototype.toJSON = function() {
    return this.toString();
};
const $a462ad6d1a4d2753$var$HIGH_LOW_CACHE = {};
const $a462ad6d1a4d2753$var$convertToBigFlag = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function convertToBigFlagBigInt(value) {
    return BigInt(value);
} : function convertToBigFlagHighLow(value) {
    if (value instanceof $a462ad6d1a4d2753$var$HighLow) return value;
    if (typeof value === 'number') value = value.toString();
    // These type assertions are ugly, but there doesn't seem to be a
    // runtime costless way to do a type assertion above.
    if ($a462ad6d1a4d2753$var$HIGH_LOW_CACHE[value] != null) return $a462ad6d1a4d2753$var$HIGH_LOW_CACHE[value];
    $a462ad6d1a4d2753$var$HIGH_LOW_CACHE[value] = $a462ad6d1a4d2753$var$HighLow.fromString(value);
    return $a462ad6d1a4d2753$var$HIGH_LOW_CACHE[value];
};
const $a462ad6d1a4d2753$var$EMPTY_FLAG = $a462ad6d1a4d2753$var$convertToBigFlag(0);
const $a462ad6d1a4d2753$var$flagAnd = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function flagAndBigInt(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first & second;
} : function flagAndHighLow(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first.and(second);
};
const $a462ad6d1a4d2753$var$flagOr = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function flagOrBigInt(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first | second;
} : function flagOrHighLow(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first.or(second);
};
const $a462ad6d1a4d2753$var$flagXor = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function flagXorBigInt(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first ^ second;
} : function flagXorHighLow(first = $a462ad6d1a4d2753$var$EMPTY_FLAG, second = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first.xor(second);
};
const $a462ad6d1a4d2753$var$flagNot = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function flagNotBigInt(first = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return ~first;
} : function flagNotHighLow(first = $a462ad6d1a4d2753$var$EMPTY_FLAG) {
    return first.not();
};
const $a462ad6d1a4d2753$var$flagEquals = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function flagEqualsBigInt(first, second) {
    return first === second;
} : function flagEqualsHighLow(first, second) {
    if (first == null || second == null) // eslint-disable-next-line eqeqeq
    return first == second;
    return first.equals(second);
};
function $a462ad6d1a4d2753$var$flagOrMultiple(...flags) {
    let result = flags[0];
    for(let i = 1; i < flags.length; i++)result = $a462ad6d1a4d2753$var$flagOr(result, flags[i]);
    return result;
}
function $a462ad6d1a4d2753$var$flagHas(base, flag) {
    return $a462ad6d1a4d2753$var$flagEquals($a462ad6d1a4d2753$var$flagAnd(base, flag), flag);
}
function $a462ad6d1a4d2753$var$flagHasAny(base, flag) {
    return !$a462ad6d1a4d2753$var$flagEquals($a462ad6d1a4d2753$var$flagAnd(base, flag), $a462ad6d1a4d2753$var$EMPTY_FLAG);
}
function $a462ad6d1a4d2753$var$flagAdd(base, flag) {
    return flag === $a462ad6d1a4d2753$var$EMPTY_FLAG ? base : $a462ad6d1a4d2753$var$flagOr(base, flag);
}
function $a462ad6d1a4d2753$var$flagRemove(base, flag) {
    return flag === $a462ad6d1a4d2753$var$EMPTY_FLAG ? base : $a462ad6d1a4d2753$var$flagXor(base, $a462ad6d1a4d2753$var$flagAnd(base, flag));
}
const $a462ad6d1a4d2753$var$getFlag = $a462ad6d1a4d2753$var$SUPPORTS_BIGINT ? function getFlagBigInt(index) {
    return BigInt(1) << BigInt(index);
} : function getFlagHighLow(index) {
    return $a462ad6d1a4d2753$var$HighLow.fromBit(index);
};
var $a462ad6d1a4d2753$export$2e2bcd8739ae039 = {
    combine: $a462ad6d1a4d2753$var$flagOrMultiple,
    add: $a462ad6d1a4d2753$var$flagAdd,
    remove: $a462ad6d1a4d2753$var$flagRemove,
    filter: $a462ad6d1a4d2753$var$flagAnd,
    invert: $a462ad6d1a4d2753$var$flagNot,
    has: $a462ad6d1a4d2753$var$flagHas,
    hasAny: $a462ad6d1a4d2753$var$flagHasAny,
    equals: $a462ad6d1a4d2753$var$flagEquals,
    deserialize: $a462ad6d1a4d2753$var$convertToBigFlag,
    getFlag: $a462ad6d1a4d2753$var$getFlag
};


var $46a39478d4fb12cc$export$b87f1ea3076d6f58;
(function(RPCCloseCodes) {
    RPCCloseCodes[RPCCloseCodes["CLOSE_NORMAL"] = 1000] = "CLOSE_NORMAL";
    RPCCloseCodes[RPCCloseCodes["CLOSE_UNSUPPORTED"] = 1003] = "CLOSE_UNSUPPORTED";
    RPCCloseCodes[RPCCloseCodes["CLOSE_ABNORMAL"] = 1006] = "CLOSE_ABNORMAL";
    RPCCloseCodes[RPCCloseCodes["INVALID_CLIENTID"] = 4000] = "INVALID_CLIENTID";
    RPCCloseCodes[RPCCloseCodes["INVALID_ORIGIN"] = 4001] = "INVALID_ORIGIN";
    RPCCloseCodes[RPCCloseCodes["RATELIMITED"] = 4002] = "RATELIMITED";
    RPCCloseCodes[RPCCloseCodes["TOKEN_REVOKED"] = 4003] = "TOKEN_REVOKED";
    RPCCloseCodes[RPCCloseCodes["INVALID_VERSION"] = 4004] = "INVALID_VERSION";
    RPCCloseCodes[RPCCloseCodes["INVALID_ENCODING"] = 4005] = "INVALID_ENCODING";
})($46a39478d4fb12cc$export$b87f1ea3076d6f58 || ($46a39478d4fb12cc$export$b87f1ea3076d6f58 = {}));
var $46a39478d4fb12cc$export$9ebb08d40ecbafd9;
(function(RPCErrorCodes) {
    RPCErrorCodes[RPCErrorCodes["INVALID_PAYLOAD"] = 4000] = "INVALID_PAYLOAD";
    RPCErrorCodes[RPCErrorCodes["INVALID_COMMAND"] = 4002] = "INVALID_COMMAND";
    RPCErrorCodes[RPCErrorCodes["INVALID_GUILD"] = 4003] = "INVALID_GUILD";
    RPCErrorCodes[RPCErrorCodes["INVALID_EVENT"] = 4004] = "INVALID_EVENT";
    RPCErrorCodes[RPCErrorCodes["INVALID_CHANNEL"] = 4005] = "INVALID_CHANNEL";
    RPCErrorCodes[RPCErrorCodes["INVALID_PERMISSIONS"] = 4006] = "INVALID_PERMISSIONS";
    RPCErrorCodes[RPCErrorCodes["INVALID_CLIENTID"] = 4007] = "INVALID_CLIENTID";
    RPCErrorCodes[RPCErrorCodes["INVALID_ORIGIN"] = 4008] = "INVALID_ORIGIN";
    RPCErrorCodes[RPCErrorCodes["INVALID_TOKEN"] = 4009] = "INVALID_TOKEN";
    RPCErrorCodes[RPCErrorCodes["INVALID_USER"] = 4010] = "INVALID_USER";
})($46a39478d4fb12cc$export$9ebb08d40ecbafd9 || ($46a39478d4fb12cc$export$9ebb08d40ecbafd9 = {}));
/**
 * @deprecated use OrientationTypeObject instead
 */ var $46a39478d4fb12cc$export$df54d73aa0ec5e82;
(function(Orientation) {
    Orientation["LANDSCAPE"] = "landscape";
    Orientation["PORTRAIT"] = "portrait";
})($46a39478d4fb12cc$export$df54d73aa0ec5e82 || ($46a39478d4fb12cc$export$df54d73aa0ec5e82 = {}));
var $46a39478d4fb12cc$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["MOBILE"] = "mobile";
    Platform["DESKTOP"] = "desktop";
})($46a39478d4fb12cc$export$2dffd0b5373a4389 || ($46a39478d4fb12cc$export$2dffd0b5373a4389 = {}));
/** See https://discord.com/developers/docs/topics/permissions#permissions-bitwise-permission-flags for more Permissions details */ const $46a39478d4fb12cc$export$2d41982586bbb6be = Object.freeze({
    CREATE_INSTANT_INVITE: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(0),
    KICK_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(1),
    BAN_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(2),
    ADMINISTRATOR: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(3),
    MANAGE_CHANNELS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(4),
    MANAGE_GUILD: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(5),
    ADD_REACTIONS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(6),
    VIEW_AUDIT_LOG: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(7),
    PRIORITY_SPEAKER: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(8),
    STREAM: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(9),
    VIEW_CHANNEL: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(10),
    SEND_MESSAGES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(11),
    SEND_TTS_MESSAGES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(12),
    MANAGE_MESSAGES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(13),
    EMBED_LINKS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(14),
    ATTACH_FILES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(15),
    READ_MESSAGE_HISTORY: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(16),
    MENTION_EVERYONE: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(17),
    USE_EXTERNAL_EMOJIS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(18),
    VIEW_GUILD_INSIGHTS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(19),
    CONNECT: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(20),
    SPEAK: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(21),
    MUTE_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(22),
    DEAFEN_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(23),
    MOVE_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(24),
    USE_VAD: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(25),
    CHANGE_NICKNAME: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(26),
    MANAGE_NICKNAMES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(27),
    MANAGE_ROLES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(28),
    MANAGE_WEBHOOKS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(29),
    MANAGE_GUILD_EXPRESSIONS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(30),
    USE_APPLICATION_COMMANDS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(31),
    REQUEST_TO_SPEAK: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(32),
    MANAGE_EVENTS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(33),
    MANAGE_THREADS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(34),
    CREATE_PUBLIC_THREADS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(35),
    CREATE_PRIVATE_THREADS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(36),
    USE_EXTERNAL_STICKERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(37),
    SEND_MESSAGES_IN_THREADS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(38),
    USE_EMBEDDED_ACTIVITIES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(39),
    MODERATE_MEMBERS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(40),
    VIEW_CREATOR_MONETIZATION_ANALYTICS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(41),
    USE_SOUNDBOARD: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(42),
    CREATE_GUILD_EXPRESSIONS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(43),
    CREATE_EVENTS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(44),
    USE_EXTERNAL_SOUNDS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(45),
    SEND_VOICE_MESSAGES: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(46),
    SEND_POLLS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(49),
    USE_EXTERNAL_APPS: (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).getFlag(50)
});
const $46a39478d4fb12cc$export$6d0e4238fc52b7e2 = -1;
const $46a39478d4fb12cc$export$e124ef0815aed2db = 250;


var $7563c491739c9977$exports = {};

$parcel$export($7563c491739c9977$exports, "DISPATCH", () => $7563c491739c9977$export$efd7770b5da84f9e);
$parcel$export($7563c491739c9977$exports, "Commands", () => $7563c491739c9977$export$ba30f7724cb0e54e);
$parcel$export($7563c491739c9977$exports, "ReceiveFramePayload", () => $7563c491739c9977$export$7a3470becaa040fa);
$parcel$export($7563c491739c9977$exports, "ScopesObject", () => $7563c491739c9977$export$75435f4e5bc6ddd7);
$parcel$export($7563c491739c9977$exports, "Scopes", () => $7563c491739c9977$export$8546186883d6ff3e);
$parcel$export($7563c491739c9977$exports, "Relationship", () => $7563c491739c9977$export$69a0e7946cf616df);
$parcel$export($7563c491739c9977$exports, "User", () => $7563c491739c9977$export$1f44aaf2ec115b54);
$parcel$export($7563c491739c9977$exports, "GuildMember", () => $7563c491739c9977$export$6ba76af5c834ff81);
$parcel$export($7563c491739c9977$exports, "GuildMemberRPC", () => $7563c491739c9977$export$8fbf13c8b5cc978c);
$parcel$export($7563c491739c9977$exports, "Emoji", () => $7563c491739c9977$export$56cc48506ff790a);
$parcel$export($7563c491739c9977$exports, "VoiceState", () => $7563c491739c9977$export$e40a3aa7b507330e);
$parcel$export($7563c491739c9977$exports, "UserVoiceState", () => $7563c491739c9977$export$4b86a4e430ccb511);
$parcel$export($7563c491739c9977$exports, "StatusObject", () => $7563c491739c9977$export$39054e8696850518);
$parcel$export($7563c491739c9977$exports, "Status", () => $7563c491739c9977$export$96e9906d6d93a972);
$parcel$export($7563c491739c9977$exports, "Activity", () => $7563c491739c9977$export$9c16c1426311996d);
$parcel$export($7563c491739c9977$exports, "PermissionOverwriteTypeObject", () => $7563c491739c9977$export$fab33d7660c6e6d6);
$parcel$export($7563c491739c9977$exports, "PermissionOverwrite", () => $7563c491739c9977$export$3700bd144328e1a6);
$parcel$export($7563c491739c9977$exports, "ChannelTypesObject", () => $7563c491739c9977$export$2f4cb441f3eded01);
$parcel$export($7563c491739c9977$exports, "Channel", () => $7563c491739c9977$export$cfdacaa37f9b4dd7);
$parcel$export($7563c491739c9977$exports, "PresenceUpdate", () => $7563c491739c9977$export$24da275c271e8208);
$parcel$export($7563c491739c9977$exports, "Role", () => $7563c491739c9977$export$46919bad18fb2f76);
$parcel$export($7563c491739c9977$exports, "Guild", () => $7563c491739c9977$export$85e439e10eca0e6b);
$parcel$export($7563c491739c9977$exports, "ChannelMention", () => $7563c491739c9977$export$8ce7ab97167fc310);
$parcel$export($7563c491739c9977$exports, "Attachment", () => $7563c491739c9977$export$71e4db985cfcf9e3);
$parcel$export($7563c491739c9977$exports, "EmbedFooter", () => $7563c491739c9977$export$8c9fffced316d89b);
$parcel$export($7563c491739c9977$exports, "Image", () => $7563c491739c9977$export$3e431a229df88919);
$parcel$export($7563c491739c9977$exports, "Video", () => $7563c491739c9977$export$ae01dedf5c052bb);
$parcel$export($7563c491739c9977$exports, "EmbedProvider", () => $7563c491739c9977$export$e4790b418e6d5a4d);
$parcel$export($7563c491739c9977$exports, "EmbedAuthor", () => $7563c491739c9977$export$632a034bda2c67e4);
$parcel$export($7563c491739c9977$exports, "EmbedField", () => $7563c491739c9977$export$8f305b092204e542);
$parcel$export($7563c491739c9977$exports, "Embed", () => $7563c491739c9977$export$a84540bc8b694b2d);
$parcel$export($7563c491739c9977$exports, "Reaction", () => $7563c491739c9977$export$d2ae4167a30cf6bb);
$parcel$export($7563c491739c9977$exports, "MessageActivity", () => $7563c491739c9977$export$465ad97f4d04cf9a);
$parcel$export($7563c491739c9977$exports, "MessageApplication", () => $7563c491739c9977$export$56f5e744391a955c);
$parcel$export($7563c491739c9977$exports, "MessageReference", () => $7563c491739c9977$export$bcebdc029e694ee6);
$parcel$export($7563c491739c9977$exports, "Message", () => $7563c491739c9977$export$f69c19e57285b83a);
$parcel$export($7563c491739c9977$exports, "VoiceDevice", () => $7563c491739c9977$export$624aa0dd60bb35db);
$parcel$export($7563c491739c9977$exports, "KeyTypesObject", () => $7563c491739c9977$export$2ede097136cc13e4);
$parcel$export($7563c491739c9977$exports, "ShortcutKey", () => $7563c491739c9977$export$f20a7ed0751474c1);
$parcel$export($7563c491739c9977$exports, "VoiceSettingModeTypeObject", () => $7563c491739c9977$export$9d6f8c8df913ee9d);
$parcel$export($7563c491739c9977$exports, "VoiceSettingsMode", () => $7563c491739c9977$export$c99e7704e60373e9);
$parcel$export($7563c491739c9977$exports, "VoiceSettingsIO", () => $7563c491739c9977$export$cb1d6465ddfebcf0);
$parcel$export($7563c491739c9977$exports, "CertifiedDeviceTypeObject", () => $7563c491739c9977$export$8320da8c452e87fc);
$parcel$export($7563c491739c9977$exports, "CertifiedDevice", () => $7563c491739c9977$export$4f2f4bd3c787de21);
$parcel$export($7563c491739c9977$exports, "SkuTypeObject", () => $7563c491739c9977$export$439ecd4335b15be4);
$parcel$export($7563c491739c9977$exports, "Sku", () => $7563c491739c9977$export$ccf658062b0f9f7a);
$parcel$export($7563c491739c9977$exports, "EntitlementTypesObject", () => $7563c491739c9977$export$6259f37857107b12);
$parcel$export($7563c491739c9977$exports, "Entitlement", () => $7563c491739c9977$export$7b20d168ba04011b);
$parcel$export($7563c491739c9977$exports, "OrientationLockStateTypeObject", () => $7563c491739c9977$export$7e8bb741497f2d3);
$parcel$export($7563c491739c9977$exports, "OrientationLockState", () => $7563c491739c9977$export$76765004a89b60c4);
$parcel$export($7563c491739c9977$exports, "ThermalStateTypeObject", () => $7563c491739c9977$export$6b5ef5fbc271f145);
$parcel$export($7563c491739c9977$exports, "ThermalState", () => $7563c491739c9977$export$8065eea9d621a18);
$parcel$export($7563c491739c9977$exports, "OrientationTypeObject", () => $7563c491739c9977$export$6998f50a089a6f29);
$parcel$export($7563c491739c9977$exports, "Orientation", () => $7563c491739c9977$export$df54d73aa0ec5e82);
$parcel$export($7563c491739c9977$exports, "LayoutModeTypeObject", () => $7563c491739c9977$export$94c8fa8df0efcb28);
$parcel$export($7563c491739c9977$exports, "LayoutMode", () => $7563c491739c9977$export$8f9fafd62f4ed4cc);


/**
 * This is a helper function which coerces an unsupported arg value to the key/value UNHANDLED: -1
 * This is necessary to handle a scenario where a new enum value is added in the Discord Client,
 * so that the sdk will not throw an error when given a (newly) valid enum value.
 *
 * To remove the requirement for consumers of this sdk to import an enum when parsing data,
 * we instead use an object cast as const (readonly). This maintains parity with the previous
 * schema (which used zod.enum), and behaves more like a union type, i.e. 'foo' | 'bar' | -1
 *
 * @param inputObject This object must include the key/value pair UNHANDLED = -1
 */ function $39fcf09e0d14b4fd$export$5989705faed03747(inputObject) {
    return (0, $403a382f9acbc955$export$fc37fe19dfda43ee)((arg)=>{
        var _a;
        const [objectKey] = (_a = Object.entries(inputObject).find(([, value])=>value === arg)) !== null && _a !== void 0 ? _a : [];
        if (arg != null && objectKey === undefined) return inputObject.UNHANDLED;
        return arg;
    }, (0, $403a382f9acbc955$export$22b082955e083ec3)().or((0, $403a382f9acbc955$export$98e628dec113755e)()));
}
/**
 * Fallback to the default zod value if parsing fails.
 */ function $39fcf09e0d14b4fd$export$b70693e61e1d03ea(schema) {
    const transform = (0, $403a382f9acbc955$export$4c00f665f0d4b443)().transform((data)=>{
        const res = schema.safeParse(data);
        if (res.success) return res.data;
        return schema._def.defaultValue();
    });
    // Must set this inner schema so inspection works correctly
    transform.overlayType = schema;
    // transform._def.schema = schema;
    return transform;
}




/**
 * This file is generated.
 * Run "npm run sync" to regenerate file.
 * @generated
 */ // INITIATE_IMAGE_UPLOAD
const $a43ed54831525f7d$export$599108c66632c238 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    image_url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string()
}).describe('Response for "INITIATE_IMAGE_UPLOAD" Command');
// OPEN_SHARE_MOMENT_DIALOG
const $a43ed54831525f7d$export$b7048850f4d41d23 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    mediaUrl: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(1024)
}).describe('Request for "OPEN_SHARE_MOMENT_DIALOG" Command');
// AUTHENTICATE
const $a43ed54831525f7d$export$21449d5881a7a118 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    access_token: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
        (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
    ]).optional()
}).describe('Request for "AUTHENTICATE" Command');
const $a43ed54831525f7d$export$abba1635e36ab43f = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    access_token: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
    user: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        username: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        discriminator: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        avatar: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        public_flags: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
        global_name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional()
    }),
    scopes: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $39fcf09e0d14b4fd$export$b70693e61e1d03ea)((0, $403a382f9acbc955$export$2e2bcd8739ae039).enum([
        'identify',
        'email',
        'connections',
        'guilds',
        'guilds.join',
        'guilds.members.read',
        'guilds.channels.read',
        'gdm.join',
        'bot',
        'rpc',
        'rpc.notifications.read',
        'rpc.voice.read',
        'rpc.voice.write',
        'rpc.video.read',
        'rpc.video.write',
        'rpc.screenshare.read',
        'rpc.screenshare.write',
        'rpc.activities.write',
        'webhook.incoming',
        'messages.read',
        'applications.builds.upload',
        'applications.builds.read',
        'applications.commands',
        'applications.commands.permissions.update',
        'applications.commands.update',
        'applications.store.update',
        'applications.entitlements',
        'activities.read',
        'activities.write',
        'activities.invites.write',
        'relationships.read',
        'relationships.write',
        'voice',
        'dm_channels.read',
        'role_connections.write',
        'presences.read',
        'presences.write',
        'openid',
        'dm_channels.messages.read',
        'dm_channels.messages.write',
        'gateway.connect',
        'account.global_name.update',
        'payment_sources.country_code',
        'sdk.social_layer_presence',
        'sdk.social_layer',
        'lobbies.write',
        'application_identities.write'
    ]).or((0, $403a382f9acbc955$export$2e2bcd8739ae039).literal(-1)).default(-1))),
    expires: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
    application: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        description: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        icon: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        rpc_origins: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).string()).optional(),
        name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string()
    })
}).describe('Response for "AUTHENTICATE" Command');
// GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS
const $a43ed54831525f7d$export$55c4c3c25fd5c28e = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    participants: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        username: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        global_name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        discriminator: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        avatar: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        flags: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
        bot: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
        avatar_decoration_data: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                asset: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                skuId: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                expiresAt: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
            }),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        premium_type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        nickname: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional()
    }))
}).describe('Response for "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS" Command');
// SHARE_INTERACTION
const $a43ed54831525f7d$export$34bdde5b85891d77 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    command: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
    options: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        value: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string()
    })).optional(),
    content: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(2000).optional(),
    require_launch_channel: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean().optional(),
    preview_image: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        height: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
        url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        width: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number()
    }).optional(),
    components: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).literal(1),
        components: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
            type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).literal(2),
            style: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().gte(1).lte(5),
            label: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(80).optional(),
            custom_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(100).describe('Developer-defined identifier for the button; max 100 characters').optional()
        })).max(5).optional()
    })).optional(),
    pid: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
}).describe('Request for "SHARE_INTERACTION" Command');
const $a43ed54831525f7d$export$81e529541e4eaa5a = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    success: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean()
}).describe('Response for "SHARE_INTERACTION" Command');
// SHARE_LINK
const $a43ed54831525f7d$export$3c9e2aaf9c667aad = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    custom_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(64).optional(),
    message: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(1000),
    link_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(64).optional()
}).describe('Request for "SHARE_LINK" Command');
const $a43ed54831525f7d$export$8b31f86466a5b2c7 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    success: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
    didCopyLink: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
    didSendMessage: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean()
}).describe('Response for "SHARE_LINK" Command');
// GET_RELATIONSHIPS
const $a43ed54831525f7d$export$cf3ad725da54e6ab = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    relationships: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
        user: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
            id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            username: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            global_name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
            ]).optional(),
            discriminator: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            avatar: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
            ]).optional(),
            flags: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
            bot: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
            avatar_decoration_data: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                    asset: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                    skuId: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    expiresAt: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
                }),
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
            ]).optional(),
            premium_type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
            ]).optional()
        }),
        presence: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
            status: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            activity: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                    session_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional(),
                    name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                    url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                        (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                        (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
                    ]).optional(),
                    application_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    status_display_type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional(),
                    state: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    state_url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    details: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    details_url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    emoji: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                        (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                            name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                            id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                                (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
                            ]).optional(),
                            animated: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
                                (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
                                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
                            ]).optional()
                        }),
                        (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
                    ]).optional(),
                    assets: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                        large_image: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        large_text: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        large_url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        small_image: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        small_text: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        small_url: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional()
                    }).optional(),
                    timestamps: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                        start: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional(),
                        end: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
                    }).optional(),
                    party: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                        id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        size: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).number()).min(2).max(2).optional(),
                        privacy: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
                    }).optional(),
                    secrets: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                        match: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                        join: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional()
                    }).optional(),
                    sync_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    created_at: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional(),
                    instance: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean().optional(),
                    flags: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional(),
                    metadata: (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({}).optional(),
                    platform: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                    supported_platforms: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).string()).optional(),
                    buttons: (0, $403a382f9acbc955$export$2e2bcd8739ae039).array((0, $403a382f9acbc955$export$2e2bcd8739ae039).string()).optional(),
                    hangStatus: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional()
                }),
                (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
            ]).optional()
        }).optional()
    }))
}).describe('Response for "GET_RELATIONSHIPS" Command');
// INVITE_USER_EMBEDDED
const $a43ed54831525f7d$export$b4435c365c69d3f9 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    user_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
    content: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().min(0).max(1024).optional()
}).describe('Request for "INVITE_USER_EMBEDDED" Command');
// GET_USER
const $a43ed54831525f7d$export$af08b40b856b65e9 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().max(64)
}).describe('Request for "GET_USER" Command');
const $a43ed54831525f7d$export$efae7d0364e4f628 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
    (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
        id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        username: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        global_name: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        discriminator: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        avatar: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        flags: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
        bot: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
        avatar_decoration_data: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
                asset: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
                skuId: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string().optional(),
                expiresAt: (0, $403a382f9acbc955$export$2e2bcd8739ae039).number().optional()
            }),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional(),
        premium_type: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).number(),
            (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
        ]).optional()
    }),
    (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
]);
// GET_QUEST_ENROLLMENT_STATUS
const $a43ed54831525f7d$export$1576667503dc7922 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    quest_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string()
}).describe('Request for "GET_QUEST_ENROLLMENT_STATUS" Command');
const $a43ed54831525f7d$export$d0f6ddcb78f2b9e6 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    quest_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
    is_enrolled: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean(),
    enrolled_at: (0, $403a382f9acbc955$export$2e2bcd8739ae039).union([
        (0, $403a382f9acbc955$export$2e2bcd8739ae039).string(),
        (0, $403a382f9acbc955$export$2e2bcd8739ae039).null()
    ]).optional()
}).describe('Response for "GET_QUEST_ENROLLMENT_STATUS" Command');
// QUEST_START_TIMER
const $a43ed54831525f7d$export$781354905a4676b4 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    quest_id: (0, $403a382f9acbc955$export$2e2bcd8739ae039).string()
}).describe('Request for "QUEST_START_TIMER" Command');
const $a43ed54831525f7d$export$b20fb8e5626c7518 = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({
    success: (0, $403a382f9acbc955$export$2e2bcd8739ae039).boolean()
}).describe('Response for "QUEST_START_TIMER" Command');
/**
 * RPC Commands which support schemas.
 */ var $a43ed54831525f7d$export$cc7e12c76513e857;
(function(Command) {
    Command["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Command["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Command["AUTHENTICATE"] = "AUTHENTICATE";
    Command["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Command["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Command["SHARE_LINK"] = "SHARE_LINK";
    Command["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Command["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Command["GET_USER"] = "GET_USER";
    Command["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Command["QUEST_START_TIMER"] = "QUEST_START_TIMER";
})($a43ed54831525f7d$export$cc7e12c76513e857 || ($a43ed54831525f7d$export$cc7e12c76513e857 = {}));
const $a43ed54831525f7d$var$emptyResponseSchema = (0, $403a382f9acbc955$export$2e2bcd8739ae039).object({}).optional().nullable();
const $a43ed54831525f7d$var$emptyRequestSchema = (0, $403a382f9acbc955$export$2e2bcd8739ae039).void();
/**
 * Request & Response schemas for each supported RPC Command.
 */ const $a43ed54831525f7d$export$e49b768f28ad1b60 = {
    [$a43ed54831525f7d$export$cc7e12c76513e857.INITIATE_IMAGE_UPLOAD]: {
        request: $a43ed54831525f7d$var$emptyRequestSchema,
        response: $a43ed54831525f7d$export$599108c66632c238
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.OPEN_SHARE_MOMENT_DIALOG]: {
        request: $a43ed54831525f7d$export$b7048850f4d41d23,
        response: $a43ed54831525f7d$var$emptyResponseSchema
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.AUTHENTICATE]: {
        request: $a43ed54831525f7d$export$21449d5881a7a118,
        response: $a43ed54831525f7d$export$abba1635e36ab43f
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS]: {
        request: $a43ed54831525f7d$var$emptyRequestSchema,
        response: $a43ed54831525f7d$export$55c4c3c25fd5c28e
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.SHARE_INTERACTION]: {
        request: $a43ed54831525f7d$export$34bdde5b85891d77,
        response: $a43ed54831525f7d$export$81e529541e4eaa5a
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.SHARE_LINK]: {
        request: $a43ed54831525f7d$export$3c9e2aaf9c667aad,
        response: $a43ed54831525f7d$export$8b31f86466a5b2c7
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.GET_RELATIONSHIPS]: {
        request: $a43ed54831525f7d$var$emptyRequestSchema,
        response: $a43ed54831525f7d$export$cf3ad725da54e6ab
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.INVITE_USER_EMBEDDED]: {
        request: $a43ed54831525f7d$export$b4435c365c69d3f9,
        response: $a43ed54831525f7d$var$emptyResponseSchema
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.GET_USER]: {
        request: $a43ed54831525f7d$export$af08b40b856b65e9,
        response: $a43ed54831525f7d$export$efae7d0364e4f628
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.GET_QUEST_ENROLLMENT_STATUS]: {
        request: $a43ed54831525f7d$export$1576667503dc7922,
        response: $a43ed54831525f7d$export$d0f6ddcb78f2b9e6
    },
    [$a43ed54831525f7d$export$cc7e12c76513e857.QUEST_START_TIMER]: {
        request: $a43ed54831525f7d$export$781354905a4676b4,
        response: $a43ed54831525f7d$export$b20fb8e5626c7518
    }
};


// DISPATCH is sent as cmd but is a special case, so is excluded from Commands enum
const $7563c491739c9977$export$efd7770b5da84f9e = 'DISPATCH';
var $7563c491739c9977$export$ba30f7724cb0e54e;
(function(Commands) {
    Commands["AUTHORIZE"] = "AUTHORIZE";
    Commands["GET_GUILDS"] = "GET_GUILDS";
    Commands["GET_GUILD"] = "GET_GUILD";
    Commands["GET_CHANNEL"] = "GET_CHANNEL";
    Commands["GET_CHANNELS"] = "GET_CHANNELS";
    Commands["SELECT_VOICE_CHANNEL"] = "SELECT_VOICE_CHANNEL";
    Commands["SELECT_TEXT_CHANNEL"] = "SELECT_TEXT_CHANNEL";
    Commands["SUBSCRIBE"] = "SUBSCRIBE";
    Commands["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Commands["CAPTURE_SHORTCUT"] = "CAPTURE_SHORTCUT";
    Commands["SET_CERTIFIED_DEVICES"] = "SET_CERTIFIED_DEVICES";
    Commands["SET_ACTIVITY"] = "SET_ACTIVITY";
    Commands["GET_SKUS"] = "GET_SKUS";
    Commands["GET_ENTITLEMENTS"] = "GET_ENTITLEMENTS";
    Commands["GET_SKUS_EMBEDDED"] = "GET_SKUS_EMBEDDED";
    Commands["GET_ENTITLEMENTS_EMBEDDED"] = "GET_ENTITLEMENTS_EMBEDDED";
    Commands["START_PURCHASE"] = "START_PURCHASE";
    Commands["SET_CONFIG"] = "SET_CONFIG";
    Commands["SEND_ANALYTICS_EVENT"] = "SEND_ANALYTICS_EVENT";
    Commands["USER_SETTINGS_GET_LOCALE"] = "USER_SETTINGS_GET_LOCALE";
    Commands["OPEN_EXTERNAL_LINK"] = "OPEN_EXTERNAL_LINK";
    Commands["ENCOURAGE_HW_ACCELERATION"] = "ENCOURAGE_HW_ACCELERATION";
    Commands["CAPTURE_LOG"] = "CAPTURE_LOG";
    Commands["SET_ORIENTATION_LOCK_STATE"] = "SET_ORIENTATION_LOCK_STATE";
    Commands["OPEN_INVITE_DIALOG"] = "OPEN_INVITE_DIALOG";
    Commands["GET_PLATFORM_BEHAVIORS"] = "GET_PLATFORM_BEHAVIORS";
    Commands["GET_CHANNEL_PERMISSIONS"] = "GET_CHANNEL_PERMISSIONS";
    // START-GENERATED-SECTION
    Commands["AUTHENTICATE"] = "AUTHENTICATE";
    Commands["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Commands["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Commands["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Commands["GET_USER"] = "GET_USER";
    Commands["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Commands["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Commands["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Commands["QUEST_START_TIMER"] = "QUEST_START_TIMER";
    Commands["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Commands["SHARE_LINK"] = "SHARE_LINK";
// END-GENERATED-SECTION
})($7563c491739c9977$export$ba30f7724cb0e54e || ($7563c491739c9977$export$ba30f7724cb0e54e = {}));
const $7563c491739c9977$export$7a3470becaa040fa = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    cmd: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    data: (0, $403a382f9acbc955$export$19282c40b967aec6)(),
    evt: (0, $403a382f9acbc955$export$7b1b591b262c240)(),
    nonce: (0, $403a382f9acbc955$export$22b082955e083ec3)()
}).passthrough();
// TODO afgiel -- next breaking change release
// remove Scopes and ScopesObject in favor of Types.OAuthScopes
const $7563c491739c9977$export$75435f4e5bc6ddd7 = Object.assign(Object.assign({}, (0, $a43ed54831525f7d$export$abba1635e36ab43f).shape.scopes.element.overlayType._def.innerType.options[0].Values), {
    UNHANDLED: -1
});
const $7563c491739c9977$export$8546186883d6ff3e = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$75435f4e5bc6ddd7);
const $7563c491739c9977$export$69a0e7946cf616df = (0, $a43ed54831525f7d$export$cf3ad725da54e6ab).shape.relationships.element;
const $7563c491739c9977$export$1f44aaf2ec115b54 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    username: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    discriminator: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    global_name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    avatar: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    avatar_decoration_data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        asset: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        sku_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional()
    }).nullable(),
    bot: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    flags: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    premium_type: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable()
});
const $7563c491739c9977$export$6ba76af5c834ff81 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    user: $7563c491739c9977$export$1f44aaf2ec115b54,
    nick: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    roles: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()),
    joined_at: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    deaf: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    mute: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $7563c491739c9977$export$8fbf13c8b5cc978c = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    user_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    nick: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    avatar: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    avatar_decoration_data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        asset: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        sku_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
    }).optional().nullable(),
    color_string: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$56cc48506ff790a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    roles: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()).optional().nullable(),
    user: $7563c491739c9977$export$1f44aaf2ec115b54.optional().nullable(),
    require_colons: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    managed: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    animated: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    available: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable()
});
const $7563c491739c9977$export$e40a3aa7b507330e = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    mute: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    deaf: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    self_mute: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    self_deaf: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    suppress: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $7563c491739c9977$export$4b86a4e430ccb511 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    mute: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    nick: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    user: $7563c491739c9977$export$1f44aaf2ec115b54,
    voice_state: $7563c491739c9977$export$e40a3aa7b507330e,
    volume: (0, $403a382f9acbc955$export$98e628dec113755e)()
});
const $7563c491739c9977$export$39054e8696850518 = {
    UNHANDLED: -1,
    IDLE: 'idle',
    DND: 'dnd',
    ONLINE: 'online',
    OFFLINE: 'offline'
};
const $7563c491739c9977$export$96e9906d6d93a972 = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$39054e8696850518);
const $7563c491739c9977$export$9c16c1426311996d = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    created_at: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    timestamps: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        start: (0, $403a382f9acbc955$export$98e628dec113755e)(),
        end: (0, $403a382f9acbc955$export$98e628dec113755e)()
    }).partial().optional().nullable(),
    application_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    details: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    details_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().url().optional().nullable(),
    state: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    state_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().url().optional().nullable(),
    emoji: $7563c491739c9977$export$56cc48506ff790a.optional().nullable(),
    party: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
        size: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$98e628dec113755e)()).optional().nullable()
    }).optional().nullable(),
    assets: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        large_image: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
        large_text: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
        large_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().url().optional().nullable(),
        small_image: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
        small_text: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
        small_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().url().optional().nullable()
    }).partial().optional().nullable(),
    secrets: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        join: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        match: (0, $403a382f9acbc955$export$22b082955e083ec3)()
    }).partial().optional().nullable(),
    instance: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    flags: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable()
});
const $7563c491739c9977$export$fab33d7660c6e6d6 = {
    UNHANDLED: -1,
    ROLE: 0,
    MEMBER: 1
};
const $7563c491739c9977$export$3700bd144328e1a6 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$fab33d7660c6e6d6),
    allow: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    deny: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $7563c491739c9977$export$2f4cb441f3eded01 = {
    UNHANDLED: -1,
    DM: 1,
    GROUP_DM: 3,
    GUILD_TEXT: 0,
    GUILD_VOICE: 2,
    GUILD_CATEGORY: 4,
    GUILD_ANNOUNCEMENT: 5,
    GUILD_STORE: 6,
    ANNOUNCEMENT_THREAD: 10,
    PUBLIC_THREAD: 11,
    PRIVATE_THREAD: 12,
    GUILD_STAGE_VOICE: 13,
    GUILD_DIRECTORY: 14,
    GUILD_FORUM: 15
};
const $7563c491739c9977$export$cfdacaa37f9b4dd7 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$2f4cb441f3eded01),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    position: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    permission_overwrites: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$3700bd144328e1a6).optional().nullable(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    topic: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    nsfw: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    last_message_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    bitrate: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    user_limit: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    rate_limit_per_user: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    recipients: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$1f44aaf2ec115b54).optional().nullable(),
    icon: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    owner_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    application_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    parent_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    last_pin_timestamp: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$24da275c271e8208 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    user: $7563c491739c9977$export$1f44aaf2ec115b54,
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    status: $7563c491739c9977$export$96e9906d6d93a972,
    activities: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$9c16c1426311996d),
    client_status: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        desktop: $7563c491739c9977$export$96e9906d6d93a972,
        mobile: $7563c491739c9977$export$96e9906d6d93a972,
        web: $7563c491739c9977$export$96e9906d6d93a972
    }).partial()
});
const $7563c491739c9977$export$46919bad18fb2f76 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    color: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    hoist: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    position: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    permissions: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    managed: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    mentionable: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $7563c491739c9977$export$85e439e10eca0e6b = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    owner_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    icon: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    icon_hash: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    splash: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    discovery_splash: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    owner: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    permissions: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    region: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    afk_channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    afk_timeout: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    widget_enabled: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    widget_channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    verification_level: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    default_message_notifications: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    explicit_content_filter: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    roles: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$46919bad18fb2f76),
    emojis: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$56cc48506ff790a),
    features: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()),
    mfa_level: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    application_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    system_channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    system_channel_flags: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    rules_channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    joined_at: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    large: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    unavailable: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    member_count: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    voice_states: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$e40a3aa7b507330e).optional().nullable(),
    members: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$6ba76af5c834ff81).optional().nullable(),
    channels: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$cfdacaa37f9b4dd7).optional().nullable(),
    presences: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$24da275c271e8208).optional().nullable(),
    max_presences: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    max_members: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    vanity_url_code: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    description: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    banner: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    premium_tier: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    premium_subscription_count: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    preferred_locale: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    public_updates_channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    max_video_channel_users: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    approximate_member_count: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    approximate_presence_count: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable()
});
const $7563c491739c9977$export$8ce7ab97167fc310 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $7563c491739c9977$export$71e4db985cfcf9e3 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    filename: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    size: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    proxy_url: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    height: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    width: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable()
});
const $7563c491739c9977$export$8c9fffced316d89b = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    text: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    icon_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    proxy_icon_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$3e431a229df88919 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    proxy_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    height: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    width: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable()
});
const $7563c491739c9977$export$ae01dedf5c052bb = $7563c491739c9977$export$3e431a229df88919.omit({
    proxy_url: true
});
const $7563c491739c9977$export$e4790b418e6d5a4d = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$632a034bda2c67e4 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    icon_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    proxy_icon_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$8f305b092204e542 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    value: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    inline: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $7563c491739c9977$export$a84540bc8b694b2d = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    title: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    type: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    description: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    timestamp: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    color: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    footer: $7563c491739c9977$export$8c9fffced316d89b.optional().nullable(),
    image: $7563c491739c9977$export$3e431a229df88919.optional().nullable(),
    thumbnail: $7563c491739c9977$export$3e431a229df88919.optional().nullable(),
    video: $7563c491739c9977$export$ae01dedf5c052bb.optional().nullable(),
    provider: $7563c491739c9977$export$e4790b418e6d5a4d.optional().nullable(),
    author: $7563c491739c9977$export$632a034bda2c67e4.optional().nullable(),
    fields: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$8f305b092204e542).optional().nullable()
});
const $7563c491739c9977$export$d2ae4167a30cf6bb = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    count: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    me: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    emoji: $7563c491739c9977$export$56cc48506ff790a
});
const $7563c491739c9977$export$465ad97f4d04cf9a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    type: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    party_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$56f5e744391a955c = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    cover_image: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    description: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    icon: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $7563c491739c9977$export$bcebdc029e694ee6 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    message_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$f69c19e57285b83a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    author: $7563c491739c9977$export$1f44aaf2ec115b54.optional().nullable(),
    member: $7563c491739c9977$export$6ba76af5c834ff81.optional().nullable(),
    content: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    timestamp: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    edited_timestamp: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    tts: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    mention_everyone: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    mentions: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$1f44aaf2ec115b54),
    mention_roles: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()),
    mention_channels: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$8ce7ab97167fc310),
    attachments: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$71e4db985cfcf9e3),
    embeds: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$a84540bc8b694b2d),
    reactions: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$d2ae4167a30cf6bb).optional().nullable(),
    nonce: (0, $403a382f9acbc955$export$971dd5b0dfd021b6)([
        (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        (0, $403a382f9acbc955$export$98e628dec113755e)()
    ]).optional().nullable(),
    pinned: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    webhook_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    type: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    activity: $7563c491739c9977$export$465ad97f4d04cf9a.optional().nullable(),
    application: $7563c491739c9977$export$56f5e744391a955c.optional().nullable(),
    message_reference: $7563c491739c9977$export$bcebdc029e694ee6.optional().nullable(),
    flags: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    stickers: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$19282c40b967aec6)()).optional().nullable(),
    // Cannot self reference, but this is possibly a Message
    referenced_message: (0, $403a382f9acbc955$export$19282c40b967aec6)().optional().nullable()
});
const $7563c491739c9977$export$624aa0dd60bb35db = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $7563c491739c9977$export$2ede097136cc13e4 = {
    UNHANDLED: -1,
    KEYBOARD_KEY: 0,
    MOUSE_BUTTON: 1,
    KEYBOARD_MODIFIER_KEY: 2,
    GAMEPAD_BUTTON: 3
};
const $7563c491739c9977$export$f20a7ed0751474c1 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$2ede097136cc13e4),
    code: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $7563c491739c9977$export$9d6f8c8df913ee9d = {
    UNHANDLED: -1,
    PUSH_TO_TALK: 'PUSH_TO_TALK',
    VOICE_ACTIVITY: 'VOICE_ACTIVITY'
};
const $7563c491739c9977$export$c99e7704e60373e9 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$9d6f8c8df913ee9d),
    auto_threshold: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    threshold: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    shortcut: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$f20a7ed0751474c1),
    delay: (0, $403a382f9acbc955$export$98e628dec113755e)()
});
const $7563c491739c9977$export$cb1d6465ddfebcf0 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    device_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    volume: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    available_devices: (0, $403a382f9acbc955$export$2f23118c22fb2630)($7563c491739c9977$export$624aa0dd60bb35db)
});
const $7563c491739c9977$export$8320da8c452e87fc = {
    UNHANDLED: -1,
    AUDIO_INPUT: 'AUDIO_INPUT',
    AUDIO_OUTPUT: 'AUDIO_OUTPUT',
    VIDEO_INPUT: 'VIDEO_INPUT'
};
const $7563c491739c9977$export$4f2f4bd3c787de21 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$8320da8c452e87fc),
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    vendor: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        url: (0, $403a382f9acbc955$export$22b082955e083ec3)()
    }),
    model: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        url: (0, $403a382f9acbc955$export$22b082955e083ec3)()
    }),
    related: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()),
    echo_cancellation: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    noise_suppression: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    automatic_gain_control: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    hardware_mute: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable()
});
const $7563c491739c9977$export$439ecd4335b15be4 = {
    UNHANDLED: -1,
    APPLICATION: 1,
    DLC: 2,
    CONSUMABLE: 3,
    BUNDLE: 4,
    SUBSCRIPTION: 5
};
const $7563c491739c9977$export$ccf658062b0f9f7a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$439ecd4335b15be4),
    price: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        amount: (0, $403a382f9acbc955$export$98e628dec113755e)(),
        currency: (0, $403a382f9acbc955$export$22b082955e083ec3)()
    }),
    application_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    flags: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    release_date: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable()
});
const $7563c491739c9977$export$6259f37857107b12 = {
    UNHANDLED: -1,
    PURCHASE: 1,
    PREMIUM_SUBSCRIPTION: 2,
    DEVELOPER_GIFT: 3,
    TEST_MODE_PURCHASE: 4,
    FREE_PURCHASE: 5,
    USER_GIFT: 6,
    PREMIUM_PURCHASE: 7
};
const $7563c491739c9977$export$7b20d168ba04011b = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    sku_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    application_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    user_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    gift_code_flags: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$6259f37857107b12),
    gifter_user_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    branches: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$22b082955e083ec3)()).optional().nullable(),
    starts_at: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    ends_at: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    parent_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    consumed: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    deleted: (0, $403a382f9acbc955$export$4a21f16c33752377)().optional().nullable(),
    gift_code_batch_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable()
});
const $7563c491739c9977$export$7e8bb741497f2d3 = {
    UNHANDLED: -1,
    UNLOCKED: 1,
    PORTRAIT: 2,
    LANDSCAPE: 3
};
const $7563c491739c9977$export$76765004a89b60c4 = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$7e8bb741497f2d3);
const $7563c491739c9977$export$6b5ef5fbc271f145 = {
    UNHANDLED: -1,
    NOMINAL: 0,
    FAIR: 1,
    SERIOUS: 2,
    CRITICAL: 3
};
const $7563c491739c9977$export$8065eea9d621a18 = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$6b5ef5fbc271f145);
const $7563c491739c9977$export$6998f50a089a6f29 = {
    UNHANDLED: -1,
    PORTRAIT: 0,
    LANDSCAPE: 1
};
const $7563c491739c9977$export$df54d73aa0ec5e82 = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$6998f50a089a6f29);
const $7563c491739c9977$export$94c8fa8df0efcb28 = {
    UNHANDLED: -1,
    FOCUSED: 0,
    PIP: 1,
    GRID: 2
};
const $7563c491739c9977$export$8f9fafd62f4ed4cc = (0, $39fcf09e0d14b4fd$export$5989705faed03747)($7563c491739c9977$export$94c8fa8df0efcb28);




// ERROR is sent as evt but is a special case, so is excluded from Events enum
const $4658010a245c8473$export$103bedf43ba882db = 'ERROR';
var $4658010a245c8473$export$ada873a34909da65;
(function(Events) {
    Events["READY"] = "READY";
    Events["VOICE_STATE_UPDATE"] = "VOICE_STATE_UPDATE";
    Events["SPEAKING_START"] = "SPEAKING_START";
    Events["SPEAKING_STOP"] = "SPEAKING_STOP";
    Events["ACTIVITY_LAYOUT_MODE_UPDATE"] = "ACTIVITY_LAYOUT_MODE_UPDATE";
    Events["ORIENTATION_UPDATE"] = "ORIENTATION_UPDATE";
    Events["CURRENT_USER_UPDATE"] = "CURRENT_USER_UPDATE";
    Events["CURRENT_GUILD_MEMBER_UPDATE"] = "CURRENT_GUILD_MEMBER_UPDATE";
    Events["ENTITLEMENT_CREATE"] = "ENTITLEMENT_CREATE";
    Events["THERMAL_STATE_UPDATE"] = "THERMAL_STATE_UPDATE";
    Events["ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE"] = "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE";
    Events["RELATIONSHIP_UPDATE"] = "RELATIONSHIP_UPDATE";
    Events["ACTIVITY_JOIN"] = "ACTIVITY_JOIN";
    Events["QUEST_ENROLLMENT_STATUS_UPDATE"] = "QUEST_ENROLLMENT_STATUS_UPDATE";
})($4658010a245c8473$export$ada873a34909da65 || ($4658010a245c8473$export$ada873a34909da65 = {}));
const $4658010a245c8473$export$326fa0fd43fb9e9c = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
    evt: (0, $403a382f9acbc955$export$6fe7eca19ebe5199)($4658010a245c8473$export$ada873a34909da65),
    nonce: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    cmd: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)((0, $7563c491739c9977$export$efd7770b5da84f9e)),
    data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({}).passthrough()
});
const $4658010a245c8473$export$4c6f5e6e10fb9fd0 = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
    evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$103bedf43ba882db),
    data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
        code: (0, $403a382f9acbc955$export$98e628dec113755e)(),
        message: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional()
    }).passthrough(),
    cmd: (0, $403a382f9acbc955$export$6fe7eca19ebe5199)((0, $7563c491739c9977$export$ba30f7724cb0e54e)),
    nonce: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable()
});
const $4658010a245c8473$export$a242e5821d539c8e = $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
    evt: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $4658010a245c8473$export$f344a15bf52574b2 = (0, $403a382f9acbc955$export$971dd5b0dfd021b6)([
    $4658010a245c8473$export$326fa0fd43fb9e9c,
    $4658010a245c8473$export$a242e5821d539c8e,
    $4658010a245c8473$export$4c6f5e6e10fb9fd0
]);
function $4658010a245c8473$export$a46bc76e895063f4(data) {
    const event = data.evt;
    if (!(event in $4658010a245c8473$export$ada873a34909da65)) throw new Error(`Unrecognized event type ${data.evt}`);
    const eventSchema = $4658010a245c8473$export$769a4ec051ed522c[event];
    return eventSchema.payload.parse(data);
}
const $4658010a245c8473$export$769a4ec051ed522c = {
    /**
     * @description
     * The READY event is emitted by Discord's RPC server in reply to a client
     * initiating the RPC handshake. The event includes information about
     * - the rpc server version
     * - the discord client configuration
     * - the (basic) user object
     *
     * Unlike other events, READY will only be omitted once, immediately after the
     * Embedded App SDK is initialized
     *
     * # Supported Platforms
     * | Web | iOS | Android |
     * |-----|-----|---------|
     * | ✅  | ✅  | ✅      |
     *
     * Required scopes: []
     *
     */ [$4658010a245c8473$export$ada873a34909da65.READY]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.READY),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                v: (0, $403a382f9acbc955$export$98e628dec113755e)(),
                config: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                    cdn_host: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
                    api_endpoint: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                    environment: (0, $403a382f9acbc955$export$22b082955e083ec3)()
                }),
                user: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                    username: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                    discriminator: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                    avatar: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional()
                }).optional()
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.VOICE_STATE_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.VOICE_STATE_UPDATE),
            data: (0, $7563c491739c9977$export$4b86a4e430ccb511)
        }),
        subscribeArgs: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
            channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)()
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.SPEAKING_START]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.SPEAKING_START),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                lobby_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
                channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
                user_id: (0, $403a382f9acbc955$export$22b082955e083ec3)()
            })
        }),
        subscribeArgs: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
            lobby_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable().optional(),
            channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable().optional()
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.SPEAKING_STOP]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.SPEAKING_STOP),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                lobby_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
                channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
                user_id: (0, $403a382f9acbc955$export$22b082955e083ec3)()
            })
        }),
        subscribeArgs: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
            lobby_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable().optional(),
            channel_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable().optional()
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                layout_mode: (0, $39fcf09e0d14b4fd$export$5989705faed03747)((0, $7563c491739c9977$export$94c8fa8df0efcb28))
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.ORIENTATION_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.ORIENTATION_UPDATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                screen_orientation: (0, $39fcf09e0d14b4fd$export$5989705faed03747)((0, $7563c491739c9977$export$6998f50a089a6f29)),
                /**
                 * @deprecated use screen_orientation instead
                 */ orientation: (0, $403a382f9acbc955$export$6fe7eca19ebe5199)((0, $46a39478d4fb12cc$export$df54d73aa0ec5e82))
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.CURRENT_USER_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.CURRENT_USER_UPDATE),
            data: (0, $7563c491739c9977$export$1f44aaf2ec115b54)
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE),
            data: (0, $7563c491739c9977$export$8fbf13c8b5cc978c)
        }),
        subscribeArgs: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
            guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)()
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.ENTITLEMENT_CREATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.ENTITLEMENT_CREATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                entitlement: (0, $7563c491739c9977$export$7b20d168ba04011b)
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.THERMAL_STATE_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.THERMAL_STATE_UPDATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                thermal_state: (0, $7563c491739c9977$export$8065eea9d621a18)
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                participants: (0, $a43ed54831525f7d$export$55c4c3c25fd5c28e).shape.participants
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.RELATIONSHIP_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.RELATIONSHIP_UPDATE),
            data: (0, $7563c491739c9977$export$69a0e7946cf616df)
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.ACTIVITY_JOIN]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.ACTIVITY_JOIN),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                applicationId: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                secret: (0, $403a382f9acbc955$export$22b082955e083ec3)()
            })
        })
    },
    [$4658010a245c8473$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE]: {
        payload: $4658010a245c8473$export$326fa0fd43fb9e9c.extend({
            evt: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)($4658010a245c8473$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE),
            data: (0, $403a382f9acbc955$export$be5493f9613cbbe)({
                quest_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
                is_enrolled: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
                enrolled_at: (0, $403a382f9acbc955$export$22b082955e083ec3)().date()
            })
        })
    }
};






/**
 * Assets x is statically unreachable at build-time,
 * and throws at runtime if data is dynamic.
 */ function $692eee92c989cd6f$export$2e2bcd8739ae039(_x, runtimeError) {
    throw runtimeError;
}


const $2689ee7a71dc2dcb$export$2663ce359599a39a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({}).nullable();
const $2689ee7a71dc2dcb$export$a20dff0010f153a4 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    code: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $2689ee7a71dc2dcb$export$c72c401de381626f = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    guilds: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $403a382f9acbc955$export$be5493f9613cbbe)({
        id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
        name: (0, $403a382f9acbc955$export$22b082955e083ec3)()
    }))
});
const $2689ee7a71dc2dcb$export$5845be03a3ebb99a = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    icon_url: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional(),
    members: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$6ba76af5c834ff81))
});
const $2689ee7a71dc2dcb$export$116d844d40ad5f3c = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    type: (0, $39fcf09e0d14b4fd$export$5989705faed03747)((0, $7563c491739c9977$export$2f4cb441f3eded01)),
    guild_id: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    name: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    topic: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional().nullable(),
    bitrate: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    user_limit: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    position: (0, $403a382f9acbc955$export$98e628dec113755e)().optional().nullable(),
    voice_states: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$4b86a4e430ccb511)),
    messages: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$f69c19e57285b83a))
});
const $2689ee7a71dc2dcb$export$1f3b23c28c30c42c = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    channels: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$cfdacaa37f9b4dd7))
});
const $2689ee7a71dc2dcb$export$8ff9fe3ffde6290d = $2689ee7a71dc2dcb$export$116d844d40ad5f3c.nullable();
const $2689ee7a71dc2dcb$export$c74d4aa0f66fc05e = $2689ee7a71dc2dcb$export$116d844d40ad5f3c.nullable();
const $2689ee7a71dc2dcb$export$e114312640cd43d8 = $2689ee7a71dc2dcb$export$116d844d40ad5f3c.nullable();
const $2689ee7a71dc2dcb$export$f3dffed82766df8f = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    input: (0, $7563c491739c9977$export$cb1d6465ddfebcf0),
    output: (0, $7563c491739c9977$export$cb1d6465ddfebcf0),
    mode: (0, $7563c491739c9977$export$c99e7704e60373e9),
    automatic_gain_control: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    echo_cancellation: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    noise_suppression: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    qos: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    silence_warning: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    deaf: (0, $403a382f9acbc955$export$4a21f16c33752377)(),
    mute: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $2689ee7a71dc2dcb$export$89425a92d6d4fba3 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    evt: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $2689ee7a71dc2dcb$export$49ab8a39ea910965 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    shortcut: (0, $7563c491739c9977$export$f20a7ed0751474c1)
});
const $2689ee7a71dc2dcb$export$6441b328b684708a = (0, $7563c491739c9977$export$9c16c1426311996d);
const $2689ee7a71dc2dcb$export$c5585ad29c8f7bd0 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    skus: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$ccf658062b0f9f7a))
});
const $2689ee7a71dc2dcb$export$4232197b78e8b524 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    entitlements: (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$7b20d168ba04011b))
});
const $2689ee7a71dc2dcb$export$17177c7243ab05e = (0, $403a382f9acbc955$export$2f23118c22fb2630)((0, $7563c491739c9977$export$7b20d168ba04011b)).nullable();
const $2689ee7a71dc2dcb$export$d92a181530f7d8d5 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    use_interactive_pip: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $2689ee7a71dc2dcb$export$b462b396db5f92a0 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    locale: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $2689ee7a71dc2dcb$export$15549cbd10945eeb = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    enabled: (0, $403a382f9acbc955$export$4a21f16c33752377)()
});
const $2689ee7a71dc2dcb$export$67379dca9f34c2b9 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    permissions: (0, $403a382f9acbc955$export$a0f65b52274bcc00)().or((0, $403a382f9acbc955$export$22b082955e083ec3)())
});
const $2689ee7a71dc2dcb$export$5e5d1b8668e0d4d5 = (0, $39fcf09e0d14b4fd$export$b70693e61e1d03ea)((0, $403a382f9acbc955$export$be5493f9613cbbe)({
    opened: (0, $403a382f9acbc955$export$4a21f16c33752377)().or((0, $403a382f9acbc955$export$7b1b591b262c240)())
}).default({
    opened: null
}));
/**
 * Because of the nature of Platform Behavior changes
 * every key/value is optional and may eventually be removed
 */ const $2689ee7a71dc2dcb$export$ea78864ca3ab3f3c = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    iosKeyboardResizesView: (0, $403a382f9acbc955$export$516e28dec6a4b6d4)((0, $403a382f9acbc955$export$4a21f16c33752377)())
});
const $2689ee7a71dc2dcb$export$8ffc8c4280411e44 = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
    cmd: (0, $403a382f9acbc955$export$6fe7eca19ebe5199)((0, $7563c491739c9977$export$ba30f7724cb0e54e)),
    evt: (0, $403a382f9acbc955$export$7b1b591b262c240)()
});
function $2689ee7a71dc2dcb$var$parseResponseData({ cmd: cmd, data: data }) {
    switch(cmd){
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).AUTHORIZE:
            return $2689ee7a71dc2dcb$export$a20dff0010f153a4.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).CAPTURE_SHORTCUT:
            return $2689ee7a71dc2dcb$export$49ab8a39ea910965.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).ENCOURAGE_HW_ACCELERATION:
            return $2689ee7a71dc2dcb$export$15549cbd10945eeb.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNEL:
            return $2689ee7a71dc2dcb$export$116d844d40ad5f3c.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNELS:
            return $2689ee7a71dc2dcb$export$1f3b23c28c30c42c.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNEL_PERMISSIONS:
            return $2689ee7a71dc2dcb$export$67379dca9f34c2b9.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_GUILD:
            return $2689ee7a71dc2dcb$export$5845be03a3ebb99a.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_GUILDS:
            return $2689ee7a71dc2dcb$export$c72c401de381626f.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_PLATFORM_BEHAVIORS:
            return $2689ee7a71dc2dcb$export$ea78864ca3ab3f3c.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNEL:
            return $2689ee7a71dc2dcb$export$116d844d40ad5f3c.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SELECT_TEXT_CHANNEL:
            return $2689ee7a71dc2dcb$export$e114312640cd43d8.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SELECT_VOICE_CHANNEL:
            return $2689ee7a71dc2dcb$export$c74d4aa0f66fc05e.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_ACTIVITY:
            return $2689ee7a71dc2dcb$export$6441b328b684708a.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_SKUS_EMBEDDED:
            return $2689ee7a71dc2dcb$export$c5585ad29c8f7bd0.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_ENTITLEMENTS_EMBEDDED:
            return $2689ee7a71dc2dcb$export$4232197b78e8b524.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_CONFIG:
            return $2689ee7a71dc2dcb$export$d92a181530f7d8d5.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).START_PURCHASE:
            return $2689ee7a71dc2dcb$export$17177c7243ab05e.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SUBSCRIBE:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).UNSUBSCRIBE:
            return $2689ee7a71dc2dcb$export$89425a92d6d4fba3.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).USER_SETTINGS_GET_LOCALE:
            return $2689ee7a71dc2dcb$export$b462b396db5f92a0.parse(data);
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).OPEN_EXTERNAL_LINK:
            return $2689ee7a71dc2dcb$export$5e5d1b8668e0d4d5.parse(data);
        // Empty Responses
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_ORIENTATION_LOCK_STATE:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_CERTIFIED_DEVICES:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SEND_ANALYTICS_EVENT:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).OPEN_INVITE_DIALOG:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).CAPTURE_LOG:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_SKUS:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_ENTITLEMENTS:
            return $2689ee7a71dc2dcb$export$2663ce359599a39a.parse(data);
        // START-GENERATED-SECTION
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).AUTHENTICATE:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_QUEST_ENROLLMENT_STATUS:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_RELATIONSHIPS:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_USER:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).INITIATE_IMAGE_UPLOAD:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).INVITE_USER_EMBEDDED:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).OPEN_SHARE_MOMENT_DIALOG:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).QUEST_START_TIMER:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SHARE_INTERACTION:
        case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SHARE_LINK:
            // END-GENERATED-SECTION
            const { response: response } = (0, $a43ed54831525f7d$export$e49b768f28ad1b60)[cmd];
            return response.parse(data);
        default:
            (0, $692eee92c989cd6f$export$2e2bcd8739ae039)(cmd, new Error(`Unrecognized command ${cmd}`));
    }
}
function $2689ee7a71dc2dcb$export$4890fc55aa463c4c(payload) {
    return Object.assign(Object.assign({}, payload), {
        data: $2689ee7a71dc2dcb$var$parseResponseData(payload)
    });
}




(0, $403a382f9acbc955$export$be5493f9613cbbe)({
    frame_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    platform: (0, $403a382f9acbc955$export$6fe7eca19ebe5199)((0, $46a39478d4fb12cc$export$2dffd0b5373a4389)).optional().nullable()
});
(0, $403a382f9acbc955$export$be5493f9613cbbe)({
    v: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)(1),
    encoding: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)('json').optional(),
    client_id: (0, $403a382f9acbc955$export$22b082955e083ec3)(),
    frame_id: (0, $403a382f9acbc955$export$22b082955e083ec3)()
});
const $41dc29da86c0e5f0$export$46b1619f8b73becb = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    code: (0, $403a382f9acbc955$export$98e628dec113755e)(),
    message: (0, $403a382f9acbc955$export$22b082955e083ec3)().optional()
});
const $41dc29da86c0e5f0$export$d3f475fe77824935 = (0, $403a382f9acbc955$export$be5493f9613cbbe)({
    evt: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    nonce: (0, $403a382f9acbc955$export$22b082955e083ec3)().nullable(),
    data: (0, $403a382f9acbc955$export$19282c40b967aec6)().nullable(),
    cmd: (0, $403a382f9acbc955$export$22b082955e083ec3)()
}).passthrough();
function $41dc29da86c0e5f0$export$97b1c66ab98393bd(payload) {
    const incoming = $41dc29da86c0e5f0$export$d3f475fe77824935.parse(payload);
    if (incoming.evt != null) {
        if (incoming.evt === (0, $4658010a245c8473$export$103bedf43ba882db)) return (0, $4658010a245c8473$export$4c6f5e6e10fb9fd0).parse(incoming);
        return (0, $4658010a245c8473$export$a46bc76e895063f4)((0, $4658010a245c8473$export$f344a15bf52574b2).parse(incoming));
    } else return (0, $2689ee7a71dc2dcb$export$4890fc55aa463c4c)((0, $2689ee7a71dc2dcb$export$8ffc8c4280411e44).passthrough().parse(incoming));
}








function $1d84de1e5c5656aa$export$df09d935d625c3d3(sendCommand, cmd, response, transferTransform = ()=>undefined) {
    const payload = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
        cmd: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)(cmd),
        data: response
    });
    return async (args)=>{
        const reply = await sendCommand({
            cmd: cmd,
            args: args,
            transfer: transferTransform(args)
        });
        const parsed = payload.parse(reply);
        return parsed.data;
    };
}
function $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8(cmd, transferTransform = ()=>undefined) {
    const response = (0, $a43ed54831525f7d$export$e49b768f28ad1b60)[cmd].response;
    const payload = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
        cmd: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)(cmd),
        data: response
    });
    return (sendCommand)=>async (args)=>{
            const reply = await sendCommand({
                // @ts-expect-error - Merge commands
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        };
}


/**
 * Should be called directly after a `ready` payload is received from the
 * Discord client. It includes a list of all scopes that your activity would
 * like to be authorized to use. If the user does not yet have a valid token
 * for all scopes requested, this command will open an OAuth modal. Once an
 * authorized token is available, it will be returned in the command response.
 */ const $2298c401127190e3$export$be1f35f80d3e29cc = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).AUTHORIZE, (0, $2689ee7a71dc2dcb$export$a20dff0010f153a4));





/**
 *
 */ const $5364b9f4f3bb54e8$export$bd13a7db1bc707cf = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).CAPTURE_LOG, (0, $2689ee7a71dc2dcb$export$2663ce359599a39a));





/**
 *
 */ const $2c3ecfa96db85359$export$18896ba25f701706 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).ENCOURAGE_HW_ACCELERATION, (0, $2689ee7a71dc2dcb$export$15549cbd10945eeb));





/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#getchannel
 * Calling getChannel gets info about the requested channel such as the channel name.
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes:
 * - [guilds] for guild channels
 * - [guilds, dm_channels.read] for GDM channels. dm_channels.read requires approval from Discord.
 *
 * @example
 * await discordSdk.commands.getActivity({
 *   channel_id: discordSdk.channelId,
 * });
 */ const $6a0600def6b3ad21$export$98c37618398a9832 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNEL, (0, $2689ee7a71dc2dcb$export$116d844d40ad5f3c));





/**
 *
 */ const $167f521aa6b7f03a$export$6fb7719f7ba7d022 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_ENTITLEMENTS_EMBEDDED, (0, $2689ee7a71dc2dcb$export$4232197b78e8b524));





/*
 *
 */ const $e5f5c69d7cf346ab$export$dcbcde0b5cdb27ed = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_SKUS_EMBEDDED, (0, $2689ee7a71dc2dcb$export$c5585ad29c8f7bd0));





/**
 * Returns a bigint representing Permissions for the current user in the currently connected channel. Use PermissionsUtils to calculate if a user has a particular permission.
 * Always returns `0n` (no valid permissions) in a (G)DM context, so is unnecessary to call when discordSdk.guildId == null.
 */ const $7c6fd9b85a4f8be7$export$e660ed046f465777 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_CHANNEL_PERMISSIONS, (0, $2689ee7a71dc2dcb$export$67379dca9f34c2b9));





/**
 * Returns an object with information about platform behaviors
 * This command can be utilized to inform and react to a breaking change in platform behavior
 *
 * @returns {GetPlatformBehaviorsPayload} payload - The command return value
 * @returns {boolean} payload.data.iosKeyboardResizesView - If on iOS the webview is resized when the keyboard is opened
 */ const $d858dcdf4014e45c$export$efbfaabbffdc43d1 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).GET_PLATFORM_BEHAVIORS, (0, $2689ee7a71dc2dcb$export$ea78864ca3ab3f3c));





/**
 *
 */ const $e8273b88bb47fb00$export$ade3ab3891e57f44 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).OPEN_EXTERNAL_LINK, (0, $2689ee7a71dc2dcb$export$5e5d1b8668e0d4d5));





/**
 * Opens the invite dialog within the discord client, allowing users to share invite links to friends.
 * Does not work in (G)DM contexts (throws RPCError.INVALID_CHANNEL), so should not be called if discordSdk.guildId == null
 * Similarly, if the user does not have Permissions.CREATE_INSTANT_INVITE this command throws RPCErrors.INVALID_PERMISSIONS, so checking the user's permissions via getChannelPermissions is highly recommended.
 */ const $365c8e173295d475$export$d02b38bee2b2489b = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).OPEN_INVITE_DIALOG, (0, $2689ee7a71dc2dcb$export$2663ce359599a39a));





(0, $7563c491739c9977$export$9c16c1426311996d).pick({
    state: true,
    state_url: true,
    details: true,
    details_url: true,
    timestamps: true,
    assets: true,
    party: true,
    secrets: true,
    instance: true,
    type: true
}).extend({
    type: (0, $7563c491739c9977$export$9c16c1426311996d).shape.type.optional(),
    instance: (0, $7563c491739c9977$export$9c16c1426311996d).shape.instance.optional()
}).nullable();
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#setactivity
 * Calling setActivity allows modifying how your activity's rich presence is displayed in the Discord App
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes: [rpc.activities.write]
 *
 * @example
 * await discordSdk.commands.setActivity({
 *   activity: {
 *     type: 0,
 *     details: 'Details',
 *     state: 'Playing',
 *   },
 * });
 */ const $c9ed0b65660b0bd2$export$5e61ed4454e4dc1b = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_ACTIVITY, (0, $2689ee7a71dc2dcb$export$6441b328b684708a));





/**
 *
 */ const $742fc62d5e836d33$export$940a7873bb071df8 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_CONFIG, (0, $2689ee7a71dc2dcb$export$d92a181530f7d8d5));







/**
 * @args - the primary args to send with the command.
 * @fallbackArgs - the args to try the command with in the case where an old Discord
 *  client doesn't support one of the new args.
 */ function $41aa84ca77d5ee74$export$2e2bcd8739ae039({ sendCommand: sendCommand, cmd: cmd, response: response, fallbackTransform: fallbackTransform, transferTransform: transferTransform = ()=>undefined }) {
    const payload = (0, $7563c491739c9977$export$7a3470becaa040fa).extend({
        cmd: (0, $403a382f9acbc955$export$c8ec6e1ec9fefcb0)(cmd),
        data: response
    });
    return async (args)=>{
        try {
            const reply = await sendCommand({
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        } catch (error) {
            if (error.code === (0, $46a39478d4fb12cc$export$9ebb08d40ecbafd9).INVALID_PAYLOAD) {
                const fallbackArgs = fallbackTransform(args);
                const reply = await sendCommand({
                    cmd: cmd,
                    args: fallbackArgs,
                    transfer: transferTransform(fallbackArgs)
                });
                const parsed = payload.parse(reply);
                return parsed.data;
            } else throw error;
        }
    };
}


const $d84f479abf9cb65c$var$fallbackTransform = (args)=>{
    return {
        lock_state: args.lock_state,
        picture_in_picture_lock_state: args.picture_in_picture_lock_state
    };
};
const $d84f479abf9cb65c$export$970bc058b4f43d8a = (sendCommand)=>(0, $41aa84ca77d5ee74$export$2e2bcd8739ae039)({
        sendCommand: sendCommand,
        cmd: (0, $7563c491739c9977$export$ba30f7724cb0e54e).SET_ORIENTATION_LOCK_STATE,
        response: (0, $2689ee7a71dc2dcb$export$2663ce359599a39a),
        fallbackTransform: $d84f479abf9cb65c$var$fallbackTransform
    });





/**
 *
 */ const $75663fef2004c279$export$fb512c02b6232086 = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).START_PURCHASE, (0, $2689ee7a71dc2dcb$export$17177c7243ab05e));





/**
 *
 */ const $0dc7581775e594cc$export$8358d3ac583ae3cc = (sendCommand)=>(0, $1d84de1e5c5656aa$export$df09d935d625c3d3)(sendCommand, (0, $7563c491739c9977$export$ba30f7724cb0e54e).USER_SETTINGS_GET_LOCALE, (0, $2689ee7a71dc2dcb$export$b462b396db5f92a0));




/**
 * Authenticate Activity
 */ const $899e337a7dd79428$export$61bb00ddedae72e4 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).AUTHENTICATE);




const $42e696870ad66442$export$b446055c1c3a2811 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS);




const $c586f429cec34dac$export$12ffbf39da29c43e = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).GET_QUEST_ENROLLMENT_STATUS);




const $a09fcfe5cb32da8c$export$ece9beb28e4eb24 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).GET_RELATIONSHIPS);




const $1394fe8bb67cb124$export$7cbf767827cd68ba = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).GET_USER);




/**
 * Triggers the file upload flow in the Discord app. The user will be prompted to select a valid image file
 * and then it will be uploaded on the app side to the Discord CDN.
 *
 * NOTE: The URL provided by the API is an ephemeral attachment URL, so the image will not be permanently
 * accessible at the link provided.
 *
 * @returns {Promise<{image_url: string}>}
 */ const $296c245598f4ef9b$export$1870764d8cf96241 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).INITIATE_IMAGE_UPLOAD);




const $3f1b8d27e9755aeb$export$6ebf76884107f3b0 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).INVITE_USER_EMBEDDED);




/**
 * Opens the Share Moment Dialog in the user's client, allowing them to share the media at mediaUrl as a message.
 *
 * @param {string} mediaUrl - a Discord CDN URL for the piece of media to be shared.
 * @returns {Promise<void>}
 */ const $e91f1e0d76ff6640$export$de3eb37c8ceccf16 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).OPEN_SHARE_MOMENT_DIALOG);




const $d21caffc43f6ada1$export$128e47a361e01b46 = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).QUEST_START_TIMER);




const $4a22b82a3bbf25f3$export$c69b0fe8e5e669dc = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).SHARE_INTERACTION);




/**
 * Opens a modal in the user's client to share the Activity link.
 *
 * @param {string} referrer_id
 * @param {string} custom_id
 * @param {string} message - message sent alongside link when shared.
 * @returns {Promise<{success: boolean>} whether or not the user shared the link to someone
 */ const $2a2e97893e2aa0f9$export$125499b12b97cddb = (0, $1d84de1e5c5656aa$export$3c2dac6e8a4c05f8)((0, $a43ed54831525f7d$export$cc7e12c76513e857).SHARE_LINK);


function $c2b2d40a6340332c$export$2e2bcd8739ae039(sendCommand) {
    return {
        authorize: (0, $2298c401127190e3$export$be1f35f80d3e29cc)(sendCommand),
        captureLog: (0, $5364b9f4f3bb54e8$export$bd13a7db1bc707cf)(sendCommand),
        encourageHardwareAcceleration: (0, $2c3ecfa96db85359$export$18896ba25f701706)(sendCommand),
        getChannel: (0, $6a0600def6b3ad21$export$98c37618398a9832)(sendCommand),
        getChannelPermissions: (0, $7c6fd9b85a4f8be7$export$e660ed046f465777)(sendCommand),
        getEntitlements: (0, $167f521aa6b7f03a$export$6fb7719f7ba7d022)(sendCommand),
        getPlatformBehaviors: (0, $d858dcdf4014e45c$export$efbfaabbffdc43d1)(sendCommand),
        getSkus: (0, $e5f5c69d7cf346ab$export$dcbcde0b5cdb27ed)(sendCommand),
        openExternalLink: (0, $e8273b88bb47fb00$export$ade3ab3891e57f44)(sendCommand),
        openInviteDialog: (0, $365c8e173295d475$export$d02b38bee2b2489b)(sendCommand),
        setActivity: (0, $c9ed0b65660b0bd2$export$5e61ed4454e4dc1b)(sendCommand),
        setConfig: (0, $742fc62d5e836d33$export$940a7873bb071df8)(sendCommand),
        setOrientationLockState: (0, $d84f479abf9cb65c$export$970bc058b4f43d8a)(sendCommand),
        startPurchase: (0, $75663fef2004c279$export$fb512c02b6232086)(sendCommand),
        userSettingsGetLocale: (0, $0dc7581775e594cc$export$8358d3ac583ae3cc)(sendCommand),
        // Backward compatibility - getInstanceConnectedParticipants is an alias for getActivityInstanceConnectedParticipants
        getInstanceConnectedParticipants: (0, $42e696870ad66442$export$b446055c1c3a2811)(sendCommand),
        // START-GENERATED-SECTION
        authenticate: (0, $899e337a7dd79428$export$61bb00ddedae72e4)(sendCommand),
        getActivityInstanceConnectedParticipants: (0, $42e696870ad66442$export$b446055c1c3a2811)(sendCommand),
        getQuestEnrollmentStatus: (0, $c586f429cec34dac$export$12ffbf39da29c43e)(sendCommand),
        getRelationships: (0, $a09fcfe5cb32da8c$export$ece9beb28e4eb24)(sendCommand),
        getUser: (0, $1394fe8bb67cb124$export$7cbf767827cd68ba)(sendCommand),
        initiateImageUpload: (0, $296c245598f4ef9b$export$1870764d8cf96241)(sendCommand),
        inviteUserEmbedded: (0, $3f1b8d27e9755aeb$export$6ebf76884107f3b0)(sendCommand),
        openShareMomentDialog: (0, $e91f1e0d76ff6640$export$de3eb37c8ceccf16)(sendCommand),
        questStartTimer: (0, $d21caffc43f6ada1$export$128e47a361e01b46)(sendCommand),
        shareInteraction: (0, $4a22b82a3bbf25f3$export$c69b0fe8e5e669dc)(sendCommand),
        shareLink: (0, $2a2e97893e2aa0f9$export$125499b12b97cddb)(sendCommand)
    };
}


class $3ef1b11d536158b3$export$e1d52e4f0c7557a1 extends Error {
    constructor(code, message = ''){
        super(message);
        this.code = code;
        this.message = message;
        this.name = 'Discord SDK Error';
    }
}




function $4ba1bc9ff3722d9c$export$2e2bcd8739ae039() {
    return {
        disableConsoleLogOverride: false
    };
}


const $e355169fecea76da$export$a3647e951d1937a9 = [
    'log',
    'warn',
    'debug',
    'info',
    'error'
];
function $e355169fecea76da$export$46a03bf5755ffc4c(console, level, callback) {
    const _consoleMethod = console[level];
    const _console = console;
    if (!_consoleMethod) return;
    console[level] = function() {
        const args = [].slice.call(arguments);
        const message = '' + args.join(' ');
        callback(level, message);
        _consoleMethod.apply(_console, args);
    };
}


var $b9691ad61d5899a7$export$83d89fbfd8236492 = "2.4.0";



const $1f3f838b00733c09$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $1f3f838b00733c09$export$2e2bcd8739ae039 = {
    randomUUID: $1f3f838b00733c09$var$randomUUID
};


let $947aeecfddcb5874$var$getRandomValues;
const $947aeecfddcb5874$var$rnds8 = new Uint8Array(16);
function $947aeecfddcb5874$export$2e2bcd8739ae039() {
    if (!$947aeecfddcb5874$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $947aeecfddcb5874$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $947aeecfddcb5874$var$getRandomValues($947aeecfddcb5874$var$rnds8);
}


const $c19adbeab4f96da3$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$c19adbeab4f96da3$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $c19adbeab4f96da3$export$8fb373d660548968(arr, offset = 0) {
    return ($c19adbeab4f96da3$var$byteToHex[arr[offset + 0]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 1]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 2]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 3]] + '-' + $c19adbeab4f96da3$var$byteToHex[arr[offset + 4]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 5]] + '-' + $c19adbeab4f96da3$var$byteToHex[arr[offset + 6]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 7]] + '-' + $c19adbeab4f96da3$var$byteToHex[arr[offset + 8]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 9]] + '-' + $c19adbeab4f96da3$var$byteToHex[arr[offset + 10]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 11]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 12]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 13]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 14]] + $c19adbeab4f96da3$var$byteToHex[arr[offset + 15]]).toLowerCase();
}


function $22629b62dd584f53$export$2e2bcd8739ae039(options, buf, offset) {
    if ((0, $1f3f838b00733c09$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $1f3f838b00733c09$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $947aeecfddcb5874$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    return (0, $c19adbeab4f96da3$export$8fb373d660548968)(rnds);
}


var $c537748c1911e01f$export$6354ae5022ad3977;
(function(Opcodes) {
    Opcodes[Opcodes["HANDSHAKE"] = 0] = "HANDSHAKE";
    Opcodes[Opcodes["FRAME"] = 1] = "FRAME";
    Opcodes[Opcodes["CLOSE"] = 2] = "CLOSE";
    Opcodes[Opcodes["HELLO"] = 3] = "HELLO";
})($c537748c1911e01f$export$6354ae5022ad3977 || ($c537748c1911e01f$export$6354ae5022ad3977 = {}));
const $c537748c1911e01f$var$ALLOWED_ORIGINS = new Set($c537748c1911e01f$var$getAllowedOrigins());
function $c537748c1911e01f$var$getAllowedOrigins() {
    if (typeof window === 'undefined') return [];
    return [
        window.location.origin,
        'https://discord.com',
        'https://discordapp.com',
        'https://ptb.discord.com',
        'https://ptb.discordapp.com',
        'https://canary.discord.com',
        'https://canary.discordapp.com',
        'https://staging.discord.co',
        'http://localhost:3333',
        'https://pax.discord.com',
        'null'
    ];
}
/**
 * The embedded application is running in an IFrame either within the main Discord client window or in a popout. The RPC server is always running in the main Discord client window. In either case, the referrer is the correct origin.
 */ function $c537748c1911e01f$var$getRPCServerSource() {
    var _a;
    return [
        (_a = window.parent.opener) !== null && _a !== void 0 ? _a : window.parent,
        !!document.referrer ? document.referrer : '*'
    ];
}
class $c537748c1911e01f$export$7cb9b6936cca2046 {
    getTransfer(payload) {
        var _a;
        switch(payload.cmd){
            case (0, $7563c491739c9977$export$ba30f7724cb0e54e).SUBSCRIBE:
            case (0, $7563c491739c9977$export$ba30f7724cb0e54e).UNSUBSCRIBE:
                return undefined;
            default:
                return (_a = payload.transfer) !== null && _a !== void 0 ? _a : undefined;
        }
    }
    constructor(clientId, configuration){
        this.sdkVersion = (0, $b9691ad61d5899a7$export$83d89fbfd8236492);
        this.mobileAppVersion = null;
        this.source = null;
        this.sourceOrigin = '';
        this.eventBus = new (0, $1cc29b2b9ac0411b$export$2e2bcd8739ae039)();
        this.pendingCommands = new Map();
        this.sendCommand = (payload)=>{
            var _a;
            if (this.source == null) throw new Error('Attempting to send message before initialization');
            const nonce = (0, $22629b62dd584f53$export$2e2bcd8739ae039)();
            (_a = this.source) === null || _a === void 0 || _a.postMessage([
                $c537748c1911e01f$export$6354ae5022ad3977.FRAME,
                Object.assign(Object.assign({}, payload), {
                    nonce: nonce
                })
            ], this.sourceOrigin, this.getTransfer(payload));
            const promise = new Promise((resolve, reject)=>{
                this.pendingCommands.set(nonce, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return promise;
        };
        this.commands = (0, $c2b2d40a6340332c$export$2e2bcd8739ae039)(this.sendCommand);
        /**
         * WARNING - All "console" logs are emitted as messages to the Discord client
         *  If you write "console.log" anywhere in handleMessage or subsequent message handling
         * there is a good chance you will cause an infinite loop where you receive a message
         * which causes "console.log" which sends a message, which causes the discord client to
         * send a reply which causes handleMessage to fire again, and again to inifinity
         *
         * If you need to log within handleMessage, consider setting
         * config.disableConsoleLogOverride to true when initializing the SDK
         */ this.handleMessage = (event)=>{
            if (!$c537748c1911e01f$var$ALLOWED_ORIGINS.has(event.origin)) return;
            const tuple = event.data;
            if (!Array.isArray(tuple)) return;
            const [opcode, data] = tuple;
            switch(opcode){
                case $c537748c1911e01f$export$6354ae5022ad3977.HELLO:
                    // backwards compat; the Discord client will still send HELLOs for old applications.
                    //
                    // TODO: figure out compatibility approach; it would be easier to maintain compatibility at the SDK level, not the underlying RPC protocol level...
                    return;
                case $c537748c1911e01f$export$6354ae5022ad3977.CLOSE:
                    return this.handleClose(data);
                case $c537748c1911e01f$export$6354ae5022ad3977.HANDSHAKE:
                    return this.handleHandshake();
                case $c537748c1911e01f$export$6354ae5022ad3977.FRAME:
                    return this.handleFrame(data);
                default:
                    throw new Error('Invalid message format');
            }
        };
        this.isReady = false;
        this.clientId = clientId;
        this.configuration = configuration !== null && configuration !== void 0 ? configuration : (0, $4ba1bc9ff3722d9c$export$2e2bcd8739ae039)();
        if (typeof window !== 'undefined') window.addEventListener('message', this.handleMessage);
        if (typeof window === 'undefined') {
            this.frameId = '';
            this.instanceId = '';
            this.customId = null;
            this.referrerId = null;
            this.platform = (0, $46a39478d4fb12cc$export$2dffd0b5373a4389).DESKTOP;
            this.guildId = null;
            this.channelId = null;
            this.locationId = null;
            return;
        }
        // START Capture URL Query Params
        const urlParams = new URLSearchParams(this._getSearch());
        const frameId = urlParams.get('frame_id');
        if (!frameId) throw new Error('frame_id query param is not defined');
        this.frameId = frameId;
        const instanceId = urlParams.get('instance_id');
        if (!instanceId) throw new Error('instance_id query param is not defined');
        this.instanceId = instanceId;
        const platform = urlParams.get('platform');
        if (!platform) throw new Error('platform query param is not defined');
        else if (platform !== (0, $46a39478d4fb12cc$export$2dffd0b5373a4389).DESKTOP && platform !== (0, $46a39478d4fb12cc$export$2dffd0b5373a4389).MOBILE) throw new Error(`Invalid query param "platform" of "${platform}". Valid values are "${(0, $46a39478d4fb12cc$export$2dffd0b5373a4389).DESKTOP}" or "${(0, $46a39478d4fb12cc$export$2dffd0b5373a4389).MOBILE}"`);
        this.platform = platform;
        this.customId = urlParams.get('custom_id');
        this.referrerId = urlParams.get('referrer_id');
        this.guildId = urlParams.get('guild_id');
        this.channelId = urlParams.get('channel_id');
        this.locationId = urlParams.get('location_id');
        this.mobileAppVersion = urlParams.get('mobile_app_version');
        // END Capture URL Query Params
        [this.source, this.sourceOrigin] = $c537748c1911e01f$var$getRPCServerSource();
        this.addOnReadyListener();
        this.handshake();
    }
    close(code, message) {
        var _a;
        window.removeEventListener('message', this.handleMessage);
        const nonce = (0, $22629b62dd584f53$export$2e2bcd8739ae039)();
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $c537748c1911e01f$export$6354ae5022ad3977.CLOSE,
            {
                code: code,
                message: message,
                nonce: nonce
            }
        ], this.sourceOrigin);
    }
    async subscribe(event, listener, ...rest) {
        const [subscribeArgs] = rest;
        const listenerCount = this.eventBus.listenerCount(event);
        const emitter = this.eventBus.on(event, listener);
        // If first subscription, subscribe via RPC
        if (Object.values((0, $4658010a245c8473$export$ada873a34909da65)).includes(event) && event !== (0, $4658010a245c8473$export$ada873a34909da65).READY && listenerCount === 0) await this.sendCommand({
            cmd: (0, $7563c491739c9977$export$ba30f7724cb0e54e).SUBSCRIBE,
            args: subscribeArgs,
            evt: event
        });
        return emitter;
    }
    async unsubscribe(event, listener, ...rest) {
        const [unsubscribeArgs] = rest;
        if (event !== (0, $4658010a245c8473$export$ada873a34909da65).READY && this.eventBus.listenerCount(event) === 1) await this.sendCommand({
            cmd: (0, $7563c491739c9977$export$ba30f7724cb0e54e).UNSUBSCRIBE,
            evt: event,
            args: unsubscribeArgs
        });
        return this.eventBus.off(event, listener);
    }
    async ready() {
        if (this.isReady) return;
        else await new Promise((resolve)=>{
            this.eventBus.once((0, $4658010a245c8473$export$ada873a34909da65).READY, resolve);
        });
    }
    parseMajorMobileVersion() {
        if (this.mobileAppVersion && this.mobileAppVersion.includes('.')) try {
            return parseInt(this.mobileAppVersion.split('.')[0]);
        } catch (_a) {
            return 0, $46a39478d4fb12cc$export$6d0e4238fc52b7e2;
        }
        return 0, $46a39478d4fb12cc$export$6d0e4238fc52b7e2;
    }
    handshake() {
        var _a;
        const handshakePayload = {
            v: 1,
            encoding: 'json',
            client_id: this.clientId,
            frame_id: this.frameId
        };
        const majorMobileVersion = this.parseMajorMobileVersion();
        if (this.platform === (0, $46a39478d4fb12cc$export$2dffd0b5373a4389).DESKTOP || majorMobileVersion >= (0, $46a39478d4fb12cc$export$e124ef0815aed2db)) handshakePayload['sdk_version'] = this.sdkVersion;
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $c537748c1911e01f$export$6354ae5022ad3977.HANDSHAKE,
            handshakePayload
        ], this.sourceOrigin);
    }
    addOnReadyListener() {
        this.eventBus.once((0, $4658010a245c8473$export$ada873a34909da65).READY, ()=>{
            this.overrideConsoleLogging();
            this.isReady = true;
        });
    }
    overrideConsoleLogging() {
        if (this.configuration.disableConsoleLogOverride) return;
        const sendCaptureLogCommand = (level, message)=>{
            this.commands.captureLog({
                level: level,
                message: message
            });
        };
        (0, $e355169fecea76da$export$a3647e951d1937a9).forEach((level)=>{
            (0, $e355169fecea76da$export$46a03bf5755ffc4c)(console, level, sendCaptureLogCommand);
        });
    }
    handleClose(data) {
        (0, $41dc29da86c0e5f0$export$46b1619f8b73becb).parse(data);
    }
    handleHandshake() {}
    handleFrame(payload) {
        var _a, _b;
        let parsed;
        try {
            parsed = (0, $41dc29da86c0e5f0$export$97b1c66ab98393bd)(payload);
        } catch (e) {
            console.error('Failed to parse', payload);
            console.error(e);
            return;
        }
        if (parsed.cmd === 'DISPATCH') this.eventBus.emit(parsed.evt, parsed.data);
        else {
            if (parsed.evt === (0, $4658010a245c8473$export$103bedf43ba882db)) {
                // In response to a command
                if (parsed.nonce != null) {
                    (_a = this.pendingCommands.get(parsed.nonce)) === null || _a === void 0 || _a.reject(parsed.data);
                    this.pendingCommands.delete(parsed.nonce);
                    return;
                }
                // General error
                this.eventBus.emit('error', new (0, $3ef1b11d536158b3$export$e1d52e4f0c7557a1)(parsed.data.code, parsed.data.message));
            }
            if (parsed.nonce == null) {
                console.error('Missing nonce', payload);
                return;
            }
            (_b = this.pendingCommands.get(parsed.nonce)) === null || _b === void 0 || _b.resolve(parsed);
            this.pendingCommands.delete(parsed.nonce);
        }
    }
    _getSearch() {
        return typeof window === 'undefined' ? '' : window.location.search;
    }
}







function $adb7c9919bf9feeb$var$can(permission, permissions) {
    return (0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).has((0, $a462ad6d1a4d2753$export$2e2bcd8739ae039).deserialize(permissions), permission);
}
var $adb7c9919bf9feeb$export$2e2bcd8739ae039 = {
    can: $adb7c9919bf9feeb$var$can
};


/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */ // ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //
// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var $9a79e0cc470306c5$var$MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
$9a79e0cc470306c5$var$defaults = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // The natural logarithm of 10.
    // 115 digits
    LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
}, // ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //
$9a79e0cc470306c5$export$95c991896bef8714, $9a79e0cc470306c5$var$external = true, $9a79e0cc470306c5$var$decimalError = '[DecimalError] ', $9a79e0cc470306c5$var$invalidArgument = $9a79e0cc470306c5$var$decimalError + 'Invalid argument: ', $9a79e0cc470306c5$var$exponentOutOfRange = $9a79e0cc470306c5$var$decimalError + 'Exponent out of range: ', $9a79e0cc470306c5$var$mathfloor = Math.floor, $9a79e0cc470306c5$var$mathpow = Math.pow, $9a79e0cc470306c5$var$isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $9a79e0cc470306c5$var$ONE, $9a79e0cc470306c5$var$BASE = 1e7, $9a79e0cc470306c5$var$LOG_BASE = 7, $9a79e0cc470306c5$var$MAX_SAFE_INTEGER = 9007199254740991, $9a79e0cc470306c5$var$MAX_E = $9a79e0cc470306c5$var$mathfloor($9a79e0cc470306c5$var$MAX_SAFE_INTEGER / $9a79e0cc470306c5$var$LOG_BASE), // Decimal.prototype object
$9a79e0cc470306c5$var$P = {};
// Decimal prototype methods
/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */ /*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */ $9a79e0cc470306c5$var$P.absoluteValue = $9a79e0cc470306c5$var$P.abs = function() {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
};
/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */ $9a79e0cc470306c5$var$P.comparedTo = $9a79e0cc470306c5$var$P.cmp = function(y) {
    var i, j, xdL, ydL, x = this;
    y = new x.constructor(y);
    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;
    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
    xdL = x.d.length;
    ydL = y.d.length;
    // Compare digit by digit.
    for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
        if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }
    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
};
/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */ $9a79e0cc470306c5$var$P.decimalPlaces = $9a79e0cc470306c5$var$P.dp = function() {
    var x = this, w = x.d.length - 1, dp = (w - x.e) * $9a79e0cc470306c5$var$LOG_BASE;
    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for(; w % 10 == 0; w /= 10)dp--;
    return dp < 0 ? 0 : dp;
};
/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.dividedBy = $9a79e0cc470306c5$var$P.div = function(y) {
    return $9a79e0cc470306c5$var$divide(this, new this.constructor(y));
};
/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.dividedToIntegerBy = $9a79e0cc470306c5$var$P.idiv = function(y) {
    var x = this, Ctor = x.constructor;
    return $9a79e0cc470306c5$var$round($9a79e0cc470306c5$var$divide(x, new Ctor(y), 0, 1), Ctor.precision);
};
/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.equals = $9a79e0cc470306c5$var$P.eq = function(y) {
    return !this.cmp(y);
};
/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */ $9a79e0cc470306c5$var$P.exponent = function() {
    return $9a79e0cc470306c5$var$getBase10Exponent(this);
};
/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */ $9a79e0cc470306c5$var$P.greaterThan = $9a79e0cc470306c5$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.greaterThanOrEqualTo = $9a79e0cc470306c5$var$P.gte = function(y) {
    return this.cmp(y) >= 0;
};
/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.isInteger = $9a79e0cc470306c5$var$P.isint = function() {
    return this.e > this.d.length - 2;
};
/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.isNegative = $9a79e0cc470306c5$var$P.isneg = function() {
    return this.s < 0;
};
/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.isPositive = $9a79e0cc470306c5$var$P.ispos = function() {
    return this.s > 0;
};
/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.isZero = function() {
    return this.s === 0;
};
/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.lessThan = $9a79e0cc470306c5$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */ $9a79e0cc470306c5$var$P.lessThanOrEqualTo = $9a79e0cc470306c5$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */ $9a79e0cc470306c5$var$P.logarithm = $9a79e0cc470306c5$var$P.log = function(base) {
    var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
    // Default base is 10.
    if (base === void 0) base = new Ctor(10);
    else {
        base = new Ctor(base);
        // log[-b](x) = NaN
        // log[0](x)  = NaN
        // log[1](x)  = NaN
        if (base.s < 1 || base.eq($9a79e0cc470306c5$var$ONE)) throw Error($9a79e0cc470306c5$var$decimalError + 'NaN');
    }
    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error($9a79e0cc470306c5$var$decimalError + (x.s ? 'NaN' : '-Infinity'));
    // log[b](1) = 0
    if (x.eq($9a79e0cc470306c5$var$ONE)) return new Ctor(0);
    $9a79e0cc470306c5$var$external = false;
    r = $9a79e0cc470306c5$var$divide($9a79e0cc470306c5$var$ln(x, wpr), $9a79e0cc470306c5$var$ln(base, wpr), wpr);
    $9a79e0cc470306c5$var$external = true;
    return $9a79e0cc470306c5$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.minus = $9a79e0cc470306c5$var$P.sub = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $9a79e0cc470306c5$var$subtract(x, y) : $9a79e0cc470306c5$var$add(x, (y.s = -y.s, y));
};
/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.modulo = $9a79e0cc470306c5$var$P.mod = function(y) {
    var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
    y = new Ctor(y);
    // x % 0 = NaN
    if (!y.s) throw Error($9a79e0cc470306c5$var$decimalError + 'NaN');
    // Return x if x is 0.
    if (!x.s) return $9a79e0cc470306c5$var$round(new Ctor(x), pr);
    // Prevent rounding of intermediate calculations.
    $9a79e0cc470306c5$var$external = false;
    q = $9a79e0cc470306c5$var$divide(x, y, 0, 1).times(y);
    $9a79e0cc470306c5$var$external = true;
    return x.minus(q);
};
/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $9a79e0cc470306c5$var$P.naturalExponential = $9a79e0cc470306c5$var$P.exp = function() {
    return $9a79e0cc470306c5$var$exp(this);
};
/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.naturalLogarithm = $9a79e0cc470306c5$var$P.ln = function() {
    return $9a79e0cc470306c5$var$ln(this);
};
/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */ $9a79e0cc470306c5$var$P.negated = $9a79e0cc470306c5$var$P.neg = function() {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
};
/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.plus = $9a79e0cc470306c5$var$P.add = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $9a79e0cc470306c5$var$add(x, y) : $9a79e0cc470306c5$var$subtract(x, (y.s = -y.s, y));
};
/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */ $9a79e0cc470306c5$var$P.precision = $9a79e0cc470306c5$var$P.sd = function(z) {
    var e, sd, w, x = this;
    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error($9a79e0cc470306c5$var$invalidArgument + z);
    e = $9a79e0cc470306c5$var$getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * $9a79e0cc470306c5$var$LOG_BASE + 1;
    w = x.d[w];
    // If non-zero...
    if (w) {
        // Subtract the number of trailing zeros of the last word.
        for(; w % 10 == 0; w /= 10)sd--;
        // Add the number of digits of the first word.
        for(w = x.d[0]; w >= 10; w /= 10)sd++;
    }
    return z && e > sd ? e : sd;
};
/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $9a79e0cc470306c5$var$P.squareRoot = $9a79e0cc470306c5$var$P.sqrt = function() {
    var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
    // Negative or zero?
    if (x.s < 1) {
        if (!x.s) return new Ctor(0);
        // sqrt(-x) = NaN
        throw Error($9a79e0cc470306c5$var$decimalError + 'NaN');
    }
    e = $9a79e0cc470306c5$var$getBase10Exponent(x);
    $9a79e0cc470306c5$var$external = false;
    // Initial estimate.
    s = Math.sqrt(+x);
    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
        n = $9a79e0cc470306c5$var$digitsToString(x.d);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(n);
        e = $9a79e0cc470306c5$var$mathfloor((e + 1) / 2) - (e < 0 || e % 2);
        if (s == 1 / 0) n = '5e' + e;
        else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf('e') + 1) + e;
        }
        r = new Ctor(n);
    } else r = new Ctor(s.toString());
    pr = Ctor.precision;
    s = wpr = pr + 3;
    // Newton-Raphson iteration.
    for(;;){
        t = r;
        r = t.plus($9a79e0cc470306c5$var$divide(x, t, wpr + 2)).times(0.5);
        if ($9a79e0cc470306c5$var$digitsToString(t.d).slice(0, wpr) === (n = $9a79e0cc470306c5$var$digitsToString(r.d)).slice(0, wpr)) {
            n = n.slice(wpr - 3, wpr + 1);
            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
            // 4999, i.e. approaching a rounding boundary, continue the iteration.
            if (s == wpr && n == '4999') {
                // On the first iteration only, check to see if rounding up gives the exact result as the
                // nines may infinitely repeat.
                $9a79e0cc470306c5$var$round(t, pr + 1, 0);
                if (t.times(t).eq(x)) {
                    r = t;
                    break;
                }
            } else if (n != '9999') break;
            wpr += 4;
        }
    }
    $9a79e0cc470306c5$var$external = true;
    return $9a79e0cc470306c5$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */ $9a79e0cc470306c5$var$P.times = $9a79e0cc470306c5$var$P.mul = function(y) {
    var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);
    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;
    // Ensure xd points to the longer array.
    if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
    }
    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for(i = rL; i--;)r.push(0);
    // Multiply!
    for(i = ydL; --i >= 0;){
        carry = 0;
        for(k = xdL + i; k > i;){
            t = r[k] + yd[i] * xd[k - i - 1] + carry;
            r[k--] = t % $9a79e0cc470306c5$var$BASE | 0;
            carry = t / $9a79e0cc470306c5$var$BASE | 0;
        }
        r[k] = (r[k] + carry) % $9a79e0cc470306c5$var$BASE | 0;
    }
    // Remove trailing zeros.
    for(; !r[--rL];)r.pop();
    if (carry) ++e;
    else r.shift();
    y.d = r;
    y.e = e;
    return $9a79e0cc470306c5$var$external ? $9a79e0cc470306c5$var$round(y, Ctor.precision) : y;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $9a79e0cc470306c5$var$P.toDecimalPlaces = $9a79e0cc470306c5$var$P.todp = function(dp, rm) {
    var x = this, Ctor = x.constructor;
    x = new Ctor(x);
    if (dp === void 0) return x;
    $9a79e0cc470306c5$var$checkInt32(dp, 0, $9a79e0cc470306c5$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $9a79e0cc470306c5$var$checkInt32(rm, 0, 8);
    return $9a79e0cc470306c5$var$round(x, dp + $9a79e0cc470306c5$var$getBase10Exponent(x) + 1, rm);
};
/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $9a79e0cc470306c5$var$P.toExponential = function(dp, rm) {
    var str, x = this, Ctor = x.constructor;
    if (dp === void 0) str = $9a79e0cc470306c5$var$toString(x, true);
    else {
        $9a79e0cc470306c5$var$checkInt32(dp, 0, $9a79e0cc470306c5$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $9a79e0cc470306c5$var$checkInt32(rm, 0, 8);
        x = $9a79e0cc470306c5$var$round(new Ctor(x), dp + 1, rm);
        str = $9a79e0cc470306c5$var$toString(x, true, dp + 1);
    }
    return str;
};
/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */ $9a79e0cc470306c5$var$P.toFixed = function(dp, rm) {
    var str, y, x = this, Ctor = x.constructor;
    if (dp === void 0) return $9a79e0cc470306c5$var$toString(x);
    $9a79e0cc470306c5$var$checkInt32(dp, 0, $9a79e0cc470306c5$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $9a79e0cc470306c5$var$checkInt32(rm, 0, 8);
    y = $9a79e0cc470306c5$var$round(new Ctor(x), dp + $9a79e0cc470306c5$var$getBase10Exponent(x) + 1, rm);
    str = $9a79e0cc470306c5$var$toString(y.abs(), false, dp + $9a79e0cc470306c5$var$getBase10Exponent(y) + 1);
    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */ $9a79e0cc470306c5$var$P.toInteger = $9a79e0cc470306c5$var$P.toint = function() {
    var x = this, Ctor = x.constructor;
    return $9a79e0cc470306c5$var$round(new Ctor(x), $9a79e0cc470306c5$var$getBase10Exponent(x) + 1, Ctor.rounding);
};
/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */ $9a79e0cc470306c5$var$P.toNumber = function() {
    return +this;
};
/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */ $9a79e0cc470306c5$var$P.toPower = $9a79e0cc470306c5$var$P.pow = function(y) {
    var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
    // pow(x, 0) = 1
    if (!y.s) return new Ctor($9a79e0cc470306c5$var$ONE);
    x = new Ctor(x);
    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
        if (y.s < 1) throw Error($9a79e0cc470306c5$var$decimalError + 'Infinity');
        return x;
    }
    // pow(1, y) = 1
    if (x.eq($9a79e0cc470306c5$var$ONE)) return x;
    pr = Ctor.precision;
    // pow(x, 1) = x
    if (y.eq($9a79e0cc470306c5$var$ONE)) return $9a79e0cc470306c5$var$round(x, pr);
    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;
    if (!yIsInt) {
        // pow(x < 0, y non-integer) = NaN
        if (sign < 0) throw Error($9a79e0cc470306c5$var$decimalError + 'NaN');
    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= $9a79e0cc470306c5$var$MAX_SAFE_INTEGER) {
        r = new Ctor($9a79e0cc470306c5$var$ONE);
        // Max k of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        e = Math.ceil(pr / $9a79e0cc470306c5$var$LOG_BASE + 4);
        $9a79e0cc470306c5$var$external = false;
        for(;;){
            if (k % 2) {
                r = r.times(x);
                $9a79e0cc470306c5$var$truncate(r.d, e);
            }
            k = $9a79e0cc470306c5$var$mathfloor(k / 2);
            if (k === 0) break;
            x = x.times(x);
            $9a79e0cc470306c5$var$truncate(x.d, e);
        }
        $9a79e0cc470306c5$var$external = true;
        return y.s < 0 ? new Ctor($9a79e0cc470306c5$var$ONE).div(r) : $9a79e0cc470306c5$var$round(r, pr);
    }
    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
    x.s = 1;
    $9a79e0cc470306c5$var$external = false;
    r = y.times($9a79e0cc470306c5$var$ln(x, pr + guard));
    $9a79e0cc470306c5$var$external = true;
    r = $9a79e0cc470306c5$var$exp(r);
    r.s = sign;
    return r;
};
/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $9a79e0cc470306c5$var$P.toPrecision = function(sd, rm) {
    var e, str, x = this, Ctor = x.constructor;
    if (sd === void 0) {
        e = $9a79e0cc470306c5$var$getBase10Exponent(x);
        str = $9a79e0cc470306c5$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
        $9a79e0cc470306c5$var$checkInt32(sd, 1, $9a79e0cc470306c5$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $9a79e0cc470306c5$var$checkInt32(rm, 0, 8);
        x = $9a79e0cc470306c5$var$round(new Ctor(x), sd, rm);
        e = $9a79e0cc470306c5$var$getBase10Exponent(x);
        str = $9a79e0cc470306c5$var$toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }
    return str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $9a79e0cc470306c5$var$P.toSignificantDigits = $9a79e0cc470306c5$var$P.tosd = function(sd, rm) {
    var x = this, Ctor = x.constructor;
    if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
    } else {
        $9a79e0cc470306c5$var$checkInt32(sd, 1, $9a79e0cc470306c5$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $9a79e0cc470306c5$var$checkInt32(rm, 0, 8);
    }
    return $9a79e0cc470306c5$var$round(new Ctor(x), sd, rm);
};
/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */ $9a79e0cc470306c5$var$P.toString = $9a79e0cc470306c5$var$P.valueOf = $9a79e0cc470306c5$var$P.val = $9a79e0cc470306c5$var$P.toJSON = $9a79e0cc470306c5$var$P[Symbol.for('nodejs.util.inspect.custom')] = function() {
    var x = this, e = $9a79e0cc470306c5$var$getBase10Exponent(x), Ctor = x.constructor;
    return $9a79e0cc470306c5$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};
// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */ function $9a79e0cc470306c5$var$add(x, y) {
    var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
    // If either is zero...
    if (!x.s || !y.s) {
        // Return x if y is zero.
        // Return y if y is non-zero.
        if (!y.s) y = new Ctor(x);
        return $9a79e0cc470306c5$var$external ? $9a79e0cc470306c5$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are finite, non-zero numbers with the same sign.
    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;
    // If base 1e7 exponents differ...
    if (i) {
        if (i < 0) {
            d = xd;
            i = -i;
            len = yd.length;
        } else {
            d = yd;
            e = k;
            len = xd.length;
        }
        // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
        k = Math.ceil(pr / $9a79e0cc470306c5$var$LOG_BASE);
        len = k > len ? k + 1 : len + 1;
        if (i > len) {
            i = len;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
        d.reverse();
        for(; i--;)d.push(0);
        d.reverse();
    }
    len = xd.length;
    i = yd.length;
    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
        i = len;
        d = yd;
        yd = xd;
        xd = d;
    }
    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for(carry = 0; i;){
        carry = (xd[--i] = xd[i] + yd[i] + carry) / $9a79e0cc470306c5$var$BASE | 0;
        xd[i] %= $9a79e0cc470306c5$var$BASE;
    }
    if (carry) {
        xd.unshift(carry);
        ++e;
    }
    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for(len = xd.length; xd[--len] == 0;)xd.pop();
    y.d = xd;
    y.e = e;
    return $9a79e0cc470306c5$var$external ? $9a79e0cc470306c5$var$round(y, pr) : y;
}
function $9a79e0cc470306c5$var$checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) throw Error($9a79e0cc470306c5$var$invalidArgument + i);
}
function $9a79e0cc470306c5$var$digitsToString(d) {
    var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
    if (indexOfLastWord > 0) {
        str += w;
        for(i = 1; i < indexOfLastWord; i++){
            ws = d[i] + '';
            k = $9a79e0cc470306c5$var$LOG_BASE - ws.length;
            if (k) str += $9a79e0cc470306c5$var$getZeroString(k);
            str += ws;
        }
        w = d[i];
        ws = w + '';
        k = $9a79e0cc470306c5$var$LOG_BASE - ws.length;
        if (k) str += $9a79e0cc470306c5$var$getZeroString(k);
    } else if (w === 0) return '0';
    // Remove trailing zeros of last w.
    for(; w % 10 === 0;)w /= 10;
    return str + w;
}
var $9a79e0cc470306c5$var$divide = function() {
    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
        var temp, carry = 0, i = x.length;
        for(x = x.slice(); i--;){
            temp = x[i] * k + carry;
            x[i] = temp % $9a79e0cc470306c5$var$BASE | 0;
            carry = temp / $9a79e0cc470306c5$var$BASE | 0;
        }
        if (carry) x.unshift(carry);
        return x;
    }
    function compare(a, b, aL, bL) {
        var i, r;
        if (aL != bL) r = aL > bL ? 1 : -1;
        else {
            for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                r = a[i] > b[i] ? 1 : -1;
                break;
            }
        }
        return r;
    }
    function subtract(a, b, aL) {
        var i = 0;
        // Subtract b from a.
        for(; aL--;){
            a[aL] -= i;
            i = a[aL] < b[aL] ? 1 : 0;
            a[aL] = i * $9a79e0cc470306c5$var$BASE + a[aL] - b[aL];
        }
        // Remove leading zeros.
        for(; !a[0] && a.length > 1;)a.shift();
    }
    return function(x, y, pr, dp) {
        var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
        // Either 0?
        if (!x.s) return new Ctor(x);
        if (!y.s) throw Error($9a79e0cc470306c5$var$decimalError + 'Division by zero');
        e = x.e - y.e;
        yL = yd.length;
        xL = xd.length;
        q = new Ctor(sign);
        qd = q.d = [];
        // Result exponent may be one less than e.
        for(i = 0; yd[i] == (xd[i] || 0);)++i;
        if (yd[i] > (xd[i] || 0)) --e;
        if (pr == null) sd = pr = Ctor.precision;
        else if (dp) sd = pr + ($9a79e0cc470306c5$var$getBase10Exponent(x) - $9a79e0cc470306c5$var$getBase10Exponent(y)) + 1;
        else sd = pr;
        if (sd < 0) return new Ctor(0);
        // Convert precision in number of base 10 digits to base 1e7 digits.
        sd = sd / $9a79e0cc470306c5$var$LOG_BASE + 2 | 0;
        i = 0;
        // divisor < 1e7
        if (yL == 1) {
            k = 0;
            yd = yd[0];
            sd++;
            // k is the carry.
            for(; (i < xL || k) && sd--; i++){
                t = k * $9a79e0cc470306c5$var$BASE + (xd[i] || 0);
                qd[i] = t / yd | 0;
                k = t % yd | 0;
            }
        // divisor >= 1e7
        } else {
            // Normalise xd and yd so highest order digit of yd is >= BASE/2
            k = $9a79e0cc470306c5$var$BASE / (yd[0] + 1) | 0;
            if (k > 1) {
                yd = multiplyInteger(yd, k);
                xd = multiplyInteger(xd, k);
                yL = yd.length;
                xL = xd.length;
            }
            xi = yL;
            rem = xd.slice(0, yL);
            remL = rem.length;
            // Add zeros to make remainder as long as divisor.
            for(; remL < yL;)rem[remL++] = 0;
            yz = yd.slice();
            yz.unshift(0);
            yd0 = yd[0];
            if (yd[1] >= $9a79e0cc470306c5$var$BASE / 2) ++yd0;
            do {
                k = 0;
                // Compare divisor and remainder.
                cmp = compare(yd, rem, yL, remL);
                // If divisor < remainder.
                if (cmp < 0) {
                    // Calculate trial digit, k.
                    rem0 = rem[0];
                    if (yL != remL) rem0 = rem0 * $9a79e0cc470306c5$var$BASE + (rem[1] || 0);
                    // k will be how many times the divisor goes into the current remainder.
                    k = rem0 / yd0 | 0;
                    //  Algorithm:
                    //  1. product = divisor * trial digit (k)
                    //  2. if product > remainder: product -= divisor, k--
                    //  3. remainder -= product
                    //  4. if product was < remainder at 2:
                    //    5. compare new remainder and divisor
                    //    6. If remainder > divisor: remainder -= divisor, k++
                    if (k > 1) {
                        if (k >= $9a79e0cc470306c5$var$BASE) k = $9a79e0cc470306c5$var$BASE - 1;
                        // product = divisor * trial digit.
                        prod = multiplyInteger(yd, k);
                        prodL = prod.length;
                        remL = rem.length;
                        // Compare product and remainder.
                        cmp = compare(prod, rem, prodL, remL);
                        // product > remainder.
                        if (cmp == 1) {
                            k--;
                            // Subtract divisor from product.
                            subtract(prod, yL < prodL ? yz : yd, prodL);
                        }
                    } else {
                        // cmp is -1.
                        // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                        // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                        if (k == 0) cmp = k = 1;
                        prod = yd.slice();
                    }
                    prodL = prod.length;
                    if (prodL < remL) prod.unshift(0);
                    // Subtract product from remainder.
                    subtract(rem, prod, remL);
                    // If product was < previous remainder.
                    if (cmp == -1) {
                        remL = rem.length;
                        // Compare divisor and new remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < new remainder, subtract divisor from remainder.
                        if (cmp < 1) {
                            k++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yd, remL);
                        }
                    }
                    remL = rem.length;
                } else if (cmp === 0) {
                    k++;
                    rem = [
                        0
                    ];
                } // if cmp === 1, k will be 0
                // Add the next digit, k, to the result array.
                qd[i++] = k;
                // Update the remainder.
                if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                else {
                    rem = [
                        xd[xi]
                    ];
                    remL = 1;
                }
            }while ((xi++ < xL || rem[0] !== void 0) && sd--);
        }
        // Leading zero?
        if (!qd[0]) qd.shift();
        q.e = e;
        return $9a79e0cc470306c5$var$round(q, dp ? pr + $9a79e0cc470306c5$var$getBase10Exponent(q) + 1 : pr);
    };
}();
/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */ function $9a79e0cc470306c5$var$exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
    if ($9a79e0cc470306c5$var$getBase10Exponent(x) > 16) throw Error($9a79e0cc470306c5$var$exponentOutOfRange + $9a79e0cc470306c5$var$getBase10Exponent(x));
    // exp(0) = 1
    if (!x.s) return new Ctor($9a79e0cc470306c5$var$ONE);
    if (sd == null) {
        $9a79e0cc470306c5$var$external = false;
        wpr = pr;
    } else wpr = sd;
    t = new Ctor(0.03125);
    while(x.abs().gte(0.1)){
        x = x.times(t); // x = x / 2^5
        k += 5;
    }
    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log($9a79e0cc470306c5$var$mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor($9a79e0cc470306c5$var$ONE);
    Ctor.precision = wpr;
    for(;;){
        pow = $9a79e0cc470306c5$var$round(pow.times(x), wpr);
        denominator = denominator.times(++i);
        t = sum.plus($9a79e0cc470306c5$var$divide(pow, denominator, wpr));
        if ($9a79e0cc470306c5$var$digitsToString(t.d).slice(0, wpr) === $9a79e0cc470306c5$var$digitsToString(sum.d).slice(0, wpr)) {
            while(k--)sum = $9a79e0cc470306c5$var$round(sum.times(sum), wpr);
            Ctor.precision = pr;
            return sd == null ? ($9a79e0cc470306c5$var$external = true, $9a79e0cc470306c5$var$round(sum, pr)) : sum;
        }
        sum = t;
    }
}
// Calculate the base 10 exponent from the base 1e7 exponent.
function $9a79e0cc470306c5$var$getBase10Exponent(x) {
    var e = x.e * $9a79e0cc470306c5$var$LOG_BASE, w = x.d[0];
    // Add the number of digits of the first word of the digits array.
    for(; w >= 10; w /= 10)e++;
    return e;
}
function $9a79e0cc470306c5$var$getLn10(Ctor, sd, pr) {
    if (sd > Ctor.LN10.sd()) {
        // Reset global state in case the exception is caught.
        $9a79e0cc470306c5$var$external = true;
        if (pr) Ctor.precision = pr;
        throw Error($9a79e0cc470306c5$var$decimalError + 'LN10 precision limit exceeded');
    }
    return $9a79e0cc470306c5$var$round(new Ctor(Ctor.LN10), sd);
}
function $9a79e0cc470306c5$var$getZeroString(k) {
    var zs = '';
    for(; k--;)zs += '0';
    return zs;
}
/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */ function $9a79e0cc470306c5$var$ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error($9a79e0cc470306c5$var$decimalError + (x.s ? 'NaN' : '-Infinity'));
    // ln(1) = 0
    if (x.eq($9a79e0cc470306c5$var$ONE)) return new Ctor(0);
    if (sd == null) {
        $9a79e0cc470306c5$var$external = false;
        wpr = pr;
    } else wpr = sd;
    if (x.eq(10)) {
        if (sd == null) $9a79e0cc470306c5$var$external = true;
        return $9a79e0cc470306c5$var$getLn10(Ctor, wpr);
    }
    wpr += guard;
    Ctor.precision = wpr;
    c = $9a79e0cc470306c5$var$digitsToString(xd);
    c0 = c.charAt(0);
    e = $9a79e0cc470306c5$var$getBase10Exponent(x);
    if (Math.abs(e) < 1.5e15) {
        // Argument reduction.
        // The series converges faster the closer the argument is to 1, so using
        // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
        // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
        // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
        // later be divided by this number, then separate out the power of 10 using
        // ln(a*10^b) = ln(a) + b*ln(10).
        // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
        //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
        // max n is 6 (gives 0.7 - 1.3)
        while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
            x = x.times(y);
            c = $9a79e0cc470306c5$var$digitsToString(x.d);
            c0 = c.charAt(0);
            n++;
        }
        e = $9a79e0cc470306c5$var$getBase10Exponent(x);
        if (c0 > 1) {
            x = new Ctor('0.' + c);
            e++;
        } else x = new Ctor(c0 + '.' + c.slice(1));
    } else {
        // The argument reduction method above may result in overflow if the argument y is a massive
        // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
        // function using ln(x*10^e) = ln(x) + e*ln(10).
        t = $9a79e0cc470306c5$var$getLn10(Ctor, wpr + 2, pr).times(e + '');
        x = $9a79e0cc470306c5$var$ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
        Ctor.precision = pr;
        return sd == null ? ($9a79e0cc470306c5$var$external = true, $9a79e0cc470306c5$var$round(x, pr)) : x;
    }
    // x is reduced to a value near 1.
    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = $9a79e0cc470306c5$var$divide(x.minus($9a79e0cc470306c5$var$ONE), x.plus($9a79e0cc470306c5$var$ONE), wpr);
    x2 = $9a79e0cc470306c5$var$round(x.times(x), wpr);
    denominator = 3;
    for(;;){
        numerator = $9a79e0cc470306c5$var$round(numerator.times(x2), wpr);
        t = sum.plus($9a79e0cc470306c5$var$divide(numerator, new Ctor(denominator), wpr));
        if ($9a79e0cc470306c5$var$digitsToString(t.d).slice(0, wpr) === $9a79e0cc470306c5$var$digitsToString(sum.d).slice(0, wpr)) {
            sum = sum.times(2);
            // Reverse the argument reduction.
            if (e !== 0) sum = sum.plus($9a79e0cc470306c5$var$getLn10(Ctor, wpr + 2, pr).times(e + ''));
            sum = $9a79e0cc470306c5$var$divide(sum, new Ctor(n), wpr);
            Ctor.precision = pr;
            return sd == null ? ($9a79e0cc470306c5$var$external = true, $9a79e0cc470306c5$var$round(sum, pr)) : sum;
        }
        sum = t;
        denominator += 2;
    }
}
/*
 * Parse the value of a new Decimal `x` from string `str`.
 */ function $9a79e0cc470306c5$var$parseDecimal(x, str) {
    var e, i, len;
    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
    } else if (e < 0) // Integer.
    e = str.length;
    // Determine leading zeros.
    for(i = 0; str.charCodeAt(i) === 48;)++i;
    // Determine trailing zeros.
    for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
    str = str.slice(i, len);
    if (str) {
        len -= i;
        e = e - i - 1;
        x.e = $9a79e0cc470306c5$var$mathfloor(e / $9a79e0cc470306c5$var$LOG_BASE);
        x.d = [];
        // Transform base
        // e is the base 10 exponent.
        // i is where to slice str to get the first word of the digits array.
        i = (e + 1) % $9a79e0cc470306c5$var$LOG_BASE;
        if (e < 0) i += $9a79e0cc470306c5$var$LOG_BASE;
        if (i < len) {
            if (i) x.d.push(+str.slice(0, i));
            for(len -= $9a79e0cc470306c5$var$LOG_BASE; i < len;)x.d.push(+str.slice(i, i += $9a79e0cc470306c5$var$LOG_BASE));
            str = str.slice(i);
            i = $9a79e0cc470306c5$var$LOG_BASE - str.length;
        } else i -= len;
        for(; i--;)str += '0';
        x.d.push(+str);
        if ($9a79e0cc470306c5$var$external && (x.e > $9a79e0cc470306c5$var$MAX_E || x.e < -$9a79e0cc470306c5$var$MAX_E)) throw Error($9a79e0cc470306c5$var$exponentOutOfRange + e);
    } else {
        // Zero.
        x.s = 0;
        x.e = 0;
        x.d = [
            0
        ];
    }
    return x;
}
/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */ function $9a79e0cc470306c5$var$round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
    // Get the length of the first word of the digits array xd.
    for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
    i = sd - n;
    // Is the rounding digit in the first word of xd?
    if (i < 0) {
        i += $9a79e0cc470306c5$var$LOG_BASE;
        j = sd;
        w = xd[xdi = 0];
    } else {
        xdi = Math.ceil((i + 1) / $9a79e0cc470306c5$var$LOG_BASE);
        k = xd.length;
        if (xdi >= k) return x;
        w = k = xd[xdi];
        // Get the number of digits of w.
        for(n = 1; k >= 10; k /= 10)n++;
        // Get the index of rd within w.
        i %= $9a79e0cc470306c5$var$LOG_BASE;
        // Get the index of rd within w, adjusted for leading zeros.
        // The number of leading zeros of w is given by LOG_BASE - n.
        j = i - $9a79e0cc470306c5$var$LOG_BASE + n;
    }
    if (rm !== void 0) {
        k = $9a79e0cc470306c5$var$mathpow(10, n - j - 1);
        // Get the rounding digit at index j of w.
        rd = w / k % 10 | 0;
        // Are there any non-zero digits after the rounding digit?
        doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
        // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
        // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
        // 714.
        doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / $9a79e0cc470306c5$var$mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
    }
    if (sd < 1 || !xd[0]) {
        if (doRound) {
            k = $9a79e0cc470306c5$var$getBase10Exponent(x);
            xd.length = 1;
            // Convert sd to decimal places.
            sd = sd - k - 1;
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xd[0] = $9a79e0cc470306c5$var$mathpow(10, ($9a79e0cc470306c5$var$LOG_BASE - sd % $9a79e0cc470306c5$var$LOG_BASE) % $9a79e0cc470306c5$var$LOG_BASE);
            x.e = $9a79e0cc470306c5$var$mathfloor(-sd / $9a79e0cc470306c5$var$LOG_BASE) || 0;
        } else {
            xd.length = 1;
            // Zero.
            xd[0] = x.e = x.s = 0;
        }
        return x;
    }
    // Remove excess digits.
    if (i == 0) {
        xd.length = xdi;
        k = 1;
        xdi--;
    } else {
        xd.length = xdi + 1;
        k = $9a79e0cc470306c5$var$mathpow(10, $9a79e0cc470306c5$var$LOG_BASE - i);
        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
        // j > 0 means i > number of leading zeros of w.
        xd[xdi] = j > 0 ? (w / $9a79e0cc470306c5$var$mathpow(10, n - j) % $9a79e0cc470306c5$var$mathpow(10, j) | 0) * k : 0;
    }
    if (doRound) {
        for(;;)// Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
            if ((xd[0] += k) == $9a79e0cc470306c5$var$BASE) {
                xd[0] = 1;
                ++x.e;
            }
            break;
        } else {
            xd[xdi] += k;
            if (xd[xdi] != $9a79e0cc470306c5$var$BASE) break;
            xd[xdi--] = 0;
            k = 1;
        }
    }
    // Remove trailing zeros.
    for(i = xd.length; xd[--i] === 0;)xd.pop();
    if ($9a79e0cc470306c5$var$external && (x.e > $9a79e0cc470306c5$var$MAX_E || x.e < -$9a79e0cc470306c5$var$MAX_E)) throw Error($9a79e0cc470306c5$var$exponentOutOfRange + $9a79e0cc470306c5$var$getBase10Exponent(x));
    return x;
}
function $9a79e0cc470306c5$var$subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
        if (y.s) y.s = -y.s;
        else y = new Ctor(x);
        return $9a79e0cc470306c5$var$external ? $9a79e0cc470306c5$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are non-zero numbers with the same sign.
    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;
    // If exponents differ...
    if (k) {
        xLTy = k < 0;
        if (xLTy) {
            d = xd;
            k = -k;
            len = yd.length;
        } else {
            d = yd;
            e = xe;
            len = xd.length;
        }
        // Numbers with massively different exponents would result in a very high number of zeros
        // needing to be prepended, but this can be avoided while still ensuring correct rounding by
        // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
        i = Math.max(Math.ceil(pr / $9a79e0cc470306c5$var$LOG_BASE), len) + 2;
        if (k > i) {
            k = i;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents.
        d.reverse();
        for(i = k; i--;)d.push(0);
        d.reverse();
    // Base 1e7 exponents equal.
    } else {
        // Check digits to determine which is the bigger number.
        i = xd.length;
        len = yd.length;
        xLTy = i < len;
        if (xLTy) len = i;
        for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
            xLTy = xd[i] < yd[i];
            break;
        }
        k = 0;
    }
    if (xLTy) {
        d = xd;
        xd = yd;
        yd = d;
        y.s = -y.s;
    }
    len = xd.length;
    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
    // Subtract yd from xd.
    for(i = yd.length; i > k;){
        if (xd[--i] < yd[i]) {
            for(j = i; j && xd[--j] === 0;)xd[j] = $9a79e0cc470306c5$var$BASE - 1;
            --xd[j];
            xd[i] += $9a79e0cc470306c5$var$BASE;
        }
        xd[i] -= yd[i];
    }
    // Remove trailing zeros.
    for(; xd[--len] === 0;)xd.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xd[0] === 0; xd.shift())--e;
    // Zero?
    if (!xd[0]) return new Ctor(0);
    y.d = xd;
    y.e = e;
    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return $9a79e0cc470306c5$var$external ? $9a79e0cc470306c5$var$round(y, pr) : y;
}
function $9a79e0cc470306c5$var$toString(x, isExp, sd) {
    var k, e = $9a79e0cc470306c5$var$getBase10Exponent(x), str = $9a79e0cc470306c5$var$digitsToString(x.d), len = str.length;
    if (isExp) {
        if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + $9a79e0cc470306c5$var$getZeroString(k);
        else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
        str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
        str = '0.' + $9a79e0cc470306c5$var$getZeroString(-e - 1) + str;
        if (sd && (k = sd - len) > 0) str += $9a79e0cc470306c5$var$getZeroString(k);
    } else if (e >= len) {
        str += $9a79e0cc470306c5$var$getZeroString(e + 1 - len);
        if (sd && (k = sd - e - 1) > 0) str = str + '.' + $9a79e0cc470306c5$var$getZeroString(k);
    } else {
        if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
        if (sd && (k = sd - len) > 0) {
            if (e + 1 === len) str += '.';
            str += $9a79e0cc470306c5$var$getZeroString(k);
        }
    }
    return x.s < 0 ? '-' + str : str;
}
// Does not strip trailing zeros.
function $9a79e0cc470306c5$var$truncate(arr, len) {
    if (arr.length > len) {
        arr.length = len;
        return true;
    }
}
// Decimal methods
/*
 *  clone
 *  config/set
 */ /*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */ function $9a79e0cc470306c5$var$clone(obj) {
    var i, p, ps;
    /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */ function Decimal(value) {
        var x = this;
        // Decimal called without new.
        if (!(x instanceof Decimal)) return new Decimal(value);
        // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
        // which points to Object.
        x.constructor = Decimal;
        // Duplicate.
        if (value instanceof Decimal) {
            x.s = value.s;
            x.e = value.e;
            x.d = (value = value.d) ? value.slice() : value;
            return;
        }
        if (typeof value === 'number') {
            // Reject Infinity/NaN.
            if (value * 0 !== 0) throw Error($9a79e0cc470306c5$var$invalidArgument + value);
            if (value > 0) x.s = 1;
            else if (value < 0) {
                value = -value;
                x.s = -1;
            } else {
                x.s = 0;
                x.e = 0;
                x.d = [
                    0
                ];
                return;
            }
            // Fast path for small integers.
            if (value === ~~value && value < 1e7) {
                x.e = 0;
                x.d = [
                    value
                ];
                return;
            }
            return $9a79e0cc470306c5$var$parseDecimal(x, value.toString());
        } else if (typeof value !== 'string') throw Error($9a79e0cc470306c5$var$invalidArgument + value);
        // Minus sign?
        if (value.charCodeAt(0) === 45) {
            value = value.slice(1);
            x.s = -1;
        } else x.s = 1;
        if ($9a79e0cc470306c5$var$isDecimal.test(value)) $9a79e0cc470306c5$var$parseDecimal(x, value);
        else throw Error($9a79e0cc470306c5$var$invalidArgument + value);
    }
    Decimal.prototype = $9a79e0cc470306c5$var$P;
    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;
    Decimal.clone = $9a79e0cc470306c5$var$clone;
    Decimal.config = Decimal.set = $9a79e0cc470306c5$var$config;
    if (obj === void 0) obj = {};
    if (obj) {
        ps = [
            'precision',
            'rounding',
            'toExpNeg',
            'toExpPos',
            'LN10'
        ];
        for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }
    Decimal.config(obj);
    return Decimal;
}
/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */ function $9a79e0cc470306c5$var$config(obj) {
    if (!obj || typeof obj !== 'object') throw Error($9a79e0cc470306c5$var$decimalError + 'Object expected');
    var i, p, v, ps = [
        'precision',
        1,
        $9a79e0cc470306c5$var$MAX_DIGITS,
        'rounding',
        0,
        8,
        'toExpNeg',
        -1 / 0,
        0,
        'toExpPos',
        0,
        1 / 0
    ];
    for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
        if ($9a79e0cc470306c5$var$mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error($9a79e0cc470306c5$var$invalidArgument + p + ': ' + v);
    }
    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error($9a79e0cc470306c5$var$invalidArgument + p + ': ' + v);
    }
    return this;
}
// Create and configure initial Decimal constructor.
var $9a79e0cc470306c5$export$95c991896bef8714 = $9a79e0cc470306c5$var$clone($9a79e0cc470306c5$var$defaults);
// Internal constant.
$9a79e0cc470306c5$var$ONE = new $9a79e0cc470306c5$export$95c991896bef8714(1);
var $9a79e0cc470306c5$export$2e2bcd8739ae039 = $9a79e0cc470306c5$export$95c991896bef8714;


var $143b9a0b43a52e61$export$82cf6e3d4c009fa7;
(function(CurrencyCodes) {
    CurrencyCodes["AED"] = "aed";
    CurrencyCodes["AFN"] = "afn";
    CurrencyCodes["ALL"] = "all";
    CurrencyCodes["AMD"] = "amd";
    CurrencyCodes["ANG"] = "ang";
    CurrencyCodes["AOA"] = "aoa";
    CurrencyCodes["ARS"] = "ars";
    CurrencyCodes["AUD"] = "aud";
    CurrencyCodes["AWG"] = "awg";
    CurrencyCodes["AZN"] = "azn";
    CurrencyCodes["BAM"] = "bam";
    CurrencyCodes["BBD"] = "bbd";
    CurrencyCodes["BDT"] = "bdt";
    CurrencyCodes["BGN"] = "bgn";
    CurrencyCodes["BHD"] = "bhd";
    CurrencyCodes["BIF"] = "bif";
    CurrencyCodes["BMD"] = "bmd";
    CurrencyCodes["BND"] = "bnd";
    CurrencyCodes["BOB"] = "bob";
    CurrencyCodes["BOV"] = "bov";
    CurrencyCodes["BRL"] = "brl";
    CurrencyCodes["BSD"] = "bsd";
    CurrencyCodes["BTN"] = "btn";
    CurrencyCodes["BWP"] = "bwp";
    CurrencyCodes["BYN"] = "byn";
    CurrencyCodes["BYR"] = "byr";
    CurrencyCodes["BZD"] = "bzd";
    CurrencyCodes["CAD"] = "cad";
    CurrencyCodes["CDF"] = "cdf";
    CurrencyCodes["CHE"] = "che";
    CurrencyCodes["CHF"] = "chf";
    CurrencyCodes["CHW"] = "chw";
    CurrencyCodes["CLF"] = "clf";
    CurrencyCodes["CLP"] = "clp";
    CurrencyCodes["CNY"] = "cny";
    CurrencyCodes["COP"] = "cop";
    CurrencyCodes["COU"] = "cou";
    CurrencyCodes["CRC"] = "crc";
    CurrencyCodes["CUC"] = "cuc";
    CurrencyCodes["CUP"] = "cup";
    CurrencyCodes["CVE"] = "cve";
    CurrencyCodes["CZK"] = "czk";
    CurrencyCodes["DJF"] = "djf";
    CurrencyCodes["DKK"] = "dkk";
    CurrencyCodes["DOP"] = "dop";
    CurrencyCodes["DZD"] = "dzd";
    CurrencyCodes["EGP"] = "egp";
    CurrencyCodes["ERN"] = "ern";
    CurrencyCodes["ETB"] = "etb";
    CurrencyCodes["EUR"] = "eur";
    CurrencyCodes["FJD"] = "fjd";
    CurrencyCodes["FKP"] = "fkp";
    CurrencyCodes["GBP"] = "gbp";
    CurrencyCodes["GEL"] = "gel";
    CurrencyCodes["GHS"] = "ghs";
    CurrencyCodes["GIP"] = "gip";
    CurrencyCodes["GMD"] = "gmd";
    CurrencyCodes["GNF"] = "gnf";
    CurrencyCodes["GTQ"] = "gtq";
    CurrencyCodes["GYD"] = "gyd";
    CurrencyCodes["HKD"] = "hkd";
    CurrencyCodes["HNL"] = "hnl";
    CurrencyCodes["HRK"] = "hrk";
    CurrencyCodes["HTG"] = "htg";
    CurrencyCodes["HUF"] = "huf";
    CurrencyCodes["IDR"] = "idr";
    CurrencyCodes["ILS"] = "ils";
    CurrencyCodes["INR"] = "inr";
    CurrencyCodes["IQD"] = "iqd";
    CurrencyCodes["IRR"] = "irr";
    CurrencyCodes["ISK"] = "isk";
    CurrencyCodes["JMD"] = "jmd";
    CurrencyCodes["JOD"] = "jod";
    CurrencyCodes["JPY"] = "jpy";
    CurrencyCodes["KES"] = "kes";
    CurrencyCodes["KGS"] = "kgs";
    CurrencyCodes["KHR"] = "khr";
    CurrencyCodes["KMF"] = "kmf";
    CurrencyCodes["KPW"] = "kpw";
    CurrencyCodes["KRW"] = "krw";
    CurrencyCodes["KWD"] = "kwd";
    CurrencyCodes["KYD"] = "kyd";
    CurrencyCodes["KZT"] = "kzt";
    CurrencyCodes["LAK"] = "lak";
    CurrencyCodes["LBP"] = "lbp";
    CurrencyCodes["LKR"] = "lkr";
    CurrencyCodes["LRD"] = "lrd";
    CurrencyCodes["LSL"] = "lsl";
    CurrencyCodes["LTL"] = "ltl";
    CurrencyCodes["LVL"] = "lvl";
    CurrencyCodes["LYD"] = "lyd";
    CurrencyCodes["MAD"] = "mad";
    CurrencyCodes["MDL"] = "mdl";
    CurrencyCodes["MGA"] = "mga";
    CurrencyCodes["MKD"] = "mkd";
    CurrencyCodes["MMK"] = "mmk";
    CurrencyCodes["MNT"] = "mnt";
    CurrencyCodes["MOP"] = "mop";
    CurrencyCodes["MRO"] = "mro";
    CurrencyCodes["MUR"] = "mur";
    CurrencyCodes["MVR"] = "mvr";
    CurrencyCodes["MWK"] = "mwk";
    CurrencyCodes["MXN"] = "mxn";
    CurrencyCodes["MXV"] = "mxv";
    CurrencyCodes["MYR"] = "myr";
    CurrencyCodes["MZN"] = "mzn";
    CurrencyCodes["NAD"] = "nad";
    CurrencyCodes["NGN"] = "ngn";
    CurrencyCodes["NIO"] = "nio";
    CurrencyCodes["NOK"] = "nok";
    CurrencyCodes["NPR"] = "npr";
    CurrencyCodes["NZD"] = "nzd";
    CurrencyCodes["OMR"] = "omr";
    CurrencyCodes["PAB"] = "pab";
    CurrencyCodes["PEN"] = "pen";
    CurrencyCodes["PGK"] = "pgk";
    CurrencyCodes["PHP"] = "php";
    CurrencyCodes["PKR"] = "pkr";
    CurrencyCodes["PLN"] = "pln";
    CurrencyCodes["PYG"] = "pyg";
    CurrencyCodes["QAR"] = "qar";
    CurrencyCodes["RON"] = "ron";
    CurrencyCodes["RSD"] = "rsd";
    CurrencyCodes["RUB"] = "rub";
    CurrencyCodes["RWF"] = "rwf";
    CurrencyCodes["SAR"] = "sar";
    CurrencyCodes["SBD"] = "sbd";
    CurrencyCodes["SCR"] = "scr";
    CurrencyCodes["SDG"] = "sdg";
    CurrencyCodes["SEK"] = "sek";
    CurrencyCodes["SGD"] = "sgd";
    CurrencyCodes["SHP"] = "shp";
    CurrencyCodes["SLL"] = "sll";
    CurrencyCodes["SOS"] = "sos";
    CurrencyCodes["SRD"] = "srd";
    CurrencyCodes["SSP"] = "ssp";
    CurrencyCodes["STD"] = "std";
    CurrencyCodes["SVC"] = "svc";
    CurrencyCodes["SYP"] = "syp";
    CurrencyCodes["SZL"] = "szl";
    CurrencyCodes["THB"] = "thb";
    CurrencyCodes["TJS"] = "tjs";
    CurrencyCodes["TMT"] = "tmt";
    CurrencyCodes["TND"] = "tnd";
    CurrencyCodes["TOP"] = "top";
    CurrencyCodes["TRY"] = "try";
    CurrencyCodes["TTD"] = "ttd";
    CurrencyCodes["TWD"] = "twd";
    CurrencyCodes["TZS"] = "tzs";
    CurrencyCodes["UAH"] = "uah";
    CurrencyCodes["UGX"] = "ugx";
    CurrencyCodes["USD"] = "usd";
    CurrencyCodes["USN"] = "usn";
    CurrencyCodes["USS"] = "uss";
    CurrencyCodes["UYI"] = "uyi";
    CurrencyCodes["UYU"] = "uyu";
    CurrencyCodes["UZS"] = "uzs";
    CurrencyCodes["VEF"] = "vef";
    CurrencyCodes["VND"] = "vnd";
    CurrencyCodes["VUV"] = "vuv";
    CurrencyCodes["WST"] = "wst";
    CurrencyCodes["XAF"] = "xaf";
    CurrencyCodes["XAG"] = "xag";
    CurrencyCodes["XAU"] = "xau";
    CurrencyCodes["XBA"] = "xba";
    CurrencyCodes["XBB"] = "xbb";
    CurrencyCodes["XBC"] = "xbc";
    CurrencyCodes["XBD"] = "xbd";
    CurrencyCodes["XCD"] = "xcd";
    CurrencyCodes["XDR"] = "xdr";
    CurrencyCodes["XFU"] = "xfu";
    CurrencyCodes["XOF"] = "xof";
    CurrencyCodes["XPD"] = "xpd";
    CurrencyCodes["XPF"] = "xpf";
    CurrencyCodes["XPT"] = "xpt";
    CurrencyCodes["XSU"] = "xsu";
    CurrencyCodes["XTS"] = "xts";
    CurrencyCodes["XUA"] = "xua";
    CurrencyCodes["YER"] = "yer";
    CurrencyCodes["ZAR"] = "zar";
    CurrencyCodes["ZMW"] = "zmw";
    CurrencyCodes["ZWL"] = "zwl";
})($143b9a0b43a52e61$export$82cf6e3d4c009fa7 || ($143b9a0b43a52e61$export$82cf6e3d4c009fa7 = {}));
const $143b9a0b43a52e61$export$610339706cd0bc07 = {
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AED]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AFN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ALL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AMD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ANG]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AOA]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ARS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AUD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AWG]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.AZN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BAM]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BBD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BDT]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BGN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BHD]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BIF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BMD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BND]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BOB]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BOV]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BRL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BSD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BTN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BWP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BYR]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BYN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.BZD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CAD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CDF]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CHE]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CHF]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CHW]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CLF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CLP]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CNY]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.COP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.COU]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CRC]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CUC]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CUP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CVE]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.CZK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.DJF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.DKK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.DOP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.DZD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.EGP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ERN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ETB]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.EUR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.FJD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.FKP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GBP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GEL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GHS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GIP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GMD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GNF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GTQ]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.GYD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.HKD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.HNL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.HRK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.HTG]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.HUF]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.IDR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ILS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.INR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.IQD]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.IRR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ISK]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.JMD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.JOD]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.JPY]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KES]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KGS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KHR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KMF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KPW]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KRW]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KWD]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KYD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.KZT]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LAK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LBP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LKR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LRD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LSL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LTL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LVL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.LYD]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MAD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MDL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MGA]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MKD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MMK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MNT]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MOP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MRO]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MUR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MVR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MWK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MXN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MXV]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MYR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.MZN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NAD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NGN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NIO]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NOK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NPR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.NZD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.OMR]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PAB]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PEN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PGK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PHP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PKR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PLN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.PYG]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.QAR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.RON]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.RSD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.RUB]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.RWF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SAR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SBD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SCR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SDG]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SEK]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SGD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SHP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SLL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SOS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SRD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SSP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.STD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SVC]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SYP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.SZL]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.THB]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TJS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TMT]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TND]: 3,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TOP]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TRY]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TTD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TWD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.TZS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.UAH]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.UGX]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.USD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.USN]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.USS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.UYI]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.UYU]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.UZS]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.VEF]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.VND]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.VUV]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.WST]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XAF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XAG]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XAU]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XBA]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XBB]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XBC]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XBD]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XCD]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XDR]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XFU]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XOF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XPD]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XPF]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XPT]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XSU]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XTS]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.XUA]: 0,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.YER]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ZAR]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ZMW]: 2,
    [$143b9a0b43a52e61$export$82cf6e3d4c009fa7.ZWL]: 2
};


function $0e5ba417f9052f4b$var$formatPrice(price, locale = 'en-US') {
    const { amount: amount, currency: currency } = price;
    const formatter = Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    });
    return formatter.format($0e5ba417f9052f4b$var$convertToMajorCurrencyUnits(amount, currency));
}
function $0e5ba417f9052f4b$var$convertToMajorCurrencyUnits(minorUnitValue, currency) {
    const exponent = (0, $143b9a0b43a52e61$export$610339706cd0bc07)[currency];
    if (exponent == null) {
        console.warn(`Unexpected currency ${currency}`);
        return minorUnitValue;
    }
    const minorUnit = new (0, $9a79e0cc470306c5$export$2e2bcd8739ae039)(minorUnitValue);
    return minorUnit.dividedBy(10 ** exponent).toNumber();
}
var $0e5ba417f9052f4b$export$2e2bcd8739ae039 = {
    formatPrice: $0e5ba417f9052f4b$var$formatPrice
};






var $5c93292201a74627$export$5edeffb658f039f4 = {
    exports: {}
};


/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (0, $5c93292201a74627$export$5edeffb658f039f4).exports;
var $f57d2b44638b1fc3$var$hasRequiredLodash_transform;
function $f57d2b44638b1fc3$export$b88c30a9414655a0() {
    if ($f57d2b44638b1fc3$var$hasRequiredLodash_transform) return (0, $5c93292201a74627$export$5edeffb658f039f4).exports;
    $f57d2b44638b1fc3$var$hasRequiredLodash_transform = 1;
    (function(module, exports) {
        /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
        /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
        /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
        /** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
        /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
        /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        /**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
        /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
        /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
        /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof (0, $1a35ac73ddb3ee8a$export$a441d440b06e3168) == 'object' && (0, $1a35ac73ddb3ee8a$export$a441d440b06e3168) && (0, $1a35ac73ddb3ee8a$export$a441d440b06e3168).Object === Object && (0, $1a35ac73ddb3ee8a$export$a441d440b06e3168);
        /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
        /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
        /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
            try {
                return freeProcess && freeProcess.binding('util');
            } catch (e) {}
        }();
        /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        /**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */ function arrayEach(array, iteratee) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        /**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */ function arraySome(array, predicate) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        /**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        /**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */ function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        /**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */ function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        /**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */ function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        /**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */ function isHostObject(value) {
            // Many host objects are `Object` objects that can coerce to strings
            // despite having improperly defined `toString` methods.
            var result = false;
            if (value != null && typeof value.toString != 'function') try {
                result = !!(value + '');
            } catch (e) {}
            return result;
        }
        /**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */ function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        /**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */ function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        /**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */ function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */ var objectToString = objectProto.toString;
        /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
        /* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Hash(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
        }
        /**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function hashDelete(key) {
            return this.has(key) && delete this.__data__[key];
        }
        /**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */ function hashSet(key, value) {
            var data = this.__data__;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function ListCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */ function listCacheClear() {
            this.__data__ = [];
        }
        /**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            return true;
        }
        /**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) data.push([
                key,
                value
            ]);
            else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function MapCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */ function mapCacheClear() {
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function mapCacheDelete(key) {
            return getMapData(this, key)['delete'](key);
        }
        /**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */ function mapCacheSet(key, value) {
            getMapData(this, key).set(key, value);
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */ function SetCache(values) {
            var index = -1, length = values ? values.length : 0;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Stack(entries) {
            this.__data__ = new ListCache(entries);
        }
        /**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */ function stackClear() {
            this.__data__ = new ListCache;
        }
        /**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function stackDelete(key) {
            return this.__data__['delete'](key);
        }
        /**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */ function stackSet(key, value) {
            var cache = this.__data__;
            if (cache instanceof ListCache) {
                var pairs = cache.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    return this;
                }
                cache = this.__data__ = new MapCache(pairs);
            }
            cache.set(key, value);
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */ function arrayLikeKeys(value, inherited) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            // Safari 9 makes `arguments.length` enumerable in strict mode.
            var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
            var length = result.length, skipIndexes = !!length;
            for(var key in value)if (hasOwnProperty.call(value, key) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */ function baseCreate(proto) {
            return isObject(proto) ? objectCreate(proto) : {};
        }
        /**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */ var baseFor = createBaseFor();
        /**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */ function baseGet(object, path) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ function baseGetTag(value) {
            return objectToString.call(value);
        }
        /**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */ function baseHasIn(object, key) {
            return object != null && key in Object(object);
        }
        /**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {boolean} [bitmask] The bitmask of comparison flags.
		 *  The bitmask may be composed of the following flags:
		 *     1 - Unordered comparison
		 *     2 - Partial comparison
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
        }
        /**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
            if (!objIsArr) {
                objTag = getTag(object);
                objTag = objTag == argsTag ? objectTag : objTag;
            }
            if (!othIsArr) {
                othTag = getTag(other);
                othTag = othTag == argsTag ? objectTag : othTag;
            }
            var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
            }
            if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
        }
        /**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index;
            if (object == null) return !length;
            object = Object(object);
            while(index--){
                var data = matchData[index];
                if (data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    var result;
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
        }
        /**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
            };
        }
        /**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array} Returns the cast property path array.
		 */ function castPath(value) {
            return isArray(value) ? value : stringToPath(value);
        }
        /**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) return stacked == other;
            var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= UNORDERED_COMPARE_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) return stacked == other;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11,
        // for data views in Edge < 14, and promises in Node.js.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */ function hasPath(object, path, hasFunc) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var result, index = -1, length = path.length;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result) return result;
            var length = object ? object.length : 0;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */ function isIndex(value, length) {
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }
        /**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
            };
        }
        /**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */ var stringToPath = memoize(function(string) {
            string = toString(string);
            var result = [];
            if (reLeadingDot.test(string)) result.push('');
            string.replace(rePropName, function(match, number, quote, string) {
                result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result);
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Assign cache to `_.memoize`.
        memoize.Cache = MapCache;
        /**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */ function isArguments(value) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
        }
        /**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */ var isArray = Array.isArray;
        /**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */ function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 8-9 which returns 'object' for typed array and other constructors.
            var tag = isObject(value) ? objectToString.call(value) : '';
            return tag == funcTag || tag == genTag;
        }
        /**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */ function isObject(value) {
            var type = typeof value;
            return !!value && (type == 'object' || type == 'function');
        }
        /**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */ function isObjectLike(value) {
            return !!value && typeof value == 'object';
        }
        /**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
		 * An alternative to `_.reduce`; this method transforms `object` to a new
		 * `accumulator` object which is the result of running each of its own
		 * enumerable string keyed properties thru `iteratee`, with each invocation
		 * potentially mutating the `accumulator` object. If `accumulator` is not
		 * provided, a new object with the same `[[Prototype]]` will be used. The
		 * iteratee is invoked with four arguments: (accumulator, value, key, object).
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.3.0
		 * @category Object
		 * @param {Object} object The object to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @param {*} [accumulator] The custom accumulator value.
		 * @returns {*} Returns the accumulated value.
		 * @example
		 *
		 * _.transform([2, 3, 4], function(result, n) {
		 *   result.push(n *= n);
		 *   return n % 2 == 0;
		 * }, []);
		 * // => [4, 9]
		 *
		 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
		 *   (result[value] || (result[value] = [])).push(key);
		 * }, {});
		 * // => { '1': ['a', 'c'], '2': ['b'] }
		 */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object) || isTypedArray(object);
            iteratee = baseIteratee(iteratee);
            if (accumulator == null) {
                if (isArr || isObject(object)) {
                    var Ctor = object.constructor;
                    if (isArr) accumulator = isArray(object) ? new Ctor : [];
                    else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                } else accumulator = {};
            }
            (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */ function identity(value) {
            return value;
        }
        /**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        module.exports = transform;
    })((0, $5c93292201a74627$export$5edeffb658f039f4), (0, $5c93292201a74627$export$5edeffb658f039f4).exports);
    return (0, $5c93292201a74627$export$5edeffb658f039f4).exports;
}


var $358f2bed9bd86c42$var$lodash_transformExports = (0, $f57d2b44638b1fc3$export$b88c30a9414655a0)();
var $358f2bed9bd86c42$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $1a35ac73ddb3ee8a$export$22b09f878622677a)($358f2bed9bd86c42$var$lodash_transformExports);





class $d908b37dde252fe8$export$112ebc686c39e9ae {
    constructor(clientId, guildId, channelId, locationId){
        this.platform = (0, $46a39478d4fb12cc$export$2dffd0b5373a4389).DESKTOP;
        this.instanceId = '123456789012345678';
        this.configuration = (0, $4ba1bc9ff3722d9c$export$2e2bcd8739ae039)();
        this.source = null;
        this.sourceOrigin = '';
        this.sdkVersion = 'mock';
        this.mobileAppVersion = 'unknown';
        this.frameId = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
        this.eventBus = new (0, $1cc29b2b9ac0411b$export$2e2bcd8739ae039)();
        this.clientId = clientId;
        this.commands = this._updateCommandMocks({});
        this.guildId = guildId;
        this.channelId = channelId;
        this.locationId = locationId;
        this.customId = null;
        this.referrerId = null;
    }
    _updateCommandMocks(newCommands) {
        // Wrap all the command functions with logging
        this.commands = (0, $358f2bed9bd86c42$export$2e2bcd8739ae039)(Object.assign({}, $d908b37dde252fe8$export$df10d8e5927d39a4, newCommands), (mock, func, name)=>{
            mock[name] = async (...args)=>{
                console.info(`DiscordSDKMock: ${String(name)}(${JSON.stringify(args)})`);
                return await func(...args);
            };
        });
        // redundant return here to satisfy the constructor defining commands
        return this.commands;
    }
    emitReady() {
        this.emitEvent('READY', undefined);
    }
    close(...args) {
        console.info(`DiscordSDKMock: close(${JSON.stringify(args)})`);
    }
    ready() {
        return Promise.resolve();
    }
    async subscribe(event, listener, ..._subscribeArgs) {
        return await this.eventBus.on(event, listener);
    }
    async unsubscribe(event, listener, ..._unsubscribeArgs) {
        return await this.eventBus.off(event, listener);
    }
    emitEvent(event, data) {
        this.eventBus.emit(event, data);
    }
}
/** Default return values for all discord SDK commands */ const $d908b37dde252fe8$export$df10d8e5927d39a4 = {
    authorize: ()=>Promise.resolve({
            code: 'mock_code'
        }),
    setActivity: ()=>Promise.resolve({
            name: 'mock_activity_name',
            type: 0
        }),
    getChannel: ()=>Promise.resolve({
            id: 'mock_channel_id',
            name: 'mock_channel_name',
            type: (0, $7563c491739c9977$export$2f4cb441f3eded01).GUILD_TEXT,
            voice_states: [],
            messages: []
        }),
    getSkus: ()=>Promise.resolve({
            skus: []
        }),
    getEntitlements: ()=>Promise.resolve({
            entitlements: []
        }),
    startPurchase: ()=>Promise.resolve([]),
    setConfig: ()=>Promise.resolve({
            use_interactive_pip: false
        }),
    userSettingsGetLocale: ()=>Promise.resolve({
            locale: ''
        }),
    openExternalLink: ()=>Promise.resolve({
            opened: false
        }),
    encourageHardwareAcceleration: ()=>Promise.resolve({
            enabled: true
        }),
    captureLog: ()=>Promise.resolve(null),
    setOrientationLockState: ()=>Promise.resolve(null),
    openInviteDialog: ()=>Promise.resolve(null),
    getPlatformBehaviors: ()=>Promise.resolve({
            iosKeyboardResizesView: true
        }),
    getChannelPermissions: ()=>Promise.resolve({
            permissions: (0, $77fcb239dda6bb0b$export$2e2bcd8739ae039)(1234567890)
        }),
    getInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    // START-GENERATED-SECTION
    openShareMomentDialog: ()=>Promise.resolve(null),
    authenticate: ()=>Promise.resolve({
            access_token: 'mock_token',
            user: {
                username: 'mock_user_username',
                discriminator: 'mock_user_discriminator',
                id: 'mock_user_id',
                avatar: null,
                public_flags: 1
            },
            scopes: [],
            expires: new Date(2121, 1, 1).toString(),
            application: {
                description: 'mock_app_description',
                icon: 'mock_app_icon',
                id: 'mock_app_id',
                name: 'mock_app_name'
            }
        }),
    shareLink: ()=>Promise.resolve({
            success: false,
            didSendMessage: false,
            didCopyLink: false
        }),
    initiateImageUpload: ()=>Promise.resolve({
            image_url: 'https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0b52aa9e99b832574a53_full_logo_blurple_RGB.png'
        }),
    getRelationships: ()=>Promise.resolve({
            relationships: [
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator',
                        id: 'mock_friend_id_1',
                        avatar: null
                    }
                },
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username_with_nickname',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator_with_nickname',
                        id: 'mock_friend_id_2',
                        avatar: null
                    },
                    nickname: 'mock_friend_nickname_for_user'
                },
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username_with_since',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator_with_since',
                        id: 'mock_friend_id_3',
                        avatar: null
                    },
                    since: '2021-06-29T00:32:37.180813+00:00'
                }
            ]
        }),
    inviteUserEmbedded: ()=>Promise.resolve(null),
    getUser: ()=>{
        return Promise.resolve({
            username: 'mock_friend_username',
            flags: 0,
            bot: false,
            discriminator: 'mock_friend_discriminator',
            id: 'mock_friend_id_1',
            avatar: null
        });
    },
    getQuestEnrollmentStatus: ()=>Promise.resolve({
            quest_id: 'mock_quest_id',
            is_enrolled: false,
            enrolled_at: null
        }),
    questStartTimer: ()=>Promise.resolve({
            success: true
        }),
    getActivityInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    shareInteraction: ()=>Promise.resolve({
            success: false
        })
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $6e5b0844ba2fa5da$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;


/**
 * Creates a regular expression from a target string. The target string
 * may contain `{name}` tokens which will end up being translated to
 * a named group match for a series of word characters with the group named `name`
 * The substitution pattern is {a-z} because the named groups must be valid JS identifiers,
 * making items like {0} invalid.
 *
 * @returns a RegExp object
 **/ const $b7205b0aeee9432c$var$SUBSTITUTION_REGEX = /\{([a-z]+)\}/g;
function $b7205b0aeee9432c$var$regexFromTarget(target) {
    const regexString = target.replace($b7205b0aeee9432c$var$SUBSTITUTION_REGEX, (match, name)=>`(?<${name}>[\\w-]+)`);
    return new RegExp(`${regexString}(/|$)`);
}
/**
 *
 * Attempts to map the actual url (i.e. google.com) to a url path, per the url
 * mappings set up in the embedded application. If the target contains `{foo}`
 * tokens, they will be replace with the values contained in the original URL,
 * via the pattern described in the prefix
 *
 * @returns  null if URL doesn't match prefix, otherwise return rewritten URL
 */ function $b7205b0aeee9432c$export$a79199ba3137e3aa({ originalURL: originalURL, prefix: prefix, prefixHost: prefixHost, target: target }) {
    // coerce url with filler https protocol so we can retrieve host and pathname from target
    const targetURL = new URL(`https://${target}`);
    // Depending on the environment, the URL constructor may turn `{` and `}` into `%7B` and `%7D`, respectively
    const targetRegEx = $b7205b0aeee9432c$var$regexFromTarget(targetURL.host.replace(/%7B/g, '{').replace(/%7D/g, '}'));
    const match = originalURL.toString().match(targetRegEx);
    // Null match indicates that this target is not relevant
    if (match == null) return originalURL;
    const newURL = new URL(originalURL.toString());
    newURL.host = prefixHost;
    newURL.pathname = prefix.replace($b7205b0aeee9432c$var$SUBSTITUTION_REGEX, (_, matchName)=>{
        var _a;
        const replaceValue = (_a = match.groups) === null || _a === void 0 ? void 0 : _a[matchName];
        if (replaceValue == null) throw new Error('Misconfigured route.');
        return replaceValue;
    });
    // Append the original path
    const pathToAppend = originalURL.pathname.startsWith('/') ? originalURL.pathname.slice(1) : originalURL.pathname;
    newURL.pathname += newURL.pathname.endsWith('/') ? pathToAppend : '/' + pathToAppend;
    // Remove the target's path from the new url path
    newURL.pathname = newURL.pathname.replace(targetURL.pathname, '');
    // Add a trailing slash if original url had it, and if it doesn't already have one or if matches filename regex
    if (originalURL.pathname.endsWith('/') && !newURL.pathname.endsWith('/')) newURL.pathname += '/';
    return newURL;
}
function $b7205b0aeee9432c$export$11fe587afbb5d544(url, protocol = window.location.protocol, host = window.location.host) {
    // If the first arg is a complete url, it will ignore the second arg
    // This call structure lets us set relative urls to have a full url with the proper protocol and host
    return new URL(url, `${protocol}//${host}`);
}


function $b11db2d8d587d00f$export$8cf746fdd009b78f(mappings, { patchFetch: patchFetch = true, patchWebSocket: patchWebSocket = true, patchXhr: patchXhr = true, patchSrcAttributes: patchSrcAttributes = false } = {}) {
    // Bail out if we're not in a browser
    if (typeof window === 'undefined') return;
    if (patchFetch) {
        const fetchImpl = window.fetch;
        // fetch is a duplex, but this is consistent
        window.fetch = function(input, init) {
            // If fetch has Request as input, we need to resolve any stream
            // before we create a new request with the mapped url
            if (input instanceof Request) {
                const newUrl = $b11db2d8d587d00f$export$e84bab733853880b({
                    url: (0, $b7205b0aeee9432c$export$11fe587afbb5d544)(input.url),
                    mappings: mappings
                });
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _a = init !== null && init !== void 0 ? init : {}, newInit = (0, $6e5b0844ba2fa5da$export$3c9a16f847548506)(_a, [
                    "url"
                ]);
                Object.keys(Request.prototype).forEach((value)=>{
                    if (value === 'url') return;
                    try {
                        // @ts-expect-error
                        newInit[value] = input[value];
                    } catch (ex) {
                        console.warn(`Remapping fetch request key "${value}" failed`, ex);
                    }
                });
                return new Promise((resolve, reject)=>{
                    try {
                        input.blob().then((blob)=>{
                            if (input.method.toUpperCase() !== 'HEAD' && input.method.toUpperCase() !== 'GET' && blob.size > 0) newInit.body = blob;
                            resolve(fetchImpl(new Request(newUrl, newInit)));
                        });
                    } catch (ex) {
                        reject(ex);
                    }
                });
            }
            // Assuming a generic url or string
            const remapped = $b11db2d8d587d00f$export$e84bab733853880b({
                url: input instanceof URL ? input : (0, $b7205b0aeee9432c$export$11fe587afbb5d544)(input),
                mappings: mappings
            });
            return fetchImpl(remapped, init);
        };
    }
    if (patchWebSocket) {
        class WebSocketProxy extends WebSocket {
            constructor(url, protocols){
                const remapped = $b11db2d8d587d00f$export$e84bab733853880b({
                    url: url instanceof URL ? url : (0, $b7205b0aeee9432c$export$11fe587afbb5d544)(url),
                    mappings: mappings
                });
                super(remapped, protocols);
            }
        }
        window.WebSocket = WebSocketProxy;
    }
    if (patchXhr) {
        const openImpl = XMLHttpRequest.prototype.open;
        // @ts-expect-error - the ts interface exports two 'open' methods
        XMLHttpRequest.prototype.open = function(method, url, async, username, password) {
            const remapped = $b11db2d8d587d00f$export$e84bab733853880b({
                url: (0, $b7205b0aeee9432c$export$11fe587afbb5d544)(url),
                mappings: mappings
            });
            openImpl.apply(this, [
                method,
                remapped,
                async,
                username,
                password
            ]);
        };
    }
    if (patchSrcAttributes) {
        const callback = function(mutationsList) {
            for (const mutation of mutationsList){
                if (mutation.type === 'attributes' && mutation.attributeName === 'src') $b11db2d8d587d00f$var$attemptSetNodeSrc(mutation.target, mappings);
                else if (mutation.type === 'childList') mutation.addedNodes.forEach((node)=>{
                    $b11db2d8d587d00f$var$attemptSetNodeSrc(node, mappings);
                    $b11db2d8d587d00f$var$recursivelyRemapChildNodes(node, mappings);
                });
            }
        };
        const observer = new MutationObserver(callback);
        const config = {
            attributeFilter: [
                'src'
            ],
            childList: true,
            subtree: true
        };
        observer.observe(window.document, config);
        window.document.querySelectorAll('[src]').forEach((node)=>{
            $b11db2d8d587d00f$var$attemptSetNodeSrc(node, mappings);
        });
    }
}
function $b11db2d8d587d00f$var$recursivelyRemapChildNodes(node, mappings) {
    if (node.hasChildNodes()) node.childNodes.forEach((child)=>{
        $b11db2d8d587d00f$var$attemptSetNodeSrc(child, mappings);
        $b11db2d8d587d00f$var$recursivelyRemapChildNodes(child, mappings);
    });
}
function $b11db2d8d587d00f$var$attemptSetNodeSrc(node, mappings) {
    if (node instanceof HTMLElement && node.hasAttribute('src')) {
        const rawSrc = node.getAttribute('src');
        const url = (0, $b7205b0aeee9432c$export$11fe587afbb5d544)(rawSrc !== null && rawSrc !== void 0 ? rawSrc : '');
        if (url.host === window.location.host) return;
        if (node.tagName.toLowerCase() === 'script') // Scripts are a special case, and need to be wholly recreated since
        // modifying a script tag doesn't refetch.
        $b11db2d8d587d00f$var$attemptRecreateScriptNode(node, {
            url: url,
            mappings: mappings
        });
        else {
            const newSrc = $b11db2d8d587d00f$export$e84bab733853880b({
                url: url,
                mappings: mappings
            }).toString();
            // Only apply the remapping if we actually remapped the value
            if (newSrc !== rawSrc) node.setAttribute('src', newSrc);
        }
    }
}
function $b11db2d8d587d00f$var$attemptRecreateScriptNode(node, { url: url, mappings: mappings }) {
    const newUrl = $b11db2d8d587d00f$export$e84bab733853880b({
        url: url,
        mappings: mappings
    });
    if (url.toString() !== newUrl.toString()) {
        // Note: Script tags cannot be duplicated via `node.clone()` because their internal 'already started'
        // state prevents the new one from being fetched. We must manually recreate the duplicate tag instead.
        const newNode = document.createElement(node.tagName);
        newNode.innerHTML = node.innerHTML;
        for (const attr of node.attributes)newNode.setAttribute(attr.name, attr.value);
        newNode.setAttribute('src', $b11db2d8d587d00f$export$e84bab733853880b({
            url: url,
            mappings: mappings
        }).toString());
        node.after(newNode);
        node.remove();
    }
}
function $b11db2d8d587d00f$export$e84bab733853880b({ url: url, mappings: mappings }) {
    const newURL = new URL(url.toString());
    for (const mapping of mappings){
        const mapped = (0, $b7205b0aeee9432c$export$a79199ba3137e3aa)({
            originalURL: newURL,
            prefix: mapping.prefix,
            target: mapping.target,
            prefixHost: window.location.host
        });
        if (mapped != null && (mapped === null || mapped === void 0 ? void 0 : mapped.toString()) !== url.toString()) return mapped;
    }
    return newURL;
}


const { Commands: $f30644a19c0d8a85$export$ba30f7724cb0e54e } = $7563c491739c9977$exports;


var $e444d6404c095fa5$var$t = "undefined" != typeof window ? window : void 0, $e444d6404c095fa5$var$i = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$t;
"undefined" == typeof self && ($e444d6404c095fa5$var$i.self = $e444d6404c095fa5$var$i), "undefined" == typeof File && ($e444d6404c095fa5$var$i.File = function() {});
var $e444d6404c095fa5$var$e = Array.prototype, $e444d6404c095fa5$var$r = $e444d6404c095fa5$var$e.forEach, $e444d6404c095fa5$var$s = $e444d6404c095fa5$var$e.indexOf, $e444d6404c095fa5$var$n = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.navigator, $e444d6404c095fa5$var$o = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.document, $e444d6404c095fa5$var$a = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.location, $e444d6404c095fa5$var$l = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.fetch, $e444d6404c095fa5$var$u = null != $e444d6404c095fa5$var$i && $e444d6404c095fa5$var$i.XMLHttpRequest && "withCredentials" in new $e444d6404c095fa5$var$i.XMLHttpRequest ? $e444d6404c095fa5$var$i.XMLHttpRequest : void 0, $e444d6404c095fa5$var$h = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.AbortController, $e444d6404c095fa5$var$d = null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.userAgent, $e444d6404c095fa5$var$v = null != $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t : {}, $e444d6404c095fa5$var$c = "1.362.0", $e444d6404c095fa5$var$f = {
    DEBUG: !1,
    LIB_VERSION: $e444d6404c095fa5$var$c,
    LIB_NAME: "web",
    JS_SDK_VERSION: $e444d6404c095fa5$var$c
};
function $e444d6404c095fa5$var$p(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function $e444d6404c095fa5$var$_(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                $e444d6404c095fa5$var$p(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $e444d6404c095fa5$var$p(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $e444d6404c095fa5$var$g() {
    return $e444d6404c095fa5$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $e444d6404c095fa5$var$g.apply(null, arguments);
}
function $e444d6404c095fa5$var$m(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var $e444d6404c095fa5$var$b = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $e444d6404c095fa5$var$y = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $e444d6404c095fa5$var$w = function(t, i) {
    if (void 0 === i && (i = []), !t) return !1;
    var e = t.toLowerCase();
    return $e444d6404c095fa5$var$y.concat(i).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
};
function $e444d6404c095fa5$var$E(t, i) {
    return -1 !== t.indexOf(i);
}
var $e444d6404c095fa5$var$S = function(t) {
    return t.trim();
}, $e444d6404c095fa5$var$x = function(t) {
    return t.replace(/^\$/, "");
};
var $e444d6404c095fa5$var$k = Array.isArray, $e444d6404c095fa5$var$P = Object.prototype, $e444d6404c095fa5$var$T = $e444d6404c095fa5$var$P.hasOwnProperty, $e444d6404c095fa5$var$R = $e444d6404c095fa5$var$P.toString, $e444d6404c095fa5$var$I = $e444d6404c095fa5$var$k || function(t) {
    return "[object Array]" === $e444d6404c095fa5$var$R.call(t);
}, $e444d6404c095fa5$var$C = (t)=>"function" == typeof t, $e444d6404c095fa5$var$O = (t)=>t === Object(t) && !$e444d6404c095fa5$var$I(t), $e444d6404c095fa5$var$F = (t)=>{
    if ($e444d6404c095fa5$var$O(t)) {
        for(var i in t)if ($e444d6404c095fa5$var$T.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $e444d6404c095fa5$var$M = (t)=>void 0 === t, $e444d6404c095fa5$var$A = (t)=>"[object String]" == $e444d6404c095fa5$var$R.call(t), $e444d6404c095fa5$var$D = (t)=>$e444d6404c095fa5$var$A(t) && 0 === t.trim().length, $e444d6404c095fa5$var$L = (t)=>null === t, $e444d6404c095fa5$var$j = (t)=>$e444d6404c095fa5$var$M(t) || $e444d6404c095fa5$var$L(t), $e444d6404c095fa5$var$N = (t)=>"[object Number]" == $e444d6404c095fa5$var$R.call(t) && t == t, $e444d6404c095fa5$var$U = (t)=>$e444d6404c095fa5$var$N(t) && t > 0, $e444d6404c095fa5$var$z = (t)=>"[object Boolean]" === $e444d6404c095fa5$var$R.call(t), $e444d6404c095fa5$var$H = (t)=>t instanceof FormData, $e444d6404c095fa5$var$B = (t)=>$e444d6404c095fa5$var$E($e444d6404c095fa5$var$b, t);
function $e444d6404c095fa5$var$q(t) {
    return null === t || "object" != typeof t;
}
function $e444d6404c095fa5$var$V(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $e444d6404c095fa5$var$W(t) {
    return !$e444d6404c095fa5$var$M(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $e444d6404c095fa5$var$G = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $e444d6404c095fa5$var$Y = (t)=>$e444d6404c095fa5$var$E($e444d6404c095fa5$var$G, t), $e444d6404c095fa5$var$J = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $e444d6404c095fa5$var$K(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), $e444d6404c095fa5$var$N(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), $e444d6404c095fa5$var$K(s || e, i, e, r));
}
class $e444d6404c095fa5$var$X {
    constructor(t){
        this.t = {}, this.i = t.i, this.o = $e444d6404c095fa5$var$K(t.bucketSize, 0, 100, t.h), this.m = $e444d6404c095fa5$var$K(t.refillRate, 0, this.o, t.h), this.S = $e444d6404c095fa5$var$K(t.refillInterval, 0, 864e5, t.h);
    }
    $(t, i) {
        var e = i - t.lastAccess, r = Math.floor(e / this.S);
        if (r > 0) {
            var s = r * this.m;
            t.tokens = Math.min(t.tokens + s, this.o), t.lastAccess = t.lastAccess + r * this.S;
        }
    }
    consumeRateLimit(t) {
        var i, e = Date.now(), r = String(t), s = this.t[r];
        return s ? this.$(s, e) : (s = {
            tokens: this.o,
            lastAccess: e
        }, this.t[r] = s), 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (i = this.i) || i.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.t = {};
    }
}
var $e444d6404c095fa5$var$Q = "Mobile", $e444d6404c095fa5$var$Z = "iOS", $e444d6404c095fa5$var$tt = "Android", $e444d6404c095fa5$var$it = "Tablet", $e444d6404c095fa5$var$et = $e444d6404c095fa5$var$tt + " " + $e444d6404c095fa5$var$it, $e444d6404c095fa5$var$rt = "iPad", $e444d6404c095fa5$var$st = "Apple", $e444d6404c095fa5$var$nt = $e444d6404c095fa5$var$st + " Watch", $e444d6404c095fa5$var$ot = "Safari", $e444d6404c095fa5$var$at = "BlackBerry", $e444d6404c095fa5$var$lt = "Samsung", $e444d6404c095fa5$var$ut = $e444d6404c095fa5$var$lt + "Browser", $e444d6404c095fa5$var$ht = $e444d6404c095fa5$var$lt + " Internet", $e444d6404c095fa5$var$dt = "Chrome", $e444d6404c095fa5$var$vt = $e444d6404c095fa5$var$dt + " OS", $e444d6404c095fa5$var$ct = $e444d6404c095fa5$var$dt + " " + $e444d6404c095fa5$var$Z, $e444d6404c095fa5$var$ft = "Internet Explorer", $e444d6404c095fa5$var$pt = $e444d6404c095fa5$var$ft + " " + $e444d6404c095fa5$var$Q, $e444d6404c095fa5$var$_t = "Opera", $e444d6404c095fa5$var$gt = $e444d6404c095fa5$var$_t + " Mini", $e444d6404c095fa5$var$mt = "Edge", $e444d6404c095fa5$var$bt = "Microsoft " + $e444d6404c095fa5$var$mt, $e444d6404c095fa5$var$yt = "Firefox", $e444d6404c095fa5$var$wt = $e444d6404c095fa5$var$yt + " " + $e444d6404c095fa5$var$Z, $e444d6404c095fa5$var$Et = "Nintendo", $e444d6404c095fa5$var$St = "PlayStation", $e444d6404c095fa5$var$xt = "Xbox", $e444d6404c095fa5$var$$t = $e444d6404c095fa5$var$tt + " " + $e444d6404c095fa5$var$Q, $e444d6404c095fa5$var$kt = $e444d6404c095fa5$var$Q + " " + $e444d6404c095fa5$var$ot, $e444d6404c095fa5$var$Pt = "Windows", $e444d6404c095fa5$var$Tt = $e444d6404c095fa5$var$Pt + " Phone", $e444d6404c095fa5$var$Rt = "Nokia", $e444d6404c095fa5$var$It = "Ouya", $e444d6404c095fa5$var$Ct = "Generic", $e444d6404c095fa5$var$Ot = $e444d6404c095fa5$var$Ct + " " + $e444d6404c095fa5$var$Q.toLowerCase(), $e444d6404c095fa5$var$Ft = $e444d6404c095fa5$var$Ct + " " + $e444d6404c095fa5$var$it.toLowerCase(), $e444d6404c095fa5$var$Mt = "Konqueror", $e444d6404c095fa5$var$At = "(\\d+(\\.\\d+)?)", $e444d6404c095fa5$var$Dt = new RegExp("Version/" + $e444d6404c095fa5$var$At), $e444d6404c095fa5$var$Lt = new RegExp($e444d6404c095fa5$var$xt, "i"), $e444d6404c095fa5$var$jt = new RegExp($e444d6404c095fa5$var$St + " \\w+", "i"), $e444d6404c095fa5$var$Nt = new RegExp($e444d6404c095fa5$var$Et + " \\w+", "i"), $e444d6404c095fa5$var$Ut = new RegExp($e444d6404c095fa5$var$at + "|PlayBook|BB10", "i"), $e444d6404c095fa5$var$zt = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $e444d6404c095fa5$var$Ht, $e444d6404c095fa5$var$Bt, $e444d6404c095fa5$var$qt, $e444d6404c095fa5$var$Vt = (t, i)=>i && $e444d6404c095fa5$var$E(i, $e444d6404c095fa5$var$st) || function(t) {
        return $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$ot) && !$e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$dt) && !$e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$tt);
    }(t), $e444d6404c095fa5$var$Wt = function(t, i) {
    return i = i || "", $e444d6404c095fa5$var$E(t, " OPR/") && $e444d6404c095fa5$var$E(t, "Mini") ? $e444d6404c095fa5$var$gt : $e444d6404c095fa5$var$E(t, " OPR/") ? $e444d6404c095fa5$var$_t : $e444d6404c095fa5$var$Ut.test(t) ? $e444d6404c095fa5$var$at : $e444d6404c095fa5$var$E(t, "IE" + $e444d6404c095fa5$var$Q) || $e444d6404c095fa5$var$E(t, "WPDesktop") ? $e444d6404c095fa5$var$pt : $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$ut) ? $e444d6404c095fa5$var$ht : $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$mt) || $e444d6404c095fa5$var$E(t, "Edg/") ? $e444d6404c095fa5$var$bt : $e444d6404c095fa5$var$E(t, "FBIOS") ? "Facebook " + $e444d6404c095fa5$var$Q : $e444d6404c095fa5$var$E(t, "UCWEB") || $e444d6404c095fa5$var$E(t, "UCBrowser") ? "UC Browser" : $e444d6404c095fa5$var$E(t, "CriOS") ? $e444d6404c095fa5$var$ct : $e444d6404c095fa5$var$E(t, "CrMo") || $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$dt) ? $e444d6404c095fa5$var$dt : $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$tt) && $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$ot) ? $e444d6404c095fa5$var$$t : $e444d6404c095fa5$var$E(t, "FxiOS") ? $e444d6404c095fa5$var$wt : $e444d6404c095fa5$var$E(t.toLowerCase(), $e444d6404c095fa5$var$Mt.toLowerCase()) ? $e444d6404c095fa5$var$Mt : $e444d6404c095fa5$var$Vt(t, i) ? $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$Q) ? $e444d6404c095fa5$var$kt : $e444d6404c095fa5$var$ot : $e444d6404c095fa5$var$E(t, $e444d6404c095fa5$var$yt) ? $e444d6404c095fa5$var$yt : $e444d6404c095fa5$var$E(t, "MSIE") || $e444d6404c095fa5$var$E(t, "Trident/") ? $e444d6404c095fa5$var$ft : $e444d6404c095fa5$var$E(t, "Gecko") ? $e444d6404c095fa5$var$yt : "";
}, $e444d6404c095fa5$var$Gt = {
    [$e444d6404c095fa5$var$pt]: [
        new RegExp("rv:" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$bt]: [
        new RegExp($e444d6404c095fa5$var$mt + "?\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$dt]: [
        new RegExp("(" + $e444d6404c095fa5$var$dt + "|CrMo)\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$ct]: [
        new RegExp("CriOS\\/" + $e444d6404c095fa5$var$At)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$ot]: [
        $e444d6404c095fa5$var$Dt
    ],
    [$e444d6404c095fa5$var$kt]: [
        $e444d6404c095fa5$var$Dt
    ],
    [$e444d6404c095fa5$var$_t]: [
        new RegExp("(Opera|OPR)\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$yt]: [
        new RegExp($e444d6404c095fa5$var$yt + "\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$wt]: [
        new RegExp("FxiOS\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$Mt]: [
        new RegExp("Konqueror[:/]?" + $e444d6404c095fa5$var$At, "i")
    ],
    [$e444d6404c095fa5$var$at]: [
        new RegExp($e444d6404c095fa5$var$at + " " + $e444d6404c095fa5$var$At),
        $e444d6404c095fa5$var$Dt
    ],
    [$e444d6404c095fa5$var$$t]: [
        new RegExp("android\\s" + $e444d6404c095fa5$var$At, "i")
    ],
    [$e444d6404c095fa5$var$ht]: [
        new RegExp($e444d6404c095fa5$var$ut + "\\/" + $e444d6404c095fa5$var$At)
    ],
    [$e444d6404c095fa5$var$ft]: [
        new RegExp("(rv:|MSIE )" + $e444d6404c095fa5$var$At)
    ],
    Mozilla: [
        new RegExp("rv:" + $e444d6404c095fa5$var$At)
    ]
}, $e444d6404c095fa5$var$Yt = function(t, i) {
    var e = $e444d6404c095fa5$var$Wt(t, i), r = $e444d6404c095fa5$var$Gt[e];
    if ($e444d6404c095fa5$var$M(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $e444d6404c095fa5$var$Jt = [
    [
        new RegExp($e444d6404c095fa5$var$xt + "; " + $e444d6404c095fa5$var$xt + " (.*?)[);]", "i"),
        (t)=>[
                $e444d6404c095fa5$var$xt,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Et, "i"),
        [
            $e444d6404c095fa5$var$Et,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$St, "i"),
        [
            $e444d6404c095fa5$var$St,
            ""
        ]
    ],
    [
        $e444d6404c095fa5$var$Ut,
        [
            $e444d6404c095fa5$var$at,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Pt, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $e444d6404c095fa5$var$Tt,
                ""
            ];
            if (new RegExp($e444d6404c095fa5$var$Q).test(i) && !/IEMobile\b/.test(i)) return [
                $e444d6404c095fa5$var$Pt + " " + $e444d6404c095fa5$var$Q,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $e444d6404c095fa5$var$zt[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $e444d6404c095fa5$var$Pt,
                    s
                ];
            }
            return [
                $e444d6404c095fa5$var$Pt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$Z,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$Z,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $e444d6404c095fa5$var$M(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $e444d6404c095fa5$var$tt + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e444d6404c095fa5$var$tt + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$tt,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$tt,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $e444d6404c095fa5$var$vt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $e444d6404c095fa5$var$Kt = function(t) {
    return $e444d6404c095fa5$var$Nt.test(t) ? $e444d6404c095fa5$var$Et : $e444d6404c095fa5$var$jt.test(t) ? $e444d6404c095fa5$var$St : $e444d6404c095fa5$var$Lt.test(t) ? $e444d6404c095fa5$var$xt : new RegExp($e444d6404c095fa5$var$It, "i").test(t) ? $e444d6404c095fa5$var$It : new RegExp("(" + $e444d6404c095fa5$var$Tt + "|WPDesktop)", "i").test(t) ? $e444d6404c095fa5$var$Tt : /iPad/.test(t) ? $e444d6404c095fa5$var$rt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $e444d6404c095fa5$var$nt : $e444d6404c095fa5$var$Ut.test(t) ? $e444d6404c095fa5$var$at : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($e444d6404c095fa5$var$Rt, "i").test(t) ? $e444d6404c095fa5$var$Rt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($e444d6404c095fa5$var$Q).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $e444d6404c095fa5$var$tt : $e444d6404c095fa5$var$et : new RegExp("(pda|" + $e444d6404c095fa5$var$Q + ")", "i").test(t) ? $e444d6404c095fa5$var$Ot : new RegExp($e444d6404c095fa5$var$it, "i").test(t) && !new RegExp($e444d6404c095fa5$var$it + " pc", "i").test(t) ? $e444d6404c095fa5$var$Ft : "";
}, $e444d6404c095fa5$var$Xt = (t)=>t instanceof Error;
function $e444d6404c095fa5$var$Qt(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return $e444d6404c095fa5$var$qt && e.length === $e444d6404c095fa5$var$Bt || ($e444d6404c095fa5$var$Bt = e.length, $e444d6404c095fa5$var$qt = e.reduce((e, r)=>{
            $e444d6404c095fa5$var$Ht || ($e444d6404c095fa5$var$Ht = {});
            var s = $e444d6404c095fa5$var$Ht[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, $e444d6404c095fa5$var$Ht[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), $e444d6404c095fa5$var$qt;
    }
}
class $e444d6404c095fa5$var$Zt {
    constructor(t, i, e){
        void 0 === e && (e = []), this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(i), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $e444d6404c095fa5$var$_(function*() {
            for (var e of t)e.stacktrace && e.stacktrace.frames && $e444d6404c095fa5$var$I(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? i.skipFirstLines : 0), i.chunkIdMap)), $e444d6404c095fa5$var$g({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $e444d6404c095fa5$var$_(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $e444d6404c095fa5$var$g({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var i;
        return {
            chunkIdMap: $e444d6404c095fa5$var$Qt(this.stackParser),
            skipFirstLines: null !== (i = t.skipFirstLines) && void 0 !== i ? i : 1
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return $e444d6404c095fa5$var$g({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
var $e444d6404c095fa5$var$ti = "?";
function $e444d6404c095fa5$var$ii(t, i, e, r, s) {
    var n = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? $e444d6404c095fa5$var$ti : e,
        in_app: !0
    };
    return $e444d6404c095fa5$var$M(r) || (n.lineno = r), $e444d6404c095fa5$var$M(s) || (n.colno = s), n;
}
var $e444d6404c095fa5$var$ei = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $e444d6404c095fa5$var$ti,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, $e444d6404c095fa5$var$ri = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $e444d6404c095fa5$var$si = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $e444d6404c095fa5$var$ni = /\((\S*)(?::(\d+))(?::(\d+))\)/, $e444d6404c095fa5$var$oi = (t, i)=>{
    var e = $e444d6404c095fa5$var$ri.exec(t);
    if (e) {
        var [, r, s, n] = e;
        return $e444d6404c095fa5$var$ii(i, r, $e444d6404c095fa5$var$ti, +s, +n);
    }
    var o = $e444d6404c095fa5$var$si.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = $e444d6404c095fa5$var$ni.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = $e444d6404c095fa5$var$ei(o[1] || $e444d6404c095fa5$var$ti, o[2]);
        return $e444d6404c095fa5$var$ii(i, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, $e444d6404c095fa5$var$ai = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $e444d6404c095fa5$var$li = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $e444d6404c095fa5$var$ui = (t, i)=>{
    var e = $e444d6404c095fa5$var$ai.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            var r = $e444d6404c095fa5$var$li.exec(e[3]);
            r && (e[1] = e[1] || "eval", e[3] = r[1], e[4] = r[2], e[5] = "");
        }
        var s = e[3], n = e[1] || $e444d6404c095fa5$var$ti;
        return [n, s] = $e444d6404c095fa5$var$ei(n, s), $e444d6404c095fa5$var$ii(i, s, n, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, $e444d6404c095fa5$var$hi = /\(error: (.*)\)/, $e444d6404c095fa5$var$di = 50;
function $e444d6404c095fa5$var$vi() {
    return function(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        return function(i, r) {
            void 0 === r && (r = 0);
            for(var s = [], n = i.split("\n"), o = r; o < n.length; o++){
                var a = n[o];
                if (!(a.length > 1024)) {
                    var l = $e444d6404c095fa5$var$hi.test(a) ? a.replace($e444d6404c095fa5$var$hi, "$1") : a;
                    if (!l.match(/\S*Error: /)) {
                        for (var u of e){
                            var h = u(l, t);
                            if (h) {
                                s.push(h);
                                break;
                            }
                        }
                        if (s.length >= $e444d6404c095fa5$var$di) break;
                    }
                }
            }
            return function(t) {
                if (!t.length) return [];
                var i = Array.from(t);
                return i.reverse(), i.slice(0, $e444d6404c095fa5$var$di).map((t)=>{
                    var e;
                    return $e444d6404c095fa5$var$g({}, t, {
                        filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                        function: t.function || $e444d6404c095fa5$var$ti
                    });
                });
            }(s);
        };
    }("web:javascript", $e444d6404c095fa5$var$oi, $e444d6404c095fa5$var$ui);
}
class $e444d6404c095fa5$var$ci {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = $e444d6404c095fa5$var$A(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return $e444d6404c095fa5$var$V(t, "DOMException");
    }
    isDOMError(t) {
        return $e444d6404c095fa5$var$V(t, "DOMError");
    }
}
class $e444d6404c095fa5$var$fi {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $e444d6404c095fa5$var$pi {
    constructor(){}
    match(t) {
        return $e444d6404c095fa5$var$V(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var $e444d6404c095fa5$var$_i = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $e444d6404c095fa5$var$gi {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match($e444d6404c095fa5$var$_i);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var $e444d6404c095fa5$var$mi = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $e444d6404c095fa5$var$bi(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class $e444d6404c095fa5$var$yi {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $e444d6404c095fa5$var$W(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + $e444d6404c095fa5$var$bi(t);
    }
    isSeverityLevel(t) {
        return $e444d6404c095fa5$var$A(t) && !$e444d6404c095fa5$var$D(t) && $e444d6404c095fa5$var$mi.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if ($e444d6404c095fa5$var$Xt(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $e444d6404c095fa5$var$wi {
    match(t) {
        return $e444d6404c095fa5$var$W(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $e444d6404c095fa5$var$bi(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$Ei {
    match(t) {
        return $e444d6404c095fa5$var$q(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$Si {
    match(t) {
        return $e444d6404c095fa5$var$V(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$e444d6404c095fa5$var$W(t)) return !1;
        try {
            var i = t.detail;
            return null != i && "object" == typeof i && "reason" in i;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return $e444d6404c095fa5$var$q(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $e444d6404c095fa5$var$xi = function(i, e) {
    var { debugEnabled: r } = void 0 === e ? {} : e, s = {
        k: function(e) {
            if ($e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$f.DEBUG || $e444d6404c095fa5$var$v.POSTHOG_DEBUG || r) && !$e444d6404c095fa5$var$M($e444d6404c095fa5$var$t.console) && $e444d6404c095fa5$var$t.console) {
                for(var s = ("__rrweb_original__" in $e444d6404c095fa5$var$t.console[e]) ? $e444d6404c095fa5$var$t.console[e].__rrweb_original__ : $e444d6404c095fa5$var$t.console[e], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)o[a - 1] = arguments[a];
                s(i, ...o);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, e)=>$e444d6404c095fa5$var$xi(i + " " + t, e)
    };
    return s;
}, $e444d6404c095fa5$var$$i = $e444d6404c095fa5$var$xi("[PostHog.js]"), $e444d6404c095fa5$var$ki = $e444d6404c095fa5$var$$i.createLogger, $e444d6404c095fa5$var$Pi = $e444d6404c095fa5$var$ki("[ExternalScriptsLoader]"), $e444d6404c095fa5$var$Ti = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $e444d6404c095fa5$var$Pi.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!$e444d6404c095fa5$var$o) return e("document not found");
        var r = $e444d6404c095fa5$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $e444d6404c095fa5$var$o.head.appendChild(r);
        else {
            var s, n = $e444d6404c095fa5$var$o.querySelectorAll("body > script");
            if (n.length > 0) null == (s = n[0].parentNode) || s.insertBefore(r, n[0]);
            else $e444d6404c095fa5$var$o.body.appendChild(r);
        }
    };
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.body ? l() : null == $e444d6404c095fa5$var$o || $e444d6404c095fa5$var$o.addEventListener("DOMContentLoaded", l);
};
$e444d6404c095fa5$var$v.__PosthogExtensions__ = $e444d6404c095fa5$var$v.__PosthogExtensions__ || {}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $e444d6404c095fa5$var$Ti(t, n, e);
}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $e444d6404c095fa5$var$Ti(t, r, e);
};
var $e444d6404c095fa5$var$Ri = {};
function $e444d6404c095fa5$var$Ii(t, i, e) {
    if ($e444d6404c095fa5$var$I(t)) {
        if ($e444d6404c095fa5$var$r && t.forEach === $e444d6404c095fa5$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $e444d6404c095fa5$var$Ri) return;
        }
    }
}
function $e444d6404c095fa5$var$Ci(t, i, e) {
    if (!$e444d6404c095fa5$var$j(t)) {
        if ($e444d6404c095fa5$var$I(t)) return $e444d6404c095fa5$var$Ii(t, i, e);
        if ($e444d6404c095fa5$var$H(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $e444d6404c095fa5$var$Ri) return;
        } else for(var s in t)if ($e444d6404c095fa5$var$T.call(t, s) && i.call(e, t[s], s) === $e444d6404c095fa5$var$Ri) return;
    }
}
var $e444d6404c095fa5$var$Oi = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Ii(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $e444d6404c095fa5$var$Fi = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Ii(e, function(i) {
        $e444d6404c095fa5$var$Ii(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $e444d6404c095fa5$var$Mi(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $e444d6404c095fa5$var$Ai = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $e444d6404c095fa5$var$Di = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $e444d6404c095fa5$var$$i.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $e444d6404c095fa5$var$$i.critical(t);
        }
    };
}, $e444d6404c095fa5$var$Li = function(t) {
    var i = {};
    return $e444d6404c095fa5$var$Ci(t, function(t, e) {
        ($e444d6404c095fa5$var$A(t) && t.length > 0 || $e444d6404c095fa5$var$N(t)) && (i[e] = t);
    }), i;
};
function $e444d6404c095fa5$var$ji(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$e444d6404c095fa5$var$A(t) && !$e444d6404c095fa5$var$L(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $e444d6404c095fa5$var$I(i) ? (n = [], $e444d6404c095fa5$var$Ii(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $e444d6404c095fa5$var$Ci(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $e444d6404c095fa5$var$Ni = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $e444d6404c095fa5$var$Ui(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$e444d6404c095fa5$var$A(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $e444d6404c095fa5$var$Ni)if (e === r) return !1;
    return !0;
}
function $e444d6404c095fa5$var$zi(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $e444d6404c095fa5$var$Hi(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
function $e444d6404c095fa5$var$Bi(t) {
    return "ph_toolbar_internal" === t.name;
}
var $e444d6404c095fa5$var$qi = "$people_distinct_id", $e444d6404c095fa5$var$Vi = "__alias", $e444d6404c095fa5$var$Wi = "__timers", $e444d6404c095fa5$var$Gi = "$autocapture_disabled_server_side", $e444d6404c095fa5$var$Yi = "$heatmaps_enabled_server_side", $e444d6404c095fa5$var$Ji = "$exception_capture_enabled_server_side", $e444d6404c095fa5$var$Ki = "$error_tracking_suppression_rules", $e444d6404c095fa5$var$Xi = "$error_tracking_capture_extension_exceptions", $e444d6404c095fa5$var$Qi = "$web_vitals_enabled_server_side", $e444d6404c095fa5$var$Zi = "$dead_clicks_enabled_server_side", $e444d6404c095fa5$var$te = "$product_tours_enabled_server_side", $e444d6404c095fa5$var$ie = "$web_vitals_allowed_metrics", $e444d6404c095fa5$var$ee = "$session_recording_remote_config", $e444d6404c095fa5$var$re = "$sesid", $e444d6404c095fa5$var$se = "$session_is_sampled", $e444d6404c095fa5$var$ne = "$enabled_feature_flags", $e444d6404c095fa5$var$oe = "$early_access_features", $e444d6404c095fa5$var$ae = "$feature_flag_details", $e444d6404c095fa5$var$le = "$stored_person_properties", $e444d6404c095fa5$var$ue = "$stored_group_properties", $e444d6404c095fa5$var$he = "$surveys", $e444d6404c095fa5$var$de = "$flag_call_reported", $e444d6404c095fa5$var$ve = "$flag_call_reported_session_id", $e444d6404c095fa5$var$ce = "$feature_flag_errors", $e444d6404c095fa5$var$fe = "$feature_flag_evaluated_at", $e444d6404c095fa5$var$pe = "$user_state", $e444d6404c095fa5$var$_e = "$client_session_props", $e444d6404c095fa5$var$ge = "$capture_rate_limit", $e444d6404c095fa5$var$me = "$initial_campaign_params", $e444d6404c095fa5$var$be = "$initial_referrer_info", $e444d6404c095fa5$var$ye = "$initial_person_info", $e444d6404c095fa5$var$we = "$epp", $e444d6404c095fa5$var$Ee = "__POSTHOG_TOOLBAR__", $e444d6404c095fa5$var$Se = "$posthog_cookieless", $e444d6404c095fa5$var$xe = [
    $e444d6404c095fa5$var$qi,
    $e444d6404c095fa5$var$Vi,
    "__cmpns",
    $e444d6404c095fa5$var$Wi,
    "$session_recording_enabled_server_side",
    $e444d6404c095fa5$var$Yi,
    $e444d6404c095fa5$var$re,
    $e444d6404c095fa5$var$ne,
    $e444d6404c095fa5$var$Ki,
    $e444d6404c095fa5$var$pe,
    $e444d6404c095fa5$var$oe,
    $e444d6404c095fa5$var$ae,
    $e444d6404c095fa5$var$ue,
    $e444d6404c095fa5$var$le,
    $e444d6404c095fa5$var$he,
    $e444d6404c095fa5$var$de,
    $e444d6404c095fa5$var$ve,
    $e444d6404c095fa5$var$ce,
    $e444d6404c095fa5$var$fe,
    $e444d6404c095fa5$var$_e,
    $e444d6404c095fa5$var$ge,
    $e444d6404c095fa5$var$me,
    $e444d6404c095fa5$var$be,
    $e444d6404c095fa5$var$we,
    $e444d6404c095fa5$var$ye
];
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $e444d6404c095fa5$var$N(t) && isFinite(t) && Math.floor(t) === t;
});
var $e444d6404c095fa5$var$$e = "0123456789abcdef";
class $e444d6404c095fa5$var$ke {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $e444d6404c095fa5$var$ke(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $e444d6404c095fa5$var$$e.charAt(this.bytes[i] >>> 4) + $e444d6404c095fa5$var$$e.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $e444d6404c095fa5$var$ke(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $e444d6404c095fa5$var$Pe {
    constructor(){
        this.P = 0, this.T = 0, this.R = new $e444d6404c095fa5$var$Ie;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($e444d6404c095fa5$var$M(t)) {
            this.P = 0;
            var i = this.generateOrAbort();
            if ($e444d6404c095fa5$var$M(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.P) this.P = t, this.I();
        else {
            if (!(t + 1e4 > this.P)) return;
            this.T++, this.T > 4398046511103 && (this.P++, this.I());
        }
        return $e444d6404c095fa5$var$ke.fromFieldsV7(this.P, Math.trunc(this.T / Math.pow(2, 30)), this.T & Math.pow(2, 30) - 1, this.R.nextUint32());
    }
    I() {
        this.T = 1024 * this.R.nextUint32() + (1023 & this.R.nextUint32());
    }
}
var $e444d6404c095fa5$var$Te, $e444d6404c095fa5$var$Re = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$M($e444d6404c095fa5$var$t.crypto) && crypto.getRandomValues && ($e444d6404c095fa5$var$Re = (t)=>crypto.getRandomValues(t));
class $e444d6404c095fa5$var$Ie {
    constructor(){
        this.C = new Uint32Array(8), this.O = 1 / 0;
    }
    nextUint32() {
        return this.O >= this.C.length && ($e444d6404c095fa5$var$Re(this.C), this.O = 0), this.C[this.O++];
    }
}
var $e444d6404c095fa5$var$Ce = ()=>$e444d6404c095fa5$var$Oe().toString(), $e444d6404c095fa5$var$Oe = ()=>($e444d6404c095fa5$var$Te || ($e444d6404c095fa5$var$Te = new $e444d6404c095fa5$var$Pe)).generate(), $e444d6404c095fa5$var$Fe = "";
var $e444d6404c095fa5$var$Me = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $e444d6404c095fa5$var$Ae(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $e444d6404c095fa5$var$o), $e444d6404c095fa5$var$Fe) return $e444d6404c095fa5$var$Fe;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $e444d6404c095fa5$var$Ce(); !$e444d6404c095fa5$var$Fe && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $e444d6404c095fa5$var$Fe = n);
            }
            return $e444d6404c095fa5$var$Fe;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($e444d6404c095fa5$var$Me);
                return i ? i[0] : "";
            })(t);
            r !== e && $e444d6404c095fa5$var$$i.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $e444d6404c095fa5$var$De = {
    F: ()=>!!$e444d6404c095fa5$var$o,
    M: function(t) {
        $e444d6404c095fa5$var$$i.error("cookieStore error: " + t);
    },
    A: function(t) {
        if ($e444d6404c095fa5$var$o) {
            try {
                for(var i = t + "=", e = $e444d6404c095fa5$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    D: function(t) {
        var i;
        try {
            i = JSON.parse($e444d6404c095fa5$var$De.A(t)) || {};
        } catch (t) {}
        return i;
    },
    L: function(t, i, e, r, s) {
        if ($e444d6404c095fa5$var$o) try {
            var n = "", a = "", l = $e444d6404c095fa5$var$Ae($e444d6404c095fa5$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $e444d6404c095fa5$var$$i.warn("cookieStore warning: large cookie, len=" + h.length), $e444d6404c095fa5$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    j: function(t, i) {
        if (null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.cookie) try {
            $e444d6404c095fa5$var$De.L(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $e444d6404c095fa5$var$Le = null, $e444d6404c095fa5$var$je = {
    F: function() {
        if (!$e444d6404c095fa5$var$L($e444d6404c095fa5$var$Le)) return $e444d6404c095fa5$var$Le;
        var i = !0;
        if ($e444d6404c095fa5$var$M($e444d6404c095fa5$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $e444d6404c095fa5$var$je.L(e, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$je.A(e) && (i = !1), $e444d6404c095fa5$var$je.j(e);
        } catch (t) {
            i = !1;
        }
        return i || $e444d6404c095fa5$var$$i.error("localStorage unsupported; falling back to cookie store"), $e444d6404c095fa5$var$Le = i, i;
    },
    M: function(t) {
        $e444d6404c095fa5$var$$i.error("localStorage error: " + t);
    },
    A: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$je.M(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$je.A(t)) || {};
        } catch (t) {}
        return null;
    },
    L: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$je.M(t);
        }
    },
    j: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$je.M(t);
        }
    }
}, $e444d6404c095fa5$var$Ne = [
    "$device_id",
    "distinct_id",
    $e444d6404c095fa5$var$re,
    $e444d6404c095fa5$var$se,
    $e444d6404c095fa5$var$we,
    $e444d6404c095fa5$var$ye,
    $e444d6404c095fa5$var$pe
], $e444d6404c095fa5$var$Ue = {}, $e444d6404c095fa5$var$ze = {
    F: function() {
        return !0;
    },
    M: function(t) {
        $e444d6404c095fa5$var$$i.error("memoryStorage error: " + t);
    },
    A: function(t) {
        return $e444d6404c095fa5$var$Ue[t] || null;
    },
    D: function(t) {
        return $e444d6404c095fa5$var$Ue[t] || null;
    },
    L: function(t, i) {
        $e444d6404c095fa5$var$Ue[t] = i;
    },
    j: function(t) {
        delete $e444d6404c095fa5$var$Ue[t];
    }
}, $e444d6404c095fa5$var$He = null, $e444d6404c095fa5$var$Be = {
    F: function() {
        if (!$e444d6404c095fa5$var$L($e444d6404c095fa5$var$He)) return $e444d6404c095fa5$var$He;
        if ($e444d6404c095fa5$var$He = !0, $e444d6404c095fa5$var$M($e444d6404c095fa5$var$t)) $e444d6404c095fa5$var$He = !1;
        else try {
            var i = "__support__";
            $e444d6404c095fa5$var$Be.L(i, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$Be.A(i) && ($e444d6404c095fa5$var$He = !1), $e444d6404c095fa5$var$Be.j(i);
        } catch (t) {
            $e444d6404c095fa5$var$He = !1;
        }
        return $e444d6404c095fa5$var$He;
    },
    M: function(t) {
        $e444d6404c095fa5$var$$i.error("sessionStorage error: ", t);
    },
    A: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Be.M(t);
        }
        return null;
    },
    D: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$Be.A(t)) || null;
        } catch (t) {}
        return null;
    },
    L: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$Be.M(t);
        }
    },
    j: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Be.M(t);
        }
    }
}, $e444d6404c095fa5$var$qe = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $e444d6404c095fa5$var$Ve {
    constructor(t){
        this._instance = t;
    }
    get N() {
        return this._instance.config;
    }
    get consent() {
        return this.U() ? $e444d6404c095fa5$var$qe.DENIED : this.H;
    }
    isOptedOut() {
        return "always" === this.N.cookieless_mode || this.consent === $e444d6404c095fa5$var$qe.DENIED || this.consent === $e444d6404c095fa5$var$qe.PENDING && (this.N.opt_out_capturing_by_default || "on_reject" === this.N.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === $e444d6404c095fa5$var$qe.DENIED;
    }
    optInOut(t) {
        this.B.L(this.q, t ? 1 : 0, this.N.cookie_expiration, this.N.cross_subdomain_cookie, this.N.secure_cookie);
    }
    reset() {
        this.B.j(this.q, this.N.cross_subdomain_cookie);
    }
    get q() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get H() {
        var t = this.B.A(this.q);
        return $e444d6404c095fa5$var$Y(t) ? $e444d6404c095fa5$var$qe.GRANTED : $e444d6404c095fa5$var$E($e444d6404c095fa5$var$J, t) ? $e444d6404c095fa5$var$qe.DENIED : $e444d6404c095fa5$var$qe.PENDING;
    }
    get B() {
        if (!this.V) {
            var t = this.N.opt_out_capturing_persistence_type;
            this.V = "localStorage" === t ? $e444d6404c095fa5$var$je : $e444d6404c095fa5$var$De;
            var i = "localStorage" === t ? $e444d6404c095fa5$var$De : $e444d6404c095fa5$var$je;
            i.A(this.q) && (this.V.A(this.q) || this.optInOut($e444d6404c095fa5$var$Y(i.A(this.q))), i.j(this.q, this.N.cross_subdomain_cookie));
        }
        return this.V;
    }
    U() {
        return !!this.N.respect_dnt && !!$e444d6404c095fa5$var$zi([
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.doNotTrack,
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.msDoNotTrack,
            $e444d6404c095fa5$var$v.doNotTrack
        ], (t)=>$e444d6404c095fa5$var$Y(t));
    }
}
var $e444d6404c095fa5$var$We = $e444d6404c095fa5$var$ki("[Dead Clicks]"), $e444d6404c095fa5$var$Ge = ()=>!0, $e444d6404c095fa5$var$Ye = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($e444d6404c095fa5$var$Zi)), r = t.instance.config.capture_dead_clicks;
    return $e444d6404c095fa5$var$z(r) ? r : !!$e444d6404c095fa5$var$O(r) || e;
};
class $e444d6404c095fa5$var$Je {
    get lazyLoadedDeadClicksAutocapture() {
        return this.W;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        "captureDeadClicks" in t && (this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Zi]: t.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.G(()=>{
            this.Y();
        }) : this.stop();
    }
    G(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $e444d6404c095fa5$var$We.error("failed to load script", i) : t();
        });
    }
    Y() {
        var t;
        if ($e444d6404c095fa5$var$o) {
            if (!this.W && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $e444d6404c095fa5$var$O(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.W = $e444d6404c095fa5$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.W.start($e444d6404c095fa5$var$o), $e444d6404c095fa5$var$We.info("starting...");
            }
        } else $e444d6404c095fa5$var$We.error("`document` not found. Cannot start.");
    }
    stop() {
        this.W && (this.W.stop(), this.W = void 0, $e444d6404c095fa5$var$We.info("stopping..."));
    }
}
var $e444d6404c095fa5$var$Ke = $e444d6404c095fa5$var$ki("[SegmentIntegration]");
function $e444d6404c095fa5$var$Xe(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $e444d6404c095fa5$var$Ce();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($e444d6404c095fa5$var$pe, "identified")), i();
        }, s = e.user();
        "then" in s && $e444d6404c095fa5$var$C(s.then) ? s.then(r) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $e444d6404c095fa5$var$Ke.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($e444d6404c095fa5$var$Ke.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($e444d6404c095fa5$var$Ke.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $e444d6404c095fa5$var$Qe = "posthog-js";
function $e444d6404c095fa5$var$Ze(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c, f = (null == (a = i.exception) ? void 0 : a.values) || [], p = f.map((t)=>$e444d6404c095fa5$var$g({}, t, {
                stacktrace: t.stacktrace ? $e444d6404c095fa5$var$g({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$e444d6404c095fa5$var$g({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), _ = {
            $exception_message: (null == (l = f[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = f[0]) ? void 0 : u.type,
            $exception_level: i.level,
            $exception_list: p,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = f[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = f[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        (e && r && (_.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o) && (null == (c = t.exceptions) || c.sendExceptionEvent(_));
        return i;
    };
}
class $e444d6404c095fa5$var$tr {
    constructor(t, i, e, r, s, n){
        this.name = $e444d6404c095fa5$var$Qe, this.setupOnce = function(o) {
            o($e444d6404c095fa5$var$Ze(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
class $e444d6404c095fa5$var$ir {
    constructor(t){
        this.J = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength) && ($e444d6404c095fa5$var$$i.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.K = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.X();
    }
    X() {
        var t;
        this.Z = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.J);
    }
    destroy() {
        var t;
        null == (t = this.Z) || t.call(this), this.Z = void 0;
    }
    doPageView(i, e) {
        var r, s = this.tt(i, e);
        return this.K = {
            pathname: null !== (r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.tt(t, null == (i = this.K) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.K) ? void 0 : t.pageViewId
        };
    }
    tt(t, i) {
        var e = this.K;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($e444d6404c095fa5$var$M(n) || $e444d6404c095fa5$var$M(o) || $e444d6404c095fa5$var$M(a) || $e444d6404c095fa5$var$M(l) || $e444d6404c095fa5$var$M(u) || $e444d6404c095fa5$var$M(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $e444d6404c095fa5$var$K(o / n, 0, 1, $e444d6404c095fa5$var$$i), v = n <= 1 ? 1 : $e444d6404c095fa5$var$K(a / n, 0, 1, $e444d6404c095fa5$var$$i), c = l <= 1 ? 1 : $e444d6404c095fa5$var$K(u / l, 0, 1, $e444d6404c095fa5$var$$i), f = l <= 1 ? 1 : $e444d6404c095fa5$var$K(h / l, 0, 1, $e444d6404c095fa5$var$$i);
                r = $e444d6404c095fa5$var$Oi(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $e444d6404c095fa5$var$er = (t)=>{
    var i = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.createElement("a");
    return $e444d6404c095fa5$var$M(i) ? null : (i.href = t, i);
}, $e444d6404c095fa5$var$rr = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $e444d6404c095fa5$var$Ci(t, function(t, i) {
        $e444d6404c095fa5$var$M(t) || $e444d6404c095fa5$var$M(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $e444d6404c095fa5$var$sr = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$e444d6404c095fa5$var$I(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $e444d6404c095fa5$var$$i.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $e444d6404c095fa5$var$nr = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $e444d6404c095fa5$var$I(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $e444d6404c095fa5$var$or = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $e444d6404c095fa5$var$ar = "https?://(.*)", $e444d6404c095fa5$var$lr = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $e444d6404c095fa5$var$ur = $e444d6404c095fa5$var$Fi([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $e444d6404c095fa5$var$lr), $e444d6404c095fa5$var$hr = "<masked>", $e444d6404c095fa5$var$dr = [
    "li_fat_id"
];
function $e444d6404c095fa5$var$vr(t, i, e) {
    if (!$e444d6404c095fa5$var$o) return {};
    var r, s = i ? $e444d6404c095fa5$var$Fi([], $e444d6404c095fa5$var$lr, e || []) : [], n = $e444d6404c095fa5$var$cr($e444d6404c095fa5$var$nr($e444d6404c095fa5$var$o.URL, s, $e444d6404c095fa5$var$hr), t), a = (r = {}, $e444d6404c095fa5$var$Ci($e444d6404c095fa5$var$dr, function(t) {
        var i = $e444d6404c095fa5$var$De.A(t);
        r[t] = i || null;
    }), r);
    return $e444d6404c095fa5$var$Oi(a, n);
}
function $e444d6404c095fa5$var$cr(t, i) {
    var e = $e444d6404c095fa5$var$ur.concat(i || []), r = {};
    return $e444d6404c095fa5$var$Ci(e, function(i) {
        var e = $e444d6404c095fa5$var$sr(t, i);
        r[i] = e || null;
    }), r;
}
function $e444d6404c095fa5$var$fr(t) {
    var i = function(t) {
        return t ? 0 === t.search($e444d6404c095fa5$var$ar + "google.([^/?]*)") ? "google" : 0 === t.search($e444d6404c095fa5$var$ar + "bing.com") ? "bing" : 0 === t.search($e444d6404c095fa5$var$ar + "yahoo.com") ? "yahoo" : 0 === t.search($e444d6404c095fa5$var$ar + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$e444d6404c095fa5$var$L(i)) {
        r.$search_engine = i;
        var s = $e444d6404c095fa5$var$o ? $e444d6404c095fa5$var$sr($e444d6404c095fa5$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $e444d6404c095fa5$var$pr() {
    return navigator.language || navigator.userLanguage;
}
function $e444d6404c095fa5$var$_r() {
    return (null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) || "$direct";
}
function $e444d6404c095fa5$var$gr(t, i) {
    var e = t ? $e444d6404c095fa5$var$Fi([], $e444d6404c095fa5$var$lr, i || []) : [], r = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href.substring(0, 1e3);
    return {
        r: $e444d6404c095fa5$var$_r().substring(0, 1e3),
        u: r ? $e444d6404c095fa5$var$nr(r, e, $e444d6404c095fa5$var$hr) : void 0
    };
}
function $e444d6404c095fa5$var$mr(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $e444d6404c095fa5$var$er(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $e444d6404c095fa5$var$er(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $e444d6404c095fa5$var$cr(r);
        $e444d6404c095fa5$var$Oi(s, o);
    }
    if (e) {
        var a = $e444d6404c095fa5$var$fr(e);
        $e444d6404c095fa5$var$Oi(s, a);
    }
    return s;
}
function $e444d6404c095fa5$var$br() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$yr() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$wr(i, e) {
    var r, s, n, o;
    if (!$e444d6404c095fa5$var$d) return {};
    var l, u, h, v, c, p, _, g, m = i ? $e444d6404c095fa5$var$Fi([], $e444d6404c095fa5$var$lr, e || []) : [], [b, y] = function(t) {
        for(var i = 0; i < $e444d6404c095fa5$var$Jt.length; i++){
            var [e, r] = $e444d6404c095fa5$var$Jt[i], s = e.exec(t), n = s && ($e444d6404c095fa5$var$C(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($e444d6404c095fa5$var$d);
    return $e444d6404c095fa5$var$Oi($e444d6404c095fa5$var$Li({
        $os: b,
        $os_version: y,
        $browser: $e444d6404c095fa5$var$Wt($e444d6404c095fa5$var$d, navigator.vendor),
        $device: $e444d6404c095fa5$var$Kt($e444d6404c095fa5$var$d),
        $device_type: (u = $e444d6404c095fa5$var$d, h = {
            userAgentDataPlatform: null == (r = navigator) || null == (r = r.userAgentData) ? void 0 : r.platform,
            maxTouchPoints: null == (s = navigator) ? void 0 : s.maxTouchPoints,
            screenWidth: null == $e444d6404c095fa5$var$t || null == (n = $e444d6404c095fa5$var$t.screen) ? void 0 : n.width,
            screenHeight: null == $e444d6404c095fa5$var$t || null == (o = $e444d6404c095fa5$var$t.screen) ? void 0 : o.height,
            devicePixelRatio: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.devicePixelRatio
        }, g = $e444d6404c095fa5$var$Kt(u), g === $e444d6404c095fa5$var$rt || g === $e444d6404c095fa5$var$et || "Kobo" === g || "Kindle Fire" === g || g === $e444d6404c095fa5$var$Ft ? $e444d6404c095fa5$var$it : g === $e444d6404c095fa5$var$Et || g === $e444d6404c095fa5$var$xt || g === $e444d6404c095fa5$var$St || g === $e444d6404c095fa5$var$It ? "Console" : g === $e444d6404c095fa5$var$nt ? "Wearable" : g ? $e444d6404c095fa5$var$Q : "Android" === (null == h ? void 0 : h.userAgentDataPlatform) && (null !== (v = null == h ? void 0 : h.maxTouchPoints) && void 0 !== v ? v : 0) > 0 ? Math.min(null !== (c = null == h ? void 0 : h.screenWidth) && void 0 !== c ? c : 0, null !== (p = null == h ? void 0 : h.screenHeight) && void 0 !== p ? p : 0) / (null !== (_ = null == h ? void 0 : h.devicePixelRatio) && void 0 !== _ ? _ : 1) >= 600 ? $e444d6404c095fa5$var$it : $e444d6404c095fa5$var$Q : "Desktop"),
        $timezone: $e444d6404c095fa5$var$br(),
        $timezone_offset: $e444d6404c095fa5$var$yr()
    }), {
        $current_url: $e444d6404c095fa5$var$nr(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href, m, $e444d6404c095fa5$var$hr),
        $host: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.host,
        $pathname: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.pathname,
        $raw_user_agent: $e444d6404c095fa5$var$d.length > 1e3 ? $e444d6404c095fa5$var$d.substring(0, 997) + "..." : $e444d6404c095fa5$var$d,
        $browser_version: $e444d6404c095fa5$var$Yt($e444d6404c095fa5$var$d, navigator.vendor),
        $browser_language: $e444d6404c095fa5$var$pr(),
        $browser_language_prefix: (l = $e444d6404c095fa5$var$pr(), "string" == typeof l ? l.split("-")[0] : void 0),
        $screen_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.height,
        $screen_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.width,
        $viewport_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerHeight,
        $viewport_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerWidth,
        $lib: $e444d6404c095fa5$var$f.LIB_NAME,
        $lib_version: $e444d6404c095fa5$var$f.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $e444d6404c095fa5$var$Er = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $e444d6404c095fa5$var$Sr {
    constructor(t, i){
        this.N = t, this.props = {}, this.it = !1, this.et = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.B = this.rt(t), this.load(), t.debug && $e444d6404c095fa5$var$$i.info("Persistence loaded", t.persistence, $e444d6404c095fa5$var$g({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.st;
    }
    rt(i) {
        -1 === $e444d6404c095fa5$var$Er.indexOf(i.persistence.toLowerCase()) && ($e444d6404c095fa5$var$$i.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        var e = function(i) {
            void 0 === i && (i = []);
            var e = [
                ...$e444d6404c095fa5$var$Ne,
                ...i
            ];
            return $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$je, {
                D: function(t) {
                    try {
                        var i = {};
                        try {
                            i = $e444d6404c095fa5$var$De.D(t) || {};
                        } catch (t) {}
                        var e = $e444d6404c095fa5$var$Oi(i, JSON.parse($e444d6404c095fa5$var$je.A(t) || "{}"));
                        return $e444d6404c095fa5$var$je.L(t, e), e;
                    } catch (t) {}
                    return null;
                },
                L: function(t, i, r, s, n, o) {
                    try {
                        $e444d6404c095fa5$var$je.L(t, i, void 0, void 0, o);
                        var a = {};
                        e.forEach((t)=>{
                            i[t] && (a[t] = i[t]);
                        }), Object.keys(a).length && $e444d6404c095fa5$var$De.L(t, a, r, s, n, o);
                    } catch (t) {
                        $e444d6404c095fa5$var$je.M(t);
                    }
                },
                j: function(i, e) {
                    try {
                        null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i), $e444d6404c095fa5$var$De.j(i, e);
                    } catch (t) {
                        $e444d6404c095fa5$var$je.M(t);
                    }
                }
            });
        }(i.cookie_persisted_properties || []), r = i.persistence.toLowerCase();
        return "localstorage" === r && $e444d6404c095fa5$var$je.F() ? $e444d6404c095fa5$var$je : "localstorage+cookie" === r && e.F() ? e : "sessionstorage" === r && $e444d6404c095fa5$var$Be.F() ? $e444d6404c095fa5$var$Be : "memory" === r ? $e444d6404c095fa5$var$ze : "cookie" === r ? $e444d6404c095fa5$var$De : e.F() ? e : $e444d6404c095fa5$var$De;
    }
    nt(t) {
        var i = null != t ? t : this.N.feature_flag_cache_ttl_ms;
        if (!i || i <= 0) return !1;
        var e = this.props[$e444d6404c095fa5$var$fe];
        return !e || "number" != typeof e || Date.now() - e > i;
    }
    properties() {
        var t = {};
        return $e444d6404c095fa5$var$Ci(this.props, (i, e)=>{
            if (e === $e444d6404c095fa5$var$ne && $e444d6404c095fa5$var$O(i)) {
                if (!this.nt()) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            } else a = e, l = !1, ($e444d6404c095fa5$var$L(o = $e444d6404c095fa5$var$xe) ? l : $e444d6404c095fa5$var$s && o.indexOf === $e444d6404c095fa5$var$s ? -1 != o.indexOf(a) : ($e444d6404c095fa5$var$Ci(o, function(t) {
                if (l || (l = t === a)) return $e444d6404c095fa5$var$Ri;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.st) {
            var t = this.B.D(this.et);
            t && (this.props = $e444d6404c095fa5$var$Oi({}, t));
        }
    }
    save() {
        this.st || this.B.L(this.et, this.props, this.ot, this.ut, this.ht, this.N.debug);
    }
    remove() {
        this.B.j(this.et, !1), this.B.j(this.et, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($e444d6404c095fa5$var$O(t)) {
            $e444d6404c095fa5$var$M(i) && (i = "None"), this.ot = $e444d6404c095fa5$var$M(e) ? this.dt : e;
            var r = !1;
            if ($e444d6404c095fa5$var$Ci(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($e444d6404c095fa5$var$O(t)) {
            this.ot = $e444d6404c095fa5$var$M(i) ? this.dt : i;
            var e = !1;
            if ($e444d6404c095fa5$var$Ci(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.it) {
            var t = $e444d6404c095fa5$var$vr(this.N.custom_campaign_params, this.N.mask_personal_data_properties, this.N.custom_personal_data_properties);
            $e444d6404c095fa5$var$F($e444d6404c095fa5$var$Li(t)) || this.register(t), this.it = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) ? $e444d6404c095fa5$var$fr(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $e444d6404c095fa5$var$_r(),
            $referring_domain: null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.referrer && (null == (t = $e444d6404c095fa5$var$er($e444d6404c095fa5$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$e444d6404c095fa5$var$me] || this.props[$e444d6404c095fa5$var$be] || this.register_once({
            [$e444d6404c095fa5$var$ye]: $e444d6404c095fa5$var$gr(this.N.mask_personal_data_properties, this.N.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $e444d6404c095fa5$var$Ci([
            $e444d6404c095fa5$var$be,
            $e444d6404c095fa5$var$me
        ], (i)=>{
            var e = this.props[i];
            e && $e444d6404c095fa5$var$Ci(e, function(i, e) {
                t["$initial_" + $e444d6404c095fa5$var$x(e)] = i;
            });
        });
        var i, e, r = this.props[$e444d6404c095fa5$var$ye];
        if (r) {
            var s = (i = $e444d6404c095fa5$var$mr(r), e = {}, $e444d6404c095fa5$var$Ci(i, function(t, i) {
                e["$initial_" + $e444d6404c095fa5$var$x(i)] = t;
            }), e);
            $e444d6404c095fa5$var$Oi(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $e444d6404c095fa5$var$Ci(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.dt = this.ot = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence || !((t, i)=>{
            if (t.length !== i.length) return !1;
            var e = [
                ...t
            ].sort(), r = [
                ...i
            ].sort();
            return e.every((t, i)=>t === r[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || [])) {
            var r = this.rt(t), s = this.props;
            this.clear(), this.B = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.st = t, this.st ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.ut && (this.ut = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.ht && (this.ht = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$e444d6404c095fa5$var$Wi] || {};
        e[t] = i, this.props[$e444d6404c095fa5$var$Wi] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$e444d6404c095fa5$var$Wi] || {})[t];
        return $e444d6404c095fa5$var$M(i) || (delete this.props[$e444d6404c095fa5$var$Wi][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var $e444d6404c095fa5$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $e444d6404c095fa5$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $e444d6404c095fa5$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $e444d6404c095fa5$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $e444d6404c095fa5$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $e444d6404c095fa5$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $e444d6404c095fa5$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $e444d6404c095fa5$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $e444d6404c095fa5$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $e444d6404c095fa5$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date"
}, $e444d6404c095fa5$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
}, $e444d6404c095fa5$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $e444d6404c095fa5$export$e5d0052c1e47bfda = function(t) {
    return t.SHOWN = "product tour shown", t.DISMISSED = "product tour dismissed", t.COMPLETED = "product tour completed", t.STEP_SHOWN = "product tour step shown", t.STEP_COMPLETED = "product tour step completed", t.BUTTON_CLICKED = "product tour button clicked", t.STEP_SELECTOR_FAILED = "product tour step selector failed", t.BANNER_CONTAINER_SELECTOR_FAILED = "product tour banner container selector failed", t.BANNER_ACTION_CLICKED = "product tour banner action clicked", t;
}({}), $e444d6404c095fa5$export$eedf6d13bc23d767 = function(t) {
    return t.TOUR_ID = "$product_tour_id", t.TOUR_NAME = "$product_tour_name", t.TOUR_ITERATION = "$product_tour_iteration", t.TOUR_RENDER_REASON = "$product_tour_render_reason", t.TOUR_STEP_ID = "$product_tour_step_id", t.TOUR_STEP_ORDER = "$product_tour_step_order", t.TOUR_STEP_TYPE = "$product_tour_step_type", t.TOUR_DISMISS_REASON = "$product_tour_dismiss_reason", t.TOUR_BUTTON_TEXT = "$product_tour_button_text", t.TOUR_BUTTON_ACTION = "$product_tour_button_action", t.TOUR_BUTTON_LINK = "$product_tour_button_link", t.TOUR_BUTTON_TOUR_ID = "$product_tour_button_tour_id", t.TOUR_STEPS_COUNT = "$product_tour_steps_count", t.TOUR_STEP_SELECTOR = "$product_tour_step_selector", t.TOUR_STEP_SELECTOR_FOUND = "$product_tour_step_selector_found", t.TOUR_STEP_ELEMENT_TAG = "$product_tour_step_element_tag", t.TOUR_STEP_ELEMENT_ID = "$product_tour_step_element_id", t.TOUR_STEP_ELEMENT_CLASSES = "$product_tour_step_element_classes", t.TOUR_STEP_ELEMENT_TEXT = "$product_tour_step_element_text", t.TOUR_ERROR = "$product_tour_error", t.TOUR_MATCHES_COUNT = "$product_tour_matches_count", t.TOUR_FAILURE_PHASE = "$product_tour_failure_phase", t.TOUR_WAITED_FOR_ELEMENT = "$product_tour_waited_for_element", t.TOUR_WAIT_DURATION_MS = "$product_tour_wait_duration_ms", t.TOUR_BANNER_SELECTOR = "$product_tour_banner_selector", t.TOUR_LINKED_SURVEY_ID = "$product_tour_linked_survey_id", t.USE_MANUAL_SELECTOR = "$use_manual_selector", t.INFERENCE_DATA_PRESENT = "$inference_data_present", t.TOUR_LAST_SEEN_DATE = "$product_tour_last_seen_date", t.TOUR_TYPE = "$product_tour_type", t;
}({}), $e444d6404c095fa5$var$jr = $e444d6404c095fa5$var$ki("[RateLimiter]");
class $e444d6404c095fa5$var$Nr {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $e444d6404c095fa5$var$jr.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $e444d6404c095fa5$var$jr.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$ge)) && void 0 !== i ? i : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = a.tokens < 1;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($e444d6404c095fa5$var$ge, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $e444d6404c095fa5$var$Ur = $e444d6404c095fa5$var$ki("[RemoteConfig]");
class $e444d6404c095fa5$var$zr {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    vt(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    ct(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $e444d6404c095fa5$var$Ur.info("Using preloaded remote config", this.remoteConfig), this.ft(this.remoteConfig), void this._t();
            if (this._instance.bt()) return void $e444d6404c095fa5$var$Ur.warn("Remote config is disabled. Falling back to local config.");
            this.vt((t)=>{
                if (!t) return $e444d6404c095fa5$var$Ur.info("No config found after loading remote JS config. Falling back to JSON."), void this.ct((t)=>{
                    this.ft(t), this._t();
                });
                this.ft(t), this._t();
            });
        } catch (t) {
            $e444d6404c095fa5$var$Ur.error("Error loading remote config", t);
        }
    }
    stop() {
        this.yt && (clearInterval(this.yt), this.yt = void 0);
    }
    refresh() {
        this._instance.bt() || "hidden" === (null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.visibilityState) || this._instance.reloadFeatureFlags();
    }
    _t() {
        var t;
        if (!this.yt) {
            var i = null !== (t = this._instance.config.remote_config_refresh_interval_ms) && void 0 !== t ? t : 3e5;
            0 !== i && (this.yt = setInterval(()=>{
                this.refresh();
            }, i));
        }
    }
    ft(t) {
        var i;
        (t || $e444d6404c095fa5$var$Ur.error("Failed to fetch remote config from PostHog."), this._instance.ft(null != t ? t : {}), !1 !== (null == t ? void 0 : t.hasFeatureFlags)) && (this._instance.config.advanced_disable_feature_flags_on_first_load || null == (i = this._instance.featureFlags) || i.ensureFlagsLoaded());
    }
}
var $e444d6404c095fa5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $e444d6404c095fa5$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $e444d6404c095fa5$var$qr = Uint8Array, $e444d6404c095fa5$var$Vr = Uint16Array, $e444d6404c095fa5$var$Wr = Uint32Array, $e444d6404c095fa5$var$Gr = new $e444d6404c095fa5$var$qr([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $e444d6404c095fa5$var$Yr = new $e444d6404c095fa5$var$qr([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $e444d6404c095fa5$var$Jr = new $e444d6404c095fa5$var$qr([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $e444d6404c095fa5$var$Kr = function(t, i) {
    for(var e = new $e444d6404c095fa5$var$Vr(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $e444d6404c095fa5$var$Wr(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $e444d6404c095fa5$var$Xr = $e444d6404c095fa5$var$Kr($e444d6404c095fa5$var$Gr, 2), $e444d6404c095fa5$var$Qr = $e444d6404c095fa5$var$Xr[0], $e444d6404c095fa5$var$Zr = $e444d6404c095fa5$var$Xr[1];
$e444d6404c095fa5$var$Qr[28] = 258, $e444d6404c095fa5$var$Zr[258] = 28;
for(var $e444d6404c095fa5$var$ts = $e444d6404c095fa5$var$Kr($e444d6404c095fa5$var$Yr, 0)[1], $e444d6404c095fa5$var$is = new $e444d6404c095fa5$var$Vr(32768), $e444d6404c095fa5$var$es = 0; $e444d6404c095fa5$var$es < 32768; ++$e444d6404c095fa5$var$es){
    var $e444d6404c095fa5$var$rs = (43690 & $e444d6404c095fa5$var$es) >>> 1 | (21845 & $e444d6404c095fa5$var$es) << 1;
    $e444d6404c095fa5$var$rs = (61680 & ($e444d6404c095fa5$var$rs = (52428 & $e444d6404c095fa5$var$rs) >>> 2 | (13107 & $e444d6404c095fa5$var$rs) << 2)) >>> 4 | (3855 & $e444d6404c095fa5$var$rs) << 4, $e444d6404c095fa5$var$is[$e444d6404c095fa5$var$es] = ((65280 & $e444d6404c095fa5$var$rs) >>> 8 | (255 & $e444d6404c095fa5$var$rs) << 8) >>> 1;
}
var $e444d6404c095fa5$var$ss = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $e444d6404c095fa5$var$Vr(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $e444d6404c095fa5$var$Vr(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $e444d6404c095fa5$var$Vr(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$e444d6404c095fa5$var$is[d] >>> l] = u;
    } else for(o = new $e444d6404c095fa5$var$Vr(r), s = 0; s < r; ++s)o[s] = $e444d6404c095fa5$var$is[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $e444d6404c095fa5$var$ns = new $e444d6404c095fa5$var$qr(288);
for($e444d6404c095fa5$var$es = 0; $e444d6404c095fa5$var$es < 144; ++$e444d6404c095fa5$var$es)$e444d6404c095fa5$var$ns[$e444d6404c095fa5$var$es] = 8;
for($e444d6404c095fa5$var$es = 144; $e444d6404c095fa5$var$es < 256; ++$e444d6404c095fa5$var$es)$e444d6404c095fa5$var$ns[$e444d6404c095fa5$var$es] = 9;
for($e444d6404c095fa5$var$es = 256; $e444d6404c095fa5$var$es < 280; ++$e444d6404c095fa5$var$es)$e444d6404c095fa5$var$ns[$e444d6404c095fa5$var$es] = 7;
for($e444d6404c095fa5$var$es = 280; $e444d6404c095fa5$var$es < 288; ++$e444d6404c095fa5$var$es)$e444d6404c095fa5$var$ns[$e444d6404c095fa5$var$es] = 8;
var $e444d6404c095fa5$var$os = new $e444d6404c095fa5$var$qr(32);
for($e444d6404c095fa5$var$es = 0; $e444d6404c095fa5$var$es < 32; ++$e444d6404c095fa5$var$es)$e444d6404c095fa5$var$os[$e444d6404c095fa5$var$es] = 5;
var $e444d6404c095fa5$var$as = $e444d6404c095fa5$var$ss($e444d6404c095fa5$var$ns, 9, 0), $e444d6404c095fa5$var$ls = $e444d6404c095fa5$var$ss($e444d6404c095fa5$var$os, 5, 0), $e444d6404c095fa5$var$us = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $e444d6404c095fa5$var$hs = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $e444d6404c095fa5$var$Vr ? $e444d6404c095fa5$var$Vr : t instanceof $e444d6404c095fa5$var$Wr ? $e444d6404c095fa5$var$Wr : $e444d6404c095fa5$var$qr)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $e444d6404c095fa5$var$ds = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $e444d6404c095fa5$var$vs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $e444d6404c095fa5$var$cs = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $e444d6404c095fa5$var$qr(0),
        0
    ];
    if (1 == s) {
        var o = new $e444d6404c095fa5$var$qr(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $e444d6404c095fa5$var$Vr(v + 1), f = $e444d6404c095fa5$var$fs(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, _ = f - i, g = 1 << _;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += g - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= _; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == i && (--c[y], ++p);
        }
        f = i;
    }
    return [
        new $e444d6404c095fa5$var$qr(c),
        f
    ];
}, $e444d6404c095fa5$var$fs = function(t, i, e) {
    return -1 == t.s ? Math.max($e444d6404c095fa5$var$fs(t.l, i, e + 1), $e444d6404c095fa5$var$fs(t.r, i, e + 1)) : i[t.s] = e;
}, $e444d6404c095fa5$var$ps = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $e444d6404c095fa5$var$Vr(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $e444d6404c095fa5$var$_s = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $e444d6404c095fa5$var$gs = function(t, i, e) {
    var r = e.length, s = $e444d6404c095fa5$var$us(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $e444d6404c095fa5$var$ms = function(t, i, e, r, s, n, o, a, l, u, h) {
    $e444d6404c095fa5$var$ds(i, h++, e), ++s[256];
    for(var d = $e444d6404c095fa5$var$cs(s, 15), v = d[0], c = d[1], f = $e444d6404c095fa5$var$cs(n, 15), p = f[0], _ = f[1], g = $e444d6404c095fa5$var$ps(v), m = g[0], b = g[1], y = $e444d6404c095fa5$var$ps(p), w = y[0], E = y[1], S = new $e444d6404c095fa5$var$Vr(19), x = 0; x < m.length; ++x)S[31 & m[x]]++;
    for(x = 0; x < w.length; ++x)S[31 & w[x]]++;
    for(var k = $e444d6404c095fa5$var$cs(S, 7), P = k[0], T = k[1], R = 19; R > 4 && !P[$e444d6404c095fa5$var$Jr[R - 1]]; --R);
    var I, C, O, F, M = u + 5 << 3, A = $e444d6404c095fa5$var$_s(s, $e444d6404c095fa5$var$ns) + $e444d6404c095fa5$var$_s(n, $e444d6404c095fa5$var$os) + o, D = $e444d6404c095fa5$var$_s(s, v) + $e444d6404c095fa5$var$_s(n, p) + o + 14 + 3 * R + $e444d6404c095fa5$var$_s(S, P) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (M <= A && M <= D) return $e444d6404c095fa5$var$gs(i, h, t.subarray(l, l + u));
    if ($e444d6404c095fa5$var$ds(i, h, 1 + (D < A)), h += 2, D < A) {
        I = $e444d6404c095fa5$var$ss(v, c, 0), C = v, O = $e444d6404c095fa5$var$ss(p, _, 0), F = p;
        var L = $e444d6404c095fa5$var$ss(P, T, 0);
        $e444d6404c095fa5$var$ds(i, h, b - 257), $e444d6404c095fa5$var$ds(i, h + 5, E - 1), $e444d6404c095fa5$var$ds(i, h + 10, R - 4), h += 14;
        for(x = 0; x < R; ++x)$e444d6404c095fa5$var$ds(i, h + 3 * x, P[$e444d6404c095fa5$var$Jr[x]]);
        h += 3 * R;
        for(var j = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = j[N];
            for(x = 0; x < U.length; ++x){
                var z = 31 & U[x];
                $e444d6404c095fa5$var$ds(i, h, L[z]), h += P[z], z > 15 && ($e444d6404c095fa5$var$ds(i, h, U[x] >>> 5 & 127), h += U[x] >>> 12);
            }
        }
    } else I = $e444d6404c095fa5$var$as, C = $e444d6404c095fa5$var$ns, O = $e444d6404c095fa5$var$ls, F = $e444d6404c095fa5$var$os;
    for(x = 0; x < a; ++x)if (r[x] > 255) {
        z = r[x] >>> 18 & 31;
        $e444d6404c095fa5$var$vs(i, h, I[z + 257]), h += C[z + 257], z > 7 && ($e444d6404c095fa5$var$ds(i, h, r[x] >>> 23 & 31), h += $e444d6404c095fa5$var$Gr[z]);
        var H = 31 & r[x];
        $e444d6404c095fa5$var$vs(i, h, O[H]), h += F[H], H > 3 && ($e444d6404c095fa5$var$vs(i, h, r[x] >>> 5 & 8191), h += $e444d6404c095fa5$var$Yr[H]);
    } else $e444d6404c095fa5$var$vs(i, h, I[r[x]]), h += C[r[x]];
    return $e444d6404c095fa5$var$vs(i, h, I[256]), h + C[256];
}, $e444d6404c095fa5$var$bs = new $e444d6404c095fa5$var$Wr([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $e444d6404c095fa5$var$ys = function() {
    for(var t = new $e444d6404c095fa5$var$Wr(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $e444d6404c095fa5$var$ws = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $e444d6404c095fa5$var$qr(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $e444d6404c095fa5$var$gs(l, u, t.subarray(h, d)) : (l[h] = n, u = $e444d6404c095fa5$var$gs(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $e444d6404c095fa5$var$bs[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, _ = new $e444d6404c095fa5$var$Vr(32768), g = new $e444d6404c095fa5$var$Vr(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $e444d6404c095fa5$var$Wr(25e3), E = new $e444d6404c095fa5$var$Vr(288), S = new $e444d6404c095fa5$var$Vr(32), x = 0, k = 0, P = (h = 0, 0), T = 0, R = 0; h < o; ++h){
                var I = y(h), C = 32767 & h, O = g[I];
                if (_[C] = O, g[I] = C, T <= h) {
                    var F = o - h;
                    if ((x > 7e3 || P > 24576) && F > 423) {
                        u = $e444d6404c095fa5$var$ms(t, l, 0, w, E, S, k, P, R, h - R, u), P = x = k = 0, R = h;
                        for(var M = 0; M < 286; ++M)E[M] = 0;
                        for(M = 0; M < 30; ++M)S[M] = 0;
                    }
                    var A = 2, D = 0, L = f, j = C - O & 32767;
                    if (F > 2 && I == y(h - j)) for(var N = Math.min(c, F) - 1, U = Math.min(32767, h), z = Math.min(258, F); j <= U && --L && C != O;){
                        if (t[h + A] == t[h + A - j]) {
                            for(var H = 0; H < z && t[h + H] == t[h + H - j]; ++H);
                            if (H > A) {
                                if (A = H, D = j, H > N) break;
                                var B = Math.min(j, H - 2), q = 0;
                                for(M = 0; M < B; ++M){
                                    var V = h - j + M + 32768 & 32767, W = V - _[V] + 32768 & 32767;
                                    W > q && (q = W, O = V);
                                }
                            }
                        }
                        j += (C = O) - (O = _[C]) + 32768 & 32767;
                    }
                    if (D) {
                        w[P++] = 268435456 | $e444d6404c095fa5$var$Zr[A] << 18 | $e444d6404c095fa5$var$ts[D];
                        var G = 31 & $e444d6404c095fa5$var$Zr[A], Y = 31 & $e444d6404c095fa5$var$ts[D];
                        k += $e444d6404c095fa5$var$Gr[G] + $e444d6404c095fa5$var$Yr[Y], ++E[257 + G], ++S[Y], T = h + A, ++x;
                    } else w[P++] = t[h], ++E[t[h]];
                }
            }
            u = $e444d6404c095fa5$var$ms(t, l, n, w, E, S, k, P, R, h - R, u);
        }
        return $e444d6404c095fa5$var$hs(a, 0, r + $e444d6404c095fa5$var$us(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, $e444d6404c095fa5$var$Es = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $e444d6404c095fa5$var$Ss(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p: function(i) {
                for(var e = t, r = 0; r < i.length; ++r)e = $e444d6404c095fa5$var$ys[255 & e ^ i[r]] ^ e >>> 8;
                t = e;
            },
            d: function() {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    e.p(t);
    var s, n = $e444d6404c095fa5$var$ws(t, i, 10 + ((s = i).filename && s.filename.length + 1 || 0), 8), o = n.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $e444d6404c095fa5$var$Es(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
        }
    }(n, i), $e444d6404c095fa5$var$Es(n, o - 8, e.d()), $e444d6404c095fa5$var$Es(n, o - 4, r), n;
}
var $e444d6404c095fa5$var$xs = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $e444d6404c095fa5$var$L(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $e444d6404c095fa5$var$$s = !!$e444d6404c095fa5$var$u || !!$e444d6404c095fa5$var$l, $e444d6404c095fa5$var$ks = function(t, i, e) {
    var r;
    void 0 === e && (e = !0);
    var [s, n] = t.split("?"), o = $e444d6404c095fa5$var$g({}, i), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var i, [r, s] = t.split("="), n = e && null !== (i = o[r]) && void 0 !== i ? i : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = $e444d6404c095fa5$var$rr(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $e444d6404c095fa5$var$Ps = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $e444d6404c095fa5$var$Ts = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) {
            var r = $e444d6404c095fa5$var$Ss(function(t, i) {
                var e = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $e444d6404c095fa5$var$qr(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; o < e; ++o){
                    if (s + 5 > r.length) {
                        var a = new $e444d6404c095fa5$var$qr(s + 8 + (e - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $e444d6404c095fa5$var$hs(r, 0, s);
            }($e444d6404c095fa5$var$Ps(i)), {
                mtime: 0
            });
            return {
                contentType: "text/plain",
                body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength),
                estimatedSize: r.byteLength
            };
        }
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) {
            var s = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $e444d6404c095fa5$var$xs(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($e444d6404c095fa5$var$Ps(i)), n = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $e444d6404c095fa5$var$Ps(t)))(s);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: n,
                estimatedSize: new Blob([
                    n
                ]).size
            };
        }
        var o = $e444d6404c095fa5$var$Ps(i);
        return {
            contentType: "application/json",
            body: o,
            estimatedSize: new Blob([
                o
            ]).size
        };
    }
}, $e444d6404c095fa5$var$Rs = [];
$e444d6404c095fa5$var$l && $e444d6404c095fa5$var$Rs.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $e444d6404c095fa5$var$Ts(t)) && void 0 !== i ? i : {}, o = new Headers;
        $e444d6404c095fa5$var$Ci(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($e444d6404c095fa5$var$h) {
            var d = new $e444d6404c095fa5$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $e444d6404c095fa5$var$l(a, $e444d6404c095fa5$var$g({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $e444d6404c095fa5$var$$i.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $e444d6404c095fa5$var$$i.error(i), null == t.callback || t.callback({
                statusCode: 0,
                error: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $e444d6404c095fa5$var$u && $e444d6404c095fa5$var$Rs.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $e444d6404c095fa5$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $e444d6404c095fa5$var$Ts(t)) && void 0 !== i ? i : {};
        $e444d6404c095fa5$var$Ci(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $e444d6404c095fa5$var$n && $e444d6404c095fa5$var$n.sendBeacon && $e444d6404c095fa5$var$Rs.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $e444d6404c095fa5$var$ks(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $e444d6404c095fa5$var$Ts(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $e444d6404c095fa5$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $e444d6404c095fa5$var$Is = 3e3;
class $e444d6404c095fa5$var$Cs {
    constructor(t, i){
        this.wt = !0, this.Et = [], this.St = $e444d6404c095fa5$var$K((null == i ? void 0 : i.flush_interval_ms) || $e444d6404c095fa5$var$Is, 250, 5e3, $e444d6404c095fa5$var$$i.createLogger("flush interval"), $e444d6404c095fa5$var$Is), this.xt = t;
    }
    enqueue(t) {
        this.Et.push(t), this.$t || this.kt();
    }
    unload() {
        this.Pt();
        var t = this.Et.length > 0 ? this.Tt() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.xt($e444d6404c095fa5$var$g({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.wt = !1, this.kt();
    }
    kt() {
        var t = this;
        this.wt || (this.$t = setTimeout(()=>{
            if (this.Pt(), this.Et.length > 0) {
                var i = this.Tt(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $e444d6404c095fa5$var$I(e.data) && $e444d6404c095fa5$var$Ci(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.xt(e);
                };
                for(var r in i)e();
            }
        }, this.St));
    }
    Pt() {
        clearTimeout(this.$t), this.$t = void 0;
    }
    Tt() {
        var t = {};
        return $e444d6404c095fa5$var$Ci(this.Et, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $e444d6404c095fa5$var$M(t[s]) && (t[s] = $e444d6404c095fa5$var$g({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.Et = [], t;
    }
}
var $e444d6404c095fa5$var$Os = [
    "retriesPerformedSoFar"
];
class $e444d6404c095fa5$var$Fs {
    constructor(i){
        this.Rt = !1, this.It = 3e3, this.Et = [], this._instance = i, this.Et = [], this.Ct = !0, !$e444d6404c095fa5$var$M($e444d6404c095fa5$var$t) && "onLine" in $e444d6404c095fa5$var$t.navigator && (this.Ct = $e444d6404c095fa5$var$t.navigator.onLine, this.Ot = ()=>{
            this.Ct = !0, this.Ft();
        }, this.Mt = ()=>{
            this.Ct = !1;
        }, $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "online", this.Ot), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "offline", this.Mt));
    }
    get length() {
        return this.Et.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $e444d6404c095fa5$var$m(t, $e444d6404c095fa5$var$Os);
        $e444d6404c095fa5$var$U(i) && (e.url = $e444d6404c095fa5$var$ks(e.url, {
            retry_count: i
        })), this._instance._send_request($e444d6404c095fa5$var$g({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.At($e444d6404c095fa5$var$g({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    At(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.Et.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $e444d6404c095fa5$var$$i.warn(s), this.Rt || (this.Rt = !0, this.Dt());
    }
    Dt() {
        if (this.Lt && clearTimeout(this.Lt), 0 === this.Et.length) return this.Rt = !1, void (this.Lt = void 0);
        this.Lt = setTimeout(()=>{
            this.Ct && this.Et.length > 0 && this.Ft(), this.Dt();
        }, this.It);
    }
    Ft() {
        var t = Date.now(), i = [], e = this.Et.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.Et = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: i } of (this.Lt && (clearTimeout(this.Lt), this.Lt = void 0), this.Rt = !1, $e444d6404c095fa5$var$M($e444d6404c095fa5$var$t) || (this.Ot && ($e444d6404c095fa5$var$t.removeEventListener("online", this.Ot), this.Ot = void 0), this.Mt && ($e444d6404c095fa5$var$t.removeEventListener("offline", this.Mt), this.Mt = void 0)), this.Et))try {
            this._instance._send_request($e444d6404c095fa5$var$g({}, i, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $e444d6404c095fa5$var$$i.error(t);
        }
        this.Et = [];
    }
}
class $e444d6404c095fa5$var$Ms {
    constructor(t){
        this.jt = ()=>{
            var t, i, e, r;
            this.Nt || (this.Nt = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Nt.lastScrollY = Math.ceil(n), this.Nt.maxScrollY = Math.max(n, null !== (t = this.Nt.maxScrollY) && void 0 !== t ? t : 0), this.Nt.maxScrollHeight = Math.max(o, null !== (i = this.Nt.maxScrollHeight) && void 0 !== i ? i : 0), this.Nt.lastContentY = a, this.Nt.maxContentY = Math.max(a, null !== (e = this.Nt.maxContentY) && void 0 !== e ? e : 0), this.Nt.maxContentHeight = Math.max(l, null !== (r = this.Nt.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Nt;
    }
    resetContext() {
        var t = this.Nt;
        return setTimeout(this.jt, 0), t;
    }
    startMeasuringScrollPosition() {
        $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "scroll", this.jt, {
            capture: !0
        }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "scrollend", this.jt, {
            capture: !0
        }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "resize", this.jt);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.documentElement;
        var i = $e444d6404c095fa5$var$I(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollY || $e444d6404c095fa5$var$t.pageYOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollX || $e444d6404c095fa5$var$t.pageXOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $e444d6404c095fa5$var$As = (t)=>$e444d6404c095fa5$var$gr(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $e444d6404c095fa5$var$Ds {
    constructor(t, i, e, r){
        this.Ut = (t)=>{
            var i = this.zt();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Ht(this._instance)
                };
                this.Bt.register({
                    [$e444d6404c095fa5$var$_e]: e
                });
            }
        }, this._instance = t, this.qt = i, this.Bt = e, this.Ht = r || $e444d6404c095fa5$var$As, this.qt.onSessionId(this.Ut);
    }
    zt() {
        return this.Bt.props[$e444d6404c095fa5$var$_e];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.zt()) ? void 0 : t.props;
        return i ? "r" in i ? $e444d6404c095fa5$var$mr(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $e444d6404c095fa5$var$Ci($e444d6404c095fa5$var$Li(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $e444d6404c095fa5$var$x(e)] = i;
        }), t;
    }
}
class $e444d6404c095fa5$var$Ls {
    constructor(){
        this.Vt = {}, this.Vt = {};
    }
    on(t, i) {
        return this.Vt[t] || (this.Vt[t] = []), this.Vt[t].push(i), ()=>{
            this.Vt[t] = this.Vt[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Vt[t] || [])e(i);
        for (var r of this.Vt["*"] || [])r(t, i);
    }
}
var $e444d6404c095fa5$var$js = $e444d6404c095fa5$var$ki("[SessionId]");
class $e444d6404c095fa5$var$Ns {
    on(t, i) {
        return this.Wt.on(t, i);
    }
    constructor(t, i, e){
        var r;
        if (this.Gt = [], this.Yt = void 0, this.Wt = new $e444d6404c095fa5$var$Ls, this.Jt = (t, i)=>!(!$e444d6404c095fa5$var$U(t) || !$e444d6404c095fa5$var$U(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.N = t.config, this.Bt = t.persistence, this.Kt = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Qt = i || $e444d6404c095fa5$var$Ce, this.Zt = e || $e444d6404c095fa5$var$Ce;
        var s = this.N.persistence_name || this.N.token, n = this.N.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $e444d6404c095fa5$var$K(n, 60, 36e3, $e444d6404c095fa5$var$js.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.ti(), this.ii = "ph_" + s + "_window_id", this.ei = "ph_" + s + "_primary_window_exists", this.ri()) {
            var o = $e444d6404c095fa5$var$Be.D(this.ii), a = $e444d6404c095fa5$var$Be.D(this.ei);
            o && !a ? this.Kt = o : $e444d6404c095fa5$var$Be.j(this.ii), $e444d6404c095fa5$var$Be.L(this.ei, !0);
        }
        if (null != (r = this.N.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.N.bootstrap.sessionID);
            this.si(this.N.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $e444d6404c095fa5$var$js.error("Invalid sessionID in bootstrap", t);
        }
        this.ni();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $e444d6404c095fa5$var$M(this.Gt) && (this.Gt = []), this.Gt.push(t), this.Xt && t(this.Xt, this.Kt), ()=>{
            this.Gt = this.Gt.filter((i)=>i !== t);
        };
    }
    ri() {
        return "memory" !== this.N.persistence && !this.Bt.st && $e444d6404c095fa5$var$Be.F();
    }
    oi(t) {
        t !== this.Kt && (this.Kt = t, this.ri() && $e444d6404c095fa5$var$Be.L(this.ii, t));
    }
    ai() {
        return this.Kt ? this.Kt : this.ri() ? $e444d6404c095fa5$var$Be.D(this.ii) : null;
    }
    si(t, i, e) {
        t === this.Xt && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Xt = t, this.Bt.register({
            [$e444d6404c095fa5$var$re]: [
                i,
                t,
                e
            ]
        }));
    }
    li() {
        var t = this.Bt.props[$e444d6404c095fa5$var$re];
        return $e444d6404c095fa5$var$I(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.si(null, null, null);
    }
    destroy() {
        clearTimeout(this.ui), this.ui = void 0, this.Yt && $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.removeEventListener("beforeunload", this.Yt, {
            capture: !1
        }), this.Yt = void 0), this.Gt = [];
    }
    ni() {
        this.Yt = ()=>{
            this.ri() && $e444d6404c095fa5$var$Be.j(this.ei);
        }, $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "beforeunload", this.Yt, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.N.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this.li(), o = this.ai(), a = $e444d6404c095fa5$var$U(n) && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !u && !t && this.Jt(e, r);
        u || h || a ? (s = this.Qt(), o = this.Zt(), $e444d6404c095fa5$var$js.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Zt(), l = !0);
        var d = !!$e444d6404c095fa5$var$U(r) && t && !a ? r : e, v = !$e444d6404c095fa5$var$U(n) ? (new Date).getTime() : n;
        return this.oi(o), this.si(s, d, v), t || this.ti(), l && this.Gt.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    ti() {
        clearTimeout(this.ui), this.ui = setTimeout(()=>{
            var [t] = this.li();
            if (this.Jt((new Date).getTime(), t)) {
                var i = this.Xt;
                this.resetSessionId(), this.Wt.emit("forcedIdleReset", {
                    idleSessionId: i
                });
            }
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $e444d6404c095fa5$var$Us = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $e444d6404c095fa5$var$w(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$e444d6404c095fa5$var$w(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $e444d6404c095fa5$var$zs = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $e444d6404c095fa5$var$Hs(t, i, e) {
    return $e444d6404c095fa5$var$Ps({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $e444d6404c095fa5$var$Bs = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$e444d6404c095fa5$var$zs(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$e444d6404c095fa5$var$zs(i, t))),
    icontains: (t, i)=>i.map($e444d6404c095fa5$var$qs).some((i)=>t.map($e444d6404c095fa5$var$qs).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($e444d6404c095fa5$var$qs).every((i)=>t.map($e444d6404c095fa5$var$qs).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
}, $e444d6404c095fa5$var$qs = (t)=>t.toLowerCase();
function $e444d6404c095fa5$var$Vs(t, i) {
    return !t || Object.entries(t).every((t)=>{
        var [e, r] = t, s = null == i ? void 0 : i[e];
        if ($e444d6404c095fa5$var$M(s) || $e444d6404c095fa5$var$L(s)) return !1;
        var n = [
            String(s)
        ], o = $e444d6404c095fa5$var$Bs[r.operator];
        return !!o && o(r.values, n);
    });
}
var $e444d6404c095fa5$var$Ws = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $e444d6404c095fa5$var$Gs = "i.posthog.com";
class $e444d6404c095fa5$var$Ys {
    constructor(t){
        this.hi = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $e444d6404c095fa5$var$Gs, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.hi[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.hi[this.apiHost] = $e444d6404c095fa5$var$Ws.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.hi[this.apiHost] = $e444d6404c095fa5$var$Ws.EU : this.hi[this.apiHost] = $e444d6404c095fa5$var$Ws.CUSTOM), this.hi[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if ("flags" === t) return this.flagsApiHost + i;
        if (this.region === $e444d6404c095fa5$var$Ws.CUSTOM) return this.apiHost + i;
        var e = $e444d6404c095fa5$var$Gs + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $e444d6404c095fa5$var$Js = $e444d6404c095fa5$var$ki("[Surveys]");
var $e444d6404c095fa5$var$Ks = "seenSurvey_", $e444d6404c095fa5$var$Xs = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, $e444d6404c095fa5$var$Qs = (t)=>((t, i)=>{
        var e = "" + t + i.id;
        return i.current_iteration && i.current_iteration > 0 && (e = "" + t + i.id + "_" + i.current_iteration), e;
    })($e444d6404c095fa5$var$Ks, t), $e444d6404c095fa5$var$Zs = [
    $e444d6404c095fa5$export$22779822dd24228f.Popover,
    $e444d6404c095fa5$export$22779822dd24228f.Widget,
    $e444d6404c095fa5$export$22779822dd24228f.API
], $e444d6404c095fa5$var$tn = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $e444d6404c095fa5$export$a8a66d9d1b857494.Popover
}, $e444d6404c095fa5$var$en = $e444d6404c095fa5$var$ki("[PostHog ExternalIntegrations]"), $e444d6404c095fa5$var$rn = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $e444d6404c095fa5$var$sn {
    constructor(t){
        this._instance = t;
    }
    G(t, i) {
        var e;
        null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $e444d6404c095fa5$var$en.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.G($e444d6404c095fa5$var$rn[i], ()=>{
                var e;
                null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
var $e444d6404c095fa5$var$nn = {}, $e444d6404c095fa5$var$on = 0, $e444d6404c095fa5$var$an = ()=>{}, $e444d6404c095fa5$var$ln = "posthog", $e444d6404c095fa5$var$un = !$e444d6404c095fa5$var$$s && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("MSIE")) && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("Mozilla")), $e444d6404c095fa5$var$hn = (i)=>{
    var e;
    return $e444d6404c095fa5$var$g({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $e444d6404c095fa5$var$Ui(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $e444d6404c095fa5$var$an,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        debug: $e444d6404c095fa5$var$a && $e444d6404c095fa5$var$A(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.search) && -1 !== $e444d6404c095fa5$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $e444d6404c095fa5$var$$i.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $e444d6404c095fa5$var$Is
        },
        error_tracking: {},
        _onCapture: $e444d6404c095fa5$var$an,
        __preview_eager_load_replay: !1
    }, ((t)=>({
            rageclick: !(t && t >= "2025-11-30") || {
                content_ignorelist: !0
            },
            capture_pageview: !(t && t >= "2025-05-24") || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0
        }))(i));
}, $e444d6404c095fa5$var$dn = (t)=>{
    var i = {};
    $e444d6404c095fa5$var$M(t.process_person) || (i.person_profiles = t.process_person), $e444d6404c095fa5$var$M(t.xhr_headers) || (i.request_headers = t.xhr_headers), $e444d6404c095fa5$var$M(t.cookie_name) || (i.persistence_name = t.cookie_name), $e444d6404c095fa5$var$M(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $e444d6404c095fa5$var$M(t.store_google) || (i.save_campaign_params = t.store_google), $e444d6404c095fa5$var$M(t.verbose) || (i.debug = t.verbose);
    var e = $e444d6404c095fa5$var$Oi({}, i, t);
    return $e444d6404c095fa5$var$I(t.property_blacklist) && ($e444d6404c095fa5$var$M(t.property_denylist) ? e.property_denylist = t.property_blacklist : $e444d6404c095fa5$var$I(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $e444d6404c095fa5$var$$i.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $e444d6404c095fa5$var$vn {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get di() {
        return this.__forceAllowLocalhost;
    }
    set di(t) {
        $e444d6404c095fa5$var$$i.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $e444d6404c095fa5$export$a9d6b9cbf49b8241 {
    vi(t, i) {
        if (t) {
            var e = this.ci.indexOf(t);
            -1 !== e && this.ci.splice(e, 1);
        }
        return this.ci.push(i), null == i.initialize || i.initialize(), i;
    }
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.webPerformance = new $e444d6404c095fa5$var$vn, this.fi = !1, this.version = $e444d6404c095fa5$var$f.LIB_VERSION, this.pi = new $e444d6404c095fa5$var$Ls, this.ci = [], this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $e444d6404c095fa5$var$hn(), this.SentryIntegration = $e444d6404c095fa5$var$tr, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $e444d6404c095fa5$var$Ze(t, i);
                return {
                    name: $e444d6404c095fa5$var$Qe,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.gi = !1, this.mi = null, this.bi = null, this.yi = null, this.scrollManager = new $e444d6404c095fa5$var$Ms(this), this.pageViewManager = new $e444d6404c095fa5$var$ir(this), this.rateLimiter = new $e444d6404c095fa5$var$Nr(this), this.requestRouter = new $e444d6404c095fa5$var$Ys(this), this.consent = new $e444d6404c095fa5$var$Ve(this), this.externalIntegrations = new $e444d6404c095fa5$var$sn(this);
        var i = null !== (t = $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = i.featureFlags && new i.featureFlags(this), this.toolbar = i.toolbar && new i.toolbar(this), this.surveys = i.surveys && new i.surveys(this), this.conversations = i.conversations && new i.conversations(this), this.logs = i.logs && new i.logs(this), this.experiments = i.experiments && new i.experiments(this), this.exceptions = i.exceptions && new i.exceptions(this), this.people = {
            set: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$A(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$A(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$e444d6404c095fa5$var$$i.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $e444d6404c095fa5$var$ln) {
            var r, s = null !== (r = $e444d6404c095fa5$var$nn[e]) && void 0 !== r ? r : new $e444d6404c095fa5$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $e444d6404c095fa5$var$nn[e] = s, $e444d6404c095fa5$var$nn[$e444d6404c095fa5$var$ln][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s;
        if (void 0 === e && (e = {}), $e444d6404c095fa5$var$M(i) || $e444d6404c095fa5$var$D(i)) return $e444d6404c095fa5$var$$i.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, e.debug = this.wi(e.debug), this.Ei = e, this.Si = [], e.person_profiles ? this.bi = e.person_profiles : e.process_person && (this.bi = e.process_person), this.set_config($e444d6404c095fa5$var$Oi({}, $e444d6404c095fa5$var$hn(e.defaults), $e444d6404c095fa5$var$dn(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $e444d6404c095fa5$var$$i.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS;
        var n = this.xi();
        this.persistence = new $e444d6404c095fa5$var$Sr(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Sr($e444d6404c095fa5$var$g({}, this.config, {
            persistence: "sessionStorage"
        }), n);
        var o = $e444d6404c095fa5$var$g({}, this.persistence.props), a = $e444d6404c095fa5$var$g({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.$i = new $e444d6404c095fa5$var$Cs((t)=>this.ki(t), this.config.request_queue_config), this.Pi = new $e444d6404c095fa5$var$Fs(this), this.__request_queue = [];
        var l = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (l || (this.sessionManager = new $e444d6404c095fa5$var$Ns(this), this.sessionPropsManager = new $e444d6404c095fa5$var$Ds(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($e444d6404c095fa5$var$$i.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.Ti(l);
        }, 0)) : ($e444d6404c095fa5$var$$i.info("Initializing extensions synchronously"), this.Ti(l)), $e444d6404c095fa5$var$f.DEBUG = $e444d6404c095fa5$var$f.DEBUG || this.config.debug, $e444d6404c095fa5$var$f.DEBUG && $e444d6404c095fa5$var$$i.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $e444d6404c095fa5$var$g({}, this.config),
            p: o,
            s: a
        }), void 0 !== (null == (s = e.bootstrap) ? void 0 : s.distinctID)) {
            var u, h, d = this.config.get_device_id($e444d6404c095fa5$var$Ce()), v = null != (u = e.bootstrap) && u.isIdentifiedID ? d : e.bootstrap.distinctID;
            this.persistence.set_property($e444d6404c095fa5$var$pe, null != (h = e.bootstrap) && h.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (l) this.register_once({
            distinct_id: $e444d6404c095fa5$var$Se,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var c = this.config.get_device_id($e444d6404c095fa5$var$Ce());
            this.register_once({
                distinct_id: c,
                $device_id: c
            }, ""), this.persistence.set_property($e444d6404c095fa5$var$pe, "anonymous");
        }
        return $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), e.segment ? $e444d6404c095fa5$var$Xe(this, ()=>this.Ri()) : this.Ri(), $e444d6404c095fa5$var$C(this.config._onCapture) && this.config._onCapture !== $e444d6404c095fa5$var$an && ($e444d6404c095fa5$var$$i.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $e444d6404c095fa5$var$$i.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    Ti(t) {
        var i, e, r, s, n, o, a, l = performance.now(), u = $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses, this.config.__extensionClasses), h = [];
        u.featureFlags && this.ci.push(this.featureFlags = null !== (i = this.featureFlags) && void 0 !== i ? i : new u.featureFlags(this));
        u.exceptions && this.ci.push(this.exceptions = null !== (e = this.exceptions) && void 0 !== e ? e : new u.exceptions(this));
        (u.historyAutocapture && this.ci.push(this.historyAutocapture = new u.historyAutocapture(this)), u.tracingHeaders && this.ci.push(new u.tracingHeaders(this)), u.siteApps && this.ci.push(this.siteApps = new u.siteApps(this)), u.sessionRecording && !t && this.ci.push(this.sessionRecording = new u.sessionRecording(this)), this.config.disable_scroll_properties || h.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), u.autocapture && this.ci.push(this.autocapture = new u.autocapture(this)), u.surveys) && this.ci.push(this.surveys = null !== (r = this.surveys) && void 0 !== r ? r : new u.surveys(this));
        u.logs && this.ci.push(this.logs = null !== (s = this.logs) && void 0 !== s ? s : new u.logs(this));
        u.conversations && this.ci.push(this.conversations = null !== (n = this.conversations) && void 0 !== n ? n : new u.conversations(this));
        (u.productTours && this.ci.push(this.productTours = new u.productTours(this)), u.heatmaps && this.ci.push(this.heatmaps = new u.heatmaps(this)), u.webVitalsAutocapture && this.ci.push(this.webVitalsAutocapture = new u.webVitalsAutocapture(this)), u.exceptionObserver && this.ci.push(this.exceptionObserver = new u.exceptionObserver(this)), u.deadClicksAutocapture && this.ci.push(this.deadClicksAutocapture = new u.deadClicksAutocapture(this, $e444d6404c095fa5$var$Ye)), u.toolbar) && this.ci.push(this.toolbar = null !== (o = this.toolbar) && void 0 !== o ? o : new u.toolbar(this));
        u.experiments && this.ci.push(this.experiments = null !== (a = this.experiments) && void 0 !== a ? a : new u.experiments(this));
        this.ci.forEach((t)=>{
            t.initialize && h.push(()=>{
                null == t.initialize || t.initialize();
            });
        }), h.push(()=>{
            if (this.Ii) {
                var t = this.Ii;
                this.Ii = void 0, this.ft(t);
            }
        }), this.Ci(h, l);
    }
    Ci(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions) {
                if (performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                    this.Ci(t, i);
                }, 0);
            }
            var e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $e444d6404c095fa5$var$$i.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - i);
        this.register_for_session({
            $sdk_debug_extensions_init_method: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            $sdk_debug_extensions_init_time_ms: r
        }), this.config.__preview_deferred_init_extensions && $e444d6404c095fa5$var$$i.info("PostHog extensions initialized (" + r + "ms)");
    }
    ft(t) {
        var i;
        if (!$e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.body) return $e444d6404c095fa5$var$$i.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.ft(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.Ii = t), this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $e444d6404c095fa5$var$E(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) ? $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS : $e444d6404c095fa5$var$E(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) ? $e444d6404c095fa5$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.bi ? this.bi : "identified_only"
        }), this.ci.forEach((i)=>null == i.onRemoteConfig ? void 0 : i.onRemoteConfig(t));
    }
    Ri() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $e444d6404c095fa5$var$$i.critical("`loaded` function failed", t);
        }
        if (this.Oi(), this.config.internal_or_test_user_hostname && null != $e444d6404c095fa5$var$a && $e444d6404c095fa5$var$a.hostname) {
            var t = $e444d6404c095fa5$var$a.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.Fi();
        }, 1), this.Mi = new $e444d6404c095fa5$var$zr(this), this.Mi.load();
    }
    Oi() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.$i) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $e444d6404c095fa5$var$Ii(this.__request_queue, (t)=>this.ki(t)), this.__request_queue = [], this.Oi();
    }
    _handle_unload() {
        var t, i, e;
        null == (t = this.surveys) || t.handlePageUnload(), this.config.request_batching ? (this.Ai() && this.capture("$pageleave"), null == (i = this.$i) || i.unload(), null == (e = this.Pi) || e.unload()) : this.Ai() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && ($e444d6404c095fa5$var$un ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $e444d6404c095fa5$var$ks(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $e444d6404c095fa5$var$g({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $e444d6404c095fa5$var$g({}, t);
            s.timeout = s.timeout || 6e4, s.url = $e444d6404c095fa5$var$ks(s.url, {
                _: (new Date).getTime().toString(),
                ver: $e444d6404c095fa5$var$f.JS_SDK_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = $e444d6404c095fa5$var$Rs.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = $e444d6404c095fa5$var$zi(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })($e444d6404c095fa5$var$g({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    ki(t) {
        this.Pi ? this.Pi.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        $e444d6404c095fa5$var$on++;
        try {
            var i, e = [], r = [], s = [];
            $e444d6404c095fa5$var$Ii(t, (t)=>{
                t && (i = t[0], $e444d6404c095fa5$var$I(i) ? s.push(t) : $e444d6404c095fa5$var$C(t) ? t.call(this) : $e444d6404c095fa5$var$I(t) && "alias" === i ? e.push(t) : $e444d6404c095fa5$var$I(t) && -1 !== i.indexOf("capture") && $e444d6404c095fa5$var$C(this[i]) ? s.push(t) : r.push(t));
            });
            var n = function(t, i) {
                $e444d6404c095fa5$var$Ii(t, function(t) {
                    if ($e444d6404c095fa5$var$I(t[0])) {
                        var e = i;
                        $e444d6404c095fa5$var$Ci(t, function(t) {
                            e = e[t[0]].apply(e, t.slice(1));
                        });
                    } else this[t[0]].apply(this, t.slice(1));
                }, i);
            };
            n(e, this), n(r, this), n(s, this);
        } finally{
            $e444d6404c095fa5$var$on--;
        }
    }
    push(t) {
        if ($e444d6404c095fa5$var$on > 0 && $e444d6404c095fa5$var$I(t) && $e444d6404c095fa5$var$A(t[0])) {
            var i = $e444d6404c095fa5$export$a9d6b9cbf49b8241.prototype[t[0]];
            $e444d6404c095fa5$var$C(i) && i.apply(this, t.slice(1));
        } else this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.$i) {
            if (this.is_capturing()) {
                if (!$e444d6404c095fa5$var$M(t) && $e444d6404c095fa5$var$A(t)) {
                    var s = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!(s && !this.config.__preview_capture_bot_pageviews)) {
                        var n = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == n || !n.isRateLimited) {
                            null != i && i.$current_url && !$e444d6404c095fa5$var$A(null == i ? void 0 : i.$current_url) && ($e444d6404c095fa5$var$$i.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), "$exception" !== t || null != e && e.Di || $e444d6404c095fa5$var$$i.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var o = new Date, a = (null == e ? void 0 : e.timestamp) || o, l = $e444d6404c095fa5$var$Ce(), u = {
                                uuid: l,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, a, l)
                            };
                            "$pageview" === t && this.config.__preview_capture_bot_pageviews && s && (u.event = "$bot_pageview", u.properties.$browser_type = "bot"), n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), (null == e ? void 0 : e.$set) && (u.$set = null == e ? void 0 : e.$set);
                            var h, d = "$groupidentify" !== t, v = "$identify" === t, c = this.Li(null == e ? void 0 : e.$set_once, d, v);
                            if (c && (u.$set_once = c), (u = $e444d6404c095fa5$var$ji(u, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, $e444d6404c095fa5$var$M(null == e ? void 0 : e.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), t === $e444d6404c095fa5$export$9d7ec1793ca1658e.DISMISSED || t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT) {
                                var f = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ID], p = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ITERATION];
                                h = {
                                    id: f,
                                    current_iteration: p
                                }, localStorage.getItem($e444d6404c095fa5$var$Qs(h)) || localStorage.setItem($e444d6404c095fa5$var$Qs(h), "true"), u.$set = $e444d6404c095fa5$var$g({}, u.$set, {
                                    [$e444d6404c095fa5$var$Xs({
                                        id: f,
                                        current_iteration: p
                                    }, t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            } else t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN && (u.$set = $e444d6404c095fa5$var$g({}, u.$set, {
                                [$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            if (t === $e444d6404c095fa5$export$e5d0052c1e47bfda.SHOWN) {
                                var _ = null == i ? void 0 : i[$e444d6404c095fa5$export$eedf6d13bc23d767.TOUR_TYPE];
                                _ && (u.$set = $e444d6404c095fa5$var$g({}, u.$set, {
                                    [$e444d6404c095fa5$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE + "/" + _]: (new Date).toISOString()
                                }));
                            }
                            var m = $e444d6404c095fa5$var$g({}, u.properties.$set, u.$set);
                            if ($e444d6404c095fa5$var$F(m) || this.setPersonPropertiesForFlags(m), !$e444d6404c095fa5$var$j(this.config.before_send)) {
                                var b = this.ji(u);
                                if (!b) return;
                                u = b;
                            }
                            this.pi.emit("eventCaptured", u);
                            var y = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: u,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.ki(y) : this.$i.enqueue(y), u;
                        }
                        $e444d6404c095fa5$var$$i.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $e444d6404c095fa5$var$$i.error("No event name provided to posthog.capture");
            }
        } else $e444d6404c095fa5$var$$i.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $e444d6404c095fa5$var$g({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $e444d6404c095fa5$var$g({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$e444d6404c095fa5$var$A(a.distinct_id) && !$e444d6404c095fa5$var$N(a.distinct_id) || $e444d6404c095fa5$var$D(a.distinct_id)) && $e444d6404c095fa5$var$$i.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $e444d6404c095fa5$var$wr(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $e444d6404c095fa5$var$Oi(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $e444d6404c095fa5$var$Oi(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.Pi) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $e444d6404c095fa5$var$Ws.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $e444d6404c095fa5$var$Oi(a, u), "$pageview" === t && $e444d6404c095fa5$var$o && (a.title = $e444d6404c095fa5$var$o.title), !$e444d6404c095fa5$var$M(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $e444d6404c095fa5$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $e444d6404c095fa5$var$Oi({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $e444d6404c095fa5$var$I(this.config.property_denylist) ? $e444d6404c095fa5$var$Ci(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $e444d6404c095fa5$var$$i.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var _ = this.config.sanitize_properties;
        _ && ($e444d6404c095fa5$var$$i.error("sanitize_properties is deprecated. Use before_send instead"), a = _(a, t));
        var m = this.Ni();
        return a.$process_person_profile = m, m && !s && this.Ui("_calculate_event_properties"), a;
    }
    Li(t, i, e) {
        var r;
        if (void 0 === i && (i = !0), void 0 === e && (e = !1), !this.persistence || !this.Ni()) return t;
        if (this.fi && !e) return t;
        var s = this.persistence.get_initial_props(), n = null == (r = this.sessionPropsManager) ? void 0 : r.getSetOnceProps(), o = $e444d6404c095fa5$var$Oi({}, s, n || {}, t || {}), a = this.config.sanitize_properties;
        return a && ($e444d6404c095fa5$var$$i.error("sanitize_properties is deprecated. Use before_send instead"), o = a(o, "$set_once")), i && (this.fi = !0), $e444d6404c095fa5$var$F(o) ? void 0 : o;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    zi(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.getFeatureFlagResult(t, i);
    }
    isFeatureEnabled(t, i) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        var t;
        null == (t = this.featureFlags) || t.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var r;
        null == (r = this.featureFlags) || r.updateFlags(t, i, e);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r;
        null == (r = this.featureFlags) || r.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        var r;
        return void 0 === i && (i = !1), null == (r = this.featureFlags) ? void 0 : r.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.pi.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: "Surveys module not available"
        }), ()=>{});
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys ? this.surveys.getSurveys(t, i) : t([], {
            isLoaded: !1,
            error: "Surveys module not available"
        });
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys ? this.surveys.getActiveMatchingSurveys(t, i) : t([], {
            isLoaded: !1,
            error: "Surveys module not available"
        });
    }
    renderSurvey(t, i) {
        var e;
        null == (e = this.surveys) || e.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        var e;
        void 0 === i && (i = $e444d6404c095fa5$var$tn), null == (e = this.surveys) || e.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        var i;
        null == (i = this.surveys) || i.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var i, e;
        return null !== (i = null == (e = this.surveys) ? void 0 : e.canRenderSurvey(t)) && void 0 !== i ? i : {
            visible: !1,
            disabledReason: "Surveys module not available"
        };
    }
    canRenderSurveyAsync(t, i) {
        var e, r;
        return void 0 === i && (i = !1), null !== (e = null == (r = this.surveys) ? void 0 : r.canRenderSurveyAsync(t, i)) && void 0 !== e ? e : Promise.resolve({
            visible: !1,
            disabledReason: "Surveys module not available"
        });
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $e444d6404c095fa5$var$$i.uninitializedWarning("posthog.identify");
        if ($e444d6404c095fa5$var$N(t) && (t = t.toString(), $e444d6404c095fa5$var$$i.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $e444d6404c095fa5$var$$i.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $e444d6404c095fa5$var$Se) {
                if (this.Ui("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($e444d6404c095fa5$var$Vi) && (this.unregister($e444d6404c095fa5$var$Vi), this.register({
                        distinct_id: t
                    }));
                    var n, o = "anonymous" === (this.persistence.get_property($e444d6404c095fa5$var$pe) || "anonymous");
                    if (t !== r && o) this.persistence.set_property($e444d6404c095fa5$var$pe, "identified"), this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.yi = $e444d6404c095fa5$var$Hs(t, i, e), null == (n = this.featureFlags) || n.setAnonymousDistinctId(r);
                    else (i || e) && this.setPersonProperties(i, e);
                    t !== r && (this.reloadFeatureFlags(), this.unregister($e444d6404c095fa5$var$de));
                }
            } else $e444d6404c095fa5$var$$i.critical('The string "' + $e444d6404c095fa5$var$Se + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $e444d6404c095fa5$var$$i.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Ui("posthog.setPersonProperties")) {
            var e = $e444d6404c095fa5$var$Hs(this.get_distinct_id(), t, i);
            this.yi !== e ? (this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.yi = e) : $e444d6404c095fa5$var$$i.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            var r = this.getGroups();
            r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $e444d6404c095fa5$var$g({}, r, {
                    [t]: i
                })
            }), e && (this.capture("$groupidentify", {
                $group_type: t,
                $group_key: i,
                $group_set: e
            }), this.setGroupPropertiesForFlags({
                [t]: e
            })), r[t] === i || e || this.reloadFeatureFlags();
        } else $e444d6404c095fa5$var$$i.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        var e;
        void 0 === i && (i = !0), null == (e = this.featureFlags) || e.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        var t;
        null == (t = this.featureFlags) || t.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        var e;
        void 0 === i && (i = !0), this.Ui("posthog.setGroupPropertiesForFlags") && (null == (e = this.featureFlags) || e.setGroupPropertiesForFlags(t, i));
    }
    resetGroupPropertiesForFlags(t) {
        var i;
        null == (i = this.featureFlags) || i.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s, n, o, a;
        if ($e444d6404c095fa5$var$$i.info("reset"), !this.__loaded) return $e444d6404c095fa5$var$$i.uninitializedWarning("posthog.reset");
        var l = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), null == (r = this.surveys) || r.reset(), null == (s = this.Mi) || s.stop(), null == (n = this.featureFlags) || n.reset(), null == (o = this.persistence) || o.set_property($e444d6404c095fa5$var$pe, "anonymous"), null == (a = this.sessionManager) || a.resetSessionId(), this.yi = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: $e444d6404c095fa5$var$Se,
            $device_id: null
        }, "");
        else {
            var u = this.config.get_device_id($e444d6404c095fa5$var$Ce());
            this.register_once({
                distinct_id: u,
                $device_id: t ? u : l
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1), this.reloadFeatureFlags();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($e444d6404c095fa5$var$qi) ? ($e444d6404c095fa5$var$$i.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ui("posthog.alias") ? ($e444d6404c095fa5$var$M(i) && (i = this.get_distinct_id()), t !== i ? (this.zi($e444d6404c095fa5$var$Vi, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($e444d6404c095fa5$var$$i.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = $e444d6404c095fa5$var$g({}, this.config);
        if ($e444d6404c095fa5$var$O(t)) {
            var e, r, s, n, o, a, l, u, h;
            $e444d6404c095fa5$var$Oi(this.config, $e444d6404c095fa5$var$dn(t));
            var d = this.xi();
            null == (e = this.persistence) || e.update_config(this.config, i, d), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Sr($e444d6404c095fa5$var$g({}, this.config, {
                persistence: "sessionStorage"
            }), d);
            var v = this.wi(this.config.debug);
            $e444d6404c095fa5$var$z(v) && (this.config.debug = v), $e444d6404c095fa5$var$z(this.config.debug) && (this.config.debug ? ($e444d6404c095fa5$var$f.DEBUG = !0, $e444d6404c095fa5$var$je.F() && $e444d6404c095fa5$var$je.L("ph_debug", !0), $e444d6404c095fa5$var$$i.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $e444d6404c095fa5$var$g({}, this.config)
            })) : ($e444d6404c095fa5$var$f.DEBUG = !1, $e444d6404c095fa5$var$je.F() && $e444d6404c095fa5$var$je.j("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.sessionRecording) || s.startIfEnabledOrStop(), null == (n = this.autocapture) || n.startIfEnabled(), null == (o = this.heatmaps) || o.startIfEnabled(), null == (a = this.exceptionObserver) || a.startIfEnabledOrStop(), null == (l = this.deadClicksAutocapture) || l.startIfEnabledOrStop(), null == (u = this.surveys) || u.loadIfEnabled(), this.Hi(), null == (h = this.externalIntegrations) || h.startIfEnabledOrStop();
        }
    }
    _overrideSDKInfo(t, i) {
        $e444d6404c095fa5$var$f.LIB_NAME = t, $e444d6404c095fa5$var$f.LIB_VERSION = i;
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        if (this.exceptions) {
            var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: e
            });
            return this.exceptions.sendExceptionEvent($e444d6404c095fa5$var$g({}, r, i));
        }
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var i, e;
        return null !== (i = null == (e = this.toolbar) ? void 0 : e.loadToolbar(t)) && void 0 !== i && i;
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $e444d6404c095fa5$var$ln;
        return i !== $e444d6404c095fa5$var$ln && (i = $e444d6404c095fa5$var$ln + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$pe)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($e444d6404c095fa5$var$pe));
    }
    Ni() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $e444d6404c095fa5$var$F(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$e444d6404c095fa5$var$Vi]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$e444d6404c095fa5$var$we]));
    }
    Ai() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.Ni() || this.Ui("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.Ui("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    Ui(t) {
        return "never" === this.config.person_profiles ? ($e444d6404c095fa5$var$$i.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.zi($e444d6404c095fa5$var$we, !0), !0);
    }
    xi() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    Hi() {
        var t, i, e, r, s = this.xi();
        (null == (t = this.persistence) ? void 0 : t.st) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.st) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        var i;
        if ("always" !== this.config.cookieless_mode) {
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) {
                var e, r, s, n, o;
                this.reset(!0), null == (e = this.sessionManager) || e.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $e444d6404c095fa5$var$Ns(this), this.pageViewManager = new $e444d6404c095fa5$var$ir(this), this.persistence && (this.sessionPropsManager = new $e444d6404c095fa5$var$Ds(this, this.sessionManager, this.persistence));
                var a = null !== (s = null == (n = this.config.__extensionClasses) ? void 0 : n.sessionRecording) && void 0 !== s ? s : null == (o = $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses) ? void 0 : o.sessionRecording;
                a && (this.sessionRecording = this.vi(this.sessionRecording, new a(this)));
            }
            var l, u;
            if (this.consent.optInOut(!0), this.Hi(), this.Oi(), null == (i = this.sessionRecording) || i.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode) null == (l = this.surveys) || l.loadIfEnabled();
            if ($e444d6404c095fa5$var$M(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (u = null == t ? void 0 : t.captureEventName) && void 0 !== u ? u : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.Fi();
        } else $e444d6404c095fa5$var$$i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t, i, e;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.Hi(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $e444d6404c095fa5$var$Se,
            $device_id: null
        }), null == (t = this.sessionManager) || t.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (e = this.sessionRecording) || e.stopRecording(), this.sessionRecording = void 0, this.Fi())) : $e444d6404c095fa5$var$$i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === $e444d6404c095fa5$var$qe.GRANTED ? "granted" : t === $e444d6404c095fa5$var$qe.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.Hi();
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n ? $e444d6404c095fa5$var$Us($e444d6404c095fa5$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    Fi() {
        $e444d6404c095fa5$var$o && ("visible" === $e444d6404c095fa5$var$o.visibilityState ? this.gi || (this.gi = !0, this.capture("$pageview", {
            title: $e444d6404c095fa5$var$o.title
        }, {
            send_instantly: !0
        }), this.mi && ($e444d6404c095fa5$var$o.removeEventListener("visibilitychange", this.mi), this.mi = null)) : this.mi || (this.mi = this.Fi.bind(this), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "visibilitychange", this.mi)));
    }
    debug(i) {
        !1 === i ? (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    bt() {
        var t, i, e, r, s, n, o, a = this.Ei || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($e444d6404c095fa5$var$$i.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $e444d6404c095fa5$var$$i, n = (i = "advanced_disable_flags") in (t = a) && !$e444d6404c095fa5$var$j(t[i]), o = e in t && !$e444d6404c095fa5$var$j(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    ji(t) {
        if ($e444d6404c095fa5$var$j(this.config.before_send)) return t;
        var i = $e444d6404c095fa5$var$I(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $e444d6404c095fa5$var$j(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $e444d6404c095fa5$var$B(t.event) ? $e444d6404c095fa5$var$$i.warn(s + ". This can cause unexpected behavior.") : $e444d6404c095fa5$var$$i.info(s), null;
            }
            e.properties && !$e444d6404c095fa5$var$F(e.properties) || $e444d6404c095fa5$var$$i.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.K) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    wi(t) {
        var i = $e444d6404c095fa5$var$z(t) && !t, e = $e444d6404c095fa5$var$je.F() && "true" === $e444d6404c095fa5$var$je.A("ph_debug");
        return !i && (!!e || t);
    }
}
$e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $e444d6404c095fa5$var$Di(t.prototype[i[e]]);
}($e444d6404c095fa5$export$a9d6b9cbf49b8241, [
    "identify"
]);
function $e444d6404c095fa5$var$fn(t) {
    return t instanceof Element && (t.id === $e444d6404c095fa5$var$Ee || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $e444d6404c095fa5$var$pn(t) {
    return !!t && 1 === t.nodeType;
}
function $e444d6404c095fa5$var$_n(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $e444d6404c095fa5$var$gn(t) {
    return !!t && 3 === t.nodeType;
}
function $e444d6404c095fa5$var$mn(t) {
    return !!t && 11 === t.nodeType;
}
function $e444d6404c095fa5$var$bn(t) {
    return t ? $e444d6404c095fa5$var$S(t).split(/\s+/) : [];
}
function $e444d6404c095fa5$var$yn(i) {
    var e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $e444d6404c095fa5$var$wn(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $e444d6404c095fa5$var$bn(i);
}
function $e444d6404c095fa5$var$En(t) {
    return $e444d6404c095fa5$var$j(t) ? null : $e444d6404c095fa5$var$S(t).split(/(\s+)/).filter((t)=>$e444d6404c095fa5$var$Bn(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $e444d6404c095fa5$var$Sn(t) {
    var i = "";
    return $e444d6404c095fa5$var$An(t) && !$e444d6404c095fa5$var$Dn(t) && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ci(t.childNodes, function(t) {
        var e;
        $e444d6404c095fa5$var$gn(t) && t.textContent && (i += null !== (e = $e444d6404c095fa5$var$En(t.textContent)) && void 0 !== e ? e : "");
    }), $e444d6404c095fa5$var$S(i);
}
function $e444d6404c095fa5$var$xn(t) {
    var i;
    return $e444d6404c095fa5$var$M(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $e444d6404c095fa5$var$$n = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $e444d6404c095fa5$var$kn(t, i) {
    if ($e444d6404c095fa5$var$M(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function $e444d6404c095fa5$var$Pn(t) {
    var i = t.parentNode;
    return !(!i || !$e444d6404c095fa5$var$pn(i)) && i;
}
var $e444d6404c095fa5$var$Tn = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $e444d6404c095fa5$var$Rn = 10;
var $e444d6404c095fa5$var$In = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
function $e444d6404c095fa5$var$Cn(i, e) {
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$On(i)) return !1;
    var r, s, n;
    $e444d6404c095fa5$var$z(e) ? (r = !!e && $e444d6404c095fa5$var$In, s = void 0) : (r = null !== (n = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== n ? n : $e444d6404c095fa5$var$In, s = null == e ? void 0 : e.content_ignorelist);
    if (!1 === r) return !1;
    var { targetElementList: o } = $e444d6404c095fa5$var$Fn(i, !1);
    return !function(t, i) {
        if (!1 === t || $e444d6404c095fa5$var$M(t)) return !1;
        var e;
        if (!0 === t) e = $e444d6404c095fa5$var$Tn;
        else {
            if (!$e444d6404c095fa5$var$I(t)) return !1;
            if (t.length > $e444d6404c095fa5$var$Rn) return $e444d6404c095fa5$var$$i.error("[PostHog] content_ignorelist array cannot exceed " + $e444d6404c095fa5$var$Rn + " items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some((t)=>{
            var { safeText: i, ariaLabel: r } = t;
            return e.some((t)=>i.includes(t) || r.includes(t));
        });
    }(s, o.map((t)=>{
        var i;
        return {
            safeText: $e444d6404c095fa5$var$Sn(t).toLowerCase(),
            ariaLabel: (null == (i = t.getAttribute("aria-label")) ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !$e444d6404c095fa5$var$kn(o, r);
}
var $e444d6404c095fa5$var$On = (t)=>!t || $e444d6404c095fa5$var$_n(t, "html") || !$e444d6404c095fa5$var$pn(t), $e444d6404c095fa5$var$Fn = (i, e)=>{
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$On(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !$e444d6404c095fa5$var$_n(n, "body");)if ($e444d6404c095fa5$var$mn(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $e444d6404c095fa5$var$Pn(n);
        if (!o) break;
        if (e || $e444d6404c095fa5$var$$n.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $e444d6404c095fa5$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $e444d6404c095fa5$var$Mn(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$On(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$e444d6404c095fa5$var$yn(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $e444d6404c095fa5$var$yn(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = $e444d6404c095fa5$var$Fn(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($e444d6404c095fa5$var$M(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!$e444d6404c095fa5$var$kn(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = $e444d6404c095fa5$var$t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($e444d6404c095fa5$var$$n.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $e444d6404c095fa5$var$An(t) {
    for(var i = t; i.parentNode && !$e444d6404c095fa5$var$_n(i, "body"); i = i.parentNode){
        var e = $e444d6404c095fa5$var$wn(i);
        if ($e444d6404c095fa5$var$E(e, "ph-sensitive") || $e444d6404c095fa5$var$E(e, "ph-no-capture")) return !1;
    }
    if ($e444d6404c095fa5$var$E($e444d6404c095fa5$var$wn(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($e444d6404c095fa5$var$A(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($e444d6404c095fa5$var$A(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Dn(t) {
    return !!($e444d6404c095fa5$var$_n(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $e444d6404c095fa5$var$_n(t, "select") || $e444d6404c095fa5$var$_n(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $e444d6404c095fa5$var$Ln = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $e444d6404c095fa5$var$jn = new RegExp("^(?:" + $e444d6404c095fa5$var$Ln + ")$"), $e444d6404c095fa5$var$Nn = new RegExp($e444d6404c095fa5$var$Ln), $e444d6404c095fa5$var$Un = "\\d{3}-?\\d{2}-?\\d{4}", $e444d6404c095fa5$var$zn = new RegExp("^(" + $e444d6404c095fa5$var$Un + ")$"), $e444d6404c095fa5$var$Hn = new RegExp("(" + $e444d6404c095fa5$var$Un + ")");
function $e444d6404c095fa5$var$Bn(t, i) {
    if (void 0 === i && (i = !0), $e444d6404c095fa5$var$j(t)) return !1;
    if ($e444d6404c095fa5$var$A(t)) {
        if (t = $e444d6404c095fa5$var$S(t), (i ? $e444d6404c095fa5$var$jn : $e444d6404c095fa5$var$Nn).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $e444d6404c095fa5$var$zn : $e444d6404c095fa5$var$Hn).test(t)) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$qn(t) {
    var i = $e444d6404c095fa5$var$Sn(t);
    return $e444d6404c095fa5$var$Bn(i = (i + " " + $e444d6404c095fa5$var$Vn(t)).trim()) ? i : "";
}
function $e444d6404c095fa5$var$Vn(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ci(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $e444d6404c095fa5$var$Sn(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $e444d6404c095fa5$var$Vn(t)).trim());
        } catch (t) {
            $e444d6404c095fa5$var$$i.error("[AutoCapture]", t);
        }
    }), i;
}
function $e444d6404c095fa5$var$Wn(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $e444d6404c095fa5$var$g({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $e444d6404c095fa5$var$Mi(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$e444d6404c095fa5$var$Gn(i.toString())] = $e444d6404c095fa5$var$Gn(e.toString());
            }), r += ":", r += $e444d6404c095fa5$var$Mi(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $e444d6404c095fa5$var$Yn(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $e444d6404c095fa5$var$Mi(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $e444d6404c095fa5$var$Gn(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $e444d6404c095fa5$var$Yn(t) {
    var i = t.attr__class;
    return i ? $e444d6404c095fa5$var$I(i) ? i : $e444d6404c095fa5$var$bn(i) : void 0;
}
class $e444d6404c095fa5$var$Jn {
    constructor(t){
        this.disabled = !1 === t;
        var i = $e444d6404c095fa5$var$O(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < this.thresholdPx && e - r.timestamp < this.timeoutMs) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $e444d6404c095fa5$var$Kn = "$copy_autocapture", $e444d6404c095fa5$var$Xn = $e444d6404c095fa5$var$ki("[AutoCapture]");
function $e444d6404c095fa5$var$Qn(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $e444d6404c095fa5$var$Zn(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$e444d6404c095fa5$var$pn(i));
    return i;
}
function $e444d6404c095fa5$var$to(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $e444d6404c095fa5$var$$n.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $e444d6404c095fa5$var$Qn(1024, $e444d6404c095fa5$var$qn(t)) : n.$el_text = $e444d6404c095fa5$var$Qn(1024, $e444d6404c095fa5$var$Sn(t)));
    var o = $e444d6404c095fa5$var$wn(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $e444d6404c095fa5$var$Ci(t.attributes, function(e) {
        var s;
        if ((!$e444d6404c095fa5$var$Dn(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $e444d6404c095fa5$var$Bn(e.value) && (s = e.name, !$e444d6404c095fa5$var$A(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $e444d6404c095fa5$var$bn(o).join(" ")), n["attr__" + e.name] = $e444d6404c095fa5$var$Qn(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $e444d6404c095fa5$var$Zn(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $e444d6404c095fa5$var$io(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$e444d6404c095fa5$var$_n(d, "body");)$e444d6404c095fa5$var$mn(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, _ = !1;
    if ($e444d6404c095fa5$var$Ci(h, (t)=>{
        var i = $e444d6404c095fa5$var$An(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $e444d6404c095fa5$var$Bn(p) && p), $e444d6404c095fa5$var$E($e444d6404c095fa5$var$wn(t), "ph-no-capture") && (_ = !0), c.push($e444d6404c095fa5$var$to(t, o, a, l));
        var e = function(t) {
            if (!$e444d6404c095fa5$var$An(t)) return {};
            var i = {};
            return $e444d6404c095fa5$var$Ci(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $e444d6404c095fa5$var$Bn(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $e444d6404c095fa5$var$Oi(f, e);
    }), _) return {
        props: {},
        explicitNoCapture: _
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $e444d6404c095fa5$var$qn(i) : c[0].$el_text = $e444d6404c095fa5$var$Sn(i)), p) {
        var g, m;
        c[0].attr__href = p;
        var b = null == (g = $e444d6404c095fa5$var$er(p)) ? void 0 : g.host, y = null == $e444d6404c095fa5$var$t || null == (m = $e444d6404c095fa5$var$t.location) ? void 0 : m.host;
        b && y && b !== y && (v = p);
    }
    return {
        props: $e444d6404c095fa5$var$Oi({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $e444d6404c095fa5$var$Wn(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
var $e444d6404c095fa5$var$eo = $e444d6404c095fa5$var$ki("[ExceptionAutocapture]");
function $e444d6404c095fa5$var$ro(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $e444d6404c095fa5$var$C(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
var $e444d6404c095fa5$var$so = $e444d6404c095fa5$var$ki("[TracingHeaders]");
var $e444d6404c095fa5$var$no = $e444d6404c095fa5$var$ki("[Web Vitals]"), $e444d6404c095fa5$var$oo = 9e5;
var $e444d6404c095fa5$var$ao = "disabled", $e444d6404c095fa5$var$lo = "lazy_loading", $e444d6404c095fa5$var$uo = "awaiting_config", $e444d6404c095fa5$var$ho = "missing_config";
$e444d6404c095fa5$var$ki("[SessionRecording]");
var $e444d6404c095fa5$var$vo = "[SessionRecording]", $e444d6404c095fa5$var$co = $e444d6404c095fa5$var$ki($e444d6404c095fa5$var$vo);
var $e444d6404c095fa5$var$fo = $e444d6404c095fa5$var$ki("[Heatmaps]");
function $e444d6404c095fa5$var$po(t) {
    return $e444d6404c095fa5$var$O(t) && "clientX" in t && "clientY" in t && $e444d6404c095fa5$var$N(t.clientX) && $e444d6404c095fa5$var$N(t.clientY);
}
var $e444d6404c095fa5$var$_o = $e444d6404c095fa5$var$ki("[Product Tours]"), $e444d6404c095fa5$var$go = "ph_product_tours";
var $e444d6404c095fa5$var$mo = [
    "$set_once",
    "$set"
], $e444d6404c095fa5$var$bo = $e444d6404c095fa5$var$ki("[SiteApps]");
function $e444d6404c095fa5$var$yo(t, i, e) {
    if ($e444d6404c095fa5$var$j(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            var r = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $e444d6404c095fa5$var$wo {
    constructor(t){
        this.Bi = new $e444d6404c095fa5$var$Ls, this.qi = (t, i)=>this.Vi(t, i) && this.Wi(t, i) && this.Gi(t, i) && this.Yi(t, i), this.Vi = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.Ji = new Set, this.Ki = new Set;
    }
    init() {
        var t;
        if (!$e444d6404c095fa5$var$M(null == (t = this._instance) ? void 0 : t._addCaptureHook)) {
            var i;
            null == (i = this._instance) || i._addCaptureHook((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$e444d6404c095fa5$var$M(null == (i = this._instance) ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Ki) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Ji) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Ji.has(t) || this.Ji.has(null == i ? void 0 : i.event)) && this.Ki && (null == (e = this.Ki) ? void 0 : e.size) > 0 && this.Ki.forEach((t)=>{
            this.Xi(i, t) && this.Bi.emit("actionCaptured", t.name);
        });
    }
    Qi(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Xi(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.qi(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Bi.on(t, i);
    }
    Wi(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$e444d6404c095fa5$var$yo(r, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    Gi(t, i) {
        return !!this.Zi(t, i) && !!this.te(t, i) && !!this.ie(t, i);
    }
    Zi(t, i) {
        var e;
        if (null == i || !i.href) return !0;
        var r = this.ee(t);
        if (r.length > 0) return r.some((t)=>$e444d6404c095fa5$var$yo(t.href, i.href, i.href_matching || "exact"));
        var s, n = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!n && $e444d6404c095fa5$var$yo((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", i.href, i.href_matching || "exact");
    }
    te(t, i) {
        var e;
        if (null == i || !i.text) return !0;
        var r = this.ee(t);
        if (r.length > 0) return r.some((t)=>$e444d6404c095fa5$var$yo(t.text, i.text, i.text_matching || "exact") || $e444d6404c095fa5$var$yo(t.$el_text, i.text, i.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var i, e = [], r = /(?::|")text="(.*?)"/g; !$e444d6404c095fa5$var$j(i = r.exec(t));)e.includes(i[1]) || e.push(i[1]);
            return e;
        }(a), n = i.text, o = i.text_matching || "exact", s.some((t)=>$e444d6404c095fa5$var$yo(t, n, o)));
    }
    ie(t, i) {
        var e, r;
        if (null == i || !i.selector) return !0;
        var s = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
        if (null != s && s.includes(i.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (i.selector_regex && n) try {
            return new RegExp(i.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    ee(t) {
        var i;
        return null == (null == t || null == (i = t.properties) ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Yi(t, i) {
        return null == i || !i.properties || 0 === i.properties.length || $e444d6404c095fa5$var$Vs(i.properties.reduce((t, i)=>{
            var e = $e444d6404c095fa5$var$I(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $e444d6404c095fa5$var$Eo {
    constructor(t){
        this._instance = t, this.re = new Map, this.se = new Map, this.ne = new Map;
    }
    oe(t, i) {
        return !!t && $e444d6404c095fa5$var$Vs(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    ae(t, i) {
        var e = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[i]) || null == (r = r.values) || r.forEach((i)=>{
                if (null != i && i.name) {
                    var r = e.get(i.name) || [];
                    r.push(t.id), e.set(i.name, r);
                }
            });
        }), e;
    }
    le(t, i, e) {
        var r = (e === $e444d6404c095fa5$export$352273f853caad57.Activation ? this.re : this.se).get(t), s = [];
        return this.ue((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[e]) || null == (s = s.values) ? void 0 : s.find((i)=>i.name === t);
            return this.oe(n, i);
        });
    }
    register(t) {
        var i;
        $e444d6404c095fa5$var$M(null == (i = this._instance) ? void 0 : i._addCaptureHook) || (this.he(t), this.de(t));
    }
    de(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.ve) {
                this.ve = new $e444d6404c095fa5$var$wo(this._instance), this.ve.init();
                this.ve.Qi((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.ve) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.ne.get(i.name);
                        e && e.push(t.id), this.ne.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    he(t) {
        var i, e = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.cancelEvents) && (null == (e = t.conditions) || null == (e = e.cancelEvents) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== e.length || 0 !== r.length) null == (i = this._instance) || i._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        }), this.re = this.ae(t, $e444d6404c095fa5$export$352273f853caad57.Activation), this.se = this.ae(t, $e444d6404c095fa5$export$352273f853caad57.Cancellation);
    }
    onEvent(t, i) {
        var e, r = this.ce(), s = this.fe(), n = this.pe(), o = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[s]) || [];
        if (n === t && i && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: i,
                existingActivatedItems: o
            });
            var u = (null == i || null == (a = i.properties) ? void 0 : a.$survey_id) || (null == i || null == (l = i.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                h >= 0 && (o.splice(h, 1), this._e(o));
            }
        } else {
            if (this.se.has(t)) {
                var d = this.le(t, i, $e444d6404c095fa5$export$352273f853caad57.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var i = o.indexOf(t.id);
                    i >= 0 && o.splice(i, 1), this.ge(t.id);
                }), this._e(o));
            }
            if (this.re.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: i,
                    items: this.re.get(t)
                });
                var v = this.le(t, i, $e444d6404c095fa5$export$352273f853caad57.Activation);
                this._e(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var i, e = this.fe(), r = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[e]) || [];
        this.ne.has(t) && this._e(r.concat(this.ne.get(t) || []));
    }
    _e(t) {
        var i, e = this.ce(), r = this.fe(), s = [
            ...new Set(t)
        ].filter((t)=>!this.me(t));
        e.info("updating activated items", {
            activatedItems: s
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [r]: s
        });
    }
    getActivatedIds() {
        var t, i = this.fe(), e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[i];
        return e || [];
    }
    getEventToItemsMap() {
        return this.re;
    }
    be() {
        return this.ve;
    }
}
class $e444d6404c095fa5$var$So extends $e444d6404c095fa5$var$Eo {
    constructor(t){
        super(t);
    }
    fe() {
        return "$surveys_activated";
    }
    pe() {
        return $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN;
    }
    ue(t) {
        var i;
        null == (i = this._instance) || i.getSurveys(t);
    }
    ge(t) {
        var i;
        null == (i = this._instance) || i.cancelPendingSurvey(t);
    }
    ce() {
        return $e444d6404c095fa5$var$Js;
    }
    me() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
var $e444d6404c095fa5$var$xo = null != $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.location ? $e444d6404c095fa5$var$or($e444d6404c095fa5$var$t.location.hash, "__posthog") || $e444d6404c095fa5$var$or(location.hash, "state") : null, $e444d6404c095fa5$var$$o = "_postHogToolbarParams", $e444d6404c095fa5$var$ko = $e444d6404c095fa5$var$ki("[Toolbar]"), $e444d6404c095fa5$var$Po = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($e444d6404c095fa5$var$Po || {});
var $e444d6404c095fa5$var$To = $e444d6404c095fa5$var$ki("[FeatureFlags]"), $e444d6404c095fa5$var$Ro = $e444d6404c095fa5$var$ki("[FeatureFlags]", {
    debugEnabled: !0
}), $e444d6404c095fa5$var$Io = "errors_while_computing_flags", $e444d6404c095fa5$var$Co = "flag_missing", $e444d6404c095fa5$var$Oo = "quota_limited", $e444d6404c095fa5$var$Fo = "timeout", $e444d6404c095fa5$var$Mo = "connection_error", $e444d6404c095fa5$var$Ao = "unknown_error", $e444d6404c095fa5$var$Do = (t)=>"api_error_" + t, $e444d6404c095fa5$var$Lo = "$active_feature_flags", $e444d6404c095fa5$var$jo = "$override_feature_flags", $e444d6404c095fa5$var$No = "$feature_flag_payloads", $e444d6404c095fa5$var$Uo = "$override_feature_flag_payloads", $e444d6404c095fa5$var$zo = "$feature_flag_request_id", $e444d6404c095fa5$var$Ho = (t)=>{
    var i = {};
    for (var [e, r] of $e444d6404c095fa5$var$Mi(t || {}))r && (i[e] = r);
    return i;
}, $e444d6404c095fa5$var$Bo = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $e444d6404c095fa5$var$To.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $e444d6404c095fa5$var$qo = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
var $e444d6404c095fa5$var$Vo = $e444d6404c095fa5$var$ki("[Error tracking]");
var $e444d6404c095fa5$var$Wo = {
    icontains: (i, e)=>!!$e444d6404c095fa5$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$e444d6404c095fa5$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$e444d6404c095fa5$var$t && $e444d6404c095fa5$var$zs(e.href, i),
    not_regex: (i, e)=>!!$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$zs(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $e444d6404c095fa5$var$Go {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $e444d6404c095fa5$var$Go.ye("retrieved web experiments from the server"), i.we = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.we) $e444d6404c095fa5$var$Go.ye("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.we) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $e444d6404c095fa5$var$A(r) && t.variants[r] && i.Ee(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $e444d6404c095fa5$var$Go.Se(n) && i.Ee(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    initialize() {}
    onFeatureFlags(t) {
        if (this._is_bot()) $e444d6404c095fa5$var$Go.ye("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($e444d6404c095fa5$var$j(this.we)) return this.we = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $e444d6404c095fa5$var$Go.ye("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.we && null != (i = this.we) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.we) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.Ee(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $e444d6404c095fa5$var$Go.getWindowLocation();
        if (null != t && t.search) {
            var i = $e444d6404c095fa5$var$sr(null == t ? void 0 : t.search, "__experiment_id"), e = $e444d6404c095fa5$var$sr(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($e444d6404c095fa5$var$Go.ye("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.xe(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    xe(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($e444d6404c095fa5$var$Go.ye("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.Ee(r[0].name, i, r[0].variants[i].transforms));
    }
    static Se(t) {
        return !$e444d6404c095fa5$var$j(t.conditions) && $e444d6404c095fa5$var$Go.$e(t) && $e444d6404c095fa5$var$Go.ke(t);
    }
    static $e(t) {
        var i;
        if ($e444d6404c095fa5$var$j(t.conditions) || $e444d6404c095fa5$var$j(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $e444d6404c095fa5$var$Go.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $e444d6404c095fa5$var$Wo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location;
    }
    static ke(t) {
        var i;
        if ($e444d6404c095fa5$var$j(t.conditions) || $e444d6404c095fa5$var$j(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $e444d6404c095fa5$var$vr();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static ye(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $e444d6404c095fa5$var$$i.info("[WebExperiments] " + t, e);
    }
    Ee(t, i, e) {
        this._is_bot() ? $e444d6404c095fa5$var$Go.ye("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $e444d6404c095fa5$var$Go.ye("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $e444d6404c095fa5$var$Go.ye("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n && this._instance ? $e444d6404c095fa5$var$Us($e444d6404c095fa5$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $e444d6404c095fa5$var$Yo = $e444d6404c095fa5$var$ki("[Conversations]");
var $e444d6404c095fa5$var$Jo = {
    featureFlags: class {
        constructor(t){
            this.Pe = !1, this.Te = !1, this.Re = !1, this.Ie = !1, this.Ce = !1, this.Oe = !1, this.Fe = !1, this.Me = !1, this._instance = t, this.featureFlagEventHandlers = [];
        }
        Ae() {
            var t, i;
            return null !== (t = null == (i = this._instance.persistence) ? void 0 : i.nt(this._instance.config.feature_flag_cache_ttl_ms)) && void 0 !== t && t;
        }
        De() {
            return !!this.Ae() && (this.Me || this.Re || (this.Me = !0, $e444d6404c095fa5$var$To.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        Le() {
            var t, i = null !== (t = this._instance.config.evaluation_contexts) && void 0 !== t ? t : this._instance.config.evaluation_environments;
            return !this._instance.config.evaluation_environments || this._instance.config.evaluation_contexts || this.Fe || ($e444d6404c095fa5$var$To.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Fe = !0), null != i && i.length ? i.filter((t)=>{
                var i = t && "string" == typeof t && t.trim().length > 0;
                return i || $e444d6404c095fa5$var$To.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
            }) : [];
        }
        je() {
            return this.Le().length > 0;
        }
        initialize() {
            var t, i, { config: e } = this._instance, r = null !== (t = null == (i = e.bootstrap) ? void 0 : i.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(r).length) {
                var s, n, o = null !== (s = null == (n = e.bootstrap) ? void 0 : n.featureFlagPayloads) && void 0 !== s ? s : {}, a = Object.keys(r).filter((t)=>!!r[t]).reduce((t, i)=>(t[i] = r[i] || !1, t), {}), l = Object.keys(o).filter((t)=>a[t]).reduce((t, i)=>(o[i] && (t[i] = o[i]), t), {});
                this.receivedFeatureFlags({
                    featureFlags: a,
                    featureFlagPayloads: l
                });
            }
        }
        updateFlags(t, i, e) {
            var r = null != e && e.merge ? this.getFlagVariants() : {}, s = null != e && e.merge ? this.getFlagPayloads() : {}, n = $e444d6404c095fa5$var$g({}, r, t), o = $e444d6404c095fa5$var$g({}, s, i), a = {};
            for (var [l, u] of Object.entries(n)){
                var h = "string" == typeof u;
                a[l] = {
                    key: l,
                    enabled: !!h || Boolean(u),
                    variant: h ? u : void 0,
                    reason: void 0,
                    metadata: $e444d6404c095fa5$var$M(null == o ? void 0 : o[l]) ? void 0 : {
                        id: 0,
                        version: void 0,
                        description: void 0,
                        payload: o[l]
                    }
                };
            }
            this.receivedFeatureFlags({
                flags: a
            });
        }
        get hasLoadedFlags() {
            return this.Te;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            var t = this._instance.get_property($e444d6404c095fa5$var$ae), i = this._instance.get_property($e444d6404c095fa5$var$jo), e = this._instance.get_property($e444d6404c095fa5$var$Uo);
            if (!e && !i) return t || {};
            var r = $e444d6404c095fa5$var$Oi({}, t || {}), s = [
                ...new Set([
                    ...Object.keys(e || {}),
                    ...Object.keys(i || {})
                ])
            ];
            for (var n of s){
                var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $e444d6404c095fa5$var$M(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $e444d6404c095fa5$var$M(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $e444d6404c095fa5$var$g({}, l, {
                    enabled: h,
                    variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
                });
                if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $e444d6404c095fa5$var$g({}, null == l ? void 0 : l.metadata, {
                    payload: v,
                    original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
                });
                r[n] = c;
            }
            return this.Pe || ($e444d6404c095fa5$var$To.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: e,
                finalDetails: r
            }), this.Pe = !0), r;
        }
        getFlagVariants() {
            var t = this._instance.get_property($e444d6404c095fa5$var$ne), i = this._instance.get_property($e444d6404c095fa5$var$jo);
            if (!i) return t || {};
            for(var e = $e444d6404c095fa5$var$Oi({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
            return this.Pe || ($e444d6404c095fa5$var$To.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: i,
                finalFlags: e
            }), this.Pe = !0), e;
        }
        getFlagPayloads() {
            var t = this._instance.get_property($e444d6404c095fa5$var$No), i = this._instance.get_property($e444d6404c095fa5$var$Uo);
            if (!i) return t || {};
            for(var e = $e444d6404c095fa5$var$Oi({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
            return this.Pe || ($e444d6404c095fa5$var$To.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: i,
                finalPayloads: e
            }), this.Pe = !0), e;
        }
        reloadFeatureFlags() {
            this.Ie || this._instance.config.advanced_disable_feature_flags || this.Ne || (this._instance.pi.emit("featureFlagsReloading", !0), this.Ne = setTimeout(()=>{
                this.Ue();
            }, 5));
        }
        ze() {
            clearTimeout(this.Ne), this.Ne = void 0;
        }
        ensureFlagsLoaded() {
            this.Te || this.Re || this.Ne || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.Ie = t;
        }
        Ue(t) {
            var i;
            if (this.ze(), !this._instance.bt()) {
                if (this.Re) this.Ce = !0;
                else {
                    var e = this._instance.config.token, r = this._instance.get_property("$device_id"), s = {
                        token: e,
                        distinct_id: this._instance.get_distinct_id(),
                        groups: this._instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: $e444d6404c095fa5$var$g({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($e444d6404c095fa5$var$le) || {}),
                        group_properties: this._instance.get_property($e444d6404c095fa5$var$ue),
                        timezone: $e444d6404c095fa5$var$br()
                    };
                    $e444d6404c095fa5$var$L(r) || $e444d6404c095fa5$var$M(r) || (s.$device_id = r), (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (s.disable_flags = !0), this.je() && (s.evaluation_contexts = this.Le());
                    var n = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", o = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + n);
                    this.Re = !0, this._instance._send_request({
                        method: "POST",
                        url: o,
                        data: s,
                        compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                        timeout: this._instance.config.feature_flag_request_timeout_ms,
                        callback: (t)=>{
                            var i, e, r, n = !0;
                            if (200 === t.statusCode && (this.Ce || (this.$anon_distinct_id = void 0), n = !1), this.Re = !1, !s.disable_flags || this.Ce) {
                                this.Oe = !n;
                                var o = [];
                                t.error ? t.error instanceof Error ? o.push("AbortError" === t.error.name ? $e444d6404c095fa5$var$Fo : $e444d6404c095fa5$var$Mo) : o.push($e444d6404c095fa5$var$Ao) : 200 !== t.statusCode && o.push($e444d6404c095fa5$var$Do(t.statusCode)), null != (i = t.json) && i.errorsWhileComputingFlags && o.push($e444d6404c095fa5$var$Io);
                                var a = !(null == (e = t.json) || null == (e = e.quotaLimited) || !e.includes($e444d6404c095fa5$var$qo.FeatureFlags));
                                if (a && o.push($e444d6404c095fa5$var$Oo), null == (r = this._instance.persistence) || r.register({
                                    [$e444d6404c095fa5$var$ce]: o
                                }), a) $e444d6404c095fa5$var$To.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                                else {
                                    var l;
                                    if (!s.disable_flags) this.receivedFeatureFlags(null !== (l = t.json) && void 0 !== l ? l : {}, n);
                                    this.Ce && (this.Ce = !1, this.Ue());
                                }
                            }
                        }
                    });
                }
            }
        }
        getFeatureFlag(t, i) {
            var e;
            if (void 0 === i && (i = {}), !i.fresh || this.Oe) {
                if (this.Te || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.De()) {
                        var r = this.getFeatureFlagResult(t, i);
                        return null !== (e = null == r ? void 0 : r.variant) && void 0 !== e ? e : null == r ? void 0 : r.enabled;
                    }
                } else $e444d6404c095fa5$var$To.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
            }
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            var i = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == i ? void 0 : i.payload;
        }
        getFeatureFlagResult(t, i) {
            if (void 0 === i && (i = {}), !i.fresh || this.Oe) {
                if (this.Te || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.De()) {
                        var e = this.getFlagVariants(), r = t in e, s = e[t], n = this.getFlagPayloads()[t], o = String(s), a = this._instance.get_property($e444d6404c095fa5$var$zo) || void 0, l = this._instance.get_property($e444d6404c095fa5$var$fe) || void 0, u = this._instance.get_property($e444d6404c095fa5$var$de) || {};
                        if (this._instance.config.advanced_feature_flags_dedup_per_session) {
                            var h, d = this._instance.get_session_id(), v = this._instance.get_property($e444d6404c095fa5$var$ve);
                            if (d && d !== v) u = {}, null == (h = this._instance.persistence) || h.register({
                                [$e444d6404c095fa5$var$de]: u,
                                [$e444d6404c095fa5$var$ve]: d
                            });
                        }
                        if ((i.send_event || !("send_event" in i)) && (!(t in u) || !u[t].includes(o))) {
                            var c, f, p, _, g, m, b, y, w, E;
                            $e444d6404c095fa5$var$I(u[t]) ? u[t].push(o) : u[t] = [
                                o
                            ], null == (c = this._instance.persistence) || c.register({
                                [$e444d6404c095fa5$var$de]: u
                            });
                            var S = this.getFeatureFlagDetails(t), x = [
                                ...null !== (f = this._instance.get_property($e444d6404c095fa5$var$ce)) && void 0 !== f ? f : []
                            ];
                            $e444d6404c095fa5$var$M(s) && x.push($e444d6404c095fa5$var$Co);
                            var k = {
                                $feature_flag: t,
                                $feature_flag_response: s,
                                $feature_flag_payload: n || null,
                                $feature_flag_request_id: a,
                                $feature_flag_evaluated_at: l,
                                $feature_flag_bootstrapped_response: (null == (p = this._instance.config.bootstrap) || null == (p = p.featureFlags) ? void 0 : p[t]) || null,
                                $feature_flag_bootstrapped_payload: (null == (_ = this._instance.config.bootstrap) || null == (_ = _.featureFlagPayloads) ? void 0 : _[t]) || null,
                                $used_bootstrap_value: !this.Oe
                            };
                            $e444d6404c095fa5$var$M(null == S || null == (g = S.metadata) ? void 0 : g.version) || (k.$feature_flag_version = S.metadata.version);
                            var P, T = null !== (m = null == S || null == (b = S.reason) ? void 0 : b.description) && void 0 !== m ? m : null == S || null == (y = S.reason) ? void 0 : y.code;
                            if (T && (k.$feature_flag_reason = T), null != S && null != (w = S.metadata) && w.id && (k.$feature_flag_id = S.metadata.id), $e444d6404c095fa5$var$M(null == S ? void 0 : S.original_variant) && $e444d6404c095fa5$var$M(null == S ? void 0 : S.original_enabled) || (k.$feature_flag_original_response = $e444d6404c095fa5$var$M(S.original_variant) ? S.original_enabled : S.original_variant), null != S && null != (E = S.metadata) && E.original_payload) k.$feature_flag_original_payload = null == S || null == (P = S.metadata) ? void 0 : P.original_payload;
                            x.length && (k.$feature_flag_error = x.join(",")), this._instance.capture("$feature_flag_called", k);
                        }
                        if (r) {
                            var R = n;
                            if (!$e444d6404c095fa5$var$M(n)) try {
                                R = JSON.parse(n);
                            } catch (t) {}
                            return {
                                key: t,
                                enabled: !!s,
                                variant: "string" == typeof s ? s : void 0,
                                payload: R
                            };
                        }
                    }
                } else $e444d6404c095fa5$var$To.warn('getFeatureFlagResult for key "' + t + "\" failed. Feature flags didn't load in time.");
            }
        }
        getRemoteConfigPayload(t, i) {
            var e = this._instance.config.token, r = {
                distinct_id: this._instance.get_distinct_id(),
                token: e
            };
            this.je() && (r.evaluation_contexts = this.Le()), this._instance._send_request({
                method: "POST",
                url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"),
                data: r,
                compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                timeout: this._instance.config.feature_flag_request_timeout_ms,
                callback: (e)=>{
                    var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                    i((null == s ? void 0 : s[t]) || void 0);
                }
            });
        }
        isFeatureEnabled(t, i) {
            if (void 0 === i && (i = {}), !i.fresh || this.Oe) {
                if (this.Te || this.getFlags() && this.getFlags().length > 0) {
                    var e = this.getFeatureFlag(t, i);
                    return $e444d6404c095fa5$var$M(e) ? void 0 : !!e;
                }
                $e444d6404c095fa5$var$To.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
            }
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
        }
        receivedFeatureFlags(t, i) {
            if (this._instance.persistence) {
                this.Te = !0;
                var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
                !function(t, i, e, r, s) {
                    void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                    var n = $e444d6404c095fa5$var$Bo(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                    if (a) {
                        var u = t.requestId, h = t.evaluatedAt;
                        if ($e444d6404c095fa5$var$I(a)) {
                            $e444d6404c095fa5$var$To.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                            var d = {};
                            if (a) for(var v = 0; v < a.length; v++)d[a[v]] = !0;
                            i && i.register({
                                [$e444d6404c095fa5$var$Lo]: a,
                                [$e444d6404c095fa5$var$ne]: d
                            });
                        } else {
                            var c = a, f = l, p = o;
                            if (t.errorsWhileComputingFlags) {
                                if (o) {
                                    var _ = new Set(Object.keys(o).filter((t)=>{
                                        var i;
                                        return !(null != (i = o[t]) && i.failed);
                                    }));
                                    c = $e444d6404c095fa5$var$g({}, e, Object.fromEntries(Object.entries(c).filter((t)=>{
                                        var [i] = t;
                                        return _.has(i);
                                    }))), f = $e444d6404c095fa5$var$g({}, r, Object.fromEntries(Object.entries(f || {}).filter((t)=>{
                                        var [i] = t;
                                        return _.has(i);
                                    }))), p = $e444d6404c095fa5$var$g({}, s, Object.fromEntries(Object.entries(p || {}).filter((t)=>{
                                        var [i] = t;
                                        return _.has(i);
                                    })));
                                } else c = $e444d6404c095fa5$var$g({}, e, c), f = $e444d6404c095fa5$var$g({}, r, f), p = $e444d6404c095fa5$var$g({}, s, p);
                            }
                            i && i.register($e444d6404c095fa5$var$g({
                                [$e444d6404c095fa5$var$Lo]: Object.keys($e444d6404c095fa5$var$Ho(c)),
                                [$e444d6404c095fa5$var$ne]: c || {},
                                [$e444d6404c095fa5$var$No]: f || {},
                                [$e444d6404c095fa5$var$ae]: p || {}
                            }, u ? {
                                [$e444d6404c095fa5$var$zo]: u
                            } : {}, h ? {
                                [$e444d6404c095fa5$var$fe]: h
                            } : {}));
                        }
                    }
                }(t, this._instance.persistence, e, r, s), i || (this.Me = !1), this.He(i);
            }
        }
        override(t, i) {
            void 0 === i && (i = !1), $e444d6404c095fa5$var$To.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: i
            });
        }
        overrideFeatureFlags(t) {
            if (!this._instance.__loaded || !this._instance.persistence) return $e444d6404c095fa5$var$To.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
            if (!1 === t) return this._instance.persistence.unregister($e444d6404c095fa5$var$jo), this._instance.persistence.unregister($e444d6404c095fa5$var$Uo), this.He(), $e444d6404c095fa5$var$Ro.info("All overrides cleared");
            if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                var i, e = t;
                if (this.Pe = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                    if (!1 === e.flags) this._instance.persistence.unregister($e444d6404c095fa5$var$jo), $e444d6404c095fa5$var$Ro.info("Flag overrides cleared");
                    else if (e.flags) {
                        if ($e444d6404c095fa5$var$I(e.flags)) {
                            for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                            this._instance.persistence.register({
                                [$e444d6404c095fa5$var$jo]: r
                            });
                        } else this._instance.persistence.register({
                            [$e444d6404c095fa5$var$jo]: e.flags
                        });
                        $e444d6404c095fa5$var$Ro.info("Flag overrides set", {
                            flags: e.flags
                        });
                    }
                }
                return "payloads" in e && (!1 === e.payloads ? (this._instance.persistence.unregister($e444d6404c095fa5$var$Uo), $e444d6404c095fa5$var$Ro.info("Payload overrides cleared")) : e.payloads && (this._instance.persistence.register({
                    [$e444d6404c095fa5$var$Uo]: e.payloads
                }), $e444d6404c095fa5$var$Ro.info("Payload overrides set", {
                    payloads: e.payloads
                }))), void this.He();
            }
            this.He();
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.Te) {
                var { flags: i, flagVariants: e } = this.Be();
                t(i, e);
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, i, e) {
            var r, s = (this._instance.get_property($e444d6404c095fa5$var$oe) || []).find((i)=>i.flagKey === t), n = {
                ["$feature_enrollment/" + t]: i
            }, o = {
                $feature_flag: t,
                $feature_enrollment: i,
                $set: n
            };
            s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
            var a = $e444d6404c095fa5$var$g({}, this.getFlagVariants(), {
                [t]: i
            });
            null == (r = this._instance.persistence) || r.register({
                [$e444d6404c095fa5$var$Lo]: Object.keys($e444d6404c095fa5$var$Ho(a)),
                [$e444d6404c095fa5$var$ne]: a
            }), this.He();
        }
        getEarlyAccessFeatures(t, i, e) {
            void 0 === i && (i = !1);
            var r = this._instance.get_property($e444d6404c095fa5$var$oe), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
            if (r && !i) return t(r);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
                method: "GET",
                callback: (i)=>{
                    var e, r;
                    if (i.json) {
                        var s = i.json.earlyAccessFeatures;
                        return null == (e = this._instance.persistence) || e.unregister($e444d6404c095fa5$var$oe), null == (r = this._instance.persistence) || r.register({
                            [$e444d6404c095fa5$var$oe]: s
                        }), t(s);
                    }
                }
            });
        }
        Be() {
            var t = this.getFlags(), i = this.getFlagVariants();
            return {
                flags: t.filter((t)=>i[t]),
                flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
            };
        }
        He(t) {
            var { flags: i, flagVariants: e } = this.Be();
            this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                    errorsLoading: t
                }));
        }
        setPersonPropertiesForFlags(t, i) {
            void 0 === i && (i = !0);
            var e = this._instance.get_property($e444d6404c095fa5$var$le) || {};
            this._instance.register({
                [$e444d6404c095fa5$var$le]: $e444d6404c095fa5$var$g({}, e, t)
            }), i && this._instance.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags() {
            this._instance.unregister($e444d6404c095fa5$var$le);
        }
        setGroupPropertiesForFlags(t, i) {
            void 0 === i && (i = !0);
            var e = this._instance.get_property($e444d6404c095fa5$var$ue) || {};
            0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
                e[i] = $e444d6404c095fa5$var$g({}, e[i], t[i]), delete t[i];
            }), this._instance.register({
                [$e444d6404c095fa5$var$ue]: $e444d6404c095fa5$var$g({}, e, t)
            }), i && this._instance.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                var i = this._instance.get_property($e444d6404c095fa5$var$ue) || {};
                this._instance.register({
                    [$e444d6404c095fa5$var$ue]: $e444d6404c095fa5$var$g({}, i, {
                        [t]: {}
                    })
                });
            } else this._instance.unregister($e444d6404c095fa5$var$ue);
        }
        reset() {
            this.Te = !1, this.Re = !1, this.Ie = !1, this.Ce = !1, this.Oe = !1, this.$anon_distinct_id = void 0, this.ze(), this.Pe = !1;
        }
    }
}, $e444d6404c095fa5$var$Ko = {
    sessionRecording: class {
        get started() {
            var t;
            return !(null == (t = this.qe) || !t.isStarted);
        }
        get status() {
            var t, i;
            return this.Ve === $e444d6404c095fa5$var$uo || this.Ve === $e444d6404c095fa5$var$ho ? this.Ve : null !== (t = null == (i = this.qe) ? void 0 : i.status) && void 0 !== t ? t : this.Ve;
        }
        constructor(t){
            if (this._forceAllowLocalhostNetworkCapture = !1, this.Ve = $e444d6404c095fa5$var$ao, this.We = void 0, this._instance = t, !this._instance.sessionManager) throw $e444d6404c095fa5$var$co.error("started without valid sessionManager"), new Error($e444d6404c095fa5$var$vo + " started without valid sessionManager. This is a bug.");
            if ("always" === this._instance.config.cookieless_mode) throw new Error($e444d6404c095fa5$var$vo + ' cannot be used with cookieless_mode="always"');
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        get Ge() {
            var i, e = !(null == (i = this._instance.get_property($e444d6404c095fa5$var$ee)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
            return $e444d6404c095fa5$var$t && e && r && !s;
        }
        startIfEnabledOrStop(t) {
            var i;
            if (!this.Ge || null == (i = this.qe) || !i.isStarted) {
                var e = !$e444d6404c095fa5$var$M(Object.assign) && !$e444d6404c095fa5$var$M(Array.from);
                this.Ge && e ? (this.Ye(t), $e444d6404c095fa5$var$co.info("starting")) : (this.Ve = $e444d6404c095fa5$var$ao, this.stopRecording());
            }
        }
        Ye(t) {
            var i, e, r;
            this.Ge && (this.Ve !== $e444d6404c095fa5$var$uo && this.Ve !== $e444d6404c095fa5$var$ho && (this.Ve = $e444d6404c095fa5$var$lo), null != $e444d6404c095fa5$var$v && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.initSessionRecording ? this.Je(t) : null == (r = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Ke, (i)=>{
                if (i) return $e444d6404c095fa5$var$co.error("could not load recorder", i);
                this.Je(t);
            }));
        }
        stopRecording() {
            var t, i;
            null == (t = this.We) || t.call(this), this.We = void 0, null == (i = this.qe) || i.stop();
        }
        Xe() {
            var t, i;
            null == (t = this.We) || t.call(this), this.We = void 0, null == (i = this.qe) || i.discard();
        }
        Qe() {
            var t;
            null == (t = this._instance.persistence) || t.unregister($e444d6404c095fa5$var$se);
        }
        Ze(t, i) {
            if ($e444d6404c095fa5$var$j(t)) return null;
            var e, r = $e444d6404c095fa5$var$N(t) ? t : parseFloat(t);
            return "number" == typeof (e = r) && Number.isFinite(e) && e >= 0 && e <= 1 ? r : ($e444d6404c095fa5$var$co.warn(i + " must be between 0 and 1. Ignoring invalid value:", t), null);
        }
        tr(t) {
            if (this._instance.persistence) {
                var i, e, r = this._instance.persistence, s = ()=>{
                    var i, e = !1 === t.sessionRecording ? void 0 : t.sessionRecording, s = this.Ze(null == (i = this._instance.config.session_recording) ? void 0 : i.sampleRate, "session_recording.sampleRate"), n = this.Ze(null == e ? void 0 : e.sampleRate, "remote config sampleRate"), o = null != s ? s : n;
                    $e444d6404c095fa5$var$j(o) && this.Qe();
                    var a = null == e ? void 0 : e.minimumDurationMilliseconds;
                    r.register({
                        [$e444d6404c095fa5$var$ee]: $e444d6404c095fa5$var$g({
                            cache_timestamp: Date.now(),
                            enabled: !!e
                        }, e, {
                            networkPayloadCapture: $e444d6404c095fa5$var$g({
                                capturePerformance: t.capturePerformance
                            }, null == e ? void 0 : e.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == e ? void 0 : e.recordCanvas,
                                fps: null == e ? void 0 : e.canvasFps,
                                quality: null == e ? void 0 : e.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $e444d6404c095fa5$var$M(a) ? null : a,
                            endpoint: null == e ? void 0 : e.endpoint,
                            triggerMatchType: null == e ? void 0 : e.triggerMatchType,
                            masking: null == e ? void 0 : e.masking,
                            urlTriggers: null == e ? void 0 : e.urlTriggers
                        })
                    });
                };
                s(), null == (i = this.We) || i.call(this), this.We = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
            }
        }
        onRemoteConfig(t) {
            return "sessionRecording" in t ? !1 === t.sessionRecording ? (this.tr(t), void this.Xe()) : (this.tr(t), void this.startIfEnabledOrStop()) : (this.Ve === $e444d6404c095fa5$var$uo && (this.Ve = $e444d6404c095fa5$var$ho, $e444d6404c095fa5$var$co.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, i) {
            var e;
            void 0 === i && (i = "log"), null != (e = this.qe) && e.log ? this.qe.log(t, i) : $e444d6404c095fa5$var$co.warn("log called before recorder was ready");
        }
        get Ke() {
            var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$ee);
            return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
        }
        ir() {
            var t, i = this._instance.get_property($e444d6404c095fa5$var$ee);
            if (!i) return !1;
            var e = null !== (t = ("object" == typeof i ? i : JSON.parse(i)).cache_timestamp) && void 0 !== t ? t : Date.now();
            return Date.now() - e <= 36e5;
        }
        Je(t) {
            var i, e;
            if (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
            this.qe || (this.qe = null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.qe._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
            if (!this.ir()) {
                if (this.Ve === $e444d6404c095fa5$var$ho || this.Ve === $e444d6404c095fa5$var$uo) return;
                return this.Ve = $e444d6404c095fa5$var$uo, $e444d6404c095fa5$var$co.info("persisted remote config is stale, requesting fresh config before starting"), void new $e444d6404c095fa5$var$zr(this._instance).load();
            }
            this.Ve = $e444d6404c095fa5$var$lo, this.qe.start(t);
        }
        onRRwebEmit(t) {
            var i;
            null == (i = this.qe) || null == i.onRRwebEmit || i.onRRwebEmit(t);
        }
        overrideLinkedFlag() {
            var t, i;
            this.qe || null == (i = this._instance.persistence) || i.register({
                $replay_override_linked_flag: !0
            });
            null == (t = this.qe) || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, i;
            this.qe || null == (i = this._instance.persistence) || i.register({
                $replay_override_sampling: !0
            });
            null == (t = this.qe) || t.overrideSampling();
        }
        overrideTrigger(t) {
            var i, e;
            this.qe || null == (e = this._instance.persistence) || e.register({
                ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
            });
            null == (i = this.qe) || i.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            return (null == (t = this.qe) ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            };
        }
        tryAddCustomEvent(t, i) {
            var e;
            return !(null == (e = this.qe) || !e.tryAddCustomEvent(t, i));
        }
    }
}, $e444d6404c095fa5$var$Xo = {
    autocapture: class {
        constructor(t){
            this.er = !1, this.rr = null, this.sr = !1, this.instance = t, this.rageclicks = new $e444d6404c095fa5$var$Jn(t.config.rageclick), this.nr = null;
        }
        initialize() {
            this.startIfEnabled();
        }
        get N() {
            var t, i, e = $e444d6404c095fa5$var$O(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
            return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
        }
        ar() {
            if (this.isBrowserSupported()) {
                if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o) {
                    var i = (i)=>{
                        i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event);
                        try {
                            this.lr(i);
                        } catch (t) {
                            $e444d6404c095fa5$var$Xn.error("Failed to capture event", t);
                        }
                    };
                    if ($e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "submit", i, {
                        capture: !0
                    }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "change", i, {
                        capture: !0
                    }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "click", i, {
                        capture: !0
                    }), this.N.capture_copied_text) {
                        var e = (i)=>{
                            i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event), this.lr(i, $e444d6404c095fa5$var$Kn);
                        };
                        $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "copy", e, {
                            capture: !0
                        }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "cut", e, {
                            capture: !0
                        });
                    }
                }
            } else $e444d6404c095fa5$var$Xn.info("Disabling Automatic Event Collection because this browser is not supported");
        }
        startIfEnabled() {
            this.isEnabled && !this.er && (this.ar(), this.er = !0);
        }
        onRemoteConfig(t) {
            t.elementsChainAsString && (this.sr = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
                [$e444d6404c095fa5$var$Gi]: !!t.autocapture_opt_out
            }), this.rr = !!t.autocapture_opt_out, this.startIfEnabled();
        }
        setElementSelectors(t) {
            this.nr = t;
        }
        getElementSelectors(t) {
            var i, e = [];
            return null == (i = this.nr) || i.forEach((i)=>{
                var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll(i);
                null == r || r.forEach((r)=>{
                    t === r && e.push(i);
                });
            }), e;
        }
        get isEnabled() {
            var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$Gi], r = this.rr;
            if ($e444d6404c095fa5$var$L(r) && !$e444d6404c095fa5$var$z(e) && !this.instance.bt()) return !1;
            var s = null !== (i = this.rr) && void 0 !== i ? i : !!e;
            return !!this.instance.config.autocapture && !s;
        }
        lr(i, e) {
            if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
                var r, s = $e444d6404c095fa5$var$xn(i);
                if ($e444d6404c095fa5$var$gn(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime()) && $e444d6404c095fa5$var$Cn(s, this.instance.config.rageclick) && this.lr(i, "$rageclick");
                var n = e === $e444d6404c095fa5$var$Kn;
                if (s && $e444d6404c095fa5$var$Mn(s, i, this.N, n, n ? [
                    "copy",
                    "cut"
                ] : void 0)) {
                    var { props: o, explicitNoCapture: a } = $e444d6404c095fa5$var$io(s, {
                        e: i,
                        maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                        maskAllText: this.instance.config.mask_all_text,
                        elementAttributeIgnoreList: this.N.element_attribute_ignorelist,
                        elementsChainAsString: this.sr
                    });
                    if (a) return !1;
                    var l = this.getElementSelectors(s);
                    if (l && l.length > 0 && (o.$element_selectors = l), e === $e444d6404c095fa5$var$Kn) {
                        var u, h = $e444d6404c095fa5$var$En(null == $e444d6404c095fa5$var$t || null == (u = $e444d6404c095fa5$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                        if (!h) return !1;
                        o.$selected_content = h, o.$copy_type = d;
                    }
                    return this.instance.capture(e, o), !0;
                }
            }
        }
        isBrowserSupported() {
            return $e444d6404c095fa5$var$C(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll);
        }
    },
    historyAutocapture: class {
        constructor(i){
            var e;
            this._instance = i, this.ur = (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname) || "";
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            return "history_change" === this._instance.config.capture_pageview;
        }
        startIfEnabled() {
            this.isEnabled && ($e444d6404c095fa5$var$$i.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        stop() {
            this.hr && this.hr(), this.hr = void 0, $e444d6404c095fa5$var$$i.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            var i, e;
            if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.history) {
                var r = this;
                null != (i = $e444d6404c095fa5$var$t.history.pushState) && i.__posthog_wrapped__ || $e444d6404c095fa5$var$ro($e444d6404c095fa5$var$t.history, "pushState", (t)=>function(i, e, s) {
                        t.call(this, i, e, s), r.dr("pushState");
                    }), null != (e = $e444d6404c095fa5$var$t.history.replaceState) && e.__posthog_wrapped__ || $e444d6404c095fa5$var$ro($e444d6404c095fa5$var$t.history, "replaceState", (t)=>function(i, e, s) {
                        t.call(this, i, e, s), r.dr("replaceState");
                    }), this.vr();
            }
        }
        dr(i) {
            try {
                var e, r = null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname;
                if (!r) return;
                r !== this.ur && this.isEnabled && this._instance.capture("$pageview", {
                    navigation_type: i
                }), this.ur = r;
            } catch (t) {
                $e444d6404c095fa5$var$$i.error("Error capturing " + i + " pageview", t);
            }
        }
        vr() {
            if (!this.hr) {
                var i = ()=>{
                    this.dr("popstate");
                };
                $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "popstate", i), this.hr = ()=>{
                    $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.removeEventListener("popstate", i);
                };
            }
        }
    },
    heatmaps: class {
        constructor(t){
            var i;
            this.cr = !1, this.er = !1, this.pr = null, this.instance = t, this.cr = !(null == (i = this.instance.persistence) || !i.props[$e444d6404c095fa5$var$Yi]), this.rageclicks = new $e444d6404c095fa5$var$Jn(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            var t = 5e3;
            return $e444d6404c095fa5$var$O(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $e444d6404c095fa5$var$j(this.instance.config.capture_heatmaps) ? $e444d6404c095fa5$var$j(this.instance.config.enable_heatmaps) ? this.cr : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.er) return;
                $e444d6404c095fa5$var$fo.info("starting..."), this._r(), this.gr();
            } else {
                var t;
                clearInterval(null !== (t = this.pr) && void 0 !== t ? t : void 0), this.mr(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if ("heatmaps" in t) {
                var i = !!t.heatmaps;
                this.instance.persistence && this.instance.persistence.register({
                    [$e444d6404c095fa5$var$Yi]: i
                }), this.cr = i, this.startIfEnabled();
            }
        }
        getAndClearBuffer() {
            var t = this.C;
            return this.C = void 0, t;
        }
        br(t) {
            this.yr(t.originalEvent, "deadclick");
        }
        gr() {
            this.pr && clearInterval(this.pr), this.pr = function(t) {
                return "visible" === (null == t ? void 0 : t.visibilityState);
            }($e444d6404c095fa5$var$o) ? setInterval(this.Ft.bind(this), this.flushIntervalMilliseconds) : null;
        }
        _r() {
            $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o && (this.wr = this.Ft.bind(this), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "beforeunload", this.wr), this.Er = (i)=>this.yr(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "click", this.Er, {
                capture: !0
            }), this.Sr = (i)=>this.$r(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "mousemove", this.Sr, {
                capture: !0
            }), this.kr = new $e444d6404c095fa5$var$Je(this.instance, $e444d6404c095fa5$var$Ge, this.br.bind(this)), this.kr.startIfEnabledOrStop(), this.Pr = this.gr.bind(this), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "visibilitychange", this.Pr), this.er = !0);
        }
        mr() {
            var i;
            $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o && (this.wr && $e444d6404c095fa5$var$t.removeEventListener("beforeunload", this.wr), this.Er && $e444d6404c095fa5$var$o.removeEventListener("click", this.Er, {
                capture: !0
            }), this.Sr && $e444d6404c095fa5$var$o.removeEventListener("mousemove", this.Sr, {
                capture: !0
            }), this.Pr && $e444d6404c095fa5$var$o.removeEventListener("visibilitychange", this.Pr), clearTimeout(this.Tr), null == (i = this.kr) || i.stop(), this.er = !1);
        }
        Rr(i, e) {
            var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
                for(var s = i; s && $e444d6404c095fa5$var$pn(s) && !$e444d6404c095fa5$var$_n(s, "body");){
                    if (s === r) return !1;
                    if ($e444d6404c095fa5$var$E(e, null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.getComputedStyle(s).position)) return !0;
                    s = $e444d6404c095fa5$var$Pn(s);
                }
                return !1;
            }($e444d6404c095fa5$var$xn(i), [
                "fixed",
                "sticky"
            ], n);
            return {
                x: i.clientX + (o ? 0 : s),
                y: i.clientY + (o ? 0 : r),
                target_fixed: o,
                type: e
            };
        }
        yr(t, i) {
            var e;
            if (void 0 === i && (i = "click"), !$e444d6404c095fa5$var$fn(t.target) && $e444d6404c095fa5$var$po(t)) {
                var r = this.Rr(t, i);
                null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.Ir($e444d6404c095fa5$var$g({}, r, {
                    type: "rageclick"
                })), this.Ir(r);
            }
        }
        $r(t) {
            !$e444d6404c095fa5$var$fn(t.target) && $e444d6404c095fa5$var$po(t) && (clearTimeout(this.Tr), this.Tr = setTimeout(()=>{
                this.Ir(this.Rr(t, "mousemove"));
            }, 500));
        }
        Ir(i) {
            if ($e444d6404c095fa5$var$t) {
                var e = $e444d6404c095fa5$var$t.location.href, r = this.instance.config.mask_personal_data_properties, s = this.instance.config.custom_personal_data_properties, n = r ? $e444d6404c095fa5$var$Fi([], $e444d6404c095fa5$var$lr, s || []) : [], o = $e444d6404c095fa5$var$nr(e, n, $e444d6404c095fa5$var$hr);
                this.C = this.C || {}, this.C[o] || (this.C[o] = []), this.C[o].push(i);
            }
        }
        Ft() {
            this.C && !$e444d6404c095fa5$var$F(this.C) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $e444d6404c095fa5$var$Je,
    webVitalsAutocapture: class {
        constructor(t){
            var i;
            this.cr = !1, this.er = !1, this.C = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this.Cr = ()=>{
                clearTimeout(this.Or), 0 !== this.C.metrics.length && (this._instance.capture("$web_vitals", this.C.metrics.reduce((t, i)=>$e444d6404c095fa5$var$g({}, t, {
                        ["$web_vitals_" + i.name + "_event"]: $e444d6404c095fa5$var$g({}, i),
                        ["$web_vitals_" + i.name + "_value"]: i.value
                    }), {})), this.C = {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.Fr = (t)=>{
                var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
                if ($e444d6404c095fa5$var$M(e)) $e444d6404c095fa5$var$no.error("Could not read session ID. Dropping metrics!");
                else {
                    this.C = this.C || {
                        url: void 0,
                        metrics: [],
                        firstMetricTimestamp: void 0
                    };
                    var r = this.Mr();
                    if (!$e444d6404c095fa5$var$M(r)) {
                        if ($e444d6404c095fa5$var$j(null == t ? void 0 : t.name) || $e444d6404c095fa5$var$j(null == t ? void 0 : t.value)) $e444d6404c095fa5$var$no.error("Invalid metric received", t);
                        else if (this.Ar && t.value >= this.Ar) $e444d6404c095fa5$var$no.error("Ignoring metric with value >= " + this.Ar, t);
                        else this.C.url !== r && (this.Cr(), this.Or = setTimeout(this.Cr, this.flushToCaptureTimeoutMs)), $e444d6404c095fa5$var$M(this.C.url) && (this.C.url = r), this.C.firstMetricTimestamp = $e444d6404c095fa5$var$M(this.C.firstMetricTimestamp) ? Date.now() : this.C.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.C.metrics.push($e444d6404c095fa5$var$g({}, t, {
                            $current_url: r,
                            $session_id: e.sessionId,
                            $window_id: e.windowId,
                            timestamp: Date.now()
                        })), this.C.metrics.length === this.allowedMetrics.length && this.Cr();
                    }
                }
            }, this.Dr = ()=>{
                if (!this.er) {
                    var t, i, e, r, s = $e444d6404c095fa5$var$v.__PosthogExtensions__;
                    $e444d6404c095fa5$var$M(s) || $e444d6404c095fa5$var$M(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.Fr.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Fr.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.Fr.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.Fr.bind(this)), this.er = !0) : $e444d6404c095fa5$var$no.error("web vitals callbacks not loaded - not starting");
                }
            }, this._instance = t, this.cr = !(null == (i = this._instance.persistence) || !i.props[$e444d6404c095fa5$var$Qi]), this.startIfEnabled();
        }
        get allowedMetrics() {
            var t, i, e = $e444d6404c095fa5$var$O(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $e444d6404c095fa5$var$j(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$e444d6404c095fa5$var$ie]) || [
                "CLS",
                "FCP",
                "INP",
                "LCP"
            ] : e;
        }
        get flushToCaptureTimeoutMs() {
            return ($e444d6404c095fa5$var$O(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get useAttribution() {
            var t = $e444d6404c095fa5$var$O(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_attribution : void 0;
            return null != t && t;
        }
        get Ar() {
            var t = $e444d6404c095fa5$var$O(this._instance.config.capture_performance) && $e444d6404c095fa5$var$N(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $e444d6404c095fa5$var$oo;
            return 0 < t && t <= 6e4 ? $e444d6404c095fa5$var$oo : t;
        }
        get isEnabled() {
            var t = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.protocol;
            if ("http:" !== t && "https:" !== t) return $e444d6404c095fa5$var$no.info("Web Vitals are disabled on non-http/https protocols"), !1;
            var i = $e444d6404c095fa5$var$O(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $e444d6404c095fa5$var$z(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
            return $e444d6404c095fa5$var$z(i) ? i : this.cr;
        }
        startIfEnabled() {
            this.isEnabled && !this.er && ($e444d6404c095fa5$var$no.info("enabled, starting..."), this.G(this.Dr));
        }
        onRemoteConfig(t) {
            if ("capturePerformance" in t) {
                var i = $e444d6404c095fa5$var$O(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $e444d6404c095fa5$var$O(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
                this._instance.persistence && (this._instance.persistence.register({
                    [$e444d6404c095fa5$var$Qi]: i
                }), this._instance.persistence.register({
                    [$e444d6404c095fa5$var$ie]: e
                })), this.cr = i, this.startIfEnabled();
            }
        }
        G(t) {
            var i, e;
            if (null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks) t();
            else {
                var r = this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
                null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, r, (i)=>{
                    i ? $e444d6404c095fa5$var$no.error("failed to load script", i) : t();
                });
            }
        }
        Mr() {
            var i = $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t.location.href : void 0;
            if (i) {
                var e = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, s = e ? $e444d6404c095fa5$var$Fi([], $e444d6404c095fa5$var$lr, r || []) : [];
                return $e444d6404c095fa5$var$nr(i, s, $e444d6404c095fa5$var$hr);
            }
            $e444d6404c095fa5$var$no.error("Could not determine current URL");
        }
    }
}, $e444d6404c095fa5$var$Qo = {
    exceptionObserver: class {
        constructor(i){
            var e, r, s;
            this.Dr = ()=>{
                var i;
                if ($e444d6404c095fa5$var$t && this.isEnabled && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                    var e = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                    try {
                        !this.Lr && this.N.capture_unhandled_errors && (this.Lr = e(this.captureException.bind(this))), !this.jr && this.N.capture_unhandled_rejections && (this.jr = r(this.captureException.bind(this))), !this.Nr && this.N.capture_console_errors && (this.Nr = s(this.captureException.bind(this)));
                    } catch (t) {
                        $e444d6404c095fa5$var$eo.error("failed to start", t), this.Ur();
                    }
                }
            }, this._instance = i, this.zr = !(null == (e = this._instance.persistence) || !e.props[$e444d6404c095fa5$var$Ji]), this.Hr = new $e444d6404c095fa5$var$X({
                refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
                bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
                refillInterval: 1e4,
                h: $e444d6404c095fa5$var$eo
            }), this.N = this.Br(), this.startIfEnabledOrStop();
        }
        Br() {
            var t = this._instance.config.capture_exceptions, i = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $e444d6404c095fa5$var$O(t) ? i = $e444d6404c095fa5$var$g({}, i, t) : ($e444d6404c095fa5$var$M(t) ? this.zr : t) && (i = $e444d6404c095fa5$var$g({}, i, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), i;
        }
        get isEnabled() {
            return this.N.capture_console_errors || this.N.capture_unhandled_errors || this.N.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($e444d6404c095fa5$var$eo.info("enabled"), this.Ur(), this.G(this.Dr)) : this.Ur();
        }
        G(t) {
            var i, e;
            null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
                if (i) return $e444d6404c095fa5$var$eo.error("failed to load script", i);
                t();
            });
        }
        Ur() {
            var t, i, e;
            null == (t = this.Lr) || t.call(this), this.Lr = void 0, null == (i = this.jr) || i.call(this), this.jr = void 0, null == (e = this.Nr) || e.call(this), this.Nr = void 0;
        }
        onRemoteConfig(t) {
            if ("autocaptureExceptions" in t) {
                var i = t.autocaptureExceptions;
                this.zr = !!i || !1, this._instance.persistence && this._instance.persistence.register({
                    [$e444d6404c095fa5$var$Ji]: this.zr
                }), this.N = this.Br(), this.startIfEnabledOrStop();
            }
        }
        onConfigChange() {
            this.N = this.Br();
        }
        captureException(t) {
            var i, e, r, s = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
            this.Hr.consumeRateLimit(s) ? $e444d6404c095fa5$var$eo.info("Skipping exception capture because of client rate limiting.", {
                exception: s
            }) : null == (r = this._instance.exceptions) || r.sendExceptionEvent(t);
        }
    },
    exceptions: class {
        constructor(t){
            var i, e;
            this.qr = [], this.Vr = new $e444d6404c095fa5$var$Zt([
                new $e444d6404c095fa5$var$ci,
                new $e444d6404c095fa5$var$Si,
                new $e444d6404c095fa5$var$pi,
                new $e444d6404c095fa5$var$fi,
                new $e444d6404c095fa5$var$wi,
                new $e444d6404c095fa5$var$yi,
                new $e444d6404c095fa5$var$gi,
                new $e444d6404c095fa5$var$Ei
            ], $e444d6404c095fa5$var$vi()), this._instance = t, this.qr = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$Ki)) && void 0 !== i ? i : [];
        }
        onRemoteConfig(t) {
            var i, e, r;
            if ("errorTracking" in t) {
                var s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
                this.qr = s, this._instance.persistence && this._instance.persistence.register({
                    [$e444d6404c095fa5$var$Ki]: this.qr,
                    [$e444d6404c095fa5$var$Xi]: n
                });
            }
        }
        get Wr() {
            var t, i = !!this._instance.get_property($e444d6404c095fa5$var$Xi), e = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != e ? e : i) && void 0 !== t && t;
        }
        buildProperties(t, i) {
            return this.Vr.buildFromUnknown(t, {
                syntheticException: null == i ? void 0 : i.syntheticException,
                mechanism: {
                    handled: null == i ? void 0 : i.handled
                }
            });
        }
        sendExceptionEvent(t) {
            var i = t.$exception_list;
            if (this.Gr(i)) {
                if (this.Yr(i)) return void $e444d6404c095fa5$var$Vo.info("Skipping exception capture because a suppression rule matched");
                if (!this.Wr && this.Jr(i)) return void $e444d6404c095fa5$var$Vo.info("Skipping exception capture because it was thrown by an extension");
                if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.Kr(i)) return void $e444d6404c095fa5$var$Vo.info("Skipping exception capture because it was thrown by the PostHog SDK");
            }
            return this._instance.capture("$exception", t, {
                _noTruncate: !0,
                _batchKey: "exceptionEvent",
                Di: !0
            });
        }
        Yr(t) {
            if (0 === t.length) return !1;
            var i = t.reduce((t, i)=>{
                var { type: e, value: r } = i;
                return $e444d6404c095fa5$var$A(e) && e.length > 0 && t.$exception_types.push(e), $e444d6404c095fa5$var$A(r) && r.length > 0 && t.$exception_values.push(r), t;
            }, {
                $exception_types: [],
                $exception_values: []
            });
            return this.qr.some((t)=>{
                var e = t.values.map((t)=>{
                    var e, r = $e444d6404c095fa5$var$Bs[t.operator], s = $e444d6404c095fa5$var$I(t.value) ? t.value : [
                        t.value
                    ], n = null !== (e = i[t.key]) && void 0 !== e ? e : [];
                    return s.length > 0 && r(s, n);
                });
                return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
            });
        }
        Jr(t) {
            return t.flatMap((t)=>{
                var i, e;
                return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
            }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
        }
        Kr(t) {
            if (t.length > 0) {
                var i, e, r, s, n = null !== (i = null == (e = t[0].stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [], o = n[n.length - 1];
                return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
            }
            return !1;
        }
        Gr(t) {
            return !$e444d6404c095fa5$var$j(t) && $e444d6404c095fa5$var$I(t);
        }
    }
}, $e444d6404c095fa5$var$Zo = $e444d6404c095fa5$var$g({
    productTours: class {
        constructor(t){
            this.Xr = null, this.Qr = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            "productTours" in t && (this._instance.persistence && this._instance.persistence.register({
                [$e444d6404c095fa5$var$te]: !!t.productTours
            }), this.loadIfEnabled());
        }
        loadIfEnabled() {
            var t, i;
            this.Xr || (t = this._instance).config.disable_product_tours || null == (i = t.persistence) || !i.get_property($e444d6404c095fa5$var$te) || this.G(()=>this.Zr());
        }
        G(t) {
            var i, e;
            null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.generateProductTours ? t() : null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "product-tours", (i)=>{
                i ? $e444d6404c095fa5$var$_o.error("Could not load product tours script", i) : t();
            });
        }
        Zr() {
            var t;
            !this.Xr && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.generateProductTours && (this.Xr = $e444d6404c095fa5$var$v.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, i) {
            if (void 0 === i && (i = !1), !$e444d6404c095fa5$var$I(this.Qr) || i) {
                var e = this._instance.persistence;
                if (e) {
                    var r = e.props[$e444d6404c095fa5$var$go];
                    if ($e444d6404c095fa5$var$I(r) && !i) return this.Qr = r, void t(r, {
                        isLoaded: !0
                    });
                }
                this._instance._send_request({
                    url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                    method: "GET",
                    callback: (i)=>{
                        var r = i.statusCode;
                        if (200 !== r || !i.json) {
                            var s = "Product Tours API could not be loaded, status: " + r;
                            return $e444d6404c095fa5$var$_o.error(s), void t([], {
                                isLoaded: !1,
                                error: s
                            });
                        }
                        var n = $e444d6404c095fa5$var$I(i.json.product_tours) ? i.json.product_tours : [];
                        this.Qr = n, e && e.register({
                            [$e444d6404c095fa5$var$go]: n
                        }), t(n, {
                            isLoaded: !0
                        });
                    }
                });
            } else t(this.Qr, {
                isLoaded: !0
            });
        }
        getActiveProductTours(t) {
            $e444d6404c095fa5$var$j(this.Xr) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.Xr.getActiveProductTours(t);
        }
        showProductTour(t) {
            var i;
            null == (i = this.Xr) || i.showTourById(t);
        }
        previewTour(t) {
            this.Xr ? this.Xr.previewTour(t) : this.G(()=>{
                var i;
                this.Zr(), null == (i = this.Xr) || i.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null == (t = this.Xr) || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null == (t = this.Xr) || t.nextStep();
        }
        previousStep() {
            var t;
            null == (t = this.Xr) || t.previousStep();
        }
        clearCache() {
            var t;
            this.Qr = null, null == (t = this._instance.persistence) || t.unregister($e444d6404c095fa5$var$go);
        }
        resetTour(t) {
            var i;
            null == (i = this.Xr) || i.resetTour(t);
        }
        resetAllTours() {
            var t;
            null == (t = this.Xr) || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var i;
            null == (i = this.Xr) || i.cancelPendingTour(t);
        }
    }
}, $e444d6404c095fa5$var$Jo), $e444d6404c095fa5$var$ta = {
    siteApps: class {
        constructor(t){
            this._instance = t, this.ts = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        es(t, i) {
            if (i) {
                var e = this.globalsForEvent(i);
                this.ts.push(e), this.ts.length > 1e3 && (this.ts = this.ts.slice(10));
            }
        }
        get siteAppLoaders() {
            var t;
            return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                var t = this._instance._addCaptureHook(this.es.bind(this));
                this.rs = ()=>{
                    t(), this.ts = [], this.rs = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var i, e, r, s, n, o, a;
            if (!t) throw new Error("Event payload is required");
            var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (var [d, v] of Object.entries(h))l[d] = {
                id: u[d],
                type: d,
                properties: v
            };
            var { $set_once: c, $set: f } = t;
            return {
                event: $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$m(t, $e444d6404c095fa5$var$mo), {
                    properties: $e444d6404c095fa5$var$g({}, t.properties, f ? {
                        $set: $e444d6404c095fa5$var$g({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                    } : {}, c ? {
                        $set_once: $e444d6404c095fa5$var$g({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                    } : {}),
                    elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                    distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: l
            };
        }
        setupSiteApp(t) {
            var i = this.apps[t.id], e = ()=>{
                var e;
                (!i.errored && this.ts.length && ($e444d6404c095fa5$var$bo.info("Processing " + this.ts.length + " events for site app with id " + t.id), this.ts.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.rs) || e.call(this));
            }, r = !1, s = (s)=>{
                i.errored = !s, i.loaded = !0, $e444d6404c095fa5$var$bo.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
            };
            try {
                var { processEvent: n } = t.init({
                    posthog: this._instance,
                    callback: (t)=>{
                        s(t);
                    }
                });
                n && (i.processEvent = n), r = !0;
            } catch (i) {
                $e444d6404c095fa5$var$bo.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
            }
            if (r && i.loaded) try {
                e();
            } catch (e) {
                $e444d6404c095fa5$var$bo.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
            }
        }
        ss() {
            var t = this.siteAppLoaders || [];
            for (var i of t)this.apps[i.id] = {
                id: i.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (var e of t)this.setupSiteApp(e);
        }
        ns(t) {
            if (0 !== Object.keys(this.apps).length) {
                var i = this.globalsForEvent(t);
                for (var e of Object.values(this.apps))try {
                    null == e.processEvent || e.processEvent(i);
                } catch (i) {
                    $e444d6404c095fa5$var$bo.error("Error while processing event " + t.event + " for site app " + e.id, i);
                }
            }
        }
        onRemoteConfig(t) {
            var i, e, r, s = this;
            if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.ss(), void this._instance.on("eventCaptured", (t)=>this.ns(t))) : void $e444d6404c095fa5$var$bo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null == (e = this.rs) || e.call(this), null != (r = t.siteApps) && r.length) {
                if (this.isEnabled) {
                    var n = function(t) {
                        var i;
                        $e444d6404c095fa5$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                            if (i) return $e444d6404c095fa5$var$bo.error("Error while initializing PostHog app with config id " + t, i);
                        });
                    };
                    for (var { id: o, url: a } of t.siteApps)n(o);
                } else $e444d6404c095fa5$var$bo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}, $e444d6404c095fa5$var$ia = {
    tracingHeaders: class {
        constructor(t){
            this.os = void 0, this.ls = void 0, this.Dr = ()=>{
                var t, i;
                $e444d6404c095fa5$var$M(this.os) && (null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
                $e444d6404c095fa5$var$M(this.ls) && (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            }, this._instance = t;
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        G(t) {
            var i, e;
            null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
                if (i) return $e444d6404c095fa5$var$so.error("failed to load script", i);
                t();
            });
        }
        startIfEnabledOrStop() {
            var t, i;
            this._instance.config.__add_tracing_headers ? this.G(this.Dr) : (null == (t = this.os) || t.call(this), null == (i = this.ls) || i.call(this), this.os = void 0, this.ls = void 0);
        }
    }
}, $e444d6404c095fa5$var$ea = $e444d6404c095fa5$var$g({
    surveys: class {
        constructor(t){
            this.us = void 0, this._surveyManager = null, this.hs = !1, this.ds = [], this.vs = null, this._instance = t, this._surveyEventReceiver = null;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this._instance.config.disable_surveys) {
                var i = t.surveys;
                if ($e444d6404c095fa5$var$j(i)) return $e444d6404c095fa5$var$Js.warn("Flags not loaded yet. Not loading surveys.");
                var e = $e444d6404c095fa5$var$I(i);
                this.us = e ? i.length > 0 : i, $e444d6404c095fa5$var$Js.info("flags response received, isSurveysEnabled: " + this.us), this.loadIfEnabled();
            }
        }
        reset() {
            localStorage.removeItem("lastSeenSurveyDate");
            for(var t = [], i = 0; i < localStorage.length; i++){
                var e = localStorage.key(i);
                (null != e && e.startsWith($e444d6404c095fa5$var$Ks) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
            }
            t.forEach((t)=>localStorage.removeItem(t));
        }
        loadIfEnabled() {
            if (!this._surveyManager) {
                if (this.hs) $e444d6404c095fa5$var$Js.info("Already initializing surveys, skipping...");
                else if (this._instance.config.disable_surveys) $e444d6404c095fa5$var$Js.info("Disabled. Not loading surveys.");
                else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) $e444d6404c095fa5$var$Js.info("Not loading surveys in cookieless mode without consent.");
                else {
                    var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                    if (t) {
                        if (!$e444d6404c095fa5$var$M(this.us) || this._instance.config.advanced_enable_surveys) {
                            var i = this.us || this._instance.config.advanced_enable_surveys;
                            this.hs = !0;
                            try {
                                var e = t.generateSurveys;
                                if (e) return void this.cs(e, i);
                                var r = t.loadExternalDependency;
                                if (!r) return void this.fs("PostHog loadExternalDependency extension not found.");
                                r(this._instance, "surveys", (e)=>{
                                    e || !t.generateSurveys ? this.fs("Could not load surveys script", e) : this.cs(t.generateSurveys, i);
                                });
                            } catch (t) {
                                throw this.fs("Error initializing surveys", t), t;
                            } finally{
                                this.hs = !1;
                            }
                        }
                    } else $e444d6404c095fa5$var$Js.error("PostHog Extensions not found.");
                }
            }
        }
        cs(t, i) {
            this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new $e444d6404c095fa5$var$So(this._instance), $e444d6404c095fa5$var$Js.info("Surveys loaded successfully"), this.ps({
                isLoaded: !0
            });
        }
        fs(t, i) {
            $e444d6404c095fa5$var$Js.error(t, i), this.ps({
                isLoaded: !1,
                error: t
            });
        }
        onSurveysLoaded(t) {
            return this.ds.push(t), this._surveyManager && this.ps({
                isLoaded: !0
            }), ()=>{
                this.ds = this.ds.filter((i)=>i !== t);
            };
        }
        getSurveys(t, i) {
            if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $e444d6404c095fa5$var$Js.info("Disabled. Not loading surveys."), t([]);
            var e, r = this._instance.get_property($e444d6404c095fa5$var$he);
            if (r && !i) return t(r, {
                isLoaded: !0
            });
            "undefined" != typeof Promise && this.vs ? this.vs.then((i)=>{
                var { surveys: e, context: r } = i;
                return t(e, r);
            }) : ("undefined" != typeof Promise && (this.vs = new Promise((t)=>{
                e = t;
            })), this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
                method: "GET",
                timeout: this._instance.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var r;
                    this.vs = null;
                    var s = i.statusCode;
                    if (200 !== s || !i.json) {
                        var n = "Surveys API could not be loaded, status: " + s;
                        $e444d6404c095fa5$var$Js.error(n);
                        var o = {
                            isLoaded: !1,
                            error: n
                        };
                        return t([], o), void (null == e || e({
                            surveys: [],
                            context: o
                        }));
                    }
                    var a, l = i.json.surveys || [], u = l.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                        }(t) || function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                        }(t)));
                    u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u));
                    null == (r = this._instance.persistence) || r.register({
                        [$e444d6404c095fa5$var$he]: l
                    });
                    var h = {
                        isLoaded: !0
                    };
                    t(l, h), null == e || e({
                        surveys: l,
                        context: h
                    });
                }
            }));
        }
        ps(t) {
            for (var i of this.ds)try {
                if (!t.isLoaded) return i([], t);
                this.getSurveys(i);
            } catch (t) {
                $e444d6404c095fa5$var$Js.error("Error in survey callback", t);
            }
        }
        getActiveMatchingSurveys(t, i) {
            if (void 0 === i && (i = !1), !$e444d6404c095fa5$var$j(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
            $e444d6404c095fa5$var$Js.warn("init was not called");
        }
        _s(t) {
            var i = null;
            return this.getSurveys((e)=>{
                var r;
                i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
            }), i;
        }
        gs(t) {
            if ($e444d6404c095fa5$var$j(this._surveyManager)) return {
                eligible: !1,
                reason: "SDK is not enabled or survey functionality is not yet loaded"
            };
            var i = "string" == typeof t ? this._s(t) : t;
            return i ? this._surveyManager.checkSurveyEligibility(i) : {
                eligible: !1,
                reason: "Survey not found"
            };
        }
        canRenderSurvey(t) {
            if ($e444d6404c095fa5$var$j(this._surveyManager)) return $e444d6404c095fa5$var$Js.warn("init was not called"), {
                visible: !1,
                disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
            };
            var i = this.gs(t);
            return {
                visible: i.eligible,
                disabledReason: i.reason
            };
        }
        canRenderSurveyAsync(t, i) {
            return $e444d6404c095fa5$var$j(this._surveyManager) ? ($e444d6404c095fa5$var$Js.warn("init was not called"), Promise.resolve({
                visible: !1,
                disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
            })) : new Promise((e)=>{
                this.getSurveys((i)=>{
                    var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                    if (s) {
                        var n = this.gs(s);
                        e({
                            visible: n.eligible,
                            disabledReason: n.reason
                        });
                    } else e({
                        visible: !1,
                        disabledReason: "Survey not found"
                    });
                }, i);
            });
        }
        renderSurvey(t, i, e) {
            var r;
            if ($e444d6404c095fa5$var$j(this._surveyManager)) $e444d6404c095fa5$var$Js.warn("init was not called");
            else {
                var s = "string" == typeof t ? this._s(t) : t;
                if (null != s && s.id) {
                    if ($e444d6404c095fa5$var$Zs.includes(s.type)) {
                        var n = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelector(i);
                        if (n) return null != (r = s.appearance) && r.surveyPopupDelaySeconds ? ($e444d6404c095fa5$var$Js.info("Rendering survey " + s.id + " with delay of " + s.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                            var t, i;
                            $e444d6404c095fa5$var$Js.info("Rendering survey " + s.id + " with delay of " + (null == (t = s.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(s, n, e), $e444d6404c095fa5$var$Js.info("Survey " + s.id + " rendered");
                        }, 1e3 * s.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(s, n, e);
                        $e444d6404c095fa5$var$Js.warn("Survey element not found");
                    } else $e444d6404c095fa5$var$Js.warn("Surveys of type " + s.type + " cannot be rendered in the app");
                } else $e444d6404c095fa5$var$Js.warn("Survey not found");
            }
        }
        displaySurvey(t, i) {
            var e;
            if ($e444d6404c095fa5$var$j(this._surveyManager)) $e444d6404c095fa5$var$Js.warn("init was not called");
            else {
                var r = this._s(t);
                if (r) {
                    var s = r;
                    if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = $e444d6404c095fa5$var$g({}, r, {
                        appearance: $e444d6404c095fa5$var$g({}, r.appearance, {
                            surveyPopupDelaySeconds: 0
                        })
                    })), i.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Popover && i.initialResponses && $e444d6404c095fa5$var$Js.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
                        var n = this.canRenderSurvey(r);
                        if (!n.visible) return void $e444d6404c095fa5$var$Js.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                    }
                    i.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, i) : this.renderSurvey(s, i.selector, i.properties);
                } else $e444d6404c095fa5$var$Js.warn("Survey not found");
            }
        }
        cancelPendingSurvey(t) {
            $e444d6404c095fa5$var$j(this._surveyManager) ? $e444d6404c095fa5$var$Js.warn("init was not called") : this._surveyManager.cancelSurvey(t);
        }
        handlePageUnload() {
            var t;
            null == (t = this._surveyManager) || t.handlePageUnload();
        }
    }
}, $e444d6404c095fa5$var$Jo), $e444d6404c095fa5$var$ra = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        bs(t) {
            $e444d6404c095fa5$var$v.ph_toolbar_state = t;
        }
        ys() {
            var t;
            return null !== (t = $e444d6404c095fa5$var$v.ph_toolbar_state) && void 0 !== t ? t : $e444d6404c095fa5$var$Po.UNINITIALIZED;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(i, e, r) {
            if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), $e444d6404c095fa5$var$Bi(this.instance.config)) return !1;
            if (!$e444d6404c095fa5$var$t || !$e444d6404c095fa5$var$o) return !1;
            i = null != i ? i : $e444d6404c095fa5$var$t.location, r = null != r ? r : $e444d6404c095fa5$var$t.history;
            try {
                if (!e) {
                    try {
                        $e444d6404c095fa5$var$t.localStorage.setItem("test", "test"), $e444d6404c095fa5$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage;
                }
                var s, n = $e444d6404c095fa5$var$xo || $e444d6404c095fa5$var$or(i.hash, "__posthog") || $e444d6404c095fa5$var$or(i.hash, "state"), a = n ? $e444d6404c095fa5$var$Ai(()=>JSON.parse(atob(decodeURIComponent(n)))) || $e444d6404c095fa5$var$Ai(()=>JSON.parse(decodeURIComponent(n))) : null;
                return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($e444d6404c095fa5$var$$o) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
            } catch (t) {
                return !1;
            }
        }
        ws(t) {
            var i = $e444d6404c095fa5$var$v.ph_load_toolbar || $e444d6404c095fa5$var$v.ph_load_editor;
            !$e444d6404c095fa5$var$j(i) && $e444d6404c095fa5$var$C(i) ? i(t, this.instance) : $e444d6404c095fa5$var$ko.warn("No toolbar load function found");
        }
        loadToolbar(i) {
            var e = !(null == $e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.getElementById($e444d6404c095fa5$var$Ee));
            if (!$e444d6404c095fa5$var$t || e) return !1;
            var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $e444d6404c095fa5$var$g({
                token: this.instance.config.token
            }, i, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, r ? {
                instrument: !1
            } : {});
            if ($e444d6404c095fa5$var$t.localStorage.setItem($e444d6404c095fa5$var$$o, JSON.stringify($e444d6404c095fa5$var$g({}, s, {
                source: void 0
            }))), this.ys() === $e444d6404c095fa5$var$Po.LOADED) this.ws(s);
            else if (this.ys() === $e444d6404c095fa5$var$Po.UNINITIALIZED) {
                var n;
                this.bs($e444d6404c095fa5$var$Po.LOADING), null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                    if (t) return $e444d6404c095fa5$var$ko.error("[Toolbar] Failed to load", t), void this.bs($e444d6404c095fa5$var$Po.UNINITIALIZED);
                    this.bs($e444d6404c095fa5$var$Po.LOADED), this.ws(s);
                }), $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$t, "turbolinks:load", ()=>{
                    this.bs($e444d6404c095fa5$var$Po.UNINITIALIZED), this.loadToolbar(s);
                });
            }
            return !0;
        }
        Es(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, i, e) {
            return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
        }
    }
}, $e444d6404c095fa5$var$sa = $e444d6404c095fa5$var$g({
    experiments: $e444d6404c095fa5$var$Go
}, $e444d6404c095fa5$var$Jo), $e444d6404c095fa5$var$na = {
    conversations: class {
        constructor(t){
            this.Ss = void 0, this._conversationsManager = null, this.xs = !1, this.$s = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this._instance.config.disable_conversations) {
                var i = t.conversations;
                $e444d6404c095fa5$var$j(i) || ($e444d6404c095fa5$var$z(i) ? this.Ss = i : (this.Ss = i.enabled, this.$s = i), this.loadIfEnabled());
            }
        }
        reset() {
            var t;
            null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.Ss = void 0, this.$s = null;
        }
        loadIfEnabled() {
            if (!(this._conversationsManager || this.xs || this._instance.config.disable_conversations || $e444d6404c095fa5$var$Bi(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
                var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (t && !$e444d6404c095fa5$var$M(this.Ss) && this.Ss) {
                    if (this.$s && this.$s.token) {
                        this.xs = !0;
                        try {
                            var i = t.initConversations;
                            if (i) return this.ks(i), void (this.xs = !1);
                            var e = t.loadExternalDependency;
                            if (!e) return void this.Ps("PostHog loadExternalDependency extension not found.");
                            e(this._instance, "conversations", (i)=>{
                                i || !t.initConversations ? this.Ps("Could not load conversations script", i) : this.ks(t.initConversations), this.xs = !1;
                            });
                        } catch (t) {
                            this.Ps("Error initializing conversations", t), this.xs = !1;
                        }
                    } else $e444d6404c095fa5$var$Yo.error("Conversations enabled but missing token in remote config.");
                }
            }
        }
        ks(t) {
            if (this.$s) try {
                this._conversationsManager = t(this.$s, this._instance), $e444d6404c095fa5$var$Yo.info("Conversations loaded successfully");
            } catch (t) {
                this.Ps("Error completing conversations initialization", t);
            }
            else $e444d6404c095fa5$var$Yo.error("Cannot complete initialization: remote config is null");
        }
        Ps(t, i) {
            $e444d6404c095fa5$var$Yo.error(t, i), this._conversationsManager = null, this.xs = !1;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $e444d6404c095fa5$var$Yo.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.Ss && !$e444d6404c095fa5$var$L(this._conversationsManager);
        }
        isVisible() {
            var t, i;
            return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, i, e) {
            var r = this;
            return $e444d6404c095fa5$var$_(function*() {
                return r._conversationsManager ? r._conversationsManager.sendMessage(t, i, e) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        getMessages(t, i) {
            var e = this;
            return $e444d6404c095fa5$var$_(function*() {
                return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        markAsRead(t) {
            var i = this;
            return $e444d6404c095fa5$var$_(function*() {
                return i._conversationsManager ? i._conversationsManager.markAsRead(t) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        getTickets(t) {
            var i = this;
            return $e444d6404c095fa5$var$_(function*() {
                return i._conversationsManager ? i._conversationsManager.getTickets(t) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        requestRestoreLink(t) {
            var i = this;
            return $e444d6404c095fa5$var$_(function*() {
                return i._conversationsManager ? i._conversationsManager.requestRestoreLink(t) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        restoreFromToken(t) {
            var i = this;
            return $e444d6404c095fa5$var$_(function*() {
                return i._conversationsManager ? i._conversationsManager.restoreFromToken(t) : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $e444d6404c095fa5$var$_(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($e444d6404c095fa5$var$Yo.warn("Conversations not available yet."), null);
            })();
        }
        getCurrentTicketId() {
            var t, i;
            return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, i;
            return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
    }
}, $e444d6404c095fa5$var$oa = {
    logs: class {
        constructor(t){
            var i;
            this.Ts = !1, this.Rs = !1, this._instance = t, this._instance && null != (i = this._instance.config.logs) && i.captureConsoleLogs && (this.Ts = !0);
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            var i, e = null == (i = t.logs) ? void 0 : i.captureConsoleLogs;
            !$e444d6404c095fa5$var$j(e) && e && (this.Ts = !0, this.loadIfEnabled());
        }
        reset() {}
        loadIfEnabled() {
            if (this.Ts && !this.Rs) {
                var t = $e444d6404c095fa5$var$ki("[logs]"), i = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (i) {
                    var e = i.loadExternalDependency;
                    e ? e(this._instance, "logs", (e)=>{
                        var r;
                        e || null == (r = i.logs) || !r.initializeLogs ? t.error("Could not load logs script", e) : (i.logs.initializeLogs(this._instance), this.Rs = !0);
                    }) : t.error("PostHog loadExternalDependency extension not found.");
                } else t.error("PostHog Extensions not found.");
            }
        }
    }
}, $e444d6404c095fa5$var$aa = $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$Jo, $e444d6404c095fa5$var$Ko, $e444d6404c095fa5$var$Xo, $e444d6404c095fa5$var$Qo, $e444d6404c095fa5$var$Zo, $e444d6404c095fa5$var$ta, $e444d6404c095fa5$var$ea, $e444d6404c095fa5$var$ia, $e444d6404c095fa5$var$ra, $e444d6404c095fa5$var$sa, $e444d6404c095fa5$var$na, $e444d6404c095fa5$var$oa);
$e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$aa);
var $e444d6404c095fa5$var$la, $e444d6404c095fa5$export$2e2bcd8739ae039 = ($e444d6404c095fa5$var$la = $e444d6404c095fa5$var$nn[$e444d6404c095fa5$var$ln] = new $e444d6404c095fa5$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $e444d6404c095fa5$var$un = !1, $e444d6404c095fa5$var$Ci($e444d6404c095fa5$var$nn, function(t) {
            t._dom_loaded();
        }));
    }
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.addEventListener ? "complete" === $e444d6404c095fa5$var$o.readyState ? i() : $e444d6404c095fa5$var$Hi($e444d6404c095fa5$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$$i.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $e444d6404c095fa5$var$la);


const $a9032ec354beaac7$var$KEY = "phc_gq09WTJLVGUXD8XhtZvYGVyNUJYmOMKHi6R0D47sUPz" ?? "";
const $a9032ec354beaac7$var$isDiscord = window.location.hostname.endsWith("discordsays.com") || new URLSearchParams(window.location.search).get("frame_id") !== null;
const $a9032ec354beaac7$export$722a64dea1b767dc = $a9032ec354beaac7$var$isDiscord ? "discord" : "web";
function $a9032ec354beaac7$export$f2a39aaa42ea357a() {
    if (!$a9032ec354beaac7$var$KEY) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).init($a9032ec354beaac7$var$KEY, {
        api_host: $a9032ec354beaac7$var$isDiscord ? "/ingest" : "https://us.i.posthog.com",
        person_profiles: "identified_only",
        autocapture: false,
        capture_pageview: false
    });
}
function $a9032ec354beaac7$export$f127983c05788e92(id, props) {
    if (!$a9032ec354beaac7$var$KEY) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).identify(id, props);
}
function $a9032ec354beaac7$export$6b2a7d5132615086(event, props) {
    if (!$a9032ec354beaac7$var$KEY) return;
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture(event, props);
}


(0, $a9032ec354beaac7$export$f2a39aaa42ea357a)();
// Global variable to keep the user ID accessible in the PixelJS rendering loops
let $35da740d59af89ba$var$globalDiscordUserId = null;
let $35da740d59af89ba$var$discordSdk = null;
async function $35da740d59af89ba$var$authenticateDiscord() {
    // Only initialize SDK if playing inside a Discord Activity (checks for frame_id)
    const frameId = new URLSearchParams(window.location.search).get('frame_id');
    if (!frameId) {
        console.log("Not running in a Discord Activity. Skipping Discord SDK initialization.");
        return;
    }
    try {
        $35da740d59af89ba$var$discordSdk = new (0, $c537748c1911e01f$export$7cb9b6936cca2046)("1404912660927086752");
        await $35da740d59af89ba$var$discordSdk.ready();
        // Authorize with Discord Client
        const { code: code } = await $35da740d59af89ba$var$discordSdk.commands.authorize({
            client_id: "1404912660927086752",
            response_type: "code",
            state: "",
            prompt: "none",
            scope: [
                "identify",
                "guilds",
                "applications.commands"
            ]
        });
        // Trade code for token via our Netlify Proxy Function
        const response = await fetch('/.netlify/functions/discord-token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code
            })
        });
        if (!response.ok) throw new Error(`Failed to exchange token. Status: ${response.status}`);
        const { access_token: access_token } = await response.json();
        // Authenticate the SDK
        const authInfo = await $35da740d59af89ba$var$discordSdk.commands.authenticate({
            access_token: access_token
        });
        if (authInfo == null) throw new Error("Authenticate command failed");
        // Cache the Discord user ID locally
        $35da740d59af89ba$var$globalDiscordUserId = authInfo.user.id;
        console.log("Discord authentication successful. User ID:", $35da740d59af89ba$var$globalDiscordUserId);
        const guildId = $35da740d59af89ba$var$discordSdk.guildId ?? "dm";
        (0, $a9032ec354beaac7$export$f127983c05788e92)($35da740d59af89ba$var$globalDiscordUserId, {
            username: authInfo.user.username,
            guild_id: guildId
        });
    } catch (err) {
        console.error("Discord SDK authentication failed:", err);
    }
}
async function $35da740d59af89ba$var$createApplication() {
    // Create a new PixiJS Application
    const app = new (0, $2202931bfc9ee5c9$export$16975c34e60e1e61)();
    const targetWidth = 720;
    const targetHeight = 1280;
    const aspectRatio = targetWidth / targetHeight;
    const width = 180;
    const height = 400;
    const scale = Math.min(width / targetWidth, height / targetHeight);
    // Initialize the application with settings
    await app.init({
        width: targetWidth * scale,
        height: targetHeight * scale,
        backgroundColor: 0x000000,
        antialias: true,
        resolution: 2
    });
    // Start Discord Authentication as early as possible without blocking standard load
    $35da740d59af89ba$var$authenticateDiscord();
    (0, $a9032ec354beaac7$export$6b2a7d5132615086)("player_session", {
        game: "gravulous",
        platform: $a9032ec354beaac7$export$722a64dea1b767dc
    });
    (0, $a9032ec354beaac7$export$6b2a7d5132615086)("game_start", {
        game: "gravulous"
    });
    // Append the canvas to the document body
    document.body.appendChild(app.canvas);
    const uiLayer = new (0, $eicwU.Container)();
    const spriteLayer = new (0, $eicwU.Container)();
    app.stage.addChild(spriteLayer);
    app.stage.addChild(uiLayer);
    // Create a loading bar
    const loadingBar = new (0, $3cebA.Graphics)();
    loadingBar.fill(0xffffff);
    loadingBar.rect(0, 0, 300, 20);
    loadingBar.fill();
    loadingBar.x = (app.screen.width - 300) / 2;
    loadingBar.y = app.screen.height / 2;
    loadingBar.scale.x = 0; // Start with zero width
    app.stage.addChild(loadingBar);
    // Create loading text
    const loadingText = new (0, $dd84afd4ef9f1e09$export$5f1af8db9871e1d6)({
        text: 'Loading... 0%',
        style: new (0, $eKNW7.TextStyle)({
            fill: 0xffffff,
            fontSize: 24
        })
    });
    loadingText.anchor.set(0.5);
    loadingText.x = app.screen.width / 2;
    loadingText.y = app.screen.height / 2 - 40;
    app.stage.addChild(loadingText);
    // Load assets with progress tracking
    const assets = [
        {
            alias: 'bg',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($08d460a2845743e4$exports)))
        },
        {
            alias: 'planet1',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bef0165d1ad394b0$exports)))
        },
        {
            alias: 'planet2',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c86de67ff8578ac6$exports)))
        },
        {
            alias: 'planet3',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ad859356d32f3a79$exports)))
        },
        {
            alias: 'hole1',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6f2d3d314a720f3a$exports)))
        },
        {
            alias: 'hole2',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($71da43bcfecbc88f$exports)))
        },
        {
            alias: 'explode1',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7a5a24d9cc7c7b72$exports)))
        },
        {
            alias: 'explode2',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($46a2be3ffa3bfd30$exports)))
        },
        {
            alias: 'gameover',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dbc2c9c10a838714$exports)))
        },
        {
            alias: 'discord',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($806881d35f5528af$exports)))
        }
    ];
    // Add all assets to the manager before loading them
    for (const asset of assets)(0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).add(asset);
    async function loadAssetsWithProgress() {
        let loadedCount = 0;
        for (const asset of assets){
            // Load each asset individually by alias
            await (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).load(asset.alias);
            // Increment the count of loaded assets
            loadedCount++;
            // Calculate and update progress
            const progress = loadedCount / assets.length * 100;
            loadingBar.scale.x = progress / 100; // Update loading bar scale
            loadingText.text = `Loading... ${Math.round(progress)}%`; // Update loading text
            console.log(loadingText.text);
        }
        // Remove loading bar and text when done
        app.stage.removeChild(loadingBar);
        app.stage.removeChild(loadingText);
        initializeGame();
    }
    loadAssetsWithProgress();
    let background = null;
    async function createBackground() {
        // Load the texture
        const texture = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('bg'); // Load the imported path
        background = new (0, $4rhnu.Sprite)(texture);
        // Set the background size and position
        background.width = app.screen.width;
        background.height = app.screen.height;
        background.anchor.set(0); // Align to the top-left corner
        app.stage.addChildAt(background, 0); // Add to the bottom of the stage
    }
    async function initializeGame() {
        createBackground().catch((err)=>console.error('Error loading background:', err));
        // Load the planet texture
        const planetTexture = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('planet1');
        const planetTexture2 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('planet2');
        const planetTexture3 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('planet3');
        const holeTexture1 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('hole1');
        const holeTexture2 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('hole2');
        const explodeTexture1 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('explode1');
        const explodeTexture2 = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('explode2');
        const gameoverTexture = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('gameover');
        const discordTexture = (0, $f4e4ce59fcdafcd2$export$c8eca95e306f7116).get('discord');
        let gravX = app.screen.width / 2;
        let gravY = app.screen.height - 40;
        const GRAV_RADIUS = 20; // Radius of the white circle
        const GRAV_SIZE = 60;
        // Draw the central circle
        const circle = new (0, $4rhnu.Sprite)(holeTexture1);
        circle.anchor.set(0.5);
        circle.scale.set(1); // Reset scale
        circle.raidus = GRAV_RADIUS;
        circle.width = GRAV_SIZE; // Diameter
        circle.height = GRAV_SIZE; // Diameter
        // Position the circle near the bottom center
        circle.x = gravX; // Center horizontally
        circle.y = gravY; // 20 pixels above the bottom (radius = 20)
        spriteLayer.addChild(circle);
        const circle2 = new (0, $4rhnu.Sprite)(holeTexture2);
        circle2.anchor.set(0.5);
        circle2.scale.set(1); // Reset scale
        circle2.raidus = GRAV_RADIUS;
        circle2.width = GRAV_SIZE; // Diameter
        circle2.height = GRAV_SIZE; // Diameter
        // Position the circle near the bottom center
        circle2.x = gravX; // Center horizontally
        circle2.y = gravY; // 20 pixels above the bottom (radius = 20)
        spriteLayer.addChild(circle2);
        console.log("screen width " + app.screen.width + " screen height " + app.screen.height + " scale: " + scale);
        // planet.fill(0x0000ff); // Blue color
        // planet.circle(0, 0, 10); // Radius of 10
        // planet.fill();
        // planet.x = gravX;
        // planet.y = gravY;
        // app.stage.addChild(planet);
        // Interaction setup
        // planet.interactive = true;
        // planet.buttonMode = true;
        let activePlanet;
        const restingPlanets = [];
        // Physics variables
        let isDragging = false;
        let velocityX = 0;
        let velocityY = 0;
        const dragLine = new (0, $3cebA.Graphics)();
        // Add the drag line to the stage
        app.stage.addChild(dragLine);
        // Cap values
        const MAX_DISTANCE = 20; // Maximum drag distance
        const MAX_VELOCITY = 20; // Maximum velocity
        const DAMPING = 0.95;
        const SCALE_SPEED = 0.2; // Speed of scaling
        const GROWTH_SPEED = 10; // Speed of growth
        let createNewPlanet = false;
        let moving = false;
        let initialCollison = false;
        let score = 0;
        let best = 0;
        // Text style for score
        const scoreStyle = new (0, $eKNW7.TextStyle)({
            fontFamily: 'Arial',
            fontSize: 12,
            fill: 0xffffff,
            align: 'right'
        });
        // Create score text
        const scoreText = new (0, $dd84afd4ef9f1e09$export$5f1af8db9871e1d6)({
            text: `Score: ${score}`,
            style: scoreStyle
        });
        scoreText.anchor.set(1, 1); // Align to bottom-right corner
        scoreText.x = app.screen.width - 10; // 10px padding from the right
        scoreText.y = app.screen.height - 60; // 10px padding from the bottom, moved up 50px
        uiLayer.addChild(scoreText);
        // Create score text
        const bestText = new (0, $dd84afd4ef9f1e09$export$5f1af8db9871e1d6)({
            text: `Best: ${score}`,
            style: scoreStyle
        });
        bestText.anchor.set(0, 1); // Align to bottom-right corner
        bestText.x = 5; // 10px padding from the right
        bestText.y = app.screen.height - 60; // 10px padding from the bottom, moved up 50px
        uiLayer.addChild(bestText);
        const discordSprite = new (0, $4rhnu.Sprite)(discordTexture);
        // Position below "Best" text score (which anchors at bottom-left: x=5, y=app.screen.height-10)
        discordSprite.x = 5;
        discordSprite.y = bestText.y + 5; // placing it just below the best score
        discordSprite.width = 15; // 50% smaller
        discordSprite.height = 15; // 50% smaller
        discordSprite.interactive = true;
        discordSprite.buttonMode = true; // Add buttonMode to fix clickability sometimes needed in Pixi
        discordSprite.cursor = 'pointer';
        const openDiscordLink = ()=>{
            if ($35da740d59af89ba$var$discordSdk) $35da740d59af89ba$var$discordSdk.commands.openExternalLink({
                url: 'https://discord.gg/28ndJ6MebN'
            });
            else window.open('https://discord.gg/28ndJ6MebN', '_blank');
        };
        // Some environments require using 'pointerup' or 'tap' in addition to/instead of 'pointerdown'
        discordSprite.on('pointerup', openDiscordLink);
        discordSprite.on('touchend', openDiscordLink);
        uiLayer.addChild(discordSprite);
        const introStyle = new (0, $eKNW7.TextStyle)({
            fontFamily: 'Arial',
            fontSize: 10,
            fill: 0xffffff,
            align: 'center'
        });
        let introText = new (0, $dd84afd4ef9f1e09$export$5f1af8db9871e1d6)({
            text: `Click drag planet to slingshot\nit out of the Gravulous`,
            style: introStyle
        });
        introText.anchor.set(0.5, 0.5); // Align to bottom-right corner
        introText.x = app.screen.width / 2; // 10px padding from the right
        introText.y = app.screen.height / 2; // 10px padding from the bottom
        uiLayer.addChild(introText);
        const PLANET_BASE_RADIUS = 10; // Radius of the planets
        // Create a particle container with default options
        const container = new (0, $b425caa62af94b42$export$e63bf72b2cfda112)({
            // this is the default, but we show it here for clarity
            dynamicProperties: {
                position: true,
                scale: false,
                rotation: false,
                color: false // Static color
            }
        });
        // Add particles
        // const texture = Texture.from(planetImagePath);
        // for (let i = 0; i < 100; ++i) {
        //     let particle = new Particle({
        //         texture,
        //         x: Math.random() * 360,
        //         y: Math.random() * 640,
        //         scaleX: 0.15,
        //         scaleY: 0.15,
        //     });
        //     container.addParticle(particle);
        // }
        // Load textures for explosion animation
        const explodeTextures = [
            new (0, $4rhnu.Sprite)(explodeTexture1),
            new (0, $4rhnu.Sprite)(explodeTexture2)
        ];
        // Create an AnimatedSprite using the textures
        // const explosion = new AnimatedSprite(explodeTextures);
        // // // Set animation properties
        // explosion.animationSpeed = 0.1; // Speed of animation
        // explosion.loop = false; // Play animation only once
        // explosion.anchor.set(0.5); // Center the sprite
        // // Add container to the Pixi stage
        //app.stage.addChild(container);
        // Function to create a new planet
        function createPlanet() {
            // const planet = new Graphics();
            // planet.fill(0x0000ff); // Blue color
            // planet.circle(0, 0, PLANET_BASE_RADIUS); // Radius of 10
            // planet.fill();
            const planet = new (0, $4rhnu.Sprite)(planetTexture);
            // Center the sprite for positioning
            planet.anchor.set(0.5);
            planet.scale.set(1); // Reset scale
            // Resize the planet sprite to match the desired size
            planet.width = PLANET_BASE_RADIUS * 2; // Diameter
            planet.height = PLANET_BASE_RADIUS * 2; // Diameter
            planet.x = gravX;
            planet.y = gravY;
            planet.baseRadius = PLANET_BASE_RADIUS; // Base radius before scaling
            planet.hits = 0;
            planet.getRadius = function() {
                // return this.baseRadius * this.scale.x;
                return this.width / 2;
            }; // Dynamically calculate scaled radius
            planet.interactive = true;
            planet.cursor = "pointer";
            spriteLayer.addChild(planet);
            // Add drag interaction to the active planet
            planet.on('pointerdown', ()=>{
                if (activePlanet !== planet) return; // Only allow dragging the active planet
                isDragging = true;
                if (introText) {
                    uiLayer.removeChild(introText);
                    introText = null;
                }
            });
            return planet;
        }
        // Create the first active planet
        activePlanet = createPlanet();
        const buttonStyle = new (0, $eKNW7.TextStyle)({
            fontFamily: 'Arial',
            fontSize: 24,
            fill: 0x00FF00,
            align: 'center'
        });
        // Text style for "Game Over"
        const gameOverStyle = new (0, $eKNW7.TextStyle)({
            fontFamily: 'Arial',
            fontSize: 36,
            fill: 0xff0000,
            align: 'center'
        });
        let gameOverText = null; // Reference to Game Over text
        let restartButton = null; // Reference to Restart button
        let gameOver = false; // Game over
        // Function to display "Game Over" text
        function displayGameOver() {
            if (gameOver) return; // Prevent multiple calls
            console.log("Game Over");
            velocityX = 0;
            velocityY = 0;
            gameOverText = new (0, $4rhnu.Sprite)(gameoverTexture);
            gameOverText.anchor.set(0.5); // Center the text
            gameOverText.x = app.screen.width / 2;
            gameOverText.y = app.screen.height / 2 - 75;
            gameOverText.scale.x = 0.1;
            gameOverText.scale.y = 0.1;
            app.stage.addChild(gameOverText);
            restartButton = new (0, $dd84afd4ef9f1e09$export$5f1af8db9871e1d6)({
                text: 'Restart',
                style: buttonStyle
            });
            restartButton.anchor.set(0.5);
            restartButton.x = app.screen.width / 2;
            restartButton.y = app.screen.height / 2 + 40;
            restartButton.interactive = true;
            restartButton.buttonMode = true;
            // Restart game when the button is clicked
            restartButton.on('pointerdown', ()=>{
                (0, $a9032ec354beaac7$export$6b2a7d5132615086)("game_restart", {
                    game: "gravulous",
                    score: score,
                    guild_id: $35da740d59af89ba$var$discordSdk?.guildId ?? "dm"
                });
                app.stage.removeChild(gameOverText);
                app.stage.removeChild(restartButton);
                resetGame();
            });
            app.stage.addChild(restartButton);
            gameOver = true; // Stop further actions
            app.ticker.add(function gameoverTicker() {
                gameOverText.scale.x += 0.02;
                gameOverText.scale.y += 0.02;
                // Check for collisions with canvas edges
                if (gameOverText.scale.x >= 0.75) {
                    app.ticker.remove(gameoverTicker); // Stop scaling
                    return;
                }
            });
            // Priority 1: From query param check for bot link sharing URLs 
            // Priority 2: From Discord Embedded App SDK (global state)
            // Priority 3: Fallback from previous manual URL params
            const finalUserId = getQueryParam('userId') || $35da740d59af89ba$var$globalDiscordUserId || getQueryParam('user_id');
            (0, $a9032ec354beaac7$export$6b2a7d5132615086)("game_complete", {
                game: "gravulous",
                score: score,
                guild_id: $35da740d59af89ba$var$discordSdk?.guildId ?? "dm"
            });
            if (finalUserId) {
                console.log(`Sending score ${score} to Discord Webhook for user ${finalUserId}`);
                fetch('/.netlify/functions/score', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        userId: finalUserId,
                        gameId: 'gravulous',
                        score: score
                    })
                }).then(async (response)=>{
                    if (!response.ok) {
                        const txt = await response.text();
                        console.error("Score Webhook Post Failed", response.status, txt);
                    } else console.log("Score posted successfully wrapper");
                }).catch((err)=>{
                    console.error("Score Webhook Request Error", err);
                });
            } else console.log("No valid userId found. Skipping score webhook post.");
            const chat_id = getQueryParam('chat_id');
            const message_id = getQueryParam('message_id');
            const inline_message_id = getQueryParam('inline_message_id');
            // Original standard post_score proxy backward compatibility if needed:
            if (chat_id || message_id || inline_message_id) fetch('/post_score', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    user_id: getQueryParam('user_id'),
                    chat_id: chat_id,
                    message_id: message_id,
                    inline_message_id: inline_message_id,
                    score: score
                })
            }).catch((e)=>console.error("Legacy /post_score failed", e));
        }
        // Function to reset the game state
        function resetGame() {
            // Clear all resting planets
            for (const planet of restingPlanets)spriteLayer.removeChild(planet);
            restingPlanets.length = 0;
            // Reset variables
            velocityX = 0;
            velocityY = 0;
            isDragging = false;
            gameOver = false;
            best = score;
            score = 0;
            updateScore();
            if (activePlanet) spriteLayer.removeChild(activePlanet);
            moving = false;
            initialCollison = false;
            // Create a new active planet
            activePlanet = createPlanet();
        }
        // Drag end (shoot)
        const onPointerUp = ()=>{
            if (!isDragging) return;
            isDragging = false;
            const rect = app.canvas.getBoundingClientRect(); // Get canvas bounds
            const localX = event.clientX - rect.left; // Pointer's X relative to canvas
            const localY = event.clientY - rect.top; // Pointer's Y relative to canvas  
            let position = new (0, $1HooC.Point)(localX / 2, localY / 2);
            // Calculate drag vector
            const dx = gravX - position.x;
            const dy = gravY - position.y;
            let distance = Math.sqrt(dx * dx + dy * dy);
            // Cap the distance
            if (distance > MAX_DISTANCE) distance = MAX_DISTANCE;
            // Scale velocity based on distance
            const angle = Math.atan2(dy, dx);
            const speed = distance / MAX_DISTANCE * MAX_VELOCITY;
            velocityX = Math.cos(angle) * speed;
            velocityY = Math.sin(angle) * speed;
            // Clear the drag line
            dragLine.clear();
            initialCollison = true;
            moving = true;
        };
        // Update loop
        app.ticker.add(()=>{
            circle.rotation += 0.005;
            circle2.rotation += 0.01;
            if (!isDragging && activePlanet) {
                // Update position
                activePlanet.x += velocityX;
                activePlanet.y += velocityY;
                if (moving) activePlanet.rotation += 0.005;
                // Apply damping to slow down the planet
                velocityX *= DAMPING;
                velocityY *= DAMPING;
                // Check collision with the white circle
                if (moving) {
                    if (detectGravCollision(activePlanet)) {
                        if (!initialCollison) {
                            displayGameOver();
                            return;
                        }
                    } else initialCollison = false;
                }
                // Handle collisions with resting planets
                let removingPlanets = [];
                for (const restingPlanet of restingPlanets){
                    const dx = restingPlanet.x - activePlanet.x;
                    const dy = restingPlanet.y - activePlanet.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < activePlanet.getRadius() + restingPlanet.getRadius()) {
                        handleCollision(activePlanet, restingPlanet);
                        restingPlanet.hits++;
                        if (restingPlanet.hits == 1) restingPlanet.texture = planetTexture2;
                        else if (restingPlanet.hits == 2) restingPlanet.texture = planetTexture3;
                        if (restingPlanet.hits >= 3) removingPlanets.push(restingPlanet);
                    }
                }
                if (removingPlanets.length > 0) for (const planet of removingPlanets){
                    spriteLayer.removeChild(planet);
                    restingPlanets.splice(restingPlanets.indexOf(planet), 1);
                    score++;
                    updateScore();
                // Add explosion sprite to the stage
                // app.stage.addChild(explosion);
                // explosion.position = planet.position;
                // explosion.play();
                // // Start the animation when needed
                // explosion.onComplete = () => {
                //     console.log('Explosion animation completed');
                //     app.stage.removeChild(explosion); // Optional: Remove sprite after animation
                //     explosion.stop();
                //     explosion.currentFrame = 0;
                // };
                }
                // Stop movement when velocity is very small
                if (moving && Math.abs(velocityX) < 0.01 && Math.abs(velocityY) < 0.01) {
                    velocityX = 0;
                    velocityY = 0;
                    moving = false;
                    // Add the current active planet to the resting planets array
                    restingPlanets.push(activePlanet);
                    // Scale up the resting planet
                    scalePlanet(activePlanet);
                    activePlanet = null;
                }
                if (activePlanet != null) {
                    // Handle wall collisions (bounce effect)
                    if (activePlanet.x <= 10 || activePlanet.x >= app.screen.width - 10) {
                        velocityX *= -1; // Reverse velocity
                        activePlanet.x = Math.max(10, Math.min(activePlanet.x, app.screen.width - 10));
                    }
                    if (activePlanet.y <= 10 || activePlanet.y >= app.screen.height - 10) {
                        velocityY *= -1; // Reverse velocity
                        activePlanet.y = Math.max(10, Math.min(activePlanet.y, app.screen.height - 10));
                    }
                }
            }
            // Create a new active planet
            if (createNewPlanet) {
                activePlanet = createPlanet();
                createNewPlanet = false;
            }
        });
        // Visual feedback for drag
        //app.stage.interactive = true;
        const onPointerMove = (event1)=>{
            if (isDragging) {
                const rect = app.canvas.getBoundingClientRect(); // Get canvas bounds
                const localX = event1.clientX - rect.left; // Pointer's X relative to canvas
                const localY = event1.clientY - rect.top; // Pointer's Y relative to canvas  
                let position = new (0, $1HooC.Point)(localX / 2, localY / 2);
                // Clear and redraw drag line
                dragLine.clear();
                dragLine.moveTo(gravX, gravY).lineTo(position.x, position.y).stroke({
                    color: 0xff0000
                });
            // Position the active planet while dragging
            //activePlanet.x = position.x;
            // activePlanet.y = position.y;
            }
        };
        // Function to detect collision between two planets
        function detectCollision(planet1, planet2) {
            const dx = planet2.x - planet1.x;
            const dy = planet2.y - planet1.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            return distance < planet1.getRadius() + planet2.getRadius();
        }
        // Function to detect collision between two planets
        function detectGravCollision(planet) {
            const dx = planet.x - gravX;
            const dy = planet.y - gravY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            return distance < planet.getRadius() + GRAV_RADIUS;
        }
        // Function to handle collision response and resolve overlap
        function handleCollision(movingPlanet, restingPlanet) {
            const dx = restingPlanet.x - movingPlanet.x;
            const dy = restingPlanet.y - movingPlanet.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            // Normalize the collision vector
            const nx = dx / distance;
            const ny = dy / distance;
            // Calculate overlap distance
            const overlap = movingPlanet.getRadius() + restingPlanet.getRadius() - distance;
            // Resolve overlap by pushing the moving planet away
            movingPlanet.x -= nx * overlap;
            movingPlanet.y -= ny * overlap;
            // Reflect the velocity of the moving planet
            const dot = velocityX * nx + velocityY * ny; // Dot product of velocity and normal
            velocityX -= 2 * dot * nx;
            velocityY -= 2 * dot * ny;
        }
        // Function to handle scaling of a stopped planet
        function scalePlanet(planet) {
            app.ticker.add(function scaleTicker() {
                //planet.scale.x += SCALE_SPEED;
                //planet.scale.y += SCALE_SPEED;
                planet.width = planet.width + GROWTH_SPEED; // Diameter
                planet.height = planet.height + GROWTH_SPEED; // Diameter
                // Check for collision with white circle
                if (detectGravCollision(planet)) {
                    app.ticker.remove(scaleTicker);
                    displayGameOver();
                    return;
                }
                // Check for collisions with other planets
                for (const otherPlanet of restingPlanets)if (planet !== otherPlanet && detectCollision(planet, otherPlanet)) {
                    app.ticker.remove(scaleTicker); // Stop scaling
                    createNewPlanet = true;
                    return;
                }
                // Check for collisions with canvas edges
                if (planet.x - planet.getRadius() <= 0 || planet.x + planet.getRadius() >= app.screen.width || planet.y - planet.getRadius() <= 0 || planet.y + planet.getRadius() >= app.screen.height) {
                    app.ticker.remove(scaleTicker); // Stop scaling
                    createNewPlanet = true;
                    return;
                }
            });
        }
        function updateScore() {
            scoreText.text = `Score: ${score}`;
            bestText.text = `Best: ${best}`;
        }
        app.stage.on('pointermove', onPointerMove);
        // Attach global listeners
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        function getQueryParam(param) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        }
    }
}
// Call the function to set up the application
$35da740d59af89ba$var$createApplication().catch((err)=>{
    console.error('Error initializing application:', err);
});


//# sourceMappingURL=repo.ba8aab35.js.map
